export const translations = {
  "application_name": {
    "sheet_name": "Web",
    "en": "WorkPilots",
    "ru": "WorkPilots",
    "fi": "WorkPilots",
    "sv": "WorkPilots",
    "fa": "WorkPilots",
    "ar": "WorkPilots",
    "uk": "WorkPilots"
  },
  "label_worker": {
    "sheet_name": "Web",
    "en": "Worker",
    "ru": "\u0440\u0430\u0431\u043e\u0442\u043d\u0438\u043a",
    "fi": "Tekij\u00e4",
    "sv": "Utf\u00f6rare",
    "fa": "\u06a9\u0627\u0631\u06af\u0631",
    "ar": "\u0627\u0644\u0639\u0627\u0645\u0644",
    "uk": "\u0420\u043e\u0431\u0456\u0442\u043d\u0438\u043a"
  },
  "label_orderer": {
    "sheet_name": "Web",
    "en": "Orderer",
    "ru": "\u0437\u0430\u043a\u0430\u0437\u0447\u0438\u043a",
    "fi": "Tilaaja",
    "sv": "Best\u00e4llare",
    "fa": "\u0633\u0641\u0627\u0631\u0634 \u062f\u0647\u0646\u062f\u0647",
    "ar": "\u0635\u0627\u062d\u0628 \u0627\u0644\u0639\u0645\u0644",
    "uk": "\u0417\u0430\u043c\u043e\u0432\u043d\u0438\u043a"
  },
  "login_label_login": {
    "sheet_name": "Web",
    "en": "Login",
    "ru": "\u041b\u043e\u0433\u0438\u043d",
    "fi": "Kirjaudu",
    "sv": "Login",
    "fa": "\u0648\u0631\u0648\u062f \u0628\u0647 \u0633\u06cc\u0633\u062a\u0645",
    "ar": "\u062a\u0633\u062c\u064a\u0644 \u0627\u0644\u062f\u062e\u0648\u0644",
    "uk": "\u041b\u043e\u0433\u0456\u043d"
  },
  "login_label_email": {
    "sheet_name": "Web",
    "en": "E-mail",
    "ru": "\u042d\u043b. \u043f\u043e\u0447\u0442\u0430",
    "fi": "S\u00e4hk\u00f6posti",
    "sv": "E-postadress",
    "fa": "\u0627\u06cc\u0645\u06cc\u0644",
    "ar": "\u0627\u0644\u0628\u0631\u064a\u062f \u0627\u0644\u0627\u0644\u0643\u062a\u0631\u0648\u0646\u064a",
    "uk": "\u0415\u043b\u0435\u043a\u0442\u0440\u043e\u043d\u043d\u0430 \u043f\u043e\u0448\u0442\u0430"
  },
  "login_label_password": {
    "sheet_name": "Web",
    "en": "Password",
    "ru": "\u043f\u0430\u0440\u043e\u043b\u044c",
    "fi": "Salasana",
    "sv": "L\u00f6senord",
    "fa": "\u0631\u0645\u0632 \u0639\u0628\u0648\u0631",
    "ar": "\u0643\u0644\u0645\u0629 \u0627\u0644\u0633\u0631",
    "uk": "\u041f\u0430\u0440\u043e\u043b\u044c"
  },
  "login_label_forgot_password": {
    "sheet_name": "Web",
    "en": "Forgot Password?",
    "ru": "\u0417\u0430\u0431\u044b\u043b\u0438 \u041f\u0430\u0440\u043e\u043b\u044c?",
    "fi": "Unohditko salasanan?",
    "sv": "Gl\u00f6mt l\u00f6senord?",
    "fa": "\u0631\u0645\u0632 \u0639\u0628\u0648\u0631 \u0631\u0627 \u0641\u0631\u0627\u0645\u0648\u0634 \u06a9\u0631\u062f\u0647 \u0627\u06cc\u062f\u061f",
    "ar": "\u0647\u0644 \u0646\u0633\u064a\u062a \u0643\u0644\u0645\u0629 \u0627\u0644\u0633\u0631",
    "uk": "\u0417\u0430\u0431\u0443\u043b\u0438 \u043f\u0430\u0440\u043e\u043b\u044c?"
  },
  "login_label_reset_message": {
    "sheet_name": "Web",
    "en": "We sent you an email with the instructions to change your password, please check your inbox and spam folder, too.",
    "ru": "\u041c\u044b \u043e\u0442\u043f\u0440\u0430\u0432\u0438\u043b\u0438 \u0438\u043d\u0441\u0442\u0440\u0443\u043a\u0446\u0438\u0438 \u043d\u0430 \u0432\u0430\u0448\u0443 \u044d\u043b\u0435\u043a\u0442\u0440\u043e\u043d\u043d\u0443\u044e \u043f\u043e\u0447\u0442\u0443. \u041d\u0435 \u0437\u0430\u0431\u0443\u0434\u044c\u0442\u0435 \u0442\u0430\u043a\u0436\u0435 \u043f\u0440\u043e\u0432\u0435\u0440\u0438\u0442\u044c \u043a\u043e\u0440\u0437\u0438\u043d\u0443 \u0441\u043e \u0441\u043f\u0430\u043c\u043e\u043c, \u0435\u0441\u043b\u0438 \u043d\u0430 \u043f\u043e\u0447\u0442\u0435 \u043d\u0435 \u0432\u0438\u0434\u043d\u043e",
    "fi": "Olemme l\u00e4hett\u00e4neet ohjeet salasanan vaihtoon s\u00e4hk\u00f6postiisi. Muistathan tarkistaa my\u00f6s roskapostin, jos s\u00e4hk\u00f6postia ei n\u00e4y.",
    "sv": "Vi skickade ett e-postmeddelande med instruktionerna f\u00f6r att \u00e4ndra ditt l\u00f6senord. Kontrollera \u00e4ven din inkorg och skr\u00e4ppostmapp.",
    "fa": "\u0645\u0627 \u06cc\u06a9 \u0627\u06cc\u0645\u06cc\u0644 \u0628\u0647 \u0622\u062f\u0631\u0633 \u0634\u0645\u0627 \u0627\u0631\u0633\u0627\u0644 \u06a9\u0631\u062f\u0647 \u0627\u06cc\u0645. \u0644\u0637\u0641\u0627 \u0627\u06cc\u0645\u06cc\u0644 \u062e\u0648\u062f \u0631\u0627 \u0628\u0631\u0631\u0633\u06cc \u06a9\u0646\u06cc\u062f",
    "ar": "\u0644\u0642\u062f \u0623\u0631\u0633\u0644\u0646\u0627 \u0625\u0644\u064a\u0643 \u0628\u0631\u064a\u062f\u064b\u0627 \u0625\u0644\u0643\u062a\u0631\u0648\u0646\u064a\u064b\u0627 \u064a\u062d\u062a\u0648\u064a \u0639\u0644\u0649 \u062a\u0639\u0644\u064a\u0645\u0627\u062a \u0644\u062a\u063a\u064a\u064a\u0631 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0627\u0644\u062e\u0627\u0635\u0629 \u0628\u0643 \u060c \u064a\u0631\u062c\u0649 \u0627\u0644\u062a\u062d\u0642\u0642 \u0645\u0646 \u0627\u0644\u0628\u0631\u064a\u062f \u0627\u0644\u0648\u0627\u0631\u062f \u0648\u0645\u062c\u0644\u062f \u0627\u0644\u0628\u0631\u064a\u062f \u0627\u0644\u0639\u0634\u0648\u0627\u0626\u064a \u0623\u064a\u0636\u064b\u0627",
    "uk": "\u041c\u0438 \u0432\u0456\u0434\u043f\u0440\u0430\u0432\u0438\u043b\u0438 \u0432\u0430\u043c \u0435\u043b\u0435\u043a\u0442\u0440\u043e\u043d\u043d\u0438\u0439 \u043b\u0438\u0441\u0442 \u0437 \u0456\u043d\u0441\u0442\u0440\u0443\u043a\u0446\u0456\u044f\u043c\u0438 \u0449\u043e\u0434\u043e \u0437\u043c\u0456\u043d\u0438 \u043f\u0430\u0440\u043e\u043b\u044f. \u042f\u043a\u0449\u043e \u0432\u0438 \u043d\u0435 \u043e\u0442\u0440\u0438\u043c\u0430\u043b\u0438 \u043f\u043e\u0432\u0456\u0434\u043e\u043c\u043b\u0435\u043d\u043d\u044f, \u043f\u0435\u0440\u0435\u0432\u0456\u0440\u0442\u0435 \u043f\u0430\u043f\u043a\u0443 \"\u0421\u043f\u0430\u043c\""
  },
  "login_label_resend_title": {
    "sheet_name": "Web",
    "en": "Resend confirmation email",
    "ru": "\u041e\u0442\u043f\u0440\u0430\u0432\u0438\u0442\u044c \u043f\u043e\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043d\u0438\u0435 \u043d\u0430 \u043f\u043e\u0447\u0442\u0443 \u043f\u043e\u0432\u0442\u043e\u0440\u043d\u043e",
    "fi": "L\u00e4het\u00e4 s\u00e4hk\u00f6postivahvistus uudelleen",
    "sv": "Skicka e-postbekr\u00e4ftelsen igen",
    "fa": "\u0627\u06cc\u0645\u06cc\u0644 \u062a\u0627\u06cc\u06cc\u062f \u0631\u0627 \u062f\u0648\u0628\u0627\u0631\u0647 \u0628\u0641\u0631\u0633\u062a",
    "ar": "\u0623\u0639\u062f \u0625\u0631\u0633\u0627\u0644 \u0631\u0633\u0627\u0644\u0629 \u0627\u0644\u0628\u0631\u064a\u062f \u0627\u0644\u0627\u0644\u0643\u062a\u0631\u0648\u0646\u064a \u0627\u0644\u062e\u0627\u0635\u0629 \u0628\u0627\u0644\u062a\u0623\u0643\u064a\u062f",
    "uk": "\u041d\u0430\u0434\u0456\u0441\u043b\u0430\u0442\u0438 \u043f\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043d\u043d\u044f \u0435\u043b\u0435\u043a\u0442\u0440\u043e\u043d\u043d\u043e\u044e \u043f\u043e\u0448\u0442\u043e\u044e \u043f\u043e\u0432\u0442\u043e\u0440\u043d\u043e"
  },
  "login_label_resend_message": {
    "sheet_name": "Web",
    "en": "We resent the confirmation email. Please check your inbox and spam folder, too.",
    "ru": "\u041f\u043e\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043d\u0438\u0435 \u043e\u0442\u043f\u0440\u0430\u0432\u043b\u0435\u043d\u043e \u043d\u0430 \u043f\u043e\u0447\u0442\u0443 \u043f\u043e\u0432\u0442\u043e\u0440\u043d\u043e",
    "fi": "Vahvistuss\u00e4hk\u00f6posti on l\u00e4hetetty uudelleen",
    "sv": "Bekr\u00e4ftelsemejl har skickats igen.",
    "fa": "\u0645\u0627 \u0627\u06cc\u0645\u06cc\u0644 \u062a\u0623\u06cc\u06cc\u062f \u0631\u0627 \u0645\u062c\u062f\u062f\u0627 \u0627\u0631\u0633\u0627\u0644 \u06a9\u0631\u062f\u06cc\u0645. \u0644\u0637\u0641\u0627\u064b \u0635\u0646\u062f\u0648\u0642 \u0648\u0631\u0648\u062f\u06cc \u0648 \u067e\u0648\u0634\u0647 \u0647\u0631\u0632\u0646\u0627\u0645\u0647 \u0627\u06cc\u0645\u06cc\u0644 \u062e\u0648\u062f \u0631\u0627 \u0646\u06cc\u0632 \u0628\u0631\u0631\u0633\u06cc \u06a9\u0646\u06cc\u062f.",
    "ar": "\u0646\u062d\u0646 \u0646\u0633\u062a\u0627\u0621 \u0645\u0646 \u0631\u0633\u0627\u0644\u0629 \u0627\u0644\u062a\u0623\u0643\u064a\u062f \u0627\u0644\u0625\u0644\u0643\u062a\u0631\u0648\u0646\u064a\u0629. \u064a\u0631\u062c\u0649 \u0627\u0644\u062a\u062d\u0642\u0642 \u0645\u0646 \u0627\u0644\u0628\u0631\u064a\u062f \u0627\u0644\u0648\u0627\u0631\u062f \u0648\u0645\u062c\u0644\u062f \u0627\u0644\u0628\u0631\u064a\u062f \u0627\u0644\u0639\u0634\u0648\u0627\u0626\u064a \u0623\u064a\u0636\u064b\u0627.",
    "uk": "\u041b\u0438\u0441\u0442 \u0456\u0437 \u043f\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043d\u043d\u044f\u043c \u043d\u0430\u0434\u0456\u0441\u043b\u0430\u043d\u043e \u043f\u043e\u0432\u0442\u043e\u0440\u043d\u043e. \u042f\u043a\u0449\u043e \u0432\u0438 \u043d\u0435 \u043e\u0442\u0440\u0438\u043c\u0430\u043b\u0438 \u043f\u043e\u0432\u0456\u0434\u043e\u043c\u043b\u0435\u043d\u043d\u044f, \u043f\u0435\u0440\u0435\u0432\u0456\u0440\u0442\u0435 \u043f\u0430\u043f\u043a\u0443 \"\u0421\u043f\u0430\u043c\""
  },
  "login_form_welcome": {
    "sheet_name": "Web",
    "en": "Welcome",
    "ru": "\u0414\u043e\u0431\u0440\u043e \u043f\u043e\u0436\u0430\u043b\u043e\u0432\u0430\u0442\u044c",
    "fi": "Tervetuloa",
    "sv": "V\u00e4lkommen",
    "fa": "\u062e\u0648\u0634 \u0622\u0645\u062f\u06cc",
    "ar": "\u0623\u0647\u0644\u0627 \u0628\u0643",
    "uk": "\u041b\u0430\u0441\u043a\u0430\u0432\u043e \u043f\u0440\u043e\u0441\u0438\u043c\u043e!"
  },
  "login_form_sign_in": {
    "sheet_name": "Web",
    "en": "Sign in to your account",
    "ru": "\u0417\u0430\u0439\u0434\u0438\u0442\u0435 \u0432 \u0441\u0432\u043e\u0439 \u0430\u043a\u043a\u0430\u0443\u043d\u0442",
    "fi": "Kirjaudu tilillesi",
    "sv": "Logga in p\u00e5 ditt konto",
    "fa": "\u0628\u0647 \u062d\u0633\u0627\u0628 \u062e\u0648\u062f \u0648\u0627\u0631\u062f \u0634\u0648\u06cc\u062f",
    "ar": "\u062a\u0633\u062c\u064a\u0644 \u0627\u0644\u062f\u062e\u0648\u0644",
    "uk": "\u0423\u0432\u0456\u0439\u0442\u0438 \u0443 \u0441\u0432\u0456\u0439 \u043e\u0431\u043b\u0456\u043a\u043e\u0432\u0438\u0439 \u0437\u0430\u043f\u0438\u0441"
  },
  "login_form_forgot_password": {
    "sheet_name": "Web",
    "en": "Forgot password",
    "ru": "\u0417\u0430\u0431\u044b\u043b\u0438 \u041f\u0430\u0440\u043e\u043b\u044c",
    "fi": "Unohtunut salasana",
    "sv": "Gl\u00f6mt l\u00f6senord",
    "fa": "\u0631\u0645\u0632 \u0639\u0628\u0648\u0631 \u0631\u0627 \u0641\u0631\u0627\u0645\u0648\u0634 \u06a9\u0631\u062f\u0647 \u0627\u06cc\u062f\u061f",
    "ar": "\u0646\u0633\u064a\u062a \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631",
    "uk": "\u0417\u0430\u0431\u0443\u043b\u0438 \u043f\u0430\u0440\u043e\u043b\u044c"
  },
  "login_label_resend_confirmation": {
    "sheet_name": "Web",
    "en": "Resend email confirmation",
    "ru": "\u041e\u0442\u043f\u0440\u0430\u0432\u0438\u0442\u044c \u043f\u043e\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043d\u0438\u0435 \u043d\u0430 \u043f\u043e\u0447\u0442\u0443 \u043f\u043e\u0432\u0442\u043e\u0440\u043d\u043e",
    "fi": "L\u00e4het\u00e4 s\u00e4hk\u00f6postivahvistus uudelleen",
    "sv": "Skicka e-postbekr\u00e4ftelsen igen",
    "fa": "\u0627\u06cc\u0645\u06cc\u0644 \u062a\u0627\u06cc\u06cc\u062f\u06cc\u0647 \u0631\u0627 \u0645\u062c\u062f\u062f\u0627 \u0627\u0631\u0633\u0627\u0644 \u06a9\u0646",
    "ar": "\u0625\u0639\u0627\u062f\u0629 \u0625\u0631\u0633\u0627\u0644 \u062a\u0623\u0643\u064a\u062f \u0627\u0644\u0628\u0631\u064a\u062f \u0627\u0644\u0625\u0644\u0643\u062a\u0631\u0648\u0646\u064a",
    "uk": "\u0412\u0456\u0434\u043f\u0440\u0430\u0432\u0438\u0442\u0438 \u043f\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043d\u043d\u044f \u0435\u043b\u0435\u043a\u0442\u0440\u043e\u043d\u043d\u043e\u044e \u043f\u043e\u0448\u0442\u043e\u044e \u043f\u043e\u0432\u0442\u043e\u0440\u043d\u043e"
  },
  "loginreg_link_to_registration": {
    "sheet_name": "Web",
    "en": "Don't have an account?",
    "ru": "\u0423 \u0432\u0430\u0441 \u043d\u0435\u0442 \u0435\u0449\u0435 \u0430\u043a\u043a\u0430\u0443\u043d\u0442\u0430?",
    "fi": "Eik\u00f6 sinulla ole viel\u00e4 tili\u00e4?",
    "sv": "Har du inte ett konto?",
    "fa": "",
    "ar": "",
    "uk": "\u0412\u0438 \u0449\u0435 \u043d\u0435 \u043c\u0430\u0454\u0442\u0435 \u043e\u0431\u043b\u0456\u043a\u043e\u0432\u0438\u0439 \u0437\u0430\u043f\u0438\u0441?"
  },
  "loginreg_link_to_login": {
    "sheet_name": "Web",
    "en": "I already have an account",
    "ru": "",
    "fi": "Minulla on jo k\u00e4ytt\u00e4j\u00e4tili",
    "sv": "Jag har redan ett konto",
    "fa": "",
    "ar": "",
    "uk": "\u042f \u043c\u0430\u044e \u043e\u0431\u043b\u0456\u043a\u043e\u0432\u0438\u0439 \u0437\u0430\u043f\u0438\u0441"
  },
  "reg_accept_tou": {
    "sheet_name": "Web",
    "en": "Please accept Terms of use!",
    "ru": "",
    "fi": "Hyv\u00e4ksyth\u00e4n viel\u00e4 k\u00e4ytt\u00f6ehdot!",
    "sv": "V\u00e4nligen acceptera allm\u00e4nna vilkor!",
    "fa": "",
    "ar": "",
    "uk": "\u0411\u0443\u0434\u044c \u043b\u0430\u0441\u043a\u0430, \u043f\u0440\u0438\u0439\u043c\u0456\u0442\u044c \u0443\u043c\u043e\u0432\u0438 \u0432\u0438\u043a\u043e\u0440\u0438\u0441\u0442\u0430\u043d\u043d\u044f"
  },
  "reg_form_ok": {
    "sheet_name": "Web",
    "en": "OK",
    "ru": "\u041e\u043a",
    "fi": "Selv\u00e4",
    "sv": "OK",
    "fa": "\u062a\u0627\u06cc\u06cc\u062f",
    "ar": "\u062d\u0633\u0646\u0627",
    "uk": "\u0414\u043e\u0431\u0440\u0435"
  },
  "merchant_label_select_service": {
    "sheet_name": "Web",
    "en": "Select service",
    "ru": "\u0412\u044b\u0431\u0435\u0440\u0438\u0442\u0435 \u0441\u0435\u0440\u0432\u0438\u0441",
    "fi": "Valitse palvelu",
    "sv": "V\u00e4lj tj\u00e4nst",
    "fa": "\u062e\u062f\u0645\u0627\u062a \u0631\u0627 \u0627\u0646\u062a\u062e\u0627\u0628 \u06a9\u0646\u06cc\u062f",
    "ar": "\u062d\u062f\u062f \u0627\u0644\u062e\u062f\u0645\u0629",
    "uk": "\u041e\u0431\u0435\u0440\u0456\u0442\u044c \u043f\u043e\u0441\u043b\u0443\u0433\u0443"
  },
  "phone_area_code": {
    "sheet_name": "Web",
    "en": "Area code",
    "ru": "\u041a\u043e\u0434 \u0440\u0435\u0433\u0438\u043e\u043d\u0430",
    "fi": "Suuntanumero",
    "sv": "Riktnummer",
    "fa": "\u06a9\u062f \u0645\u0646\u0637\u0642\u0647",
    "ar": "\u0631\u0645\u0632 \u0627\u0644\u0645\u0646\u0637\u0642\u0629",
    "uk": "\u041a\u043e\u0434 \u0440\u0435\u0433\u0456\u043e\u043d\u0443"
  },
  "native_select_type_text": {
    "sheet_name": "Web",
    "en": "Type...",
    "ru": "\u041f\u0435\u0447\u0430\u0442\u0430\u0435\u0442...",
    "fi": "Kirjoita...",
    "sv": "Typ...",
    "fa": "\u062a\u0627\u06cc\u067e \u06a9\u0646\u06cc\u062f ...",
    "ar": "\u0627\u0643\u062a\u0628",
    "uk": "\u0414\u0440\u0443\u043a\u0443\u0454\u2026"
  },
  "native_select_start_type_text": {
    "sheet_name": "Web",
    "en": "Start typing...",
    "ru": "\u041d\u0430\u0447\u043d\u0438\u0442\u0435 \u043f\u0435\u0447\u0430\u0442\u0430\u0442\u044c...",
    "fi": "Aloita kirjoittaminen...",
    "sv": "B\u00f6rja skriva...",
    "fa": "\u0634\u0631\u0648\u0639 \u0628\u0647 \u062a\u0627\u06cc\u067e ...",
    "ar": "\u0627\u0628\u062f\u0623 \u0627\u0644\u0637\u0628\u0627\u0639\u0629...",
    "uk": "\u041f\u043e\u0447\u043d\u0456\u0442\u044c \u0432\u0432\u043e\u0434\u0438\u0442\u0438.."
  },
  "register_label_create_account": {
    "sheet_name": "Web",
    "en": "Sign Up",
    "ru": "\u0421\u043e\u0437\u0434\u0430\u0439\u0442\u0435 \u0430\u043a\u043a\u0430\u0443\u043d\u0442",
    "fi": "Rekister\u00f6idy",
    "sv": "Skapa ett konto",
    "fa": "\u0627\u06cc\u062c\u0627\u062f \u062d\u0633\u0627\u0628 \u06a9\u0627\u0631\u0628\u0631\u06cc",
    "ar": "\u0625\u0635\u0646\u0639 \u062d\u0633\u0627\u0628",
    "uk": "\u0421\u0442\u0432\u043e\u0440\u0438\u0442\u0438 \u0430\u043a\u0430\u0443\u043d\u0442"
  },
  "register_label_tou": {
    "sheet_name": "Web",
    "en": "I have read and accept %s %s.",
    "ru": "\u042f \u043f\u0440\u043e\u0447\u0438\u0442\u0430\u043b \u0438 \u043f\u0440\u0438\u043d\u0438\u043c\u0430\u044e %s %s",
    "fi": "Olen lukenut ja hyv\u00e4ksyn %s %s",
    "sv": "Jag har l\u00e4st och godk\u00e4nner %s %s",
    "fa": "\u0645\u0646 \u0634\u0631\u0627\u06cc\u0637 s %s% \u0631\u0627 \u062e\u0648\u0627\u0646\u062f\u0647 \u0648 \u067e\u0630\u06cc\u0631\u0641\u062a\u0647 \u0627\u0645.",
    "ar": "\u0644\u0642\u062f \u0642\u0631\u0623\u062a \u0648\u0623\u0648\u0627\u0641\u0642 \u0639\u0644\u0649 %s \u0645\u0646 %s.",
    "uk": "\u042f \u043f\u0440\u043e\u0447\u0438\u0442\u0430\u0432 \u0442\u0430 \u043f\u0440\u0438\u0439\u043c\u0430\u044e %s %s."
  },
  "register_message_success": {
    "sheet_name": "Web",
    "en": "<p>Dear %s,<\/p>\n  <p>your registration was successful.<\/p>\n  <p>In order to complete the registration process,\n  please click on the link in the confirmation we\n  just sent you.<\/p>",
    "ru": "<p>%s,<\/p> <p>\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044f \u043f\u0440\u043e\u0448\u043b\u0430 \u0443\u0441\u043f\u0435\u0448\u043d\u043e .<\/p> <p>\u0427\u0442\u043e\u0431\u044b \u043f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u044c\u0441\u044f \u0434\u0430\u043d\u043d\u043e\u0439 \u043f\u0440\u043e\u0433\u0440\u0430\u043c\u043c\u043e\u0439, \u0432\u0430\u043c \u043d\u0435\u043e\u0431\u0445\u043e\u0434\u0438\u043c\u043e \u043f\u043e\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044c \u0432\u0430\u0448\u0443 \u044d\u043b. \u043f\u043e\u0447\u0442\u0443 .<\/p>",
    "fi": "<p>%s,<\/p>\n  <p>rekister\u00f6itymisesi oli onnistunut.<\/p>\n  <p>Jotta voit k\u00e4ytt\u00e4\u00e4 palveluamme, t\u00e4ytyy sinun viel\u00e4 vahvistaa s\u00e4hk\u00f6postiosoitteesi juuri l\u00e4hett\u00e4m\u00e4st\u00e4mme s\u00e4hk\u00f6postista.<\/p>",
    "sv": "<p>K\u00e4ra %s,<\/p>\n <p>din registrering lyckades.<\/p>\n <p>F\u00f6r att slutf\u00f6ra registreringsprocessen, v\u00e4nligen klicka p\u00e5 l\u00e4nken i bekr\u00e4ftelsen som vi just skickade till dig.<\/p>",
    "fa": "<p> \u0645\u0634\u062a\u0631\u06a9 \u06af\u0631\u0627\u0645\u06cc <\/p>\n  <p> \u062b\u0628\u062a \u0646\u0627\u0645 \u0634\u0645\u0627 \u0628\u0627 \u0645\u0648\u0641\u0642\u06cc\u062a \u0627\u0646\u062c\u0627\u0645 \u0634\u062f. <\/p>\n  <p> \u0628\u0647 \u0645\u0646\u0638\u0648\u0631 \u062a\u06a9\u0645\u06cc\u0644 \u0645\u0631\u0627\u062d\u0644 \u062b\u0628\u062a \u0646\u0627\u0645\u060c\n  \u0644\u0637\u0641\u0627\u064b \u0631\u0648\u06cc \u0644\u06cc\u0646\u06a9 \u062a\u0627\u06cc\u06cc\u062f\u06cc\u0647 \u06a9\u0647 \u0628\u0631\u0627\u06cc \u0634\u0645\u0627 \u0627\u0631\u0633\u0627\u0644 \u06a9\u0631\u062f\u0647 \u0627\u06cc\u0645\u060c \u06a9\u0644\u06cc\u06a9 \u06a9\u0646\u06cc\u062f <\/p>",
    "ar": "\"\"\"<p> \u0639\u0632\u064a\u0632\u064a\u066a s \u060c <\/p>\" <p> \u062a\u0645 \u0627\u0644\u062a\u0633\u062c\u064a\u0644 \u0628\u0646\u062c\u0627\u062d. <\/ p> <p> \u0645\u0646 \u0623\u062c\u0644 \u0627\u0633\u062a\u0643\u0645\u0627\u0644 \u0639\u0645\u0644\u064a\u0629 \u0627\u0644\u062a\u0633\u062c\u064a\u0644 \u060c \u0627\u0644\u0631\u062c\u0627\u0621 \u0627\u0644\u0636\u063a\u0637 \u0639\u0644\u0649 \u0627\u0644\u0631\u0627\u0628\u0637 \u0641\u064a \u0627\u0644\u062a\u0623\u0643\u064a\u062f \u0646\u062d\u0646 \"\u0623\u0631\u0633\u0644 \u0644\u0643 \u0644\u0644\u062a\u0648 <\/ p> \"\"\"",
    "uk": "<p>\u0428\u0430\u043d\u043e\u0432\u043d\u0438\u0439 %s,<\/p>\n  <p>\u0432\u0430\u0448\u0430 \u0440\u0435\u0454\u0441\u0442\u0440\u0430\u0446\u0456\u044f \u043f\u0440\u043e\u0439\u0448\u043b\u0430 \u0443\u0441\u043f\u0456\u0448\u043d\u043e.<\/p>\n  <p\u0429\u043e\u0431 \u0437\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u0438 \u043f\u0440\u043e\u0446\u0435\u0441 \u0440\u0435\u0454\u0441\u0442\u0440\u0430\u0446\u0456\u0457, \u043d\u0430\u0442\u0438\u0441\u043d\u0456\u0442\u044c \u043d\u0430 \u043f\u043e\u0441\u0438\u043b\u0430\u043d\u043d\u044f \u0443 \u043f\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043d\u043d\u0456, \u044f\u043a\u0435 \u043c\u0438 \u0449\u043e\u0439\u043d\u043e \u043d\u0430\u0434\u0456\u0441\u043b\u0430\u043b\u0438 \u0432\u0430\u043c \u043d\u0430 \u0435\u043b\u0435\u043a\u0442\u0440\u043e\u043d\u043d\u0443 \u043f\u043e\u0448\u0442\u0443  .<\/p>"
  },
  "register_label_register": {
    "sheet_name": "Web",
    "en": "Register",
    "ru": "\u0417\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043e\u0432\u0430\u0442\u044c\u0441\u044f",
    "fi": "Rekister\u00f6idy",
    "sv": "Registera",
    "fa": "\u062b\u0628\u062a \u0646\u0627\u0645",
    "ar": "\u062a\u0633\u062c\u064a\u0644",
    "uk": "\u0417\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u0443\u0432\u0430\u0442\u0438\u0441\u044f"
  },
  "merchant_label_service": {
    "sheet_name": "Web",
    "en": "Service",
    "ru": "\u0421\u0435\u0440\u0432\u0438\u0441",
    "fi": "Palvelu",
    "sv": "Tj\u00e4nst",
    "fa": "\u062e\u062f\u0645\u0627\u062a",
    "ar": "\u0627\u0644\u062e\u062f\u0645\u0627\u062a",
    "uk": "\u0421\u0435\u0440\u0432\u0456\u0441"
  },
  "merchant_label_private_service": {
    "sheet_name": "Web",
    "en": "Private service",
    "ru": "\u0427\u0430\u0441\u0442\u043d\u044b\u0439 \u0441\u0435\u0440\u0432\u0438\u0441",
    "fi": "Yksityinen palvelu",
    "sv": "Privat tj\u00e4nst",
    "fa": "\u062e\u062f\u0645\u0627\u062a \u062e\u0635\u0648\u0635\u06cc",
    "ar": "\u062e\u062f\u0645\u0629 \u062e\u0627\u0635\u0629",
    "uk": "\u041f\u0440\u0438\u0432\u0430\u0442\u043d\u0438\u0439 \u0441\u0435\u0440\u0432\u0456\u0441"
  },
  "merchant_label_private_code": {
    "sheet_name": "Web",
    "en": "Private service code",
    "ru": "\u041b\u0438\u0447\u043d\u044b\u0439 \u043a\u043e\u0434",
    "fi": "Yksityinen koodi",
    "sv": "Privat kod",
    "fa": "\u06a9\u062f \u062e\u0635\u0648\u0635\u06cc",
    "ar": "\u0631\u0645\u0632 \u0627\u0644\u062e\u062f\u0645\u0629 \u0627\u0644\u062e\u0627\u0635\u0629",
    "uk": "\u041f\u0435\u0440\u0441\u043e\u043d\u0430\u043b\u044c\u043d\u0438\u0439 \u043a\u043e\u0434"
  },
  "merchant_label_private_name": {
    "sheet_name": "Web",
    "en": "Private service name",
    "ru": "",
    "fi": "Yksityisen palvelun nimi",
    "sv": "Privat tj\u00e4nstnamn",
    "fa": "",
    "ar": "",
    "uk": "\u041f\u0435\u0440\u0441\u043e\u043d\u0430\u043b\u044c\u043d\u0430 \u043d\u0430\u0437\u0432\u0430"
  },
  "register_label_password_confirm": {
    "sheet_name": "Web",
    "en": "Confirm password",
    "ru": "\u041f\u043e\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435 \u043f\u0430\u0440\u043e\u043b\u044c",
    "fi": "Vahvista salasana",
    "sv": "Bekr\u00e4fta l\u00f6senord",
    "fa": "\u0631\u0645\u0632 \u0639\u0628\u0648\u0631 \u0631\u0627 \u062a\u0623\u06cc\u06cc\u062f \u06a9\u0646\u06cc\u062f",
    "ar": "\u062a\u0623\u0643\u064a\u062f \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631",
    "uk": "\u041f\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438 \u043f\u0430\u0440\u043e\u043b\u044c"
  },
  "register_label_first_name": {
    "sheet_name": "Web",
    "en": "First Name",
    "ru": "\u0418\u043c\u044f",
    "fi": "Etunimi",
    "sv": "F\u00f6rnamn",
    "fa": "\u0646\u0627\u0645",
    "ar": "\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0627\u0648\u0644",
    "uk": "\u0406\u043c'\u044f"
  },
  "register_label_last_name": {
    "sheet_name": "Web",
    "en": "Last Name",
    "ru": "\u0424\u0430\u043c\u0438\u043b\u0438\u044f",
    "fi": "Sukunimi",
    "sv": "Efternamn",
    "fa": "\u0646\u0627\u0645 \u062e\u0627\u0646\u0648\u0627\u062f\u06af\u06cc",
    "ar": "\u0627\u0633\u0645 \u0627\u0644\u0639\u0627\u0626\u0644\u0629",
    "uk": "\u041f\u0440\u0456\u0437\u0432\u0438\u0449\u0435"
  },
  "phone_number_label": {
    "sheet_name": "Web",
    "en": "Phone number",
    "ru": "\u0422\u0435\u043b\u0435\u0444\u043e\u043d",
    "fi": "Puhelinnumero",
    "sv": "Telefonnummer",
    "fa": "\u0634\u0645\u0627\u0631\u0647 \u062a\u0645\u0627\u0633",
    "ar": "\u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062a\u0641",
    "uk": "\u0422\u0435\u043b\u0435\u0444\u043e\u043d"
  },
  "register_label_already": {
    "sheet_name": "Web",
    "en": "Already a user?",
    "ru": "\u0412\u044b \u0443\u0436\u0435 \u043f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u0435\u043b\u044c?",
    "fi": "Oletko jo k\u00e4ytt\u00e4j\u00e4?",
    "sv": "\u00c4r du redan medlem?",
    "fa": "\u0622\u06cc\u0627 \u0642\u0628\u0644\u0627 \u062b\u0628\u062a \u0646\u0627\u0645 \u06a9\u0631\u062f\u0647 \u0627\u06cc\u062f\u061f",
    "ar": "\u0647\u0644 \u0643\u0646\u062a \u0645\u0633\u062a\u062e\u062f\u0645\u061f",
    "uk": "\u0412\u0438 \u0432\u0436\u0435 \u043a\u043e\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447?"
  },
  "email_confirmation_success_message": {
    "sheet_name": "Web",
    "en": "Your email address is now confirmed. Please log in.",
    "ru": "\u0410\u0434\u0440\u0435\u0441 \u044d\u043b. \u043f\u043e\u0447\u0442\u044b \u043f\u043e\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0451\u043d. \u041f\u043e\u0436\u0430\u043b\u0443\u0439\u0441\u0442\u0430 \u0432\u043e\u0439\u0434\u0438\u0442\u0435.",
    "fi": "S\u00e4hk\u00f6postiosoitteesi on nyt vahvistettu. Ole hyv\u00e4 ja kirjaudu sis\u00e4\u00e4n.",
    "sv": "Din email \u00e4r nu bekr\u00e4ftad och du kan logga in.",
    "fa": "\u0627\u06cc\u0645\u06cc\u0644 \u0634\u0645\u0627 \u062a\u0627\u06cc\u06cc\u062f \u0634\u062f. \u0644\u0637\u0641\u0627 \u0648\u0627\u0631\u062f \u0633\u06cc\u0633\u062a\u0645 \u0634\u0648\u06cc\u062f!",
    "ar": "\u062a\u0645 \u062a\u0623\u0643\u064a\u062f \u0639\u0646\u0648\u0627\u0646 \u0628\u0631\u064a\u062f\u0643 \u0627\u0644\u0625\u0644\u0643\u062a\u0631\u0648\u0646\u064a \u0627\u0644\u0622\u0646. \u0627\u0644\u0631\u062c\u0627\u0621 \u062a\u0633\u062c\u064a\u0644 \u0627\u0644\u062f\u062e\u0648\u0644.",
    "uk": "\u0412\u0430\u0448\u0430 \u0435\u043b\u0435\u043a\u0442\u0440\u043e\u043d\u043d\u0430 \u0430\u0434\u0440\u0435\u0441\u0430 \u043f\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043d\u0430. \u0411\u0443\u0434\u044c \u043b\u0430\u0441\u043a\u0430, \u0443\u0432\u0456\u0439\u0434\u0456\u0442\u044c"
  },
  "register_label_success": {
    "sheet_name": "Web",
    "en": "Your registration was successful.",
    "ru": "\u0412\u044b \u0443\u0441\u043f\u0435\u0448\u043d\u043e \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043e\u0432\u0430\u043b\u0438\u0441\u044c",
    "fi": "Rekister\u00f6itymisesi onnistui",
    "sv": "Din registrering har nu lyckats",
    "fa": "\u062b\u0628\u062a \u0646\u0627\u0645 \u0634\u0645\u0627 \u0628\u0627 \u0645\u0648\u0641\u0642\u06cc\u062a \u0627\u0646\u062c\u0627\u0645 \u0634\u062f.",
    "ar": "\u062a\u0645 \u062a\u0633\u062c\u064a\u0644\u0643\u0645 \u0628\u0646\u062c\u0627\u062d",
    "uk": "\u0412\u0430\u0448\u0430 \u0440\u0435\u0454\u0441\u0442\u0440\u0430\u0446\u0456\u044f \u043f\u0440\u043e\u0439\u0448\u043b\u0430 \u0443\u0441\u043f\u0456\u0448\u043d\u043e"
  },
  "not_the_same_as_password": {
    "sheet_name": "Web",
    "en": "Password confirm is not equal to password",
    "ru": "\u041f\u0430\u0440\u043e\u043b\u044c \u043d\u0435 \u043f\u043e\u0434\u0445\u043e\u0434\u0438\u0442 \u0434\u043b\u044f \u043f\u0430\u0440\u043e\u043b\u044f",
    "fi": "Salasanat eiv\u00e4t t\u00e4sm\u00e4\u00e4",
    "sv": "Din bekr\u00e4ftelse av l\u00f6senordet matchar inte ditt uppgivna l\u00f6senord",
    "fa": "\u062a\u0623\u06cc\u06cc\u062f \u0631\u0645\u0632 \u0639\u0628\u0648\u0631 \u0628\u0627 \u0631\u0645\u0632 \u0639\u0628\u0648\u0631 \u0628\u0631\u0627\u0628\u0631 \u0646\u06cc\u0633\u062a",
    "ar": "\u0644\u064a\u0633\u062a \u0646\u0641\u0633 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631",
    "uk": "\u041f\u0430\u0440\u043e\u043b\u0456 \u043d\u0435 \u0437\u0431\u0456\u0433\u0430\u044e\u0442\u044c\u0441\u044f. \u0411\u0443\u0434\u044c \u043b\u0430\u0441\u043a\u0430, \u0441\u043f\u0440\u043e\u0431\u0443\u0439\u0442\u0435 \u0449\u0435"
  },
  "fn_too_short": {
    "sheet_name": "Web",
    "en": "First name is too short (minimum is 2 characters)",
    "ru": "",
    "fi": "Etunimi on liian lyhyt (v\u00e4hint\u00e4\u00e4n 2 merkki\u00e4)",
    "sv": "F\u00f6rnamnet \u00e4r f\u00f6r kort (minst 2 tecken)",
    "fa": "\u0646\u0627\u0645 \u0628\u0633\u06cc\u0627\u0631 \u06a9\u0648\u062a\u0627\u0647 \u0627\u0633\u062a (\u062d\u062f\u0627\u0642\u0644 \u06a9\u0627\u0631\u0627\u06a9\u062a\u0631\u0647\u0627)",
    "ar": "",
    "uk": "\u0406\u043c'\u044f \u0437\u0430\u043d\u0430\u0434\u0442\u043e \u043a\u043e\u0440\u043e\u0442\u043a\u0435 (\u043c\u0456\u043d\u0456\u043c\u0443\u043c 2 \u043b\u0456\u0442\u0435\u0440\u0438)"
  },
  "is_too_long": {
    "sheet_name": "Web",
    "en": "Password is too long (maximum is %s characters)",
    "ru": "\u041f\u0430\u0440\u043e\u043b\u044c \u0441\u043b\u0438\u0448\u043a\u043e\u043c \u0434\u043b\u0438\u043d\u043d\u044b\u0439 (\u043c\u0430\u043a\u0441\u0438\u043c\u0443\u043c %s \u0441\u0438\u043c\u0432\u043e\u043b\u043e\u0432)",
    "fi": "Salasana on liian pitk\u00e4 (enint\u00e4\u00e4n %s merkki\u00e4)",
    "sv": "L\u00f6senordet \u00e4r f\u00f6r l\u00e5ngt (h\u00f6gst %s tecken)",
    "fa": "\u0631\u0645\u0632 \u0639\u0628\u0648\u0631 \u062e\u06cc\u0644\u06cc \u0637\u0648\u0644\u0627\u0646\u06cc \u0627\u0633\u062a (\u062d\u062f\u0627\u06a9\u062b\u0631 s% \u0646\u0648\u06cc\u0633\u0647)",
    "ar": "\u0637\u0648\u064a\u0644 %s\u062c\u062f\u0627",
    "uk": "\u041f\u0430\u0440\u043e\u043b\u044c \u0437\u0430\u043d\u0430\u0434\u0442\u043e \u0434\u043e\u0432\u0433\u0438\u0439 (\u043c\u0430\u043a\u0441\u0438\u043c\u0443\u043c %s \u0441\u0438\u043c\u0432\u043e\u043b\u0456\u0432 )"
  },
  "pw_is_too_short": {
    "sheet_name": "Web",
    "en": "Password is too short (minimum is 6 characters)",
    "ru": "",
    "fi": "Salasana on liian lyhyt (v\u00e4hint\u00e4\u00e4n 6 merkki\u00e4)",
    "sv": "L\u00f6senordet \u00e4r f\u00f6r kort (minst 6 tecken)",
    "fa": "\u06af\u0630\u0631\u0648\u0627\u0698\u0647 \u062e\u06cc\u0644\u06cc \u06a9\u0648\u062a\u0627\u0647 \u0627\u0633\u062a (\u062d\u062f\u0627\u0642\u0644 6 \u062d\u0631\u0641)",
    "ar": "",
    "uk": "\u041f\u0430\u0440\u043e\u043b\u044c \u0437\u0430\u043d\u0430\u0434\u0442\u043e \u043a\u043e\u0440\u043e\u0442\u043a\u0438\u0439 (\u043c\u0456\u043d\u0456\u043c\u0443\u043c 6 \u0441\u0438\u043c\u0432\u043e\u043b\u0456\u0432)"
  },
  "is_too_short": {
    "sheet_name": "Web",
    "en": "%s is too short (minimum is %s characters)",
    "ru": "%s \u0441\u043b\u0438\u0448\u043a\u043e\u043c \u0434\u043b\u0438\u043d\u043d\u044b\u0439 (\u043c\u0430\u043a\u0441\u0438\u043c\u0443\u043c %s \u0441\u0438\u043c\u0432\u043e\u043b\u043e\u0432)",
    "fi": "%s on liian lyhyt (v\u00e4hint\u00e4\u00e4n %s merkki\u00e4)",
    "sv": "%s \u00e4r f\u00f6r kort (minst %s tecken)",
    "fa": "\u0631\u0645\u0632 \u0639\u0628\u0648\u0631 \u062e\u06cc\u0644\u06cc \u06a9\u0648\u062a\u0627\u0647 \u0627\u0633\u062a (\u062d\u062f\u0627\u0642\u0644 s% \u0646\u0648\u06cc\u0633\u0647)",
    "ar": "%s\u0625\u0646\u0647 \u0642\u0635\u064a\u0631 \u0623\u0643\u062b\u0631 \u0645\u0646 \u0627\u0644\u0644\u0627\u0632\u0645%s",
    "uk": "%s \u0437\u0430\u043d\u0430\u0434\u0442\u043e \u0434\u043e\u0432\u0433\u0438\u0439, (\u043c\u0456\u043d\u0456\u043c\u0443\u043c %s \u0441\u0438\u043c\u0432\u043e\u043b\u0456\u0432)"
  },
  "is_required": {
    "sheet_name": "Web",
    "en": "Field is required",
    "ru": "\u0422\u0440\u0435\u0431\u0443\u0435\u0442",
    "fi": "Vaadittu",
    "sv": "F\u00e4ltet \u00e4r obligatoriskt",
    "fa": "\u0627\u062c\u0628\u0627\u0631\u06cc",
    "ar": "\u0645\u0637\u0644\u0648\u0628",
    "uk": "\u041e\u0431\u043e\u0432'\u044f\u0437\u043a\u043e\u0432\u0435 \u043f\u043e\u043b\u0435"
  },
  "register_change_to_private": {
    "sheet_name": "Web",
    "en": "Don't have a Private code? Register to an open platform",
    "ru": "",
    "fi": "Eik\u00f6 sinulla ole yksityist\u00e4 koodia? Rekister\u00f6idy avoimeen palveluun",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0423 \u0432\u0430\u0441 \u043d\u0435\u043c\u0430\u0454 \u043e\u0441\u043e\u0431\u0438\u0441\u0442\u043e\u0433\u043e \u043f\u0440\u0438\u0432\u0430\u0442\u043d\u043e\u0433\u043e \u043a\u043e\u0434\u0443?  \u0417\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u0443\u0439\u0442\u0435\u0441\u044f \u043f\u0443\u0431\u043b\u0456\u0447\u043d\u043e"
  },
  "register_change_to_public": {
    "sheet_name": "Web",
    "en": "Do you have a Private code? Register to a private platform",
    "ru": "",
    "fi": "Onko sinulla yksityinen koodi? Rekister\u00f6idy yksityiseen palveluun",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0423 \u0432\u0430\u0441 \u0454 \u043e\u0441\u043e\u0431\u0438\u0441\u0442\u0438\u0439 \u043f\u0440\u0438\u0432\u0430\u0442\u043d\u0438\u0439 \u043a\u043e\u0434?  \u0417\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u0443\u0439\u0442\u0435\u0441\u044c \u043f\u0440\u0438\u0432\u0430\u0442\u043d\u043e"
  },
  "register_tooltip_private_merchant": {
    "sheet_name": "Web",
    "en": "Please type the code (with capital letters) for the merchant you intend to register to",
    "ru": "",
    "fi": "Kirjoita sen palvelun koodi, johon haluat rekister\u00f6ity\u00e4. Huom. kirjoita isoilla kirjaimilla!",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0411\u0443\u0434\u044c \u043b\u0430\u0441\u043a\u0430, \u0432\u0432\u0435\u0434\u0456\u0442\u044c \u043a\u043e\u0434 \u043f\u0440\u043e\u0434\u0430\u0432\u0446\u044f, \u0443 \u044f\u043a\u043e\u0433\u043e \u0432\u0438 \u0437\u0431\u0438\u0440\u0430\u0454\u0442\u0435\u0441\u044f \u0437\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u0443\u0432\u0430\u0442\u0438\u0441\u044f"
  },
  "register_tooltip_public_merchant": {
    "sheet_name": "Web",
    "en": "Try one of our open platforms by choosing it from the list",
    "ru": "",
    "fi": "Kokeile yht\u00e4 meid\u00e4n avoimista palveluista valitsemalla se listalta",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0421\u043f\u0440\u043e\u0431\u0443\u0439\u0442\u0435 \u043e\u0434\u043d\u043e\u0433\u043e \u0437 \u043d\u0430\u0448\u0438\u0445 \u043f\u0443\u0431\u043b\u0456\u0447\u043d\u0438\u0445 \u043f\u0440\u043e\u0434\u0430\u0432\u0446\u0456\u0432, \u0432\u0438\u0431\u0440\u0430\u0432\u0448\u0438 \u0439\u043e\u0433\u043e \u0437\u0456 \u0441\u043f\u0438\u0441\u043a\u0443"
  },
  "invalid_input": {
    "sheet_name": "Web",
    "en": "Invalid input!",
    "ru": "\u041d\u0435\u0432\u0435\u0440\u043d\u044b\u0435 \u0434\u0430\u043d\u043d\u044b\u0435",
    "fi": "Virheellist\u00e4 tietoa!",
    "sv": "Felaktigt data!",
    "fa": "\u0645\u0642\u062f\u0627\u0631 \u0646\u0627\u0645\u0639\u062a\u0628\u0631 \u0627\u0633\u062a",
    "ar": "\u0645\u0639\u0644\u0648\u0645\u0627\u062a \u063a\u064a\u0631 \u0635\u0627\u0644\u062d\u0629",
    "uk": "\u041d\u0435\u0432\u0456\u0440\u043d\u0430 \u0456\u043d\u0444\u043e\u0440\u043c\u0430\u0446\u0456\u044f"
  },
  "settings_label_change_pw": {
    "sheet_name": "Web",
    "en": "Change Password",
    "ru": "\u041f\u043e\u043c\u0435\u043d\u044f\u0439\u0442\u0435 \u0432\u0430\u0448 \u043f\u0430\u0440\u043e\u043b\u044c",
    "fi": "Vaihda salasana",
    "sv": "Byt l\u00f6senord",
    "fa": "\u062a\u063a\u06cc\u06cc\u0631 \u0631\u0645\u0632 \u0639\u0628\u0648\u0631",
    "ar": "\u062a\u063a\u064a\u0631 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631",
    "uk": "\u0417\u043c\u0456\u043d\u0438\u0442\u0438 \u043f\u0430\u0440\u043e\u043b\u044c"
  },
  "login_label_reset_password": {
    "sheet_name": "Web",
    "en": "Reset your password",
    "ru": "\u042f \u0437\u0430\u0431\u044b\u043b \u043f\u0430\u0440\u043e\u043b\u044c",
    "fi": "Unohdin salasanani",
    "sv": "Jag har gl\u00f6mt mitt l\u00f6senord",
    "fa": "\u0631\u0645\u0632\u0639\u0628\u0648\u0631 \u062e\u0648\u062f \u0631\u0627 \u062f\u0648\u0628\u0627\u0631\u0647 \u062a\u0646\u0638\u06cc\u0645 \u06a9\u0646\u06cc\u062f",
    "ar": "\u0646\u0633\u064a\u062a \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631",
    "uk": "\u042f \u0437\u0430\u0431\u0443\u0432 \u0441\u0432\u0456\u0439 \u043f\u0430\u0440\u043e\u043b\u044c"
  },
  "login_form_send": {
    "sheet_name": "Web",
    "en": "Send",
    "ru": "\u041e\u0442\u043f\u0440\u0430\u0432\u0438\u0442\u044c",
    "fi": "L\u00e4het\u00e4",
    "sv": "Skicka",
    "fa": "\u0627\u0631\u0633\u0627\u0644",
    "ar": "\u0625\u0631\u0633\u0627\u0644",
    "uk": "\u0412\u0456\u0434\u043f\u0440\u0430\u0432\u0438\u0442\u0438"
  },
  "change_password_form_title": {
    "sheet_name": "Web",
    "en": "Change your password",
    "ru": "\u041f\u043e\u043c\u0435\u043d\u044f\u0439\u0442\u0435 \u0432\u0430\u0448\u0443 \u043f\u0430\u0440\u043e\u043b\u044c",
    "fi": "Vaihda salasanasi",
    "sv": "Byt l\u00f6senord",
    "fa": "\u062a\u063a\u06cc\u06cc\u0631 \u0631\u0645\u0632 \u0639\u0628\u0648\u0631",
    "ar": "\u063a\u064a\u0631 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0627\u0644\u062e\u0627\u0635\u0629 \u0628\u0643",
    "uk": "\u0417\u043c\u0456\u043d\u0456\u0442\u044c \u0432\u0430\u0448 \u043f\u0430\u0440\u043e\u043b\u044c"
  },
  "change_password_old_password_label": {
    "sheet_name": "Web",
    "en": "Old password",
    "ru": "\u0421\u0442\u0430\u0440\u044b\u0439 \u043f\u0430\u0440\u043e\u043b\u044c",
    "fi": "Vanha salasanasi",
    "sv": "Tidigare l\u00f6senord",
    "fa": "\u0631\u0645\u0632 \u0639\u0628\u0648\u0631 \u0642\u062f\u06cc\u0645\u06cc",
    "ar": "\u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0627\u0644\u0642\u062f\u064a\u0645\u0629",
    "uk": "\u0421\u0442\u0430\u0440\u0438\u0439 \u043f\u0430\u0440\u043e\u043b\u044c"
  },
  "change_password_new_password_label": {
    "sheet_name": "Web",
    "en": "New password",
    "ru": "\u041d\u043e\u0432\u044b\u0439 \u043f\u0430\u0440\u043e\u043b\u044c",
    "fi": "Uusi salasana",
    "sv": "Nytt l\u00f6senord",
    "fa": "\u0631\u0645\u0632 \u0639\u0628\u0648\u0631 \u062c\u062f\u06cc\u062f",
    "ar": "\u0643\u0644\u0645\u0629 \u0645\u0631\u0648\u0631 \u062c\u062f\u064a\u062f\u0629",
    "uk": "\u041d\u043e\u0432\u0438\u0439 \u043f\u0430\u0440\u043e\u043b\u044c"
  },
  "change_password_submit_label": {
    "sheet_name": "Web",
    "en": "Save",
    "ru": "\u0421\u043e\u0445\u0440\u0430\u043d\u0438\u0442\u044c",
    "fi": "Tallenna",
    "sv": "Spara",
    "fa": "\u0630\u062e\u06cc\u0631\u0647",
    "ar": "\u062d\u0641\u0638",
    "uk": "\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438"
  },
  "change_password_cancel_label": {
    "sheet_name": "Web",
    "en": "Cancel",
    "ru": "\u043e\u0442\u043c\u0435\u043d\u0438\u0442\u044c",
    "fi": "Peruuta",
    "sv": "Avbryta",
    "fa": "\u0644\u063a\u0648",
    "ar": "\u062a\u0631\u0627\u062c\u0639",
    "uk": "\u0421\u043a\u0430\u0441\u0443\u0432\u0430\u0442\u0438"
  },
  "change_password_success_message": {
    "sheet_name": "Web",
    "en": "Your password has changed",
    "ru": "\u041f\u0430\u0440\u043e\u043b\u044c \u0438\u0437\u043c\u0435\u043d\u0435\u043d",
    "fi": "Salasanasi on vaihdettu",
    "sv": "Ditt l\u00f6senord har \u00e4ndrats",
    "fa": "\u0631\u0645\u0632 \u0639\u0628\u0648\u0631 \u0634\u0645\u0627 \u062a\u063a\u06cc\u06cc\u0631 \u06a9\u0631\u062f\u0647 \u0627\u0633\u062a",
    "ar": "\u062a\u0645 \u062a\u063a\u064a\u064a\u0631 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0627\u0644\u062e\u0627\u0635\u0629 \u0628\u0643",
    "uk": "\u0412\u0430\u0448 \u043f\u0430\u0440\u043e\u043b\u044c \u0437\u043c\u0456\u043d\u0435\u043d\u043e"
  },
  "reset_password_form_title": {
    "sheet_name": "Web",
    "en": "Reset your password",
    "ru": "\u041f\u043e\u043c\u0435\u043d\u044f\u0439\u0442\u0435 \u0432\u0430\u0448\u0443 \u043f\u0430\u0440\u043e\u043b\u044c",
    "fi": "Vaihda salasanasi",
    "sv": "Byt l\u00f6senord",
    "fa": "\u062a\u063a\u06cc\u06cc\u0631 \u0631\u0645\u0632 \u0639\u0628\u0648\u0631",
    "ar": "\u0646\u0633\u064a\u062a \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631",
    "uk": "\u0417\u043c\u0456\u043d\u0456\u0442\u044c \u0432\u0430\u0448 \u043f\u0430\u0440\u043e\u043b\u044c"
  },
  "reset_password_password_label": {
    "sheet_name": "Web",
    "en": "Password",
    "ru": "\u043f\u0430\u0440\u043e\u043b\u044c",
    "fi": "Salasana",
    "sv": "L\u00f6senord",
    "fa": "\u0631\u0645\u0632 \u0639\u0628\u0648\u0631",
    "ar": "\u0643\u0644\u0645\u0629 \u0627\u0644\u0633\u0631",
    "uk": "\u041f\u0430\u0440\u043e\u043b\u044c"
  },
  "reset_password_confirm_password_label": {
    "sheet_name": "Web",
    "en": "Confirm password",
    "ru": "\u041f\u043e\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435 \u043f\u0430\u0440\u043e\u043b\u044c",
    "fi": "Vahvista salasana",
    "sv": "Bekr\u00e4fta l\u00f6senord",
    "fa": "\u0631\u0645\u0632 \u0639\u0628\u0648\u0631 \u0631\u0627 \u062a\u0623\u06cc\u06cc\u062f \u06a9\u0646\u06cc\u062f",
    "ar": "\u062a\u0623\u0643\u064a\u062f \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631",
    "uk": "\u041f\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0456\u0442\u044c  \u043f\u0430\u0440\u043e\u043b\u044c"
  },
  "reset_password_submit_label": {
    "sheet_name": "Web",
    "en": "Save",
    "ru": "\u0421\u043e\u0445\u0440\u0430\u043d\u0438\u0442\u044c",
    "fi": "Tallenna",
    "sv": "Spara",
    "fa": "\u0630\u062e\u06cc\u0631\u0647",
    "ar": "\u062d\u0641\u0638",
    "uk": "\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438"
  },
  "reset_password_cancel_label": {
    "sheet_name": "Web",
    "en": "Login",
    "ru": "\u041b\u043e\u0433\u0438\u043d",
    "fi": "Kirjaudu",
    "sv": "Login",
    "fa": "\u0648\u0631\u0648\u062f \u0628\u0647 \u0633\u06cc\u0633\u062a\u0645",
    "ar": "\u062a\u0633\u062c\u064a\u0644 \u0627\u0644\u062f\u062e\u0648\u0644",
    "uk": "\u0410\u0432\u0442\u043e\u0440\u0438\u0437\u0443\u0432\u0430\u0442\u0438\u0441\u044f"
  },
  "reset_password_no_token_message": {
    "sheet_name": "Web",
    "en": "This password reset email has expired.",
    "ru": "\u0417\u0430\u043c\u0435\u043d\u0430 \u0434\u0430\u043d\u043d\u043e\u0433\u043e \u043f\u0430\u0440\u043e\u043b\u044f \u0443\u0441\u0442\u0430\u0440\u0435\u043b\u0430. \u041e\u0442\u043f\u0440\u0430\u0432\u0438\u0442\u0435 \u043d\u043e\u0432\u0443\u044e \u0437\u0430\u044f\u0432\u043a\u0443 \u043d\u0430 \u0437\u0430\u043c\u0435\u043d\u0443 \u043f\u0430\u0440\u043e\u043b\u044f",
    "fi": "T\u00e4m\u00e4 salasanan vaihto on jo er\u00e4\u00e4ntynyt. L\u00e4het\u00e4 uusi salasanan vaihtopyynt\u00f6.",
    "sv": "Ditt \u00e5terst\u00e4llningsl\u00f6senord har utg\u00e5tt",
    "fa": "\u0627\u06cc\u0646 \u0627\u06cc\u0645\u06cc\u0644 \u0628\u0627\u0632\u0646\u0634\u0627\u0646\u06cc \u06af\u0630\u0631\u0648\u0627\u0698\u0647 \u0645\u0646\u0642\u0636\u06cc \u0634\u062f\u0647 \u0627\u0633\u062a.",
    "ar": "\u0627\u0646\u062a\u0647\u062a \u0635\u0644\u0627\u062d\u064a\u0629 \u0627\u0644\u0628\u0631\u064a\u062f \u0627\u0644\u0625\u0644\u0643\u062a\u0631\u0648\u0646\u064a \u0644\u0625\u0639\u0627\u062f\u0629 \u062a\u0639\u064a\u064a\u0646 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631.",
    "uk": "\u0417\u0430\u043c\u0456\u043d\u0430 \u043f\u0430\u0440\u043e\u043b\u044f \u0432\u0436\u0435 \u043d\u0435 \u0434\u0456\u0439\u0441\u043d\u0430. \u0412\u0456\u0434\u043f\u0440\u0430\u0432\u0442\u0435 \u043d\u043e\u0432\u0438\u0439 \u0437\u0430\u043f\u0438\u0442 \u043d\u0430 \u0437\u043c\u0456\u043d\u0443 \u043f\u0430\u0440\u043e\u043b\u044f"
  },
  "reset_password_success_message": {
    "sheet_name": "Web",
    "en": "You have set your new password. Now you can sign in using it.",
    "ru": "\u0412\u044b \u043f\u043e\u043c\u0435\u043d\u044f\u043b\u0438 \u043f\u0430\u0440\u043e\u043b\u044c. \u041c\u043e\u0436\u0435\u0442\u0435 \u0432\u043e\u0439\u0442\u0438 \u0432 \u0441\u0438\u0441\u0442\u0435\u043c\u0443 \u0441 \u043d\u043e\u0432\u044b\u043c \u043f\u0430\u0440\u043e\u043b\u0435\u043c",
    "fi": "Olet vaihtanut salasanasi. Voit nyt kirjautua uudella salasanalla.",
    "sv": "Du har skapat ett nytt l\u00f6senord. Nu kan du logga in",
    "fa": "\u0631\u0645\u0632 \u062c\u062f\u06cc\u062f \u062e\u0648\u062f \u0631\u0627 \u062a\u0646\u0638\u06cc\u0645 \u06a9\u0631\u062f\u0647 \u0627\u06cc\u062f. \u0627\u06a9\u0646\u0648\u0646 \u0645\u06cc \u062a\u0648\u0627\u0646\u06cc\u062f \u0628\u0627 \u0627\u0633\u062a\u0641\u0627\u062f\u0647 \u0627\u0632 \u0622\u0646 \u0648\u0627\u0631\u062f \u0633\u06cc\u0633\u062a\u0645 \u0634\u0648\u06cc\u062f.",
    "ar": "\u0644\u0642\u062f \u0642\u0645\u062a \u0628\u062a\u0639\u064a\u064a\u0646 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0627\u0644\u062c\u062f\u064a\u062f\u0629 \u0627\u0644\u062e\u0627\u0635\u0629 \u0628\u0643. \u0627\u0644\u0622\u0646 \u064a\u0645\u0643\u0646\u0643 \u062a\u0633\u062c\u064a\u0644 \u0627\u0644\u062f\u062e\u0648\u0644 \u0628\u0627\u0633\u062a\u062e\u062f\u0627\u0645\u0647.",
    "uk": "\u0412\u0430\u0448 \u043f\u0430\u0440\u043e\u043b\u044c \u0437\u043c\u0456\u043d\u0435\u043d\u043e. \u041c\u043e\u0436\u0435\u0442\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0443\u0432\u0430\u0442\u0438\u0441\u044f \u0437 \u043d\u043e\u0432\u0438\u043c \u043f\u0430\u0440\u043e\u043b\u0435\u043c."
  },
  "home_hexa_and_reports": {
    "sheet_name": "Web",
    "en": "reports",
    "ru": "",
    "fi": "raportit",
    "sv": "rapporter",
    "fa": "",
    "ar": "",
    "uk": "\u0417\u0432\u0456\u0442\u0438"
  },
  "home_hexa_pend": {
    "sheet_name": "Web",
    "en": "\/ Open",
    "ru": "\u041f\u043e\u0434\u043e\u0436\u0434\u0438\u0442\u0435",
    "fi": "\/ Avoinna",
    "sv": "\/ \u00d6ppna",
    "fa": "\u062f\u0631 \u0627\u0646\u062a\u0638\u0627\u0631",
    "ar": "\u0642\u064a\u062f \u0627\u0644\u0627\u0646\u062a\u0638\u0627\u0631",
    "uk": "\u0412\u0456\u0434\u043a\u0440\u0438\u0442\u0438"
  },
  "home_hexa_await": {
    "sheet_name": "Web",
    "en": "Awaiting",
    "ru": "\u041f\u043e\u0434\u043e\u0436\u0434\u0438\u0442\u0435",
    "fi": "Odottaa",
    "sv": "V\u00e4ntar",
    "fa": "\u062f\u0631 \u0627\u0646\u062a\u0638\u0627\u0631",
    "ar": "\u0641\u064a \u0627\u0646\u062a\u0638\u0627\u0631",
    "uk": "\u041e\u0447\u0456\u043a\u0443\u0439\u0442\u0435"
  },
  "home_hexa_apprv": {
    "sheet_name": "Web",
    "en": "approval",
    "ru": "\u0423\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043d\u0438\u0435",
    "fi": "hyv\u00e4ksynt\u00e4\u00e4",
    "sv": "p\u00e5 godk\u00e4nnande",
    "fa": "\u0645\u0648\u0627\u0641\u0642\u062a",
    "ar": "\u0645\u0648\u0627\u0641\u0642\u0629",
    "uk": "\u0417\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043d\u043d\u044f"
  },
  "home_hexa_foryou": {
    "sheet_name": "Web",
    "en": "for you",
    "ru": "\u0414\u043b\u044f \u0432\u0430\u0441",
    "fi": "sinulle",
    "sv": "f\u00f6r dig",
    "fa": "\u0628\u0631\u0627\u06cc \u0634\u0645\u0627",
    "ar": "\u0644\u0643",
    "uk": "\u0414\u043b\u044f \u0432\u0430\u0441"
  },
  "home_button_new": {
    "sheet_name": "Web",
    "en": "New order",
    "ru": "\u041d\u043e\u0432\u044b\u0439 \u0437\u0430\u043a\u0430\u0437",
    "fi": "Uusi tilaus",
    "sv": "Nytt uppdrag",
    "fa": "\u0634\u0641\u0627\u0631\u0634 \u062c\u062f\u06cc\u062f",
    "ar": "\u0637\u0644\u0628 \u062c\u062f\u064a\u062f",
    "uk": "\u041d\u043e\u0432\u0435 \u0437\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f"
  },
  "home_hexa_payments": {
    "sheet_name": "Web",
    "en": "Payments &",
    "ru": "",
    "fi": "Maksut &",
    "sv": "Betalningar &",
    "fa": "",
    "ar": "",
    "uk": "\u041f\u043b\u0430\u0442\u0435\u0436\u0456 &"
  },
  "home_hexa_amount": {
    "sheet_name": "Web",
    "en": "Earned this year",
    "ru": "\u041f\u043e\u043b\u0443\u0447\u0435\u043d\u043d\u0430\u044f \u0441\u0443\u043c\u043c\u0430",
    "fi": "Tulot \/ vuosi",
    "sv": "Tj\u00e4nat detta \u00e5r",
    "fa": "\u0645\u0628\u0644\u063a \u06a9\u0633\u0628 \u0634\u062f\u0647",
    "ar": "\u062d\u0635\u0644 \u0647\u0630\u0627 \u0627\u0644\u0639\u0627\u0645",
    "uk": "\u0414\u043e\u0445\u0456\u0434 \u0437\u0430 \u0440\u0456\u043a"
  },
  "menu_label_switch_service": {
    "sheet_name": "Web",
    "en": "Switch service",
    "ru": "\u041f\u043e\u043c\u0435\u043d\u044f\u0442\u044c \u0441\u043b\u0443\u0436\u0431\u0443",
    "fi": "Vaihda palvelua",
    "sv": "V\u00e4lj annan service",
    "fa": "\u062a\u063a\u06cc\u06cc\u0631 \u0633\u0631\u0648\u06cc\u0633",
    "ar": "\u062e\u062f\u0645\u0629 \u0627\u0644\u062a\u0628\u062f\u064a\u0644",
    "uk": "\u0417\u043c\u0456\u043d\u0430 \u043f\u043e\u0441\u043b\u0443\u0433\u0438"
  },
  "menu_label_terms": {
    "sheet_name": "Web",
    "en": "Terms of use",
    "ru": "\u0423\u0441\u043b\u043e\u0432\u0438\u044f \u0438\u0441\u043f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u043d\u0438\u044f",
    "fi": "K\u00e4ytt\u00f6ehdot",
    "sv": "Allm\u00e4nna villkor",
    "fa": "\u0634\u0631\u0627\u06cc\u0637 \u0627\u0633\u062a\u0641\u0627\u062f\u0647 \u0627\u0632 \u062e\u062f\u0645\u0627\u062a",
    "ar": "\u0634\u0631\u0648\u0637 \u0627\u0644\u062e\u062f\u0645\u0629",
    "uk": "\u0423\u043c\u043e\u0432\u0438 \u0432\u0438\u043a\u043e\u0440\u0438\u0441\u0442\u0430\u043d\u043d\u044f"
  },
  "menu_label_workers_map": {
    "sheet_name": "Web",
    "en": "Worker's map",
    "ru": "\u041a\u0430\u0440\u0442\u0430 \u0440\u0430\u0431\u043e\u0442\u043d\u0438\u043a\u043e\u0432",
    "fi": "Tekij\u00e4t",
    "sv": "Karta \u00f6ver utf\u00f6rare",
    "fa": "\u0646\u0642\u0634\u0647 \u06a9\u0627\u0631\u06af\u0631\u0627\u0646",
    "ar": "\u062e\u0631\u064a\u0637\u0629 \u0627\u0644\u0639\u0627\u0645\u0644",
    "uk": "\u041a\u0430\u0440\u0442\u0430 \u0440\u043e\u0431\u0456\u0442\u043d\u0438\u043a\u0456\u0432"
  },
  "menu_label_selectlang": {
    "sheet_name": "Web",
    "en": "Select language",
    "ru": "\u0412\u044b\u0431\u0435\u0440\u0438\u0442\u0435 \u044f\u0437\u044b\u043a",
    "fi": "Valitse kieli",
    "sv": "V\u00e4lj spr\u00e5k",
    "fa": "\u0632\u0628\u0627\u0646 \u0631\u0627 \u0627\u0646\u062a\u062e\u0627\u0628 \u06a9\u0646\u06cc\u062f",
    "ar": "\u0625\u062e\u062a\u0631 \u0627\u0644\u0644\u063a\u0629",
    "uk": "\u041e\u0431\u0435\u0440\u0456\u0442\u044c \u043c\u043e\u0432\u0443"
  },
  "menu_label_support": {
    "sheet_name": "Web",
    "en": "Support",
    "ru": "\u0421\u043b\u0443\u0436\u0431\u0430 \u043f\u043e\u0434\u0434\u0435\u0440\u0436\u043a\u0438",
    "fi": "Tuki",
    "sv": "Kundservice",
    "fa": "\u067e\u0634\u062a\u06cc\u0628\u0627\u0646\u06cc",
    "ar": "\u0627\u0644\u062f\u0639\u0645",
    "uk": "\u0421\u043b\u0443\u0436\u0431\u0430 \u043f\u0456\u0434\u0442\u0440\u0438\u043c\u043a\u0438"
  },
  "menu_no_content": {
    "sheet_name": "Web",
    "en": "No content yet.",
    "ru": "\u0415\u0449\u0451 \u043d\u0435\u0442 \u0441\u043e\u0434\u0435\u0440\u0436\u0430\u043d\u0438\u044f",
    "fi": "Ei viel\u00e4 sis\u00e4lt\u00f6\u00e4.",
    "sv": "Finns inget inneh\u00e5ll.",
    "fa": "\u0647\u0646\u0648\u0632 \u0645\u062d\u062a\u0648\u0627 \u0645\u0648\u062c\u0648\u062f \u0646\u06cc\u0633\u062a",
    "ar": "\u0644\u0627 \u0645\u062d\u062a\u0648\u0649 \u062d\u062a\u0649 \u0627\u0644\u0627\u0646",
    "uk": "\u0412\u043c\u0456\u0441\u0442\u0443 \u0449\u0435 \u043d\u0435\u043c\u0430\u0454"
  },
  "menu_label_service_admin": {
    "sheet_name": "Web",
    "en": "Service administration",
    "ru": "",
    "fi": "Palvelun hallinta",
    "sv": "Tj\u00e4nst administration",
    "fa": "",
    "ar": "",
    "uk": "\u0410\u0434\u043c\u0456\u043d\u0456\u0441\u0442\u0440\u0443\u0432\u0430\u043d\u043d\u044f \u0441\u0435\u0440\u0432\u0456\u0441\u0443"
  },
  "menu_label_home": {
    "sheet_name": "Web",
    "en": "Home",
    "ru": "\u0413\u043b\u0430\u0432\u043d\u0430\u044f",
    "fi": "Etusivu",
    "sv": "Hem",
    "fa": "\u0635\u0641\u062d\u0647 \u0627\u0635\u0644\u06cc",
    "ar": "\u0627\u0644\u0635\u0641\u062d\u0629 \u0627\u0644\u0631\u0626\u064a\u0633\u064a\u0629",
    "uk": "\u0413\u043e\u043b\u043e\u0432\u043d\u0430"
  },
  "menu_label_orders": {
    "sheet_name": "Web",
    "en": "Orders",
    "ru": "\u0417\u0430\u043a\u0430\u0437\u044b",
    "fi": "Tilaukset",
    "sv": "Uppdrag",
    "fa": "\u0633\u0641\u0627\u0631\u0634\u0627\u062a",
    "ar": "\u0627\u0644\u0627\u0634\u062a\u0631\u0627\u0643\u0627\u062a",
    "uk": "\u0417\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f"
  },
  "menu_label_settings": {
    "sheet_name": "Web",
    "en": "Profile settings",
    "ru": "\u041d\u0430\u0441\u0442\u0440\u043e\u0439\u043a\u0438 \u043f\u0440\u043e\u0444\u0438\u043b\u044f",
    "fi": "Profiilin asetukset",
    "sv": "Profilinst\u00e4llningar",
    "fa": "\u062a\u0646\u0638\u06cc\u0645\u0627\u062a \u067e\u0631\u0648\u0641\u0627\u06cc\u0644",
    "ar": "\u0625\u0639\u062f\u0627\u062f\u062a \u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u0634\u062e\u0635\u064a",
    "uk": "\u041d\u0430\u043b\u0430\u0448\u0442\u0443\u0432\u0430\u043d\u043d\u044f \u043f\u0440\u043e\u0444\u0456\u043b\u044e"
  },
  "menu_label_logout": {
    "sheet_name": "Web",
    "en": "Logout",
    "ru": "\u0412\u044b\u0439\u0442\u0438",
    "fi": "Kirjaudu ulos",
    "sv": "Logga ut",
    "fa": "\u062e\u0631\u0648\u062c",
    "ar": "\u062a\u0633\u062c\u064a\u0644 \u062e\u0631\u0648\u062c",
    "uk": "\u0412\u0438\u0439\u0442\u0438"
  },
  "menu_label_mode_worker": {
    "sheet_name": "Web",
    "en": "Worker %s",
    "ru": "%s \u0440\u0430\u0431\u043e\u0442\u043d\u0438\u043a\u0430",
    "fi": "Tekij\u00e4 %s",
    "sv": "Utf\u00f6rare %s",
    "fa": "%s \u06a9\u0627\u0631\u06af\u0631",
    "ar": "%s \u0627\u0644\u0639\u0627\u0645\u0644",
    "uk": "%s \u043f\u0440\u0430\u0446\u0456\u0432\u043d\u0438\u043a\u0430"
  },
  "menu_label_mode_orderer": {
    "sheet_name": "Web",
    "en": "Orderer %s",
    "ru": "%s \u0437\u0430\u043a\u0430\u0437\u0447\u0438\u043a\u0430",
    "fi": "Tilaaja %s",
    "sv": "Best\u00e4llare %s",
    "fa": "%s \u0633\u0641\u0627\u0631\u0634 \u062f\u0647\u0646\u062f\u0647",
    "ar": "%s \u0627\u0644\u0645\u0633\u0624\u0648\u0644",
    "uk": "%s \u0437\u0430\u043c\u043e\u0432\u043d\u0438\u043a\u0430"
  },
  "menu_label_payment_methods": {
    "sheet_name": "Web",
    "en": "Payment methods",
    "ru": "\u041f\u043b\u0430\u0442\u0435\u0436\u043d\u044b\u0435 \u0441\u0447\u0435\u0442\u0430",
    "fi": "Maksutavat",
    "sv": "Betalningsmetoder",
    "fa": "\u0631\u0648\u0634 \u0647\u0627\u06cc \u067e\u0631\u062f\u0627\u062e\u062a",
    "ar": "\u0637\u0631\u0642 \u0627\u0644\u062f\u0641\u0639",
    "uk": "\u041f\u043b\u0430\u0442\u0456\u0436\u043d\u0456 \u0440\u0430\u0445\u0443\u043d\u043a\u0438"
  },
  "menu_label_reports": {
    "sheet_name": "Web",
    "en": "Reports",
    "ru": "O\u0442\u0447\u0435\u0442\u044b",
    "fi": "Raportit",
    "sv": "Rapporter",
    "fa": "\u06af\u0632\u0627\u0631\u0634 \u0647\u0627",
    "ar": "\u062a\u0642\u0627\u0631\u064a\u0631",
    "uk": "\u0417\u0432\u0456\u0442\u0438"
  },
  "menu_label_pilot_points": {
    "sheet_name": "Web",
    "en": "PilotPoints",
    "ru": "PilotPoints",
    "fi": "PilotPoints",
    "sv": "PilotPoints",
    "fa": "PilotPoints",
    "ar": "PilotPoints",
    "uk": "PilotPoints"
  },
  "menu_label_public_profile": {
    "sheet_name": "Web",
    "en": "Profile used in tasks",
    "ru": "\u041f\u043e\u043a\u0430\u0437\u0430\u0442\u044c \u043c\u043e\u0439 \u043e\u0431\u0449\u0435\u0434\u043e\u0441\u0442\u0443\u043f\u043d\u044b\u0439 \u043f\u0440\u043e\u0444\u0438\u043b\u044c",
    "fi": "Profiili teht\u00e4viss\u00e4",
    "sv": "Visa min offentliga profil",
    "fa": "\u0646\u0645\u0627\u06cc\u0634 \u0645\u0634\u062e\u0635\u0627\u062a \u0639\u0645\u0648\u0645\u06cc \u0645\u0646",
    "ar": "\u0645\u0644\u0641 \u0627\u0644\u062a\u0639\u0631\u064a\u0641 \u0627\u0644\u0645\u0633\u062a\u062e\u062f\u0645 \u0641\u064a \u0627\u0644\u0645\u0647\u0627\u0645",
    "uk": "\u0417\u0430\u0433\u0430\u043b\u044c\u043d\u043e\u0434\u043e\u0441\u0442\u0443\u043f\u043d\u0438\u0439 \u043f\u0440\u043e\u0444\u0456\u043b\u044c"
  },
  "menu_label_my_teams": {
    "sheet_name": "Web",
    "en": "My teams",
    "ru": "\u041c\u043e\u0438 \u0433\u0440\u0443\u043f\u043f\u044b",
    "fi": "Ryhm\u00e4ni",
    "sv": "Mina grupper",
    "fa": "\u062a\u06cc\u0645 \u0647\u0627\u06cc \u0645\u0646",
    "ar": "\u0627\u0644\u0645\u062c\u0645\u0648\u0639\u0627\u062a \u0627\u0644\u062a\u064a \u0627\u0646\u062a\u0645\u064a \u0625\u0644\u064a\u0647\u0627",
    "uk": "\u041c\u043e\u0457 \u0433\u0440\u0443\u043f\u0438"
  },
  "menu_label_taskinterests": {
    "sheet_name": "Web",
    "en": "Task interests",
    "ru": "\u0418\u043d\u0442\u0435\u0440\u0435\u0441\u043d\u044b\u0435 \u0437\u0430\u0434\u0430\u0447\u0438",
    "fi": "Kiinnostavat kategoriat",
    "sv": "Intressanta uppdrag",
    "fa": "\u0634\u063a\u0644 \u0647\u0627\u06cc \u0645\u0648\u0631\u062f \u0639\u0644\u0627\u0642\u0647",
    "ar": "\u0645\u0647\u0627\u0645 \u0645\u062b\u064a\u0631\u0629 \u0644\u0644\u0627\u0647\u062a\u0645\u0627\u0645",
    "uk": "\u0426\u0456\u043a\u0430\u0432\u0456 \u0437\u0430\u0432\u0434\u0430\u043d\u043d\u044f"
  },
  "menu_label_personalinfo": {
    "sheet_name": "Web",
    "en": "Personal info",
    "ru": "\u041b\u0438\u0447\u043d\u0430\u044f \u0438\u043d\u0444\u043e\u0440\u043c\u0430\u0446\u0438\u044f",
    "fi": "Henkil\u00f6tiedot",
    "sv": "Personlig info",
    "fa": "\u0627\u0637\u0644\u0627\u0639\u0627\u062a \u0634\u062e\u0635\u06cc",
    "ar": "\u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062a \u0627\u0644\u0634\u062e\u0635\u064a\u0629",
    "uk": "\u041e\u0441\u043e\u0431\u0438\u0441\u0442\u0430 \u0456\u043d\u0444\u043e\u0440\u043c\u0430\u0446\u0456\u044f"
  },
  "menu_label_accomplishments": {
    "sheet_name": "Web",
    "en": "Accomplishments",
    "ru": "\u0412\u044b\u043f\u043e\u043b\u043d\u0435\u043d\u0438\u044f",
    "fi": "Osaaminen",
    "sv": "F\u00e4rdigheter",
    "fa": "\u062f\u0633\u062a\u0627\u0648\u0631\u062f\u0647\u0627\u06cc",
    "ar": "\u0627\u0644\u062e\u0628\u0631\u0627\u062a",
    "uk": "\u0414\u043e\u0441\u044f\u0433\u043d\u0435\u043d\u043d\u044f"
  },
  "home_switch_merchant_message": {
    "sheet_name": "Web",
    "en": "You have successfully switched service to %s!",
    "ru": "",
    "fi": "Olet vaihtanut onnistuneesti palveluun %s!",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0412\u0438 \u0443\u0441\u043f\u0456\u0448\u043d\u043e \u043f\u0435\u0440\u0435\u043a\u043b\u044e\u0447\u0438\u043b\u0438 \u0441\u043b\u0443\u0436\u0431\u0443 \u043d\u0430 %s!"
  },
  "settings_label_upload_img": {
    "sheet_name": "Web",
    "en": "Upload new image",
    "ru": "",
    "fi": "Lataa uusi kuva",
    "sv": "Ladda upp en ny bild",
    "fa": "",
    "ar": "",
    "uk": "\u0417\u0430\u0432\u0430\u043d\u0442\u0430\u0436\u0438\u0442\u0438 \u043d\u043e\u0432\u0435 \u0437\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u043d\u044f"
  },
  "settings_label_unlimited_dist": {
    "sheet_name": "Web",
    "en": "Unlimited distance",
    "ru": "",
    "fi": "Ei km rajoitusta",
    "sv": "Obegr\u00e4nsat avst\u00e5nd",
    "fa": "",
    "ar": "",
    "uk": "\u041d\u0435\u043e\u0431\u043c\u0435\u0436\u0435\u043d\u0430 \u0432\u0456\u0434\u0441\u0442\u0430\u043d\u044c"
  },
  "settings_label_no_lang_added": {
    "sheet_name": "Web",
    "en": "No language added yet.",
    "ru": "",
    "fi": "Kielitaitoa ei viel\u00e4 lis\u00e4tty",
    "sv": "Inget spr\u00e5k har lagts till \u00e4nnu.",
    "fa": "",
    "ar": "",
    "uk": "\u041c\u043e\u0432\u0430 \u0449\u0435 \u043d\u0435 \u0434\u043e\u0434\u0430\u043d\u0430"
  },
  "settings_label_no_edu_added": {
    "sheet_name": "Web",
    "en": "No education added yet.",
    "ru": "",
    "fi": "Koulutuksia ei viel\u00e4 lis\u00e4tty",
    "sv": "Inget spr\u00e5k har lagts till \u00e4nnu.",
    "fa": "",
    "ar": "",
    "uk": "\u041e\u0441\u0432\u0456\u0442\u0430 \u0449\u0435 \u043d\u0435 \u0434\u043e\u0434\u0430\u043d\u0430"
  },
  "settings_label_add_edu": {
    "sheet_name": "Web",
    "en": "Add education or certificate",
    "ru": "",
    "fi": "Lis\u00e4\u00e4 koulutus tai sertifikaatti",
    "sv": "L\u00e4gg till utbildning eller certifikat",
    "fa": "",
    "ar": "",
    "uk": "\u0414\u043e\u0434\u0430\u0442\u0438 \u043e\u0441\u0432\u0456\u0442\u0443 \u0430\u0431\u043e \u0441\u0435\u0440\u0442\u0438\u0444\u0456\u043a\u0430\u0442\u0438"
  },
  "settings_label_completed_year": {
    "sheet_name": "Web",
    "en": "Completed year",
    "ru": "",
    "fi": "Valmistunut vuosi",
    "sv": "Slutf\u00f6rt \u00e5r",
    "fa": "",
    "ar": "",
    "uk": "\u0417\u0430\u043a\u0456\u043d\u0447\u0435\u043d\u0438\u0439 \u0440\u0456\u043a"
  },
  "settings_label_completed_month": {
    "sheet_name": "Web",
    "en": "Completed month",
    "ru": "",
    "fi": "Valmistunut kk",
    "sv": "Slutf\u00f6rd m\u00e5nad",
    "fa": "",
    "ar": "",
    "uk": "\u0417\u0430\u043a\u0456\u043d\u0447\u0435\u043d\u0438\u0439 \u043c\u0456\u0441\u044f\u0446\u044c"
  },
  "settings_label_delete": {
    "sheet_name": "Web",
    "en": "Delete",
    "ru": "",
    "fi": "Poista",
    "sv": "Radera",
    "fa": "",
    "ar": "",
    "uk": "\u0412\u0438\u0434\u0430\u043b\u0438\u0442\u0438"
  },
  "settings_label_lang_ar": {
    "sheet_name": "Web",
    "en": "Arabic",
    "ru": "",
    "fi": "Arabia",
    "sv": "Arabiska",
    "fa": "",
    "ar": "",
    "uk": "\u0410\u0440\u0430\u0431\u0441\u044c\u043a\u0430"
  },
  "settings_label_lang_en": {
    "sheet_name": "Web",
    "en": "English",
    "ru": "",
    "fi": "Englanti",
    "sv": "Engelska",
    "fa": "",
    "ar": "",
    "uk": "\u0410\u043d\u0433\u043b\u0456\u0439\u0441\u044c\u043a\u0430"
  },
  "settings_label_lang_fa": {
    "sheet_name": "Web",
    "en": "Dari",
    "ru": "",
    "fi": "Dari",
    "sv": "Dari",
    "fa": "",
    "ar": "",
    "uk": "\u0414\u0430\u0440\u0456"
  },
  "settings_label_lang_fi": {
    "sheet_name": "Web",
    "en": "Finnish",
    "ru": "",
    "fi": "Suomi",
    "sv": "Finska",
    "fa": "",
    "ar": "",
    "uk": "\u0424\u0456\u043d\u0441\u044c\u043a\u0430"
  },
  "settings_label_lang_ru": {
    "sheet_name": "Web",
    "en": "Russian",
    "ru": "",
    "fi": "Ven\u00e4j\u00e4",
    "sv": "Ryska",
    "fa": "",
    "ar": "",
    "uk": "\u0420\u043e\u0441\u0456\u0439\u0441\u044c\u043a\u0430"
  },
  "settings_label_lang_sv": {
    "sheet_name": "Web",
    "en": "Swedish",
    "ru": "",
    "fi": "Ruotsi",
    "sv": "Svenska",
    "fa": "",
    "ar": "",
    "uk": "\u0428\u0432\u0435\u0434\u0441\u044c\u043a\u0430"
  },
  "settings_label_no_exp_added": {
    "sheet_name": "Web",
    "en": "No experience added yet.",
    "ru": "",
    "fi": "Kokemuksia ei viel\u00e4 lis\u00e4tty",
    "sv": "Ingen erfarenhet tillagd \u00e4n.",
    "fa": "",
    "ar": "",
    "uk": "\u0414\u043e\u0441\u0432\u0456\u0434 \u0449\u0435 \u043d\u0435 \u0434\u043e\u0434\u0430\u043d\u043e"
  },
  "settings_label_start_month": {
    "sheet_name": "Web",
    "en": "Start month",
    "ru": "",
    "fi": "Aloitus kk",
    "sv": "Startm\u00e5nad",
    "fa": "",
    "ar": "",
    "uk": "\u041f\u043e\u0447\u0430\u0442\u043e\u043a \u043c\u0456\u0441\u044f\u0446\u044f"
  },
  "settings_label_start_year": {
    "sheet_name": "Web",
    "en": "Start year",
    "ru": "",
    "fi": "Aloitus vuosi",
    "sv": "Start\u00e5r",
    "fa": "",
    "ar": "",
    "uk": "\u041f\u043e\u0447\u0430\u0442\u043e\u043a \u0440\u043e\u043a\u0443"
  },
  "settings_label_end_month": {
    "sheet_name": "Web",
    "en": "End month",
    "ru": "",
    "fi": "Lopetus kk",
    "sv": "Slutm\u00e5nad",
    "fa": "",
    "ar": "",
    "uk": "\u041a\u0456\u043d\u0435\u0446\u044c \u043c\u0456\u0441\u044f\u0446\u044f"
  },
  "settings_label_end_year": {
    "sheet_name": "Web",
    "en": "End year",
    "ru": "",
    "fi": "Lopetus vuosi",
    "sv": "Slut\u00e5r",
    "fa": "",
    "ar": "",
    "uk": "\u041a\u0456\u043d\u0435\u0446\u044c \u0440\u043e\u043a\u0443"
  },
  "settings_label_edit_exp": {
    "sheet_name": "Web",
    "en": "Edit experience",
    "ru": "\u0440\u0435\u0434\u0430\u043a\u0442\u0438\u0440\u043e\u0432\u0430\u0442\u044c \u043e\u043f\u044b\u0442",
    "fi": "Muokkaa kokemusta",
    "sv": "Redigera erfarenhet",
    "fa": "\u062a\u062c\u0631\u0628\u0647 \u062e\u0648\u062f \u0631\u0627 \u0648\u06cc\u0631\u0627\u06cc\u0634 \u06a9\u0646\u06cc\u062f",
    "ar": "\u062a\u0639\u062f\u064a\u0644 \u0627\u0644\u062e\u0628\u0631\u0627\u062a",
    "uk": "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438 \u0434\u043e\u0441\u0432\u0456\u0434"
  },
  "settings_label_saved": {
    "sheet_name": "Web",
    "en": "New settings saved successfully!",
    "ru": "",
    "fi": "Uudet asetukset tallennettu",
    "sv": "Nya inst\u00e4llningar har sparats",
    "fa": "",
    "ar": "",
    "uk": "\u041d\u043e\u0432\u0456 \u043d\u0430\u043b\u0430\u0448\u0442\u0443\u0432\u0430\u043d\u043d\u044f \u0443\u0441\u043f\u0456\u0448\u043d\u043e \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043d\u043e"
  },
  "settings_label_update_dialog": {
    "sheet_name": "Web",
    "en": "Update your profile image",
    "ru": "\u041e\u0431\u043d\u043e\u0432\u0438\u0442\u044c \u0438\u0437\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u0438\u0435 \u0441\u0432\u043e\u0435\u0433\u043e \u043f\u0440\u043e\u0444\u0438\u043b\u044f",
    "fi": "P\u00e4ivit\u00e4 profiilikuvasi",
    "sv": "Uppdatera profilbild",
    "fa": "\u062a\u0635\u0648\u06cc\u0631 \u067e\u0631\u0648\u0641\u0627\u06cc\u0644 \u062e\u0648\u062f \u0631\u0627 \u0628\u0647 \u0631\u0648\u0632 \u06a9\u0646\u06cc\u062f",
    "ar": "\u064a\u0631\u062c\u0649 \u062a\u062d\u062f\u064a\u062b \u0635\u0648\u0631\u0629 \u0645\u0644\u0641\u0643 \u0627\u0644\u0634\u062e\u0635\u064a",
    "uk": "\u041e\u043d\u043e\u0432\u0438\u0442\u0438 \u0437\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u043d\u044f \u043f\u0440\u043e\u0444\u0456\u043b\u044e"
  },
  "settings_label_update": {
    "sheet_name": "Web",
    "en": "Update",
    "ru": "\u041e\u0431\u043d\u043e\u0432\u0438\u0442\u044c",
    "fi": "P\u00e4ivit\u00e4",
    "sv": "Uppdatera",
    "fa": "\u0628\u0647 \u0631\u0648\u0632 \u0631\u0633\u0627\u0646\u06cc",
    "ar": "\u062a\u062d\u062f\u064a\u062b",
    "uk": "\u041e\u043d\u043e\u0432\u043b\u0435\u043d\u043d\u044f"
  },
  "settings_org_type_invalid_txt": {
    "sheet_name": "Web",
    "en": "Organization type is required",
    "ru": "\u0422\u0438\u043f \u043e\u0440\u0433\u0430\u043d\u0438\u0437\u0430\u0446\u0438\u0438",
    "fi": "Organisaatiotyyppi",
    "sv": "Typ av organisation",
    "fa": "\u0646\u0648\u0639 \u0633\u0627\u0632\u0645\u0627\u0646",
    "ar": "\u0646\u0648\u0639 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0645\u0637\u0644\u0648\u0628",
    "uk": "\u0422\u0438\u043f \u043e\u0440\u0433\u0430\u043d\u0456\u0437\u0430\u0446\u0456\u0457"
  },
  "settings_label_worker_type": {
    "sheet_name": "Web",
    "en": "Worker type",
    "ru": "\u0442\u0438\u043f \u0440\u0430\u0431\u043e\u0442\u043d\u0438\u043a\u0430",
    "fi": "Sopimusmuoto",
    "sv": "Typ av arbetare",
    "fa": "\u0646\u0648\u0639 \u06a9\u0627\u0631\u06af\u0631",
    "ar": "\u0646\u0648\u0639 \u0627\u0644\u0639\u0627\u0645\u0644",
    "uk": "\u0422\u0438\u043f \u043f\u0440\u0430\u0446\u0456\u0432\u043d\u0438\u043a\u0430"
  },
  "settings_label_distance": {
    "sheet_name": "Web",
    "en": "Distance (km)",
    "ru": "\u0420\u0430\u0441\u0441\u0442\u043e\u044f\u043d\u0438\u0435 (\u043a\u043c)",
    "fi": "Et\u00e4isyys (km)",
    "sv": "Avst\u00e5nd (km)",
    "fa": "\u0641\u0627\u0635\u0644\u0647 (\u06a9\u06cc\u0644\u0648\u0645\u062a\u0631)",
    "ar": "\u0627\u0644\u0645\u0633\u0627\u0641\u0629( \u0643\u064a\u0644\u0648\u0645\u062a\u0631)",
    "uk": "\u0412\u0456\u0434\u0441\u0442\u0430\u043d\u044c (\u043a\u043c)"
  },
  "settings_label_bank_acc": {
    "sheet_name": "Web",
    "en": "Bank account number",
    "ru": "\u041d\u043e\u043c\u0435\u0440 \u0431\u0430\u043d\u043a\u043e\u0432\u0441\u043a\u043e\u0433\u043e \u0441\u0447\u0435\u0442\u0430",
    "fi": "Pankkitilinumero",
    "sv": "Clearingnummer och kontonummer",
    "fa": "\u0634\u0645\u0627\u0631\u0647 \u062d\u0633\u0627\u0628 \u0628\u0627\u0646\u06a9\u06cc",
    "ar": "\u0631\u0642\u0645 \u0627\u0644\u062d\u0633\u0627\u0628 \u0627\u0644\u0645\u0635\u0631\u0641\u064a",
    "uk": "\u041d\u043e\u043c\u0435\u0440 \u0431\u0430\u043d\u043a\u0456\u0432\u0441\u044c\u043a\u043e\u0433\u043e \u0440\u0430\u0445\u0443\u043d\u043a\u0443"
  },
  "settings_label_tax": {
    "sheet_name": "Web",
    "en": "Tax percentage",
    "ru": "\u041f\u0440\u043e\u0446\u0435\u043d\u0442 \u043d\u0430\u043b\u043e\u0433\u0430",
    "fi": "Veroprosentti",
    "sv": "Skatteprocent",
    "fa": "\u062f\u0631\u0635\u062f \u0645\u0627\u0644\u06cc\u0627\u062a",
    "ar": "\u0645\u0639\u062f\u0644 \u0627\u0644\u0636\u0631\u064a\u0628\u0629",
    "uk": "\u0412\u0456\u0434\u0441\u043e\u0442\u043e\u043a \u043f\u043e\u0434\u0430\u0442\u043a\u0443"
  },
  "settings_label_ssn": {
    "sheet_name": "Web",
    "en": "Social Security Number (SSN)",
    "ru": "\u041d\u043e\u043c\u0435\u0440 \u0441\u043e\u0446\u0438\u0430\u043b\u044c\u043d\u043e\u0433\u043e \u0441\u0442\u0440\u0430\u0445\u043e\u0432\u0430\u043d\u0438\u044f (SSN)",
    "fi": "Henkil\u00f6tunnus",
    "sv": "Personnummer",
    "fa": "\u0634\u0645\u0627\u0631\u0647 \u0622\u06cc\u062f\u06cc \u06a9\u0627\u0631\u062a",
    "ar": "\u0631\u0642\u0645 \u0627\u0644\u0647\u0648\u064a\u0629",
    "uk": "\u041e\u0441\u043e\u0431\u0438\u0441\u0442\u0438\u0439 \u0456\u0434\u0435\u043d\u0442\u0438\u0444\u0456\u043a\u0430\u0446\u0456\u0439\u043d\u0438\u0439 \u043d\u043e\u043c\u0435\u0440"
  },
  "settings_label_video_pres": {
    "sheet_name": "Web",
    "en": "Video presentation",
    "ru": "\u0412\u0438\u0434\u0435\u043e \u043f\u0440\u0435\u0437\u0435\u043d\u0442\u0430\u0446\u0438\u044f",
    "fi": "Videoesittelyni",
    "sv": "Video presentation",
    "fa": "\u0627\u0631\u0627\u0626\u0647 \u0641\u06cc\u0644\u0645",
    "ar": "\u0639\u0631\u0636 \u0641\u064a\u062f\u064a\u0648",
    "uk": "\u0412\u0456\u0434\u0435\u043e\u043f\u0440\u0435\u0437\u0435\u043d\u0442\u0430\u0446\u0456\u044f"
  },
  "settings_label_company": {
    "sheet_name": "Web",
    "en": "Company name",
    "ru": "\u041d\u0430\u0437\u0432\u0430\u043d\u0438\u0435 \u043a\u043e\u043c\u043f\u0430\u043d\u0438\u0438",
    "fi": "Organisaation nimi",
    "sv": "Organisationens namn",
    "fa": "\u0646\u0627\u0645 \u0634\u0631\u06a9\u062a",
    "ar": "\u0627\u0633\u0645 \u0627\u0644\u0634\u0631\u0643\u0629",
    "uk": "\u041d\u0430\u0437\u0432\u0430 \u043a\u043e\u043c\u043f\u0430\u043d\u0456\u0457"
  },
  "settings_label_select_task_type": {
    "sheet_name": "Web",
    "en": "Select categories you're interested in",
    "ru": "\u0412\u044b\u0431\u0435\u0440\u0438\u0442\u0435 \u0442\u0438\u043f\u044b \u0440\u0430\u0431\u043e\u0442, \u0432 \u043a\u043e\u0442\u043e\u0440\u044b\u0445 \u0412\u044b \u0437\u0430\u0438\u043d\u0442\u0435\u0440\u0435\u0441\u043e\u0432\u0430\u043d\u044b",
    "fi": "Kategoriat, joista olet kiinnostunut",
    "sv": "V\u00e4lj uppdrag som du \u00e4r intresserad av",
    "fa": "\u0627\u0646\u0648\u0627\u0639 \u06a9\u0627\u0631\u0647\u0627\u06cc\u06cc \u0631\u0627 \u06a9\u0647 \u0628\u0647 \u0622\u0646\u0647\u0627 \u0639\u0644\u0627\u0642\u0647 \u062f\u0627\u0631\u06cc\u062f \u0627\u0646\u062a\u062e\u0627\u0628 \u06a9\u0646\u06cc\u062f",
    "ar": "\u062d\u062f\u062f \u0627\u0646\u0648\u0627\u0639 \u0627\u0644\u0645\u0647\u0627\u0645 \u0627\u0644\u062a\u064a \u062a\u0647\u062a\u0645 \u0628\u0647\u0627",
    "uk": "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044c \u0442\u0438\u043f \u0440\u043e\u0431\u0456\u0442, \u044f\u043a\u0456 \u0432\u0430\u0441 \u0446\u0456\u043a\u0430\u0432\u043b\u044f\u0442\u044c"
  },
  "settings_label_proficiency": {
    "sheet_name": "Web",
    "en": "Proficiency",
    "ru": "\u0423\u0440\u043e\u0432\u0435\u043d\u044c",
    "fi": "P\u00e4tevyys",
    "sv": "Skicklighet",
    "fa": "\u0645\u0647\u0627\u0631\u062a",
    "ar": "\u0625\u062a\u0642\u0627\u0646",
    "uk": "\u0420\u0456\u0432\u0435\u043d\u044c \u043c\u0430\u0439\u0441\u0442\u0435\u0440\u043d\u043e\u0441\u0442\u0456"
  },
  "settings_label_type": {
    "sheet_name": "Web",
    "en": "Type",
    "ru": "\u0422\u0438\u043f",
    "fi": "Tyyppi",
    "sv": "Typ",
    "fa": "\u0646\u0648\u0639",
    "ar": "\u0627\u0644\u0646\u0648\u0639",
    "uk": "\u0422\u0438\u043f"
  },
  "settings_label_title": {
    "sheet_name": "Web",
    "en": "Title",
    "ru": "\u0422\u0438\u0442\u043b",
    "fi": "Tutkinto \/ Tutkinnon kuvaus",
    "sv": "Titel \/ Expertis",
    "fa": "\u0631\u0634\u062a\u0647 \/ \u062f\u0631\u062c\u0647 \u062a\u062d\u0635\u06cc\u0644",
    "ar": "\u0627\u0644\u0645\u0633\u0645\u0649 \u0627\u0644\u0648\u0638\u064a\u0641\u064a",
    "uk": "\u0422\u0438\u0442\u0443\u043b"
  },
  "settings_label_where": {
    "sheet_name": "Web",
    "en": "Where",
    "ru": "\u041a\u0443\u0434\u0430",
    "fi": "Miss\u00e4 \/ Organisaatio",
    "sv": "Var \/ Organisationen",
    "fa": "\u062f\u0631 \u06a9\u062c\u0627",
    "ar": "\u0627\u064a\u0646",
    "uk": "\u041a\u0443\u0434\u0438"
  },
  "settings_label_add_exp": {
    "sheet_name": "Web",
    "en": "Add experience",
    "ru": "\u0414\u043e\u0431\u0430\u0432\u044c\u0442\u0435 \u0441\u0432\u043e\u0439 \u043f\u0440\u0435\u0434\u044b\u0434\u0443\u0449\u0438\u0439 \u0438 \u043d\u0430\u0441\u0442\u043e\u044f\u0449\u0438\u0439 \u043e\u043f\u044b\u0442 \u0440\u0430\u0431\u043e\u0442\u044b",
    "fi": "Lis\u00e4\u00e4 kokemus",
    "sv": "L\u00e4gg till erfarenhet",
    "fa": "\u0627\u0636\u0627\u0641\u0647 \u06a9\u0631\u062f\u0646 \u062a\u062c\u0631\u0628\u0647",
    "ar": "\u0627\u0644\u0645\u0632\u064a\u062f \u0645\u0646 \u0627\u0644\u062e\u0628\u0631\u0629",
    "uk": "\u0414\u043e\u0434\u0430\u0439\u0442\u0435 \u0441\u0432\u0456\u0439 \u043f\u043e\u043f\u0435\u0440\u0435\u0434\u043d\u0456\u0439 \u0442\u0430 \u0442\u0435\u043f\u0435\u0440\u0456\u0448\u043d\u0456\u0439 \u0434\u043e\u0441\u0432\u0456\u0434 \u0440\u043e\u0431\u043e\u0442\u0438"
  },
  "settings_label_tooltip_exp": {
    "sheet_name": "Web",
    "en": "Here you can add any type of job or other type of work experience that you have. For example: volunteer work, part time gigs or any other items that you think could be interesting.",
    "ru": "\u0417\u0434\u0435\u0441\u044c \u0412\u044b \u043c\u043e\u0436\u0435\u0442\u0435 \u0434\u043e\u0431\u0430\u0432\u0438\u0442\u044c \u043b\u044e\u0431\u043e\u0439 \u0442\u0438\u043f \u0440\u0430\u0431\u043e\u0442\u044b \u0438\u043b\u0438 \u0434\u0440\u0443\u0433\u043e\u0439 \u0432\u0438\u0434 \u043e\u043f\u044b\u0442\u0430, \u043a\u043e\u0442\u043e\u0440\u044b\u0439 \u0443 \u0412\u0430\u0441 \u0435\u0441\u0442\u044c. \u041d\u0430\u043f\u0440\u0438\u043c\u0435\u0440: \u043b\u0435\u0442\u043d\u044f\u044f \u0440\u0430\u0431\u043e\u0442\u0430, \u0432\u043e\u043b\u043e\u043d\u0442\u0435\u0440\u0441\u043a\u0430\u044f \u0440\u0430\u0431\u043e\u0442\u0430, \u043a\u043e\u043d\u0446\u0435\u0440\u0442\u044b \u043d\u0430 \u043d\u0435\u043f\u043e\u043b\u043d\u044b\u0439 \u0440\u0430\u0431\u043e\u0447\u0438\u0439 \u0434\u0435\u043d\u044c \u0438\u043b\u0438 \u043b\u044e\u0431\u044b\u0435 \u0434\u0440\u0443\u0433\u0438\u0435 \u0440\u0430\u0437\u0434\u0435\u043b\u044b, \u043a\u043e\u0442\u043e\u0440\u044b\u0435, \u043f\u043e \u0412\u0430\u0448\u0435\u043c\u0443 \u043c\u043d\u0435\u043d\u0438\u044e, \u043c\u043e\u0433\u0443\u0442 \u0431\u044b\u0442\u044c \u0438\u043d\u0442\u0435\u0440\u0435\u0441\u043d\u044b\u043c\u0438.",
    "fi": "T\u00e4nne voit lis\u00e4t\u00e4 ty\u00f6kokemuksesi ja muuta kokemusta, josta voisi olla hy\u00f6ty\u00e4 CV:ll\u00e4si. Esim. vapaaehtoisty\u00f6, osa-aikaty\u00f6 ja muut vastuut.",
    "sv": "H\u00e4r kan du l\u00e4gga till vilken typ av jobb eller annan arbetslivserfarenhet du har. Till exempel: volont\u00e4rarbete, deltidsjobb eller andra saker som du tycker att kan vara till din f\u00f6rdel.",
    "fa": "\u0627\u06cc\u0646\u062c\u0627 \u0645\u06cc\u062a\u0648\u0627\u0646\u06cc\u062f \u0647\u0631 \u0646\u0648\u0639 \u062a\u062c\u0631\u0628\u0647 \u06a9\u0627\u0631\u06cc \u0631\u0627 \u06a9\u0647 \u0634\u0645\u0627 \u062f\u0627\u0631\u06cc\u062f \u0627\u0636\u0627\u0641\u0647 \u0646\u0645\u0627\u06cc\u06cc\u062f. \u0628\u0637\u0648\u0631 \u0645\u062b\u0627\u0644\u060c \u062a\u062c\u0627\u0631\u0628 \u06a9\u0627\u0631 \u0647\u0627\u06cc \u062a\u0627\u0628\u0633\u062a\u0627\u0646\u06cc\u060c \u062a\u062c\u0627\u0631\u0628 \u06a9\u0627\u0631 \u0647\u0627\u06cc \u06a9\u0648\u062a\u0627\u0647 \u0645\u062f\u062a \u0648 \u06a9\u0627\u0631 \u0647\u0627\u06cc \u06a9\u0647 \u0634\u0645\u0627 \u0628\u0647 \u0627\u0646\u062c\u0627\u0645 \u0622\u0646 \u0639\u0644\u0627\u0642\u0647 \u062f\u0627\u0631\u06cc\u062f.",
    "ar": "\u0647\u0646\u0627 \u064a\u0645\u0643\u0646\u0643 \u0625\u0636\u0627\u0641\u0629 \u0627\u064a \u0646\u0648\u0639 \u0645\u0646 \u0627\u0644\u0639\u0645\u0644 \u0627\u0648 \u0627\u064a \u0646\u0648\u0639 \u0627\u062e\u0631 \u0645\u0646 \u0627\u0644\u062e\u0628\u0631\u0629 \u0627\u0644\u0639\u0645\u0644\u064a\u0629 \u0644\u062f\u064a\u0643. \u0639\u0644\u0649 \u0633\u0628\u064a\u0644 \u0627\u0644\u0645\u062b\u0627\u0644 : \u0627\u0644\u0639\u0645\u0644 \u0627\u0644\u0635\u064a\u0641\u064a \u0627\u0648 \u0627\u0644\u0639\u0645\u0644 \u0627\u0644\u062a\u0637\u0648\u0639\u064a \u0627\u0648 \u0627\u0644\u0639\u0631\u0628\u0627\u062a \u0628\u062f\u0648\u0627\u0645 \u062c\u0632\u0626\u064a \u0627\u0648 \u0627\u064a \u0639\u0646\u0635\u0631 \u0627\u062e\u0631\u0649 \u062a\u0639\u062a\u0642\u062f \u0627\u0646\u0647\u0627 \u0642\u062f \u062a\u0643\u0648\u0646 \u0645\u062b\u064a\u0631\u0629 \u0644\u0644\u0627\u0647\u062a\u0645\u0627\u0645.",
    "uk": "\u0422\u0443\u0442 \u0432\u0438 \u043c\u043e\u0436\u0435\u0442\u0435 \u0434\u043e\u0434\u0430\u0442\u0438 \u0431\u0443\u0434\u044c-\u044f\u043a\u0438\u0439 \u0442\u0438\u043f \u0440\u043e\u0431\u043e\u0442\u0438 \u0430\u0431\u043e \u0456\u043d\u0448\u0438\u0439 \u0442\u0438\u043f \u0434\u043e\u0441\u0432\u0456\u0434\u0443 \u0440\u043e\u0431\u043e\u0442\u0438, \u044f\u043a\u0438\u0439 \u0432\u0438 \u043c\u0430\u0454\u0442\u0435. \u041d\u0430\u043f\u0440\u0438\u043a\u043b\u0430\u0434: \u0432\u043e\u043b\u043e\u043d\u0442\u0435\u0440\u0441\u044c\u043a\u0430 \u0440\u043e\u0431\u043e\u0442\u0430, \u0440\u043e\u0431\u043e\u0442\u0430 \u043d\u0430 \u043d\u0435\u043f\u043e\u0432\u043d\u0438\u0439 \u0440\u043e\u0431\u043e\u0447\u0438\u0439 \u0434\u0435\u043d\u044c, \u0442\u0438\u043c\u0447\u0430\u0441\u043e\u0432\u0430 \u0440\u043e\u0431\u043e\u0442\u0430  \u0430\u0431\u043e \u0431\u0443\u0434\u044c-\u044f\u043a\u0456 \u0456\u043d\u0448\u0456 \u0440\u0435\u0447\u0456, \u044f\u043a\u0456, \u043d\u0430 \u0432\u0430\u0448\u0443 \u0434\u0443\u043c\u043a\u0443, \u043c\u043e\u0436\u0443\u0442\u044c \u0431\u0443\u0442\u0438 \u0446\u0456\u043a\u0430\u0432\u0438\u043c\u0438"
  },
  "settings_label_position": {
    "sheet_name": "Web",
    "en": "Position \/ Other experience",
    "ru": "\u0414\u043e\u043b\u0436\u043d\u043e\u0441\u0442\u044c \/ \u0414\u0440\u0443\u0433\u043e\u0439 \u043e\u043f\u044b\u0442",
    "fi": "Asema \/ Muu kokemus",
    "sv": "Position \/ annan erfarenhet",
    "fa": "\u0645\u0642\u0627\u0645 \/ \u062a\u062c\u0631\u0628\u0647 \u062f\u06cc\u06af\u0631",
    "ar": "\u0645\u0646\u0635\u0628 \/ \u062e\u0628\u0631\u0629 \u0623\u062e\u0631\u0649",
    "uk": "\u041f\u043e\u0441\u0430\u0434\u0430\/ \u0456\u043d\u0448\u0438\u0439 \u0434\u043e\u0441\u0432\u0456\u0434"
  },
  "settings_label_current": {
    "sheet_name": "Web",
    "en": "Current",
    "ru": "\u0442\u0435\u043a\u0443\u0449\u0438\u0439",
    "fi": "Menossa",
    "sv": "P\u00e5g\u00e5ende",
    "fa": "\u062c\u0627\u0631\u06cc",
    "ar": "\u0627\u0644\u062d\u0627\u0644\u064a",
    "uk": "\u041f\u043e\u0442\u043e\u0447\u043d\u0438\u0439"
  },
  "settings_label_description": {
    "sheet_name": "Web",
    "en": "Description (optional)",
    "ru": "\u041e\u043f\u0438\u0441\u0430\u043d\u0438\u0435 (\u043d\u0435\u043e\u0431\u044f\u0437\u0430\u0442\u0435\u043b\u044c\u043d\u043e)",
    "fi": "Kuvaus",
    "sv": "Beskrivning (Valfritt)",
    "fa": "\u062a\u0648\u0636\u06cc\u062d (\u0627\u062e\u062a\u06cc\u0627\u0631\u06cc)",
    "ar": "\u0648\u0635\u0641",
    "uk": "\u041e\u043f\u0438\u0441 (\u043d\u0435\u043e\u0431\u043e\u0432'\u044f\u0437\u043a\u043e\u0432\u043e)"
  },
  "settings_label_video": {
    "sheet_name": "Web",
    "en": "Video (optional)",
    "ru": "\u0412\u0438\u0434\u0435\u043e (\u043d\u0435\u043e\u0431\u044f\u0437\u0430\u0442\u0435\u043b\u044c\u043d\u043e)",
    "fi": "Video",
    "sv": "Video (frivilligt)",
    "fa": "\u0648\u06cc\u062f\u06cc\u0648",
    "ar": "\u0641\u064a\u062f\u064a\u0648 (\u0627\u062e\u062a\u064a\u0627\u0631\u064a)",
    "uk": "\u0412\u0456\u0434\u0435\u043e (\u043d\u0435\u043e\u0431\u043e\u0432'\u044f\u0437\u043a\u043e\u0432\u043e)"
  },
  "settings_label_short_desc": {
    "sheet_name": "Web",
    "en": "Profile description",
    "ru": "\u041a\u0440\u0430\u0442\u043a\u043e\u0435 \u043e\u043f\u0438\u0441\u0430\u043d\u0438\u0435 \u0412\u0430\u0441",
    "fi": "Profiilin kuvaus",
    "sv": "Profilbeskrivning",
    "fa": "\u062a\u0648\u0636\u06cc\u062d\u06cc \u06a9\u0648\u062a\u0627\u0647 \u0627\u0632 \u062e\u0648\u062f",
    "ar": "\u0648\u0635\u0641 \u0642\u0635\u064a\u0631 \u0639\u0646 \u0646\u0641\u0633\u0643",
    "uk": "\u044f\u043a \u0431\u0438 \u0432\u0438 \u043f\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u0438\u043b\u0438\u0441\u044f \u0440\u043e\u0431\u043e\u0442\u043e\u0434\u0430\u0432\u0446\u044e?\n(\u043e\u043f\u0438\u0448\u0456\u0442\u044c \u0441\u0435\u0431\u0435 \u043a\u043e\u0440\u043e\u0442\u043a\u043e)"
  },
  "settings_label_add_lang": {
    "sheet_name": "Web",
    "en": "Add Language",
    "ru": "\u0414\u043e\u0431\u0430\u0432\u044c\u0442\u0435 \u044f\u0437\u044b\u043a",
    "fi": "Lis\u00e4\u00e4 kieli",
    "sv": "L\u00e4gg till spr\u00e5k",
    "fa": "\u0627\u0636\u0627\u0641\u0647 \u06a9\u0631\u062f\u0646 \u0632\u0628\u0627\u0646",
    "ar": "\u0625\u0636\u0627\u0641\u0629 \u0644\u063a\u0629",
    "uk": "\u0414\u043e\u0434\u0430\u0442\u0438 \u043c\u043e\u0432\u0443"
  },
  "settings_label_organization": {
    "sheet_name": "Web",
    "en": "Organization type",
    "ru": "\u0422\u0438\u043f \u043e\u0440\u0433\u0430\u043d\u0438\u0437\u0430\u0446\u0438\u0438",
    "fi": "Organisaatiotyyppi",
    "sv": "Typ av organisation",
    "fa": "\u0646\u0648\u0639 \u0633\u0627\u0632\u0645\u0627\u0646",
    "ar": "\u0646\u0648\u0639 \u0627\u0644\u0645\u0646\u0638\u0645\u0629",
    "uk": "\u0422\u0438\u043f \u043e\u0440\u0433\u0430\u043d\u0456\u0437\u0430\u0446\u0456\u0457"
  },
  "settings_exp_dialog_date_invalid": {
    "sheet_name": "Web",
    "en": "Start date should be older than end date.",
    "ru": "\u0414\u0435\u043d\u044c \u043d\u0430\u0447\u0430\u043b\u0430 \u0434\u043e\u043b\u0436\u0435\u043d \u0431\u044b\u0442\u044c \u0440\u0430\u043d\u044c\u0448\u0435, \u0447\u0435\u043c \u0444\u0438\u043d\u0430\u043b\u044c\u043d\u044b\u0439 \u0434\u0435\u043d\u044c",
    "fi": "Aloitusp\u00e4iv\u00e4n pit\u00e4\u00e4 olla aiempi kuin loppup\u00e4iv\u00e4",
    "sv": "startdatum m\u00e5ste vara senare \u00e4n slutdatumet",
    "fa": "\u062a\u0627\u0631\u06cc\u062e \u0634\u0631\u0648\u0639 \u0628\u0627\u06cc\u062f \u0642\u0628\u0644 \u062a\u0631 \u0627\u0632 \u062a\u0627\u0631\u06cc\u062e \u067e\u0627\u06cc\u0627\u0646 \u0628\u0627\u0634\u062f.",
    "ar": "\u064a\u062c\u0628 \u0623\u0646 \u064a\u0643\u0648\u0646 \u062a\u0627\u0631\u064a\u062e \u0627\u0644\u0628\u062f\u0621 \u0623\u0642\u062f\u0645 \u0645\u0646 \u062a\u0627\u0631\u064a\u062e \u0627\u0644\u0627\u0646\u062a\u0647\u0627\u0621.",
    "uk": "\u0414\u0430\u0442\u0430 \u043f\u043e\u0447\u0430\u0442\u043a\u0443 \u043f\u043e\u0432\u0438\u043d\u043d\u0430 \u0431\u0443\u0442\u0438 \u0440\u0430\u043d\u0456\u0448\u043e\u044e \u0437\u0430 \u0434\u0430\u0442\u0443 \u0437\u0430\u043a\u0456\u043d\u0447\u0435\u043d\u043d\u044f"
  },
  "settings_label_cv": {
    "sheet_name": "Web",
    "en": "Make my CV public",
    "ru": "\u041e\u043f\u0443\u0431\u043b\u0438\u043a\u0443\u0439\u0442\u0435 CV",
    "fi": "CV:ni on julkinen",
    "sv": "Dela ditt CV",
    "fa": "CV \u0645\u0646 \u0631\u0627 \u0639\u0645\u0648\u0645\u06cc \u06a9\u0646\u06cc\u062f",
    "ar": "\u0627\u0646\u0634\u0631\u0633\u064a\u0631\u062a\u0643 \u0627\u0644\u0630\u0627\u062a\u064a\u0629",
    "uk": "\u041e\u043f\u0440\u0438\u043b\u044e\u0434\u043d\u0438\u0442\u0438 \u0440\u0435\u0437\u044e\u043c\u0435"
  },
  "settings_label_month_jan": {
    "sheet_name": "Web",
    "en": "January",
    "ru": "\u042f\u043d\u0432\u0430\u0440\u044c",
    "fi": "Tammikuu",
    "sv": "Jan",
    "fa": "January",
    "ar": "\u0645\u062d\u0631\u0645",
    "uk": "\u0421\u0456\u0447\u0435\u043d\u044c"
  },
  "settings_label_month_feb": {
    "sheet_name": "Web",
    "en": "February",
    "ru": "\u0424\u0435\u0432\u0440\u0430\u043b\u044c",
    "fi": "Helmikuu",
    "sv": "Feb",
    "fa": "February",
    "ar": "\u0635\u0641\u0631",
    "uk": "\u041b\u044e\u0442\u0438\u0439"
  },
  "settings_label_month_mar": {
    "sheet_name": "Web",
    "en": "March",
    "ru": "\u041c\u0430\u0440\u0442",
    "fi": "Maaliskuu",
    "sv": "Mars",
    "fa": "March",
    "ar": "\u0631\u0628\u064a\u0639 \u0627\u0644\u0623\u0648\u0644",
    "uk": "\u0411\u0435\u0440\u0435\u0437\u0435\u043d\u044c"
  },
  "settings_label_month_apr": {
    "sheet_name": "Web",
    "en": "April",
    "ru": "\u0410\u043f\u0440\u0435\u043b\u044c",
    "fi": "Huhtikuu",
    "sv": "Apr",
    "fa": "April",
    "ar": "\u0631\u0628\u064a\u0639 \u0627\u0644\u0623\u062e\u0631",
    "uk": "\u041a\u0432\u0456\u0442\u0435\u043d\u044c"
  },
  "settings_label_month_may": {
    "sheet_name": "Web",
    "en": "May",
    "ru": "\u041c\u0430\u0439",
    "fi": "Toukokuu",
    "sv": "Maj",
    "fa": "May",
    "ar": "\u062c\u0645\u0627\u062f\u0649 \u0627\u0644\u0623\u0648\u0644",
    "uk": "\u0422\u0440\u0430\u0432\u0435\u043d\u044c"
  },
  "settings_label_month_jun": {
    "sheet_name": "Web",
    "en": "June",
    "ru": "\u0418\u044e\u043d\u044c",
    "fi": "Kes\u00e4kuu",
    "sv": "Juni",
    "fa": "June",
    "ar": "\u062c\u0645\u0627\u062f\u0649 \u0627\u0644\u062b\u0627\u0646\u064a",
    "uk": "\u0427\u0435\u0440\u0432\u0435\u043d\u044c"
  },
  "settings_label_month_jul": {
    "sheet_name": "Web",
    "en": "July",
    "ru": "\u0418\u044e\u043b\u044c",
    "fi": "Hein\u00e4kuu",
    "sv": "Juli",
    "fa": "July",
    "ar": "\u0631\u062c\u0628",
    "uk": "\u041b\u0438\u043f\u0435\u043d\u044c"
  },
  "settings_label_month_aug": {
    "sheet_name": "Web",
    "en": "August",
    "ru": "\u0410\u0432\u0433\u0443\u0441\u0442",
    "fi": "Elokuu",
    "sv": "Aug",
    "fa": "August",
    "ar": "\u0634\u0639\u0628\u0627\u0646",
    "uk": "\u0421\u0435\u0440\u043f\u0435\u043d\u044c"
  },
  "settings_label_month_sep": {
    "sheet_name": "Web",
    "en": "September",
    "ru": "\u0421\u0435\u043d\u0442\u044f\u0431\u0440\u044c",
    "fi": "Syyskuu",
    "sv": "Sep",
    "fa": "September",
    "ar": "\u0631\u0645\u0636\u0627\u0646",
    "uk": "\u0412\u0435\u0440\u0435\u0441\u0435\u043d\u044c"
  },
  "settings_label_month_oct": {
    "sheet_name": "Web",
    "en": "October",
    "ru": "\u041e\u043a\u0442\u044f\u0431\u0440\u044c",
    "fi": "Lokakuu",
    "sv": "Okt",
    "fa": "October",
    "ar": "\u0634\u0648\u0627\u0644",
    "uk": "\u0416\u043e\u0432\u0442\u0435\u043d\u044c"
  },
  "settings_label_month_nov": {
    "sheet_name": "Web",
    "en": "November",
    "ru": "\u041d\u043e\u044f\u0431\u0440\u044c",
    "fi": "Marraskuu",
    "sv": "Nov",
    "fa": "November",
    "ar": "\u0630\u0648\u0627\u0644\u0642\u0639\u062f\u0629",
    "uk": "\u041b\u0438\u0441\u0442\u043e\u043f\u0430\u0434"
  },
  "settings_label_month_dec": {
    "sheet_name": "Web",
    "en": "December",
    "ru": "\u0414\u0435\u043a\u0430\u0431\u0440\u044c",
    "fi": "Joulukuu",
    "sv": "Dec",
    "fa": "December",
    "ar": "\u0630\u0648\u0627\u0644\u062d\u062c\u0629",
    "uk": "\u0413\u0440\u0443\u0434\u0435\u043d\u044c"
  },
  "settings_label_edit_lang": {
    "sheet_name": "Web",
    "en": "Edit language",
    "ru": "\u0440\u0435\u0434\u0430\u043a\u0442\u0438\u0440\u043e\u0432\u0430\u0442\u044c \u044f\u0437\u044b\u043a",
    "fi": "Muokkaa kielitaitoja",
    "sv": "Redigera spr\u00e5k",
    "fa": "\u0645\u0647\u0627\u0631\u062a \u0647\u0627\u06cc \u0632\u0628\u0627\u0646 \u062e\u0648\u062f \u0631\u0627 \u0648\u06cc\u0631\u0627\u06cc\u0634 \u06a9\u0646\u06cc\u062f",
    "ar": "\u062a\u062d\u0631\u064a\u0631\u0627\u0644\u0644\u063a\u0629",
    "uk": "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438 \u043c\u043e\u0432\u0443"
  },
  "settings_label_edit_edu": {
    "sheet_name": "Web",
    "en": "Edit education or certificate",
    "ru": "\u0440\u0435\u0434\u0430\u043a\u0442\u0438\u0440\u043e\u0432\u0430\u0442\u044c \u0441\u0432\u043e\u0438 \u043e\u0431\u0440\u0430\u0437\u043e\u0432\u0430\u043d\u0438\u044f",
    "fi": "Muokkaa koulutustietoja",
    "sv": "Redigera utbildning",
    "fa": "\u062f\u0631\u062c\u0647 \u062a\u062d\u0635\u06cc\u0644 \u062e\u0648\u062f \u0631\u0627 \u062f\u0633\u062a \u06a9\u0627\u0631\u06cc \u06a9\u0646\u06cc\u062f",
    "ar": "\u062a\u062d\u0631\u064a\u0631 \u0627\u0644\u062a\u0639\u0644\u064a\u0645",
    "uk": "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438 \u043e\u0441\u0432\u0456\u0442\u0443 \u0430\u0431\u043e \u0441\u0435\u0440\u0442\u0435\u0444\u0456\u043a\u0430\u0442\u0438"
  },
  "settings_invalid_bank": {
    "sheet_name": "Web",
    "en": "Please enter your valid bank account number",
    "ru": "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 IBAN!",
    "fi": "Sy\u00f6t\u00e4 Pankkitilinumero oikeassa muodossa",
    "sv": "V\u00e4nligen ange ditt giltiga kontonummer",
    "fa": "IBAN \u0646\u0627\u0645\u0639\u062a\u0628\u0631 \u0627\u0633\u062a!",
    "ar": "\u0627\u0644\u062d\u0633\u0627\u0628 \u0627\u0644\u0645\u0635\u0631\u0641\u064a \u063a\u064a\u0631 \u0635\u0627\u0644\u062d!",
    "uk": "\u0414\u0456\u0439\u0441\u043d\u0438\u0439 \u043d\u043e\u043c\u0435\u0440 \u0431\u0430\u043d\u043a\u0456\u0432\u0441\u044c\u043a\u043e\u0433\u043e \u0440\u0430\u0445\u0443\u043d\u043a\u0443"
  },
  "settings_invalid_ssn": {
    "sheet_name": "Web",
    "en": "Please enter your valid Social Security Number",
    "ru": "SSN \u043d\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043b\u0435\u043d",
    "fi": "Sy\u00f6t\u00e4 Henkil\u00f6turvatunnus oikeassa muodossa",
    "sv": "V\u00e4nligen ange ditt personummer",
    "fa": "\u0634\u0645\u0627\u0631\u0647 SSN \u0646\u0627\u0645\u0639\u062a\u0628\u0631 \u0627\u0633\u062a",
    "ar": "\u0645\u0637\u0644\u0648\u0628 SSN \u0635\u0627\u0644\u062d!",
    "uk": "\u041e\u0441\u043e\u0431\u0438\u0441\u0442\u0438\u0439 \u0456\u0434\u0435\u043d\u0442\u0438\u0444\u0456\u043a\u0430\u0446\u0456\u0439\u043d\u0438\u0439 \u043d\u043e\u043c\u0435\u0440"
  },
  "settings_invalid_video": {
    "sheet_name": "Web",
    "en": "Please enter valid video presentation (Youtube or Vimeo using https:\/\/....)",
    "ru": "\u0421\u0441\u044b\u043b\u043a\u0430 \u043d\u0430 \u0432\u0438\u0434\u0435\u043e \u043d\u0435 \u044f\u0432\u043b\u044f\u0435\u0442\u0441\u044f \u0441\u0441\u044b\u043b\u043a\u043e\u0439 YouTube \u0438\u043b\u0438 Vimeo",
    "fi": "Sy\u00f6t\u00e4 Video linkki oikeassa muodossa (huom! Pit\u00e4\u00e4 olla YouTube tai Vimeo, https:\/\/...) tai j\u00e4t\u00e4 tyhj\u00e4ksi",
    "sv": "V\u00e4nligen ange en giltig Youtube eller Vimeo video (https:\/\/... ) eller l\u00e4mna tomt",
    "fa": "\u0644\u06cc\u0646\u06a9 \u0648\u06cc\u062f\u06cc\u0648 \u0646\u0627\u0645\u0639\u062a\u0628\u0631 \u0627\u0633\u062a (\u0628\u0627\u06cc\u062f YouTube \u06cc\u0627 Vimeo \u0628\u0627\u0634\u062f)",
    "ar": "\u0631\u0627\u0628\u0637 \u0627\u0644\u0641\u064a\u062f\u064a\u0648 \u0635\u0627\u0644\u062d\u0627 \u0639\u0644\u0649 YouTube \u0627\u0648 Vimeo",
    "uk": "\u0412\u0432\u0435\u0434\u0456\u0442\u044c \u043f\u043e\u0441\u0438\u043b\u0430\u043d\u043d\u044f \u0432\u0430\u0448\u043e\u0457 \u0432\u0456\u0434\u0435\u043e\u043f\u0440\u0435\u0437\u0435\u043d\u0442\u0430\u0446\u0456\u0457 (\u043f\u043e\u0441\u0438\u043b\u0430\u043d\u043d\u044f \u0432 Youtube \u0430\u0431\u043e Vimeo)"
  },
  "settings_invalid_linkedin": {
    "sheet_name": "Web",
    "en": "Please enter valid LinkedIn profile (https:\/\/www.linkedin.com\/xx....)",
    "ru": "\u041f\u0440\u043e\u0444\u0438\u043b\u044c Linkedln",
    "fi": "Sy\u00f6t\u00e4 linkki muodossa https:\/\/www.linkedin.com\/xx....",
    "sv": "V\u00e4nligen ange en giltig LinkedIn webbadress (https:\/\/www.linkedin.com\/xx...)",
    "fa": "Linkdin \u062d\u0633\u0627\u0628 \u06a9\u0627\u0631\u0628\u0631\u06cc",
    "ar": "\u0645\u0644\u0641 \u062a\u0639\u0631\u064a\u0641 LinkedIn",
    "uk": "\u0412\u0432\u0435\u0434\u0456\u0442\u044c \u043f\u043e\u0441\u0438\u043b\u0430\u043d\u043d\u044f \u043d\u0430 \u043f\u0440\u043e\u0444\u0456\u043b\u044c LinkedIn (https:\/\/www.linkedin.com\/xx....)"
  },
  "settings_invalid_tax": {
    "sheet_name": "Web",
    "en": "Please enter a valid tax percentage",
    "ru": "\u043d\u0430\u043b\u043e\u0433 \u043d\u0435\u0432\u0435\u0440\u043d\u044b\u0439",
    "fi": "Veroprosentissa on virhe",
    "sv": "Ange en giltig skattesats",
    "fa": "\u0645\u0642\u062f\u0627\u0631 \u0645\u0627\u0644\u06cc\u0627\u062a \u0646\u0627\u0645\u0639\u062a\u0628\u0631 \u0627\u0633\u062a!",
    "ar": "\u0645\u0628\u0644\u063a \u0627\u0644\u0636\u0631\u064a\u0628\u0629 \u063a\u064a\u0631 \u0635\u0627\u0644\u062d",
    "uk": "\u0412\u0456\u0434\u0441\u043e\u0442\u043e\u043a \u043f\u043e\u0434\u0430\u0442\u043a\u0443"
  },
  "settings_invalid_first_name": {
    "sheet_name": "Web",
    "en": "Please enter your first name",
    "ru": "\u0418\u043c\u044f",
    "fi": "Sy\u00f6t\u00e4 etunimi",
    "sv": "V\u00e4nligen fyll i ditt f\u00f6rnamn",
    "fa": "\u0646\u0627\u0645",
    "ar": "\u0627\u0644\u0623\u0633\u0645 \u0627\u0644\u0627\u0648\u0644",
    "uk": "\u0406\u043c'\u044f"
  },
  "settings_invalid_last_name": {
    "sheet_name": "Web",
    "en": "Please enter your last name",
    "ru": "\u0424\u0430\u043c\u0438\u043b\u0438\u044f",
    "fi": "Sy\u00f6t\u00e4 sukunimi",
    "sv": "V\u00e4nligen fyll i ditt efternamn",
    "fa": "\u0646\u0627\u0645 \u062e\u0627\u0646\u0648\u0627\u062f\u06af\u06cc",
    "ar": "\u0627\u0633\u0645 \u0627\u0644\u0639\u0627\u0626\u0644\u0629",
    "uk": "\u041f\u0440\u0456\u0437\u0432\u0438\u0449\u0435"
  },
  "settings_lang_aa": {
    "sheet_name": "Web",
    "en": "Afar",
    "ru": "",
    "fi": "Afar",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_ab": {
    "sheet_name": "Web",
    "en": "Abkhazian",
    "ru": "",
    "fi": "Abhaasi",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_ae": {
    "sheet_name": "Web",
    "en": "Avestan",
    "ru": "",
    "fi": "Avestan",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_af": {
    "sheet_name": "Web",
    "en": "Afrikaans",
    "ru": "",
    "fi": "Afrikaans",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_ak": {
    "sheet_name": "Web",
    "en": "Akan",
    "ru": "",
    "fi": "Akan",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_am": {
    "sheet_name": "Web",
    "en": "Amharic",
    "ru": "",
    "fi": "Amhara",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_an": {
    "sheet_name": "Web",
    "en": "Aragonese",
    "ru": "",
    "fi": "Aragonese",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_ar": {
    "sheet_name": "Web",
    "en": "Arabic",
    "ru": "",
    "fi": "Arabia",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0410\u0440\u0430\u0431\u0441\u044c\u043a\u0430"
  },
  "settings_lang_as": {
    "sheet_name": "Web",
    "en": "Assamese",
    "ru": "",
    "fi": "Assami",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_av": {
    "sheet_name": "Web",
    "en": "Avaric",
    "ru": "",
    "fi": "Avaari",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_ay": {
    "sheet_name": "Web",
    "en": "Aymara",
    "ru": "",
    "fi": "Aimara",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_az": {
    "sheet_name": "Web",
    "en": "Azerbaijani",
    "ru": "",
    "fi": "Azeri",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_ba": {
    "sheet_name": "Web",
    "en": "Bashkir",
    "ru": "",
    "fi": "Baskiiri",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_be": {
    "sheet_name": "Web",
    "en": "Belarusian",
    "ru": "",
    "fi": "Valkoven\u00e4j\u00e4",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_bg": {
    "sheet_name": "Web",
    "en": "Bulgarian",
    "ru": "",
    "fi": "Bulgaria",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_bi": {
    "sheet_name": "Web",
    "en": "Bislama",
    "ru": "",
    "fi": "Bislama",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_bm": {
    "sheet_name": "Web",
    "en": "Bambara",
    "ru": "",
    "fi": "Bambara",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_bn": {
    "sheet_name": "Web",
    "en": "Bengali",
    "ru": "",
    "fi": "Bengali",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_bo": {
    "sheet_name": "Web",
    "en": "Tibetan",
    "ru": "",
    "fi": "Tiibet",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_br": {
    "sheet_name": "Web",
    "en": "Breton",
    "ru": "",
    "fi": "Bretoni",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_bs": {
    "sheet_name": "Web",
    "en": "Bosnian",
    "ru": "",
    "fi": "Bosnia",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_ca": {
    "sheet_name": "Web",
    "en": "Catalan",
    "ru": "",
    "fi": "Katalaani",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_ce": {
    "sheet_name": "Web",
    "en": "Chechen",
    "ru": "",
    "fi": "T\u0161et\u0161eeni",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_ch": {
    "sheet_name": "Web",
    "en": "Chamorro",
    "ru": "",
    "fi": "Chamorro",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_co": {
    "sheet_name": "Web",
    "en": "Corsican",
    "ru": "",
    "fi": "Korsika",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_cr": {
    "sheet_name": "Web",
    "en": "Cree",
    "ru": "",
    "fi": "Cree",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_cs": {
    "sheet_name": "Web",
    "en": "Czech",
    "ru": "",
    "fi": "T\u0161ekki",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_cu": {
    "sheet_name": "Web",
    "en": "Church Slavic",
    "ru": "",
    "fi": "Kirkkoslaavi",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_cv": {
    "sheet_name": "Web",
    "en": "Chuvash",
    "ru": "",
    "fi": "Tsuvassi",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_cy": {
    "sheet_name": "Web",
    "en": "Welsh",
    "ru": "",
    "fi": "Kymri",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_da": {
    "sheet_name": "Web",
    "en": "Danish",
    "ru": "",
    "fi": "Tanska",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_de": {
    "sheet_name": "Web",
    "en": "German",
    "ru": "",
    "fi": "Saksa",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u041d\u0456\u043c\u0435\u0446\u044c\u043a\u0430"
  },
  "settings_lang_dv": {
    "sheet_name": "Web",
    "en": "Dhivehi",
    "ru": "",
    "fi": "Dhivehi",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_dz": {
    "sheet_name": "Web",
    "en": "Dzongkha",
    "ru": "",
    "fi": "Dzongkha",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_ee": {
    "sheet_name": "Web",
    "en": "Ewe",
    "ru": "",
    "fi": "Ewe",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_el": {
    "sheet_name": "Web",
    "en": "Modern Greek (1453-)",
    "ru": "",
    "fi": "Kreikka",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_en": {
    "sheet_name": "Web",
    "en": "English",
    "ru": "",
    "fi": "Englanti",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0410\u043d\u0433\u043b\u0456\u0439\u0441\u044c\u043a\u0430"
  },
  "settings_lang_eo": {
    "sheet_name": "Web",
    "en": "Esperanto",
    "ru": "",
    "fi": "Esperanto",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_es": {
    "sheet_name": "Web",
    "en": "Spanish",
    "ru": "",
    "fi": "Espanja",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0406\u0441\u043f\u0430\u043d\u0441\u044c\u043a\u0430"
  },
  "settings_lang_et": {
    "sheet_name": "Web",
    "en": "Estonian",
    "ru": "",
    "fi": "Viro",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0415\u0441\u0442\u043e\u043d\u0441\u044c\u043a\u0430"
  },
  "settings_lang_eu": {
    "sheet_name": "Web",
    "en": "Basque",
    "ru": "",
    "fi": "Baski",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_fa": {
    "sheet_name": "Web",
    "en": "Persian",
    "ru": "",
    "fi": "Persia",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_ff": {
    "sheet_name": "Web",
    "en": "Fulah",
    "ru": "",
    "fi": "Fulah",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_fj": {
    "sheet_name": "Web",
    "en": "Fijian",
    "ru": "",
    "fi": "Fidzi",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_fi": {
    "sheet_name": "Web",
    "en": "Finnish",
    "ru": "",
    "fi": "Suomi",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0424\u0456\u043d\u0441\u044c\u043a\u0430"
  },
  "settings_lang_fo": {
    "sheet_name": "Web",
    "en": "Faroese",
    "ru": "",
    "fi": "F\u00e4\u00e4ri",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_fr": {
    "sheet_name": "Web",
    "en": "French",
    "ru": "",
    "fi": "Ranska",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0424\u0440\u0430\u043d\u0446\u0443\u0437\u044c\u043a\u0430"
  },
  "settings_lang_fy": {
    "sheet_name": "Web",
    "en": "Western Frisian",
    "ru": "",
    "fi": "L\u00e4nsifriisi",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_ga": {
    "sheet_name": "Web",
    "en": "Irish",
    "ru": "",
    "fi": "Iiri",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_gd": {
    "sheet_name": "Web",
    "en": "Scottish Gaelic",
    "ru": "",
    "fi": "Gaeli",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_gl": {
    "sheet_name": "Web",
    "en": "Galician",
    "ru": "",
    "fi": "Galicia",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_gn": {
    "sheet_name": "Web",
    "en": "Guarani",
    "ru": "",
    "fi": "Guarani",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_gu": {
    "sheet_name": "Web",
    "en": "Gujarati",
    "ru": "",
    "fi": "Gudzarati",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_gv": {
    "sheet_name": "Web",
    "en": "Manx",
    "ru": "",
    "fi": "Manx",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_ha": {
    "sheet_name": "Web",
    "en": "Hausa",
    "ru": "",
    "fi": "Hausa",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_he": {
    "sheet_name": "Web",
    "en": "Hebrew",
    "ru": "",
    "fi": "Heprea",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_hi": {
    "sheet_name": "Web",
    "en": "Hindi",
    "ru": "",
    "fi": "Hindi",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_ho": {
    "sheet_name": "Web",
    "en": "Hiri Motu",
    "ru": "",
    "fi": "Hiri-motu",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_hr": {
    "sheet_name": "Web",
    "en": "Croatian",
    "ru": "",
    "fi": "Kroatia",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_ht": {
    "sheet_name": "Web",
    "en": "Haitian",
    "ru": "",
    "fi": "Haiti",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_hu": {
    "sheet_name": "Web",
    "en": "Hungarian",
    "ru": "",
    "fi": "Unkari",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_hy": {
    "sheet_name": "Web",
    "en": "Armenian",
    "ru": "",
    "fi": "Armenia",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0412\u0456\u0440\u043c\u0435\u043d\u0441\u044c\u043a\u0430"
  },
  "settings_lang_hz": {
    "sheet_name": "Web",
    "en": "Herero",
    "ru": "",
    "fi": "Herero",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_ia": {
    "sheet_name": "Web",
    "en": "Interlingua (International Auxiliary Language Association)",
    "ru": "",
    "fi": "Interlingua",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_id": {
    "sheet_name": "Web",
    "en": "Indonesian",
    "ru": "",
    "fi": "Indonesia",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_ie": {
    "sheet_name": "Web",
    "en": "Interlingue",
    "ru": "",
    "fi": "Interlingua",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_ig": {
    "sheet_name": "Web",
    "en": "Igbo",
    "ru": "",
    "fi": "Igbo",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_ii": {
    "sheet_name": "Web",
    "en": "Sichuan Yi",
    "ru": "",
    "fi": "Sichuannin-yi",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_ik": {
    "sheet_name": "Web",
    "en": "Inupiaq",
    "ru": "",
    "fi": "Inupiatun",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_io": {
    "sheet_name": "Web",
    "en": "Ido",
    "ru": "",
    "fi": "Ido",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_is": {
    "sheet_name": "Web",
    "en": "Icelandic",
    "ru": "",
    "fi": "Islanti",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_it": {
    "sheet_name": "Web",
    "en": "Italian",
    "ru": "",
    "fi": "Italia",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_iu": {
    "sheet_name": "Web",
    "en": "Inuktitut",
    "ru": "",
    "fi": "Inuktitut",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_ja": {
    "sheet_name": "Web",
    "en": "Japanese",
    "ru": "",
    "fi": "Japani",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_jv": {
    "sheet_name": "Web",
    "en": "Javanese",
    "ru": "",
    "fi": "Jaava",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_ka": {
    "sheet_name": "Web",
    "en": "Georgian",
    "ru": "",
    "fi": "Georgia",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_kg": {
    "sheet_name": "Web",
    "en": "Kongo",
    "ru": "",
    "fi": "Kongo",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_ki": {
    "sheet_name": "Web",
    "en": "Kikuyu",
    "ru": "",
    "fi": "Kikuju",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_kj": {
    "sheet_name": "Web",
    "en": "Kuanyama",
    "ru": "",
    "fi": "Kuanjama",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_kk": {
    "sheet_name": "Web",
    "en": "Kazakh",
    "ru": "",
    "fi": "Kazakki",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_kl": {
    "sheet_name": "Web",
    "en": "Kalaallisut",
    "ru": "",
    "fi": "Kalaallisut",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_km": {
    "sheet_name": "Web",
    "en": "Central Khmer",
    "ru": "",
    "fi": "Khmer",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_kn": {
    "sheet_name": "Web",
    "en": "Kannada",
    "ru": "",
    "fi": "Kannada",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_ko": {
    "sheet_name": "Web",
    "en": "Korean",
    "ru": "",
    "fi": "Korea",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_kr": {
    "sheet_name": "Web",
    "en": "Kanuri",
    "ru": "",
    "fi": "Kanuri",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_ks": {
    "sheet_name": "Web",
    "en": "Kashmiri",
    "ru": "",
    "fi": "Kasmiri",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_ku": {
    "sheet_name": "Web",
    "en": "Kurdish",
    "ru": "",
    "fi": "Kurdi",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_kv": {
    "sheet_name": "Web",
    "en": "Komi",
    "ru": "",
    "fi": "Komi",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_kw": {
    "sheet_name": "Web",
    "en": "Cornish",
    "ru": "",
    "fi": "Korni",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_ky": {
    "sheet_name": "Web",
    "en": "Kirghiz",
    "ru": "",
    "fi": "Kirgiisi",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_la": {
    "sheet_name": "Web",
    "en": "Latin",
    "ru": "",
    "fi": "Latina",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_lb": {
    "sheet_name": "Web",
    "en": "Luxembourgish",
    "ru": "",
    "fi": "Luxemburg",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_lg": {
    "sheet_name": "Web",
    "en": "Ganda",
    "ru": "",
    "fi": "Ganda",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_li": {
    "sheet_name": "Web",
    "en": "Limburgan",
    "ru": "",
    "fi": "Limburg",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_ln": {
    "sheet_name": "Web",
    "en": "Lingala",
    "ru": "",
    "fi": "Lingala",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_lo": {
    "sheet_name": "Web",
    "en": "Lao",
    "ru": "",
    "fi": "Lao",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_lt": {
    "sheet_name": "Web",
    "en": "Lithuanian",
    "ru": "",
    "fi": "Liettua",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_lu": {
    "sheet_name": "Web",
    "en": "Luba-Katanga",
    "ru": "",
    "fi": "Katanganluba",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_lv": {
    "sheet_name": "Web",
    "en": "Latvian",
    "ru": "",
    "fi": "Latvia",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_mg": {
    "sheet_name": "Web",
    "en": "Malagasy",
    "ru": "",
    "fi": "Malagassi",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_mh": {
    "sheet_name": "Web",
    "en": "Marshallese",
    "ru": "",
    "fi": "Marshall",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_mi": {
    "sheet_name": "Web",
    "en": "Maori",
    "ru": "",
    "fi": "Maori",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_mk": {
    "sheet_name": "Web",
    "en": "Macedonian",
    "ru": "",
    "fi": "Makedonia",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_ml": {
    "sheet_name": "Web",
    "en": "Malayalam",
    "ru": "",
    "fi": "Malajalam",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_mn": {
    "sheet_name": "Web",
    "en": "Mongolian",
    "ru": "",
    "fi": "Mongoli",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_mr": {
    "sheet_name": "Web",
    "en": "Marathi",
    "ru": "",
    "fi": "Marathi",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_ms": {
    "sheet_name": "Web",
    "en": "Malay (macrolanguage)",
    "ru": "",
    "fi": "Malaji",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_mt": {
    "sheet_name": "Web",
    "en": "Maltese",
    "ru": "",
    "fi": "Malta",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_my": {
    "sheet_name": "Web",
    "en": "Burmese",
    "ru": "",
    "fi": "Burma",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_na": {
    "sheet_name": "Web",
    "en": "Nauru",
    "ru": "",
    "fi": "Nauru",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_nb": {
    "sheet_name": "Web",
    "en": "Norwegian Bokm\u00e5l",
    "ru": "",
    "fi": "Kirjanorja",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_nd": {
    "sheet_name": "Web",
    "en": "North Ndebele",
    "ru": "",
    "fi": "Pohjois-ndebele",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_ne": {
    "sheet_name": "Web",
    "en": "Nepali (macrolanguage)",
    "ru": "",
    "fi": "Nepali",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_ng": {
    "sheet_name": "Web",
    "en": "Ndonga",
    "ru": "",
    "fi": "Ndonga",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_nl": {
    "sheet_name": "Web",
    "en": "Dutch",
    "ru": "",
    "fi": "Hollanti",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_nn": {
    "sheet_name": "Web",
    "en": "Norwegian Nynorsk",
    "ru": "",
    "fi": "Uusnorja",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_no": {
    "sheet_name": "Web",
    "en": "Norwegian",
    "ru": "",
    "fi": "Norja",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_nr": {
    "sheet_name": "Web",
    "en": "South Ndebele",
    "ru": "",
    "fi": "Etel\u00e4-ndebele",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_nv": {
    "sheet_name": "Web",
    "en": "Navajo",
    "ru": "",
    "fi": "Navajo",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_ny": {
    "sheet_name": "Web",
    "en": "Nyanja",
    "ru": "",
    "fi": "Njandza",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_oc": {
    "sheet_name": "Web",
    "en": "Occitan (post 1500)",
    "ru": "",
    "fi": "Oksitaani (1500-)",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_oj": {
    "sheet_name": "Web",
    "en": "Ojibwa",
    "ru": "",
    "fi": "Odzibwa",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_om": {
    "sheet_name": "Web",
    "en": "Oromo",
    "ru": "",
    "fi": "Oromo",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_or": {
    "sheet_name": "Web",
    "en": "Oriya (macrolanguage)",
    "ru": "",
    "fi": "Orija",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_os": {
    "sheet_name": "Web",
    "en": "Ossetian",
    "ru": "",
    "fi": "Osseetti",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_pa": {
    "sheet_name": "Web",
    "en": "Panjabi",
    "ru": "",
    "fi": "Pandzabi",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_pi": {
    "sheet_name": "Web",
    "en": "Pali",
    "ru": "",
    "fi": "Paali",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_pl": {
    "sheet_name": "Web",
    "en": "Polish",
    "ru": "",
    "fi": "Puola",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u041f\u043e\u043b\u044c\u0441\u044c\u043a\u0430"
  },
  "settings_lang_ps": {
    "sheet_name": "Web",
    "en": "Pushto",
    "ru": "",
    "fi": "Pastu",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_pt": {
    "sheet_name": "Web",
    "en": "Portuguese",
    "ru": "",
    "fi": "Portugali",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_qu": {
    "sheet_name": "Web",
    "en": "Quechua",
    "ru": "",
    "fi": "Ketsua",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_rm": {
    "sheet_name": "Web",
    "en": "Romansh",
    "ru": "",
    "fi": "Retoromaani",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_rn": {
    "sheet_name": "Web",
    "en": "Rundi",
    "ru": "",
    "fi": "Rundi",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_ro": {
    "sheet_name": "Web",
    "en": "Romanian",
    "ru": "",
    "fi": "Romania",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_ru": {
    "sheet_name": "Web",
    "en": "Russian",
    "ru": "",
    "fi": "Ven\u00e4j\u00e4",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0420\u043e\u0441\u0456\u0439\u0441\u044c\u043a\u0430"
  },
  "settings_lang_rw": {
    "sheet_name": "Web",
    "en": "Kinyarwanda",
    "ru": "",
    "fi": "Ruanda",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_sa": {
    "sheet_name": "Web",
    "en": "Sanskrit",
    "ru": "",
    "fi": "Sanskrit",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_sc": {
    "sheet_name": "Web",
    "en": "Sardinian",
    "ru": "",
    "fi": "Sardi",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_sd": {
    "sheet_name": "Web",
    "en": "Sindhi",
    "ru": "",
    "fi": "Sindhi",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_se": {
    "sheet_name": "Web",
    "en": "Northern Sami",
    "ru": "",
    "fi": "Pohjoissaame",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_sg": {
    "sheet_name": "Web",
    "en": "Sango",
    "ru": "",
    "fi": "Sango",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_sh": {
    "sheet_name": "Web",
    "en": "Serbo-Croatian",
    "ru": "",
    "fi": "Serbokroaatti",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_si": {
    "sheet_name": "Web",
    "en": "Sinhala",
    "ru": "",
    "fi": "Sinhala",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_sk": {
    "sheet_name": "Web",
    "en": "Slovak",
    "ru": "",
    "fi": "Slovakki",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_sl": {
    "sheet_name": "Web",
    "en": "Slovenian",
    "ru": "",
    "fi": "Sloveeni",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_sm": {
    "sheet_name": "Web",
    "en": "Samoan",
    "ru": "",
    "fi": "Samoa",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_sn": {
    "sheet_name": "Web",
    "en": "Shona",
    "ru": "",
    "fi": "Sona",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_so": {
    "sheet_name": "Web",
    "en": "Somali",
    "ru": "",
    "fi": "Somali",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_sq": {
    "sheet_name": "Web",
    "en": "Albanian",
    "ru": "",
    "fi": "Albania",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_sr": {
    "sheet_name": "Web",
    "en": "Serbian",
    "ru": "",
    "fi": "Serbia",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_ss": {
    "sheet_name": "Web",
    "en": "Swati",
    "ru": "",
    "fi": "Swati",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_st": {
    "sheet_name": "Web",
    "en": "Southern Sotho",
    "ru": "",
    "fi": "Etel\u00e4sotho",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_su": {
    "sheet_name": "Web",
    "en": "Sundanese",
    "ru": "",
    "fi": "Sunda",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_sv": {
    "sheet_name": "Web",
    "en": "Swedish",
    "ru": "",
    "fi": "Ruotsi",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0428\u0432\u0435\u0434\u0441\u044c\u043a\u0430"
  },
  "settings_lang_sw": {
    "sheet_name": "Web",
    "en": "Swahili (macrolanguage)",
    "ru": "",
    "fi": "Swahili",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_ta": {
    "sheet_name": "Web",
    "en": "Tamil",
    "ru": "",
    "fi": "Tamil",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_te": {
    "sheet_name": "Web",
    "en": "Telugu",
    "ru": "",
    "fi": "Telugu",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_tg": {
    "sheet_name": "Web",
    "en": "Tajik",
    "ru": "",
    "fi": "Tadzikki",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_th": {
    "sheet_name": "Web",
    "en": "Thai",
    "ru": "",
    "fi": "Thai",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_ti": {
    "sheet_name": "Web",
    "en": "Tigrinya",
    "ru": "",
    "fi": "Tigrinja",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_tk": {
    "sheet_name": "Web",
    "en": "Turkmen",
    "ru": "",
    "fi": "Turkmeeni",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_tl": {
    "sheet_name": "Web",
    "en": "Tagalog",
    "ru": "",
    "fi": "Tagalog",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_tn": {
    "sheet_name": "Web",
    "en": "Tswana",
    "ru": "",
    "fi": "Tswana",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_to": {
    "sheet_name": "Web",
    "en": "Tonga (Tonga Islands)",
    "ru": "",
    "fi": "Tonga",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_tr": {
    "sheet_name": "Web",
    "en": "Turkish",
    "ru": "",
    "fi": "Turkki",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_ts": {
    "sheet_name": "Web",
    "en": "Tsonga",
    "ru": "",
    "fi": "Tsonga",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_tt": {
    "sheet_name": "Web",
    "en": "Tatar",
    "ru": "",
    "fi": "Tataari",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_tw": {
    "sheet_name": "Web",
    "en": "Twi",
    "ru": "",
    "fi": "Twi",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_ty": {
    "sheet_name": "Web",
    "en": "Tahitian",
    "ru": "",
    "fi": "Tahiti",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_ug": {
    "sheet_name": "Web",
    "en": "Uighur",
    "ru": "",
    "fi": "Uiguuri",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_uk": {
    "sheet_name": "Web",
    "en": "Ukrainian",
    "ru": "",
    "fi": "Ukraina",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0423\u043a\u0440\u0430\u0457\u043d\u0441\u044c\u043a\u0430"
  },
  "settings_lang_ur": {
    "sheet_name": "Web",
    "en": "Urdu",
    "ru": "",
    "fi": "Urdu",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_uz": {
    "sheet_name": "Web",
    "en": "Uzbek",
    "ru": "",
    "fi": "Uzbekki",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_ve": {
    "sheet_name": "Web",
    "en": "Venda",
    "ru": "",
    "fi": "Venda",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_vi": {
    "sheet_name": "Web",
    "en": "Vietnamese",
    "ru": "",
    "fi": "Vietnam",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_vo": {
    "sheet_name": "Web",
    "en": "Volap\u00fck",
    "ru": "",
    "fi": "volap\u00fck",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_wa": {
    "sheet_name": "Web",
    "en": "Walloon",
    "ru": "",
    "fi": "Valloni",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_wo": {
    "sheet_name": "Web",
    "en": "Wolof",
    "ru": "",
    "fi": "Wolof",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_xh": {
    "sheet_name": "Web",
    "en": "Xhosa",
    "ru": "",
    "fi": "Xhosa",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_yi": {
    "sheet_name": "Web",
    "en": "Yiddish",
    "ru": "",
    "fi": "Jiddis",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_yo": {
    "sheet_name": "Web",
    "en": "Yoruba",
    "ru": "",
    "fi": "Joruba",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_za": {
    "sheet_name": "Web",
    "en": "Zhuang",
    "ru": "",
    "fi": "Zhuang",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_zh": {
    "sheet_name": "Web",
    "en": "Chinese",
    "ru": "",
    "fi": "Kiina",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_lang_zu": {
    "sheet_name": "Web",
    "en": "Zulu",
    "ru": "",
    "fi": "Zulu",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "settings_label_tooltip_lang": {
    "sheet_name": "Web",
    "en": "Please add your language skills and related skill levels",
    "ru": "",
    "fi": "Lis\u00e4\u00e4 kielitaitosi ja osaamistasosi",
    "sv": "L\u00e4gg till dina spr\u00e5kkunskaper och spr\u00e5kniv\u00e5",
    "fa": "",
    "ar": "",
    "uk": "\u0411\u0443\u0434\u044c \u043b\u0430\u0441\u043a\u0430, \u0434\u043e\u0434\u0430\u0439\u0442\u0435 \u0441\u0432\u043e\u0457 \u0437\u043d\u0430\u043d\u043d\u044f \u043c\u043e\u0432\u0438 \u0442\u0430 \u0432\u0456\u0434\u043f\u043e\u0432\u0456\u0434\u043d\u0456 \u0440\u0456\u0432\u043d\u0456 \u043d\u0430\u0432\u0438\u0447\u043e\u043a"
  },
  "settings_label_tooltip_edu": {
    "sheet_name": "Web",
    "en": "Add all education that you have received here including Degrees, Courses and Certificates.",
    "ru": "",
    "fi": "Lis\u00e4\u00e4 t\u00e4h\u00e4n koulutuksesi, jonka olet saanut, mukaan lukien tutkinnot, kurssit ja todistukset",
    "sv": "V\u00e4nligen l\u00e4gg till dina utbildningar, kurser, cerfikat och dina betyg\/utl\u00e5tande",
    "fa": "",
    "ar": "",
    "uk": "\u0414\u043e\u0434\u0430\u0439\u0442\u0435 \u0432\u0441\u044e \u0456\u043d\u0444\u043e\u0440\u043c\u0430\u0446\u0456\u044e \u043f\u0440\u043e \u0432\u0430\u0448\u0443 \u043e\u0441\u0432\u0456\u0442\u0443, \u044f\u043a\u0443 \u0432\u0438 \u043e\u0442\u0440\u0438\u043c\u0430\u043b\u0438, \u0432\u043a\u043b\u044e\u0447\u0430\u044e\u0447\u0438 \u0441\u0442\u0443\u043f\u0435\u043d\u0456, \u043a\u0443\u0440\u0441\u0438 \u0442\u0430 \u0441\u0435\u0440\u0442\u0438\u0444\u0456\u043a\u0430\u0442\u0438."
  },
  "settings_label_invalid_img": {
    "sheet_name": "Web",
    "en": "Profile image should be smaller than 2 megabytes.",
    "ru": "",
    "fi": "Profiilikuvan on oltava pienempi kuin 2 megatavua",
    "sv": "Profilbilden b\u00f6r vara mindre \u00e4n 2 megabyte.",
    "fa": "",
    "ar": "",
    "uk": "\u0417\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u043d\u044f \u043f\u0440\u043e\u0444\u0456\u043b\u044e \u043c\u0430\u0454 \u0431\u0443\u0442\u0438 \u043c\u0435\u043d\u0448\u0435 2 \u043c\u0435\u0433\u0430\u0431\u0430\u0439\u0442."
  },
  "settings_label_invalid_comp_name": {
    "sheet_name": "Web",
    "en": "Please enter your organisation name",
    "ru": "",
    "fi": "Sy\u00f6t\u00e4 organisaation nimi",
    "sv": "Ange ditt organisationsnamn",
    "fa": "",
    "ar": "",
    "uk": "\u0412\u0432\u0435\u0434\u0456\u0442\u044c \u043d\u0430\u0437\u0432\u0443 \u0432\u0430\u0448\u043e\u0457 \u043e\u0440\u0433\u0430\u043d\u0456\u0437\u0430\u0446\u0456\u0457"
  },
  "settings_label_invalid_reg_num": {
    "sheet_name": "Web",
    "en": "Please enter your registration number",
    "ru": "",
    "fi": "Sy\u00f6t\u00e4 organisaatio tunnuksesi",
    "sv": "Ange ditt registreringsnummer",
    "fa": "",
    "ar": "",
    "uk": "\u0412\u0432\u0435\u0434\u0456\u0442\u044c \u0441\u0432\u0456\u0439 \u0440\u0435\u0454\u0441\u0442\u0440\u0430\u0446\u0456\u0439\u043d\u0438\u0439 \u043d\u043e\u043c\u0435\u0440"
  },
  "settings_unsaved_changes": {
    "sheet_name": "Web",
    "en": "There are unsaved changes!",
    "ru": "",
    "fi": "Muutokset ovat viel\u00e4 tallentamatta!",
    "sv": "\u00c4ndringarna \u00e4r inte sparade \u00e4nnu!",
    "fa": "",
    "ar": "",
    "uk": "\u0417\u043c\u0456\u043d\u0438 \u0449\u0435 \u043d\u0435 \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043d\u043e!"
  },
  "settings_do_you_want_to_save": {
    "sheet_name": "Web",
    "en": "Do you want to save it?",
    "ru": "",
    "fi": "Haluatko tallentaa \u00e4sken tehdyt muutokset?",
    "sv": "Vill du spara \u00e4ndringarna du just gjorde?",
    "fa": "",
    "ar": "",
    "uk": "\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438 \u0437\u043c\u0456\u043d\u0438, \u044f\u043a\u0456 \u0432\u0438 \u0449\u043e\u0439\u043d\u043e \u0437\u0440\u043e\u0431\u0438\u043b\u0438?"
  },
  "settings_payment_info": {
    "sheet_name": "Web",
    "en": "This information is needed for payments",
    "ru": "",
    "fi": "N\u00e4m\u00e4 tiedot tarvitaan maksuja varten",
    "sv": "Denna information beh\u00f6vs f\u00f6r betalningar",
    "fa": "",
    "ar": "",
    "uk": "\u0426\u044f \u0456\u043d\u0444\u043e\u0440\u043c\u0430\u0446\u0456\u044f \u043f\u043e\u0442\u0440\u0456\u0431\u043d\u0430 \u0434\u043b\u044f \u0437\u0434\u0456\u0439\u0441\u043d\u0435\u043d\u043d\u044f \u043f\u043b\u0430\u0442\u0435\u0436\u0456\u0432"
  },
  "settings_label_change_pic": {
    "sheet_name": "Web",
    "en": "Change Picture",
    "ru": "",
    "fi": "Vaihda kuva",
    "sv": "V\u00e4nligen v\u00e4lj ett annat foto",
    "fa": "",
    "ar": "",
    "uk": "\u0417\u043c\u0456\u043d\u0438\u0442\u0438 \u0444\u043e\u0442\u043e\u0433\u0440\u0430\u0444\u0456\u044e"
  },
  "settings_label_edit_prof": {
    "sheet_name": "Web",
    "en": "Edit profile",
    "ru": "\u0420\u0435\u0434\u0430\u043a\u0442\u0438\u0440\u043e\u0432\u0430\u0442\u044c \u043f\u0440\u043e\u0444\u0438\u043b\u044c:",
    "fi": "Muokkaa profiilia",
    "sv": "Uppdatera profilen",
    "fa": "\u062f\u0633\u062a\u06a9\u0627\u0631\u06cc \u067e\u0631\u0648\u0641\u0627\u06cc\u0644",
    "ar": "\u062a\u0639\u062f\u064a\u0644 \u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u0634\u062e\u0635\u064a :",
    "uk": "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438 \u043f\u0440\u043e\u0444\u0456\u043b\u044c"
  },
  "settings_delete_acc": {
    "sheet_name": "Web",
    "en": "Delete your account?",
    "ru": "",
    "fi": "Poista tunnuksesi?",
    "sv": "Radera ditt konto?",
    "fa": "",
    "ar": "",
    "uk": "\u0412\u0438\u0434\u0430\u043b\u0438\u0442\u0438 \u043e\u0431\u043b\u0456\u043a\u043e\u0432\u0438\u0439 \u0437\u0430\u043f\u0438\u0441?"
  },
  "settings_pw_change_error": {
    "sheet_name": "Web",
    "en": "Password does not match your current password.",
    "ru": "",
    "fi": "Salasana ei vastaa nykyist\u00e4 salasanaasi.",
    "sv": "L\u00f6senordet matchar inte ditt nuvarande l\u00f6senord.",
    "fa": "",
    "ar": "",
    "uk": "\u041f\u0430\u0440\u043e\u043b\u044c \u043d\u0435 \u0437\u0431\u0456\u0433\u0430\u0454\u0442\u044c\u0441\u044f \u0437 \u0432\u0430\u0448\u0438\u043c \u043f\u043e\u0442\u043e\u0447\u043d\u0438\u043c \u043f\u0430\u0440\u043e\u043b\u0435\u043c"
  },
  "invalid_experiences": {
    "sheet_name": "Web",
    "en": "Invalid experiences",
    "ru": "\u041d\u0435\u0443\u0434\u0430\u0432\u0448\u0438\u0439\u0441\u044f \u043e\u043f\u044b\u0442",
    "fi": "Virheelliset kokemukset",
    "sv": "Ogiltiga upplevelser",
    "fa": "\u062a\u062c\u0627\u0631\u0628 \u0646\u0627\u062f\u0631\u0633\u062a",
    "ar": "\u062a\u062c\u0627\u0631\u0628 \u063a\u064a\u0631 \u0635\u0627\u0644\u062d\u0629",
    "uk": "\u041d\u0435\u0434\u0456\u0439\u0441\u043d\u0438\u0439 \u0434\u043e\u0441\u0432\u0456\u0434 \u0440\u043e\u0431\u043e\u0442\u0438"
  },
  "txt_cancel": {
    "sheet_name": "Web",
    "en": "Cancel",
    "ru": "\u043e\u0442\u043c\u0435\u043d\u0438\u0442\u044c",
    "fi": "Peruuta",
    "sv": "Avbryta",
    "fa": "\u0644\u063a\u0648",
    "ar": "\u062a\u0631\u0627\u062c\u0639",
    "uk": "\u0421\u043a\u0430\u0441\u0443\u0432\u0430\u0442\u0438"
  },
  "table_header_location": {
    "sheet_name": "Web",
    "en": "Location",
    "ru": "\u041c\u0435\u0441\u0442\u043e \u043d\u0430\u0445\u043e\u0436\u0434\u0435\u043d\u0438\u044f",
    "fi": "Sijainti",
    "sv": "Plats",
    "fa": "\u0645\u0648\u0642\u0639\u06cc\u062a",
    "ar": "\u0645\u0648\u0642\u0639",
    "uk": "\u041c\u0456\u0441\u0446\u0435\u0437\u043d\u0430\u0445\u043e\u0434\u0436\u0435\u043d\u043d\u044f"
  },
  "order_show_on_map": {
    "sheet_name": "Web",
    "en": "Show on map",
    "ru": "\u041f\u043e\u043a\u0430\u0437\u0430\u0442\u044c \u043d\u0430 \u043a\u0430\u0440\u0442\u0435",
    "fi": "Kartalla",
    "sv": "P\u00e5 kartan",
    "fa": "\u0646\u0645\u0627\u06cc\u0634 \u0631\u0648\u06cc \u0646\u0642\u0634\u0647",
    "ar": "\u0625\u0638\u0647\u0627\u0631 \u0639\u0644\u0649 \u0627\u0644\u062e\u0631\u064a\u0637\u0629",
    "uk": "\u041f\u043e\u043a\u0430\u0437\u0430\u0442\u0438 \u043d\u0430 \u043a\u0430\u0440\u0442\u0456"
  },
  "txt_back": {
    "sheet_name": "Web",
    "en": "Back",
    "ru": "\u041d\u0430\u0437\u0430\u0434",
    "fi": "Takaisin",
    "sv": "Tillbaka",
    "fa": "\u0628\u0627\u0632\u06af\u0634\u062a",
    "ar": "\u062a\u0631\u0627\u062c\u0639",
    "uk": "\u041d\u0430\u0437\u0430\u0434"
  },
  "profile_public_sharing_not_allowed_title": {
    "sheet_name": "Web",
    "en": "Not allowed",
    "ru": "\u041d\u0435 \u0434\u043e\u043f\u0443\u0441\u043a\u0430\u0435\u0442\u0441\u044f",
    "fi": "Ei sallittu",
    "sv": "Inte till\u00e5tet",
    "fa": "\u0645\u062c\u0627\u0632 \u0646\u06cc\u0633\u062a",
    "ar": "",
    "uk": "\u041d\u0435 \u0434\u043e\u0437\u0432\u043e\u043b\u044f\u0454\u0442\u044c\u0441\u044f"
  },
  "profile_public_sharing_not_allowed_message": {
    "sheet_name": "Web",
    "en": "You have to make your CV public on the 'Settings > Personal Info' page first.",
    "ru": "\u0421\u043d\u0430\u0447\u0430\u043b\u0430 \u0432\u0430\u043c \u043d\u0443\u0436\u043d\u043e \u0441\u043e\u0437\u0434\u0430\u0442\u044c \u0412\u0430\u0448\u0435 \u0440\u0435\u0437\u044e\u043c\u0435 \u0432 \u043d\u0430\u0441\u0442\u0440\u043e\u0439\u043a\u0430\u0445 \u043f\u0440\u043e\u0444\u0438\u043b\u044f, \u043d\u0430 \u043f\u0435\u0440\u0432\u043e\u0439 \u0441\u0442\u0440\u0430\u043d\u0438\u0446\u0435 \u043b\u0438\u0447\u043d\u043e\u0439 \u0438\u043d\u0444\u043e\u0440\u043c\u0430\u0446\u0438\u0438",
    "fi": "Sinun t\u00e4ytyy ensin tehd\u00e4 CV:t\u00e4si julkinen \u00b4Profiilini > Henkil\u00f6tiedot\u00b4 -sivulla",
    "sv": "Du m\u00e5ste dela din CV p\u00e5 sidan \u2019min profil\u2019 - sedan under profilinst\u00e4llningar",
    "fa": "\u0627\u0628\u062a\u062f\u0627 \u0628\u0627\u06cc\u062f CV \u062e\u0648\u062f \u0631\u0627 \u062f\u0631 \u0635\u0641\u062d\u0647 \"\u062a\u0646\u0638\u06cc\u0645\u0627\u062a> \u0627\u0637\u0644\u0627\u0639\u0627\u062a \u0634\u062e\u0635\u06cc\" \u0639\u0645\u0648\u0645\u06cc \u06a9\u0646\u06cc\u062f.",
    "ar": "\u064a\u062c\u0628 \u0623\u0646 \u062a\u062c\u0639\u0644 \u0633\u064a\u0631\u062a\u0643 \u0627\u0644\u0630\u0627\u062a\u064a\u0629 \u0639\u0627\u0645\u0629 \u0641\u064a \u0635\u0641\u062d\u0629 \"\u0625\u0639\u062f\u0627\u062f\u0627\u062a \u0627\u0644\u0639\u0627\u0645\u0644> \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062a \u0627\u0644\u0634\u062e\u0635\u064a\u0629\" \u0623\u0648\u0644\u0627\u064b.",
    "uk": "\u0421\u043f\u043e\u0447\u0430\u0442\u043a\u0443 \u0432\u0438 \u043c\u0430\u0454\u0442\u0435 \u043e\u043f\u0443\u0431\u043b\u0456\u043a\u0443\u0432\u0430\u0442\u0438 \u0441\u0432\u043e\u0454 \u0440\u0435\u0437\u044e\u043c\u0435 \u043d\u0430 \u0441\u0442\u043e\u0440\u0456\u043d\u0446\u0456 \"\u041d\u0430\u043b\u0430\u0448\u0442\u0443\u0432\u0430\u043d\u043d\u044f > \u041e\u0441\u043e\u0431\u0438\u0441\u0442\u0430 \u0456\u043d\u0444\u043e\u0440\u043c\u0430\u0446\u0456\u044f\"."
  },
  "txt_copy_link": {
    "sheet_name": "Web",
    "en": "Copy link",
    "ru": "\u041a\u043e\u043f\u0438\u0440\u043e\u0432\u0430\u0442\u044c \u0441\u0441\u044b\u043b\u043a\u0443",
    "fi": "Kopioi linkki",
    "sv": "Kopiera l\u00e4nken",
    "fa": "\u0644\u06cc\u0646\u06a9 \u0631\u0627 \u06a9\u067e\u06cc \u06a9\u0646\u06cc\u062f",
    "ar": "\u0646\u0633\u062e \u0627\u0644\u0631\u0627\u0628\u0637",
    "uk": "\u041a\u043e\u043f\u0456\u044e\u0432\u0430\u0442\u0438 \u043f\u043e\u0441\u0438\u043b\u0430\u043d\u043d\u044f"
  },
  "txt_select_all": {
    "sheet_name": "Web",
    "en": "Select all",
    "ru": "\u0412\u044b\u0431\u0440\u0430\u0442\u044c \u0432\u0441\u0435",
    "fi": "Valitse kaikki",
    "sv": "V\u00e4lj alla",
    "fa": "\u0627\u0646\u062a\u062e\u0627\u0628 \u0647\u0645\u0647",
    "ar": "\u0625\u062e\u062a\u0631 \u0627\u0644\u0643\u0644",
    "uk": "\u0412\u0438\u0431\u0440\u0430\u0442\u0438 \u0432\u0441\u0435"
  },
  "register_label_language": {
    "sheet_name": "Web",
    "en": "Language",
    "ru": "\u042f\u0437\u044b\u043a",
    "fi": "Kieli",
    "sv": "Spr\u00e5ket",
    "fa": "\u0632\u0628\u0627\u0646",
    "ar": "\u0627\u0644\u0644\u063a\u0629",
    "uk": "\u041c\u043e\u0432\u0430"
  },
  "menu_label_experiences": {
    "sheet_name": "Web",
    "en": "Experience",
    "ru": "\u041e\u043f\u044b\u0442",
    "fi": "Kokemus",
    "sv": "Erfarenheter",
    "fa": "\u062a\u062c\u0627\u0631\u0628",
    "ar": "\u0627\u0644\u062e\u0628\u0631\u0627\u062a",
    "uk": "\u0414\u043e\u0441\u0432\u0456\u0434"
  },
  "worker_company_registration_number": {
    "sheet_name": "Web",
    "en": "Organisation ID (business \/ permit etc)",
    "ru": "\u041d\u043e\u043c\u0435\u0440 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438",
    "fi": "Tunniste (Y-tunnus \/ lupa nro)",
    "sv": "Registreringsnummer",
    "fa": "\u0634\u0645\u0627\u0631\u0647 \u06cc \u062b\u0628\u062a \u0646\u0627\u0645",
    "ar": "\u0631\u0642\u0645 \u0627\u0644\u062a\u0633\u062c\u064a\u0644",
    "uk": "\u0406\u0434\u0435\u043d\u0442\u0438\u0444\u0456\u043a\u0430\u0442\u043e\u0440 \u043e\u0440\u0433\u0430\u043d\u0456\u0437\u0430\u0446\u0456\u0457 (\u0431\u0456\u0437\u043d\u0435\u0441 \/ \u0434\u043e\u0437\u0432\u0456\u043b \u0442\u043e\u0449\u043e)"
  },
  "register_label_select_language": {
    "sheet_name": "Web",
    "en": "Select a language",
    "ru": "\u0412\u044b\u0431\u0435\u0440\u0438\u0442\u0435 \u044f\u0437\u044b\u043a",
    "fi": "Valitse kieli",
    "sv": "V\u00e4lj spr\u00e5k",
    "fa": "\u06cc\u06a9 \u0632\u0628\u0627\u0646 \u0631\u0627 \u0627\u0646\u062a\u062e\u0627\u0628 \u06a9\u0646\u06cc\u062f",
    "ar": "\u0625\u062e\u062a\u0631 \u0627\u0644\u0644\u063a\u0629",
    "uk": "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044c \u043c\u043e\u0432\u0443"
  },
  "cv_label_completed_gigs": {
    "sheet_name": "Web",
    "en": "Completed gigs",
    "ru": "\u0417\u0430\u0434\u0430\u0447\u0438",
    "fi": "Tehdyt keikat",
    "sv": "Avslutade uppdrag",
    "fa": "\u0648\u0638\u0627\u06cc\u0641",
    "ar": "\u0627\u0644\u0639\u0631\u0628\u0627\u062a \u0627\u0644\u0645\u0643\u062a\u0645\u0644\u0629",
    "uk": "\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043d\u0456 \u0437\u0430\u0434\u0430\u0447\u0456"
  },
  "menu_label_cv": {
    "sheet_name": "Web",
    "en": "Open\/Share CV",
    "ru": "\u0421\u043e\u0437\u0434\u0430\u0442\u044c \/ \u043f\u043e\u0434\u0435\u043b\u0438\u0442\u044c\u0441\u044f \u0440\u0435\u0437\u044e\u043c\u0435",
    "fi": "Avaa\/Jaa CV",
    "sv": "\u00d6ppna\/dela CV",
    "fa": "CV \u0631\u0627 \u0628\u0627\u0632 \u06a9\u0646\u06cc\u062f \/ \u0628\u0647 \u0627\u0634\u062a\u0631\u0627\u06a9 \u0628\u06af\u0630\u0627\u0631\u06cc\u062f",
    "ar": "\u0641\u062a\u062d\/ \u0646\u0634\u0631 \u0627\u0644\u0633\u064a\u0631\u0629 \u0627\u0644\u0630\u0627\u062a\u064a\u0629",
    "uk": "\u0412\u0456\u0434\u043a\u0440\u0438\u0442\u0438\/ \u043f\u043e\u0434\u0456\u043b\u0438\u0442\u0438\u0441\u044f \u0440\u0435\u0437\u044e\u043c\u0435"
  },
  "order_descr_worker": {
    "sheet_name": "Web",
    "en": "Worker description",
    "ru": "\u041e\u043f\u0438\u0441\u0430\u043d\u0438\u0435 \u0440\u0430\u0431\u043e\u0442\u043d\u0438\u043a\u0430",
    "fi": "Tekij\u00e4n kuvaus",
    "sv": "Beskrivning av utf\u00f6raren",
    "fa": "\u062a\u0648\u0636\u06cc\u062d\u0627\u062a \u06a9\u0627\u0631\u06af\u0631",
    "ar": "\u0648\u0635\u0641 \u0627\u0644\u0639\u0627\u0645\u0644",
    "uk": "\u041e\u043f\u0438\u0441 \u043f\u0440\u0430\u0446\u0456\u0432\u043d\u0438\u043a\u0430"
  },
  "order_descr_orderer": {
    "sheet_name": "Web",
    "en": "Orderer description",
    "ru": "\u041e\u043f\u0438\u0441\u0430\u043d\u0438\u0435 \u0437\u0430\u043a\u0430\u0437\u0447\u0438\u043a\u0430",
    "fi": "Tilaajan kuvaus",
    "sv": "Beskrivning av best\u00e4lleren",
    "fa": "\u062a\u0648\u0636\u06cc\u062d\u0627\u062a \u0633\u0641\u0627\u0631\u0634 \u062f\u0647\u0646\u062f\u0647",
    "ar": "\u0648\u0635\u0641 \u0627\u0644\u0637\u0627\u0644\u0628",
    "uk": "\u041e\u043f\u0438\u0441 \u0437\u0430\u043c\u043e\u0432\u043d\u0438\u043a\u0430"
  },
  "profile_worker_info_label": {
    "sheet_name": "Web",
    "en": "Worker Info",
    "ru": "\u0418\u043d\u0444\u043e\u0440\u043c\u0430\u0446\u0438\u044f \u043e \u0440\u0430\u0431\u043e\u0442\u043d\u0438\u043a\u0435",
    "fi": "Tekij\u00e4n hakemus",
    "sv": "Ans\u00f6kan fr\u00e5n utf\u00f6rare",
    "fa": "\u0627\u0637\u0644\u0627\u0639\u0627\u062a \u06a9\u0627\u0631\u06af\u0631",
    "ar": "\u0627\u0644\u0639\u0627\u0645\u0644",
    "uk": "\u0406\u043d\u0444\u043e\u0440\u043c\u0430\u0446\u0456\u044f \u043f\u0440\u043e \u043f\u0440\u0430\u0446\u0456\u0432\u043d\u0438\u043a\u0430"
  },
  "profile_referee_label": {
    "sheet_name": "Web",
    "en": "Referee",
    "ru": "",
    "fi": "Suosittelija",
    "sv": "Referens",
    "fa": "",
    "ar": "",
    "uk": "\u0414\u043e\u0432\u0456\u0434\u043a\u0430"
  },
  "profile_description_label": {
    "sheet_name": "Web",
    "en": "Description",
    "ru": "\u041e\u043f\u0438\u0441\u0430\u043d\u0438\u0435",
    "fi": "Kuvaus",
    "sv": "Beskrivning",
    "fa": "\u0634\u0631\u062d",
    "ar": "\u0648\u0635\u0641",
    "uk": "\u041e\u043f\u0438\u0441"
  },
  "profile_city_label": {
    "sheet_name": "Web",
    "en": "City",
    "ru": "\u0413\u043e\u0440\u043e\u0434",
    "fi": "Kaupunki",
    "sv": "Stad",
    "fa": "\u0634\u0647\u0631",
    "ar": "\u0627\u0644\u0645\u062f\u064a\u0646\u0629",
    "uk": "\u041c\u0456\u0441\u0442\u043e"
  },
  "profile_postal_code_label": {
    "sheet_name": "Web",
    "en": "Postal code",
    "ru": "\u041f\u043e\u0447\u0442\u043e\u0432\u044b\u0439 \u0438\u043d\u0434\u0435\u043a\u0441",
    "fi": "Postinumero",
    "sv": "Postnummer",
    "fa": "\u06a9\u0648\u062f \u067e\u0633\u062a\u06cc",
    "ar": "\u0627\u0644\u0631\u0645\u0632 \u0627\u0644\u0628\u0631\u064a\u062f\u064a",
    "uk": "\u041f\u043e\u0448\u0442\u043e\u0432\u0438\u0439 \u0456\u043d\u0434\u0435\u043a\u0441"
  },
  "profile_email_label": {
    "sheet_name": "Web",
    "en": "Email",
    "ru": "\u042d\u043b. \u043f\u043e\u0447\u0442\u0430",
    "fi": "S\u00e4hk\u00f6posti",
    "sv": "E-mail",
    "fa": "\u0627\u06cc\u0645\u06cc\u0644",
    "ar": "\u0627\u0644\u0628\u0631\u064a\u062f \u0627\u0644\u0627\u0644\u0643\u062a\u0631\u0648\u0646\u064a",
    "uk": "\u0415\u043b\u0435\u043a\u0442\u0440\u043e\u043d\u043d\u0430 \u043f\u043e\u0448\u0442\u0430"
  },
  "profile_phone_number_label": {
    "sheet_name": "Web",
    "en": "Phone number",
    "ru": "\u041d\u043e\u043c\u0435\u0440 \u0442\u0435\u043b\u0435\u0444\u043e\u043d\u0430",
    "fi": "Puhelinnumero",
    "sv": "Telefonnummer",
    "fa": "\u0634\u0645\u0627\u0631\u0647 \u062a\u0645\u0627\u0633",
    "ar": "\u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062a\u0641",
    "uk": "\u0422\u0435\u043b\u0435\u0444\u043e\u043d"
  },
  "profile_completed_orders_label": {
    "sheet_name": "Web",
    "en": "Orders",
    "ru": "\u0417\u0430\u043a\u0430\u0437\u044b",
    "fi": "Tilaukset",
    "sv": "Uppdrag",
    "fa": "\u0633\u0641\u0627\u0631\u0634\u0627\u062a",
    "ar": "\u0627\u0644\u0627\u0634\u062a\u0631\u0627\u0643\u0627\u062a",
    "uk": "\u0417\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f"
  },
  "profile_completed_tasks_label": {
    "sheet_name": "Web",
    "en": "Tasks",
    "ru": "\u0420\u0430\u0431\u043e\u0442\u044b",
    "fi": "Teht\u00e4v\u00e4t",
    "sv": "Uppdraget",
    "fa": "\u0634\u063a\u0644 \u0647\u0627",
    "ar": "\u0627\u0644\u0645\u0647\u0627\u0645 \u0627\u0644\u0645\u0643\u062a\u0645\u0644\u0629",
    "uk": "\u0417\u0430\u0434\u0430\u0447\u0456"
  },
  "profile_overall_rating_label": {
    "sheet_name": "Web",
    "en": "User rating",
    "ru": "\u0420\u0435\u0439\u0442\u0438\u043d\u0433 \u043f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u0435\u043b\u044f",
    "fi": "Palaute",
    "sv": "Feedback",
    "fa": "\u0631\u062a\u0628\u0647 \u0628\u0646\u062f\u06cc \u06a9\u0627\u0631\u0628\u0631",
    "ar": "\u062a\u0642\u064a\u064a\u0645 \u0627\u0644\u0645\u0633\u062a\u062e\u062f\u0645",
    "uk": "\u041e\u0446\u0456\u043d\u043a\u0430 \u043a\u043e\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430"
  },
  "profile_cv_link_label": {
    "sheet_name": "Web",
    "en": "CV",
    "ru": "\u0420\u0435\u0437\u044e\u043c\u0435",
    "fi": "CV",
    "sv": "CV",
    "fa": "CV",
    "ar": "CV",
    "uk": "\u0420\u0435\u0437\u044e\u043c\u0435"
  },
  "profile_cv_link_text": {
    "sheet_name": "Web",
    "en": "Show CV",
    "ru": "",
    "fi": "N\u00e4yt\u00e4 CV",
    "sv": "Visa CV",
    "fa": "",
    "ar": "",
    "uk": "\u041f\u043e\u043a\u0430\u0437\u0430\u0442\u0438 \u0440\u0435\u0437\u044e\u043c\u0435"
  },
  "profile_linkedin_link_label": {
    "sheet_name": "Web",
    "en": "LinkedIn profile",
    "ru": "\u041f\u0440\u043e\u0444\u0438\u043b\u044c Linkedln",
    "fi": "Linkedin profiili",
    "sv": "LinkedIn profil",
    "fa": "Linkdin \u062d\u0633\u0627\u0628 \u06a9\u0627\u0631\u0628\u0631\u06cc",
    "ar": "\u0645\u0644\u0641 \u062a\u0639\u0631\u064a\u0641 LinkedIn",
    "uk": "\u041f\u0440\u043e\u0444\u0456\u043b\u044c LinkedIn"
  },
  "profile_linkedin_link_text": {
    "sheet_name": "Web",
    "en": "Show LinkedIn profile",
    "ru": "",
    "fi": "N\u00e4yt\u00e4 LinkedIn profiili",
    "sv": "Visa LinkedInprofil",
    "fa": "",
    "ar": "",
    "uk": "\u041f\u043e\u043a\u0430\u0437\u0430\u0442\u0438 \u043f\u0440\u043e\u0444\u0456\u043b\u044c LinkedIn"
  },
  "profile_linkedin_link_error_text": {
    "sheet_name": "Web",
    "en": "Invalid LinkedIn URL (please enter https:\/\/www.linkedin.com\/xx...)",
    "ru": "",
    "fi": "Virheellinen linkki. Linkki on muodossa https:\/\/www.linkedin.com\/xx....",
    "sv": "Felaktig LinkedIn webbadress (https:\/\/www.linkedin.com\/xx...)",
    "fa": "",
    "ar": "",
    "uk": "\u041d\u0435\u0434\u0456\u0439\u0441\u043d\u0430 URL-\u0430\u0434\u0440\u0435\u0441\u0430 LinkedIn (\u0432\u0432\u0435\u0434\u0456\u0442\u044c https:\/\/www.linkedin.com\/xx...)"
  },
  "profile_available_for_label": {
    "sheet_name": "Web",
    "en": "Available for",
    "ru": "\u0437\u0430\u0438\u043d\u0442\u0435\u0440\u0435\u0441\u043e\u0432\u0430\u043d\u044b \u0432 \u0437\u0430\u0434\u0430\u0447\u0430\u0445",
    "fi": "Kiinnostunut teht\u00e4vist\u00e4",
    "sv": "Tillg\u00e4nglig f\u00f6r",
    "fa": "\u0639\u0644\u0627\u0642\u0647 \u0645\u0646\u062f \u0628\u0647 \u06a9\u0627\u0631\u0647\u0633\u062a\u0646\u062f",
    "ar": "\u0645\u0647\u062a\u0645 \u0628\u0627\u0644\u0645\u0647\u0645\u0629",
    "uk": "\u0414\u043e\u0441\u0442\u0443\u043f\u043d\u0438\u0439 \u0434\u043b\u044f"
  },
  "profile_only_for_worker_text": {
    "sheet_name": "Web",
    "en": "Available after being selected",
    "ru": "\u0412 \u043d\u0430\u043b\u0438\u0447\u0438\u0438 \u043f\u043e\u0441\u043b\u0435 \u0432\u044b\u0431\u043e\u0440\u0430",
    "fi": "Saatavilla valinnan j\u00e4lkeen",
    "sv": "Tillg\u00e4nglig efter att ha valts",
    "fa": "\u067e\u0633 \u0627\u0632 \u0627\u0646\u062a\u062e\u0627\u0628 \u062f\u0631 \u062f\u0633\u062a\u0631\u0633 \u0627\u0633\u062a",
    "ar": "\u0645\u062a\u0627\u062d \u0628\u0639\u062f \u0627\u062e\u062a\u064a\u0627\u0631\u0647",
    "uk": "\u0414\u043e\u0441\u0442\u0443\u043f\u043d\u0438\u0439 \u043f\u0456\u0441\u043b\u044f \u0432\u0438\u0431\u043e\u0440\u0443"
  },
  "profile_compamy_label": {
    "sheet_name": "Web",
    "en": "Company name",
    "ru": "\u041d\u0430\u0437\u0432\u0430\u043d\u0438\u0435 \u043a\u043e\u043c\u043f\u0430\u043d\u0438\u0438",
    "fi": "Organisaation nimi",
    "sv": "Organisationens namn",
    "fa": "\u0646\u0627\u0645 \u0634\u0631\u06a9\u062a",
    "ar": "\u0627\u0633\u0645 \u0627\u0644\u0634\u0631\u0643\u0629",
    "uk": "\u041d\u0430\u0437\u0432\u0430 \u043e\u0440\u0433\u0430\u043d\u0456\u0437\u0430\u0446\u0456\u0457"
  },
  "profile_no_message": {
    "sheet_name": "Web",
    "en": "No message",
    "ru": "",
    "fi": "Ei viesti\u00e4",
    "sv": "Inget meddelande",
    "fa": "",
    "ar": "",
    "uk": "\u041f\u043e\u0432\u0456\u0434\u043e\u043c\u043b\u0435\u043d\u044c \u043d\u0435\u043c\u0430\u0454"
  },
  "profile_avail_after_worker_selected": {
    "sheet_name": "Web",
    "en": "Available after worker is selected",
    "ru": "",
    "fi": "Saatavilla tekij\u00e4n valinnan j\u00e4lkeen",
    "sv": "Tillg\u00e4nglig efter att arbetare har valts",
    "fa": "",
    "ar": "",
    "uk": "\u0414\u043e\u0441\u0442\u0443\u043f\u043d\u0438\u0439 \u043f\u0456\u0441\u043b\u044f \u0432\u0438\u0431\u043e\u0440\u0443 \u043f\u0440\u0430\u0446\u0456\u0432\u043d\u0438\u043a\u0430"
  },
  "profile_feedbacks": {
    "sheet_name": "Web",
    "en": "Feedbacks",
    "ru": "",
    "fi": "Palautteita",
    "sv": "Feedback",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "table_filters_filter": {
    "sheet_name": "Web",
    "en": "Filter",
    "ru": "",
    "fi": "Suodata",
    "sv": "Filtrera",
    "fa": "",
    "ar": "",
    "uk": "\u0424\u0456\u043b\u044c\u0442\u0440\u0438"
  },
  "table_filters_clear": {
    "sheet_name": "Web",
    "en": "Clear filters",
    "ru": "",
    "fi": "Tyhjenn\u00e4 suodattimet",
    "sv": "\u00c5terstella filter",
    "fa": "",
    "ar": "",
    "uk": "\u041e\u0447\u0438\u0441\u0442\u0438\u0442\u0438 \u0444\u0456\u043b\u044c\u0442\u0440\u0438"
  },
  "table_filters_start": {
    "sheet_name": "Web",
    "en": "Start date",
    "ru": "",
    "fi": "Aloitusp\u00e4iv\u00e4",
    "sv": "Startdatum",
    "fa": "",
    "ar": "",
    "uk": "\u0414\u0430\u0442\u0430 \u043f\u043e\u0447\u0430\u0442\u043a\u0443"
  },
  "table_filters_init_order": {
    "sheet_name": "Web",
    "en": "Initial order time",
    "ru": "",
    "fi": "Ajoitus",
    "sv": "Ursprunglig tid",
    "fa": "",
    "ar": "",
    "uk": "\u0427\u0430\u0441 \u0437\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f"
  },
  "table_filters_orderby": {
    "sheet_name": "Web",
    "en": "Order by",
    "ru": "",
    "fi": "J\u00e4rjest\u00e4",
    "sv": "Sortera",
    "fa": "",
    "ar": "",
    "uk": "\u0417\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f \u0437\u0430"
  },
  "table_filters_init_date": {
    "sheet_name": "Web",
    "en": "Initial start date",
    "ru": "",
    "fi": "Aloitusp\u00e4iv\u00e4",
    "sv": "Startdatum",
    "fa": "",
    "ar": "",
    "uk": "\u041f\u0435\u0440\u0448\u0438\u0439 \u0440\u043e\u0431\u043e\u0447\u0438\u0439 \u0434\u0435\u043d\u044c"
  },
  "table_filters_worker": {
    "sheet_name": "Web",
    "en": "Worker email",
    "ru": "",
    "fi": "Tekij\u00e4n s\u00e4hk\u00f6posti",
    "sv": "Utf\u00f6rarens e-post",
    "fa": "",
    "ar": "",
    "uk": "\u0420\u043e\u0431\u043e\u0447\u0430 \u0435\u043b\u0435\u043a\u0442\u0440\u043e\u043d\u043d\u0430 \u043f\u043e\u0448\u0442\u0430"
  },
  "table_filters_sorting": {
    "sheet_name": "Web",
    "en": "Sorting",
    "ru": "",
    "fi": "J\u00e4rjestys",
    "sv": "Ordning",
    "fa": "",
    "ar": "",
    "uk": "\u0421\u043e\u0440\u0442\u0443\u0432\u0430\u043d\u043d\u044f"
  },
  "table_filters_descending": {
    "sheet_name": "Web",
    "en": "Descending",
    "ru": "",
    "fi": "Laskeva",
    "sv": "Dalande",
    "fa": "",
    "ar": "",
    "uk": "\u0421\u043f\u0443\u0441\u0442\u0438\u0442\u0438\u0441\u044f"
  },
  "table_filters_ascending": {
    "sheet_name": "Web",
    "en": "Ascending",
    "ru": "",
    "fi": "Nouseva",
    "sv": "Stigande",
    "fa": "",
    "ar": "",
    "uk": "\u041f\u0456\u0434\u043d\u044f\u0442\u0438\u0441\u044f"
  },
  "table_filters_product": {
    "sheet_name": "Web",
    "en": "Product name",
    "ru": "",
    "fi": "Palvelu",
    "sv": "Tj\u00e4nst",
    "fa": "",
    "ar": "",
    "uk": "\u041d\u0430\u0437\u0432\u0430 \u043f\u0440\u043e\u0434\u0443\u043a\u0442\u0443"
  },
  "table_filters_team": {
    "sheet_name": "Web",
    "en": "Team code",
    "ru": "",
    "fi": "Ryhm\u00e4koodi",
    "sv": "Gruppkod",
    "fa": "",
    "ar": "",
    "uk": "\u041a\u043e\u0434 \u043a\u043e\u043c\u0430\u043d\u0434\u0438"
  },
  "table_filters_city": {
    "sheet_name": "Web",
    "en": "City name",
    "ru": "",
    "fi": "Kaupunki",
    "sv": "Stad",
    "fa": "",
    "ar": "",
    "uk": "\u041d\u0430\u0437\u0432\u0430 \u043c\u0456\u0441\u0442\u0430"
  },
  "table_search_field": {
    "sheet_name": "Web",
    "en": "Search orders",
    "ru": "\u041f\u043e\u0438\u0441\u043a \u0437\u0430\u043a\u0430\u0437\u043e\u0432",
    "fi": "Etsi tilauksia",
    "sv": "S\u00f6k best\u00e4llningar",
    "fa": "\u062c\u0633\u062a\u062c\u0648\u06cc \u0633\u0641\u0627\u0631\u0634\u0627\u062a",
    "ar": "\u0628\u062d\u062a \u0639\u0646 \u0627\u0644\u0637\u0644\u0628\u0627\u062a",
    "uk": "\u041f\u043e\u0448\u0443\u043a \u0437\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u044c"
  },
  "table_chip_unassigned": {
    "sheet_name": "Web",
    "en": "Unassigned",
    "ru": "\u041e\u0442\u043a\u0440\u044b\u0442",
    "fi": "Avoinna",
    "sv": "\u00c4nnu ej tilldelad",
    "fa": "\u0628\u0627\u0632",
    "ar": "\u0627\u0641\u062a\u062d",
    "uk": "\u041d\u0435 \u0432\u0438\u0437\u043d\u0430\u0447\u0435\u043d\u043e"
  },
  "table_chip_opps": {
    "sheet_name": "Web",
    "en": "Opportunities",
    "ru": "\u0412\u043e\u0437\u043c\u043e\u0436\u043d\u043e\u0441\u0442\u0438",
    "fi": "Mahdollisuudet",
    "sv": "M\u00f6jligheter",
    "fa": "\u0641\u0631\u0635\u062a \u0647\u0627",
    "ar": "\u0627\u0644\u0641\u0631\u0635",
    "uk": "\u041c\u043e\u0436\u043b\u0438\u0432\u043e\u0441\u0442\u0456"
  },
  "table_chip_hist": {
    "sheet_name": "Web",
    "en": "History",
    "ru": "\u0418\u0441\u0442\u043e\u0440\u0438\u044f",
    "fi": "Historia",
    "sv": "Historik",
    "fa": "\u062a\u0627\u0631\u06cc\u062e\u0686\u0647",
    "ar": "\u062a\u0627\u0631\u064a\u062e",
    "uk": "\u0406\u0441\u0442\u043e\u0440\u0456\u044f"
  },
  "table_no_result": {
    "sheet_name": "Web",
    "en": "No result.",
    "ru": "\u041d\u0435\u0442 \u0440\u0435\u0437\u0443\u043b\u044c\u0442\u0430\u0442\u043e\u0432",
    "fi": "Ei tuloksia",
    "sv": "Inget resultat",
    "fa": "\u0646\u062a\u06cc\u062c\u0647 \u0627\u06cc \u06cc\u0627\u0641\u062a \u0646\u0634\u062f",
    "ar": "\u0644\u0627 \u0646\u062a\u064a\u062c\u0629",
    "uk": "\u0420\u0435\u0437\u0443\u043b\u044c\u0442\u0430\u0442\u0456\u0432 \u043d\u0435 \u0437\u043d\u0430\u0439\u0434\u0435\u043d\u043e"
  },
  "table_chip_aw_appr": {
    "sheet_name": "Web",
    "en": "Awaiting approval",
    "ru": "\u041f\u043e\u0434\u043e\u0436\u0434\u0438\u0442\u0435 \u043e\u0434\u043e\u0431\u0440\u0435\u043d\u0438\u044f",
    "fi": "Odottaa hyv\u00e4ksynt\u00e4\u00e4",
    "sv": "V\u00e4ntar p\u00e5 godk\u00e4nnande",
    "fa": "\u062f\u0631 \u0627\u0646\u062a\u0638\u0627\u0631 \u062a\u0627\u06cc\u06cc\u062f",
    "ar": "\u0627\u0646\u062a\u0638\u0631 \u0627\u0644\u0642\u0628\u0648\u0644",
    "uk": "\u041e\u0447\u0456\u043a\u0443\u0439\u0442\u0435 \u0437\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043d\u043d\u044f"
  },
  "table_header_task": {
    "sheet_name": "Web",
    "en": "Task",
    "ru": "\u0417\u0430\u0434\u0430\u043d\u0438\u0435",
    "fi": "Teht\u00e4v\u00e4",
    "sv": "Uppdrag",
    "fa": "\u0648\u0638\u06cc\u0641\u0647",
    "ar": "\u0645\u0647\u0645\u0629",
    "uk": "\u0417\u0430\u0432\u0434\u0430\u043d\u043d\u044f"
  },
  "table_header_apply": {
    "sheet_name": "Web",
    "en": "Apply",
    "ru": "\u041f\u043e\u043b\u0443\u0447\u0438\u0442\u044c",
    "fi": "Hae",
    "sv": "Ans\u00f6ka",
    "fa": "\u062f\u0631\u062e\u0648\u0627\u0633\u062a \u062f\u0627\u062f\u0646",
    "ar": "\u062a\u0637\u0628\u064a\u0642",
    "uk": "\u0417\u0430\u0441\u0442\u043e\u0441\u0443\u0432\u0430\u0442\u0438"
  },
  "table_color_canc": {
    "sheet_name": "Web",
    "en": "Cancelled",
    "ru": "\u041e\u0442\u043c\u0435\u043d\u0435\u043d\u043e",
    "fi": "Peruutettu",
    "sv": "Annullerad",
    "fa": "\u0644\u063a\u0648 \u0634\u062f",
    "ar": "\u0623\u0644\u063a\u064a\u062a",
    "uk": "\u0421\u043a\u0430\u0441\u043e\u0432\u0430\u043d\u043e"
  },
  "table_button_create": {
    "sheet_name": "Web",
    "en": "+ Create",
    "ru": "\u0421\u043e\u0437\u0434\u0430\u0442\u044c",
    "fi": "+ Luo",
    "sv": "+ Skapa",
    "fa": "\u0627\u06cc\u062c\u0627\u062f \u06a9\u0646\u06cc\u062f +",
    "ar": "\u062e\u0644\u0642",
    "uk": "+ \u0421\u0442\u0432\u043e\u0440\u0438\u0442\u0438"
  },
  "table_header_payment_failed": {
    "sheet_name": "Web",
    "en": "Payment failed",
    "ru": "",
    "fi": "Maksu ep\u00e4onnistunut",
    "sv": "Betalning misslyckades",
    "fa": "",
    "ar": "",
    "uk": "\u041d\u0435 \u0432\u0434\u0430\u043b\u043e\u0441\u044f \u0437\u0434\u0456\u0439\u0441\u043d\u0438\u0442\u0438 \u043f\u043b\u0430\u0442\u0456\u0436"
  },
  "table_header_apps": {
    "sheet_name": "Web",
    "en": "Applicants",
    "ru": "\u041a\u0430\u043d\u0434\u0438\u0434\u0430\u0442\u044b",
    "fi": "Hakijoita",
    "sv": "S\u00f6kande",
    "fa": "\u062f\u0631\u062e\u0648\u0627\u0633\u062a \u06a9\u0646\u0646\u062f\u0647 \u0647\u0627",
    "ar": "\u0627\u0644\u0645\u062a\u0642\u062f\u0645\u064a\u0646",
    "uk": "\u041f\u0440\u0435\u0442\u0435\u043d\u0434\u0435\u043d\u0442\u0438"
  },
  "table_header_rating": {
    "sheet_name": "Web",
    "en": "Rating",
    "ru": "\u0420\u0435\u0439\u0442\u0438\u043d\u0433",
    "fi": "Palaute",
    "sv": "Feedback",
    "fa": "\u0631\u062a\u0628\u0647 \u0628\u0646\u062f\u06cc",
    "ar": "\u0631\u062f\u0648\u062f \u0627\u0644\u0641\u0639\u0644",
    "uk": "\u0420\u0435\u0439\u0442\u0438\u043d\u0433"
  },
  "table_header_init_time": {
    "sheet_name": "Web",
    "en": "Initial time",
    "ru": "\u041d\u0430\u0447\u0430\u043b\u044c\u043d\u043e\u0435 \u0432\u0440\u0435\u043c\u044f",
    "fi": "Ajoitus",
    "sv": "Ursprunglig tid",
    "fa": "\u0632\u0645\u0627\u0646 \u0627\u0635\u0644\u06cc:",
    "ar": "\u0627\u0644\u0648\u0642\u062a \u0627\u0644\u0645\u0637\u0644\u0648\u0628",
    "uk": "\u041f\u043e\u0447\u0430\u0442\u043a\u043e\u0432\u0438\u0439 \u0447\u0430\u0441"
  },
  "table_hide_cancelled_label": {
    "sheet_name": "Web",
    "en": "Hide cancelled",
    "ru": "",
    "fi": "Piilota peruutetut",
    "sv": "G\u00f6m annulerad",
    "fa": "",
    "ar": "",
    "uk": "\u041f\u0440\u0438\u0445\u043e\u0432\u0430\u0442\u0438 \u0441\u043a\u0430\u0441\u043e\u0432\u0430\u043d\u0435"
  },
  "table_chip_in_prog": {
    "sheet_name": "Web",
    "en": "In progress",
    "ru": "\u0412 \u0445\u043e\u0434\u0435 \u0432\u044b\u043f\u043e\u043b\u043d\u0435\u043d\u0438\u044f",
    "fi": "Meneill\u00e4\u00e4n",
    "sv": "P\u00e5g\u00e5ende",
    "fa": "\u062f\u0631 \u062d\u0627\u0644 \u0627\u0646\u062c\u0627\u0645",
    "ar": "\u0641\u064a \u062a\u0642\u062f\u0645",
    "uk": "\u0412 \u043f\u0440\u043e\u0446\u0435\u0441\u0456"
  },
  "order_no_appls": {
    "sheet_name": "Web",
    "en": "No applicant chosen",
    "ru": "\u041d\u0438 \u043e\u0434\u0438\u043d \u043a\u0430\u043d\u0434\u0438\u0434\u0430\u0442 \u043d\u0435 \u0432\u044b\u0431\u0440\u0430\u043d",
    "fi": "Hakijaa ei valittu",
    "sv": "Ingen s\u00f6kande utvald",
    "fa": "\u062f\u0631\u062e\u0648\u0627\u0633\u062a \u06a9\u0646\u0646\u062f\u0647\u0627\u0646\u062a\u062e\u0627\u0628 \u0646\u0634\u062f",
    "ar": "\u0644\u0645 \u064a\u062a\u0645 \u0625\u062e\u062a\u064a\u0627\u0631 \u0627\u0644\u0645\u062a\u0642\u062f\u0645",
    "uk": "\u041d\u0435 \u043e\u0431\u0440\u0430\u043d\u043e \u0436\u043e\u0434\u043d\u043e\u0433\u043e \u043f\u0440\u0435\u0442\u0435\u043d\u0434\u0435\u043d\u0442\u0430"
  },
  "order_name": {
    "sheet_name": "Web",
    "en": "Name",
    "ru": "\u0418\u043c\u044f",
    "fi": "Nimi",
    "sv": "Namn",
    "fa": "\u0646\u0627\u0645",
    "ar": "\u0627\u0644\u0627\u0633\u0645",
    "uk": "\u0406\u043c'\u044f"
  },
  "order_compl_jobs": {
    "sheet_name": "Web",
    "en": "Completed Jobs",
    "ru": "\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043d\u043d\u044b\u0435 \u0417\u0430\u044f\u0432\u043a\u0438",
    "fi": "Valmistuneet teht\u00e4v\u00e4t",
    "sv": "Avslutat uppdrag",
    "fa": "\u06a9\u0627\u0631\u0647\u0627\u06cc \u0627\u0646\u062c\u0627\u0645 \u0634\u062f\u0647",
    "ar": "\u062a\u0645 \u0625\u0646\u062c\u0627\u0632 \u0627\u0644\u0645\u0647\u0645\u0629",
    "uk": "\u0412\u0438\u043a\u043e\u043d\u0430\u043d\u0456 \u0437\u0430\u0432\u0434\u0430\u043d\u043d\u044f"
  },
  "order_work_info": {
    "sheet_name": "Web",
    "en": "Worker Info",
    "ru": "\u0418\u043d\u0444\u043e\u0440\u043c\u0430\u0446\u0438\u044f \u043e \u0440\u0430\u0431\u043e\u0442\u043d\u0438\u043a\u0435",
    "fi": "Tekij\u00e4n hakemus",
    "sv": "Ans\u00f6kan fr\u00e5n utf\u00f6rare",
    "fa": "\u0627\u0637\u0644\u0627\u0639\u0627\u062a \u06a9\u0627\u0631\u06af\u0631",
    "ar": "\u0627\u0644\u0639\u0627\u0645\u0644",
    "uk": "\u0406\u043d\u0444\u043e\u0440\u043c\u0430\u0446\u0456\u044f \u043f\u0440\u043e \u043f\u0440\u0430\u0446\u0456\u0432\u043d\u0438\u043a\u0430"
  },
  "order_more_appl": {
    "sheet_name": "Web",
    "en": "Do you want to select more applicants?",
    "ru": "\u0412\u044b \u0445\u043e\u0442\u0438\u0442\u0435 \u0432\u044b\u0431\u0440\u0430\u0442\u044c \u0431\u043e\u043b\u044c\u0448\u0435 \u043a\u0430\u043d\u0434\u0438\u0434\u0430\u0442\u043e\u0432?",
    "fi": "Tekij\u00e4 on valittu. Haluatko valita lis\u00e4\u00e4 tekij\u00f6it\u00e4?",
    "sv": "Vill du v\u00e4lja fler kandidater?",
    "fa": "\u0622\u06cc\u0627 \u0645\u06cc \u062e\u0648\u0627\u0647\u06cc\u062f \u0645\u062a\u0642\u0627\u0636\u06cc\u0627\u0646 \u0628\u06cc\u0634\u062a\u0631\u06cc \u0631\u0627 \u0627\u0646\u062a\u062e\u0627\u0628 \u06a9\u0646\u06cc\u062f\u061f",
    "ar": "\u062a\u0645 \u0625\u062e\u062a\u064a\u0627\u0631 \u0627\u0644\u0639\u0627\u0645\u0644. \u0647\u0644 \u062a\u0631\u064a\u062f \u0625\u062e\u062a\u064a\u0627\u0631 \u0645\u0632\u064a\u062f \u0645\u0646 \u0627\u0644\u0639\u0645\u0627\u0644\u061f",
    "uk": "\u0425\u043e\u0447\u0435\u0442\u0435 \u0432\u0438\u0431\u0440\u0430\u0442\u0438 \u0431\u0456\u043b\u044c\u0448\u0435 \u043f\u0440\u0435\u0442\u0435\u043d\u0434\u0435\u043d\u0442\u0456\u0432?"
  },
  "txt_yes": {
    "sheet_name": "Web",
    "en": "Yes",
    "ru": "\u0434\u0430",
    "fi": "Kyll\u00e4",
    "sv": "Ja",
    "fa": "\u0628\u0644\u06cc",
    "ar": "\u0646\u0639\u0645",
    "uk": "\u0422\u0430\u043a"
  },
  "order_no_only_one": {
    "sheet_name": "Web",
    "en": "No, only one",
    "ru": "\u041d\u0435\u0442",
    "fi": "En",
    "sv": "Nej",
    "fa": "\u0646\u062e\u06cc\u0631",
    "ar": "\u0644\u0627",
    "uk": "\u041d\u0456"
  },
  "order_own_desc": {
    "sheet_name": "Web",
    "en": "Own description",
    "ru": "\u0421\u043e\u0431\u0441\u0442\u0432\u0435\u043d\u043d\u043e\u0435 \u043e\u043f\u0438\u0441\u0430\u043d\u0438\u0435",
    "fi": "Kuvaus",
    "sv": "Beskrivning",
    "fa": "\u062a\u0648\u0636\u06cc\u062d\u0627\u062a",
    "ar": "\u0648\u0635\u0641",
    "uk": "\u0412\u043b\u0430\u0441\u043d\u0438\u0439 \u043e\u043f\u0438\u0441"
  },
  "order_view_profile": {
    "sheet_name": "Web",
    "en": "View profile",
    "ru": "\u041f\u043e\u0441\u043c\u043e\u0442\u0440\u0435\u0442\u044c \u043f\u0440\u043e\u0444\u0438\u043b\u044c",
    "fi": "N\u00e4yt\u00e4 profiili",
    "sv": "Visa profil",
    "fa": "\u0645\u0634\u0627\u0647\u062f\u0647 \u067e\u0631\u0648\u0641\u0627\u06cc\u0644",
    "ar": "\u0639\u0631\u0636 \u0627\u0644\u0635\u0641\u062d\u0629 \u0627\u0644\u0634\u062e\u0635\u064a\u0629",
    "uk": "\u041f\u0435\u0440\u0435\u0433\u043b\u044f\u043d\u0443\u0442\u0438 \u043f\u0440\u043e\u0444\u0456\u043b\u044c"
  },
  "share_inorder": {
    "sheet_name": "Web",
    "en": "For more info\/apply, please",
    "ru": "\u0427\u0442\u043e\u0431\u044b \u043f\u0440\u043e\u0434\u043e\u043b\u0436\u0438\u0442\u044c, \u043f\u043e\u0436\u0430\u043b\u0443\u0439\u0441\u0442\u0430, \u0438",
    "fi": "Lis\u00e4tietoja\/tee hakemus",
    "sv": "V\u00e4nligen forts\u00e4tt",
    "fa": "\u0628\u0631\u0627\u06cc \u0627\u062f\u0627\u0645\u0647 \u06a9\u0627\u0631 \u060c \u0644\u0637\u0641\u0627\u064b",
    "ar": "\u0645\u0646 \u0627\u062c\u0644 \u0627\u0644\u0645\u0636\u064a \u0642\u062f\u0645\u0627 , \u0645\u0646 \u0641\u0636\u0644\u0643",
    "uk": "\u0414\u043b\u044f \u043e\u0442\u0440\u0438\u043c\u0430\u043d\u043d\u044f \u0434\u043e\u0434\u0430\u0442\u043a\u043e\u0432\u043e\u0457 \u0456\u043d\u0444\u043e\u043c\u0430\u0446\u0456\u0457 \u0437\u0432\u0435\u0440\u043d\u0456\u0442\u044c\u0441\u044f, \u0431\u0443\u0434\u044c \u043b\u0430\u0441\u043a\u0430"
  },
  "share_usemob": {
    "sheet_name": "Web",
    "en": "or use mobile applications:",
    "ru": "\u0418\u043b\u0438 \u0438\u0441\u043f\u043e\u043b\u044c\u0437\u0443\u0439\u0442\u0435 \u043c\u043e\u0431\u0438\u043b\u044c\u043d\u044b\u0435 \u0441\u0435\u0440\u0432\u0438\u0441\u044b",
    "fi": "tai k\u00e4yt\u00e4 mobiilipalveluja",
    "sv": "eller anv\u00e4nd mobil applikation",
    "fa": "\u06cc\u0627 \u0627\u0632 \u0628\u0631\u0646\u0627\u0645\u0647 \u0647\u0627\u06cc \u062a\u0644\u0641\u0646 \u0647\u0645\u0631\u0627\u0647 \u0627\u0633\u062a\u0641\u0627\u062f\u0647 \u06a9\u0646\u06cc\u062f:",
    "ar": "\u0623\u0648 \u0627\u0633\u062a\u062e\u062f\u0645 \u062a\u0637\u0628\u064a\u0642\u0627\u062a \u0627\u0644\u062c\u0648\u0627\u0644:",
    "uk": "\u0410\u0431\u043e \u0441\u043a\u043e\u0440\u0438\u0441\u0442\u0430\u0439\u0442\u0435\u0441\u044f \u043c\u043e\u0431\u0456\u043b\u044c\u043d\u0438\u043c \u0434\u043e\u0434\u0430\u0442\u043a\u043e\u043c"
  },
  "order_apply_task": {
    "sheet_name": "Web",
    "en": "Apply",
    "ru": "\u041f\u0440\u0435\u0442\u0435\u043d\u0434\u043e\u0432\u0430\u0442\u044c \u043d\u0430 \u044d\u0442\u0443 \u0440\u0430\u0431\u043e\u0442\u0443",
    "fi": "Hae teht\u00e4v\u00e4\u00e4n",
    "sv": "S\u00f6k uppdraget",
    "fa": "\u0628\u0631\u0627\u06cc \u0627\u06cc\u0646 \u06a9\u0627\u0631 \u062f\u0631\u062e\u0648\u0627\u0633\u062a \u06a9\u0646\u06cc\u062f",
    "ar": "\u062a\u0642\u062f\u0645 \u0628\u0637\u0644\u0628 \u0644\u0647\u0630\u0647 \u0627\u0644\u0645\u0647\u0645\u0647",
    "uk": "\u044f \u0445\u043e\u0447\u0443 \u0446\u044e \u0440\u043e\u0431\u043e\u0442\u0443"
  },
  "order_your_comment_label": {
    "sheet_name": "Web",
    "en": "Write here your short application and further information to orderer",
    "ru": "\u0414\u043e\u043f\u043e\u043b\u043d\u0438\u0442\u0435\u043b\u044c\u043d\u0430\u044f \u0438\u043d\u0444\u043e\u0440\u043c\u0430\u0446\u0438\u044f \u0434\u043b\u044f \u0437\u0430\u043a\u0430\u0437\u0447\u0438\u043a\u0430",
    "fi": "Kirjoita t\u00e4h\u00e4n lyhyt hakemuksesi ja lis\u00e4tietoa tilaajalle",
    "sv": "Dina kommentarer till best\u00e4llaren",
    "fa": "\u0646\u0638\u0631\u0627\u062a \u0634\u0645\u0627 \u0628\u0647 \u0633\u0641\u0627\u0631\u0634 \u062f\u0647\u0646\u062f\u0647 \u060c \u0628\u0647 \u0639\u0646\u0648\u0627\u0646 \u0645\u062b\u0627\u0644 \u0686\u0631\u0627 \u0622\u0646\u0647\u0627 \u0628\u0627\u06cc\u062f \u0634\u0645\u0627 \u0631\u0627 \u0627\u0646\u062a\u062e\u0627\u0628 \u06a9\u0646\u0646\u062f \u0648 \u063a\u06cc\u0631\u0647",
    "ar": "\u062a\u0639\u0644\u064a\u0642\u0627\u062a\u0643 \u0644\u0644\u062c\u0647\u0629 \u0627\u0644\u0645\u0646\u0638\u0645\u0629 , \u0639\u0644\u0649 \u0633\u0628\u064a\u0644 \u0627\u0644\u0645\u062b\u0627\u0644 \u0644\u0645\u0627\u0630\u0627 \u064a\u062c\u0628 \u0625\u062e\u062a\u064a\u0627\u0631\u0643 .",
    "uk": "\u041d\u0430\u043f\u0438\u0448\u0456\u0442\u044c \u0442\u0443\u0442 \u0434\u043e\u0434\u0430\u0442\u043a\u043e\u0432\u0443 \u0456\u043d\u0444\u043e\u0440\u043c\u0430\u0446\u0456\u044e \u0434\u043b\u044f \u0437\u0430\u043c\u043e\u0432\u043d\u0438\u043a\u0430"
  },
  "order_cancel": {
    "sheet_name": "Web",
    "en": "Cancel order",
    "ru": "\u041e\u0442\u043c\u0435\u043d\u0438\u0442\u044c \u0437\u0430\u043a\u0430\u0437",
    "fi": "Peruuta tilaus",
    "sv": "Annulera best\u00e4llning",
    "fa": "\u0644\u063a\u0648 \u0633\u0641\u0627\u0631\u0634",
    "ar": "\u0625\u0644\u063a\u0627\u0621 \u0627\u0644\u0637\u0644\u0628",
    "uk": "\u0412\u0456\u0434\u043c\u0456\u043d\u0438\u0442\u0438 \u0437\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f"
  },
  "order_cancel_confirm": {
    "sheet_name": "Web",
    "en": "Are you sure you want to cancel this task?",
    "ru": "\u0412\u044b \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043b\u044c\u043d\u043e \u0445\u043e\u0442\u0438\u0442\u0435 \u0441\u043d\u044f\u0442\u044c \u044d\u0442\u043e\u0442 \u0437\u0430\u043a\u0430\u0437?",
    "fi": "Oletko varma ett\u00e4 haluat perua t\u00e4m\u00e4n teht\u00e4v\u00e4n?",
    "sv": "\u00c4r du s\u00e4ker att du vill avbryta dett updrag?",
    "fa": "\u0622\u06cc\u0627 \u0645\u0637\u0645\u0626\u0646 \u0647\u0633\u062a\u06cc\u062f \u06a9\u0647 \u0645\u06cc \u062e\u0648\u0627\u0647\u06cc\u062f \u0627\u06cc\u0646 \u06a9\u0627\u0631 \u0631\u0627 \u0644\u063a\u0648 \u06a9\u0646\u06cc\u062f\u061f",
    "ar": "\u0647\u0644 \u0627\u0646\u062a \u0645\u062a\u0623\u0643\u062f \u0627\u0646\u0643 \u062a\u0631\u064a\u062f \u0625\u0644\u063a\u0627\u0621 \u0647\u0630\u0647 \u0627\u0644\u0645\u0647\u0645\u0647\u061f",
    "uk": "\u0412\u0438 \u0432\u043f\u0435\u0432\u043d\u0435\u043d\u0456, \u0449\u043e \u0445\u043e\u0447\u0435\u0442\u0435 \u0441\u043a\u0430\u0441\u0443\u0432\u0430\u0442\u0438 \u0446\u0435 \u0437\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f?"
  },
  "order_approve": {
    "sheet_name": "Web",
    "en": "Approve",
    "ru": "\u0423\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044c",
    "fi": "Hyv\u00e4ksy",
    "sv": "Godk\u00e4nn",
    "fa": "\u062a\u0627\u06cc\u06cc\u062f",
    "ar": "\u0648\u0627\u0641\u0642",
    "uk": "\u0417\u0430\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438"
  },
  "order_not_approve": {
    "sheet_name": "Web",
    "en": "Reject",
    "ru": "\u041d\u0435 \u0443\u0442\u0432\u0435\u0440\u0436\u0434\u0430\u0442\u044c",
    "fi": "Hylk\u00e4\u00e4",
    "sv": "Avvisa",
    "fa": "\u062a\u0623\u06cc\u06cc\u062f \u0646\u0645\u06cc \u0634\u0648\u062f",
    "ar": "\u0644\u0645 \u062a\u062a\u0645 \u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629",
    "uk": "\u041d\u0435 \u0437\u0430\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438"
  },
  "order_task_complete": {
    "sheet_name": "Web",
    "en": "Claim as completed",
    "ru": "\u0417\u0430\u044f\u0432\u0438\u0442\u044c \u0440\u0430\u0431\u043e\u0442\u0443 \u043a\u0430\u043a \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043d\u043d\u0443\u044e",
    "fi": "Kuittaa valmistuneeksi",
    "sv": "Markera slutf\u00f6rt uppdrag",
    "fa": "\u0627\u0646\u062c\u0627\u0645 \u06a9\u0627\u0631 \u0627\u062f\u0639\u0627 \u0634\u062f",
    "ar": "\u0645\u0647\u0645\u0629 \u0627\u0644\u0645\u0637\u0627\u0644\u0628\u0629 \u0643\u0645\u0627 \u0627\u0643\u062a\u0645\u0644\u062a",
    "uk": "\u0420\u043e\u0431\u043e\u0442\u0443 \u0432\u0438\u043a\u043e\u043d\u0430\u043d\u043e"
  },
  "order_conf_time": {
    "sheet_name": "Web",
    "en": "Confirmed time",
    "ru": "\u041f\u043e\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043d\u043d\u043e\u0435 \u0432\u0440\u0435\u043c\u044f \u0434\u043b\u044f \u0440\u0430\u0431\u043e\u0442\u044b",
    "fi": "Vahvistettu aika",
    "sv": "Bekr\u00e4ftad tid f\u00f6r uppdrag",
    "fa": "\u0632\u0645\u0627\u0646 \u062a\u0623\u06cc\u06cc\u062f \u0634\u062f",
    "ar": "\u0627\u0644\u0648\u0642\u062a \u0627\u0644\u0645\u0624\u0643\u062f \u0644\u0644\u0645\u0647\u0645\u0629",
    "uk": "\u041f\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043d\u0438\u0439 \u0447\u0430\u0441 \u0440\u043e\u0431\u043e\u0442\u0438"
  },
  "order_feedback_text": {
    "sheet_name": "Web",
    "en": "Your feedback will be public. Any feedback you provide will appear in the users profile.",
    "ru": "\u0412\u0430\u0448\u0438 \u043e\u0442\u0437\u044b\u0432\u044b \u0431\u0443\u0434\u0443\u0442 \u043f\u0443\u0431\u043b\u0438\u0447\u043d\u044b\u043c\u0438. \u041b\u044e\u0431\u0430\u044f \u043e\u0431\u0440\u0430\u0442\u043d\u0430\u044f \u0441\u0432\u044f\u0437\u044c, \u043a\u043e\u0442\u043e\u0440\u0443\u044e \u0412\u044b \u043f\u0440\u0435\u0434\u043e\u0441\u0442\u0430\u0432\u043b\u044f\u0435\u0442\u0435, \u043f\u043e\u044f\u0432\u0438\u0442\u0441\u044f \u0432 \u043f\u0440\u043e\u0444\u0438\u043b\u0435 \u043f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u0435\u043b\u0435\u0439.",
    "fi": "Huomioithan, ett\u00e4 antamasi palaute n\u00e4kyy k\u00e4ytt\u00e4j\u00e4n profiilissa jatkossa my\u00f6s muille k\u00e4ytt\u00e4jille seuraavien tilauksien yhteydess\u00e4",
    "sv": "Observera att din feedback kommer att vara synlig i anv\u00e4ndarens profil f\u00f6r andra anv\u00e4ndare",
    "fa": "\u0628\u0627\u0631\u062e\u0648\u0631\u062f \u0634\u0645\u0627 \u0639\u0645\u0648\u0645\u06cc \u062e\u0648\u0627\u0647\u062f \u0628\u0648\u062f. \u0647\u0631 \u0628\u0627\u0632\u062e\u0648\u0631\u062f \u0634\u0645\u0627 \u0648\u0627\u0631\u062f \u06a9\u0646\u06cc\u062f \u0631\u0648\u06cc \u067e\u0631\u0648\u0641\u0627\u06cc\u0644 \u06af\u06cc\u0631\u0646\u062f\u0647 \u0638\u0627\u0647\u0631 \u062e\u0648\u0627\u0647\u062f \u0634\u062f.",
    "ar": "\u064a\u0631\u062c\u0649 \u0645\u0644\u0627\u062d\u0638\u0629 \u0627\u0646 \u0627\u0644\u062a\u0639\u0644\u064a\u0642\u0627\u062a \u0627\u0644\u062a\u064a \u062a\u0642\u062f\u0645\u0647\u0627 \u0633\u062a\u0633\u062a\u0645\u0631 \u0641\u064a \u0627\u0644\u0638\u0647\u0648\u0631 \u0641\u064a \u0627\u0644\u0645\u0644\u0641\u0627\u062a \u0627\u0644\u0634\u062e\u0635\u064a\u0629 \u0644\u0644\u0645\u0633\u062a\u062e\u062f\u0645\u064a\u0646 \u0627\u0644\u0627\u062e\u0631\u064a\u0646 \u0641\u064a\u0645\u0627 \u064a\u062a\u0639\u0644\u0642 \u0628\u0627\u0644\u0637\u0644\u0628\u0627\u062a \u0627\u0644\u0644\u0627\u062d\u0642\u0629.",
    "uk": "\u0412\u0430\u0448\u0456 \u0432\u0456\u0434\u0433\u0443\u043a\u0438 \u0431\u0443\u0434\u0443\u0442\u044c \u043f\u0443\u0431\u043b\u0456\u0447\u043d\u0438\u043c\u0438. \u0411\u0443\u0434\u044c-\u044f\u043a\u0438\u0439 \u043d\u0430\u0434\u0430\u043d\u0438\u0439 \u0432\u0430\u043c\u0438 \u0432\u0456\u0434\u0433\u0443\u043a \u0431\u0443\u0434\u0435 \u0432\u0456\u0434\u043e\u0431\u0440\u0430\u0436\u0430\u0442\u0438\u0441\u044f \u0432 \u043f\u0440\u043e\u0444\u0456\u043b\u0456 \u043a\u043e\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430"
  },
  "order_date": {
    "sheet_name": "Web",
    "en": "NOTE! Completion date (displayed in your certificate)",
    "ru": "\u041f\u043e\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043d\u043d\u043e\u0435 \u0432\u0440\u0435\u043c\u044f (\u043a\u043e\u043c\u043c\u0435\u043d\u0442\u0430\u0440\u0438\u0439 \u0440\u0430\u0431\u043e\u0442\u043d\u0438\u043a\u0430",
    "fi": "Huom! Valmistumisp\u00e4iv\u00e4 (n\u00e4kyy todistuksissa)",
    "sv": "OBS! Uppdragets slutdatum (syns i intyg)",
    "fa": "\u062a\u0648\u062c\u0647 \u062f\u0627\u0634\u062a\u0647 \u0628\u0627\u0634\u06cc\u062f! \u062a\u0627\u0631\u06cc\u062e \u062a\u06a9\u0645\u06cc\u0644 (\u0646\u0645\u0627\u06cc\u0634 \u062f\u0627\u062f\u0647 \u0634\u062f\u0647 \u062f\u0631 \u06af\u0648\u0627\u0647\u06cc\u0646\u0627\u0645\u0647 \u06a9\u0627\u0631\u06cc \u0634\u0645\u0627)",
    "ar": "\u0645\u0644\u0627\u062d\u0638\u0629 ! \u062a\u0627\u0631\u064a\u062e \u0627\u0644\u0625\u0646\u062a\u0647\u0627\u0621 (\u064a\u0638\u0647\u0631 \u0639\u0644\u0649 \u0627\u0644\u0634\u0647\u0627\u062f\u0627\u062a)",
    "uk": "\u041f\u0440\u0438\u043c\u0456\u0442\u043a\u0430! \n\u0414\u0430\u0442\u0430 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043d\u043d\u044f (\u0432\u0456\u0434\u043e\u0431\u0440\u0430\u0436\u0430\u0454\u0442\u044c\u0441\u044f \u0443 \u0432\u0430\u0448\u043e\u043c\u0443 \u0441\u0435\u0440\u0442\u0438\u0444\u0456\u043a\u0430\u0442\u0456)"
  },
  "order_short_comment": {
    "sheet_name": "Web",
    "en": "Write a short comment",
    "ru": "\u041d\u0430\u043f\u0438\u0448\u0438\u0442\u0435 \u043a\u043e\u0440\u043e\u0442\u043a\u0438\u0439 \u043a\u043e\u043c\u043c\u0435\u043d\u0442\u0430\u0440\u0438\u0439",
    "fi": "Kirjoita lyhyt kommentti",
    "sv": "Skriv en kort kommentar",
    "fa": "\u06a9\u0648\u062a\u0627\u0647 \u0646\u0638\u0631\u062e\u0648\u062f \u0631\u0627 \u0628\u0646\u0648\u06cc\u0633\u06cc\u062f",
    "ar": "\u0627\u0643\u062a\u0628 \u062a\u0639\u0644\u064a\u0642 \u0642\u0635\u064a\u0631",
    "uk": "\u041d\u0430\u043f\u0438\u0448\u0456\u0442\u044c \u043a\u043e\u0440\u043e\u0442\u043a\u0438\u0439 \u043a\u043e\u043c\u0435\u043d\u0442\u0430\u0440"
  },
  "order_change_duration": {
    "sheet_name": "Web",
    "en": "Change duration",
    "ru": "",
    "fi": "Muuta kestoa",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "order_change_duration_if_needed": {
    "sheet_name": "Web",
    "en": "Change duration only if needed",
    "ru": "",
    "fi": "Muuta kestoa vain tarvittaessa",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "order_add_completion_date": {
    "sheet_name": "Web",
    "en": "Add completion date",
    "ru": "",
    "fi": "Lis\u00e4\u00e4 valmistumisp\u00e4iv\u00e4",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "order_choose_rat": {
    "sheet_name": "Web",
    "en": "Choose a rating",
    "ru": "\u041f\u043e\u0436\u0430\u043b\u0443\u0439\u0441\u0442\u0430, \u0432\u044b\u0431\u0435\u0440\u0438\u0442\u0435 emoji",
    "fi": "Ole hyv\u00e4, ja valitse arvostelu",
    "sv": "Var god och v\u00e4lj en bed\u00f6mning",
    "fa": "\u0644\u0637\u0641\u0627 \u0631\u062a\u0628\u0647 \u0628\u0646\u062f\u06cc \u0631\u0627 \u0627\u0646\u062a\u062e\u0627\u0628 \u06a9\u0646\u06cc\u062f",
    "ar": "\u064a\u0631\u062c\u0649 \u0627\u062e\u062a\u064a\u0627\u0631 \u0627\u0644\u062a\u0642\u064a\u064a\u0645",
    "uk": "\u0411\u0443\u0434\u044c \u043b\u0430\u0441\u043a\u0430, \u043f\u043e\u0441\u0442\u0430\u0432\u0442\u0435 \u043e\u0446\u0456\u043d\u043a\u0443"
  },
  "order_submit": {
    "sheet_name": "Web",
    "en": "Submit",
    "ru": "\u041e\u0442\u043f\u0440\u0430\u0432\u0438\u0442\u044c",
    "fi": "L\u00e4het\u00e4",
    "sv": "Skicka in",
    "fa": "\u0627\u0631\u0633\u0627\u0644",
    "ar": "\u0625\u0631\u0633\u0627\u0644",
    "uk": "\u041d\u0430\u0434\u0456\u0441\u043b\u0430\u0442\u0438"
  },
  "order_rate_orderer": {
    "sheet_name": "Web",
    "en": "Rate the orderer",
    "ru": "\u041f\u043e\u0436\u0430\u043b\u0443\u0439\u0441\u0442\u0430, \u043e\u0446\u0435\u043d\u0438\u0442\u0435 \u0440\u0430\u0431\u043e\u0442\u043d\u0438\u043a\u0430",
    "fi": "Anna palautetta tilaajalle",
    "sv": "V\u00e4nligen ge feedback",
    "fa": "\u0644\u0637\u0641\u0627 \u0633\u0641\u0627\u0631\u0634 \u062f\u0647\u0646\u062f\u0647 \u0631\u0627 \u0627\u0631\u0632\u06cc\u0627\u0628\u06cc \u06a9\u0646\u06cc\u062f",
    "ar": "\u064a\u0631\u062c\u0649 \u062a\u0642\u064a\u064a\u0645 \u0627\u0644\u0637\u0627\u0644\u0628",
    "uk": "\u0411\u0443\u0434\u044c \u043b\u0430\u0441\u043a\u0430, \u043e\u0446\u0456\u043d\u0456\u0442\u044c \u043f\u0440\u0430\u0446\u0456\u0432\u043d\u0438\u043a\u0430"
  },
  "order_rate_worker": {
    "sheet_name": "Web",
    "en": "Rate the worker",
    "ru": "\u041f\u043e\u0436\u0430\u043b\u0443\u0439\u0441\u0442\u0430, \u043e\u0446\u0435\u043d\u0438\u0442\u0435 \u0437\u0430\u043a\u0430\u0437\u0447\u0438\u043a\u0430",
    "fi": "Anna palautetta tekij\u00e4lle",
    "sv": "V\u00e4nligen ge feedback",
    "fa": "\u0644\u0637\u0641\u0627 \u0628\u0647 \u06a9\u0627\u0631\u06af\u0631 \u0627\u0645\u062a\u06cc\u0627\u0632 \u062f\u0647\u06cc\u062f",
    "ar": "\u064a\u0631\u062c\u0649 \u062a\u0642\u064a\u064a\u0645 \u0627\u0644\u0639\u0627\u0645\u0644",
    "uk": "\u0411\u0443\u0434\u044c \u043b\u0430\u0441\u043a\u0430, \u043e\u0446\u0456\u043d\u0456\u0442\u044c \u0437\u0430\u043c\u043e\u0432\u043d\u0438\u043a\u0430"
  },
  "order_browse_appl": {
    "sheet_name": "Web",
    "en": "Browse applicants",
    "ru": "\u041f\u0440\u043e\u0441\u043c\u043e\u0442\u0440 \u043a\u0430\u043d\u0434\u0438\u0434\u0430\u0442\u043e\u0432",
    "fi": "Selaa hakijat",
    "sv": "Bl\u00e4ddra igenom s\u00f6kanden",
    "fa": "\u0645\u062a\u0642\u0627\u0636\u06cc\u0627\u0646 \u0631\u0627 \u0645\u0631\u0648\u0631 \u06a9\u0646\u06cc\u062f",
    "ar": "\u062a\u0635\u0641\u062d \u0627\u0644\u0645\u062a\u0642\u062f\u0645\u064a\u0646",
    "uk": "\u041f\u0435\u0440\u0435\u0433\u043b\u044f\u0434 \u043a\u0430\u043d\u0434\u0438\u0434\u0430\u0442\u0456\u0432"
  },
  "order_cancel_appl": {
    "sheet_name": "Web",
    "en": "Remove your application",
    "ru": "\u041e\u0442\u043c\u0435\u043d\u0438\u0442\u044c \u0437\u0430\u044f\u0432\u043a\u0443",
    "fi": "Poista hakemuksesi",
    "sv": "Annullera ans\u00f6kan",
    "fa": "\u0628\u0631\u0646\u0627\u0645\u0647 \u0631\u0627 \u0644\u063a\u0648 \u06a9\u0646\u06cc\u062f",
    "ar": "\u0625\u0644\u063a\u0627\u0621 \u0627\u0644\u0637\u0644\u0628",
    "uk": "\u0421\u043a\u0430\u0441\u0443\u0432\u0430\u0442\u0438 \u0437\u0430\u044f\u0432\u043a\u0443"
  },
  "order_task_loc": {
    "sheet_name": "Web",
    "en": "Location",
    "ru": "\u041c\u0435\u0441\u0442\u043e\u043f\u043e\u043b\u043e\u0436\u0435\u043d\u0438\u0435 \u0440\u0430\u0431\u043e\u0442\u044b",
    "fi": "Sijainti",
    "sv": "Plats f\u00f6r uppdraget",
    "fa": "\u0645\u0648\u0642\u0639\u06cc\u062a \u06a9\u0627\u0631",
    "ar": "\u0645\u0648\u0642\u0639 \u0627\u0644\u0639\u0645\u0644",
    "uk": "\u041c\u0456\u0441\u0446\u0435\u0437\u043d\u0430\u0445\u043e\u0434\u0436\u0435\u043d\u043d\u044f \u0440\u043e\u0431\u043e\u0442\u0438"
  },
  "order_show_rcpt": {
    "sheet_name": "Web",
    "en": "Show receipt",
    "ru": "\u041f\u043e\u043a\u0430\u0437\u0430\u0442\u044c \u043a\u0432\u0438\u0442\u0430\u043d\u0446\u0438\u044e",
    "fi": "N\u00e4yt\u00e4 kuitti",
    "sv": "Visa kvitto",
    "fa": "\u062f\u0631\u06cc\u0627\u0641\u062a \u0631\u0633\u06cc\u062f",
    "ar": "\u0625\u0638\u0647\u0627\u0631 \u0627\u0644\u0625\u064a\u0635\u0627\u0644",
    "uk": "\u041f\u043e\u043a\u0430\u0437\u0430\u0442\u0438 \u043a\u0432\u0438\u0442\u0430\u043d\u0446\u0456\u044e"
  },
  "order_vat": {
    "sheet_name": "Web",
    "en": "VAT",
    "ru": "\u041d\u0414\u0421",
    "fi": "ALV",
    "sv": "MOMS",
    "fa": "\u0645\u0627\u0644\u06cc\u0627\u062a \u0628\u0631 \u0627\u0631\u0632\u0634 \u0627\u0641\u0632\u0648\u062f\u0647",
    "ar": "\u0636\u0631\u064a\u0628\u0629 \u0627\u0644\u0642\u064a\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629",
    "uk": "\u041f\u0414\u0412"
  },
  "order_status": {
    "sheet_name": "Web",
    "en": "Order status:",
    "ru": "\u0414\u0435\u0442\u0430\u043b\u0438 \u0437\u0430\u043a\u0430\u0437\u0430:",
    "fi": "Tilauksen status:",
    "sv": "Best\u00e4llningens status:",
    "fa": "\u0648\u0636\u0639\u06cc\u062a \u0633\u0641\u0627\u0631\u0634:",
    "ar": "\u062d\u0627\u0644\u0629 \u0627\u0644\u0637\u0644\u0628 :",
    "uk": "\u0421\u0442\u0430\u0442\u0443\u0441 \u0437\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f:"
  },
  "order_get_cert": {
    "sheet_name": "Web",
    "en": "Get certificate",
    "ru": "\u041f\u043e\u043b\u0443\u0447\u0438\u0442\u044c \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043a\u0430\u0442",
    "fi": "Hae todistus",
    "sv": "F\u00e5 ett certificat",
    "fa": "\u062f\u0631\u06cc\u0627\u0641\u062a \u06af\u0648\u0627\u0647\u06cc\u0646\u0627\u0645\u0647",
    "ar": "\u0627\u0644\u062d\u0635\u0648\u0644 \u0639\u0644\u0649 \u0627\u0644\u0634\u0647\u0627\u062f\u0629",
    "uk": "\u041e\u0442\u0440\u0438\u043c\u0430\u0442\u0438 \u0441\u0435\u0440\u0442\u0438\u0444\u0456\u043a\u0430\u0442"
  },
  "order_add_fback_dont": {
    "sheet_name": "Web",
    "en": "Don't add feedback",
    "ru": "\u041d\u0435 \u0434\u043e\u0431\u0430\u0432\u043b\u044f\u0439\u0442\u0435 \u043e\u0442\u0437\u044b\u0432",
    "fi": "Ei palautetta",
    "sv": "Nej tack",
    "fa": "\u0628\u0627\u0632\u062e\u0648\u0631\u062f \u0627\u0636\u0627\u0641\u0647 \u0646\u06a9\u0646\u06cc\u062f",
    "ar": "\u0644\u0627 \u062a\u0648\u062c\u062f \u0631\u062f\u0648\u062f \u0627\u0644\u0641\u0639\u0644",
    "uk": "\u041d\u0435\u043c\u0430\u0454 \u0432\u0456\u0434\u0433\u0443\u043a\u0456\u0432"
  },
  "order_cert_add": {
    "sheet_name": "Web",
    "en": "Would you like to add the order feedback to your certificate?",
    "ru": "\u0412\u044b \u0445\u043e\u0442\u0438\u0442\u0435 \u0434\u043e\u0431\u0430\u0432\u0438\u0442\u044c \u043e\u0442\u0437\u044b\u0432 \u043e \u0437\u0430\u043a\u0430\u0437\u0435 \u0432 \u0441\u0432\u043e\u0439 \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043a\u0430\u0442?",
    "fi": "Haluatko lis\u00e4t\u00e4 tilaajan palautteen todistukseesi?",
    "sv": "Vill du anv\u00e4nda best\u00e4llarens feedback i ditt certifikat?",
    "fa": "\u0622\u06cc\u0627 \u0645\u06cc \u062e\u0648\u0627\u0647\u06cc\u062f \u0628\u0627\u0632\u062e\u0648\u0631\u062f \u0633\u0641\u0627\u0631\u0634 \u0631\u0627 \u0628\u0647 \u06af\u0648\u0627\u0647\u06cc\u0646\u0627\u0645\u0647 \u062e\u0648\u062f \u0627\u0636\u0627\u0641\u0647 \u06a9\u0646\u06cc\u062f\u061f",
    "ar": "\u0647\u0644 \u062a\u0631\u064a\u062f \u0641\u064a \u0625\u0636\u0627\u0641\u0629 \u0645\u0644\u0627\u062d\u0638\u0627\u062a \u0637\u0644\u0628 \u0625\u0644\u0649 \u0634\u0647\u0627\u062f\u062a\u0643\u061f",
    "uk": "\u0411\u0430\u0436\u0430\u0454\u0442\u0435 \u0434\u043e\u0434\u0430\u0442\u0438 \u0432\u0456\u0434\u0433\u0443\u043a \u043f\u0440\u043e \u0437\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f \u0434\u043e \u0441\u0432\u043e\u0433\u043e \u0441\u0435\u0440\u0442\u0438\u0444\u0456\u043a\u0430\u0442\u0443?"
  },
  "order_add_fback": {
    "sheet_name": "Web",
    "en": "Add feedback",
    "ru": "\u0414\u043e\u0431\u0430\u0432\u0438\u0442\u044c \u043e\u0442\u0437\u044b\u0432",
    "fi": "Lis\u00e4\u00e4 palaute",
    "sv": "Tack, uppskattar feedback!",
    "fa": "\u0628\u0627\u0632\u062e\u0648\u0631\u062f \u0631\u0627 \u0627\u0636\u0627\u0641\u0647 \u06a9\u0646\u06cc\u062f",
    "ar": "\u0625\u0636\u0627\u0641\u0629 \u062a\u0639\u0644\u064a\u0642\u0627\u062a",
    "uk": "\u0414\u043e\u0434\u0430\u0442\u0438 \u0432\u0456\u0434\u0433\u0443\u043a"
  },
  "order_cert_downl": {
    "sheet_name": "Web",
    "en": "Download certificate",
    "ru": "\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044c \u043c\u043e\u0439 \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043a\u0430\u0442",
    "fi": "Lataa todistus",
    "sv": "Ladda ner certifikat",
    "fa": "\u06af\u0648\u0627\u0647\u06cc\u0646\u0627\u0645\u0647 \u0645\u0646 \u0631\u0627 \u062f\u0627\u0646\u0644\u0648\u062f \u06a9\u0646\u06cc\u062f",
    "ar": "\u062a\u062d\u0645\u064a\u0644 \u0627\u0644\u0634\u0647\u0627\u062f\u0629",
    "uk": "\u0417\u0430\u0432\u0430\u043d\u0442\u0430\u0436\u0438\u0442\u0438 \u0441\u0435\u0440\u0442\u0438\u0444\u0456\u043a\u0430\u0442"
  },
  "order_apply_confirm": {
    "sheet_name": "Web",
    "en": "Are you sure you want to apply for this?",
    "ru": "\u0412\u044b \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043b\u044c\u043d\u043e \u0445\u043e\u0442\u0438\u0442\u0435 \u043f\u043e\u0434\u0430\u0442\u044c \u0437\u0430\u044f\u0432\u043a\u0443 \u043d\u0430 \u0432\u044b\u043f\u043e\u043b\u043d\u0435\u043d\u0438\u0435 \u044d\u0442\u043e\u0439 \u0440\u0430\u0431\u043e\u0442\u044b \u0438 \u0432\u044b\u043f\u043e\u043b\u043d\u0438\u0442\u044c \u0435\u0435, \u0435\u0441\u043b\u0438 \u0432\u044b \u0431\u0443\u0434\u0435\u0442\u0435 \u0432\u044b\u0431\u0440\u0430\u043d\u044b?",
    "fi": "Haluatko varmasti hakea t\u00e4h\u00e4n?",
    "sv": "\u00c4r du s\u00e4ker att du vill s\u00f6ka jobbet?",
    "fa": "\u0622\u06cc\u0627 \u0645\u0637\u0645\u0626\u0646 \u0647\u0633\u062a\u06cc\u062f \u06a9\u0647 \u0645\u06cc \u062e\u0648\u0627\u0647\u06cc\u062f \u0627\u06cc\u0646 \u06a9\u0627\u0631 \u0631\u0627 \u062f\u0631\u062e\u0648\u0627\u0633\u062a \u06a9\u0646\u06cc\u062f \u0648 \u062f\u0631 \u0635\u0648\u0631\u062a \u0627\u0646\u062a\u062e\u0627\u0628 \u0622\u0645\u0627\u062f\u0647 \u0627\u0646\u062c\u0627\u0645 \u0627\u06cc\u0646 \u06a9\u0627\u0631 \u0628\u0627\u0634\u06cc\u062f\u061f",
    "ar": "\u0647\u0644 \u0627\u0646\u062a \u0645\u062a\u0623\u0643\u062f \u0645\u0646 \u0631\u063a\u0628\u062a\u0643 \u0641\u064a \u0627\u0644\u062a\u0642\u062f\u0645 \u0644\u0647\u0630\u0647 \u0627\u0644\u0645\u0647\u0645\u0629 \u0648\u0627\u0644\u0627\u0644\u062a\u0632\u0627\u0645 \u061f",
    "uk": "\u0412\u0438 \u0432\u043f\u0435\u0432\u043d\u0435\u043d\u0456, \u0449\u043e \u0445\u043e\u0447\u0435\u0442\u0435 \u043f\u043e\u0434\u0430\u0442\u0438 \u0437\u0430\u044f\u0432\u043a\u0443 \u043d\u0430 \u0446\u0435 \u0437\u0430\u0432\u0434\u0430\u043d\u043d\u044f?"
  },
  "order_apply_without_application": {
    "sheet_name": "Web",
    "en": "Do you want to apply without writing application?",
    "ru": "",
    "fi": "Haluatko hakea ilman ett\u00e4 kirjoitat hakemusta?",
    "sv": "Vill du ans\u00f6ka utan att skriva ans\u00f6kan?",
    "fa": "",
    "ar": "",
    "uk": "\u0425\u043e\u0447\u0435\u0442\u0435 \u043f\u043e\u0434\u0430\u0442\u0438 \u0437\u0430\u044f\u0432\u0443 \u0431\u0435\u0437 \u043d\u0430\u043f\u0438\u0441\u0430\u043d\u043d\u044f \u0437\u0430\u044f\u0432\u0438?"
  },
  "order_get_paym_det": {
    "sheet_name": "Web",
    "en": "Get payment details",
    "ru": "\u041f\u043e\u043b\u0443\u0447\u0438\u0442\u044c \u043f\u043b\u0430\u0442\u0435\u0436\u043d\u044b\u0435 \u0440\u0435\u043a\u0432\u0438\u0437\u0438\u0442\u044b",
    "fi": "Avaa maksutiedot",
    "sv": "F\u00e5 betalnings detaljer",
    "fa": "\u062c\u0632\u0626\u06cc\u0627\u062a \u067e\u0631\u062f\u0627\u062e\u062a \u0631\u0627 \u062f\u0631\u06cc\u0627\u0641\u062a \u06a9\u0646\u06cc\u062f",
    "ar": "\u0627\u062d\u0635\u0644 \u0639\u0644\u0649 \u062a\u0641\u0627\u0635\u064a\u0644 \u0627\u0644\u062f\u0641\u0639",
    "uk": "\u041e\u0442\u0440\u0438\u043c\u0430\u0442\u0438 \u0440\u0435\u043a\u0432\u0456\u0437\u0438\u0442\u0438 \u0434\u043b\u044f \u043e\u043f\u043b\u0430\u0442\u0438"
  },
  "receipt_init_time": {
    "sheet_name": "Web",
    "en": "Initial time:",
    "ru": "\u041d\u0430\u0447\u0430\u043b\u044c\u043d\u043e\u0435 \u0432\u0440\u0435\u043c\u044f",
    "fi": "Ajoitus:",
    "sv": "Ursprunglig tid:",
    "fa": "\u0632\u0645\u0627\u0646 \u0627\u0635\u0644\u06cc:",
    "ar": "\u0627\u0644\u0648\u0642\u062a \u0627\u0644\u0645\u0637\u0644\u0648\u0628:",
    "uk": "\u041f\u043e\u0447\u0430\u0442\u043a\u043e\u0432\u0438\u0439 \u0447\u0430\u0441:"
  },
  "order_label_published": {
    "sheet_name": "Web",
    "en": "Order published",
    "ru": "\u041e\u043f\u0443\u0431\u043b\u0438\u043a\u043e\u0432\u0430\u043d \u0437\u0430\u043a\u0430\u0437",
    "fi": "Tilaus julkaistu",
    "sv": "Uppdrag \u00e4r publicerad",
    "fa": "\u0633\u0641\u0627\u0631\u0634 \u0645\u0646\u062a\u0634\u0631 \u0634\u062f",
    "ar": "\u062a\u0645 \u0646\u0634\u0631 \u0627\u0644\u0637\u0644\u0628",
    "uk": "\u0417\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f \u043e\u043f\u0443\u0431\u043b\u0456\u043a\u043e\u0432\u0430\u043d\u043e"
  },
  "order_worker_comms": {
    "sheet_name": "Web",
    "en": "Worker comments",
    "ru": "\u041a\u043e\u043c\u043c\u0435\u043d\u0442\u0430\u0440\u0438\u0438 \u0440\u0430\u0431\u043e\u0442\u043d\u0438\u043a\u0430:",
    "fi": "Tekij\u00e4n kommentit:",
    "sv": "Utf\u00f6rarens kommentarer:",
    "fa": "\u0646\u0638\u0631\u06cc\u0627\u062a \u06a9\u0627\u0631\u0645\u0646\u062f",
    "ar": "\u062a\u0639\u0644\u064a\u0642\u0627\u062a \u0627\u0644\u0639\u0627\u0645\u0644:",
    "uk": "\u041a\u043e\u043c\u0435\u043d\u0442\u0430\u0440\u0456 \u043f\u0440\u0430\u0446\u0456\u0432\u043d\u0438\u043a\u0456\u0432"
  },
  "order_completed_txt": {
    "sheet_name": "Web",
    "en": "Completed",
    "ru": "\u0413\u043e\u0442\u043e\u0432\u043e",
    "fi": "Valmistunut",
    "sv": "Avslutad",
    "fa": "\u062a\u06a9\u0645\u06cc\u0644 \u0634\u062f",
    "ar": "\u0645\u0646\u062c\u0632",
    "uk": "\u0412\u0438\u043a\u043e\u043d\u0430\u043d\u043e"
  },
  "order_hide_user": {
    "sheet_name": "Web",
    "en": "Hide worker",
    "ru": "\u0421\u043a\u0440\u044b\u0442\u044c \u043f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u0435\u043b\u044f",
    "fi": "Piilota hakija",
    "sv": "D\u00f6lj anv\u00e4ndare",
    "fa": "\u06a9\u0627\u0631\u06af\u0631 \u0631\u0627 \u0645\u062e\u0641\u06cc \u06a9\u0646\u06cc\u062f",
    "ar": "\u0627\u062e\u0641\u064a \u0627\u0644\u0639\u0627\u0645\u0644",
    "uk": "\u0421\u0445\u043e\u0432\u0430\u0442\u0438 \u043f\u0440\u0430\u0446\u0456\u0432\u043d\u0438\u043a\u0430"
  },
  "order_copied_link": {
    "sheet_name": "Web",
    "en": "Copied successfully!",
    "ru": "\u0421\u0441\u044b\u043b\u043a\u0430 \u0441\u043a\u043e\u043f\u0438\u0440\u043e\u0432\u0430\u043d\u0430",
    "fi": "Kopiointi onnistui!",
    "sv": "Kopierad framg\u00e5ngsrikt!",
    "fa": "\u0628\u0627 \u0645\u0648\u0641\u0642\u06cc\u062a \u06a9\u067e\u06cc \u0634\u062f!",
    "ar": "\u062a\u0645 \u0627\u0644\u0646\u0633\u062e \u0628\u0646\u062c\u0627\u062d!",
    "uk": "\u0423\u0441\u043f\u0456\u0448\u043d\u043e \u0441\u043a\u043e\u043f\u0456\u0439\u043e\u0432\u0430\u043d\u043e!"
  },
  "order_hide_user_content": {
    "sheet_name": "Web",
    "en": "Do you want to hide this applicant?",
    "ru": "\u0425\u043e\u0442\u0438\u0442\u0435 \u043b\u0438 \u0432\u044b \u0441\u043a\u0440\u044b\u0442\u044c \u044d\u0442\u043e\u0433\u043e \u043f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u0435\u043b\u044f",
    "fi": "Haluatko piilottaa t\u00e4m\u00e4n hakijan",
    "sv": "Vill du d\u00f6lja den h\u00e4r s\u00f6kanden?",
    "fa": "\u0622\u06cc\u0627 \u0645\u06cc \u062e\u0648\u0627\u0647\u06cc\u062f \u0627\u06cc\u0646 \u0645\u062a\u0642\u0627\u0636\u06cc \u0631\u0627 \u0645\u062e\u0641\u06cc \u06a9\u0646\u06cc\u062f\u061f",
    "ar": "\u0647\u0644 \u062a\u0631\u064a\u062f \u0625\u062e\u0641\u0627\u0621 \u0647\u0630\u0627 \u0627\u0644\u0645\u062a\u0642\u062f\u0645\u061f",
    "uk": "\u0412\u0438 \u0445\u043e\u0447\u0435\u0442\u0435 \u043f\u0440\u0438\u0445\u043e\u0432\u0430\u0442\u0438 \u0446\u044c\u043e\u0433\u043e \u043a\u0430\u043d\u0434\u0438\u0434\u0430\u0442\u0430?"
  },
  "order_select_appl": {
    "sheet_name": "Web",
    "en": "Select applicant",
    "ru": "\u0412\u044b\u0431\u0435\u0440\u0435\u0442\u0435 \u043f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u0435\u043b\u044f",
    "fi": "Valitse hakija",
    "sv": "V\u00e4lj s\u00f6kande",
    "fa": "\u0645\u062a\u0642\u0627\u0636\u06cc \u0631\u0627 \u0627\u0646\u062a\u062e\u0627\u0628 \u06a9\u0646\u06cc\u062f",
    "ar": "\u062d\u062f\u062f \u0645\u0642\u062f\u0645 \u0627\u0644\u0637\u0644\u0628",
    "uk": "\u0412\u0438\u0431\u0440\u0430\u0442\u0438 \u043a\u0430\u043d\u0434\u0438\u0434\u0430\u0442\u0430"
  },
  "order_successfull_worker_selection": {
    "sheet_name": "Web",
    "en": "Worker successfully selected",
    "ru": "",
    "fi": "Tekij\u00e4n valinta onnistui",
    "sv": "Utf\u00f6rare vald framg\u00e5ngsrikt",
    "fa": "",
    "ar": "",
    "uk": "\u0420\u043e\u0431\u0456\u0442\u043d\u0438\u043a \u0443\u0441\u043f\u0456\u0448\u043d\u043e \u043f\u0456\u0434\u0456\u0431\u0440\u0430\u043d\u0438\u0439"
  },
  "order_show_hworkers": {
    "sheet_name": "Web",
    "en": "Show hidden applicants",
    "ru": "\u041f\u043e\u043a\u0430\u0437\u0430\u0442\u044c \u0441\u043a\u0440\u044b\u0442\u044b\u0445 \u043f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u0435\u043b\u0435\u0439",
    "fi": "N\u00e4yt\u00e4 piilotetut hakijat",
    "sv": "Visa dolda s\u00f6kanden",
    "fa": "\u0645\u062a\u0642\u0627\u0636\u06cc\u0627\u0646 \u0645\u062e\u0641\u06cc \u0646\u0634\u0627\u0646 \u062f\u0647\u06cc\u062f",
    "ar": "\u0625\u0638\u0647\u0627\u0631 \u0627\u0644\u0645\u062a\u0642\u062f\u0645\u064a\u0646 \u0627\u0644\u0645\u062e\u0641\u064a\u064a\u0646",
    "uk": "\u041f\u043e\u043a\u0430\u0437\u0430\u0442\u0438 \u043f\u0440\u0438\u0445\u043e\u0432\u0430\u043d\u0438\u0445 \u043a\u0430\u043d\u0434\u0438\u0434\u0430\u0442\u0456\u0432"
  },
  "order_hide_hworkers": {
    "sheet_name": "Web",
    "en": "Hide hidden applicants",
    "ru": "\u0421\u043a\u0440\u044b\u0442\u044c \u0441\u043a\u0440\u044b\u0442\u044b\u0445 \u043f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u0435\u043b\u0435\u0439",
    "fi": "Piilota uudelleen",
    "sv": "G\u00f6m dolda s\u00f6kanden",
    "fa": "\u0645\u062a\u0642\u0627\u0636\u06cc\u0627\u0646 \u0645\u062e\u0641\u06cc \u0631\u0627 \u0645\u062e\u0641\u06cc \u06a9\u0646\u06cc\u062f",
    "ar": "\u0625\u062e\u0641\u0627\u0621 \u0627\u0644\u0645\u062a\u0642\u062f\u0645\u064a\u0646 \u0627\u0644\u0645\u062e\u0641\u064a\u064a\u0646",
    "uk": "\u041f\u0440\u0438\u0445\u043e\u0432\u0430\u0442\u0438 \u043f\u0440\u0438\u0445\u043e\u0432\u0430\u043d\u0438\u0445 \u043a\u0430\u043d\u0434\u0438\u0434\u0430\u0442\u0456\u0432"
  },
  "orders_is_virtual": {
    "sheet_name": "Web",
    "en": "Distance work",
    "ru": "\u0420\u0430\u0431\u043e\u0442\u0430 \u043d\u0430 \u0434\u043e\u043c\u0443",
    "fi": "Et\u00e4ty\u00f6",
    "sv": "Distansarbete",
    "fa": "\u06a9\u0627\u0631 \u0627\u0632 \u0631\u0627\u0647 \u062f\u0648\u0631",
    "ar": "\u0627\u0644\u0639\u0645\u0644 \u0639\u0646 \u0628\u0639\u062f",
    "uk": "\u0414\u0438\u0441\u0442\u0430\u043d\u0446\u0456\u0439\u043d\u0430 \u0440\u043e\u0431\u043e\u0442\u0430"
  },
  "orders_is_virtual_cbox": {
    "sheet_name": "Web",
    "en": "Distance work (sent to workers in all locations)",
    "ru": "\u0420\u0430\u0431\u043e\u0442\u0430 \u043d\u0430 \u0434\u043e\u043c\u0443 ( \u043f\u043e\u043a\u0430\u0437\u044b\u0432\u0430\u0442\u044c \u0440\u0430\u0431\u043e\u0442\u043d\u0438\u043a\u0443 \u0432\u0441\u0435 \u0440\u0430\u0439\u043e\u043d\u044b )",
    "fi": "Et\u00e4ty\u00f6 (n\u00e4kyy tekij\u00f6ille kaikilla alueilla)",
    "sv": "Distansarbete (skickas till arbetare p\u00e5 alla platser)",
    "fa": "\u06a9\u0627\u0631 \u0627\u0632 \u0631\u0627\u0647 \u062f\u0648\u0631 (\u0627\u0631\u0633\u0627\u0644 \u0634\u062f\u0647 \u0628\u0647 \u06a9\u0627\u0631\u06af\u0631\u0627\u0646 \u062f\u0631 \u0647\u0645\u0647 \u0645\u06a9\u0627\u0646 \u0647\u0627)",
    "ar": "\u0627\u0644\u0639\u0645\u0644 \u0639\u0646 \u0628\u0639\u062f (\u064a\u0631\u0633\u0644 \u0625\u0644\u0649 \u0627\u0644\u0639\u0645\u0627\u0644 \u0641\u064a \u062c\u0645\u064a\u0639 \u0627\u0644\u0645\u0648\u0627\u0642\u0639)",
    "uk": "\u0414\u0438\u0441\u0442\u0430\u043d\u0446\u0456\u0439\u043d\u0430 \u0440\u043e\u0431\u043e\u0442\u0430 (\u043d\u0430\u0434\u0441\u0438\u043b\u0430\u0454\u0442\u044c\u0441\u044f \u043f\u0440\u0430\u0446\u0456\u0432\u043d\u0438\u043a\u0430\u043c \u0443 \u0432\u0441\u0456\u0445 \u043d\u0430\u0441\u0435\u043b\u0435\u043d\u0438\u0445 \u043f\u0443\u043d\u043a\u0442\u0430\u0445)"
  },
  "order_unhide_user": {
    "sheet_name": "Web",
    "en": "Unhide worker",
    "ru": "\u0421\u043a\u0440\u044b\u0442\u044c \u043f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u0435\u043b\u044f",
    "fi": "Palauta hakija",
    "sv": "Ta fram s\u00f6kande",
    "fa": "\u0645\u062a\u0642\u0627\u0636\u06cc \u0627\u0632 \u062d\u0627\u0644\u062a \u0645\u062e\u0641\u06cc \u062e\u0627\u0631\u062c \u06a9\u0646\u06cc\u062f",
    "ar": "\u0625\u0638\u0647\u0627\u0631 \u0645\u0642\u062f\u0645 \u0627\u0644\u0637\u0644\u0628",
    "uk": "\u041f\u0440\u0438\u0445\u043e\u0432\u0430\u0442\u0438 \u043a\u043e\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430"
  },
  "order_unhide_user_content": {
    "sheet_name": "Web",
    "en": "Do you want to unhide this applicant?",
    "ru": "\u0425\u043e\u0442\u0438\u0442\u0435 \u043b\u0438 \u0432\u044b \u043f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u0435\u043b\u044f \u043e\u0431\u0440\u0430\u0442\u043d\u043e \u043d\u0430 \u044d\u043a\u0440\u0430\u043d",
    "fi": "Haluatko hakijan takaisin n\u00e4kyville?",
    "sv": "Vill du ta fram den dolda s\u00f6kande?",
    "fa": "\u0622\u06cc\u0627 \u0645\u06cc \u062e\u0648\u0627\u0647\u06cc\u062f \u0627\u06cc\u0646 \u0645\u062a\u0642\u0627\u0636\u06cc \u0631\u0627 \u0627\u0632 \u062d\u0627\u0644\u062a \u0645\u062e\u0641\u06cc \u062e\u0627\u0631\u062c \u06a9\u0646\u06cc\u062f\u061f",
    "ar": "\u0647\u0644 \u062a\u0631\u064a\u062f \u0625\u0638\u0647\u0627\u0631 \u0647\u0630\u0627 \u0627\u0644\u0645\u062a\u0642\u062f\u0645\u061f",
    "uk": "\u0412\u0438 \u0445\u043e\u0447\u0435\u0442\u0435 \u0431\u0430\u0447\u0438\u0442\u0438 \u043a\u0430\u043d\u0434\u0438\u0434\u0430\u0442\u0430  \u0437\u043d\u043e\u0432\u0443?"
  },
  "label_order": {
    "sheet_name": "Web",
    "en": "Order",
    "ru": "\u0417\u0430\u043a\u0430\u0437",
    "fi": "Tilaus",
    "sv": "Best\u00e4llning",
    "fa": "\u0633\u0641\u0627\u0631\u0634",
    "ar": "\u0637\u0644\u0628",
    "uk": "\u0417\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f"
  },
  "order_label_edit": {
    "sheet_name": "Web",
    "en": "Editing",
    "ru": "\u0418\u0437\u043c\u0435\u043d\u0438\u0442\u044c \u0437\u0430\u043a\u0430\u0437",
    "fi": "Muokkaustila",
    "sv": "Redigering",
    "fa": "\u0633\u0641\u0627\u0631\u0634 \u0631\u0627 \u062f\u0633\u062a \u06a9\u0627\u0631\u06cc \u06a9\u0646\u06cc\u062f",
    "ar": "\u062a\u062d\u0631\u064a\u0631 \u0627\u0644\u0637\u0644\u0628",
    "uk": "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438 \u0437\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f"
  },
  "order_label_copy": {
    "sheet_name": "Web",
    "en": "Copying",
    "ru": "\u041a\u043e\u043f\u0438\u0440\u043e\u0432\u0430\u0442\u044c \u0437\u0430\u043a\u0430\u0437",
    "fi": "Kopiointitila",
    "sv": "Kopiering",
    "fa": "\u06a9\u0627\u067e\u06cc \u0633\u0641\u0627\u0631\u0634",
    "ar": "\u0646\u0633\u062e \u0627\u0644\u0637\u0644\u0628",
    "uk": "\u041a\u043e\u043f\u0456\u044e\u0432\u0430\u0442\u0438 \u0437\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f"
  },
  "order_edit_back": {
    "sheet_name": "Web",
    "en": "Back to original",
    "ru": "",
    "fi": "Takaisin alkuper\u00e4iseen",
    "sv": "Tillbaka till orginalorder",
    "fa": "",
    "ar": "",
    "uk": "\u041f\u043e\u0432\u0435\u0440\u043d\u0443\u0442\u0438\u0441\u044f \u0434\u043e \u043e\u0440\u0438\u0433\u0456\u043d\u0430\u043b\u0443"
  },
  "order_acc_ref": {
    "sheet_name": "Web",
    "en": "Account reference",
    "ru": "\u0411\u0443\u0445\u0433\u0430\u043b\u0442\u0435\u0440\u0441\u043a\u0430\u044f \u0441\u043f\u0440\u0430\u0432\u043a\u0430",
    "fi": "Kirjanpidon viite",
    "sv": "Kontoh\u00e4nvisning",
    "fa": "\u062a\u0623\u06cc\u06cc\u062f \u0627\u0639\u062a\u0628\u0627\u0631",
    "ar": "",
    "uk": "\u0420\u0435\u043a\u0432\u0456\u0437\u0438\u0442\u0438 \u0440\u0430\u0445\u0443\u043d\u043a\u0443"
  },
  "txt_no": {
    "sheet_name": "Web",
    "en": "No",
    "ru": "\u041d\u0435\u0442",
    "fi": "Ei",
    "sv": "Nej",
    "fa": "\u0646\u062e\u06cc\u0631",
    "ar": "",
    "uk": "\u041d\u0456"
  },
  "order_copy_worker": {
    "sheet_name": "Web",
    "en": "The copy of this order will be directly assigned to %s. Otherwise worker will not be copied.",
    "ru": "",
    "fi": "T\u00e4m\u00e4n tilauksen kopio kohdistetaan suoraan tekij\u00e4lle %s. Valitsemalla 'ei' tekij\u00e4\u00e4 ei kopioida.",
    "sv": "Kopiera \u00e4ven arbetaren?",
    "fa": "",
    "ar": "",
    "uk": "\u041a\u043e\u043f\u0456\u044f \u0446\u044c\u043e\u0433\u043e \u043d\u0430\u043a\u0430\u0437\u0443 \u0431\u0443\u0434\u0435 \u0431\u0435\u0437\u043f\u043e\u0441\u0435\u0440\u0435\u0434\u043d\u044c\u043e \u043f\u0440\u0438\u0437\u043d\u0430\u0447\u0435\u043d\u0430 %s. \u0412 \u0456\u043d\u0448\u043e\u043c\u0443 \u0432\u0438\u043f\u0430\u0434\u043a\u0443 \u043f\u0440\u0430\u0446\u0456\u0432\u043d\u0438\u043a \u043d\u0435 \u0431\u0443\u0434\u0435 \u0441\u043a\u043e\u043f\u0456\u0439\u043e\u0432\u0430\u043d\u0438\u0439"
  },
  "order_worker_team_invalid": {
    "sheet_name": "Web",
    "en": "The worker is not in the selected team(s).",
    "ru": "",
    "fi": "Tekij\u00e4 ei ole valitussa ryhm\u00e4ss\u00e4",
    "sv": "Utf\u00f6raren tillh\u00f6r inte den valda gruppen\/grupperna.",
    "fa": "",
    "ar": "",
    "uk": "\u041f\u0440\u0430\u0446\u0456\u0432\u043d\u0438\u043a \u043d\u0435 \u0432\u0445\u043e\u0434\u0438\u0442\u044c \u0434\u043e \u043e\u0431\u0440\u0430\u043d\u043e\u0457 \u043a\u043e\u043c\u0430\u043d\u0434\u0438 (\u043a\u043e\u043c\u0430\u043d\u0434)."
  },
  "order_copy_simple": {
    "sheet_name": "Web",
    "en": "Copy order",
    "ru": "\u041a\u043e\u043f\u0438\u0440\u043e\u0432\u0430\u0442\u044c \u0437\u0430\u043a\u0430\u0437",
    "fi": "Kopioi tilaus",
    "sv": "Kopia uppdraget",
    "fa": "\u06a9\u0627\u067e\u06cc \u0633\u0641\u0627\u0631\u0634",
    "ar": "\u0646\u0633\u062e \u0627\u0644\u0637\u0644\u0628",
    "uk": "\u041a\u043e\u043f\u0456\u044e\u0432\u0430\u0442\u0438 \u0437\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f"
  },
  "order_details_not_apprv": {
    "sheet_name": "Web",
    "en": "You have marked this as not approved. Please ensure worker knows the reasons",
    "ru": "",
    "fi": "Et hyv\u00e4ksynyt suoritusta- varmistathan ett\u00e4 tekij\u00e4 tiet\u00e4\u00e4 syyn",
    "sv": "Du har inte godk\u00e4nt uppgiften.",
    "fa": "",
    "ar": "",
    "uk": "\u0412\u0438 \u043d\u0435 \u0437\u0430\u0442\u0432\u0435\u0440\u0434\u0438\u043b\u0438 \u0437\u0430\u0432\u0434\u0430\u043d\u043d\u044f. \u0411\u0443\u0434\u044c \u043b\u0430\u0441\u043a\u0430, \u043f\u0435\u0440\u0435\u043a\u043e\u043d\u0430\u0439\u0442\u0435\u0441\u044f, \u0449\u043e \u043f\u0440\u0430\u0446\u0456\u0432\u043d\u0438\u043a \u0437\u043d\u0430\u0454 \u043f\u0440\u0438\u0447\u0438\u043d\u0438"
  },
  "order_list_message_cancel": {
    "sheet_name": "Web",
    "en": "Cancelled successfully!",
    "ru": "\u041e\u0442\u043c\u0435\u043d\u0435\u043d\u043e",
    "fi": "Peruutus onnistui",
    "sv": "Annulerad!",
    "fa": "\u0644\u063a\u0648 \u0634\u062f",
    "ar": "\u062a\u0645 \u0627\u0644\u0625\u0644\u063a\u0627\u0621 \u0628\u0648\u0627\u0633\u0637\u0629",
    "uk": "\u0423\u0441\u043f\u0456\u0448\u043d\u043e \u0441\u043a\u0430\u0441\u043e\u0432\u0430\u043d\u043e"
  },
  "order_list_message_complete": {
    "sheet_name": "Web",
    "en": "Completed successfully!",
    "ru": "\u0432\u044b\u043f\u043e\u043b\u043d\u0435\u043d\u0430, \u0436\u0434\u0435\u0442 \u043e\u0434\u043e\u0431\u0440\u0435\u043d\u0438\u044f \u0437\u0430\u043a\u0430\u0437\u0447\u0438\u043a\u0430",
    "fi": "Valmistunut",
    "sv": "Avslutad!",
    "fa": "\u062a\u062d\u0648\u06cc\u0644 \u062f\u0627\u062f\u0647 \u0634\u062f\u0647 \u060c \u0645\u0646\u062a\u0638\u0631 \u062a\u0623\u06cc\u06cc\u062f\u06cc \u06a9\u0627\u0631\u0641\u0631\u0645\u0627 \u0628\u0627\u0634\u06cc\u062f",
    "ar": "\u0627\u0643\u0645\u0644\u062a , \u0627\u0646\u062a\u0638\u0627\u0631 \u0645\u0648\u0627\u0641\u0642\u062a \u0627\u0644\u0645\u0633\u0624\u0648\u0644",
    "uk": "\u0412\u0438\u043a\u043e\u043d\u0430\u043d\u043e"
  },
  "order_list_message_apply": {
    "sheet_name": "Web",
    "en": "You have applied succesfully",
    "ru": "\u0412\u044b \u043f\u043e\u0434\u0430\u043b\u0438 \u0437\u0430\u044f\u0432\u043a\u0443 \u043d\u0430 \u0440\u0430\u0431\u043e\u0442\u0443, \u0432\u044b \u0431\u0443\u0434\u0435\u0442\u0435 \u0443\u0432\u0435\u0434\u043e\u043c\u043b\u0435\u043d\u044b, \u0435\u0441\u043b\u0438 \u0432\u044b \u0432\u044b\u0431\u0440\u0430\u043d\u044b.",
    "fi": "Hait teht\u00e4v\u00e4\u00e4n onnistuneesti",
    "sv": "Du har s\u00f6kt uppdraget!",
    "fa": "\u0634\u0645\u0627 \u0628\u0631\u0627\u06cc \u0627\u06cc\u0646 \u06a9\u0627\u0631 \u062f\u0631\u062e\u0648\u0627\u0633\u062a \u06a9\u0631\u062f\u0647 \u0627\u06cc\u062f \u060c \u0627\u06af\u0631 \u0627\u0646\u062a\u062e\u0627\u0628 \u0634\u062f\u0647 \u0628\u0627\u0634\u06cc\u062f \u0628\u0647 \u0634\u0645\u0627 \u0627\u0637\u0644\u0627\u0639 \u062f\u0627\u062f\u0647 \u0645\u06cc \u0634\u0648\u062f",
    "ar": "\u0644\u0642\u062f \u062a\u0642\u062f\u0645\u062a \u0628\u0637\u0644\u0628 \u0644\u0644\u0648\u0638\u064a\u0641\u0629 ,\u0633\u064a\u062a\u0645 \u0625\u0639\u0644\u0627\u0645\u0643 \u0641\u064a \u062d\u0627\u0644 \u062a\u0645 \u0625\u062e\u062a\u064a\u0627\u0631\u0643",
    "uk": "\u0412\u0438 \u0443\u0441\u043f\u0456\u0448\u043d\u043e \u043f\u043e\u0434\u0430\u043b\u0438 \u0437\u0430\u044f\u0432\u043a\u0443 \u043d\u0430 \u0432\u0438\u043a\u043e\u043d\u0430\u043d\u043d\u044f \u0437\u0430\u0432\u0434\u0430\u043d\u043d\u044f"
  },
  "order_list_message_approve": {
    "sheet_name": "Web",
    "en": "You have approved task successfully!",
    "ru": "",
    "fi": "Olet hyv\u00e4ksynyt suorituksen onnistuneesti",
    "sv": "Du har godk\u00e4nnt uppdraget!",
    "fa": "",
    "ar": "",
    "uk": "\u0412\u0438 \u0443\u0441\u043f\u0456\u0448\u043d\u043e \u0432\u043f\u043e\u0440\u0430\u043b\u0438\u0441\u044f \u0456\u0437 \u0437\u0430\u0432\u0434\u0430\u043d\u043d\u044f\u043c!"
  },
  "order_new_time_error_increment": {
    "sheet_name": "Web",
    "en": "The amount must be in increments of .5 (x.0 or x.5).",
    "ru": "",
    "fi": "Summa pit\u00e4\u00e4 sy\u00f6tt\u00e4\u00e4 0,50 tarkkuudella (x,00 tai x,50)",
    "sv": "Beloppet beh\u00f6ver vara i steg om .5 (x.0 or x.5).",
    "fa": "",
    "ar": "",
    "uk": "\u0421\u0443\u043c\u0430 \u043f\u043e\u0432\u0438\u043d\u043d\u0430 \u0431\u0443\u0442\u0438 \u0432\u043a\u0430\u0437\u0430\u043d\u0430 \u0437 \u043a\u0440\u043e\u043a\u043e\u043c 0,5 (x.0 \u0430\u0431\u043e x.5)."
  },
  "order_new_time_error_minimum": {
    "sheet_name": "Web",
    "en": "Invalid value! The minimum value is %s.",
    "ru": "",
    "fi": "Minimi arvo on %s.",
    "sv": "Ogiltigt v\u00e4rde! Minimiv\u00e4rdet \u00e4r %s.",
    "fa": "",
    "ar": "",
    "uk": "\u041d\u0435\u0432\u0456\u0440\u043d\u0435 \u0437\u043d\u0430\u0447\u0435\u043d\u043d\u044f! \u041c\u0456\u043d\u0456\u043c\u0430\u043b\u044c\u043d\u0435 \u0437\u043d\u0430\u0447\u0435\u043d\u043d\u044f - %s."
  },
  "order_details_pay_now": {
    "sheet_name": "Web",
    "en": "Pay now",
    "ru": "",
    "fi": "Maksa nyt",
    "sv": "Betala nu",
    "fa": "",
    "ar": "",
    "uk": "\u041f\u043b\u0430\u0442\u0438\u0442\u0438 \u0437\u0430\u0440\u0430\u0437"
  },
  "order_details_pay_now_dialog": {
    "sheet_name": "Web",
    "en": "Are you sure to pay now?",
    "ru": "",
    "fi": "Oletko varma ett\u00e4 maksat nyt?",
    "sv": "\u00c4r du s\u00e4ker p\u00e5 att du vill betala nu?",
    "fa": "",
    "ar": "",
    "uk": "\u0412\u0438 \u0432\u043f\u0435\u0432\u043d\u0435\u043d\u0456, \u0449\u043e \u0445\u043e\u0447\u0435\u0442\u0435 \u043f\u043b\u0430\u0442\u0438\u0442\u0438 \u0437\u0430\u0440\u0430\u0437?"
  },
  "order_details_pay_label": {
    "sheet_name": "Web",
    "en": "Pay",
    "ru": "",
    "fi": "Maksa",
    "sv": "Betala",
    "fa": "",
    "ar": "",
    "uk": "\u041f\u043b\u0430\u0442\u0438\u0442\u0438"
  },
  "order_details_duration_info": {
    "sheet_name": "Web",
    "en": "If the task duration changed, report the actual time\/units worked. If you modify this from original order, please add an explanation of the reason and details for the change (e.g. correct date and from\/to hours)",
    "ru": "",
    "fi": "Jos teht\u00e4v\u00e4n kesto muuttui niin korjaa silloin kesto t\u00e4h\u00e4n. Jos muutat alkuper\u00e4isen tilauksen ty\u00f6skentelyaikaa\/yksik\u00f6it\u00e4, lis\u00e4\u00e4 selitys muutoksen syyst\u00e4 ja yksityiskohdat (esim. oikea p\u00e4iv\u00e4m\u00e4\u00e4r\u00e4 ja kellonajat)",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0411\u0443\u0434\u044c \u043b\u0430\u0441\u043a\u0430, \u043f\u043e\u0432\u0456\u0434\u043e\u043c\u0442\u0435 \u043f\u0440\u043e \u0444\u0430\u043a\u0442\u0438\u0447\u043d\u043e \u0432\u0456\u0434\u043f\u0440\u0430\u0446\u044c\u043e\u0432\u0430\u043d\u0438\u0439 \u0447\u0430\u0441\/\u043e\u0434\u0438\u043d\u0438\u0446\u0456. \u042f\u043a\u0449\u043e \u0432\u0438 \u0437\u043c\u0456\u043d\u044e\u0454\u0442\u0435 \u0446\u0435 \u0432 \u043f\u043e\u0440\u0456\u0432\u043d\u044f\u043d\u043d\u0456 \u0437 \u043f\u043e\u0447\u0430\u0442\u043a\u043e\u0432\u0438\u043c \u0437\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f\u043c, \u0431\u0443\u0434\u044c \u043b\u0430\u0441\u043a\u0430, \u0434\u043e\u0434\u0430\u0439\u0442\u0435 \u043f\u043e\u044f\u0441\u043d\u0435\u043d\u043d\u044f \u043f\u0440\u0438\u0447\u0438\u043d\u0438 \u0442\u0430 \u0434\u0435\u0442\u0430\u043b\u0456 \u0437\u043c\u0456\u043d\u0438 (\u043d\u0430\u043f\u0440\u0438\u043a\u043b\u0430\u0434, \u043f\u0440\u0430\u0432\u0438\u043b\u044c\u043d\u0443 \u0434\u0430\u0442\u0443 \u0442\u0430 \u0447\u0430\u0441 \u0437\/\u0434\u043e \u0433\u043e\u0434\u0438\u043d\u0438)"
  },
  "order_details_duration_label": {
    "sheet_name": "Web",
    "en": "Duration",
    "ru": "",
    "fi": "Kesto",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0422\u0440\u0438\u0432\u0430\u043b\u0456\u0441\u0442\u044c"
  },
  "order_details_duration_exp": {
    "sheet_name": "Web",
    "en": "Explanation",
    "ru": "",
    "fi": "Selitys",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u041f\u043e\u044f\u0441\u043d\u0435\u043d\u043d\u044f"
  },
  "order_details_duration_warning_info": {
    "sheet_name": "Web",
    "en": "Please check the duration confirmed by worker and price which has been changed according to that, before approving the task!",
    "ru": "",
    "fi": "Tarkista tekij\u00e4n vahvistama kesto ja sen mukaan p\u00e4ivitetty hinta ennen kuin hyv\u00e4ksyt teht\u00e4v\u00e4n!",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0411\u0443\u0434\u044c \u043b\u0430\u0441\u043a\u0430, \u043f\u0435\u0440\u0435\u0434 \u0437\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043d\u043d\u044f\u043c \u0437\u0430\u0432\u0434\u0430\u043d\u043d\u044f \u043f\u0435\u0440\u0435\u0432\u0456\u0440\u0442\u0435 \u043f\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043d\u0443 \u043f\u0440\u0430\u0446\u0456\u0432\u043d\u0438\u043a\u043e\u043c \u0442\u0440\u0438\u0432\u0430\u043b\u0456\u0441\u0442\u044c \u0442\u0430 \u0437\u043c\u0456\u043d\u0435\u043d\u0443 \u0432\u0456\u0434\u043f\u043e\u0432\u0456\u0434\u043d\u043e \u0434\u043e \u0446\u044c\u043e\u0433\u043e \u0446\u0456\u043d\u0443!"
  },
  "order_details_duration_warning_reason": {
    "sheet_name": "Web",
    "en": "Reason for the modification",
    "ru": "",
    "fi": "Syy muutokseen",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u041f\u0440\u0438\u0447\u0438\u043d\u0430 \u0432\u043d\u0435\u0441\u0435\u043d\u043d\u044f \u0437\u043c\u0456\u043d"
  },
  "order_details_duration_warning_current": {
    "sheet_name": "Web",
    "en": "Worker confirmed",
    "ru": "",
    "fi": "Tekij\u00e4n vahvistama",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u041f\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043d\u043e \u043f\u0440\u0430\u0446\u0456\u0432\u043d\u0438\u043a\u0430"
  },
  "order_details_duration_warning_original": {
    "sheet_name": "Web",
    "en": "Original duration",
    "ru": "",
    "fi": "Alkuper\u00e4inen kesto",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u041e\u0440\u0438\u0433\u0456\u043d\u0430\u043b\u044c\u043d\u0430 \u0442\u0440\u0438\u0432\u0430\u043b\u0456\u0441\u0442\u044c"
  },
  "order_details_minutes": {
    "sheet_name": "Web",
    "en": "Minutes",
    "ru": "",
    "fi": "Minuuttia",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0425\u0432\u0438\u043b\u0438\u043d\u0438"
  },
  "order_details_duration_warning_label": {
    "sheet_name": "Web",
    "en": "Worker modified the task duration",
    "ru": "",
    "fi": "Tekij\u00e4 on muokannut teht\u00e4v\u00e4n kestoa",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u041f\u0440\u0430\u0446\u0456\u0432\u043d\u0438\u043a \u0437\u043c\u0456\u043d\u0438\u0432 \u0442\u0440\u0438\u0432\u0430\u043b\u0456\u0441\u0442\u044c \u0437\u0430\u0432\u0434\u0430\u043d\u043d\u044f"
  },
  "order_details_duration_cant_modify": {
    "sheet_name": "Web",
    "en": "This task's work duration cannot be modified",
    "ru": "",
    "fi": "T\u00e4m\u00e4n teht\u00e4v\u00e4n kestoa ei voi muokata",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0422\u0440\u0438\u0432\u0430\u043b\u0456\u0441\u0442\u044c \u0440\u043e\u0431\u043e\u0442\u0438 \u043d\u0430\u0434 \u0446\u0438\u043c \u0437\u0430\u0432\u0434\u0430\u043d\u043d\u044f\u043c \u043d\u0435 \u043c\u043e\u0436\u0435 \u0431\u0443\u0442\u0438 \u0437\u043c\u0456\u043d\u0435\u043d\u0430"
  },
  "order_details_duration_orderer_appr": {
    "sheet_name": "Web",
    "en": "You have approved worker's modification.",
    "ru": "",
    "fi": "Olet hyv\u00e4ksynyt tekij\u00e4n muutoksen",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0412\u0438 \u0437\u0430\u0442\u0432\u0435\u0440\u0434\u0438\u043b\u0438 \u0437\u043c\u0456\u043d\u0443 \u043f\u0440\u0430\u0446\u0456\u0432\u043d\u0438\u043a\u0430."
  },
  "order_details_duration_orderer_not_appr": {
    "sheet_name": "Web",
    "en": "You have not approved worker's modification.",
    "ru": "",
    "fi": "Et hyv\u00e4ksynyt tekij\u00e4n muutosta.",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0412\u0438 \u043d\u0435 \u0437\u0430\u0442\u0432\u0435\u0440\u0434\u0438\u043b\u0438 \u0437\u043c\u0456\u043d\u0443 \u043f\u0440\u0430\u0446\u0456\u0432\u043d\u0438\u043a\u0430"
  },
  "order_details_duration_worker": {
    "sheet_name": "Web",
    "en": "You modified task duration.",
    "ru": "",
    "fi": "Muokkasit teht\u00e4v\u00e4n kestoa.",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0412\u0438 \u0437\u043c\u0456\u043d\u0438\u043b\u0438 \u0442\u0440\u0438\u0432\u0430\u043b\u0456\u0441\u0442\u044c \u0437\u0430\u0432\u0434\u0430\u043d\u043d\u044f"
  },
  "order_details_duration_original_price": {
    "sheet_name": "Web",
    "en": "Original total",
    "ru": "",
    "fi": "Alkuper\u00e4inen summa",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0412\u0438 \u0437\u043c\u0456\u043d\u0438\u043b\u0438 \u0442\u0440\u0438\u0432\u0430\u043b\u0456\u0441\u0442\u044c \u0437\u0430\u0432\u0434\u0430\u043d\u043d\u044f"
  },
  "order_details_duration_current_price": {
    "sheet_name": "Web",
    "en": "Updated total",
    "ru": "",
    "fi": "P\u00e4ivitetty summa",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u041e\u043d\u043e\u0432\u043b\u0435\u043d\u0430 \u0437\u0430\u0433\u0430\u043b\u044c\u043d\u0430 \u0441\u0443\u043c\u0430"
  },
  "order_details_duration_original_amount": {
    "sheet_name": "Web",
    "en": "Original earning",
    "ru": "",
    "fi": "Alkuper\u00e4inen korvaus",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u041f\u043e\u0447\u0430\u0442\u043a\u043e\u0432\u0438\u0439 \u0437\u0430\u0440\u043e\u0431\u0456\u0442\u043e\u043a"
  },
  "order_details_duration_updated_amount": {
    "sheet_name": "Web",
    "en": "Updated earning",
    "ru": "",
    "fi": "P\u00e4ivitetty korvaus",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u041e\u043d\u043e\u0432\u043b\u0435\u043d\u0438\u0439 \u0437\u0430\u0440\u043e\u0431\u0456\u0442\u043e\u043a"
  },
  "order_details_duration_edit": {
    "sheet_name": "Web",
    "en": "Edit",
    "ru": "",
    "fi": "Muokkaa",
    "sv": "Redigera",
    "fa": "",
    "ar": "",
    "uk": "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438"
  },
  "order_details_duration_edit_information": {
    "sheet_name": "Web",
    "en": "Edit information",
    "ru": "",
    "fi": "Muokkaa tietoja",
    "sv": "Redigera information",
    "fa": "",
    "ar": "",
    "uk": "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438 \u0456\u043d\u0444\u043e\u0440\u043c\u0430\u0446\u0456\u044e"
  },
  "order_edit": {
    "sheet_name": "Web",
    "en": "Edit Order",
    "ru": "\u0418\u0437\u043c\u0435\u043d\u0438\u0442\u044c \u0437\u0430\u043a\u0430\u0437",
    "fi": "Muokkaa tilausta",
    "sv": "Redigera din best\u00e4llning",
    "fa": "\u0633\u0641\u0627\u0631\u0634 \u0631\u0627 \u062f\u0633\u062a\u06a9\u0627\u0631\u06cc \u06a9\u0646\u06cc\u062f",
    "ar": "\u062a\u062d\u0631\u064a\u0631 \u0627\u0644\u0637\u0644\u0628",
    "uk": "\u0417\u043c\u0456\u043d\u0438\u0442\u0438 \u0437\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f"
  },
  "order_share": {
    "sheet_name": "Web",
    "en": "Share Order",
    "ru": "\u041f\u043e\u0434\u0435\u043b\u0438\u0442\u044c\u0441\u044f",
    "fi": "Jaa tilaus",
    "sv": "Dela uppdraget",
    "fa": "\u0633\u0641\u0627\u0631\u0634 \u0631\u0627 \u0628\u0647 \u0627\u0634\u062a\u0631\u0627\u06a9 \u0628\u06af\u0630\u0627\u0631\u06cc\u062f",
    "ar": "\u0645\u0634\u0627\u0631\u0643\u0629 \u0627\u0644\u0637\u0644\u0628",
    "uk": "\u041f\u043e\u0434\u0456\u043b\u0438\u0442\u0438\u0441\u044f"
  },
  "order_copy": {
    "sheet_name": "Web",
    "en": "Copy order to same worker?",
    "ru": "",
    "fi": "Kopioi tilaus samalle tekij\u00e4lle?",
    "sv": "Kopiera \u00e4ven utf\u00f6rare?",
    "fa": "",
    "ar": "",
    "uk": "\u041a\u043e\u043f\u0456\u044e\u0432\u0430\u0442\u0438 \u0437\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f \u043d\u0430 \u043e\u0434\u043d\u043e\u0433\u043e \u043f\u0440\u0430\u0446\u0456\u0432\u043d\u0438\u043a\u0430?"
  },
  "order_task_desc": {
    "sheet_name": "Web",
    "en": "Description",
    "ru": "\u041e\u043f\u0438\u0441\u0430\u043d\u0438\u0435 \u0440\u0430\u0431\u043e\u0442\u044b",
    "fi": "Kuvaus",
    "sv": "Beskrivning av uppdraget",
    "fa": "\u062a\u0648\u0636\u06cc\u062d\u0627\u062a \u06a9\u0627\u0631",
    "ar": "\u0648\u0635\u0641 \u0639\u0646 \u0627\u0644\u0639\u0645\u0644",
    "uk": "\u041e\u043f\u0438\u0441 \u0440\u043e\u0431\u043e\u0442\u0438"
  },
  "order_teams": {
    "sheet_name": "Web",
    "en": "Teams",
    "ru": "\u0413\u0440\u0443\u043f\u043f\u044b",
    "fi": "Ryhm\u00e4t",
    "sv": "Grupp",
    "fa": "\u062a\u06cc\u0645 \u0647\u0627",
    "ar": "\u0627\u0644\u0645\u062c\u0645\u0648\u0639\u0627\u062a",
    "uk": "\u0413\u0440\u0443\u043f\u0438"
  },
  "new_order_header_time": {
    "sheet_name": "Web",
    "en": "Time",
    "ru": "\u0412\u0440\u0435\u043c\u044f",
    "fi": "Ajoitus",
    "sv": "Tid",
    "fa": "\u0632\u0645\u0627\u0646",
    "ar": "\u0627\u0644\u0648\u0642\u062a",
    "uk": "\u0427\u0430\u0441"
  },
  "table_header_price": {
    "sheet_name": "Web",
    "en": "Price",
    "ru": "\u0426\u0435\u043d\u0430",
    "fi": "Hinta",
    "sv": "Totalpris",
    "fa": "\u0646\u0631\u062e",
    "ar": "\u0627\u0644\u0633\u0639\u0631",
    "uk": "\u0426\u0456\u043d\u0430"
  },
  "new_order_publish": {
    "sheet_name": "Web",
    "en": "Publish",
    "ru": "\u041e\u043f\u0443\u0431\u043b\u0438\u043a\u043e\u0432\u0430\u0442\u044c",
    "fi": "Julkaise",
    "sv": "Publicera",
    "fa": "\u0627\u0646\u062a\u0634\u0627\u0631",
    "ar": "\u0646\u0634\u0631",
    "uk": "\u041e\u043f\u0443\u0431\u043b\u0456\u043a\u0443\u0432\u0430\u0442\u0438"
  },
  "order_earning": {
    "sheet_name": "Web",
    "en": "Earning",
    "ru": "\u041d\u0430\u0447\u0438\u0441\u043b\u0435\u043d\u0438\u0435",
    "fi": "Korvaus",
    "sv": "Ers\u00e4ttning",
    "fa": "\u062f\u0631\u0622\u0645\u062f",
    "ar": "\u0643\u0633\u0628",
    "uk": "\u0417\u0430\u0440\u043e\u0431\u0456\u0442\u043d\u0430 \u043f\u043b\u0430\u0442\u0430"
  },
  "table_button_prev": {
    "sheet_name": "Web",
    "en": "Prev",
    "ru": "\u041f\u0440\u0435\u0434.",
    "fi": "Edell",
    "sv": "F\u00f6rra",
    "fa": "\u0642\u0628\u0644\u06cc",
    "ar": "\u0627\u0644\u0633\u0627\u0628\u0642",
    "uk": "\u041f\u043e\u043f\u0435\u0440\u0435\u0434\u043d\u0454"
  },
  "table_button_next": {
    "sheet_name": "Web",
    "en": "Next",
    "ru": "\u0421\u043b\u0435\u0434.",
    "fi": "Jatka",
    "sv": "N\u00e4sta",
    "fa": "\u0628\u0639\u062f\u06cc",
    "ar": "\u0627\u0644\u062a\u0627\u0644\u064a",
    "uk": "\u041d\u0430\u0441\u0442\u0443\u043f\u043d\u0435"
  },
  "new_order_time_choose_option": {
    "sheet_name": "Web",
    "en": "Choose one of these options:",
    "ru": "",
    "fi": "Valitse toinen n\u00e4ist\u00e4 vaihtoehdoista:",
    "sv": "V\u00e4lj ett av dessa alternativ:",
    "fa": "",
    "ar": "",
    "uk": "\u041e\u0431\u0435\u0440\u0456\u0442\u044c \u043e\u0434\u0438\u043d \u0437 \u0446\u0438\u0445 \u0432\u0430\u0440\u0456\u0430\u043d\u0442\u0456\u0432:"
  },
  "new_order_time_exact_date": {
    "sheet_name": "Web",
    "en": "1) Choose exact dates and daily working hours",
    "ru": "",
    "fi": "1) Valitse tarkat p\u00e4iv\u00e4m\u00e4\u00e4r\u00e4t ja p\u00e4ivitt\u00e4inen ty\u00f6aika",
    "sv": "1) V\u00e4lj exakta datum och dagliga arbetstider",
    "fa": "",
    "ar": "",
    "uk": "1) \u041e\u0431\u0435\u0440\u0456\u0442\u044c \u0442\u043e\u0447\u043d\u0456 \u0434\u0430\u0442\u0438 \u0442\u0430 \u0449\u043e\u0434\u0435\u043d\u043d\u0438\u0439 \u0433\u0440\u0430\u0444\u0456\u043a \u0440\u043e\u0431\u043e\u0442\u0438"
  },
  "new_order_time_enter_schedule": {
    "sheet_name": "Web",
    "en": "2) Enter schedule free form",
    "ru": "",
    "fi": "2) Kirjoita vapaamuotoinen aikataulu",
    "sv": "2) Skriva ett schema i fritt format",
    "fa": "",
    "ar": "",
    "uk": "2) \u041d\u0430\u043f\u0438\u0441\u0430\u0442\u0438 \u0440\u043e\u0437\u043a\u043b\u0430\u0434 \u0443 \u0434\u043e\u0432\u0456\u043b\u044c\u043d\u0456\u0439 \u0444\u043e\u0440\u043c\u0456"
  },
  "new_order_form_payment_no_payment_setup": {
    "sheet_name": "Web",
    "en": "You haven't set a valid payment yet, please add a card or buy PilotPoints.",
    "ru": "",
    "fi": "Et ole viel\u00e4 asettanut maksutapaa, ole hyv\u00e4 ja lis\u00e4\u00e4 maksukortti tai osta PilotPointseja.",
    "sv": "Du har inte angett en giltig betalningsmetod, \n l\u00e4gg till ett kort eller k\u00f6p PilotPoints.",
    "fa": "",
    "ar": "",
    "uk": "\u0412\u0438 \u0449\u0435 \u043d\u0435 \u0432\u0441\u0442\u0430\u043d\u043e\u0432\u0438\u043b\u0438 \u0434\u0456\u0439\u0441\u043d\u0438\u0439 \u043f\u043b\u0430\u0442\u0456\u0436, \u0431\u0443\u0434\u044c \u043b\u0430\u0441\u043a\u0430, \u0434\u043e\u0434\u0430\u0439\u0442\u0435 \u043a\u0430\u0440\u0442\u043a\u0443 \u0430\u0431\u043e \u043a\u0443\u043f\u0456\u0442\u044c PilotPoints."
  },
  "new_order_successfully_created": {
    "sheet_name": "Web",
    "en": "Order has been successfully created",
    "ru": "\u0417\u0430\u043a\u0430\u0437 \u0443\u0441\u043f\u0435\u0448\u043d\u043e \u0441\u043e\u0437\u0434\u0430\u043d",
    "fi": "Tilaus luotu onnistuneesti",
    "sv": "Din best\u00e4llning \u00e4r nu klar",
    "fa": "\u0633\u0641\u0627\u0631\u0634 \u0628\u0627 \u0645\u0648\u0641\u0642\u06cc\u062a \u0627\u06cc\u062c\u0627\u062f \u0634\u062f",
    "ar": "\u062a\u0645 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0637\u0644\u0628 \u0628\u0646\u062c\u0627\u062d",
    "uk": "\u0417\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f \u0443\u0441\u043f\u0456\u0448\u043d\u043e \u0441\u0442\u0432\u043e\u0440\u0435\u043d\u043e"
  },
  "new_order_loc_city": {
    "sheet_name": "Web",
    "en": "City",
    "ru": "\u0413\u043e\u0440\u043e\u0434",
    "fi": "Kaupunki",
    "sv": "Stad",
    "fa": "\u0634\u0647\u0631",
    "ar": "\u0627\u0644\u0645\u062f\u064a\u0646\u0629",
    "uk": "\u041c\u0456\u0441\u0442\u043e"
  },
  "new_order_loc_region": {
    "sheet_name": "Web",
    "en": "Region\/Province",
    "ru": "\u0420\u0435\u0433\u0438\u043e\u043d \/ \u041e\u0431\u043b\u0430\u0441\u0442\u044c",
    "fi": "Maakunta",
    "sv": "L\u00e4n",
    "fa": "\u0627\u06cc\u0627\u0644\u062a\/ \u0648\u0644\u0627\u06cc\u062a",
    "ar": "\u0627\u0644\u0645\u0642\u0627\u0637\u0639\u0629",
    "uk": "\u0420\u0435\u0433\u0456\u043e\u043d \/ \u043e\u0431\u043b\u0430\u0441\u0442\u044c"
  },
  "new_order_loc_postal": {
    "sheet_name": "Web",
    "en": "Postal code",
    "ru": "\u041f\u043e\u0447\u0442\u043e\u0432\u044b\u0439 \u0438\u043d\u0434\u0435\u043a\u0441",
    "fi": "Postinumero",
    "sv": "Postnummer",
    "fa": "\u06a9\u0648\u062f \u067e\u0633\u062a\u06cc",
    "ar": "\u0627\u0644\u0631\u0645\u0632 \u0627\u0644\u0628\u0631\u064a\u062f\u064a",
    "uk": "\u041f\u043e\u0448\u0442\u043e\u0432\u0438\u0439 \u0456\u043d\u0434\u0435\u043a\u0441"
  },
  "new_order_loc_country": {
    "sheet_name": "Web",
    "en": "Country",
    "ru": "\u0421\u0442\u0440\u0430\u043d\u0430",
    "fi": "Maa",
    "sv": "Land",
    "fa": "\u06a9\u0634\u0648\u0631",
    "ar": "\u0627\u0644\u0628\u0644\u062f",
    "uk": "\u041a\u0440\u0430\u0457\u043d\u0430"
  },
  "new_order_required_information": {
    "sheet_name": "Web",
    "en": "Required information",
    "ru": "",
    "fi": "Pakolliset tiedot",
    "sv": "Obligatorisk information",
    "fa": "",
    "ar": "",
    "uk": "\u041d\u0435\u043e\u0431\u0445\u0456\u0434\u043d\u0430 \u0456\u043d\u0444\u043e\u0440\u043c\u0430\u0446\u0456\u044f"
  },
  "new_order_optional_information": {
    "sheet_name": "Web",
    "en": "Optional information",
    "ru": "",
    "fi": "Lis\u00e4tiedot",
    "sv": "Valfri information",
    "fa": "",
    "ar": "",
    "uk": "\u041d\u0435\u043e\u0431\u043e\u0432'\u044f\u0437\u043a\u043e\u0432\u0430 \u0456\u043d\u0444\u043e\u0440\u043c\u0430\u0446\u0456\u044f"
  },
  "new_order_target_order": {
    "sheet_name": "Web",
    "en": "Target order (optional)",
    "ru": "",
    "fi": "Kohdenna tilaus (tarvittaessa)",
    "sv": "Rikta in din best\u00e4llning",
    "fa": "",
    "ar": "",
    "uk": "\u0426\u0456\u043b\u044c\u043e\u0432\u0435 \u0437\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f (\u043d\u0435 \u043e\u0431\u043e\u0432'\u044f\u0437\u043a\u043e\u0432\u0435)"
  },
  "new_order_merchant_specific": {
    "sheet_name": "Web",
    "en": "Merchant specific fields",
    "ru": "",
    "fi": "Palvelukohtaiset kent\u00e4t",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0421\u043f\u0435\u0446\u0438\u0444\u0456\u0447\u043d\u0456 \u0433\u0430\u043b\u0443\u0437\u0456 \u0442\u043e\u0440\u0433\u0456\u0432\u043b\u0456"
  },
  "new_order_min_val": {
    "sheet_name": "Web",
    "en": "Minimum value:",
    "ru": "",
    "fi": "Minimi:",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u041c\u0456\u043d\u0456\u043c\u0430\u043b\u044c\u043d\u0430 \u0432\u0430\u0440\u0442\u0456\u0441\u0442\u044c:"
  },
  "new_order_saving": {
    "sheet_name": "Web",
    "en": "Saving...",
    "ru": "",
    "fi": "Tallenetaan...",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0417\u0431\u0435\u0440\u0435\u0436\u0435\u043d\u043d\u044f..."
  },
  "new_order_auto_save": {
    "sheet_name": "Web",
    "en": "Changes are automatically saved",
    "ru": "",
    "fi": "Muutokset tallennetaan automaattisesti",
    "sv": "\u00c4ndringar sparas automatiskt",
    "fa": "",
    "ar": "",
    "uk": "\u0417\u043c\u0456\u043d\u0438 \u0437\u0431\u0435\u0440\u0456\u0433\u0430\u044e\u0442\u044c\u0441\u044f \u0430\u0432\u0442\u043e\u043c\u0430\u0442\u0438\u0447\u043d\u043e"
  },
  "new_order_calendar_invalid": {
    "sheet_name": "Web",
    "en": "Choose exact dates and daily working hours OR describe suitable schedule",
    "ru": "",
    "fi": "Valitse tarkat p\u00e4iv\u00e4m\u00e4\u00e4r\u00e4t ja p\u00e4ivitt\u00e4inen ty\u00f6aika TAI kirjoita vapaamuotoinen aikataulu",
    "sv": "Ange dagarna\/timmar ELLER l\u00e4mplig tid",
    "fa": "",
    "ar": "",
    "uk": "\u041e\u0431\u0435\u0440\u0456\u0442\u044c \u0442\u043e\u0447\u043d\u0456 \u0434\u0430\u0442\u0438 \u0442\u0430 \u0449\u043e\u0434\u0435\u043d\u043d\u0456 \u0433\u043e\u0434\u0438\u043d\u0438 \u0440\u043e\u0431\u043e\u0442\u0438 \u0410\u0411\u041e \u043e\u043f\u0438\u0448\u0456\u0442\u044c \u0432\u0456\u0434\u043f\u043e\u0432\u0456\u0434\u043d\u0438\u0439 \u0433\u0440\u0430\u0444\u0456\u043a"
  },
  "new_order_calendar_duration": {
    "sheet_name": "Web",
    "en": "Total",
    "ru": "",
    "fi": "Yhteens\u00e4",
    "sv": "Total",
    "fa": "",
    "ar": "",
    "uk": "\u0417\u0430\u0433\u0430\u043b\u043e\u043c"
  },
  "new_order_calendar_start_date": {
    "sheet_name": "Web",
    "en": "Start date",
    "ru": "",
    "fi": "Aloitusp\u00e4iv\u00e4",
    "sv": "Startdatum",
    "fa": "",
    "ar": "",
    "uk": "\u0414\u0430\u0442\u0430 \u043f\u043e\u0447\u0430\u0442\u043a\u0443 \u0440\u043e\u0431\u043e\u0442\u0438"
  },
  "new_order_calendar_end_date": {
    "sheet_name": "Web",
    "en": "End date",
    "ru": "",
    "fi": "Lopetusp\u00e4iv\u00e4",
    "sv": "Slutdatum",
    "fa": "",
    "ar": "",
    "uk": "\u0414\u0430\u0442\u0430 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043d\u043d\u044f \u0440\u043e\u0431\u043e\u0442\u0438"
  },
  "new_order_calendar_start_time": {
    "sheet_name": "Web",
    "en": "Start time",
    "ru": "",
    "fi": "Aloitusaika",
    "sv": "Starttid",
    "fa": "",
    "ar": "",
    "uk": "\u0427\u0430\u0441 \u043f\u043e\u0447\u0430\u0442\u043a\u0443"
  },
  "new_order_calendar_end_time": {
    "sheet_name": "Web",
    "en": "End time",
    "ru": "",
    "fi": "Lopetusaika",
    "sv": "Sluttid",
    "fa": "",
    "ar": "",
    "uk": "\u0427\u0430\u0441 \u0437\u0430\u043a\u0456\u043d\u0447\u0435\u043d\u043d\u044f"
  },
  "new_order_calendar_equal": {
    "sheet_name": "Web",
    "en": "Can't be equal",
    "ru": "",
    "fi": "Ei voi olla sama arvo",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u041d\u0435 \u043c\u043e\u0436\u0443\u0442\u044c \u0431\u0443\u0442\u0438 \u0440\u0456\u0432\u043d\u0456"
  },
  "new_order_calendar_invalid_date": {
    "sheet_name": "Web",
    "en": "Invalid date!",
    "ru": "",
    "fi": "Virheellinen p\u00e4iv\u00e4m\u00e4\u00e4r\u00e4",
    "sv": "Felaktig tid",
    "fa": "",
    "ar": "",
    "uk": "\u041d\u0435\u0432\u0456\u0440\u043d\u0430 \u0434\u0430\u0442\u0430!"
  },
  "new_order_wp_billing": {
    "sheet_name": "Web",
    "en": "Billing",
    "ru": "\u0431\u0438\u043b\u043b\u0438\u043d\u0433",
    "fi": "Laskutus",
    "sv": "Faktura",
    "fa": "\u0635\u0648\u0631\u062a\u062d\u0633\u0627\u0628",
    "ar": "\u0627\u0644\u0641\u0648\u0627\u062a\u064a\u0631",
    "uk": "\u0412\u0438\u0441\u0442\u0430\u0432\u043b\u0435\u043d\u043d\u044f \u0440\u0430\u0445\u0443\u043d\u043a\u0456\u0432"
  },
  "new_order_loc_invalid_str": {
    "sheet_name": "Web",
    "en": "Invalid street number!",
    "ru": "\u041d\u0435\u0432\u0435\u0440\u043d\u043e \u0443\u043a\u0430\u0437\u0430\u043d \u043d\u043e\u043c\u0435\u0440 \u0430\u0434\u0440\u0435\u0441\u0430",
    "fi": "Virheellinen osoitenumero!",
    "sv": "Felaktigt gatunummer!",
    "fa": "\u0634\u0645\u0627\u0631\u0647 \u062e\u06cc\u0627\u0628\u0627\u0646 \u0646\u0627\u0645\u0639\u062a\u0628\u0631 \u0627\u0633\u062a!",
    "ar": "\u0631\u0642\u0645 \u0634\u0627\u0631\u0639 \u063a\u064a\u0631 \u0635\u0627\u0644\u062d!",
    "uk": "\u041d\u0435\u0432\u0456\u0440\u043d\u043e \u0432\u043a\u0430\u0437\u0430\u043d\u043e \u043d\u043e\u043c\u0435\u0440 \u0431\u0443\u0434\u0438\u043d\u043a\u0443"
  },
  "new_order_loc_invalid_str_name": {
    "sheet_name": "Web",
    "en": "Invalid street name!",
    "ru": "\u041d\u0435\u0432\u0435\u0440\u043d\u043e \u0443\u043a\u0430\u0437\u0430\u043d \u0430\u0434\u0440\u0435\u0441",
    "fi": "Virheellinen osoite!",
    "sv": "Felaktigt gatunamn!",
    "fa": "\u0646\u0627\u0645 \u062e\u06cc\u0627\u0628\u0627\u0646 \u0646\u0627\u0645\u0639\u062a\u0628\u0631 \u0627\u0633\u062a!",
    "ar": "\u0627\u0633\u0645 \u0634\u0627\u0631\u0639 \u063a\u064a\u0631 \u0635\u0627\u0644\u062d!",
    "uk": "\u041d\u0435\u0432\u0456\u0440\u043d\u043e \u0432\u043a\u0430\u0437\u0430\u043d\u043e \u0432\u0443\u043b\u0438\u0446\u044e"
  },
  "new_order_loc_inv_ctry": {
    "sheet_name": "Web",
    "en": "Invalid country!",
    "ru": "\u041d\u0435\u0432\u0435\u0440\u043d\u043e \u0443\u043a\u0430\u0437\u0430\u043d\u0430 \u0441\u0442\u0440\u0430\u043d\u0430",
    "fi": "Virheellinen maa!",
    "sv": "Felaktigt land!",
    "fa": "\u06a9\u0634\u0648\u0631 \u0646\u0627\u0645\u0639\u062a\u0628\u0631!",
    "ar": "\u0628\u0644\u062f \u063a\u064a\u0631 \u0635\u0627\u0644\u062d!",
    "uk": "\u041d\u0435\u0432\u0456\u0440\u043d\u043e \u0432\u043a\u0430\u0437\u0430\u043d\u043e \u043a\u0440\u0430\u0457\u043d\u0443"
  },
  "new_order_loc_post": {
    "sheet_name": "Web",
    "en": "Invalid postal code!",
    "ru": "\u041d\u0435\u0432\u0435\u0440\u043d\u043e \u0443\u043a\u0430\u0437\u0430\u043d \u043d\u043e\u043c\u0435\u0440 \u043f\u043e\u0447\u0442\u044b",
    "fi": "Virheellinen postinumero!",
    "sv": "Felaktig postnummer!",
    "fa": "\u06a9\u062f \u067e\u0633\u062a\u06cc \u0646\u0627\u0645\u0639\u062a\u0628\u0631!",
    "ar": "\u0627\u0644\u0631\u0645\u0632 \u0627\u0644\u0628\u0631\u064a\u062f\u064a \u063a\u064a\u0631 \u0635\u0627\u0644\u062d!",
    "uk": "\u041d\u0435\u0432\u0456\u0440\u043d\u043e \u0432\u043a\u0430\u0437\u0430\u043d\u043e \u043f\u043e\u0448\u0442\u043e\u0432\u0438\u0439 \u0456\u043d\u0434\u0435\u043a\u0441"
  },
  "new_order_loc_addr_line": {
    "sheet_name": "Web",
    "en": "Invalid address line!",
    "ru": "\u041d\u0435\u0432\u0435\u0440\u043d\u044b\u0439 \u0430\u0434\u0440\u0435\u0441",
    "fi": "Virheellinen osoite!",
    "sv": "Felaktig adressrad!",
    "fa": "\u0622\u062f\u0631\u0633 \u0646\u0627\u0645\u0639\u062a\u0628\u0631 \u0627\u0633\u062a!",
    "ar": "\u0633\u0637\u0631 \u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u063a\u064a\u0631 \u0635\u0627\u0644\u062d!",
    "uk": "\u041d\u0435\u043f\u0440\u0430\u0432\u0438\u043b\u044c\u043d\u0430 \u0430\u0434\u0440\u0435\u0441\u0430!"
  },
  "new_order_loc_inv_cord": {
    "sheet_name": "Web",
    "en": "Invalid coordinates!",
    "ru": "\u041d\u0435\u0432\u0435\u0440\u043d\u044b\u0435 \u043a\u043e\u043e\u0440\u0434\u0438\u043d\u0430\u0442\u044b",
    "fi": "Virheelliset koordinaatit!",
    "sv": "Felaktiga koordinater!",
    "fa": "\u0645\u062e\u062a\u0635\u0627\u062a \u0646\u0627\u0645\u0639\u062a\u0628\u0631!",
    "ar": "\u0625\u062d\u062f\u0627\u062b\u064a\u0627\u062a \u063a\u064a\u0631 \u0635\u0627\u0644\u062d\u0629!",
    "uk": "\u041d\u0435\u0432\u0456\u0440\u043d\u0456 \u043a\u043e\u043e\u0440\u0434\u0438\u043d\u0430\u0442\u0438!"
  },
  "new_order_loc_no_res": {
    "sheet_name": "Web",
    "en": "No usable result",
    "ru": "\u041d\u0435\u0442 \u0438\u0441\u043f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u043d\u043d\u044b\u0445 \u0440\u0435\u0437\u0443\u043b\u044c\u0442\u0430\u0442\u043e\u0432",
    "fi": "Ei k\u00e4ytett\u00e4vi\u00e4 tuloksia",
    "sv": "Inga resultat tillg\u00e4ngliga",
    "fa": "\u0646\u062a\u06cc\u062c\u0647 \u06cc \u0642\u0627\u0628\u0644 \u0627\u0633\u062a\u0641\u0627\u062f\u0647 \u0648\u062c\u0648\u062f \u0646\u062f\u0627\u0631\u062f!",
    "ar": "\u0644\u0627 \u062a\u0648\u062c\u062f \u0646\u062a\u064a\u062c\u0629 \u0642\u0627\u0628\u0644\u0629 \u0644\u0644\u0627\u0633\u062a\u062e\u062f\u0627\u0645",
    "uk": "\u0412\u0456\u0434\u0441\u0443\u0442\u043d\u0456\u0439 \u043a\u043e\u0440\u0438\u0441\u043d\u0438\u0439 \u0440\u0435\u0437\u0443\u043b\u044c\u0442\u0430\u0442"
  },
  "new_order_loc_geo_fail": {
    "sheet_name": "Web",
    "en": "Geocoding failed",
    "ru": "\u041e\u0448\u0438\u0431\u043a\u0430 \u0433\u0435\u043e\u043a\u043e\u0434\u0438\u0440\u043e\u0432\u0430\u043d\u0438\u0435",
    "fi": "Geokoodaus ep\u00e4onnistui",
    "sv": "Geokodning misslyckades",
    "fa": "\u0645\u06a9\u0627\u0646 \u06cc\u0627\u0628\u06cc \u0646\u0627\u0645\u0648\u0641\u0642",
    "ar": "\u0641\u0634\u0644 \u0627\u0644\u062a\u0631\u0645\u064a\u0632 \u0627\u0644\u062c\u063a\u0631\u0627\u0641\u064a",
    "uk": "\u0413\u0435\u043e\u043a\u043e\u0434\u0443\u0432\u0430\u043d\u043d\u044f \u043d\u0435 \u0432\u0434\u0430\u043b\u043e\u0441\u044f"
  },
  "new_order_loc_choose_map": {
    "sheet_name": "Web",
    "en": "Write address here or move red marker on map",
    "ru": "\u0412\u044b\u0431\u0435\u0440\u0438\u0442\u0435 \u043d\u0430 \u043a\u0430\u0440\u0442\u0435",
    "fi": "Kirjoita osoite t\u00e4h\u00e4n tai siirr\u00e4 punaista merkki\u00e4 kartalla",
    "sv": "V\u00e4lj fr\u00e5n kartan",
    "fa": "\u0622\u062f\u0631\u0633 \u0631\u0627 \u0627\u0632 \u0646\u0642\u0634\u0647 \u0627\u0646\u062a\u062e\u0627\u0628 \u06a9\u0646\u06cc\u062f (\u0628\u0627 \u062d\u0631\u06a9\u062a \u062f\u0627\u062f\u0646 \u0646\u0634\u0627\u0646\u06af\u0631 \u0642\u0631\u0645\u0632)",
    "ar": "\u0625\u062e\u062a\u0631 \u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0645\u0646 \u0627\u0644\u062e\u0631\u064a\u0637\u0629 ( \u0639\u0646 \u0637\u0631\u064a\u0642 \u062a\u062d\u0631\u064a\u0643 \u0627\u0644\u0639\u0644\u0627\u0645\u0629 \u0627\u0644\u062d\u0645\u0631\u0627\u0621)",
    "uk": "\u041d\u0430\u043f\u0438\u0448\u0456\u0442\u044c \u0430\u0434\u0440\u0435\u0441\u0443 \u0442\u0443\u0442 \u0430\u0431\u043e \u043f\u0435\u0440\u0435\u043c\u0456\u0441\u0442\u0456\u0442\u044c \u0447\u0435\u0440\u0432\u043e\u043d\u0438\u0439 \u043c\u0430\u0440\u043a\u0435\u0440 \u043d\u0430 \u043a\u0430\u0440\u0442\u0456"
  },
  "new_order_loc_prm_addr": {
    "sheet_name": "Web",
    "en": "Address",
    "ru": "\u0410\u0434\u0440\u0435\u0441",
    "fi": "Osoite",
    "sv": "Adress",
    "fa": "\u0622\u062f\u0631\u0633",
    "ar": "\u0627\u0644\u0639\u0646\u0648\u0627\u0646",
    "uk": "\u0410\u0434\u0440\u0435\u0441\u0430"
  },
  "new_order_loc_sec_addr": {
    "sheet_name": "Web",
    "en": "Address further information",
    "ru": "\u0414\u043e\u043f\u043e\u043b\u043d\u0438\u0442\u0435\u043b\u044c\u043d\u0430\u044f \u0438\u043d\u0444\u043e\u0440\u043c\u0430\u0446\u0438\u044f \u0430\u0434\u0440\u0435\u0441\u0430",
    "fi": "Lis\u00e4tietoja osoitteeseen",
    "sv": "Adress (mer information)",
    "fa": "\u0627\u0637\u0644\u0627\u0639\u0627\u062a \u0628\u06cc\u0634\u062a\u0631 \u0628\u0631\u0627\u06cc \u0622\u062f\u0631\u0633",
    "ar": "\u0645\u0639\u0627\u0644\u062c\u0629 \u0645\u0632\u064a\u062f \u0645\u0646 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062a",
    "uk": "\u0417\u0430 \u0434\u043e\u0434\u0430\u0442\u043a\u043e\u0432\u043e\u044e \u0456\u043d\u0444\u043e\u0440\u043c\u0430\u0446\u0456\u0454\u044e \u0432\u0435\u0440\u0442\u0430\u0439\u0442\u0435\u0441\u044c \u0437\u0430"
  },
  "new_order_pay_card": {
    "sheet_name": "Web",
    "en": "Payment card:",
    "ru": "\u043a\u0440\u0435\u0434\u0438\u0442\u043d\u0430\u044f \u043a\u0430\u0440\u0442\u0430:",
    "fi": "Maksukortti:",
    "sv": "Betalskort:",
    "fa": "\u06a9\u0627\u0631\u062a \u0627\u0639\u062a\u0628\u0627\u0631\u06cc",
    "ar": "\u0628\u0637\u0627\u0642\u0629 \u0627\u0626\u062a\u0645\u0627\u0646",
    "uk": "\u041f\u043b\u0430\u0442\u0456\u0436\u043d\u0430 \u043a\u0430\u0440\u0442\u043a\u0430:"
  },
  "new_order_time_taskdone": {
    "sheet_name": "Web",
    "en": "Enter free format (ie. Next week)",
    "ru": "\u041a\u043e\u0433\u0434\u0430 \u043c\u043e\u0436\u043d\u043e \u0432\u044b\u043f\u043e\u043b\u043d\u0438\u0442\u044c \u0440\u0430\u0431\u043e\u0442\u0443?",
    "fi": "Toivottu ajoitus teht\u00e4v\u00e4lle (esim. Ensi viikolla)",
    "sv": "\u00d6nskad tidpunkt f\u00f6r uppdraget",
    "fa": "\u0632\u0645\u0627\u0646 \u0644\u0627\u0632\u0645 \u0628\u0631\u0627\u06cc \u0627\u0646\u062c\u0627\u0645 \u06a9\u0627\u0631",
    "ar": "\u0645\u062a\u0649 \u064a\u0645\u0643\u0646 \u0625\u0646\u062c\u0627\u0632 \u0627\u0644\u0639\u0645\u0644 \u061f",
    "uk": "\u0411\u0430\u0436\u0430\u043d\u0438\u0439 \u0447\u0430\u0441 \u0432\u0438\u043a\u043e\u043d\u0430\u043d\u043d\u044f \u0437\u0430\u0432\u0434\u0430\u043d\u043d\u044f (\u043d\u0430\u043f\u0440\u0438\u043a\u043b\u0430\u0434, \u043d\u0430\u0441\u0442\u0443\u043f\u043d\u043e\u0433\u043e \u0442\u0438\u0436\u043d\u044f)"
  },
  "new_order_time_descreq": {
    "sheet_name": "Web",
    "en": "Time description is required!",
    "ru": "\u0420\u0430\u0441\u043f\u0438\u0441\u0430\u043d\u0438\u0435 \u043e\u0442\u0441\u0443\u0442\u0441\u0442\u0432\u0443\u0435\u0442",
    "fi": "Aikataulu puuttuu!",
    "sv": "Ange tidsbeskrivining!",
    "fa": "\u062a\u0648\u0636\u06cc\u062d\u0627\u062a \u0632\u0645\u0627\u0646 \u0644\u0627\u0632\u0645 \u0627\u0633\u062a!",
    "ar": "\u0627\u0644\u062c\u062f\u0648\u0644 \u0645\u0641\u0642\u0648\u062f",
    "uk": "\u0420\u043e\u0437\u043a\u043b\u0430\u0434 \u0432\u0456\u0434\u0441\u0443\u0442\u043d\u0456\u0439!"
  },
  "new_order_time_hours": {
    "sheet_name": "Web",
    "en": "Hours",
    "ru": "\u0427\u0430\u0441\u044b",
    "fi": "Tuntia",
    "sv": "Timmar",
    "fa": "\u0633\u0627\u0639\u062a \u0647\u0627",
    "ar": "\u0633\u0627\u0639\u0627\u062a",
    "uk": "\u0413\u043e\u0434\u0438\u043d\u0438"
  },
  "new_order_desc_target": {
    "sheet_name": "Web",
    "en": "If needed, target this order ONLY to a private team (with a code) or to a team selected from list (public team)",
    "ru": "\u041c\u043e\u0436\u0435\u0442\u0435 \u043d\u0430\u043f\u0440\u0430\u0432\u0438\u0442\u044c \u0437\u0430\u043a\u0430\u0437 \u0437\u0430\u043a\u0440\u044b\u0442\u0443\u044e \u0438\u043b\u0438 \u0436\u0435 \u043e\u0442\u043a\u0440\u044b\u0442\u0443\u044e \u0433\u0440\u0443\u043f\u043f\u0443",
    "fi": "Tarvittaessa kohdista tilaus VAIN yksityiselle ryhm\u00e4lle (sy\u00f6t\u00e4 koodi) tai listalta valittavalle ryhm\u00e4lle (julkinen ryhm\u00e4)",
    "sv": "Du kan dela at uppdraget till privat eller offentlig grupp",
    "fa": "\u0645\u06cc \u062a\u0648\u0627\u0646\u06cc\u062f \u0627\u06cc\u0646 \u0633\u0641\u0627\u0631\u0634 \u0631\u0627 \u062f\u0631 \u06cc\u06a9 \u06af\u0631\u0648\u0647 \u0639\u0645\u0648\u0645\u06cc \u06cc\u0627 \u062e\u0635\u0648\u0635\u06cc \u0642\u0631\u0627\u0631 \u062f\u0647\u06cc\u062f",
    "ar": "\u064a\u0645\u0643\u0646\u0643 \u062a\u0648\u062c\u064a\u0647 \u0647\u0630\u0627 \u0627\u0644\u0637\u0644\u0628 \u0625\u0644\u0649 \u0641\u0631\u064a\u0642 \u0639\u0627\u0645 \u0623\u0648 \u062e\u0627\u0635 \u0623\u062f\u0646\u0627\u0647",
    "uk": "\u041f\u0440\u0438 \u043d\u0435\u043e\u0431\u0445\u0456\u0434\u043d\u043e\u0441\u0442\u0456, \u0432\u0438 \u043c\u043e\u0436\u0435\u0442\u0435  \u043d\u0430\u043f\u0440\u0430\u0432\u0438\u0442\u0438 \u0446\u0435 \u0437\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f \u0422\u0406\u041b\u042c\u041a\u0418 \u043f\u0440\u0438\u0432\u0430\u0442\u043d\u0456\u0439 \u043a\u043e\u043c\u0430\u043d\u0434\u0456 (\u0437 \u043a\u043e\u0434\u043e\u043c) \u0430\u0431\u043e \u043a\u043e\u043c\u0430\u043d\u0434\u0456, \u043e\u0431\u0440\u0430\u043d\u0456\u0439 \u0437\u0456 \u0441\u043f\u0438\u0441\u043a\u0443 (\u043f\u0443\u0431\u043b\u0456\u0447\u043d\u0430 \u043a\u043e\u043c\u0430\u043d\u0434\u0430)"
  },
  "new_order_desc_inv_teamcode": {
    "sheet_name": "Web",
    "en": "Invalid team code!",
    "ru": "\u041d\u0435\u0432\u0435\u0440\u043d\u044b\u0439 \u043a\u043e\u0434 \u0433\u0440\u0443\u043f\u043f\u044b",
    "fi": "Virheellinen ryhm\u00e4koodi!",
    "sv": "Felaktig gruppkod!",
    "fa": "\u06a9\u062f \u06af\u0631\u0648\u0647 \u0646\u0627\u0645\u0639\u062a\u0628\u0631 \u0627\u0633\u062a!",
    "ar": "\u0631\u0645\u0632 \u0627\u0644\u0641\u0631\u064a\u0642 \u063a\u064a\u0631 \u0635\u0627\u0644\u062d!",
    "uk": "\u041d\u0435\u0432\u0456\u0440\u043d\u0438\u0439 \u043a\u043e\u0434 \u0433\u0440\u0443\u043f\u0438!"
  },
  "new_order_desc_desc_req": {
    "sheet_name": "Web",
    "en": "Description is required!",
    "ru": "\u041e\u043f\u0438\u0441\u0430\u043d\u0438\u0435 \u0440\u0430\u0431\u043e\u0442\u044b \u043e\u0442\u0441\u0443\u0442\u0441\u0442\u0432\u0443\u0435\u0442",
    "fi": "Kuvaus puuttuu!",
    "sv": "Ange en uppdragsbeskrivning!",
    "fa": "\u0634\u0631\u062d \u0648\u0638\u06cc\u0641\u0647 \u0627\u0644\u0632\u0627\u0645\u06cc \u0627\u0633\u062a!",
    "ar": "\u0648\u0635\u0641 \u0627\u0644\u0645\u0647\u0645\u0629 \u0645\u0641\u0642\u0648\u062f",
    "uk": "\u041e\u043f\u0438\u0441 \u0437\u0430\u0432\u0434\u0430\u043d\u043d\u044f \u043e\u0431\u043e\u0432'\u044f\u0437\u043a\u043e\u0432\u0438\u0439!"
  },
  "new_order_desc_start": {
    "sheet_name": "Web",
    "en": "Start to type",
    "ru": "\u041d\u0430\u0447\u043d\u0438\u0442\u0435 \u043f\u0435\u0447\u0430\u0442\u0430\u0442\u044c",
    "fi": "Aloita kirjoittaminen",
    "sv": "B\u00f6rja skriva",
    "fa": "\u0634\u0631\u0648\u0639 \u0628\u0647 \u062a\u0627\u06cc\u067e \u06a9\u0646\u06cc\u062f",
    "ar": "\u0627\u0628\u062f\u0623 \u0641\u064a \u0627\u0644\u0643\u062a\u0627\u0628\u0629",
    "uk": "\u041f\u043e\u0447\u043d\u0456\u0442\u044c \u0432\u0432\u043e\u0434\u0438\u0442\u0438 \u0442\u0435\u043a\u0441\u0442"
  },
  "new_order_desc_task_type": {
    "sheet_name": "Web",
    "en": "Please choose a product (incl VAT)",
    "ru": "\u0412\u044b\u0431\u0435\u0440\u0438\u0442\u0435 \u0442\u043e\u0432\u0430\u0440 ( \u0432\u043a\u043b\u044e\u0447\u0430\u044f \u043d\u0430\u043b\u043e\u0433 )",
    "fi": "Valitse tuote (sis ALV)",
    "sv": "V\u00e4lj en produkt (inkl moms)",
    "fa": "\u0644\u0637\u0641\u0627\u064b \u06cc\u06a9 \u0645\u062d\u0635\u0648\u0644 \u0631\u0627 \u0627\u0646\u062a\u062e\u0627\u0628 \u06a9\u0646\u06cc\u062f (\u0634\u0627\u0645\u0644 \u0645\u0627\u0644\u06cc\u0627\u062a \u0628\u0631 \u0627\u0631\u0632\u0634 \u0627\u0641\u0632\u0648\u062f\u0647)",
    "ar": "\u064a\u0631\u062c\u0649 \u0627\u062e\u062a\u064a\u0627\u0631 \u0645\u0646\u062a\u062c (\u0628\u0645\u0627 \u0641\u064a \u0630\u0644\u0643 \u0636\u0631\u064a\u0628\u0629 \u0627\u0644\u0642\u064a\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629)",
    "uk": "\u0411\u0443\u0434\u044c \u043b\u0430\u0441\u043a\u0430, \u043e\u0431\u0435\u0440\u0456\u0442\u044c \u0442\u043e\u0432\u0430\u0440 (\u0437 \u041f\u0414\u0412)"
  },
  "new_order_desc_addteam": {
    "sheet_name": "Web",
    "en": "Add public team",
    "ru": "\u0412\u044b\u0431\u0435\u0440\u0438\u0442\u0435 \u043e\u0431\u0449\u0443\u044e \u0433\u0440\u0443\u043f\u043f\u0443",
    "fi": "Valitse ryhm\u00e4 listalta",
    "sv": "L\u00e4gg till offentlig grupp",
    "fa": "\u0627\u0636\u0627\u0641\u0647 \u06a9\u0631\u062f\u0646 \u06af\u0631\u0648\u0647 \u0639\u0645\u0648\u0645\u06cc",
    "ar": "\u0623\u0636\u0641 \u0641\u0631\u064a\u0642 \u0639\u0627\u0645",
    "uk": "\u0414\u043e\u0434\u0430\u0442\u0438 \u043f\u0443\u0431\u043b\u0456\u0447\u043d\u0443 \u0433\u0440\u0443\u043f\u0443"
  },
  "new_order_desc_addworker": {
    "sheet_name": "Web",
    "en": "Add worker email",
    "ru": "\u0414\u043e\u0431\u0430\u0432\u0438\u0442\u044c \u044d\u043b. \u043f\u043e\u0447\u0442\u0443 \u043f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u0435\u043b\u044f",
    "fi": "Yksitt\u00e4isen tekij\u00e4n s\u00e4hk\u00f6posti",
    "sv": "L\u00e4gg till utf\u00f6rarens e-post",
    "fa": "\u0627\u06cc\u0645\u06cc\u0644 \u06a9\u0627\u0631\u06af\u0631 \u0631\u0627 \u0627\u0636\u0627\u0641\u0647 \u06a9\u0646\u06cc\u062f",
    "ar": "\u0625\u0636\u0627\u0641\u0629 \u0628\u0631\u064a\u062f \u0625\u0644\u0643\u062a\u0631\u0648\u0646\u064a \u0644\u0644\u0639\u0627\u0645\u0644",
    "uk": "\u0414\u043e\u0434\u0430\u0442\u0438 \u0435\u043b\u0435\u043a\u0442\u0440\u043e\u043d\u043d\u0443 \u043f\u043e\u0448\u0442\u0443 \u043f\u0440\u0430\u0446\u0456\u0432\u043d\u0438\u043a\u0430"
  },
  "new_order_desc_inv_worker": {
    "sheet_name": "Web",
    "en": "Invalid email!",
    "ru": "\u041d\u0435\u0432\u0435\u0440\u043d\u044b\u0439 \u0430\u0434\u0440\u0435\u0441 \u044d\u043b\u0435\u043a\u0442\u0440\u043e\u043d\u043d\u043e\u0439 \u043f\u043e\u0447\u0442\u044b",
    "fi": "S\u00e4hk\u00f6postissa virhe",
    "sv": "Felaktig email",
    "fa": "\u0627\u06cc\u0645\u06cc\u0644 \u0646\u0627\u0645\u0639\u062a\u0628\u0631",
    "ar": "\u0628\u0631\u064a\u062f \u0625\u0644\u0643\u062a\u0631\u0648\u0646\u064a \u062e\u0627\u0637\u0626!",
    "uk": "\u041d\u0435\u043f\u0440\u0430\u0432\u0438\u043b\u044c\u043d\u0430 \u0430\u0434\u0440\u0435\u0441\u0430 \u0435\u043b\u0435\u043a\u0442\u0440\u043e\u043d\u043d\u043e\u0457 \u043f\u043e\u0448\u0442\u0438!"
  },
  "new_order_desc_text_worker": {
    "sheet_name": "Web",
    "en": "Or target this order to an individual worker here by adding the worker's email",
    "ru": "\u0418\u043b\u0438 \u043e\u0442\u043f\u0440\u0430\u0432\u0438\u0442\u0435 \u0437\u0430\u043a\u0430\u0437 \u0437\u043d\u0430\u044e\u0449\u0435\u043c\u0443 \u043f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u0435\u043b\u044e, \u0434\u043e\u0431\u0430\u0432\u044f \u0435\u0433\u043e \u044d\u043b\u0435\u043a\u0442\u0440\u043e\u043d\u043d\u0443\u044e \u043f\u043e\u0447\u0442\u0443",
    "fi": "Kohdista tilaus VAIN tietylle tekij\u00e4lle lis\u00e4\u00e4m\u00e4ll\u00e4 h\u00e4nen s\u00e4hk\u00f6posti",
    "sv": "Vill du ge uppdraget till en redan utvald utf\u00f6rare, l\u00e4gg till hens e-post",
    "fa": "\u06cc\u0627 \u0627\u06cc\u0646 \u0633\u0641\u0627\u0631\u0634 \u0631\u0627 \u0628\u0627 \u0627\u0636\u0627\u0641\u0647 \u06a9\u0631\u062f\u0646 \u0627\u06cc\u0645\u06cc\u0644 \u06a9\u0627\u0631\u06af\u0631 \u062f\u0631 \u0627\u06cc\u0646\u062c\u0627 \u0628\u0647 \u0627\u0648 \u0627\u062e\u062a\u0635\u0627\u0635 \u062f\u0647\u06cc\u062f",
    "ar": "\u0623\u0648 \u0627\u0633\u062a\u0647\u062f\u0641 \u0647\u0630\u0627 \u0627\u0644\u0637\u0644\u0628 \u0644\u0639\u0627\u0645\u0644 \u0641\u0631\u062f\u064a \u0647\u0646\u0627 \u0639\u0646 \u0637\u0631\u064a\u0642 \u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0628\u0631\u064a\u062f \u0627\u0644\u0625\u0644\u0643\u062a\u0631\u0648\u0646\u064a \u0644\u0644\u0639\u0627\u0645\u0644",
    "uk": "\u0410\u0431\u043e  \u0437\u0440\u043e\u0431\u0438\u0442\u0438 \u0446\u0435 \u0437\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f \u0434\u043b\u044f \u043e\u043a\u0440\u0435\u043c\u043e\u0433\u043e \u043f\u0440\u0430\u0446\u0456\u0432\u043d\u0438\u043a\u0430 \u0442\u0443\u0442, \u0434\u043e\u0434\u0430\u0432\u0448\u0438 \u0435\u043b\u0435\u043a\u0442\u0440\u043e\u043d\u043d\u0443 \u043f\u043e\u0448\u0442\u0443 \u043f\u0440\u0430\u0446\u0456\u0432\u043d\u0438\u043a\u0430"
  },
  "new_order_label_enter_task": {
    "sheet_name": "Web",
    "en": "Enter description",
    "ru": "\u0414\u043e\u0431\u0430\u0432\u0438\u0442\u044c \u043e\u043f\u0438\u0441\u0430\u043d\u0438\u0435 \u0440\u0430\u0431\u043e\u0442\u044b",
    "fi": "Lis\u00e4\u00e4 kuvaus",
    "sv": "L\u00e4gg till en uppdragsbeskrivning",
    "fa": "\u062a\u0648\u0636\u06cc\u062d\u0627\u062a \u06a9\u0627\u0631 (\u0648\u0638\u06cc\u0641\u0647) \u0631\u0627 \u0648\u0627\u0631\u062f \u06a9\u0646\u06cc\u062f",
    "ar": "\u0623\u062f\u062e\u0644 \u0648\u0635\u0641 \u0627\u0644\u0645\u0647\u0645\u0629",
    "uk": "\u0412\u0432\u0435\u0434\u0456\u0442\u044c \u043e\u043f\u0438\u0441 \u0437\u0430\u0432\u0434\u0430\u043d\u043d\u044f"
  },
  "new_order_label_pick": {
    "sheet_name": "Web",
    "en": "Pick a category",
    "ru": "\u0412\u044b\u0431\u0435\u0440\u0438\u0442\u0435 \u043a\u0430\u0442\u0435\u0433\u043e\u0440\u0438\u044e",
    "fi": "Valitse teht\u00e4v\u00e4n kategoria",
    "sv": "V\u00e4lj en uppdragskategori",
    "fa": "\u06cc\u06a9 \u062f\u0633\u062a\u0647 \u0631\u0627 \u0627\u0646\u062a\u062e\u0627\u0628 \u06a9\u0646\u06cc\u062f",
    "ar": "\u0627\u062e\u062a\u0631 \u0641\u0626\u0629",
    "uk": "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044c \u043a\u0430\u0442\u0435\u0433\u043e\u0440\u0456\u044e"
  },
  "new_order_label_add_info": {
    "sheet_name": "Web",
    "en": "Additional info",
    "ru": "\u0414\u043e\u043f\u043e\u043b\u043d\u0438\u0442\u0435\u043b\u044c\u043d\u0430\u044f \u0438\u043d\u0444\u043e\u0440\u043c\u0430\u0446\u0438\u044f",
    "fi": "Lis\u00e4tietoja",
    "sv": "Mer information",
    "fa": "\u0627\u0637\u0644\u0627\u0639\u0627\u062a \u0627\u0636\u0627\u0641\u06cc",
    "ar": "\u0645\u0639\u0644\u0648\u0645\u0627\u062a \u0625\u0636\u0627\u0641\u064a\u0629",
    "uk": "\u0414\u043e\u0434\u0430\u0442\u043a\u043e\u0432\u0430 \u0456\u043d\u0444\u043e\u0440\u043c\u0430\u0446\u0456\u044f"
  },
  "new_order_label_add_team_code": {
    "sheet_name": "Web",
    "en": "Add private team code",
    "ru": "\u0414\u043e\u0431\u0430\u0432\u0438\u0442\u044c \u043b\u0438\u0447\u043d\u044b\u0439 \u043a\u043e\u0434 \u0433\u0440\u0443\u043f\u043f\u044b",
    "fi": "Lis\u00e4\u00e4 yksityisen ryhm\u00e4n p\u00e4\u00e4sykoodi",
    "sv": "L\u00e4gg till en privat gruppkod",
    "fa": "\u06a9\u062f \u06af\u0631\u0648\u0647 \u062e\u0635\u0648\u0635\u06cc \u0631\u0627 \u0627\u0636\u0627\u0641\u0647 \u06a9\u0646\u06cc\u062f",
    "ar": "\u0623\u0636\u0641 \u0631\u0645\u0632 \u0627\u0644\u0641\u0631\u064a\u0642 \u0627\u0644\u062e\u0627\u0635",
    "uk": "\u0414\u043e\u0434\u0430\u0442\u0438 \u043a\u043e\u0434 \u043f\u0440\u0438\u0432\u0430\u0442\u043d\u043e\u0457 \u0433\u0440\u0443\u043f\u0438"
  },
  "new_order_header_desc": {
    "sheet_name": "Web",
    "en": "Description",
    "ru": "\u041e\u043f\u0438\u0441\u0430\u043d\u0438\u0435",
    "fi": "Kuvaus",
    "sv": "Beskrivning",
    "fa": "\u062a\u0648\u0636\u06cc\u062d\u0627\u062a",
    "ar": "\u0648\u0635\u0641",
    "uk": "\u041e\u043f\u0438\u0441"
  },
  "new_order_header_loc": {
    "sheet_name": "Web",
    "en": "Location",
    "ru": "\u041c\u0435\u0441\u0442\u043e \u043d\u0430\u0445\u043e\u0436\u0434\u0435\u043d\u0438\u044f",
    "fi": "Sijainti",
    "sv": "Plats",
    "fa": "\u0645\u0648\u0642\u0639\u06cc\u062a",
    "ar": "\u0645\u0648\u0642\u0639",
    "uk": "\u041c\u0456\u0441\u0446\u0435\u0437\u043d\u0430\u0445\u043e\u0434\u0436\u0435\u043d\u043d\u044f"
  },
  "new_order_header_pay": {
    "sheet_name": "Web",
    "en": "Payment",
    "ru": "\u041e\u043f\u043b\u0430\u0442\u0430",
    "fi": "Maksu",
    "sv": "Betalning",
    "fa": "\u067e\u0631\u062f\u0627\u062e\u062a",
    "ar": "\u062f\u0641\u0639",
    "uk": "\u041f\u043b\u0430\u0442\u0456\u0436"
  },
  "new_order_header_sum": {
    "sheet_name": "Web",
    "en": "Summary",
    "ru": "\u0421\u0443\u043c\u043c\u0430",
    "fi": "Yhteenveto",
    "sv": "Sammanfattning",
    "fa": "\u062c\u0645\u0639 \u0628\u0646\u062f\u06cc",
    "ar": "\u0645\u0644\u062e\u0635",
    "uk": "\u041f\u0456\u0434\u0441\u0443\u043c\u043e\u043a"
  },
  "new_order_sum_neworder": {
    "sheet_name": "Web",
    "en": "New order",
    "ru": "\u041d\u043e\u0432\u044b\u0439 \u0437\u0430\u043a\u0430\u0437",
    "fi": "Uusi tilaus",
    "sv": "Nytt uppdrag",
    "fa": "\u0633\u0641\u0627\u0631\u0634 \u062c\u062f\u06cc\u062f",
    "ar": "\u0637\u0644\u0628 \u062c\u062f\u064a\u062f",
    "uk": "\u041d\u043e\u0432\u0435 \u0437\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f"
  },
  "new_order_sum_publish": {
    "sheet_name": "Web",
    "en": "Publish this order?",
    "ru": "\u041e\u043f\u0443\u0431\u043b\u0438\u043a\u043e\u0432\u0430\u0442\u044c \u0437\u0430\u043a\u0430\u0437?",
    "fi": "Julkaise tilaus?",
    "sv": "Publicera order?",
    "fa": "\u0622\u06cc\u0627 \u0645\u06cc\u062e\u0648\u0627\u0647\u06cc\u062f \u0627\u06cc\u0646 \u0633\u0641\u0627\u0631\u0634 \u0631\u0627 \u0645\u0646\u062a\u0634\u0631 \u06a9\u0646\u06cc\u062f\u061f",
    "ar": "\u0647\u0644 \u062a\u0631\u064a\u062f \u0646\u0634\u0631 \u0647\u0630\u0627 \u0627\u0644\u0637\u0644\u0628\u061f",
    "uk": "\u041e\u043f\u0440\u0438\u043b\u044e\u0434\u043d\u0438\u0442\u0438 \u0446\u0435 \u0437\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f?"
  },
  "new_order_sum_taskdesc": {
    "sheet_name": "Web",
    "en": "Description",
    "ru": "\u041e\u043f\u0438\u0441\u0430\u043d\u0438\u0435",
    "fi": "Kuvaus",
    "sv": "Beskrivning",
    "fa": "\u062a\u0648\u0636\u06cc\u062d\u0627\u062a \u0648\u0638\u06cc\u0641\u0647",
    "ar": "\u0648\u0635\u0641 \u0639\u0646 \u0627\u0644\u0639\u0645\u0644",
    "uk": "\u041e\u043f\u0438\u0441 \u0437\u0430\u0432\u0434\u0430\u043d\u043d\u044f"
  },
  "new_order_sum_type": {
    "sheet_name": "Web",
    "en": "Service",
    "ru": "\u0422\u0438\u043f",
    "fi": "Palvelu",
    "sv": "Service",
    "fa": "\u0646\u0648\u0639",
    "ar": "\u0627\u0644\u0646\u0648\u0639",
    "uk": "\u041f\u043e\u0441\u043b\u0443\u0433\u0430"
  },
  "new_order_sum_teams": {
    "sheet_name": "Web",
    "en": "Teams",
    "ru": "\u0413\u0440\u0443\u043f\u043f\u044b",
    "fi": "Ryhm\u00e4t",
    "sv": "Grupp",
    "fa": "\u06af\u0631\u0648\u0647 \u0647\u0627",
    "ar": "\u0627\u0644\u0645\u062c\u0645\u0648\u0639\u0627\u062a",
    "uk": "\u0413\u0440\u0443\u043f\u0438"
  },
  "new_order_sum_privteam": {
    "sheet_name": "Web",
    "en": "Private teams",
    "ru": "\u0427\u0430\u0441\u0442\u043d\u044b\u0435 \u0433\u0440\u0443\u043f\u043f\u044b.",
    "fi": "Yksityiset ryhm\u00e4t",
    "sv": "Privat grupp",
    "fa": "\u06af\u0631\u0648\u0647 \u0647\u0627\u06cc \u062e\u0635\u0648\u0635\u06cc",
    "ar": "\u0645\u062c\u0645\u0648\u0639\u0627\u062a \u062e\u0627\u0635\u0629",
    "uk": "\u041f\u0440\u0438\u0432\u0430\u0442\u043d\u0456 \u0433\u0440\u0443\u043f\u0438"
  },
  "new_order_sum_amount": {
    "sheet_name": "Web",
    "en": "Amount",
    "ru": "\u041a\u043e\u043b\u0438\u0447\u0435\u0441\u0442\u0432\u043e",
    "fi": "M\u00e4\u00e4r\u00e4",
    "sv": "Antal",
    "fa": "\u0645\u0642\u062f\u0627\u0631",
    "ar": "\u0627\u0644\u0645\u062c\u0645\u0648\u0639",
    "uk": "\u041a\u0456\u043b\u044c\u043a\u0456\u0441\u0442\u044c"
  },
  "new_order_sum_payment": {
    "sheet_name": "Web",
    "en": "Payment method",
    "ru": "\u041f\u043b\u0430\u0442\u0435\u0436\u043d\u044b\u0435 \u0441\u0447\u0435\u0442\u0430",
    "fi": "Maksutavat",
    "sv": "Betalningsmetoder",
    "fa": "\u0646\u0648\u0639 \u067e\u0631\u062f\u0627\u062e\u062a",
    "ar": "\u0637\u0631\u064a\u0642\u0629 \u0627\u0644\u062f\u0641\u0639",
    "uk": "\u0421\u043f\u043e\u0441\u0456\u0431 \u043e\u043f\u043b\u0430\u0442\u0438"
  },
  "new_order_sum_price": {
    "sheet_name": "Web",
    "en": "Price",
    "ru": "\u0426\u0435\u043d\u0430",
    "fi": "Hinta",
    "sv": "Pris",
    "fa": "\u0646\u0631\u062e",
    "ar": "\u0627\u0644\u0633\u0639\u0631",
    "uk": "\u0426\u0456\u043d\u0430"
  },
  "new_order_sum_vat": {
    "sheet_name": "Web",
    "en": "VAT",
    "ru": "\u041d\u0430\u043b\u043e\u0433\u0438",
    "fi": "ALV",
    "sv": "moms",
    "fa": "\u0645\u0627\u0644\u06cc\u0627\u062a \u0628\u0631 \u0627\u0631\u0632\u0634 \u0627\u0641\u0632\u0648\u062f\u0647",
    "ar": "\u0636\u0631\u064a\u0628\u0629 \u0627\u0644\u0642\u064a\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629",
    "uk": "\u041f\u043e\u0434\u0430\u0442\u043a\u0438"
  },
  "new_order_sum_total": {
    "sheet_name": "Web",
    "en": "Total",
    "ru": "\u041a\u043e\u043b\u0438\u0447\u0435\u0441\u0442\u0432\u043e",
    "fi": "Yhteens\u00e4",
    "sv": "Totalt",
    "fa": "\u0645\u062c\u0645\u0648\u0639",
    "ar": "\u0627\u0644\u0645\u062c\u0645\u0648\u0639",
    "uk": "\u041a\u0456\u043b\u044c\u043a\u0456\u0441\u0442\u044c"
  },
  "new_order_not_en_pp": {
    "sheet_name": "Web",
    "en": "You do not have enough PilotPoints!",
    "ru": "\u041d\u0435\u0434\u043e\u0441\u0442\u0430\u0442\u043e\u0447\u043d\u043e PilotPoints!",
    "fi": "Sinulla ei ole riitt\u00e4v\u00e4sti PilotPointseja",
    "sv": "Du har inte tillr\u00e4ckligt m\u00e5nga PilotPoints",
    "fa": "\u0645\u062a\u0623\u0633\u0641\u0627\u0646\u0647 \u062f\u0631 \u06a9\u0627\u0631\u062a \u0634\u0645\u0627 \u0645\u0634\u06a9\u0644\u06cc \u067e\u06cc\u0634 \u0622\u0645\u062f. \u0644\u0637\u0641\u0627 \u062f\u0631 \u0645\u0648\u0631\u062f \u0627\u06cc\u0646 \u0645\u0634\u06a9\u0644 \u0628\u0627 \u0635\u0627\u062f\u0631\u06a9\u0646\u0646\u062f\u0647 \u06a9\u0627\u0631\u062a \u062e\u0648\u062f \u062a\u0645\u0627\u0633 \u0628\u06af\u06cc\u0631\u06cc\u062f.",
    "ar": "\u0644\u064a\u0633 \u0644\u062f\u064a\u0643 \u0645\u0627 \u064a\u0643\u0641\u064a \u0645\u0646 \u0646\u0642\u0627\u0637 PilotPoints!",
    "uk": "\u0412\u0430\u043c \u043d\u0435 \u0432\u0438\u0441\u0442\u0430\u0447\u0430\u0454 PilotPoints!"
  },
  "new_order_sum_w_em": {
    "sheet_name": "Web",
    "en": "Worker's email address",
    "ru": "",
    "fi": "Yksitt\u00e4isen tekij\u00e4n s\u00e4hk\u00f6posti",
    "sv": "Utf\u00f6rarens e-postadress",
    "fa": "",
    "ar": "",
    "uk": "\u0415\u043b\u0435\u043a\u0442\u0440\u043e\u043d\u043d\u0430 \u0430\u0434\u0440\u0435\u0441\u0430 \u043f\u0440\u0430\u0446\u0456\u0432\u043d\u0438\u043a\u0430"
  },
  "new_order_desc_noteams": {
    "sheet_name": "Web",
    "en": "No public teams in this service",
    "ru": "\u0423 \u0432\u0430\u0441 \u0435\u0449\u0435 \u043d\u0435\u0442 \u0433\u0440\u0443\u043f\u043f\u044b",
    "fi": "Palvelussa ei julkisia ryhmi\u00e4",
    "sv": "Det finns inga grupper \u00e4nnu.",
    "fa": "\u0647\u0646\u0648\u0632 \u06af\u0631\u0648\u0647\u06cc \u0648\u062c\u0648\u062f \u0646\u062f\u0627\u0631\u062f",
    "ar": "\u0644\u0627 \u0641\u0631\u0642 \u062d\u062a\u0649 \u0627\u0644\u0627\u0646",
    "uk": "\u0423 \u0432\u0430\u0441 \u0449\u0435 \u043d\u0435\u043c\u0430\u0454  \u0433\u0440\u0443\u043f"
  },
  "new_order_desc_teamname": {
    "sheet_name": "Web",
    "en": "Team name:",
    "ru": "\u041d\u0430\u0437\u0432\u0430\u043d\u0438\u0435 \u0433\u0440\u0443\u043f\u043f\u044b",
    "fi": "Ryhm\u00e4n nimi:",
    "sv": "Gruppens namn:",
    "fa": "\u0646\u0627\u0645 \u06af\u0631\u0648\u0647:",
    "ar": "\u0627\u0633\u0645 \u0627\u0644\u0641\u0631\u064a\u0642",
    "uk": "\u041d\u0430\u0437\u0432\u0430 \u0433\u0440\u0443\u043f\u0438:"
  },
  "new_order_desc_workername": {
    "sheet_name": "Web",
    "en": "Worker's name:",
    "ru": "\u0418\u043c\u044f \u0440\u0430\u0431\u043e\u0442\u043d\u0438\u043a\u0430",
    "fi": "Tekij\u00e4n nimi:",
    "sv": "Utf\u00f6rarens namn:",
    "fa": "\u0646\u0627\u0645 \u06a9\u0627\u0631\u06af\u0631:",
    "ar": "\u0627\u0633\u0645 \u0627\u0644\u0639\u0627\u0645\u0644",
    "uk": "\u0406\u043c'\u044f \u043f\u0440\u0430\u0446\u0456\u0432\u043d\u0438\u043a\u0430:"
  },
  "new_order_target_label": {
    "sheet_name": "Web",
    "en": "Target",
    "ru": "",
    "fi": "Kohdennus",
    "sv": "Inriktning",
    "fa": "",
    "ar": "",
    "uk": "\u0426\u0456\u043b\u044c"
  },
  "new_order_target_desc": {
    "sheet_name": "Web",
    "en": "By default your order will be visible to all workers interested in the task. However, you can also target the order, which means it will be visible to specific workers. If you don\u2019t want to target the order, just move to the next page by clicking \u201cNEXT\u201d.\"",
    "ru": "",
    "fi": "Oletuksena tilauksesi tulee n\u00e4kyviin kaikille teht\u00e4v\u00e4st\u00e4 kiinnostuneille tekij\u00f6ille. Voit kuitenkin my\u00f6s kohdistaa tilauksen, mik\u00e4 tarkoittaa, ett\u00e4 se tulee n\u00e4kyviin tietyille tekij\u00f6ille. Jos et halua kohdentaa tilausta, voit siirty\u00e4 suoraan seuraavalle sivulle painamalla \"JATKA\" nappia.",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0417\u0430 \u0437\u0430\u043c\u043e\u0432\u0447\u0443\u0432\u0430\u043d\u043d\u044f\u043c \u0432\u0430\u0448\u0435 \u0437\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f \u0431\u0443\u0434\u0435 \u0432\u0438\u0434\u043d\u043e \u0432\u0441\u0456\u043c \u043f\u0440\u0430\u0446\u0456\u0432\u043d\u0438\u043a\u0430\u043c, \u0437\u0430\u0446\u0456\u043a\u0430\u0432\u043b\u0435\u043d\u0438\u043c \u0443 \u0437\u0430\u0432\u0434\u0430\u043d\u043d\u0456. \u041e\u0434\u043d\u0430\u043a, \u0432\u0438 \u0442\u0430\u043a\u043e\u0436 \u043c\u043e\u0436\u0435\u0442\u0435 \u043d\u0430\u0446\u0456\u043b\u0438\u0442\u0438 \u0437\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f, \u0449\u043e \u043e\u0437\u043d\u0430\u0447\u0430\u0454, \u0449\u043e \u0432\u043e\u043d\u043e \u0431\u0443\u0434\u0435 \u0432\u0438\u0434\u0438\u043c\u0438\u043c \u0434\u043b\u044f \u043a\u043e\u043d\u043a\u0440\u0435\u0442\u043d\u0438\u0445 \u043f\u0440\u0430\u0446\u0456\u0432\u043d\u0438\u043a\u0456\u0432. \u042f\u043a\u0449\u043e \u0432\u0438 \u043d\u0435 \u0445\u043e\u0447\u0435\u0442\u0435 \u0442\u0430\u0440\u0433\u0435\u0442\u0443\u0432\u0430\u0442\u0438 \u0437\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f, \u043f\u0440\u043e\u0441\u0442\u043e \u043f\u0435\u0440\u0435\u0439\u0434\u0456\u0442\u044c \u043d\u0430 \u043d\u0430\u0441\u0442\u0443\u043f\u043d\u0443 \u0441\u0442\u043e\u0440\u0456\u043d\u043a\u0443, \u043d\u0430\u0442\u0438\u0441\u043d\u0443\u0432\u0448\u0438 \u043a\u043d\u043e\u043f\u043a\u0443 \"\u0414\u0410\u041b\u0406\".\""
  },
  "orderer_teams_title": {
    "sheet_name": "Web",
    "en": "Teams",
    "ru": "\u0413\u0440\u0443\u043f\u043f\u044b",
    "fi": "Ryhm\u00e4t",
    "sv": "Grupp",
    "fa": "\u062a\u06cc\u0645 \u0647\u0627",
    "ar": "\u0627\u0644\u0645\u062c\u0645\u0648\u0639\u0627\u062a",
    "uk": "\u0413\u0440\u0443\u043f\u0438"
  },
  "orderer_teams_confirm_title": {
    "sheet_name": "Web",
    "en": "Confirm changes",
    "ru": "\u041f\u043e\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044c \u0438\u0437\u043c\u0435\u043d\u0435\u043d\u0438\u044f",
    "fi": "Vahvista muutokset",
    "sv": "Godk\u00e4nn \u00e4ndringar",
    "fa": "\u062a\u063a\u06cc\u06cc\u0631\u0627\u062a \u0631\u0627 \u062a\u0623\u06cc\u06cc\u062f \u06a9\u0646\u06cc\u062f",
    "ar": "\u062a\u0623\u0643\u064a\u062f \u0627\u0644\u062a\u063a\u064a\u0631\u0627\u062a",
    "uk": "\u041f\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438 \u0437\u043c\u0456\u043d\u0438"
  },
  "orderer_teams_confirm_label": {
    "sheet_name": "Web",
    "en": "Confirm",
    "ru": "\u043f\u043e\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044c",
    "fi": "Vahvista",
    "sv": "Godk\u00e4nn",
    "fa": "\u062a\u0627\u06cc\u06cc\u062f",
    "ar": "\u062a\u0623\u0643\u064a\u062f",
    "uk": "\u041f\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438"
  },
  "orderer_teams_cancel_label": {
    "sheet_name": "Web",
    "en": "Cancel",
    "ru": "\u043e\u0442\u043c\u0435\u043d\u0438\u0442\u044c",
    "fi": "Peruuta",
    "sv": "Avbryta",
    "fa": "\u0644\u063a\u0648",
    "ar": "\u062a\u0631\u0627\u062c\u0639",
    "uk": "\u0421\u043a\u0430\u0441\u0443\u0432\u0430\u0442\u0438"
  },
  "orderer_teams_add_label": {
    "sheet_name": "Web",
    "en": "Add",
    "ru": "\u0414\u043e\u0431\u0430\u0432\u0438\u0442\u044c",
    "fi": "Lis\u00e4\u00e4",
    "sv": "L\u00e4gg till",
    "fa": "\u0627\u0636\u0627\u0641\u0647 \u06a9\u0631\u062f\u0646",
    "ar": "\u0625\u0636\u0627\u0641\u0629",
    "uk": "\u0414\u043e\u0434\u0430\u0442\u0438"
  },
  "orderer_teams_close_label": {
    "sheet_name": "Web",
    "en": "Close",
    "ru": "\u0417\u0430\u043a\u0440\u044b\u0442\u044c",
    "fi": "Sulje",
    "sv": "St\u00e4ng",
    "fa": "\u0628\u0633\u062a\u0646",
    "ar": "\u0642\u0641\u0644",
    "uk": "\u0417\u0430\u043a\u0440\u0438\u0442\u0438"
  },
  "orderer_teams_remove_label": {
    "sheet_name": "Web",
    "en": "Remove",
    "ru": "\u0423\u0434\u0430\u043b\u0438\u0442\u044c",
    "fi": "Poista",
    "sv": "Ta bort",
    "fa": "\u062d\u0630\u0641",
    "ar": "\u062d\u0630\u0641",
    "uk": "\u0412\u0438\u0434\u0430\u043b\u0438\u0442\u0438"
  },
  "orderer_teams_team_name_title": {
    "sheet_name": "Web",
    "en": "Team name",
    "ru": "\u041d\u0430\u0437\u0432\u0430\u043d\u0438\u0435 \u0433\u0440\u0443\u043f\u043f\u044b",
    "fi": "Ryhm\u00e4n nimi",
    "sv": "Gruppens namn",
    "fa": "\u0646\u0627\u0645 \u06af\u0631\u0648\u0647",
    "ar": "\u0627\u0633\u0645 \u0627\u0644\u0641\u0631\u064a\u0642",
    "uk": "\u041d\u0430\u0437\u0432\u0430 \u0433\u0440\u0443\u043f\u0438"
  },
  "orderer_teams_team_code_title": {
    "sheet_name": "Web",
    "en": "Team code",
    "ru": "\u041a\u043e\u0434 \u0433\u0440\u0443\u043f\u043f\u044b",
    "fi": "Ryhm\u00e4koodi",
    "sv": "Gruppkod",
    "fa": "\u06a9\u062f \u06af\u0631\u0648\u0647",
    "ar": "\u0631\u0645\u0632 \u0627\u0644\u0641\u0631\u064a\u0642",
    "uk": "\u041a\u043e\u0434 \u0433\u0440\u0443\u043f\u0438"
  },
  "orderer_teams_explanation": {
    "sheet_name": "Web",
    "en": "Create your own private team! When using your team code (5 own char + 3 system generated), orders will only be visible to your team. If you want to create several teams or add more than five workers to your team, please contact us.",
    "ru": "\u0422\u0435\u043f\u0435\u0440\u044c \u0432\u044b \u043c\u043e\u0436\u0435\u0442\u0435 \u0441\u043e\u0437\u0434\u0430\u0432\u0430\u0442\u044c \u0441\u043e\u0431\u0441\u0442\u0432\u0435\u043d\u043d\u044b\u0435 \u0433\u0440\u0443\u043f\u043f\u044b. \u041f\u0435\u0440\u0432\u0430\u044f \u0433\u0440\u0443\u043f\u043f\u0430, \u0432 \u043a\u043e\u0442\u043e\u0440\u043e\u0439 5 \u0447\u0435\u043b\u043e\u0432\u0435\u043a \u0431\u0435\u0441\u043f\u043b\u0430\u0442\u043d\u043e. \u041a\u043e\u0433\u0434\u0430 \u0438\u0441\u043f\u043e\u043b\u044c\u0437\u0443\u0435\u0442\u0441\u044f \u043a\u043e\u0434 \u0433\u0440\u0443\u043f\u043f\u044b ( 5 \u0441\u0432\u043e\u0438\u0445 + 3 \u0433\u0435\u043d\u0435\u0440\u0438\u0440\u0443\u044e\u0449\u0438\u0439\u0441\u044f \u0441\u0438\u043c\u0432\u043e\u043b\u043e\u0432 ) \u0432 \u044d\u0442\u043e\u043c \u0441\u043b\u0443\u0447\u0430\u0438 \u0437\u0430\u043a\u0430\u0437 \u043d\u0430\u043f\u0440\u0430\u0432\u043b\u0435\u043d \u0442\u043e\u043b\u044c\u043a\u043e \u043d\u0430 \u0443\u0447\u0430\u0441\u0442\u043d\u0438\u043a\u043e\u0432 \u0433\u0440\u0443\u043f\u043f\u044b. \u0415\u0441\u043b\u0438 \u0432\u044b \u0445\u043e\u0442\u0438\u0442\u0435 \u0431\u043e\u043b\u044c\u0448\u0435 \u0433\u0440\u0443\u043f\u043f \u0438\u043b\u0438 \u0447\u043b\u0435\u043d\u043e\u0432 \u0432 \u0433\u0440\u0443\u043f\u043f\u0443, \u0441\u0432\u044f\u0436\u0438\u0442\u0435\u0441\u044c \u0441 \u043d\u0430\u043c\u0438.",
    "fi": "Muodosta oma yksityinen ryhm\u00e4si! Kun ryhm\u00e4koodiasi (5 omaa merkki\u00e4 + 3 generoitua merkki\u00e4) k\u00e4ytet\u00e4\u00e4n tilauksessa niin tilaukset tulevat n\u00e4kyviin vain ryhm\u00e4si j\u00e4senille. Jos haluat luoda useamman ryhm\u00e4n tai lis\u00e4t\u00e4 ryhm\u00e4\u00e4si enemm\u00e4n kuin viisi j\u00e4sent\u00e4 niin ota yhteytt\u00e4.",
    "sv": "Skapa dina egna privata grupper! N\u00e4r du anv\u00e4nder din gruppkod (5 egna char + 3 system genererade) kommer best\u00e4llningarna endast att synas i din grupp. Om du vill ha mera grupper eller l\u00e4gga till fler \u00e4n fem  uppdragstagare till din grupp, kontakta oss.",
    "fa": "\u0627\u06a9\u0646\u0648\u0646 \u0645\u06cc \u062a\u0648\u0627\u0646\u06cc\u062f \u06af\u0631\u0648\u0647 \u0647\u0627\u06cc \u062e\u0635\u0648\u0635\u06cc \u06a9\u0627\u0631\u06af\u0631\u0627\u0646 \u062e\u0648\u062f \u0631\u0627 \u0627\u06cc\u062c\u0627\u062f \u06a9\u0646\u06cc\u062f. \u0627\u0648\u0644\u06cc\u0646 \u06af\u0631\u0648\u0647 \u0634\u0645\u0627 \u062a\u0627 5 \u06a9\u0627\u0631\u06af\u0631 \u0631\u0627\u06cc\u06af\u0627\u0646 \u0627\u0633\u062a. \u0647\u0646\u06af\u0627\u0645 \u0627\u0633\u062a\u0641\u0627\u062f\u0647 \u0627\u0632 \u06a9\u062f \u0645\u0631\u062a\u0628\u0637 (\u0633\u06cc\u0633\u062a\u0645 \u062a\u0648\u0644\u06cc\u062f 5 \u06a9\u0627\u0631\u0627\u06a9\u062a\u0631 + 3) \u060c \u0633\u0641\u0627\u0631\u0634\u0627\u062a \u0641\u0642\u0637 \u0628\u0631\u0627\u06cc \u06af\u0631\u0648\u0647 \u0634\u0645\u0627 \u0642\u0627\u0628\u0644 \u0645\u0634\u0627\u0647\u062f\u0647 \u062e\u0648\u0627\u0647\u062f \u0628\u0648\u062f. \u0627\u06af\u0631 \u0645\u06cc \u062e\u0648\u0627\u0647\u06cc\u062f \u06af\u0631\u0648\u0647 \u06cc\u0627 \u06a9\u0627\u0631\u06af\u0631 \u0628\u06cc\u0634\u062a\u0631\u06cc \u062f\u0627\u0634\u062a\u0647 \u0628\u0627\u0634\u06cc\u062f \u060c \u0644\u0637\u0641\u0627 \u0628\u0627 \u0645\u0627 \u062f\u0631 \u062a\u0645\u0627\u0633 \u0628\u06af\u06cc\u0631\u06cc\u062f.",
    "ar": "\u064a\u0645\u0643\u0646\u0643 \u0627\u0644\u0622\u0646 \u0625\u0646\u0634\u0627\u0621 \u0641\u0631\u0642\u0643 \u0627\u0644\u062e\u0627\u0635\u0629 \u0645\u0646 \u0627\u0644\u0639\u0645\u0627\u0644. \u0641\u0631\u064a\u0642\u0643 \u0627\u0644\u0623\u0648\u0644 \u064a\u0635\u0644 \u0625\u0644\u0649 5 \u0639\u0645\u0627\u0644 \u0645\u062c\u0627\u0646\u064a. \u0639\u0646\u062f \u0627\u0633\u062a\u062e\u062f\u0627\u0645 \u0627\u0644\u0631\u0645\u0632 \u0627\u0644\u0645\u0631\u062a\u0628\u0637 (\u062a\u0645 \u0625\u0646\u0634\u0627\u0621 5 \u0623\u062d\u0631\u0641 \u062e\u0627\u0635\u0629 + 3 \u0646\u0638\u0627\u0645) \u060c \u0633\u062a\u0643\u0648\u0646 \u0627\u0644\u0637\u0644\u0628\u0627\u062a \u0645\u0631\u0626\u064a\u0629 \u0641\u0642\u0637 \u0644\u0641\u0631\u064a\u0642\u0643. \u0625\u0630\u0627 \u0643\u0646\u062a \u062a\u0631\u064a\u062f \u0627\u0644\u0645\u0632\u064a\u062f \u0645\u0646 \u0627\u0644\u0641\u0631\u0642 \u0623\u0648 \u0627\u0644\u0639\u0645\u0627\u0644 \u060c \u064a\u0631\u062c\u0649 \u0627\u0644\u0627\u062a\u0635\u0627\u0644 \u0628\u0646\u0627.",
    "uk": "\u0422\u0435\u043f\u0435\u0440 \u0432\u0438 \u043c\u043e\u0436\u0435\u0442\u0435 \u0441\u0442\u0432\u043e\u0440\u044e\u0432\u0430\u0442\u0438 \u0432\u043b\u0430\u0441\u043d\u0456 \u043f\u0440\u0438\u0432\u0430\u0442\u043d\u0456 \u0433\u0440\u0443\u043f\u0438 \u0440\u043e\u0431\u0456\u0442\u043d\u0438\u043a\u0456\u0432. \u041f\u0440\u0438 \u0432\u0438\u043a\u043e\u0440\u0438\u0441\u0442\u0430\u043d\u043d\u0456 \u0430\u0441\u043e\u0446\u0456\u0439\u043e\u0432\u0430\u043d\u043e\u0433\u043e \u043a\u043e\u0434\u0443 (5 \u0432\u043b\u0430\u0441\u043d\u0438\u0445 \u0441\u0438\u043c\u0432\u043e\u043b\u0456\u0432 + 3 \u0437\u0433\u0435\u043d\u0435\u0440\u043e\u0432\u0430\u043d\u0438\u0445 \u0441\u0438\u0441\u0442\u0435\u043c\u043e\u044e) \u0437\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f \u0431\u0443\u0434\u0443\u0442\u044c \u0432\u0438\u0434\u0438\u043c\u0456 \u0442\u0456\u043b\u044c\u043a\u0438 \u0432\u0430\u0448\u0456\u0439 \u0433\u0440\u0443\u043f\u0456. \u0414\u043e\u0434\u0430\u0439\u0442\u0435 \u043d\u043e\u0432\u0438\u0445 \u0447\u043b\u0435\u043d\u0456\u0432 \u0434\u043e \u0441\u0432\u043e\u0454\u0457 \u043a\u043e\u043c\u0430\u043d\u0434\u0438, \u043d\u0430\u0442\u0438\u0441\u043d\u0443\u0432\u0448\u0438 \u043d\u0430 \u043a\u043e\u043c\u0430\u043d\u0434\u0443 \u043d\u0438\u0436\u0447\u0435. \u042f\u043a\u0449\u043e \u0432\u0438 \u0445\u043e\u0447\u0435\u0442\u0435 \u0431\u0456\u043b\u044c\u0448\u0435 \u0433\u0440\u0443\u043f \u0430\u0431\u043e \u043f\u0440\u0430\u0446\u0456\u0432\u043d\u0438\u043a\u0456\u0432, \u0431\u0443\u0434\u044c \u043b\u0430\u0441\u043a\u0430, \u0437\u0432'\u044f\u0436\u0456\u0442\u044c\u0441\u044f \u0437 \u043d\u0430\u043c\u0438"
  },
  "orderer_teams_search_placeholder": {
    "sheet_name": "Web",
    "en": "Search my teams",
    "ru": "",
    "fi": "Etsi ryhmi\u00e4ni",
    "sv": "S\u00f6k i min grupp",
    "fa": "",
    "ar": "",
    "uk": "\u041f\u043e\u0448\u0443\u043a \u0433\u0440\u0443\u043f\u0438"
  },
  "orderer_teams_details_title": {
    "sheet_name": "Web",
    "en": "Team details",
    "ru": "\u0418\u043d\u0444\u043e\u0440\u043c\u0430\u0446\u0438\u044f \u043e \u0433\u0440\u0443\u043f\u043f\u0435",
    "fi": "Ryhm\u00e4n tiedot",
    "sv": "Gruppinformation",
    "fa": "\u062c\u0632\u0626\u06cc\u0627\u062a \u06af\u0631\u0648\u0647",
    "ar": "\u062a\u0641\u0627\u0635\u064a\u0644 \u0627\u0644\u0641\u0631\u064a\u0642",
    "uk": "\u0414\u0435\u0442\u0430\u043b\u044c\u043d\u0430 \u0456\u043d\u0444\u043e\u0440\u043c\u0430\u0446\u0456\u044f \u043f\u0440\u043e \u0433\u0440\u0443\u043f\u0443"
  },
  "orderer_teams_user_label": {
    "sheet_name": "Web",
    "en": "User",
    "ru": "",
    "fi": "K\u00e4ytt\u00e4j\u00e4",
    "sv": "Anv\u00e4ndare",
    "fa": "",
    "ar": "",
    "uk": "\u041a\u043e\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447"
  },
  "orderer_teams_add_user_text": {
    "sheet_name": "Web",
    "en": "Add user to team",
    "ru": "\u0414\u043e\u0431\u0430\u0432\u0438\u0442\u044c \u043f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u0435\u043b\u044f",
    "fi": "Lis\u00e4\u00e4 k\u00e4ytt\u00e4j\u00e4 ryhm\u00e4\u00e4n",
    "sv": "L\u00e4gg till anv\u00e4ndare i gruppen",
    "fa": "\u0627\u0636\u0627\u0641\u0647 \u06a9\u0631\u062f\u0646 \u06a9\u0627\u0631\u0628\u0631 \u0628\u0647 \u06af\u0631\u0648\u0647",
    "ar": "\u0625\u0636\u0627\u0641\u0629 \u0645\u0633\u062a\u062e\u062f\u0645 \u0625\u0644\u0649 \u0627\u0644\u0641\u0631\u064a\u0642",
    "uk": "\u0414\u043e\u0434\u0430\u0442\u0438 \u043a\u043e\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430"
  },
  "orderer_teams_delete_team_label": {
    "sheet_name": "Web",
    "en": "Delete team",
    "ru": "\u0423\u0434\u0430\u043b\u0438\u0442\u044c \u0433\u0440\u0443\u043f\u043f\u0443",
    "fi": "Poista ryhm\u00e4",
    "sv": "Radera gruppen",
    "fa": "\u06af\u0631\u0648\u0647 \u0631\u0627 \u062d\u0630\u0641 \u06a9\u0646\u06cc\u062f",
    "ar": "\u062d\u0630\u0641 \u0627\u0644\u0641\u0631\u064a\u0642",
    "uk": "\u0412\u0438\u0434\u0430\u043b\u0438\u0442\u0438 \u0433\u0440\u0443\u043f\u0443"
  },
  "orderer_teams_team_not_empty_error": {
    "sheet_name": "Web",
    "en": "You need to remove all users from the team before you could delete it.",
    "ru": "\u0432\u0430\u043c \u0441\u043b\u0435\u0434\u0443\u0435\u0442 \u0443\u0434\u0430\u043b\u0438\u0442\u044c \u0432\u0441\u0435\u0445 \u043f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u0435\u043b\u0435\u0439, \u043f\u0435\u0440\u0435\u0434 \u0443\u0434\u0430\u043b\u0438\u043d\u0438\u0435\u043c \u0433\u0440\u0443\u043f\u043f\u044b",
    "fi": "Sinun t\u00e4ytyy poistaa kaikki k\u00e4ytt\u00e4j\u00e4t ryhm\u00e4st\u00e4 ennen kuin voit poistaa ryhm\u00e4n.",
    "sv": "Du m\u00e5ste ta bort alla anv\u00e4ndare fr\u00e5n gruppen innan du kan ta bort den.",
    "fa": "\u0642\u0628\u0644 \u0627\u0632 \u062d\u0630\u0641 \u0622\u0646 \u0628\u0627\u06cc\u062f \u062a\u0645\u0627\u0645 \u06a9\u0627\u0631\u0628\u0631\u0627\u0646 \u0631\u0627 \u0627\u0632 \u06af\u0631\u0648\u0647 \u062d\u0630\u0641 \u06a9\u0646\u06cc\u062f.",
    "ar": "\u062a\u062d\u062a\u0627\u062c \u0625\u0644\u0649 \u0625\u0632\u0627\u0644\u0629 \u062c\u0645\u064a\u0639 \u0627\u0644\u0645\u0633\u062a\u062e\u062f\u0645\u064a\u0646 \u0645\u0646 \u0627\u0644\u0641\u0631\u064a\u0642 \u0642\u0628\u0644 \u0623\u0646 \u062a\u062a\u0645\u0643\u0646 \u0645\u0646 \u062d\u0630\u0641\u0647.",
    "uk": "\u041f\u0435\u0440\u0448 \u043d\u0456\u0436 \u0432\u0438\u0434\u0430\u043b\u0438\u0442\u0438 \u0433\u0440\u0443\u043f\u0443, \u043f\u043e\u0442\u0440\u0456\u0431\u043d\u043e \u0432\u0438\u0434\u0430\u043b\u0438\u0442\u0438 \u0432\u0441\u0456\u0445 \u043a\u043e\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0456\u0432"
  },
  "orderer_teams_team_confirm_text": {
    "sheet_name": "Web",
    "en": "Do you really want to delete this team?",
    "ru": "\u0412\u044b \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043b\u044c\u043d\u043e \u0445\u043e\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043b\u0438\u0442\u044c \u044d\u0442\u0443 \u0433\u0440\u0443\u043f\u043f\u0443",
    "fi": "Haluatko varmasti poistaa t\u00e4m\u00e4n ryhm\u00e4n?",
    "sv": "Vill du verkligen ta bort gruppen?",
    "fa": "\u0622\u06cc\u0627 \u0648\u0627\u0642\u0639\u0627\u064b \u0645\u06cc \u062e\u0648\u0627\u0647\u06cc\u062f \u0627\u06cc\u0646 \u06af\u0631\u0648\u0647 \u0631\u0627 \u062d\u0630\u0641 \u06a9\u0646\u06cc\u062f\u061f",
    "ar": "\u0647\u0644 \u062a\u0631\u064a\u062f \u062d\u0642\u064b\u0627 \u062d\u0630\u0641 \u0647\u0630\u0627 \u0627\u0644\u0641\u0631\u064a\u0642\u061f",
    "uk": "\u0412\u0438 \u0434\u0456\u0439\u0441\u043d\u043e \u0445\u043e\u0447\u0435\u0442\u0435 \u0432\u0438\u0434\u0430\u043b\u0438\u0442\u0438 \u0446\u044e \u0433\u0440\u0443\u043f\u0443?"
  },
  "orderer_teams_user_confirm_text": {
    "sheet_name": "Web",
    "en": "Do you really want to remove this user from the team?",
    "ru": "\u0412\u044b \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043b\u044c\u043d\u043e \u0445\u043e\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043b\u0438\u0442\u044c \u044d\u0442\u043e\u0433\u043e \u043f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u0435\u043b\u044f \u0438\u0437 \u0433\u0440\u0443\u043f\u043f\u044b",
    "fi": "Haluatko varmasti poistaa t\u00e4m\u00e4n tekij\u00e4n ryhm\u00e4st\u00e4?",
    "sv": "Vill du verkligen ta bort den h\u00e4r anv\u00e4ndaren fr\u00e5n gruppen?",
    "fa": "\u0622\u06cc\u0627 \u0648\u0627\u0642\u0639\u0627\u064b \u0645\u06cc \u062e\u0648\u0627\u0647\u06cc\u062f \u0627\u06cc\u0646 \u06a9\u0627\u0631\u0628\u0631 \u0631\u0627 \u0627\u0632 \u06af\u0631\u0648\u0647 \u062d\u0630\u0641 \u06a9\u0646\u06cc\u062f\u061f",
    "ar": "\u0647\u0644 \u062a\u0631\u064a\u062f \u062d\u0642\u064b\u0627 \u0625\u0632\u0627\u0644\u0629 \u0647\u0630\u0627 \u0627\u0644\u0645\u0633\u062a\u062e\u062f\u0645 \u0645\u0646 \u0627\u0644\u0641\u0631\u064a\u0642\u061f",
    "uk": "\u0412\u0438 \u0434\u0456\u0439\u0441\u043d\u043e \u0445\u043e\u0447\u0435\u0442\u0435 \u0432\u0438\u0434\u0430\u043b\u0438\u0442\u0438 \u0446\u044c\u043e\u0433\u043e \u043a\u043e\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430 \u0437 \u0433\u0440\u0443\u043f\u0438?"
  },
  "orderer_teams_add_team_title": {
    "sheet_name": "Web",
    "en": "Add team",
    "ru": "\u0414\u043e\u0431\u0430\u0432\u0438\u0442\u044c \u0433\u0440\u0443\u043f\u043f\u0443",
    "fi": "Lis\u00e4\u00e4 ryhm\u00e4",
    "sv": "L\u00e4gg till en grupp",
    "fa": "\u0627\u0636\u0627\u0641\u0647 \u06a9\u0631\u062f\u0646 \u06af\u0631\u0648\u0647",
    "ar": "\u0625\u0636\u0627\u0641\u0629 \u0641\u0631\u064a\u0642",
    "uk": "\u0414\u043e\u0434\u0430\u0442\u0438 \u0433\u0440\u0443\u043f\u0443"
  },
  "orderer_teams_user_already_member_error": {
    "sheet_name": "Web",
    "en": "This user is already member of the team.",
    "ru": "\u042d\u0442\u043e\u0442 \u043f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u0435\u043b\u044c \u0443\u0436\u0435 \u0441\u043e\u0441\u0442\u043e\u0438\u0442 \u0432 \u0433\u0440\u0443\u043f\u043f\u0435",
    "fi": "T\u00e4m\u00e4 k\u00e4ytt\u00e4j\u00e4 on jo ryhm\u00e4n j\u00e4sen.",
    "sv": "Den h\u00e4r anv\u00e4ndaren \u00e4r redan medlem i gruppen",
    "fa": "\u0627\u06cc\u0646 \u06a9\u0627\u0631\u0628\u0631 \u0642\u0628\u0644\u0627\u064b \u0639\u0636\u0648 \u06af\u0631\u0648\u0647 \u0627\u0633\u062a",
    "ar": "\u0647\u0630\u0627 \u0627\u0644\u0645\u0633\u062a\u062e\u062f\u0645 \u0639\u0636\u0648 \u0628\u0627\u0644\u0641\u0639\u0644 \u0641\u064a \u0627\u0644\u0641\u0631\u064a\u0642",
    "uk": "\u0426\u0435\u0439 \u043a\u043e\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447 \u0432\u0436\u0435 \u0454 \u0443\u0447\u0430\u0441\u043d\u0438\u043a\u043e\u043c \u0433\u0440\u0443\u043f\u0438"
  },
  "worker_teams_title": {
    "sheet_name": "Web",
    "en": "My teams",
    "ru": "\u041c\u043e\u0438 \u0433\u0440\u0443\u043f\u043f\u044b",
    "fi": "Ryhm\u00e4ni",
    "sv": "Mina grupper",
    "fa": "\u062a\u06cc\u0645 \u0647\u0627\u06cc \u0645\u0646",
    "ar": "\u0627\u0644\u0645\u062c\u0645\u0648\u0639\u0627\u062a \u0627\u0644\u062a\u064a \u0627\u0646\u062a\u0645\u064a \u0625\u0644\u064a\u0647\u0627",
    "uk": "\u041c\u043e\u0457 \u0433\u0440\u0443\u043f\u0438"
  },
  "worker_teams_explanation": {
    "sheet_name": "Web",
    "en": "Set which teams you are a member of",
    "ru": "",
    "fi": "Valitse ryhm\u00e4t joissa olet mukana",
    "sv": "Ange vilken grupp du \u00e4r medlem i",
    "fa": "",
    "ar": "",
    "uk": "\u0412\u0441\u0442\u0430\u043d\u043e\u0432\u0438\u0442\u0438, \u0432 \u044f\u043a\u0438\u0445 \u043a\u043e\u043c\u0430\u043d\u0434\u0430\u0445 \u0432\u0438 \u043f\u0435\u0440\u0435\u0431\u0443\u0432\u0430\u0454\u0442\u0435"
  },
  "worker_teams_change_text": {
    "sheet_name": "Web",
    "en": "Public teams",
    "ru": "\u041f\u0443\u0431\u043b\u0438\u0447\u043d\u044b\u0435 \u0433\u0440\u0443\u043f\u043f\u044b.",
    "fi": "Julkiset ryhm\u00e4t",
    "sv": "Offentlig grupp",
    "fa": "\u062a\u06cc\u0645\u0647\u0627\u06cc \u0639\u0645\u0648\u0645\u06cc",
    "ar": "\u0645\u062c\u0645\u0648\u0639\u0627\u062a \u0639\u0627\u0645\u0629",
    "uk": "\u041f\u0443\u0431\u043b\u0456\u0447\u043d\u0456 \u0433\u0440\u0443\u043f\u0438"
  },
  "worker_teams_user_without_teams": {
    "sheet_name": "Web",
    "en": "You do not currently belong to any teams",
    "ru": "",
    "fi": "Et ole t\u00e4ll\u00e4 hetkell\u00e4 mukana miss\u00e4\u00e4n ryhm\u00e4ss\u00e4.",
    "sv": "Du h\u00f6r inte till n\u00e5gon grupp f\u00f6r n\u00e4rvarande",
    "fa": "",
    "ar": "",
    "uk": "\u041d\u0430 \u0434\u0430\u043d\u0438\u0439 \u043c\u043e\u043c\u0435\u043d\u0442 \u0432\u0438 \u043d\u0435 \u043f\u0435\u0440\u0435\u0431\u0443\u0432\u0430\u0454\u0442\u0435 \u0432 \u0436\u043e\u0434\u043d\u0456\u0439 \u0433\u0440\u0443\u043f\u0456"
  },
  "worker_teams_private_teams_title": {
    "sheet_name": "Web",
    "en": "My private teams",
    "ru": "\u041c\u043e\u0438 \u043b\u0438\u0447\u043d\u044b\u0435 \u0433\u0440\u0443\u043f\u043f\u044b",
    "fi": "Yksityiset ryhm\u00e4t",
    "sv": "Mitt privat gruppen",
    "fa": "\u062a\u06cc\u0645 \u0647\u0627\u06cc \u062e\u0635\u0648\u0635\u06cc \u0645\u0646",
    "ar": "\u0645\u062c\u0645\u0648\u0639\u062a\u064a \u0627\u0644\u062e\u0627\u0635\u0629",
    "uk": "\u041c\u043e\u0457 \u043f\u0440\u0438\u0432\u0430\u0442\u043d\u0456 \u0433\u0440\u0443\u043f\u0438"
  },
  "table_header_amount": {
    "sheet_name": "Web",
    "en": "Amount",
    "ru": "\u041a\u043e\u043b\u0438\u0447\u0435\u0441\u0442\u0432\u043e",
    "fi": "M\u00e4\u00e4r\u00e4",
    "sv": "Summa",
    "fa": "\u0645\u0642\u062f\u0627\u0631",
    "ar": "\u0627\u0644\u0645\u062c\u0645\u0648\u0639",
    "uk": "\u0421\u0443\u043c\u0430"
  },
  "table_header_status": {
    "sheet_name": "Web",
    "en": "Status",
    "ru": "\u0421\u0442\u0430\u0442\u0443\u0441",
    "fi": "Status",
    "sv": "Status",
    "fa": "\u0648\u0636\u0639\u06cc\u062a",
    "ar": "\u0627\u0644\u062d\u0627\u0644\u0629",
    "uk": "C\u0442\u0430\u0442\u0443\u0441"
  },
  "txt_select": {
    "sheet_name": "Web",
    "en": "Select",
    "ru": "\u0412\u044b\u0431\u0440\u0430\u0442\u044c",
    "fi": "Valitse",
    "sv": "V\u00e4lj",
    "fa": "\u0627\u0646\u062a\u062e\u0627\u0628 \u06a9\u0646\u06cc\u062f",
    "ar": "\u062a\u062d\u062f\u064a\u062f",
    "uk": "\u0412\u0438\u0431\u0440\u0430\u0442\u0438"
  },
  "pilot_points_pilotpoints": {
    "sheet_name": "Web",
    "en": "PilotPoints",
    "ru": "PilotPoints",
    "fi": "PilotPoints",
    "sv": "PilotPoints",
    "fa": "PilotPoints",
    "ar": "PilotPoints",
    "uk": "PilotPoints"
  },
  "pilot_points_save": {
    "sheet_name": "Web",
    "en": "Save",
    "ru": "\u0421\u043e\u0445\u0440\u0430\u043d\u0438\u0442\u044c",
    "fi": "Tallenna",
    "sv": "Spara",
    "fa": "\u0630\u062e\u06cc\u0631\u0647",
    "ar": "\u062d\u0641\u0638",
    "uk": "\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438"
  },
  "pilot_points_cancel": {
    "sheet_name": "Web",
    "en": "Cancel",
    "ru": "\u043e\u0442\u043c\u0435\u043d\u0438\u0442\u044c",
    "fi": "Peruuta",
    "sv": "Avbryta",
    "fa": "\u0644\u063a\u0648",
    "ar": "\u062a\u0631\u0627\u062c\u0639",
    "uk": "\u0421\u043a\u0430\u0441\u0443\u0432\u0430\u0442\u0438"
  },
  "pilot_points_buy_link_label": {
    "sheet_name": "Web",
    "en": "Buy PilotPoints",
    "ru": "\u041a\u0443\u043f\u0438\u0442\u044c PilotPoints",
    "fi": "Osta",
    "sv": "K\u00f6p PilotPoints",
    "fa": "\u062e\u0631\u06cc\u062f PilotPoints",
    "ar": "\u0634\u0631\u0627\u0621 \u0646\u0642\u0627\u0637 PilotPoints",
    "uk": "\u041a\u0443\u043f\u0438\u0442\u0438 PilotPoints"
  },
  "pilot_points_donate_link_label": {
    "sheet_name": "Web",
    "en": "Transfer PilotPoints",
    "ru": "\u041f\u0435\u0440\u0435\u0434\u0430\u0442\u044c PilotPoints",
    "fi": "Siirr\u00e4",
    "sv": "Donera PilotPoints",
    "fa": "\u0627\u0647\u062f\u0627\u0621 PilotPoints",
    "ar": "\u0646\u0642\u0644 \u0646\u0642\u0627\u0637 PilotPoints",
    "uk": "\u041f\u0435\u0440\u0435\u043d\u0435\u0441\u0442\u0438 PilotPoints"
  },
  "pilot_points_claim_link_label": {
    "sheet_name": "Web",
    "en": "Claim PilotPoints",
    "ru": "\u0417\u0430\u044f\u0432\u0438\u0442\u044c PilotPoints",
    "fi": "Lunasta",
    "sv": "L\u00f6s in PilotPoints",
    "fa": "\u0627\u0633\u062a\u062e\u0631\u0627\u062c PilotPoints",
    "ar": "\u0627\u0644\u0645\u0637\u0627\u0644\u0628\u0629 \u0628\u0627\u0644\u0646\u0642\u0627\u0637",
    "uk": "\u0417\u0430\u044f\u0432\u043a\u0430 \u043d\u0430 \u043e\u0442\u0440\u0438\u043c\u0430\u043d\u043d\u044f PilotPoints"
  },
  "pilot_points_history_link_label": {
    "sheet_name": "Web",
    "en": "PilotPoints History",
    "ru": "\u0418\u0441\u0442\u043e\u0440\u0438\u044f PilotPoints",
    "fi": "Historia",
    "sv": "PilotPoints historik",
    "fa": "\u062a\u0627\u0631\u06cc\u062e\u0686\u0647 PilotPoints",
    "ar": "\u062a\u0627\u0631\u064a\u062e PilotPoints",
    "uk": "\u0406\u0441\u0442\u043e\u0440\u0456\u044f PilotPoints"
  },
  "pilot_points_buy_form_title": {
    "sheet_name": "Web",
    "en": "Buy PilotPoints",
    "ru": "\u041a\u0443\u043f\u0438\u0442\u044c PilotPoints",
    "fi": "Osta PilotPointseja",
    "sv": "K\u00f6p PilotPoints",
    "fa": "\u062e\u0631\u06cc\u062f PilotPoints",
    "ar": "\u0634\u0631\u0627\u0621 \u0646\u0642\u0627\u0637 PilotPoints",
    "uk": "\u041a\u0443\u043f\u0438\u0442\u0438 PilotPoints"
  },
  "pilot_points_buy_explanation_line1": {
    "sheet_name": "Web",
    "en": "Here you can buy PilotPoints!",
    "ru": "\u0417\u0434\u0435\u0441\u044c \u0432\u044b \u043c\u043e\u0436\u0435\u0442\u0435 \u043a\u0443\u043f\u0438\u0442\u044c PilotPoints! \u0412\u044b",
    "fi": "T\u00e4\u00e4lt\u00e4 voit ostaa PilotPointseja!",
    "sv": "H\u00e4r kan du k\u00f6pa PilotPoints!",
    "fa": "\u0634\u0645\u0627 \u0627\u0632 \u0627\u06cc\u0646\u062c\u0627 \u0645\u06cc \u062a\u0648\u0627\u0646\u06cc\u062f PilotPoints \u0631\u0627 \u0628\u062e\u0631\u06cc\u062f!",
    "ar": "\u0647\u0646\u0627 \u064a\u0645\u0643\u0646\u0643 \u0634\u0631\u0627\u0621 \u0646\u0642\u0627\u0637 PilotPoints",
    "uk": "\u0422\u0443\u0442 \u0432\u0438 \u043c\u043e\u0436\u0435\u0442\u0435 \u043f\u0440\u0438\u0434\u0431\u0430\u0442\u0438 PilotPoints!"
  },
  "pilot_points_buy_explanation_line2": {
    "sheet_name": "Web",
    "en": "You can use PilotPoints to pay for orders, give them to people in your organisation",
    "ru": "\u043c\u043e\u0436\u0435\u0442\u0435 \u0438\u0441\u043f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u044c PilotPoints \u0434\u043b\u044f \u043e\u043f\u043b\u0430\u0442\u044b \u0437\u0430\u043a\u0430\u0437\u043e\u0432, \u0438\u043b\u0438 \u0432\u044b",
    "fi": "Voit k\u00e4ytt\u00e4\u00e4 niit\u00e4 maksamiseen, jakaa organisaatiossasi eri henkil\u00f6ille tai",
    "sv": "Du kan anv\u00e4nda PilotPoints till att betala timmar, skicka till kollega eller",
    "fa": "\u0645\u06cc \u062a\u0648\u0627\u0646\u06cc\u062f \u0627\u0632 PilotPoints \u0628\u0631\u0627\u06cc \u067e\u0631\u062f\u0627\u062e\u062a \u0647\u0632\u06cc\u0646\u0647 \u0633\u0641\u0627\u0631\u0634\u0627\u062a \u06cc\u0627 \u0634\u0645\u0627 \u0627\u0633\u062a\u0641\u0627\u062f\u0647 \u06a9\u0646\u06cc\u062f",
    "ar": "\u064a\u0645\u0643\u0646\u0643 \u0627\u0633\u062a\u062e\u062f\u0627\u0645 \u0646\u0642\u0627\u0637 PilotPoints \u0644\u062f\u0641\u0639 \u062b\u0645\u0646 \u0627\u0644\u0637\u0644\u0628\u0627\u062a \u0648\u0645\u0646\u062d\u0647\u0627 \u0644\u0644\u0623\u0634\u062e\u0627\u0635 \u0641\u064a \u0645\u0624\u0633\u0633\u062a\u0643",
    "uk": "\u0412\u0438 \u043c\u043e\u0436\u0435\u0442\u0435 \u0441\u043a\u043e\u0440\u0438\u0441\u0442\u0430\u0442\u0438\u0441\u044f PilotPoints \u0434\u043b\u044f \u043e\u043f\u043b\u0430\u0442\u0438 \u0437\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u044c"
  },
  "pilot_points_buy_explanation_line3": {
    "sheet_name": "Web",
    "en": "or transfer them to a customer or friend.",
    "ru": "\u043c\u043e\u0433\u0443\u0442 \u043f\u0435\u0440\u0435\u0434\u0430\u0442\u044c \u0438\u0445 \u0434\u0440\u0443\u0433\u0443.",
    "fi": "antaa niit\u00e4 asiakkaille tai yst\u00e4ville lahjaksi.",
    "sv": "att donera t.ex till en v\u00e4n eller kund",
    "fa": "\u0645\u06cc \u062a\u0648\u0627\u0646\u062f \u0622\u0646\u0647\u0627 \u0631\u0627 \u0628\u0647 \u06cc\u06a9 \u062f\u0648\u0633\u062a \u0627\u0647\u062f\u0627 \u06a9\u0646\u062f.",
    "ar": "\u0623\u0648 \u0646\u0642\u0644\u0647\u0627 \u0625\u0644\u0649 \u0639\u0645\u064a\u0644 \u0623\u0648 \u0635\u062f\u064a\u0642",
    "uk": "\u0430\u0431\u043e \u043f\u0435\u0440\u0435\u0434\u0430\u0442\u0438 \u0457\u0445 \u043a\u043b\u0456\u0454\u043d\u0442\u0443 \u0447\u0438 \u0434\u0440\u0443\u0433\u0443"
  },
  "pilot_points_buy_your_pp_label": {
    "sheet_name": "Web",
    "en": "Your PilotPoints",
    "ru": "\u0412\u0430\u0448\u0438 PilotPoints",
    "fi": "PilotPointsisi yht",
    "sv": "Dina PilotPoints",
    "fa": "\u0645\u0648\u062c\u0648\u062f\u06cc PilotPoints \u0634\u0645\u0627",
    "ar": "\u0646\u0642\u0627\u0637 PilotPoints \u0627\u0644\u062e\u0627\u0635 \u0628\u0643",
    "uk": "\u0412\u0430\u0448 Pilot Points"
  },
  "pilot_points_buy_buy_amount_label": {
    "sheet_name": "Web",
    "en": "Amount of PilotPoints",
    "ru": "\u041a\u043e\u043b\u0438\u0447\u0435\u0441\u0442\u0432\u043e PilotPoints",
    "fi": "PilotPoints summa",
    "sv": "Antal PilotPoints",
    "fa": "\u0645\u0642\u062f\u0627\u0631 PilotPoints",
    "ar": "\u0645\u0642\u062f\u0627\u0631 \u0646\u0642\u0627\u0637 PilotPoints",
    "uk": "\u041a\u0456\u043b\u044c\u043a\u0456\u0441\u0442\u044c PilotPoints"
  },
  "pilot_points_buy_buy_label": {
    "sheet_name": "Web",
    "en": "Buy",
    "ru": "\u041a\u0423\u041f\u0418\u0422\u042c",
    "fi": "Osta",
    "sv": "K\u00f6p",
    "fa": "\u062e\u0631\u06cc\u062f",
    "ar": "\u0634\u0631\u0627\u0621",
    "uk": "\u041a\u0443\u043f\u0438\u0442\u0438"
  },
  "pilot_points_buy_confirm_title": {
    "sheet_name": "Web",
    "en": "Confirmation",
    "ru": "\u041f\u043e\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043d\u0438\u0435",
    "fi": "Vahvista",
    "sv": "Bekr\u00e4fta",
    "fa": "\u062a\u0627\u0626\u06cc\u062f\u06cc",
    "ar": "\u0627\u0644\u062a\u0623\u0643\u064a\u062f",
    "uk": "\u041f\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043d\u043d\u044f"
  },
  "pilot_points_buy_confirm_confirm_label": {
    "sheet_name": "Web",
    "en": "Confirm",
    "ru": "\u043f\u043e\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044c",
    "fi": "Vahvista",
    "sv": "Godk\u00e4nn",
    "fa": "\u062a\u0627\u06cc\u06cc\u062f",
    "ar": "\u062a\u0623\u0643\u064a\u062f",
    "uk": "\u041f\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438"
  },
  "pilot_points_buy_confirm_cancel_label": {
    "sheet_name": "Web",
    "en": "Cancel",
    "ru": "\u043e\u0442\u043c\u0435\u043d\u0438\u0442\u044c",
    "fi": "Peruuta",
    "sv": "Avbryta",
    "fa": "\u0644\u063a\u0648",
    "ar": "\u062a\u0631\u0627\u062c\u0639",
    "uk": "\u0421\u043a\u0430\u0441\u0443\u0432\u0430\u0442\u0438"
  },
  "pilot_points_buy_confirm_text": {
    "sheet_name": "Web",
    "en": "Please confirm that you want to buy %s PilotPoints for %s %s",
    "ru": "\u041f\u043e\u0436\u0430\u043b\u0443\u0439\u0441\u0442\u0430, \u043f\u043e\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435, \u0447\u0442\u043e \u0432\u044b \u0445\u043e\u0442\u0438\u0442\u0435 \u043a\u0443\u043f\u0438\u0442\u044c %s PilotPoints \u0437\u0430 %s %s",
    "fi": "Vahvistathan, ett\u00e4 haluat ostaa %s PilotPointsia %s %s",
    "sv": "Bekr\u00e4fta att du vill k\u00f6pa %s PilotPoints f\u00f6r %s %s",
    "fa": "\u0644\u0637\u0641\u0627\u064b \u062a\u0623\u06cc\u06cc\u062f \u06a9\u0646\u06cc\u062f \u06a9\u0647 \u0645\u06cc \u062e\u0648\u0627\u0647\u06cc\u062f \u0645\u0642\u062f\u0627\u0631 s% \u0627\u0632 PilotPoints \u0631\u0627 \u0628\u0631\u0627\u06cc s %s% \u062e\u0631\u06cc\u062f\u0627\u0631\u06cc \u06a9\u0646\u06cc\u062f",
    "ar": "\u064a\u0631\u062c\u0649 \u062a\u0623\u0643\u064a\u062f \u0627\u0646\u0643 \u062a\u0631\u064a\u062f \u0634\u0631\u0627\u0621 %s PilotPointsia %s %s",
    "uk": "\u0411\u0443\u0434\u044c \u043b\u0430\u0441\u043a\u0430, \u043f\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0456\u0442\u044c, \u0449\u043e \u0432\u0438 \u0445\u043e\u0447\u0435\u0442\u0435 \u043a\u0443\u043f\u0438\u0442\u0438 %s PilotPoints \u0437\u0430 %s %s"
  },
  "pilot_points_buy_total_text": {
    "sheet_name": "Web",
    "en": "Total (VAT included): %s %s",
    "ru": "\u0412 \u043e\u0431\u0449\u0435\u043c ( \u043d\u0430\u043b\u043e\u0433\u0438 ) %s %s",
    "fi": "Yht. (sis ALV): %s %s",
    "sv": "Totalt (moms ing\u00e5r): %s %s",
    "fa": "\u06a9\u0644 (\u0634\u0627\u0645\u0644 \u0645\u0627\u0644\u06cc\u0627\u062a \u0628\u0631 \u0627\u0631\u0632\u0634 \u0627\u0641\u0632\u0648\u062f\u0647): s %s%",
    "ar": "Yht. (sis ALV): %s %s",
    "uk": "\u0412\u0441\u044c\u043e\u0433\u043e (\u0437 \u041f\u0414\u0412): %s %s"
  },
  "pilot_points_buy_error_amount_is_nan": {
    "sheet_name": "Web",
    "en": "Amount is not a valid number",
    "ru": "\u041e\u0448\u0438\u0431\u043a\u0430 \u0432 \u043a\u043e\u043b\u0438\u0447\u0435\u0441\u0442\u0432\u0435",
    "fi": "M\u00e4\u00e4r\u00e4ss\u00e4 on virhe",
    "sv": "Felaktig summa",
    "fa": "\u0645\u0628\u0644\u063a \u0635\u062d\u06cc\u062d \u0646\u06cc\u0633\u062a!",
    "ar": "\u0627\u0644\u0645\u0628\u0644\u063a \u0644\u064a\u0633 \u0631\u0642\u0645\u064b\u0627 \u0635\u0627\u0644\u062d\u064b\u0627",
    "uk": "\u041f\u043e\u043c\u0438\u043b\u043a\u0430 \u0432 \u0441\u0443\u043c\u0456"
  },
  "pilot_points_buy_error_amount_to_low": {
    "sheet_name": "Web",
    "en": "The minimum amount you can buy is %s PilotPoints",
    "ru": "\u041c\u0438\u043d\u0438\u043c\u0430\u043b\u044c\u043d\u043e\u0435 \u043a\u043e\u043b\u0438\u0447\u0435\u0441\u0442\u0432\u043e \u043a\u043e\u0442\u043e\u0440\u043e\u0435 \u043c\u043e\u0436\u0435\u0442\u0435 \u043a\u0443\u043f\u0438\u0442\u044c %s",
    "fi": "V\u00e4himm\u00e4ism\u00e4\u00e4r\u00e4 mit\u00e4 voit ostaa, on %s PilotPointsia",
    "sv": "Det l\u00e4gsta belopp du kan k\u00f6pa \u00e4r %s PilotPoints",
    "fa": "\u062d\u062f\u0627\u0642\u0644 \u0645\u0628\u0644\u063a\u06cc \u06a9\u0647 \u0634\u0645\u0627 \u0642\u0627\u062f\u0631 \u0628\u0647 \u062e\u0631\u06cc\u062f \u0647\u0633\u062a\u06cc\u062f s%",
    "ar": "\u0627\u0644\u062d\u062f \u0627\u0644\u0623\u062f\u0646\u0649 \u0644\u0644\u0645\u0628\u0644\u063a \u0627\u0644\u0630\u064a \u064a\u0645\u0643\u0646\u0643 \u0634\u0631\u0627\u0624\u0647 \u0647\u0648%s",
    "uk": "\u041c\u0456\u043d\u0456\u043c\u0430\u043b\u044c\u043d\u0430 \u0441\u0443\u043c\u0430, \u044f\u043a\u0443 \u0432\u0438 \u043c\u043e\u0436\u0435\u0442\u0435 \u043a\u0443\u043f\u0438\u0442\u0438, \u0441\u0442\u0430\u043d\u043e\u0432\u0438\u0442\u044c %s"
  },
  "pilot_points_buy_success_text": {
    "sheet_name": "Web",
    "en": "Now you have %s more PilotPoints!",
    "ru": "\u0422\u0435\u043f\u0435\u0440\u044c \u0443 \u0432\u0430\u0441 \u0435\u0441\u0442\u044c %s \u0431\u043e\u043b\u044c\u0448\u0435 PilotPoints!",
    "fi": "Nyt sinulla on %s PilotPointsia lis\u00e4\u00e4!",
    "sv": "Nu har du %s flera PilotPoints!",
    "fa": "\u0627\u06a9\u0646\u0648\u0646 \u0634\u0645\u0627 \u0645\u0642\u062f\u0627\u0631 s% \u0628\u06cc\u0634\u062a\u0631 PilotPoints \u062f\u0627\u0631\u06cc\u062f!",
    "ar": "\u0644\u062f\u064a\u0643 \u0627\u0644\u0627\u0646 \u0645\u0646 %s PilotPointsia \u0627\u0644\u0625\u0636\u0627\u0641\u064a\u0629",
    "uk": "\u0422\u0435\u043f\u0435\u0440 \u0443 \u0432\u0430\u0441 \u0431\u0456\u043b\u044c\u0448\u0435 %s PilotPoints!"
  },
  "pilot_points_buy_payment_failed": {
    "sheet_name": "Web",
    "en": "An error happened while processing your request. Please try another method of payment.",
    "ru": "\u041f\u0440\u0438 \u043e\u0431\u0440\u0430\u0431\u043e\u0442\u043a\u0435 \u0432\u0430\u0448\u0435\u0433\u043e \u0437\u0430\u043f\u0440\u043e\u0441\u0430 \u043f\u0440\u043e\u0438\u0437\u043e\u0448\u043b\u0430 \u043e\u0448\u0438\u0431\u043a\u0430. \u041f\u043e\u0436\u0430\u043b\u0443\u0439\u0441\u0442\u0430, \u043f\u043e\u043f\u0440\u043e\u0431\u0443\u0439\u0442\u0435 \u0434\u0440\u0443\u0433\u0443\u044e \u0444\u043e\u0440\u043c\u0443 \u043e\u043f\u043b\u0430\u0442\u044b.",
    "fi": "Pyynt\u00f6si k\u00e4sittelyss\u00e4 tapahtui virhe. Kokeilethan toista maksutapaa.",
    "sv": "Ett fel uppstod, v\u00e4nligen f\u00f6rs\u00f6k med en annan betalningsmetod.",
    "fa": "\u0647\u0646\u06af\u0627\u0645 \u067e\u0631\u062f\u0627\u0632\u0634 \u062f\u0631\u062e\u0648\u0627\u0633\u062a \u0634\u0645\u0627 \u062e\u0637\u0627\u06cc\u06cc \u0631\u062e \u062f\u0627\u062f. \u0644\u0637\u0641\u0627 \u0634\u06a9\u0644 \u062f\u06cc\u06af\u0631\u06cc \u0627\u0632 \u067e\u0631\u062f\u0627\u062e\u062a \u0631\u0627 \u0627\u0645\u062a\u062d\u0627\u0646 \u06a9\u0646\u06cc\u062f.",
    "ar": "\u0637\u0631\u064a\u0642\u0629 \u0627\u0644\u062f\u0641\u0639",
    "uk": "\u041f\u0456\u0434 \u0447\u0430\u0441 \u043e\u0431\u0440\u043e\u0431\u043a\u0438 \u0432\u0430\u0448\u043e\u0433\u043e \u0437\u0430\u043f\u0438\u0442\u0443 \u0441\u0442\u0430\u043b\u0430\u0441\u044f \u043f\u043e\u043c\u0438\u043b\u043a\u0430. \u0421\u043f\u0440\u043e\u0431\u0443\u0439\u0442\u0435 \u0456\u043d\u0448\u0438\u0439 \u0441\u043f\u043e\u0441\u0456\u0431 \u043e\u043f\u043b\u0430\u0442\u0438"
  },
  "pilot_points_donate_form_title": {
    "sheet_name": "Web",
    "en": "Transfer PilotPoints",
    "ru": "\u041f\u0435\u0440\u0435\u0434\u0430\u0442\u044c PilotPoints",
    "fi": "Siirr\u00e4 PilotPointseja",
    "sv": "Dela ut PilotPoints",
    "fa": "\u0627\u0647\u062f\u0627 PilotPoints",
    "ar": "\u0646\u0642\u0644 \u0646\u0642\u0627\u0637 PilotPoints",
    "uk": "\u041f\u0435\u0440\u0435\u043d\u0435\u0441\u0442\u0438 PilotPoints"
  },
  "pilot_points_donate_explanation_line1": {
    "sheet_name": "Web",
    "en": "Here you can transfer PilotPoints!",
    "ru": "\u0417\u0434\u0435\u0441\u044c \u0412\u044b \u043c\u043e\u0436\u0435\u0442\u0435 \u043f\u0435\u0440\u0435\u0434\u0430\u0442\u044c PilotPoints! \u0412\u044b",
    "fi": "T\u00e4\u00e4ll\u00e4 voit siirt\u00e4\u00e4 PilotPointseja!",
    "sv": "H\u00e4r du kan dela ut PilotPoints!",
    "fa": "\u0634\u0645\u0627 \u0627\u0632 \u0627\u06cc\u0646\u062c\u0627 \u0645\u06cc \u062a\u0648\u0627\u0646\u06cc\u062f PilotPoints \u0631\u0627 \u0627\u0647\u062f\u0627 \u06a9\u0646\u06cc\u062f!",
    "ar": "\u0647\u0646\u0627 \u064a\u0645\u0643\u0646\u0643 \u0646\u0642\u0644 \u0646\u0642\u0627\u0637 PilotPoints",
    "uk": "\u0422\u0443\u0442 \u043c\u043e\u0436\u043d\u0430 \u043f\u0435\u0440\u0435\u043d\u0435\u0441\u0442\u0438 PilotPoints!"
  },
  "pilot_points_donate_explanation_line2": {
    "sheet_name": "Web",
    "en": "You can send PilotPoints to persons in your organisation or give them",
    "ru": "\u043c\u043e\u0436\u0435\u0442\u0435 \u043e\u0442\u043f\u0440\u0430\u0432\u043b\u044f\u0442\u044c PilotPoints \u0434\u0440\u0443\u0433\u0443 \u0438\u043b\u0438 \u043a\u043e\u043b\u043b\u0435\u0433\u0435 \u0432 \u043a\u0430\u0447\u0435\u0441\u0442\u0432\u0435",
    "fi": "Voit jakaa niit\u00e4 organisaatiosi eri henkil\u00f6ille tai antaa lahjaksi",
    "sv": "Du kan skicka PilotPoints till kollega eller",
    "fa": "\u0645\u06cc \u062a\u0648\u0627\u0646\u062f PilotPoints \u0631\u0627 \u0628\u0647 \u06cc\u06a9 \u062f\u0648\u0633\u062a \u06cc\u0627 \u0647\u0645\u06a9\u0627\u0631 \u0627\u0631\u0633\u0627\u0644 \u06a9\u0646\u062f",
    "ar": "\u064a\u0645\u0643\u0646\u0643 \u0625\u0631\u0633\u0627\u0644 \u0646\u0642\u0627\u0637 PilotPoints \u0625\u0644\u0649 \u0623\u0634\u062e\u0627\u0635 \u0641\u064a \u0645\u0624\u0633\u0633\u062a\u0643 \u0623\u0648 \u0645\u0646\u062d\u0647\u0645",
    "uk": "\u0412\u0438 \u043c\u043e\u0436\u0435\u0442\u0435 \u043d\u0430\u0434\u0456\u0441\u043b\u0430\u0442\u0438 PilotPoints \u043e\u0441\u043e\u0431\u0430\u043c \u0443 \u0432\u0430\u0448\u0456\u0439 \u043e\u0440\u0433\u0430\u043d\u0456\u0437\u0430\u0446\u0456\u0457 \u0430\u0431\u043e \u043d\u0430\u0434\u0430\u0442\u0438 \u0457\u0445"
  },
  "pilot_points_donate_explanation_line3": {
    "sheet_name": "Web",
    "en": "to a friend or customer as a gift and allow them to order help.",
    "ru": "\u043f\u043e\u0434\u0430\u0440\u043a\u0430 \u0438 \u043f\u043e\u0437\u0432\u043e\u043b\u0438\u0442\u044c \u0438\u043c \u0437\u0430\u043a\u0430\u0437\u0430\u0442\u044c \u0440\u0430\u0431\u043e\u0442\u0443",
    "fi": "yst\u00e4ville tai asiakkaille ja antaa heille apua arkeen",
    "sv": "ge till kompis eller kompis som en g\u00e5va",
    "fa": "\u0647\u062f\u06cc\u0647 \u062f\u0647\u06cc\u062f \u0648 \u0628\u0647 \u0622\u0646\u0647\u0627 \u0627\u062c\u0627\u0632\u0647 \u062f\u0647\u06cc\u062f \u06a9\u0627\u0631 \u0633\u0641\u0627\u0631\u0634 \u062f\u0647\u0646\u062f",
    "ar": "\u0625\u0644\u0649 \u0635\u062f\u064a\u0642 \u0623\u0648 \u0639\u0645\u064a\u0644 \u0643\u0647\u062f\u064a\u0629 \u0648\u0627\u0644\u0633\u0645\u0627\u062d \u0644\u0647\u0645 \u0628\u0637\u0644\u0628 \u0627\u0644\u0645\u0633\u0627\u0639\u062f\u0629.",
    "uk": "\u0434\u0440\u0443\u0433\u0443 \u0430\u0431\u043e \u043a\u043b\u0456\u0454\u043d\u0442\u0443 \u0432 \u043f\u043e\u0434\u0430\u0440\u0443\u043d\u043e\u043a \u0456 \u0434\u043e\u0437\u0432\u043e\u043b\u0438\u0442\u0438 \u0457\u043c \u0437\u0430\u043c\u043e\u0432\u0438\u0442\u0438 \u0434\u043e\u043f\u043e\u043c\u043e\u0433\u0443"
  },
  "pilot_points_donate_your_pp_label": {
    "sheet_name": "Web",
    "en": "Your PilotPoints",
    "ru": "\u0412\u0430\u0448\u0438 PilotPoints",
    "fi": "PilotPointsisi yht",
    "sv": "Dina PilotPoints",
    "fa": "\u0645\u0648\u062c\u0648\u062f\u06cc PilotPoints \u0634\u0645\u0627",
    "ar": "\u0646\u0642\u0627\u0637 PilotPoints \u0627\u0644\u062e\u0627\u0635 \u0628\u0643",
    "uk": "\u0412\u0430\u0448\u0456 Pilot Points"
  },
  "pilot_points_donate_amount_label": {
    "sheet_name": "Web",
    "en": "Amount of PilotPoints",
    "ru": "\u041a\u043e\u043b\u0438\u0447\u0435\u0441\u0442\u0432\u043e PilotPoints",
    "fi": "PilotPoints summa",
    "sv": "Antal PilotPoints",
    "fa": "\u0645\u0642\u062f\u0627\u0631 PilotPoints",
    "ar": "\u0645\u0642\u062f\u0627\u0631 \u0646\u0642\u0627\u0637 PilotPoints",
    "uk": "\u041a\u0456\u043b\u044c\u043a\u0456\u0441\u0442\u044c PilotPoints"
  },
  "pilot_points_donate_leave_comment_label": {
    "sheet_name": "Web",
    "en": "Leave comment",
    "ru": "\u041e\u0441\u0442\u0430\u0432\u044c\u0442\u0435 \u043a\u043e\u043c\u043c\u0435\u043d\u0442\u0430\u0440\u0438\u0439",
    "fi": "Viestisi",
    "sv": "L\u00e4mna meddelande",
    "fa": "\u0646\u0638\u0631 \u062f\u0647\u06cc\u062f",
    "ar": "\u0631\u0633\u0627\u0644\u062a\u0643",
    "uk": "\u0417\u0430\u043b\u0438\u0448\u0442\u0435 \u043a\u043e\u043c\u0435\u043d\u0442\u0430\u0440"
  },
  "pilot_points_donate_send_to_label": {
    "sheet_name": "Web",
    "en": "Who do you want to send PilotPoints to",
    "ru": "\u041a\u043e\u043c\u0443 \u0412\u044b \u0445\u043e\u0442\u0438\u0442\u0435 \u043e\u0442\u043f\u0440\u0430\u0432\u0438\u0442\u044c PilotPoints",
    "fi": "Kenelle haluat l\u00e4hett\u00e4\u00e4 PilotPointseja?",
    "sv": "Till vem vill du skicka PilotPoints",
    "fa": "\u0634\u0645\u0627 \u0645\u06cc \u062e\u0648\u0627\u0647\u06cc\u062f PilotPoints \u0631\u0627 \u0628\u0647 \u0686\u0647 \u06a9\u0633\u06cc \u0627\u0631\u0633\u0627\u0644 \u06a9\u0646\u06cc\u062f",
    "ar": "\u0644\u0645\u0646 \u062a\u0631\u064a\u062f \u0625\u0631\u0633\u0627\u0644 PilotPointseja \u061f",
    "uk": "\u041a\u043e\u043c\u0443 \u0432\u0438 \u0445\u043e\u0447\u0435\u0442\u0435 \u043d\u0430\u0434\u0456\u0441\u043b\u0430\u0442\u0438 PilotPoints?"
  },
  "pilot_points_donate_your_comment_label": {
    "sheet_name": "Web",
    "en": "Your comment",
    "ru": "\u0412\u0430\u0448 \u043a\u043e\u043c\u043c\u0435\u043d\u0442\u0430\u0440\u0438\u0439",
    "fi": "Kommenttisi",
    "sv": "Dina kommentarer",
    "fa": "\u0646\u0638\u0631 \u0634\u0645\u0627",
    "ar": "",
    "uk": "\u0412\u0430\u0448 \u043a\u043e\u043c\u0435\u043d\u0442\u0430\u0440"
  },
  "pilot_points_donate_email_label": {
    "sheet_name": "Web",
    "en": "Email",
    "ru": "\u042d\u043b. \u043f\u043e\u0447\u0442\u0430",
    "fi": "S\u00e4hk\u00f6posti",
    "sv": "E-postadress",
    "fa": "\u0627\u06cc\u0645\u06cc\u0644",
    "ar": "\u0627\u0644\u0628\u0631\u064a\u062f \u0627\u0644\u0627\u0644\u0643\u062a\u0631\u0648\u0646\u064a",
    "uk": "\u0415\u043b\u0435\u043a\u0442\u0440\u043e\u043d\u0430 \u043f\u043e\u0448\u0442\u0430"
  },
  "pilot_points_donate_confirm_email_label": {
    "sheet_name": "Web",
    "en": "Confirm email",
    "ru": "\u041f\u043e\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435 \u0430\u0434\u0440\u0435\u0441 \u044d\u043b\u0435\u043a\u0442\u0440\u043e\u043d\u043d\u043e\u0439 \u043f\u043e\u0447\u0442\u044b",
    "fi": "Vahvista s\u00e4hk\u00f6posti",
    "sv": "Bekr\u00e4fta e-mail",
    "fa": "\u062a\u0627\u06cc\u06cc\u062f \u0627\u06cc\u0645\u06cc\u0644",
    "ar": "\u062a\u0623\u0643\u064a\u062f \u0639\u0646\u0648\u0627\u0646 \u0628\u0631\u064a\u062f\u0643 \u0627\u0644\u0625\u0644\u0643\u062a\u0631\u0648\u0646\u064a",
    "uk": "\u041f\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438 \u0435\u043b. \u043f\u043e\u0448\u0442\u0443"
  },
  "pilot_points_donate_donate_label": {
    "sheet_name": "Web",
    "en": "Transfer",
    "ru": "\u043f\u0435\u0440\u0435\u0434\u0430\u0442\u044c",
    "fi": "Siirr\u00e4",
    "sv": "Dela ut",
    "fa": "\u0627\u0647\u062f\u0627 \u06a9\u0646\u06cc\u062f",
    "ar": "\u0646\u0642\u0644",
    "uk": "\u041f\u0435\u0440\u0435\u0434\u0430\u0442\u0438"
  },
  "pilot_points_donate_confirm_title": {
    "sheet_name": "Web",
    "en": "Confirmation",
    "ru": "\u041f\u043e\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043d\u0438\u0435",
    "fi": "Vahvista",
    "sv": "Bekr\u00e4fta",
    "fa": "\u062a\u0627\u0626\u06cc\u062f\u06cc",
    "ar": "\u0627\u0644\u062a\u0623\u0643\u064a\u062f",
    "uk": "\u041f\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043d\u043d\u044f"
  },
  "pilot_points_donate_confirm_confirm_label": {
    "sheet_name": "Web",
    "en": "Confirm",
    "ru": "\u043f\u043e\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044c",
    "fi": "Vahvista",
    "sv": "Godk\u00e4nn",
    "fa": "\u062a\u0627\u06cc\u06cc\u062f",
    "ar": "\u062a\u0623\u0643\u064a\u062f",
    "uk": "\u041f\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438"
  },
  "pilot_points_donate_confirm_cancel_label": {
    "sheet_name": "Web",
    "en": "Cancel",
    "ru": "\u043e\u0442\u043c\u0435\u043d\u0438\u0442\u044c",
    "fi": "Peruuta",
    "sv": "Avbryta",
    "fa": "\u0644\u063a\u0648",
    "ar": "\u062a\u0631\u0627\u062c\u0639",
    "uk": "\u0421\u043a\u0430\u0441\u0443\u0432\u0430\u0442\u0438"
  },
  "pilot_points_donate_error_donate_to_self": {
    "sheet_name": "Web",
    "en": "You can't transfer PilotPoints to yourself",
    "ru": "^\u0412\u044b \u043d\u0435 \u043c\u043e\u0436\u0435\u0442\u0435 \u043f\u043e\u0436\u0435\u0440\u0442\u0432\u043e\u0432\u0430\u0442\u044c PilotPoints \u0434\u043b\u044f \u0441\u0435\u0431\u044f",
    "fi": "Et voi siirt\u00e4\u00e4 PilotPointseja itsellesi",
    "sv": "Du kan inte dela ut PilotsPoints till dig sj\u00e4lv",
    "fa": "\u0634\u0645\u0627 \u0646\u0645\u06cc\u062a\u0648\u0627\u0646\u06cc\u062f PilotPoints \u0628\u0647 \u062e\u0648\u062f \u0627\u0647\u062f\u0627 \u06a9\u0646\u06cc\u062f",
    "ar": "\u0644\u0627 \u064a\u0645\u0643\u0646\u0643 \u0646\u0642\u0644 \u0646\u0642\u0627\u0637 PilotPoints \u0625\u0644\u0649 \u0646\u0641\u0633\u0643",
    "uk": "\u0412\u0438 \u043d\u0435 \u043c\u043e\u0436\u0435\u0442\u0435 \u043f\u0435\u0440\u0435\u0434\u0430\u0442\u0438 PilotPoints \u0441\u043e\u0431\u0456"
  },
  "pilot_points_donate_error_amount_is_nan": {
    "sheet_name": "Web",
    "en": "Amount is not a valid number",
    "ru": "\u041e\u0448\u0438\u0431\u043a\u0430 \u0432 \u043a\u043e\u043b\u0438\u0447\u0435\u0441\u0442\u0432\u0435",
    "fi": "M\u00e4\u00e4r\u00e4ss\u00e4 on virhe",
    "sv": "Felaktig summa",
    "fa": "\u0645\u0628\u0644\u063a \u0635\u062d\u06cc\u062d \u0646\u06cc\u0633\u062a!",
    "ar": "\u0627\u0644\u0645\u0628\u0644\u063a \u0644\u064a\u0633 \u0631\u0642\u0645\u064b\u0627 \u0635\u0627\u0644\u062d\u064b\u0627",
    "uk": "\u0421\u0443\u043c\u0430 \u043d\u0435 \u0454 \u0434\u0456\u0439\u0441\u043d\u0438\u043c \u0447\u0438\u0441\u043b\u043e\u043c"
  },
  "pilot_points_donate_error_amount_too_high": {
    "sheet_name": "Web",
    "en": "You do not have enough PilotPoints for this transfer",
    "ru": "\u0423 \u0432\u0430\u0441 \u043d\u0435 \u0434\u043e\u0441\u0442\u0430\u0442\u043e\u0447\u043d\u043e PilotPonts",
    "fi": "Sinulla ei ole riitt\u00e4v\u00e4sti PilotPointseja",
    "sv": "Du har inte tillr\u00e4ckligt m\u00e5nga PilotPoints",
    "fa": "\u0634\u0645\u0627 PilotPoints \u06a9\u0627\u0641\u06cc \u0628\u0631\u0627\u06cc \u0627\u06cc\u0646 \u0627\u0646\u062a\u0642\u0627\u0644 \u0646\u062f\u0627\u0631\u06cc\u062f",
    "ar": "\u0644\u064a\u0633 \u0644\u062f\u064a\u0643 \u0645\u0627 \u064a\u0643\u0641\u064a \u0645\u0646 \u0646\u0642\u0627\u0637 PilotPoints \u0644\u0647\u0630\u0627 \u0627\u0644\u0646\u0642\u0644",
    "uk": "\u0423 \u0432\u0430\u0441 \u043d\u0435\u0434\u043e\u0441\u0442\u0430\u0442\u043d\u044c\u043e PilotPoints"
  },
  "pilot_points_donate_error_amount_too_low": {
    "sheet_name": "Web",
    "en": "The minimum amount you can transfer is %s",
    "ru": "\u041c\u0438\u043d\u0438\u043c\u0430\u043b\u044c\u043d\u043e\u0435 \u043a\u043e\u043b\u0438\u0447\u0435\u0441\u0442\u0432\u043e, \u043a\u043e\u0442\u043e\u0440\u043e\u0435 \u0432\u044b \u043c\u043e\u0436\u0435\u0442\u0435 \u043f\u043e\u0434\u0430\u0440\u0438\u0442\u044c %s",
    "fi": "V\u00e4himm\u00e4ism\u00e4\u00e4r\u00e4 mit\u00e4 voit lahjoittaa, on %s",
    "sv": "Det l\u00e4gsta belopp du kan donera \u00e4r %s",
    "fa": "\u062d\u062f\u0627\u0642\u0644 \u0645\u0628\u0644\u063a\u06cc \u06a9\u0647 \u0634\u0645\u0627 \u0642\u0627\u062f\u0631 \u0628\u0647 \u0627\u0646\u062a\u0642\u0627\u0644 \u0647\u0633\u062a\u06cc\u062f s%",
    "ar": "\u0627\u0644\u062d\u062f \u0627\u0644\u0623\u062f\u0646\u0649 \u0644\u0644\u0645\u0628\u0644\u063a \u0627\u0644\u0630\u064a \u064a\u0645\u0643\u0646\u0643 \u062a\u062d\u0648\u064a\u0644\u0647 \u0647\u0648%",
    "uk": "\u041c\u0456\u043d\u0456\u043c\u0430\u043b\u044c\u043d\u0430 \u0441\u0443\u043c\u0430, \u044f\u043a\u0443 \u0432\u0438 \u043c\u043e\u0436\u0435\u0442\u0435 \u043f\u0435\u0440\u0435\u0434\u0430\u0442\u0438, \u0441\u0442\u0430\u043d\u043e\u0432\u0438\u0442\u044c %s"
  },
  "pilot_points_donate_error_email_has_no_at": {
    "sheet_name": "Web",
    "en": "There is no \"@\" sign in this email address",
    "ru": "\u041d\u0430 \u043f\u043e\u0447\u0442\u0435 \u043e\u0442\u0441\u0443\u0442\u0441\u0442\u0432\u0443\u0435\u0442 \u0441\u0438\u043c\u0432\u043e\u043b \u00ab@\u00bb",
    "fi": "S\u00e4hk\u00f6postistasi puuttuu \"@\"-merkki",
    "sv": "Det finns inget \"@\" -tecken i den h\u00e4r e-postadressen",
    "fa": "\u0646\u0634\u0627\u0646 \"@\" \u062f\u0631 \u0627\u06cc\u0646 \u0622\u062f\u0631\u0633 \u0627\u06cc\u0645\u06cc\u0644 \u0648\u062c\u0648\u062f \u0646\u062f\u0627\u0631\u062f!",
    "ar": "\"\u0644\u0627 \u064a\u0648\u062c\u062f \u062a\u0633\u062c\u064a\u0644 \u0627\u0644\u062f\u062e\u0648\u0644\" \"@\" \"\u0641\u064a \u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0628\u0631\u064a\u062f \u0627\u0644\u0625\u0644\u0643\u062a\u0631\u0648\u0646\u064a \u0647\u0630\u0627\"",
    "uk": "\u0423 \u0446\u0456\u0439 \u0435\u043b\u0435\u043a\u0442\u0440\u043e\u043d\u043d\u0456\u0439 \u0430\u0434\u0440\u0435\u0441\u0456 \u043d\u0435\u043c\u0430\u0454 \u0437\u043d\u0430\u043a\u0430 \u00ab@\u00bb"
  },
  "pilot_points_donate_error_email_has_too_many_at": {
    "sheet_name": "Web",
    "en": "There are too many \\\"@\\\" signs in this email address",
    "ru": "\u041d\u0430 \u0430\u0434\u0440\u0435\u0441\u0435 \u044d\u043b. \u043f\u043e\u0447\u0442\u044b \u0441\u043b\u0438\u0448\u043a\u043e\u043c \u043c\u043d\u043e\u0433\u043e \u0441\u0438\u043c\u0432\u0440\u043b\u043e\u0432 \\\"@\\\"",
    "fi": "S\u00e4hk\u00f6postissa oli liian monta \\\"@\\\"-merkki\u00e4",
    "sv": "Det finns f\u00f6r m\u00e5nga \\\"@\\\" tecken i den h\u00e4r e-postadressen",
    "fa": "\u0646\u0634\u0627\u0646\u0647 \\ \"@ \\\" \u0632\u06cc\u0627\u062f\u06cc\u060c \u062f\u0631 \u0627\u06cc\u0646 \u0622\u062f\u0631\u0633 \u0627\u06cc\u0645\u06cc\u0644 \u0648\u062c\u0648\u062f \u062f\u0627\u0631\u062f!",
    "ar": "\"\u0647\u0646\u0627\u0643 \u0639\u062f\u062f \u0643\u0628\u064a\u0631 \u062c\u062f\u064b\u0627 \u0645\u0646 \u0639\u0644\u0627\u0645\u0627\u062a \\\" \"@ \\\" \"\u0641\u064a \u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0628\u0631\u064a\u062f \u0627\u0644\u0625\u0644\u0643\u062a\u0631\u0648\u0646\u064a \u0647\u0630\u0627\"",
    "uk": "\u0423 \u0446\u0456\u0439 \u0435\u043b\u0435\u043a\u0442\u0440\u043e\u043d\u043d\u0456\u0439 \u0430\u0434\u0440\u0435\u0441\u0456 \u0437\u0430\u0431\u0430\u0433\u0430\u0442\u043e \u0437\u043d\u0430\u043a\u0456\u0432 \\\"@\\\""
  },
  "pilot_points_donate_error_email_short_name": {
    "sheet_name": "Web",
    "en": "Too short name part",
    "ru": "\u042d\u043b. \u041f\u043e\u0447\u0442\u0430 \u0441\u043b\u0438\u0448\u043a\u043e\u043c \u043a\u043e\u0440\u043e\u0442\u043a\u0430\u044f",
    "fi": "S\u00e4hk\u00f6postisi on liian lyhyt",
    "sv": "Din e-postadress \u00e4r f\u00f6r kort",
    "fa": "\u0627\u06cc\u0645\u06cc\u0644 \u0634\u0645\u0627 \u06a9\u0648\u062a\u0627\u0647 \u0627\u0633\u062a!",
    "ar": "\u062c\u0632\u0621 \u0627\u0633\u0645 \u0642\u0635\u064a\u0631 \u062c\u062f\u064b\u0627",
    "uk": "\u0417\u0430\u043d\u0430\u0434\u0442\u043e \u043a\u043e\u0440\u043e\u0442\u043a\u0430 \u0435\u043b\u0435\u043a\u0442\u0440\u043e\u043d\u043d\u0430 \u0430\u0434\u0440\u0435\u0441\u0430"
  },
  "pilot_points_donate_error_email_short_domain": {
    "sheet_name": "Web",
    "en": "Too short domain part",
    "ru": "\u042d\u043b. \u041f\u043e\u0447\u0442\u0430 \u0441\u043b\u0438\u0448\u043a\u043e\u043c \u043a\u043e\u0440\u043e\u0442\u043a\u0430\u044f",
    "fi": "S\u00e4hk\u00f6postisi on liian lyhyt",
    "sv": "Din e-postadress \u00e4r f\u00f6r kort",
    "fa": "\u0627\u06cc\u0645\u06cc\u0644 \u0634\u0645\u0627 \u06a9\u0648\u062a\u0627\u0647 \u0627\u0633\u062a!",
    "ar": "\u062c\u0632\u0621 \u0627\u0644\u0645\u062c\u0627\u0644 \u0642\u0635\u064a\u0631 \u062c\u062f\u0627\u064b",
    "uk": "\u0417\u0430\u043d\u0430\u0434\u0442\u043e \u043a\u043e\u0440\u043e\u0442\u043a\u0430 \u0435\u043b\u0435\u043a\u0442\u0440\u043e\u043d\u043d\u0430 \u0430\u0434\u0440\u0435\u0441\u0430"
  },
  "pilot_points_donate_error_email_confirm_no_email": {
    "sheet_name": "Web",
    "en": "You need to fill the email first",
    "ru": "\u0417\u0430\u043f\u043e\u043b\u043d\u0438\u0442\u0435 \u0441\u043d\u0430\u0447\u0430\u043b\u0430 \u044d\u043b. \u043f\u043e\u0447\u0442\u0443",
    "fi": "T\u00e4yt\u00e4 ensin s\u00e4hk\u00f6postisi",
    "sv": "Du m\u00e5ste fylla i din e-post f\u00f6rst",
    "fa": "\u0627\u0628\u062a\u062f\u0627 \u0628\u0627\u06cc\u062f \u0627\u06cc\u0645\u06cc\u0644 \u0631\u0627 \u0648\u0627\u0631\u062f \u06a9\u0646\u06cc\u062f",
    "ar": "\u062a\u062d\u062a\u0627\u062c \u0625\u0644\u0649 \u0645\u0644\u0621 \u0627\u0644\u0628\u0631\u064a\u062f \u0627\u0644\u0625\u0644\u0643\u062a\u0631\u0648\u0646\u064a \u0623\u0648\u0644\u0627\u064b",
    "uk": "\u0421\u043f\u043e\u0447\u0430\u0442\u043a\u0443 \u043d\u0435\u043e\u0431\u0445\u0456\u0434\u043d\u043e \u0437\u0430\u043f\u043e\u0432\u043d\u0438\u0442\u0438 \u0435\u043b\u0435\u043a\u0442\u0440\u043e\u043d\u043d\u0443 \u043f\u043e\u0448\u0442\u0443"
  },
  "pilot_points_donate_error_email_confirm_wrong": {
    "sheet_name": "Web",
    "en": "Email confirmation does not match with email",
    "ru": "\u0420\u0430\u0437\u043d\u044b\u0435 \u044d\u043b. \u0430\u0434\u0440\u0435\u0441\u0430",
    "fi": "S\u00e4hk\u00f6postit eiv\u00e4t t\u00e4sm\u00e4\u00e4",
    "sv": "E-postadresser matchar inte",
    "fa": "\u062a\u0623\u06cc\u06cc\u062f\u06cc\u0647 \u0627\u06cc\u0645\u06cc\u0644 \u0628\u0627 \u0627\u06cc\u0645\u06cc\u0644 \u0645\u0637\u0627\u0628\u0642\u062a \u0646\u062f\u0627\u0631\u062f",
    "ar": "\u062a\u0623\u0643\u064a\u062f \u0627\u0644\u0628\u0631\u064a\u062f \u0627\u0644\u0625\u0644\u0643\u062a\u0631\u0648\u0646\u064a \u0644\u0627 \u064a\u062a\u0637\u0627\u0628\u0642 \u0645\u0639 \u0627\u0644\u0628\u0631\u064a\u062f \u0627\u0644\u0625\u0644\u0643\u062a\u0631\u0648\u0646\u064a",
    "uk": "\u041f\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043d\u043d\u044f \u043d\u0435 \u0437\u0431\u0456\u0433\u0430\u0454\u0442\u044c\u0441\u044f \u0437 \u0435\u043b\u0435\u043a\u0442\u0440\u043e\u043d\u043d\u043e\u044e \u043f\u043e\u0448\u0442\u043e\u044e"
  },
  "pilot_points_donate_confirm_text": {
    "sheet_name": "Web",
    "en": "Please confirm that you want to transfer %s PilotPoints to %s",
    "ru": "\u041f\u043e\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435, \u0447\u0442\u043e \u0432\u044b \u0445\u043e\u0442\u0438\u0442\u0435 \u043f\u0435\u0440\u0435\u0434\u0430\u0442\u044c %s PilotPoints %s",
    "fi": "Vahvista ett\u00e4 haluat siirt\u00e4\u00e4 %s PilotPointsia s\u00e4hk\u00f6postiin %s",
    "sv": "Bekr\u00e4fta att du vill dela ut %s PilotPoints till %s",
    "fa": "\u0644\u0637\u0641\u0627\u064b \u062a\u0623\u06cc\u06cc\u062f \u06a9\u0646\u06cc\u062f \u06a9\u0647 \u0645\u06cc \u062e\u0648\u0627\u0647\u06cc\u062f s% \u0627\u0632 PilotPoints \u0631\u0627 \u0628\u0647 s% \u0627\u0647\u062f\u0627 \u06a9\u0646\u06cc\u062f",
    "ar": "\u064a\u0631\u062c\u0649 \u062a\u0623\u0643\u064a\u062f \u0631\u063a\u0628\u062a\u0643 \u0641\u064a \u0646\u0642\u0644\u066a s PilotPoints \u0625\u0644\u0649\u066a",
    "uk": "\u0411\u0443\u0434\u044c \u043b\u0430\u0441\u043a\u0430, \u043f\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0456\u0442\u044c, \u0449\u043e \u0432\u0438 \u0445\u043e\u0447\u0435\u0442\u0435 \u043f\u0435\u0440\u0435\u0432\u0435\u0441\u0442\u0438 %s PilotPoints \u043d\u0430 %s"
  },
  "pilot_points_donate_total_text": {
    "sheet_name": "Web",
    "en": "Total (VAT included): %s %s",
    "ru": "\u0412\u043c\u0435\u0441\u0442\u0435 ( \u0432\u043a\u043b\u044e\u0447\u0430\u0435\u0442 \u043d\u0430\u043b\u043e\u0433) %s %s",
    "fi": "Yht. (sis ALV): %s %s",
    "sv": "Totalt (moms ing\u00e5r): %s %s",
    "fa": "\u06a9\u0644 (\u0634\u0627\u0645\u0644 \u0645\u0627\u0644\u06cc\u0627\u062a \u0628\u0631 \u0627\u0631\u0632\u0634 \u0627\u0641\u0632\u0648\u062f\u0647):s% s%",
    "ar": "Yht. (sis ALV): %s %s",
    "uk": "\u0412\u0441\u044c\u043e\u0433\u043e (\u0437 \u041f\u0414\u0412): %s %s"
  },
  "pilot_points_donate_success_text": {
    "sheet_name": "Web",
    "en": "You have transferred %s PilotPoints to %s!",
    "ru": "\u0412\u044b \u043f\u043e\u0436\u0435\u0440\u0442\u0432\u043e\u0432\u0430\u043b\u0438 %s PilotPoints \u0434\u043b\u044f %s!",
    "fi": "Olet siirt\u00e4nyt %s PilotPointseja osoitteeseen %s!",
    "sv": "Du has delat ut %s PilotPoints till %s!",
    "fa": "\u0634\u0645\u0627 \u0645\u0642\u062f\u0627\u0631 s% \u0627\u0632 PilotPoints \u0631\u0627 \u0628\u0647 s% \u0627\u0647\u062f\u0627 \u06a9\u0631\u062f\u06cc\u062f!",
    "ar": "\u0644\u0642\u062f \u0642\u0645\u062a \u0628\u062a\u062d\u0648\u064a\u0644\u066a s PilotPoints \u0625\u0644\u0649\u066a s!",
    "uk": "\u0412\u0438 \u043f\u0435\u0440\u0435\u0434\u0430\u043b\u0438 %s PilotPoints \u043d\u0430 %s!"
  },
  "pilot_points_claim_form_title": {
    "sheet_name": "Web",
    "en": "Claim PilotPoints",
    "ru": "\u0417\u0430\u044f\u0432\u0438\u0442\u044c PilotPoints",
    "fi": "Lunasta PilotPointseja",
    "sv": "L\u00f6s in PilotPoints",
    "fa": "\u0627\u0633\u062a\u062e\u0631\u0627\u062c PilotPoints",
    "ar": "\u0627\u0644\u0645\u0637\u0627\u0644\u0628\u0629 \u0628\u0627\u0644\u0646\u0642\u0627\u0637",
    "uk": "\u0417\u0430\u044f\u0432\u0430 \u043d\u0430 \u043e\u0442\u0440\u0438\u043c\u0430\u043d\u043d\u044f PilotPoints"
  },
  "pilot_points_claim_explanation_line1": {
    "sheet_name": "Web",
    "en": "Here you can claim PilotPoints!",
    "ru": "\u0417\u0434\u0435\u0441\u044c \u0432\u044b \u043c\u043e\u0436\u0435\u0442\u0435 \u043f\u0440\u0435\u0442\u0435\u043d\u0434\u043e\u0432\u0430\u0442\u044c \u043d\u0430 PilotPoints!",
    "fi": "T\u00e4\u00e4lt\u00e4 voit lunastaa saamiasi PilotPointseja.",
    "sv": "H\u00e4r kan du l\u00f6sa in PilotPoints",
    "fa": "\u062f\u0631 \u0627\u06cc\u0646\u062c\u0627 \u0645\u06cc \u062a\u0648\u0627\u0646\u06cc\u062f PilotPoints \u0631\u0627 \u0627\u0633\u062a\u062e\u0631\u0627\u062c \u06a9\u0646\u06cc\u062f!",
    "ar": "\u0647\u0646\u0627 \u064a\u0645\u0643\u0646\u0643 \u0627\u0644\u062d\u0635\u0648\u0644 \u0639\u0644\u0649 PilotPoints",
    "uk": "\u0422\u0443\u0442 \u0432\u0438 \u043c\u043e\u0436\u0435\u0442\u0435 \u043e\u0442\u0440\u0438\u043c\u0430\u0442\u0438 PilotPoints!"
  },
  "pilot_points_claim_explanation_line2": {
    "sheet_name": "Web",
    "en": "You can use PilotPoints to pay for orders",
    "ru": "\u0412\u044b \u043c\u043e\u0436\u0435\u0442\u0435 \u0438\u0441\u043f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u044c PilotPoints \u0434\u043b\u044f \u043e\u043f\u043b\u0430\u0442\u044b \u0437\u0430\u043a\u0430\u0437\u043e\u0432 \u0434\u043b\u044f \u0432\u0430\u0441",
    "fi": "Voit k\u00e4ytt\u00e4\u00e4 niit\u00e4 tilausten maksamiseen",
    "sv": "PilotPoints kan du anv\u00e4nda till att betala f\u00f6r tj\u00e4nster",
    "fa": "\u0628\u0631\u0627\u06cc \u067e\u0631\u062f\u0627\u062e\u062a \u0633\u0641\u0627\u0631\u0634\u0627\u062a \u0645\u06cc \u062a\u0648\u0627\u0646\u06cc\u062f \u0627\u0632 PilotPoints \u0627\u0633\u062a\u0641\u0627\u062f\u0647 \u06a9\u0646\u06cc\u062f",
    "ar": "\u064a\u0645\u0643\u0646\u0643 \u0627\u0633\u062a\u062e\u062f\u0627\u0645 \u0646\u0642\u0627\u0637 PilotPoints \u0644\u062f\u0641\u0639 \u062b\u0645\u0646 \u0627\u0644\u0637\u0644\u0628\u0627\u062a",
    "uk": "\u0412\u0438 \u043c\u043e\u0436\u0435\u0442\u0435 \u0432\u0438\u043a\u043e\u0440\u0438\u0441\u0442\u043e\u0432\u0443\u0432\u0430\u0442\u0438 PilotPoints \u0434\u043b\u044f \u043e\u043f\u043b\u0430\u0442\u0438 \u0437\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u044c"
  },
  "pilot_points_claim_your_pp_label": {
    "sheet_name": "Web",
    "en": "Your PilotPoints",
    "ru": "\u0412\u0430\u0448\u0438 PilotPoints",
    "fi": "PilotPointsisi yht",
    "sv": "Dina PilotPoints",
    "fa": "\u0645\u0648\u062c\u0648\u062f\u06cc PilotPoints \u0634\u0645\u0627",
    "ar": "\u0646\u0642\u0627\u0637 PilotPoints \u0627\u0644\u062e\u0627\u0635 \u0628\u0643",
    "uk": "\u0412\u0430\u0448 Pilot Points"
  },
  "pilot_points_claim_invitation_code_label": {
    "sheet_name": "Web",
    "en": "Invitation code",
    "ru": "\u041a\u043e\u0434 \u043f\u0440\u0438\u0433\u043b\u0430\u0448\u0435\u043d\u0438\u044f",
    "fi": "Kutsukoodi",
    "sv": "Inbjudskod",
    "fa": "\u06a9\u0648\u062f \u062f\u0639\u0648\u062a",
    "ar": "\u0631\u0642\u0645 \u0627\u0644\u062f\u0639\u0648\u0647",
    "uk": "\u041a\u043e\u0434 \u0437\u0430\u043f\u0440\u043e\u0448\u0435\u043d\u043d\u044f"
  },
  "pilot_points_claim_claim_label": {
    "sheet_name": "Web",
    "en": "Claim",
    "ru": "\u0417\u0430\u043f\u0440\u043e\u0441",
    "fi": "Lunasta",
    "sv": "Bekr\u00e4fta",
    "fa": "\u0627\u0633\u062a\u062e\u0631\u0627\u062c",
    "ar": "\u064a\u0637\u0627\u0644\u0628",
    "uk": "\u0417\u0430\u043f\u0438\u0442"
  },
  "pilot_points_claim_success_text": {
    "sheet_name": "Web",
    "en": "Now you have more PilotPoints!",
    "ru": "\u0422\u0435\u043f\u0435\u0440\u044c \u0443 \u0432\u0430\u0441 \u0435\u0441\u0442\u044c \u0431\u043e\u043b\u044c\u0448\u0435 PilotPoints!",
    "fi": "Nyt sinulla on lis\u00e4\u00e4 PilotPointseja!",
    "sv": "Nu har du flera PilotPoints!",
    "fa": "\u0627\u06a9\u0646\u0648\u0646 PilotPoints \u0628\u06cc\u0634\u062a\u0631\u06cc \u062f\u0627\u0631\u06cc\u062f!",
    "ar": "\u0627\u0644\u0627\u0646 \u0644\u062f\u064a\u0643 \u0627\u0644\u0645\u0632\u064a\u062f \u0645\u0646 PilotPoints!",
    "uk": "\u0422\u0435\u043f\u0435\u0440 \u0443 \u0432\u0430\u0441 \u0431\u0456\u043b\u044c\u0448\u0435 PilotPoints!"
  },
  "pilot_points_claim_processing_text": {
    "sheet_name": "Web",
    "en": "Processing...",
    "ru": "\u041e\u0431\u0440\u0430\u0431\u043e\u0442\u043a\u0430 ...",
    "fi": "Odota hetki...",
    "sv": "Bearbetning..",
    "fa": "\u0686\u0646\u062f \u0644\u062d\u0638\u0647 \u0635\u0628\u0631 \u06a9\u0646\u06cc\u062f ...",
    "ar": "\u062c\u0627\u0631\u064a \u0627\u0644\u062a\u062d\u0645\u064a\u0644...",
    "uk": "\u041e\u0431\u0440\u043e\u0431\u043a\u0430.."
  },
  "pilot_points_history_form_title": {
    "sheet_name": "Web",
    "en": "PilotPoints History",
    "ru": "\u0418\u0441\u0442\u043e\u0440\u0438\u044f PilotPoints",
    "fi": "PilotPoints historia",
    "sv": "PilotPoints historik",
    "fa": "\u062a\u0627\u0631\u06cc\u062e\u0686\u0647 PilotPoints",
    "ar": "\u062a\u0627\u0631\u064a\u062e PilotPoints",
    "uk": "\u0406\u0441\u0442\u043e\u0440\u0456\u044f PilotPoints"
  },
  "pilot_points_history_explanation_line": {
    "sheet_name": "Web",
    "en": "Here you can see your transaction history with PilotPoints",
    "ru": "\u0417\u0434\u0435\u0441\u044c \u0432\u044b \u043c\u043e\u0436\u0435\u0442\u0435 \u043f\u0440\u043e\u0441\u043c\u043e\u0442\u0440\u0435\u0442\u044c \u0438\u0441\u0442\u043e\u0440\u0438\u044e \u0442\u0440\u0430\u043d\u0437\u0430\u043a\u0446\u0438\u0439 \u0441 PilotPoints",
    "fi": "T\u00e4\u00e4ll\u00e4 n\u00e4et PilotsPointseihin liittyv\u00e4t tapahtumasi",
    "sv": "H\u00e4r kan du se dina PilotsPoints transaktioner",
    "fa": "\u062f\u0631 \u0627\u06cc\u0646\u062c\u0627 \u0645\u06cc \u062a\u0648\u0627\u0646\u06cc\u062f \u062a\u0627\u0631\u06cc\u062e\u0686\u0647 \u0645\u0639\u0627\u0645\u0644\u0627\u062a \u062e\u0648\u062f \u0631\u0627 \u0628\u0627 PilotPoints \u0645\u0634\u0627\u0647\u062f\u0647 \u06a9\u0646\u06cc\u062f",
    "ar": "\u0647\u0646\u0627 \u064a\u0645\u0643\u0646\u0643 \u0627\u0646 \u062a\u0631\u0649 \u062a\u0627\u0631\u064a\u062e \u0627\u0644\u0645\u0639\u0627\u0645\u0644\u0627\u062a \u0627\u0644\u062e\u0627\u0635 \u0645\u0639 PilotPoints",
    "uk": "\u0422\u0443\u0442 \u0412\u0438 \u043c\u043e\u0436\u0435\u0442\u0435 \u043f\u0435\u0440\u0435\u0433\u043b\u044f\u043d\u0443\u0442\u0438 \u0456\u0441\u0442\u043e\u0440\u0456\u044e \u0412\u0430\u0448\u0438\u0445 \u0442\u0440\u0430\u043d\u0437\u0430\u043a\u0446\u0456\u0439 \u0437 PilotPoints"
  },
  "pilot_points_history_total_label": {
    "sheet_name": "Web",
    "en": "Total",
    "ru": "\u0412\u0441\u0435\u0433\u043e",
    "fi": "Yhteens\u00e4",
    "sv": "Totalt",
    "fa": "\u0645\u062c\u0645\u0648\u0639\u0647",
    "ar": "\u0627\u0644\u0645\u062c\u0645\u0648\u0639",
    "uk": "\u0412\u0441\u044c\u043e\u0433\u043e"
  },
  "pilot_points_history_date_label": {
    "sheet_name": "Web",
    "en": "Date",
    "ru": "\u0414\u0430\u0442\u0430",
    "fi": "P\u00e4iv\u00e4",
    "sv": "Datum",
    "fa": "\u062a\u0627\u0631\u06cc\u062e",
    "ar": "\u0627\u0644\u064a\u0648\u0645",
    "uk": "\u0414\u0430\u0442\u0430"
  },
  "pilot_points_history_type_label": {
    "sheet_name": "Web",
    "en": "Type",
    "ru": "\u0422\u0438\u043f",
    "fi": "Tyyppi",
    "sv": "Typ",
    "fa": "\u0646\u0648\u0639",
    "ar": "\u0627\u0644\u0646\u0648\u0639",
    "uk": "\u0422\u0438\u043f"
  },
  "pilot_points_history_pp_label": {
    "sheet_name": "Web",
    "en": "PilotPoints",
    "ru": "PilotPoints",
    "fi": "PilotPoints",
    "sv": "PilotPoints",
    "fa": "PilotPoints",
    "ar": "PilotPoints",
    "uk": "Pilot Points"
  },
  "pilot_points_history_price_label": {
    "sheet_name": "Web",
    "en": "Price",
    "ru": "\u0426\u0435\u043d\u0430",
    "fi": "Hinta",
    "sv": "Pris",
    "fa": "\u0646\u0631\u062e",
    "ar": "\u0627\u0644\u0633\u0639\u0631",
    "uk": "\u0426\u0456\u043d\u0430"
  },
  "pilot_points_history_transaction_data_label": {
    "sheet_name": "Web",
    "en": "Transaction data",
    "ru": "\u0414\u043e\u043f\u043e\u043b\u043d\u0438\u0442\u0435\u043b\u044c\u043d\u0430\u044f \u0438\u043d\u0444\u043e\u0440\u043c\u0430\u0446\u0438\u044f",
    "fi": "Lis\u00e4tietoja",
    "sv": "Mer information",
    "fa": "\u0645\u0639\u0644\u0648\u0645\u0627\u062a \u0627\u0636\u0627\u0641\u06cc",
    "ar": "\u0645\u0639\u0644\u0648\u0645\u0627\u062a \u0625\u0636\u0627\u0641\u064a\u0629",
    "uk": "\u0414\u0430\u043d\u0456 \u043f\u0440\u043e \u0442\u0440\u0430\u043d\u0437\u0430\u043a\u0446\u0456\u044e"
  },
  "pilot_points_history_comment_label": {
    "sheet_name": "Web",
    "en": "Comment",
    "ru": "\u041a\u043e\u043c\u043c\u0435\u043d\u0442\u0430\u0440\u0438\u0439",
    "fi": "Kommentti",
    "sv": "Kommentar",
    "fa": "\u0646\u0638\u0631",
    "ar": "",
    "uk": "\u041a\u043e\u043c\u0430\u043d\u0442\u0430\u0440"
  },
  "pilot_points_history_no_history_label": {
    "sheet_name": "Web",
    "en": "No PilotPoints history yet",
    "ru": "\u041d\u0435\u0442 \u043f\u043e\u043a\u0430 \u0438\u0441\u0442\u043e\u0440\u0438\u0438 PilotPoints.",
    "fi": "Sinulla ei ole PilotPoints historiaa viel\u00e4",
    "sv": "Ingen PilotsPoints historik",
    "fa": "\u0647\u0646\u0648\u0632 \u0647\u06cc\u0686 \u062a\u0627\u0631\u06cc\u062e\u0686\u0647 PilotPoints \u0648\u062c\u0648\u062f \u0646\u062f\u0627\u0631\u062f.",
    "ar": "\u0644\u0627 \u064a\u0648\u062c\u062f \u062a\u0627\u0631\u064a\u062e PilotPoints \u062d\u062a\u0649 \u0627\u0644\u0622\u0646",
    "uk": "\u0406\u0441\u0442\u043e\u0440\u0456\u0457 PilotPoints \u0449\u0435 \u043d\u0435\u043c\u0430\u0454"
  },
  "pilot_points_ask_for_billing": {
    "sheet_name": "Web",
    "en": "Ask for billing",
    "ru": "",
    "fi": "Pyyd\u00e4 laskutusta",
    "sv": "Beg\u00e4ra fakturering",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "pilot_points_email_for_billing": {
    "sheet_name": "Web",
    "en": "Email for billing",
    "ru": "",
    "fi": "Laskutuss\u00e4hk\u00f6postiosoite",
    "sv": "E-post f\u00f6r fakturering",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "pilot_points_business_id": {
    "sheet_name": "Web",
    "en": "Business ID",
    "ru": "",
    "fi": "Y-tunnus",
    "sv": "Organisationsnumret",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "pilot_points_e_invoice_address": {
    "sheet_name": "Web",
    "en": "E-invoice address",
    "ru": "",
    "fi": "Verkkolaskutusosoite",
    "sv": "E-faktura adresser",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "pilot_points_e_invoice_operator": {
    "sheet_name": "Web",
    "en": "E-invoice operator",
    "ru": "",
    "fi": "Verkkolaskutusoperaattori",
    "sv": "E-faktura operat\u00f6r",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "pilot_points_invoice_reference": {
    "sheet_name": "Web",
    "en": "Invoice reference",
    "ru": "",
    "fi": "Laskutusviite",
    "sv": "Faktureringsreferens",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "pilot_points_ui_explanation": {
    "sheet_name": "Web",
    "en": "Asking for billing to buy Pilotpoints means that we will send you an invoice and after that transfer the corresponding amount of PilotPoints. You can view your billing requests from PilotPoints history.",
    "ru": "",
    "fi": "Laskutuksen pyyt\u00e4minen Pilotpointseja ostaessa tarkoittaa, ett\u00e4 l\u00e4het\u00e4mme sinulle laskun ja sen j\u00e4lkeen siirr\u00e4\u00e4mme sinulle vastaavan m\u00e4\u00e4r\u00e4n PilotPointseja k\u00e4ytt\u00f6\u00f6si. Voit tarkastella laskutuspyynt\u00f6j\u00e4si PilotPoints-historiasta.",
    "sv": "Att be om fakturering f\u00f6r att k\u00f6pa Pilotpoints betyder att vi skickar en faktura till dig och efter det \u00f6verf\u00f6r motsvarande m\u00e4ngd PilotPoints. Du kan se dina faktureringsf\u00f6rfr\u00e5gningar fr\u00e5n PilotPoints historik.",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "pilot_points_success_message": {
    "sheet_name": "Web",
    "en": "Your billing request was successful!",
    "ru": "",
    "fi": "Laskutuspyynt\u00f6si tehtiin onnistuneesti!",
    "sv": "Din faktureringsf\u00f6rfr\u00e5gan lyckades!",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "pilot_points_dialog_amount_supplement": {
    "sheet_name": "Web",
    "en": "By submitting this billing request, you confirm you want to buy %s PilotPoints by paying an invoice %s%s + billing supplement %s%s (Total: %s%s)",
    "ru": "",
    "fi": "L\u00e4hett\u00e4m\u00e4ll\u00e4 t\u00e4m\u00e4n laskutuspyynn\u00f6n vahvistat ett\u00e4 haluat ostaa %s PilotPointsia maksamalla laskun %s%s + laskutuslis\u00e4n %s%s (Yhteens\u00e4: %s%s)",
    "sv": "Genom att skicka in denna faktureringsf\u00f6rfr\u00e5gan bekr\u00e4ftar du att du vill k\u00f6pa %s PilotPoints genom att betala en faktura %s%s + faktureringstill\u00e4gg %s%s (Totalt: %s%s)",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "pilot_points_dialog_amount": {
    "sheet_name": "Web",
    "en": "By submitting this billing request, you confirm you want to buy %s PilotPoints (%s%s) by invoice",
    "ru": "",
    "fi": "L\u00e4hett\u00e4m\u00e4ll\u00e4 t\u00e4m\u00e4n laskutuspyynn\u00f6n vahvistat ett\u00e4 haluat ostaa %s PilotPointsia (%s%s) laskutuksella",
    "sv": "Genom att skicka in denna faktureringsf\u00f6rfr\u00e5gan bekr\u00e4ftar du att du vill k\u00f6pa %s PilotPoints (%s%s) via faktura",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "pilot_points_basic_information": {
    "sheet_name": "Web",
    "en": "Basic information",
    "ru": "",
    "fi": "Perustiedot",
    "sv": "Grundl\u00e4ggande information",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "pilot_points_invoice_information": {
    "sheet_name": "Web",
    "en": "1) Enter e-invoice information",
    "ru": "",
    "fi": "1) Sy\u00f6t\u00e4 e-laskutuksen tiedot",
    "sv": "1) Ange information om e-faktura",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "pilot_points_enter_email": {
    "sheet_name": "Web",
    "en": "2) Enter email for billing",
    "ru": "",
    "fi": "2) Sy\u00f6t\u00e4 laskutuss\u00e4hk\u00f6posti",
    "sv": "2) Ange e-post f\u00f6r fakturering",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "pilot_points_by_billing_request": {
    "sheet_name": "Web",
    "en": "By billing request #%s",
    "ru": "",
    "fi": "Laskutuspyynn\u00f6ll\u00e4 #%s",
    "sv": "Genom faktureringsf\u00f6rfr\u00e5gan #%s",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "pilot_points_category_and_units": {
    "sheet_name": "Web",
    "en": "Category & units",
    "ru": "",
    "fi": "Kategoria & kpl",
    "sv": "Kategori & enheter",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "pilot_points_any_amount": {
    "sheet_name": "Web",
    "en": "Fixed amount",
    "ru": "",
    "fi": "Kiinte\u00e4 m\u00e4\u00e4r\u00e4",
    "sv": "Fast belopp",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "pilot_points_choose_category": {
    "sheet_name": "Web",
    "en": "Choose a category",
    "ru": "",
    "fi": "Valitse kategoria",
    "sv": "V\u00e4lj en kategori",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "pilot_points_units": {
    "sheet_name": "Web",
    "en": "Units",
    "ru": "",
    "fi": "Kpl",
    "sv": "Enheter",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "cards_label_used": {
    "sheet_name": "Web",
    "en": "Please remember to update any unassigned orders that use this card",
    "ru": "",
    "fi": "Kortti on k\u00e4yt\u00f6ss\u00e4 avoimissa tilauksissasi. Muutathan n\u00e4ihin uuden korttisi (muokkaa maksutapaa)",
    "sv": "Var uppm\u00e4rksam p\u00e5 att dina uppdrag hanteras av gilltigt betalkort.",
    "fa": "",
    "ar": "",
    "uk": "\u041a\u0430\u0440\u0442\u043a\u0430 \u0432\u0438\u043a\u043e\u0440\u0438\u0441\u0442\u043e\u0432\u0443\u0454\u0442\u044c\u0441\u044f \u0434\u043b\u044f \u0432\u0430\u0448\u0438\u0445 \u0432\u0456\u0434\u043a\u0440\u0438\u0442\u0438\u0445 \u0437\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u044c. \u0412\u0438 \u043c\u043e\u0436\u0435\u0442\u0435 \u0440\u0435\u0434\u0430\u043d\u0443\u0432\u0430\u0442\u0438 \u0441\u043f\u043e\u0441\u0456\u0431 \u043e\u043f\u043b\u0430\u0442\u0438"
  },
  "cards_form_title": {
    "sheet_name": "Web",
    "en": "Payment methods",
    "ru": "\u041f\u043b\u0430\u0442\u0435\u0436\u043d\u044b\u0435 \u0441\u0447\u0435\u0442\u0430",
    "fi": "Maksutavat",
    "sv": "Betalningsmetoder",
    "fa": "\u0631\u0648\u0634 \u0647\u0627\u06cc \u067e\u0631\u062f\u0627\u062e\u062a",
    "ar": "\u0637\u0631\u0642 \u0627\u0644\u062f\u0641\u0639",
    "uk": "\u0421\u043f\u043e\u0441\u043e\u0431\u0438 \u043e\u043f\u043b\u0430\u0442\u0438"
  },
  "cards_add_card_explanation": {
    "sheet_name": "Web",
    "en": "You can add\/remove cards here and see your other available payments",
    "ru": "\u041f\u043b\u0430\u0442\u0435\u0436\u043d\u044b\u0435 \u0441\u0447\u0435\u0442\u0430",
    "fi": "Lis\u00e4\u00e4 maksukortti ja katso muut maksutapasi",
    "sv": "L\u00e4gg till (eller ta bort) betalkort och se andra betalningsmetoder",
    "fa": "\u0631\u0648\u0634 \u0647\u0627\u06cc \u067e\u0631\u062f\u0627\u062e\u062a",
    "ar": "\u0637\u0631\u0642 \u0627\u0644\u062f\u0641\u0639",
    "uk": "\u0422\u0443\u0442 \u0432\u0438 \u043c\u043e\u0436\u0435\u0442\u0435 \u0434\u043e\u0434\u0430\u0432\u0430\u0442\u0438\/\u0432\u0438\u0434\u0430\u043b\u044f\u0442\u0438 \u043a\u0430\u0440\u0442\u043a\u0438 \u0442\u0430 \u043f\u0435\u0440\u0435\u0433\u043b\u044f\u0434\u0430\u0442\u0438 \u0456\u043d\u0448\u0456 \u0434\u043e\u0441\u0442\u0443\u043f\u043d\u0456 \u043f\u043b\u0430\u0442\u0435\u0436\u0456"
  },
  "cards_options_loading_text": {
    "sheet_name": "Web",
    "en": "Loading...",
    "ru": "\u0417\u0430\u0433\u0440\u0443\u0437\u043a\u0430 ...",
    "fi": "Odota hetki...",
    "sv": "Laddas ner\u2026",
    "fa": "\u0686\u0646\u062f \u0644\u062d\u0638\u0647 \u0635\u0628\u0631 \u06a9\u0646\u06cc\u062f ...",
    "ar": "\u062c\u0627\u0631\u064a \u0627\u0644\u062a\u062d\u0645\u064a\u0644...",
    "uk": "\u0417\u0430\u0432\u0430\u043d\u0442\u0430\u0436\u0435\u043d\u043d\u044f..."
  },
  "cards_list_credit_card_label": {
    "sheet_name": "Web",
    "en": "Payment card",
    "ru": "\u043a\u0440\u0435\u0434\u0438\u0442\u043d\u0430\u044f \u043a\u0430\u0440\u0442\u0430",
    "fi": "Maksukortti",
    "sv": "Betalskort",
    "fa": "\u06a9\u0627\u0631\u062a \u0627\u0639\u062a\u0628\u0627\u0631\u06cc",
    "ar": "\u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0627\u0626\u062a\u0645\u0627\u0646",
    "uk": "\u041f\u043b\u0430\u0442\u0456\u0436\u043d\u0430 \u043a\u0430\u0440\u0442\u043a\u0430"
  },
  "cards_list_expires_label": {
    "sheet_name": "Web",
    "en": "Expires",
    "ru": "\u0423\u0441\u0442\u0430\u0440\u0435\u043b\u043e",
    "fi": "Er\u00e4\u00e4ntyy",
    "sv": "L\u00f6per ut",
    "fa": "\u0645\u0646\u0642\u0636\u06cc \u0645\u06cc \u0634\u0648\u062f",
    "ar": "\u062a\u0646\u062a\u0647\u064a \u0627\u0644\u0635\u0644\u0627\u062d\u064a\u0629",
    "uk": "\u0417\u0430\u043a\u0456\u043d\u0447\u0443\u0454\u0442\u044c\u0441\u044f \u0442\u0435\u0440\u043c\u0456\u043d \u0434\u0456\u0457"
  },
  "cards_list_remove_label": {
    "sheet_name": "Web",
    "en": "Remove",
    "ru": "\u0423\u0434\u0430\u043b\u0438\u0442\u044c",
    "fi": "Poista",
    "sv": "Ta bort",
    "fa": "\u062d\u0630\u0641",
    "ar": "\u062d\u0630\u0641",
    "uk": "\u0412\u0438\u0434\u0430\u043b\u0438\u0442\u0438"
  },
  "cards_list_pp_label": {
    "sheet_name": "Web",
    "en": "PilotPoints",
    "ru": "PilotPoints",
    "fi": "PilotPoints",
    "sv": "PilotPoints",
    "fa": "PilotPoints",
    "ar": "PilotPoints",
    "uk": "PilotPoints"
  },
  "cards_list_billing_label": {
    "sheet_name": "Web",
    "en": "Billing",
    "ru": "\u0431\u0438\u043b\u043b\u0438\u043d\u0433",
    "fi": "Laskutus",
    "sv": "Faktura",
    "fa": "\u0635\u0648\u0631\u062a\u062d\u0633\u0627\u0628",
    "ar": "\u0627\u0644\u0641\u0648\u0627\u062a\u064a\u0631",
    "uk": "\u0412\u0438\u0441\u0442\u0430\u0432\u043b\u0435\u043d\u043d\u044f \u0440\u0430\u0445\u0443\u043d\u043a\u0456\u0432"
  },
  "cards_add_card_label": {
    "sheet_name": "Web",
    "en": "Add card",
    "ru": "\u0414\u043e\u0431\u0430\u0432\u0438\u0442\u044c \u043a\u0430\u0440\u0442\u0443",
    "fi": "Lis\u00e4\u00e4 maksukortti",
    "sv": "L\u00e4gg till ett bankkort",
    "fa": "\u06a9\u0627\u0631\u062a \u0627\u0636\u0627\u0641\u0647 \u06a9\u0646\u06cc\u062f",
    "ar": "\u0625\u0636\u0627\u0641\u0629 \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u062f\u0641\u0639",
    "uk": "\u0414\u043e\u0434\u0430\u0442\u0438 \u043a\u0430\u0440\u0442\u043a\u0443"
  },
  "cards_add_card_dialog_title": {
    "sheet_name": "Web",
    "en": "Add card",
    "ru": "\u0414\u043e\u0431\u0430\u0432\u0438\u0442\u044c \u043a\u0430\u0440\u0442\u0443",
    "fi": "Lis\u00e4\u00e4 maksukortti",
    "sv": "L\u00e4gg till ett bankkort",
    "fa": "\u06a9\u0627\u0631\u062a \u0627\u0636\u0627\u0641\u0647 \u06a9\u0646\u06cc\u062f",
    "ar": "\u0625\u0636\u0627\u0641\u0629 \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u062f\u0641\u0639",
    "uk": "\u0414\u043e\u0434\u0430\u0442\u0438 \u043a\u0430\u0440\u0442\u043a\u0443"
  },
  "cards_add_card_dialog_form_title": {
    "sheet_name": "Web",
    "en": "Card details",
    "ru": "\u0420\u0435\u043a\u0432\u0438\u0437\u0438\u0442\u044b \u043a\u0430\u0440\u0442\u044b",
    "fi": "Kortin tiedot",
    "sv": "Bankkorts detaljer",
    "fa": "\u062c\u0632\u0626\u06cc\u0627\u062a \u06a9\u0627\u0631\u062a",
    "ar": "\u0645\u0639\u0644\u0648\u0645\u0627\u062a \u0627\u0644\u0628\u0637\u0627\u0642\u0629",
    "uk": "\u0420\u0435\u043a\u0432\u0456\u0437\u0438\u0442\u0438 \u043a\u0430\u0440\u0442\u043a\u0438"
  },
  "cards_add_card_dialog_card_number_label": {
    "sheet_name": "Web",
    "en": "Card number",
    "ru": "\u041d\u043e\u043c\u0435\u0440 \u043a\u0430\u0440\u0442\u044b",
    "fi": "Korttinumero",
    "sv": "Kortnummer",
    "fa": "\u0634\u0645\u0627\u0631\u0647 \u06a9\u0627\u0631\u062a",
    "ar": "\u0631\u0642\u0645 \u0627\u0644\u0628\u0637\u0627\u0642\u0629",
    "uk": "\u041d\u043e\u043c\u0435\u0440 \u043a\u0430\u0440\u0442\u043a\u0438"
  },
  "cards_add_card_dialog_expiry_month_label": {
    "sheet_name": "Web",
    "en": "Expiration month",
    "ru": "\u041f\u043e\u0441\u043b\u0435\u0434\u043d\u0438\u0439 \u043c\u0435\u0441\u044f\u0446 \u0434\u043e \u0438\u0441\u0442\u0435\u0447\u0435\u043d\u0438\u044f \u0441\u0440\u043e\u043a\u0430 \u0433\u043e\u0434\u043d\u043e\u0441\u0442\u0438",
    "fi": "Viimeinen voimassaolo kuukausi",
    "sv": "Utg\u00e5ngsm\u00e5nad",
    "fa": "\u0645\u0627\u0647 \u0627\u0646\u0642\u0636\u0627",
    "ar": "\u0627\u0646\u062a\u0647\u0627\u0621 \u0634\u0647\u0631",
    "uk": "\u041e\u0441\u0442\u0430\u043d\u043d\u0456\u0439 \u043c\u0456\u0441\u044f\u0446\u044c \u0434\u043e \u0437\u0430\u043a\u0456\u043d\u0447\u0435\u043d\u043d\u044f \u0442\u0435\u0440\u043c\u0456\u043d\u0443 \u043f\u0440\u0438\u0434\u0430\u0442\u043d\u043e\u0441\u0442\u0456"
  },
  "cards_add_card_dialog_expiry_year_label": {
    "sheet_name": "Web",
    "en": "Expiration year",
    "ru": "\u041f\u043e\u0441\u043b\u0435\u0434\u043d\u0438\u0439 \u0433\u043e\u0434 \u0434\u043e \u0438\u0441\u0442\u0435\u0447\u0435\u043d\u0438\u044f \u0441\u0440\u043e\u043a\u0430 \u0433\u043e\u0434\u043d\u043e\u0441\u0442\u0438",
    "fi": "Viimeinen voimassaolo vuosi",
    "sv": "Utg\u00e5ngs\u00e5r",
    "fa": "\u0633\u0627\u0644 \u0627\u0646\u0642\u0636\u0627",
    "ar": "\u0633\u0646\u0629 \u0627\u0646\u062a\u0647\u0627\u0621 \u0627\u0644\u0635\u0644\u0627\u062d\u064a\u0629",
    "uk": "\u041e\u0441\u0442\u0430\u043d\u043d\u0456\u0439 \u0440\u0456\u043a \u0434\u043e \u0437\u0430\u043a\u0456\u043d\u0447\u0435\u043d\u043d\u044f \u0442\u0435\u0440\u043c\u0456\u043d\u0443 \u043f\u0440\u0438\u0434\u0430\u0442\u043d\u043e\u0441\u0442\u0456"
  },
  "cards_add_card_dialog_cvv_label": {
    "sheet_name": "Web",
    "en": "CVV",
    "ru": "CVV",
    "fi": "CVV",
    "sv": "CVV",
    "fa": "CVV",
    "ar": "CVV",
    "uk": "CVV"
  },
  "cards_add_card_dialog_cvv_help_text": {
    "sheet_name": "Web",
    "en": "3 or 4 digits usually found <br> on the signature strip",
    "ru": "3 \u0438\u043b\u0438 4 \u043d\u043e\u043c\u0435\u0440\u0430, \u043a\u043e\u0442\u043e\u0440\u044b\u0435 \u043d\u0430\u0445\u043e\u0434\u0438\u0442\u044c\u0441\u044f \u043d\u0430 \u043e\u0431\u0440\u0430\u0442\u043d\u043e\u0439 \u0441\u0442\u043e\u0440\u043e\u043d\u0435 \u043a\u0430\u0440\u0442\u043e\u0447\u043a\u0438 <br> \u0440\u044f\u0434\u043e\u043c \u0441 \u043f\u043e\u043b\u0435\u043c \u0434\u043b\u044f \u043f\u043e\u0434\u043f\u0438\u0441\u0438",
    "fi": "3 tai 4 lukua, jotka l\u00f6ytyv\u00e4t kortin <br> k\u00e4\u00e4nt\u00f6puolelta allekirjoitusnauhan vierest\u00e4",
    "sv": "3 eller 4 siffror finns vanligtvis <br> d\u00e4r du signerar",
    "fa": "\u0639\u062f\u062f\u06cc \u0633\u0647 \u06cc\u0627 \u0686\u0647\u0627\u0631 \u0631\u0642\u0645\u06cc \u06a9\u0647 \u062f\u0631 \u067e\u0634\u062a \u06a9\u0627\u0631\u062a \u062d\u06a9 \u0634\u062f\u0647 \u0627\u0633\u062a!",
    "ar": "\u0639\u0627\u062f\u0629 \u0645\u0627 \u064a\u062a\u0645 \u0627\u0644\u0639\u062b\u0648\u0631 \u0639\u0644\u0649 3 \u0623\u0648 4 \u0623\u0631\u0642\u0627\u0645 \u0639\u0644\u0649 \u0634\u0631\u064a\u0637 \u0627\u0644\u062a\u0648\u0642\u064a\u0639",
    "uk": "3 \u0430\u0431\u043e 4 \u0446\u0438\u0444\u0440\u0438, \u044f\u043a\u0456 \u0437\u0430\u0437\u0432\u0438\u0447\u0430\u0439 \u0437\u043d\u0430\u0445\u043e\u0434\u044f\u0442\u044c\u0441\u044f >\u043d\u0430 \u0437\u0432\u043e\u0440\u043e\u0442\u043d\u043e\u043c\u0443 \u0431\u043e\u0446\u0456 \u043a\u0430\u0440\u0442\u043a\u0438 <br> \u043f\u043e\u0440\u0443\u0447 \u0437\u0456 \u0441\u043c\u0443\u0433\u043e\u044e \u0434\u043b\u044f \u043f\u0456\u0434\u043f\u0438\u0441\u0443"
  },
  "cards_add_card_add_card_label": {
    "sheet_name": "Web",
    "en": "Proceed",
    "ru": "\u041f\u0440\u043e\u0434\u043e\u043b\u0436\u0430\u0442\u044c",
    "fi": "Jatka",
    "sv": "Forts\u00e4tt",
    "fa": "\u0627\u062f\u0627\u0645\u0647",
    "ar": "\u0625\u0633\u062a\u0645\u0631",
    "uk": "\u041f\u0440\u043e\u0434\u043e\u0432\u0436\u0438\u0442\u0438"
  },
  "cards_add_card_processing_label": {
    "sheet_name": "Web",
    "en": "Processing...",
    "ru": "\u041e\u0431\u0440\u0430\u0431\u043e\u0442\u043a\u0430 ...",
    "fi": "Odota hetki...",
    "sv": "Bearbetning..",
    "fa": "\u0686\u0646\u062f \u0644\u062d\u0638\u0647 \u0635\u0628\u0631 \u06a9\u0646\u06cc\u062f ...",
    "ar": "\u062c\u0627\u0631\u064a \u0627\u0644\u062a\u062d\u0645\u064a\u0644...",
    "uk": "\u041e\u0431\u0440\u043e\u0431\u043a\u0430..."
  },
  "cards_add_card_cancel_label": {
    "sheet_name": "Web",
    "en": "Close",
    "ru": "\u0417\u0430\u043a\u0440\u044b\u0442\u044c",
    "fi": "Sulje",
    "sv": "St\u00e4ng",
    "fa": "\u0628\u0633\u062a\u0646",
    "ar": "\u0642\u0641\u0644",
    "uk": "\u0417\u0430\u043a\u0440\u0438\u0442\u0438"
  },
  "cards_add_card_success_text": {
    "sheet_name": "Web",
    "en": "Card added.",
    "ru": "\u041a\u0430\u0440\u0442\u0430 \u0434\u043e\u0431\u0430\u0432\u043b\u0435\u043d\u0430",
    "fi": "Kortti lis\u00e4tty.",
    "sv": "L\u00e4gg till kort",
    "fa": "\u06a9\u0627\u0631\u062a \u0627\u0636\u0627\u0641\u0647 \u0634\u062f",
    "ar": "\u062a\u0645\u062a \u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0628\u0637\u0627\u0642\u0629",
    "uk": "\u041a\u0430\u0440\u0442\u043a\u0443 \u0434\u043e\u0434\u0430\u043d\u043e"
  },
  "cards_remove_confirm_title": {
    "sheet_name": "Web",
    "en": "Confirm removal of card",
    "ru": "\u041f\u043e\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435 \u0443\u0434\u0430\u043b\u0435\u043d\u0438\u0435 \u043a\u0430\u0440\u0442\u044b",
    "fi": "Vahvista kortin poisto",
    "sv": "Bekr\u00e4fta att kort tas bort",
    "fa": "\u062d\u0630\u0641 \u06a9\u0627\u0631\u062a \u0631\u0627 \u062a\u0623\u06cc\u06cc\u062f \u06a9\u0646\u06cc\u062f",
    "ar": "\u062a\u0623\u0643\u064a\u062f \u0625\u0632\u0627\u0644\u0629 \u0627\u0644\u0628\u0637\u0627\u0642\u0629",
    "uk": "\u041f\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438 \u0432\u0438\u0434\u0430\u043b\u0435\u043d\u043d\u044f \u043a\u0430\u0440\u0442\u043a\u0438"
  },
  "cards_remove_confirm_confirm_label": {
    "sheet_name": "Web",
    "en": "Confirm",
    "ru": "\u043f\u043e\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044c",
    "fi": "Vahvista",
    "sv": "Godk\u00e4nn",
    "fa": "\u062a\u0627\u06cc\u06cc\u062f",
    "ar": "\u062a\u0623\u0643\u064a\u062f",
    "uk": "\u041f\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438"
  },
  "cards_remove_confirm_cancel_label": {
    "sheet_name": "Web",
    "en": "Cancel",
    "ru": "\u043e\u0442\u043c\u0435\u043d\u0438\u0442\u044c",
    "fi": "Peruuta",
    "sv": "Avbryta",
    "fa": "\u0644\u063a\u0648",
    "ar": "\u062a\u0631\u0627\u062c\u0639",
    "uk": "\u0421\u043a\u0430\u0441\u0443\u0432\u0430\u0442\u0438"
  },
  "cards_remove_confirm_content_text": {
    "sheet_name": "Web",
    "en": "Are you sure you want to delete this card?",
    "ru": "\u0412\u044b \u0443\u0432\u0435\u0440\u0435\u043d\u044b, \u0447\u0442\u043e \u0445\u043e\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043b\u0438\u0442\u044c \u044d\u0442\u0443 \u043a\u0430\u0440\u0442\u0443?",
    "fi": "Oletko varma, ett\u00e4 haluat poistaa t\u00e4m\u00e4n kortin?",
    "sv": "\u00c4r du s\u00e4ker p\u00e5 att du vill radera detta kort",
    "fa": "\u0645\u0637\u0645\u0626\u0646 \u0647\u0633\u062a\u06cc\u062f \u06a9\u0647 \u0645\u06cc \u062e\u0648\u0627\u0647\u06cc\u062f \u0627\u06cc\u0646 \u06a9\u0627\u0631\u062a \u0631\u0627 \u062d\u0630\u0641 \u06a9\u0646\u06cc\u062f\u061f",
    "ar": "\u0647\u0644 \u0627\u0646\u062a \u0645\u062a\u0623\u0643\u062f \u0627\u0646\u0643 \u062a\u0631\u064a\u062f \u062d\u0630\u0641 \u0627\u0644\u0628\u0637\u0627\u0642\u0629\u061f",
    "uk": "\u0412\u0438 \u0432\u043f\u0435\u0432\u043d\u0435\u043d\u0456, \u0449\u043e \u0445\u043e\u0447\u0435\u0442\u0435 \u0432\u0438\u0434\u0430\u043b\u0438\u0442\u0438 \u0446\u044e \u043a\u0430\u0440\u0442\u043a\u0443?"
  },
  "cards_remove_success_text": {
    "sheet_name": "Web",
    "en": "Card removed.",
    "ru": "\u0423\u0434\u0430\u043b\u0435\u043d\u043d\u0430\u044f \u043a\u0430\u0440\u0442\u0430",
    "fi": "Kortti poistettu",
    "sv": "Betalkortet \u00e4r borttaget",
    "fa": "\u06a9\u0627\u0631\u062a \u062d\u0630\u0641 \u0634\u062f",
    "ar": "\u062a\u0645\u062a \u0625\u0632\u0627\u0644\u0629 \u0627\u0644\u0628\u0637\u0627\u0642\u0629",
    "uk": "\u041a\u0430\u0440\u0442\u043a\u0443 \u0432\u0438\u0434\u0430\u043b\u0435\u043d\u043e"
  },
  "cards_label_tooltip": {
    "sheet_name": "Web",
    "en": "WorkPilots does not store the card information, it is only saved by our payment processor. WorkPilots only stores the card token they get from the payment processor.",
    "ru": "",
    "fi": "Maksukorttitiedot v\u00e4litet\u00e4\u00e4n ainoastaan maksunv\u00e4litt\u00e4j\u00e4n j\u00e4rjestelm\u00e4\u00e4n. WorkPilotsiin tallennetaan vain tekninen avain maksukortista ja osa korttinumerosta.",
    "sv": "WorkPilots lagrar inte n\u00e5gon kortinformationen, den sparas endast av v\u00e5r betalningsoperat\u00f6r. WorkPilots lagrar endast korttoken de f\u00e5r fr\u00e5n betalningsoperat\u00f6ren.",
    "fa": "",
    "ar": "",
    "uk": "WorkPilots \u043d\u0435 \u0437\u0431\u0435\u0440\u0456\u0433\u0430\u0454 \u0456\u043d\u0444\u043e\u0440\u043c\u0430\u0446\u0456\u044e \u043f\u0440\u043e \u043a\u0430\u0440\u0442\u043a\u0443, \u0457\u0457 \u0437\u0431\u0435\u0440\u0456\u0433\u0430\u0454 \u043b\u0438\u0448\u0435 \u043d\u0430\u0448 \u043f\u043b\u0430\u0442\u0456\u0436\u043d\u0438\u0439 \u043f\u0440\u043e\u0446\u0435\u0441\u043e\u0440. WorkPilots \u0437\u0431\u0435\u0440\u0456\u0433\u0430\u0454 \u043b\u0438\u0448\u0435 \u043a\u0430\u0440\u0442\u043a\u043e\u0432\u0438\u0439 \u0442\u043e\u043a\u0435\u043d, \u044f\u043a\u0438\u0439 \u0432\u043e\u043d\u0438 \u043e\u0442\u0440\u0438\u043c\u0443\u044e\u0442\u044c \u0437 \u043f\u043b\u0430\u0442\u0456\u0436\u043d\u043e\u0433\u043e \u043f\u0440\u043e\u0446\u0435\u0441\u043e\u0440\u0430"
  },
  "chat_search_field": {
    "sheet_name": "Web",
    "en": "Search chat partners",
    "ru": "",
    "fi": "Etsi chat",
    "sv": "S\u00f6k chat",
    "fa": "",
    "ar": "",
    "uk": "\u041f\u043e\u0448\u0443\u043a \u0447\u0430\u0442-\u043f\u0430\u0440\u0442\u043d\u0435\u0440\u0456\u0432"
  },
  "chat_order_has_been_taken": {
    "sheet_name": "Web",
    "en": "Outdated order",
    "ru": "",
    "fi": "Vanhentunut tilaus",
    "sv": "F\u00f6r\u00e5ldrad uppdrag",
    "fa": "",
    "ar": "",
    "uk": "\u0417\u0430\u0441\u0442\u0430\u0440\u0456\u043b\u0435 \u0437\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f"
  },
  "chat_order_has_been_taken_orderer": {
    "sheet_name": "Web",
    "en": "You selected another worker",
    "ru": "",
    "fi": "Valitsit toisen ty\u00f6ntekij\u00e4n",
    "sv": "Du valde en annan arbetare",
    "fa": "",
    "ar": "",
    "uk": "\u0412\u0438 \u0432\u0438\u0431\u0440\u0430\u043b\u0438 \u0456\u043d\u0448\u043e\u0433\u043e \u043f\u0440\u0430\u0446\u0456\u0432\u043d\u0438\u043a\u0430"
  },
  "chat_goto_unread_label": {
    "sheet_name": "Web",
    "en": "Jump to unread",
    "ru": "",
    "fi": "Siirry lukemattomiin viesteihin",
    "sv": "G\u00e5 till ol\u00e4sta meddelanden",
    "fa": "",
    "ar": "",
    "uk": "\u041f\u0435\u0440\u0435\u0439\u0442\u0438 \u0434\u043e \u043d\u0435\u043f\u0440\u043e\u0447\u0438\u0442\u0430\u043d\u043e\u0433\u043e"
  },
  "chat_new_label": {
    "sheet_name": "Web",
    "en": "New",
    "ru": "",
    "fi": "Uusi",
    "sv": "Nytt",
    "fa": "",
    "ar": "",
    "uk": "\u041d\u043e\u0432\u0438\u0439"
  },
  "chat_order_apply_not_approved": {
    "sheet_name": "Web",
    "en": "Unfortunately you can't chat because you have not been approved for the service. Please contact customer support.",
    "ru": "",
    "fi": "Voit chattailla vasta kun sinut on hyv\u00e4ksytty palveluun. Odota kunnes hyv\u00e4ksynt\u00e4 valmistuu.",
    "sv": "Tyv\u00e4rr kan du inte chatta innan du blivit godk\u00e4nd f\u00f6r tj\u00e4nsten. V\u00e4nligen avvakta tills du \u00e4r godk\u00e4nd.",
    "fa": "",
    "ar": "",
    "uk": "\u0412\u0438 \u043c\u043e\u0436\u0435\u0442\u0435 \u0441\u043f\u0456\u043b\u043a\u0443\u0432\u0430\u0442\u0438\u0441\u044f \u043b\u0438\u0448\u0435 \u043f\u0456\u0441\u043b\u044f \u0442\u043e\u0433\u043e, \u044f\u043a \u0432\u0430\u0441 \u043f\u0440\u0438\u0439\u043c\u0443\u0442\u044c \u0434\u043e \u043f\u043e\u0441\u043b\u0443\u0433\u0438. \u0417\u0430\u0447\u0435\u043a\u0430\u0439\u0442\u0435, \u0434\u043e\u043a\u0438 \u0437\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u044c\u0441\u044f \u0437\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043d\u043d\u044f."
  },
  "chat_input_placeholder": {
    "sheet_name": "Web",
    "en": "Write your message...",
    "ru": "",
    "fi": "Kirjoita viestisi...",
    "sv": "Skriv n\u00e5got...",
    "fa": "",
    "ar": "",
    "uk": "\u041d\u0430\u043f\u0438\u0448\u0456\u0442\u044c \u043f\u043e\u0432\u0456\u0434\u043e\u043c\u043b\u0435\u043d\u043d\u044f..."
  },
  "table_header_chat": {
    "sheet_name": "Web",
    "en": "Chat",
    "ru": "\u0427\u0430\u0442",
    "fi": "Viestit",
    "sv": "Chatt",
    "fa": "\u067e\u06cc\u0627\u0645 \u0647\u0627",
    "ar": "\u0627\u0644\u0631\u0633\u0627\u0626\u0644",
    "uk": "\u0427\u0430\u0442"
  },
  "private_chats_worker_chats": {
    "sheet_name": "Web",
    "en": "Worker chats",
    "ru": "",
    "fi": "Tekij\u00e4n chatit",
    "sv": "Chat f\u00f6r uppdragstagaren",
    "fa": "",
    "ar": "",
    "uk": "\u0420\u043e\u0431\u043e\u0447\u0438\u0439 \u0447\u0430\u0442"
  },
  "private_chat_discussion_with orderer": {
    "sheet_name": "Web",
    "en": "Private discussion with orderer",
    "ru": "",
    "fi": "Yksityinen chatti tilaajan kanssa",
    "sv": "Privat kommunikation med best\u00e4llaren",
    "fa": "",
    "ar": "",
    "uk": "\u041f\u0440\u0438\u0432\u0430\u0442\u043d\u0430 \u0440\u043e\u0437\u043c\u043e\u0432\u0430 \u0437 \u0437\u0430\u043c\u043e\u0432\u043d\u0438\u043a\u043e\u043c"
  },
  "private_chat_discussion_closed": {
    "sheet_name": "Web",
    "en": "Discussion closed (Worker(s) selected)",
    "ru": "",
    "fi": "Chatti suljettu (tekij\u00e4(t) valittu)",
    "sv": "Dialog \u00e4r st\u00e4ngd (uppdragstagare vald)",
    "fa": "",
    "ar": "",
    "uk": "\u041e\u0431\u0433\u043e\u0432\u043e\u0440\u0435\u043d\u043d\u044f \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043d\u043e (\u043e\u0431\u0440\u0430\u043d\u043e \u043f\u0440\u0430\u0446\u0456\u0432\u043d\u0438\u043a\u0430(\u0456\u0432))"
  },
  "private_chat_no_discussion_yet": {
    "sheet_name": "Web",
    "en": "No chats yet",
    "ru": "",
    "fi": "Ei viel\u00e4 chatteja",
    "sv": "Ingen dialog \u00e4nnu",
    "fa": "",
    "ar": "",
    "uk": "\u0429\u0435 \u043d\u0435\u043c\u0430\u0454 \u0447\u0430\u0442\u0456\u0432"
  },
  "send_with_enter_button": {
    "sheet_name": "Web",
    "en": "Send with enter",
    "ru": "",
    "fi": "L\u00e4het\u00e4 Enter-n\u00e4pp\u00e4imell\u00e4",
    "sv": "Skicka med enter",
    "fa": "",
    "ar": "",
    "uk": "\u041d\u0430\u0434\u0456\u0441\u043b\u0430\u0442\u0438 \u0437\u0430 \u0434\u043e\u043f\u043e\u043c\u043e\u0433\u043e\u044e Enter"
  },
  "other_workers_for_this_order": {
    "sheet_name": "Web",
    "en": "All chats for this order",
    "ru": "",
    "fi": "Tilauksen kaikki chatit",
    "sv": "Alla chattar f\u00f6r den h\u00e4r uppgiften",
    "fa": "",
    "ar": "",
    "uk": "\u0412\u0441\u0456 \u0447\u0430\u0442\u0438 \u0434\u043b\u044f \u0434\u0430\u043d\u043e\u0433\u043e \u0437\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f"
  },
  "chat_upload_image": {
    "sheet_name": "Web",
    "en": "Upload image",
    "ru": "",
    "fi": "Lataa kuva",
    "sv": "Ladda upp bild",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "chat_upload_image_button": {
    "sheet_name": "Web",
    "en": "Send image",
    "ru": "",
    "fi": "L\u00e4het\u00e4 kuva",
    "sv": "Skicka bilden",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "chat_invalid_image": {
    "sheet_name": "Web",
    "en": "Image should be smaller than 2 megabytes.",
    "ru": "",
    "fi": "Kuvan on oltava pienempi kuin 2 megatavua",
    "sv": "Bilden b\u00f6r vara mindre \u00e4n 2 megabyte.",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "chat_start_cropping": {
    "sheet_name": "Web",
    "en": "Crop",
    "ru": "",
    "fi": "Rajaa",
    "sv": "Besk\u00e4ra",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "chat_open_profile": {
    "sheet_name": "Web",
    "en": "Open Profile in new tab",
    "ru": "\u041f\u043e\u0441\u043c\u043e\u0442\u0440\u0435\u0442\u044c \u043f\u0440\u043e\u0444\u0438\u043b\u044c",
    "fi": "N\u00e4yt\u00e4 profiili",
    "sv": "Visa profil",
    "fa": "\u0645\u0634\u0627\u0647\u062f\u0647 \u067e\u0631\u0648\u0641\u0627\u06cc\u0644",
    "ar": "\u0639\u0631\u0636 \u0627\u0644\u0635\u0641\u062d\u0629 \u0627\u0644\u0634\u062e\u0635\u064a\u0629",
    "uk": "\u041f\u0435\u0440\u0435\u0433\u043b\u044f\u043d\u0443\u0442\u0438 \u043f\u0440\u043e\u0444\u0456\u043b\u044c"
  },
  "chat_image_label": {
    "sheet_name": "Web",
    "en": "Image",
    "ru": "",
    "fi": "Kuva",
    "sv": "Bild",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "receipt_id": {
    "sheet_name": "Web",
    "en": "Order ID:",
    "ru": "\u0418\u0434\u0435\u043d\u0442\u0438\u0444\u0438\u043a\u0430\u0442\u043e\u0440 \u0437\u0430\u0434\u0430\u043d\u0438\u044f:",
    "fi": "Tilauksen tunnus:",
    "sv": "Uppdrags-ID:",
    "fa": "\u0622\u06cc\u062f\u06cc \u06a9\u0627\u0631:",
    "ar": "\u0645\u0639\u0631\u0641\u0629 \u0627\u0644\u0645\u0647\u0645\u0629 :",
    "uk": "\u0406\u0434\u0435\u043d\u0442\u0438\u0444\u0456\u043a\u0430\u0442\u043e\u0440 \u0437\u0430\u0432\u0434\u0430\u043d\u043d\u044f:"
  },
  "receipt_date": {
    "sheet_name": "Web",
    "en": "Date:",
    "ru": "\u0414\u0430\u0442\u0430:",
    "fi": "P\u00e4iv\u00e4m\u00e4\u00e4r\u00e4:",
    "sv": "Datum:",
    "fa": "\u062a\u0627\u0631\u06cc\u062e:",
    "ar": "\u062a\u0627\u0631\u064a\u062e :",
    "uk": "\u0414\u0430\u0442\u0430"
  },
  "receipt_merchant": {
    "sheet_name": "Web",
    "en": "Merchant:",
    "ru": "\u0422\u043e\u0440\u0433\u043e\u0432\u0435\u0446:",
    "fi": "Kauppias:",
    "sv": "S\u00e4ljare",
    "fa": "\u0628\u0627\u0632\u0631\u06af\u0627\u0646:",
    "ar": "\u0627\u0644\u0645\u0627\u0644\u0643 :",
    "uk": "\u041f\u0440\u043e\u0434\u0430\u0432\u0435\u0446\u044c:"
  },
  "receipt_orderer": {
    "sheet_name": "Web",
    "en": "Orderer:",
    "ru": "\u0417\u0430\u043a\u0430\u0437\u0447\u0438\u043a:",
    "fi": "Tilaaja:",
    "sv": "Best\u00e4llare:",
    "fa": "\u0633\u0641\u0627\u0631\u0634 \u062f\u0647\u0646\u062f\u0647:",
    "ar": "\u0627\u0644\u0645\u0634\u062a\u0631\u064a :",
    "uk": "\u0417\u0430\u043c\u043e\u0432\u043d\u0438\u043a"
  },
  "receipt_ord_service": {
    "sheet_name": "Web",
    "en": "Ordered service:",
    "ru": "\u0417\u0430\u043a\u0430\u0437\u0430\u043d\u043d\u044b\u0439 \u0441\u0435\u0440\u0432\u0438\u0441:",
    "fi": "Tilattu palvelu:",
    "sv": "Best\u00e4lld service:",
    "fa": "\u062e\u062f\u0645\u0627\u062a \u0633\u0641\u0627\u0631\u0634\u064a:",
    "ar": "\u0627\u0644\u062e\u062f\u0645\u0647 \u0627\u0644\u0645\u0637\u0644\u0648\u0628\u0647 :",
    "uk": "\u0417\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u0430 \u043f\u043e\u0441\u043b\u0443\u0433\u0430:"
  },
  "receipt_conf_time": {
    "sheet_name": "Web",
    "en": "Confirmed time:",
    "ru": "\u041f\u043e\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043d\u043d\u043e\u0435 \u0432\u0440\u0435\u043c\u044f:",
    "fi": "Vahvistettu aika:",
    "sv": "Bekr\u00e4fta tid:",
    "fa": "\u0632\u0645\u0627\u0646 \u062a\u0623\u06cc\u06cc\u062f \u0634\u062f\u0647:",
    "ar": "\u062a\u0645 \u062a\u0623\u0643\u064a\u062f \u0627\u0644\u0648\u0642\u062a:",
    "uk": "\u041f\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043d\u0438\u0439 \u0447\u0430\u0441:"
  },
  "receipt_label": {
    "sheet_name": "Web",
    "en": "Receipt",
    "ru": "\u041a\u0432\u0438\u0442\u0430\u043d\u0446\u0438\u044f",
    "fi": "Kuitti",
    "sv": "Kvitto",
    "fa": "\u0642\u0628\u0636 \u0631\u0633\u06cc\u062f",
    "ar": "\u0627\u0644\u0625\u064a\u0635\u0627\u0644",
    "uk": "\u041a\u0432\u0438\u0442\u0430\u043d\u0446\u0456\u044f"
  },
  "receipt_vat_num": {
    "sheet_name": "Web",
    "en": "VAT number:",
    "ru": "\u041d\u043e\u043c\u0435\u0440 \u041d\u0414\u0421:",
    "fi": "ALV-numero:",
    "sv": "Org. nummer:",
    "fa": "\u0634\u0645\u0627\u0631\u0647 \u0645\u0627\u0644\u06cc\u0627\u062a \u0628\u0631 \u0627\u0631\u0632\u0634 \u0627\u0641\u0632\u0648\u062f\u0647:",
    "ar": "\u0636\u0631\u064a\u0628\u0629 \u0627\u0644\u0634\u0631\u0627\u0621",
    "uk": "\u041d\u043e\u043c\u0435\u0440 \u041f\u0414\u0412:"
  },
  "login_form_close": {
    "sheet_name": "Web",
    "en": "Close",
    "ru": "\u0417\u0430\u043a\u0440\u044b\u0442\u044c",
    "fi": "Sulje",
    "sv": "St\u00e4ng",
    "fa": "\u0628\u0633\u062a\u0646",
    "ar": "\u0642\u0641\u0644",
    "uk": "\u0417\u0430\u043a\u0440\u0438\u0442\u0438"
  },
  "payment_method_selector_no_options_text": {
    "sheet_name": "Web",
    "en": "There is no available payment option for this transaction.",
    "ru": "\u0423 \u0432\u0430\u0441 \u043d\u0435\u0442 \u043f\u043e\u0434\u0445\u043e\u0434\u044f\u0449\u0438\u0445 \u0441\u043f\u043e\u0441\u043e\u0431\u043e\u0432 \u043e\u043f\u043b\u0430\u0442\u044b \u0434\u043b\u044f \u044d\u0442\u043e\u0433\u043e \u0441\u043e\u0431\u044b\u0442\u0438\u044f.",
    "fi": "K\u00e4yt\u00f6ss\u00e4si ei ole sopivia maksutapoja t\u00e4h\u00e4n tapahtumaan.",
    "sv": "Det finns inget tillg\u00e4ngligt betalningsalternativ f\u00f6r den h\u00e4r transaktionen.",
    "fa": "\u06af\u0632\u06cc\u0646\u0647 \u067e\u0631\u062f\u0627\u062e\u062a \u062f\u0631 \u062f\u0633\u062a\u0631\u0633 \u0628\u0631\u0627\u06cc \u0627\u06cc\u0646 \u0645\u0639\u0627\u0645\u0644\u0647 \u0648\u062c\u0648\u062f \u0646\u062f\u0627\u0631\u062f.",
    "ar": "\u0644\u0627\u064a\u0648\u062c\u062f \u062e\u064a\u0627\u0631 \u062f\u0641\u0639 \u0645\u062a\u0627\u062d \u0644\u0647\u0630\u0647 \u0627\u0644\u0645\u0639\u0627\u0645\u0644\u0629",
    "uk": "\u0414\u043b\u044f \u0446\u0456\u0454\u0457 \u0442\u0440\u0430\u043d\u0437\u0430\u043a\u0446\u0456\u0457 \u043d\u0435\u043c\u0430\u0454 \u0434\u043e\u0441\u0442\u0443\u043f\u043d\u043e\u0433\u043e \u0441\u043f\u043e\u0441\u043e\u0431\u0443 \u043e\u043f\u043b\u0430\u0442\u0438"
  },
  "payment_method_selector_add_card_text": {
    "sheet_name": "Web",
    "en": "Please consider <a href=\"\/cards\">adding a new card<\/a>.",
    "ru": "\u0412\u044b \u043c\u043e\u0436\u0435\u0442\u0435 \u0434\u043e\u0431\u0430\u0432\u0438\u0442\u044c <a href=\"\/cards\"> \u043d\u043e\u0432\u0443\u044e \u043a\u0430\u0440\u0442\u0443 \u043e\u0442\u0441\u044e\u0434\u0430 <\/a>.",
    "fi": "Voit lis\u00e4t\u00e4 <a href=\"\/cards\">uuden kortin t\u00e4st\u00e4<\/a>.",
    "sv": "T\u00e4nk p\u00e5 <a href=\"\/cards\"> l\u00e4gga till ett nytt kort <\/a>.",
    "fa": "\u0644\u0637\u0641\u0627\u064b <a href=\"\/cards\"> \u0627\u0641\u0632\u0648\u062f\u0646 \u06a9\u0627\u0631\u062a \u062c\u062f\u06cc\u062f <\/a> \u0631\u0627 \u062f\u0631 \u0646\u0638\u0631 \u0628\u06af\u06cc\u0631\u06cc\u062f.",
    "ar": "\u064a\u0645\u0643\u0646\u0643 \u0625\u0636\u0627\u0641\u0629 <a href=\"\/cards\"> \u0643\u0631\u062a \u062c\u062f\u064a\u062f \u0647\u0646\u0627",
    "uk": "\u0411\u0443\u0434\u044c \u043b\u0430\u0441\u043a\u0430, \u0440\u043e\u0437\u0433\u043b\u044f\u043d\u044c\u0442\u0435 \u043c\u043e\u0436\u043b\u0438\u0432\u0456\u0441\u0442\u044c <a href=\"\/cards\">\u0434\u043e\u0434\u0430\u0432\u0430\u043d\u043d\u044f \u043d\u043e\u0432\u043e\u0457 \u043a\u0430\u0440\u0442\u043a\u0438<\/a>"
  },
  "payment_method_selector_select_text": {
    "sheet_name": "Web",
    "en": "You need to select a payment method.",
    "ru": "\u0412\u044b\u0431\u0435\u0440\u0438\u0442\u0435 \u0441\u043f\u043e\u0441\u043e\u0431 \u043e\u043f\u043b\u0430\u0442\u044b.",
    "fi": "Valitsethan maksutavan.",
    "sv": "V\u00e4lj en betalningsmetod.",
    "fa": "\u0634\u0645\u0627 \u0628\u0627\u06cc\u062f \u06cc\u06a9 \u0631\u0648\u0634 \u067e\u0631\u062f\u0627\u062e\u062a \u0631\u0627 \u0627\u0646\u062a\u062e\u0627\u0628 \u06a9\u0646\u06cc\u062f.",
    "ar": "\u064a\u0631\u062c\u0649 \u0625\u062e\u062a\u064a\u0627\u0631 \u0637\u0631\u064a\u0642\u0629 \u0627\u0644\u062f\u0641\u0639",
    "uk": "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044c \u0441\u043f\u043e\u0441\u0456\u0431 \u043e\u043f\u043b\u0430\u0442\u0438"
  },
  "payment_method_selector_close_label": {
    "sheet_name": "Web",
    "en": "Close",
    "ru": "\u0417\u0430\u043a\u0440\u044b\u0442\u044c",
    "fi": "Sulje",
    "sv": "St\u00e4ng",
    "fa": "\u0628\u0633\u062a\u0646",
    "ar": "\u0642\u0641\u0644",
    "uk": "\u0417\u0430\u043a\u0440\u0438\u0442\u0438"
  },
  "payment_method_selector_select_label": {
    "sheet_name": "Web",
    "en": "Select",
    "ru": "\u0412\u044b\u0431\u0440\u0430\u0442\u044c",
    "fi": "Valitse",
    "sv": "V\u00e4lj",
    "fa": "\u0627\u0646\u062a\u062e\u0627\u0628 \u06a9\u0646\u06cc\u062f",
    "ar": "\u062a\u062d\u062f\u064a\u062f",
    "uk": "\u0412\u0438\u0431\u0440\u0430\u0442\u0438"
  },
  "payment_method_selector_select_payment_label": {
    "sheet_name": "Web",
    "en": "Select payment method",
    "ru": "\u041f\u043e\u0436\u0430\u043b\u0443\u0439\u0441\u0442\u0430, \u0434\u043e\u0431\u0430\u0432\u044c\u0442\u0435 \u0441\u043f\u043e\u0441\u043e\u0431 \u043e\u043f\u043b\u0430\u0442\u044b",
    "fi": "Valitse maksutapa",
    "sv": "V\u00e4lja betalningsmetod",
    "fa": "\u0644\u0637\u0641\u0627\u064b \u0631\u0648\u0634 \u067e\u0631\u062f\u0627\u062e\u062a \u0631\u0627 \u0627\u0646\u062a\u062e\u0627\u0628 \u06a9\u0646\u06cc\u062f",
    "ar": "\u0625\u062e\u062a\u0631 \u0637\u0631\u064a\u0642\u0629 \u0627\u0644\u062f\u0641\u0639",
    "uk": "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044c \u0441\u043f\u043e\u0441\u0456\u0431 \u043e\u043f\u043b\u0430\u0442\u0438"
  },
  "payment_provider_not_available_text": {
    "sheet_name": "Web",
    "en": "Card payments are not available for this service",
    "ru": "",
    "fi": "Korttimaksut eiv\u00e4t ole k\u00e4yt\u00f6ss\u00e4 t\u00e4ss\u00e4 palvelussa",
    "sv": "Kortbetalningar \u00e4r inte aktiverade",
    "fa": ".",
    "ar": "",
    "uk": "\u041a\u0430\u0440\u0442\u043a\u043e\u0432\u0456 \u043f\u043b\u0430\u0442\u0435\u0436\u0456 \u0434\u043b\u044f \u0446\u0456\u0454\u0457 \u043f\u043e\u0441\u043b\u0443\u0433\u0438 \u043d\u0435\u0434\u043e\u0441\u0442\u0443\u043f\u043d\u0456"
  },
  "payment_and_reports_manage_pilotpoints": {
    "sheet_name": "Web",
    "en": "Manage PilotPoints",
    "ru": "",
    "fi": "Hallinnoi PilotPointseja",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0423\u043f\u0440\u0430\u0432\u043b\u0456\u043d\u043d\u044f PilotPoints"
  },
  "compl_date": {
    "sheet_name": "Web",
    "en": "Completion date",
    "ru": "\u0414\u0435\u043d\u044c \u043e\u043a\u043e\u043d\u0447\u0430\u043d\u0438\u044f",
    "fi": "Valmistumisp\u00e4iv\u00e4",
    "sv": "Uppdragets slutdatum",
    "fa": "\u062a\u0627\u0631\u06cc\u062e \u062a\u06a9\u0645\u06cc\u0644",
    "ar": "\u062a\u0627\u0631\u064a\u062e \u0627\u0644\u0625\u0646\u062a\u0647\u0627\u0621",
    "uk": "\u0414\u0430\u0442\u0430 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043d\u043d\u044f"
  },
  "orderer_reports_report_text": {
    "sheet_name": "Web",
    "en": "Reports",
    "ru": "O\u0442\u0447\u0435\u0442\u044b",
    "fi": "Raportit",
    "sv": "Rapporter",
    "fa": "\u06af\u0632\u0627\u0631\u0634 \u0647\u0627",
    "ar": "\u062a\u0642\u0627\u0631\u064a\u0631",
    "uk": "\u0417\u0432\u0456\u0442\u0438"
  },
  "orderer_reports_merchant_label": {
    "sheet_name": "Web",
    "en": "Service",
    "ru": "\u0421\u0435\u0440\u0432\u0438\u0441",
    "fi": "Palvelu",
    "sv": "Tj\u00e4nst",
    "fa": "\u0633\u0631\u0648\u06cc\u0633 (\u062e\u062f\u0645\u0627\u062a)",
    "ar": "\u0627\u0644\u062e\u062f\u0645\u0627\u062a",
    "uk": "\u041e\u0431\u0441\u043b\u0443\u0433\u043e\u0432\u0443\u0432\u0430\u043d\u043d\u044f"
  },
  "orderer_reports_creation_date_label": {
    "sheet_name": "Web",
    "en": "Creation date",
    "ru": "\u0421\u043e\u0437\u0434\u0430\u043d \u0432",
    "fi": "Tilaus luotu",
    "sv": "Best\u00e4llning skapad",
    "fa": "\u062a\u0627\u0631\u06cc\u062e \u0627\u06cc\u062c\u0627\u062f",
    "ar": "\u062a\u0627\u0631\u064a\u062e \u0627\u0644\u0625\u0646\u0634\u0627\u0621",
    "uk": "\u0417\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f \u0441\u0442\u0432\u043e\u0440\u0435\u043d\u043e"
  },
  "orderer_reports_completion_date_label": {
    "sheet_name": "Web",
    "en": "Completion date",
    "ru": "\u0414\u0435\u043d\u044c \u0438\u0437\u0433\u043e\u0442\u043e\u0432\u043b\u0435\u043d\u0438\u044f",
    "fi": "Valmistumisp\u00e4iv\u00e4",
    "sv": "Uppdragets slutdatum",
    "fa": "\u062a\u0627\u0631\u06cc\u062e \u062a\u06a9\u0645\u06cc\u0644",
    "ar": "\u062a\u0627\u0631\u064a\u062e \u0627\u0644\u0625\u0646\u062a\u0647\u0627\u0621",
    "uk": "\u0414\u0430\u0442\u0430 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043d\u043d\u044f"
  },
  "orderer_reports_filter_by_label": {
    "sheet_name": "Web",
    "en": "Filter by",
    "ru": "\u0424\u0438\u043b\u044c\u0442\u0440\u043e\u0432\u0430\u0442\u044c",
    "fi": "Suodata",
    "sv": "Sortera p\u00e5",
    "fa": "\u0641\u06cc\u0644\u062a\u0631 \u0628\u0631 \u0627\u0633\u0627\u0633",
    "ar": "\u0645\u0635\u0646\u0641 \u0628\u0648\u0627\u0633\u0637\u0629",
    "uk": "\u0424\u0456\u043b\u044c\u0442\u0440\u0443\u0432\u0430\u0442\u0438 \u0437\u0430"
  },
  "orderer_reports_file_type_label": {
    "sheet_name": "Web",
    "en": "File type",
    "ru": "\u0422\u0438\u043f \u0444\u0430\u0439\u043b\u0430",
    "fi": "Tiedoston muoto",
    "sv": "Filtyp",
    "fa": "\u0646\u0648\u0639 \u0641\u0627\u06cc\u0644",
    "ar": "\u0646\u0648\u0639 \u0627\u0644\u0645\u0644\u0641",
    "uk": "\u0422\u0438\u043f \u0444\u0430\u0439\u043b\u0443"
  },
  "orderer_reports_period_label": {
    "sheet_name": "Web",
    "en": "Period",
    "ru": "\u041f\u0435\u0440\u0438\u043e\u0434",
    "fi": "Jakso",
    "sv": "Period",
    "fa": "\u062f\u0648\u0631\u0647 \u06cc \u0632\u0645\u0627\u0646\u06cc",
    "ar": "\u0641\u062a\u0631\u0629",
    "uk": "\u041f\u0435\u0440\u0456\u043e\u0434"
  },
  "orderer_reports_from_date_label": {
    "sheet_name": "Web",
    "en": "From",
    "ru": "\u041e\u0442\u043a\u0443\u0434\u0430",
    "fi": "Mist\u00e4",
    "sv": "Fr\u00e5n",
    "fa": "\u0627\u0632 \u062c\u0627\u0646\u0628",
    "ar": "\u0645\u0646 \u0639\u0646\u062f",
    "uk": "\u0417\u0432\u0456\u0434\u043a\u0438"
  },
  "orderer_reports_to_date_label": {
    "sheet_name": "Web",
    "en": "To",
    "ru": "\u041a\u0443\u0434\u0430",
    "fi": "Mihin",
    "sv": "Till",
    "fa": "\u0628\u0647",
    "ar": "\u0625\u0644\u0649",
    "uk": "\u041a\u0443\u0434\u0438"
  },
  "orderer_reports_button_in_progress_text": {
    "sheet_name": "Web",
    "en": "Building report",
    "ru": "\u041e\u0442\u0447\u0451\u0442 \u0433\u0435\u043d\u0435\u0440\u0438\u0440\u0443\u0435\u0442\u0441\u044f",
    "fi": "Muodostetaan raporttia",
    "sv": "Sammanst\u00e4ller rapport",
    "fa": "\u062a\u0647\u06cc\u0647 \u06af\u0632\u0627\u0631\u0634",
    "ar": "\u062a\u0642\u0631\u064a\u0631 \u0627\u0644\u0628\u0646\u0627\u0621",
    "uk": "\u0421\u0444\u043e\u0440\u043c\u0443\u0432\u0430\u0442\u0438 \u0437\u0432\u0456\u0442"
  },
  "orderer_reports_button_text": {
    "sheet_name": "Web",
    "en": "Download report",
    "ru": "\u041f\u043e\u0440\u0442 \u0434\u043b\u044f \u0437\u0430\u0440\u044f\u0434\u043a\u0438",
    "fi": "Lataa raportti",
    "sv": "Nedladdningsrapport",
    "fa": "\u06af\u0632\u0627\u0631\u0634 \u0628\u0627\u0631\u06af\u06cc\u0631\u06cc",
    "ar": "\u062a\u0646\u0632\u064a\u0644 \u0627\u0644\u062a\u0642\u0631\u064a\u0631",
    "uk": "\u0417\u0430\u0432\u0430\u043d\u0442\u0430\u0436\u0438\u0442\u0438 \u0437\u0432\u0456\u0442"
  },
  "orderer_reports_select_type_text": {
    "sheet_name": "Web",
    "en": "Choose",
    "ru": "",
    "fi": "Valitse",
    "sv": "V\u00e4lj",
    "fa": "",
    "ar": "",
    "uk": "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044c"
  },
  "orderer_reports_no_date_type_error": {
    "sheet_name": "Web",
    "en": "You need to select a date type.",
    "ru": "",
    "fi": "Valitse mit\u00e4 p\u00e4iv\u00e4\u00e4 k\u00e4ytet\u00e4\u00e4n \"Suodata\" kent\u00e4ss\u00e4",
    "sv": "Du beh\u00f6ver v\u00e4lja typ av datum",
    "fa": "",
    "ar": "",
    "uk": "\u041f\u043e\u0442\u0440\u0456\u0431\u043d\u043e \u0432\u0438\u0431\u0440\u0430\u0442\u0438 \u0442\u0438\u043f \u0434\u0430\u0442\u0438"
  },
  "orderer_reports_no_file_type_error": {
    "sheet_name": "Web",
    "en": "You need to select a file type.",
    "ru": "",
    "fi": "Valitse tiedoston muoto",
    "sv": "Du beh\u00f6ver v\u00e4lja typ av fil",
    "fa": "",
    "ar": "",
    "uk": "\u041f\u043e\u0442\u0440\u0456\u0431\u043d\u043e \u0432\u0438\u0431\u0440\u0430\u0442\u0438 \u0442\u0438\u043f \u0444\u0430\u0439\u043b\u0443"
  },
  "orderer_reports_no_order_state_error": {
    "sheet_name": "Web",
    "en": "You need to select one or more order states.",
    "ru": "",
    "fi": "Valitse tilauksen yksi tai usempi tilauksen nykytila",
    "sv": "Du beh\u00f6ver v\u00e4lja en eller flera order status",
    "fa": "",
    "ar": "",
    "uk": "\u0412\u0430\u043c \u043d\u0435\u043e\u0431\u0445\u0456\u0434\u043d\u043e \u0432\u0438\u0431\u0440\u0430\u0442\u0438 \u043e\u0434\u0438\u043d \u0430\u0431\u043e \u0434\u0435\u043a\u0456\u043b\u044c\u043a\u0430 \u0441\u0442\u0430\u043d\u0456\u0432 \u0437\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f"
  },
  "worker_reports_title": {
    "sheet_name": "Web",
    "en": "Reports",
    "ru": "O\u0442\u0447\u0435\u0442\u044b",
    "fi": "Raportit",
    "sv": "Rapporter",
    "fa": "\u06af\u0632\u0627\u0631\u0634 \u0647\u0627",
    "ar": "\u062a\u0642\u0627\u0631\u064a\u0631",
    "uk": "\u0417\u0432\u0456\u0442\u0438"
  },
  "worker_reports_merchant_label": {
    "sheet_name": "Web",
    "en": "Service",
    "ru": "\u0421\u0435\u0440\u0432\u0438\u0441",
    "fi": "Palvelu",
    "sv": "Tj\u00e4nst",
    "fa": "\u0633\u0631\u0648\u06cc\u0633 (\u062e\u062f\u0645\u0627\u062a)",
    "ar": "\u0627\u0644\u062e\u062f\u0645\u0627\u062a",
    "uk": "\u041f\u043e\u0441\u043b\u0443\u0433\u0430"
  },
  "worker_reports_creation_date_label": {
    "sheet_name": "Web",
    "en": "Creation date",
    "ru": "\u0421\u043e\u0437\u0434\u0430\u043d \u0432",
    "fi": "Tilaus luotu",
    "sv": "Best\u00e4llning skapad",
    "fa": "\u062a\u0627\u0631\u06cc\u062e \u0627\u06cc\u062c\u0627\u062f",
    "ar": "\u062a\u0627\u0631\u064a\u062e \u0627\u0644\u0625\u0646\u0634\u0627\u0621",
    "uk": "\u0417\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f \u0441\u0442\u0432\u043e\u0440\u0435\u043d\u043e"
  },
  "worker_reports_completion_date_label": {
    "sheet_name": "Web",
    "en": "Completion date",
    "ru": "\u0414\u0435\u043d\u044c \u0438\u0437\u0433\u043e\u0442\u043e\u0432\u043b\u0435\u043d\u0438\u044f",
    "fi": "Valmistumisp\u00e4iv\u00e4",
    "sv": "Uppdragets slutdatum",
    "fa": "\u062a\u0627\u0631\u06cc\u062e \u062a\u06a9\u0645\u06cc\u0644",
    "ar": "\u062a\u0627\u0631\u064a\u062e \u0627\u0644\u0625\u0646\u062a\u0647\u0627\u0621",
    "uk": "\u0414\u0430\u0442\u0430 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043d\u043d\u044f \u0440\u043e\u0431\u043e\u0442\u0438"
  },
  "worker_reports_select_service_label": {
    "sheet_name": "Web",
    "en": "Select service",
    "ru": "\u0412\u044b\u0431\u0435\u0440\u0438\u0442\u0435 \u0441\u0435\u0440\u0432\u0438\u0441",
    "fi": "Valitse palvelu",
    "sv": "V\u00e4lj tj\u00e4nst",
    "fa": "\u0627\u0646\u062a\u062e\u0627\u062a \u0633\u0631\u0648\u06cc\u0633",
    "ar": "\u062d\u062f\u062f \u0627\u0644\u062e\u062f\u0645\u0629",
    "uk": "\u041e\u0431\u0435\u0440\u0456\u0442\u044c \u043f\u043e\u0441\u043b\u0443\u0433\u0443"
  },
  "worker_reports_period_label": {
    "sheet_name": "Web",
    "en": "Period",
    "ru": "\u041f\u0435\u0440\u0438\u043e\u0434",
    "fi": "Jakso",
    "sv": "Period",
    "fa": "\u062f\u0648\u0631\u0647 \u06cc \u0632\u0645\u0627\u0646\u06cc",
    "ar": "\u0641\u062a\u0631\u0629",
    "uk": "\u041f\u0435\u0440\u0456\u043e\u0434"
  },
  "worker_reports_period_from_label": {
    "sheet_name": "Web",
    "en": "From",
    "ru": "\u041e\u0442\u043a\u0443\u0434\u0430",
    "fi": "Mist\u00e4",
    "sv": "Fr\u00e5n",
    "fa": "\u0627\u0632 \u062c\u0627\u0646\u0628",
    "ar": "\u0645\u0646 \u0639\u0646\u062f",
    "uk": "\u0417\u0432\u0456\u0434\u043a\u0438"
  },
  "worker_reports_period_to_label": {
    "sheet_name": "Web",
    "en": "To",
    "ru": "\u041a\u0443\u0434\u0430",
    "fi": "Mihin",
    "sv": "Till",
    "fa": "\u0628\u0647",
    "ar": "\u0625\u0644\u0649",
    "uk": "\u041a\u0443\u0434\u0438"
  },
  "worker_reports_in_progress_text": {
    "sheet_name": "Web",
    "en": "Building report",
    "ru": "\u041e\u0442\u0447\u0451\u0442 \u0433\u0435\u043d\u0435\u0440\u0438\u0440\u0443\u0435\u0442\u0441\u044f",
    "fi": "Muodostetaan raporttia",
    "sv": "Sammanst\u00e4ller rapport",
    "fa": "\u062a\u0647\u06cc\u0647 \u06af\u0632\u0627\u0631\u0634",
    "ar": "\u062a\u0642\u0631\u064a\u0631 \u0627\u0644\u0628\u0646\u0627\u0621",
    "uk": "\u0421\u0444\u043e\u0440\u043c\u0443\u0432\u0430\u0442\u0438 \u0437\u0432\u0456\u0442"
  },
  "worker_reports_download_label": {
    "sheet_name": "Web",
    "en": "Download report",
    "ru": "\u041f\u043e\u0440\u0442 \u0434\u043b\u044f \u0437\u0430\u0440\u044f\u0434\u043a\u0438",
    "fi": "Lataa raportti",
    "sv": "Nedladdningsrapport",
    "fa": "\u06af\u0632\u0627\u0631\u0634 \u0628\u0627\u0631\u06af\u06cc\u0631\u06cc",
    "ar": "\u062a\u0646\u0632\u064a\u0644 \u0627\u0644\u062a\u0642\u0631\u064a\u0631",
    "uk": "\u0417\u0430\u0432\u0430\u043d\u0442\u0430\u0436\u0438\u0442\u0438 \u0437\u0432\u0456\u0442"
  },
  "worker_reports_worker_type_selector_label": {
    "sheet_name": "Web",
    "en": "Select worker type",
    "ru": "\u0412\u044b\u0431\u0435\u0440\u0438\u0442\u0435 \u0442\u0438\u043f \u0434\u043e\u0433\u043e\u0432\u043e\u0440\u0430",
    "fi": "Valitse sopimusmuoto",
    "sv": "V\u00e4lj anst\u00e4llningsform",
    "fa": "\u0646\u0648\u0639 \u06a9\u0627\u0631\u06af\u0631 \u0631\u0627 \u0627\u0646\u062a\u062e\u0627\u0628 \u06a9\u0646\u06cc\u062f",
    "ar": "\u062d\u062f\u062f \u0646\u0648\u0639 \u0627\u0644\u0639\u0627\u0645\u0644",
    "uk": "\u041e\u0431\u0435\u0440\u0456\u0442\u044c \u0442\u0438\u043f \u043a\u043e\u043d\u0442\u0440\u0430\u043a\u0442\u0443"
  },
  "worker_reports_report_input_title": {
    "sheet_name": "Web",
    "en": "Report",
    "ru": "",
    "fi": "Raportti",
    "sv": "Rapport",
    "fa": "",
    "ar": "",
    "uk": "\u0417\u0432\u0456\u0442"
  },
  "worker_reports_payment_report": {
    "sheet_name": "Web",
    "en": "Payment report",
    "ru": "",
    "fi": "Maksuraportti",
    "sv": "Betalningsrapport",
    "fa": "",
    "ar": "",
    "uk": "\u0417\u0432\u0456\u0442 \u043f\u043e \u043e\u043f\u043b\u0430\u0442\u0456"
  },
  "notification_message_empty": {
    "sheet_name": "Web",
    "en": "There is no relevant notification.",
    "ru": "\u041d\u0435\u0442 \u0442\u0435\u043a\u0443\u0449\u0438\u0445 \u043e\u0431\u044a\u044f\u0432\u043b\u0435\u043d\u0438\u0439",
    "fi": "Ei ajankohtaisia ilmoituksia.",
    "sv": "Inga aktuella meddelanden fr\u00e5n",
    "fa": "\u0647\u06cc\u0686 \u0627\u0637\u0644\u0627\u0639\u06cc\u0647 \u0627\u06cc \u0645\u0648\u062c\u0648\u062f \u0646\u06cc\u0633\u062a",
    "ar": "\u0644\u0627 \u064a\u0648\u062c\u062f \u0625\u062e\u0637\u0627\u0631 \u0630\u064a \u0635\u0644\u0629",
    "uk": "\u041d\u0435\u043c\u0430\u0454 \u043f\u043e\u0442\u043e\u0447\u043d\u0438\u0445 \u043e\u0433\u043e\u043b\u043e\u0448\u0435\u043d\u044c"
  },
  "notification_different_service_label": {
    "sheet_name": "Web",
    "en": "This notification belongs to a different service",
    "ru": "\u042d\u0442\u043e \u043e\u0431\u044a\u044f\u0432\u043b\u0435\u043d\u0438\u0435 \u043e\u0442\u043f\u0440\u0430\u0432\u043b\u044f\u0435\u043c \u043d\u0430 \u0440\u0430\u0437\u043d\u044b\u0435 \u0441\u0430\u0439\u0442\u044b",
    "fi": "T\u00e4m\u00e4 ilmoitus tulee eri palvelusta",
    "sv": "Meddelande fr\u00e5n en annan tj\u00e4nst",
    "fa": "\u0627\u06cc\u0646 \u0627\u0639\u0644\u0627\u0646 \u0645\u062a\u0639\u0644\u0642 \u0628\u0647 \u06cc\u06a9 \u0633\u0631\u0648\u06cc\u0633 \u0645\u062a\u0641\u0627\u0648\u062a \u0627\u0633\u062a",
    "ar": "\u064a\u0646\u062a\u0645\u064a \u0647\u0630\u0627 \u0627\u0644\u0625\u062e\u0637\u0627\u0631 \u0625\u0644\u0649 \u062e\u062f\u0645\u0629 \u0645\u062e\u062a\u0644\u0641\u0629",
    "uk": "\u0426\u0435 \u043f\u043e\u0432\u0456\u0434\u043e\u043c\u043b\u0435\u043d\u043d\u044f \u043d\u0430\u043b\u0435\u0436\u0438\u0442\u044c \u0434\u043e \u0456\u043d\u0448\u043e\u0433\u043e \u0441\u0435\u0440\u0432\u0456\u0441\u0443"
  },
  "notification_different_service_text": {
    "sheet_name": "Web",
    "en": "btn_close",
    "ru": "\u042d\u0442\u043e \u0443\u0432\u0435\u0434\u043e\u043c\u043b\u0435\u043d\u0438\u0435 \u043e\u0442\u043d\u043e\u0441\u0438\u0442\u0441\u044f \u043a \u0434\u0440\u0443\u0433\u043e\u043c\u0443 \u0441\u0435\u0440\u0432\u0435\u0440\u0443, \u043f\u043e\u043c\u0435\u043d\u044f\u0439\u0442\u0435 \u0441\u0435\u0440\u0432\u0435\u0440 %s",
    "fi": "T\u00e4m\u00e4 ilmoitus kuuluu toiselle palvelulle, vaihda palvelusi %s",
    "sv": "Det h\u00e4r meddelandet kommer fr\u00e5n en annan tj\u00e4nst, om du vill kontrollera det, v\u00e4nligen byt tj\u00e4nst till %s",
    "fa": "\u0627\u06cc\u0646 \u0627\u0639\u0644\u0627\u0646 \u0645\u062a\u0639\u0644\u0642 \u0628\u0647 \u06cc\u06a9 \u0633\u0631\u0648\u06cc\u0633 \u0645\u062a\u0641\u0627\u0648\u062a \u0627\u0633\u062a \u060c \u0633\u0631\u0648\u06cc\u0633 \u062e\u0648\u062f \u0631\u0627 \u0628\u0647 s% \u062a\u063a\u06cc\u06cc\u0631 \u062f\u0647\u06cc\u062f!",
    "ar": "\u064a\u0646\u062a\u0645\u064a \u0647\u0630\u0627 \u0627\u0644\u0625\u0639\u0644\u0627\u0645 \u0625\u0644\u0649 \u062e\u062f\u0645\u0629 \u0645\u062e\u062a\u0644\u0641\u0629 \u060c \u0642\u0645 \u0628\u0627\u0644\u062a\u0628\u062f\u064a\u0644 \u0625\u0644\u0649 \u0627\u0644\u062e\u062f\u0645\u0629%",
    "uk": "\u0426\u0435 \u043f\u043e\u0432\u0456\u0434\u043e\u043c\u043b\u0435\u043d\u043d\u044f \u043d\u0430\u043b\u0435\u0436\u0438\u0442\u044c \u0456\u043d\u0448\u043e\u043c\u0443 \u0441\u0435\u0440\u0432\u0456\u0441\u0443, \u0437\u043c\u0456\u043d\u0456\u0442\u044c \u0441\u0432\u0456\u0439 \u0441\u0435\u0440\u0432\u0456\u0441 %s"
  },
  "notifications_change_service": {
    "sheet_name": "Web",
    "en": "This will switch your current service to %s. Are you sure you want to proceed?",
    "ru": "\u0412\u044b \u0445\u043e\u0442\u0438\u0442\u0435 \u043f\u0435\u0440\u0435\u043a\u043b\u044e\u0447\u0438\u0442\u044c \u0442\u0435\u043a\u0443\u0449\u0438\u0439 \u0441\u0435\u0440\u0432\u0438\u0441 \u043d\u0430 %s ? \u0412\u044b \u0443\u0432\u0435\u0440\u0435\u043d\u043d\u044b, \u0447\u0442\u043e \u0445\u043e\u0442\u0438\u0442\u0435 \u043f\u0440\u043e\u0434\u043e\u043b\u0436\u0438\u0442\u044c",
    "fi": "T\u00e4m\u00e4 vaihtaa nykyisen palvelusi palveluun %s. Oletko varma, ett\u00e4 haluat jatkaa?",
    "sv": "Detta kommer att byta din nuvarande tj\u00e4nst till %s. \u00c4r du s\u00e4ker p\u00e5 att du vill forts\u00e4tta?",
    "fa": "\u0627\u06cc\u0646 \u06af\u0632\u06cc\u0646\u0647 \u0633\u0631\u0648\u06cc\u0633 \u0641\u0639\u0644\u06cc \u0634\u0645\u0627 \u0631\u0627 \u0628\u0647 %s \u062a\u063a\u06cc\u06cc\u0631 \u0645\u06cc \u062f\u0647\u062f. \u0622\u06cc\u0627 \u0645\u0637\u0645\u0626\u0646 \u0647\u0633\u062a\u06cc\u062f \u06a9\u0647 \u0645\u06cc\u062e\u0648\u0627\u0647\u06cc\u062f \u0627\u062f\u0627\u0645\u0647 \u062f\u0647\u06cc\u062f\u061f",
    "ar": "\u0633\u064a\u0624\u062f\u064a \u0647\u0630\u0627 \u0625\u0644\u0649 \u062a\u0628\u062f\u064a\u0644 \u0627\u0644\u062e\u062f\u0645\u0629 \u0627\u0644\u062d\u0627\u0644\u064a\u0629 \u0625\u0644\u0649%s. \u0647\u0644 \u0627\u0646\u062a \u0645\u062a\u0623\u0643\u062f \u0627\u0646\u0643 \u062a\u0631\u064a\u062f \u0627\u0644\u0645\u062a\u0627\u0628\u0639\u0629\u061f",
    "uk": "\u0426\u0435 \u0437\u043c\u0456\u043d\u0438\u0442\u044c \u0432\u0430\u0448 \u043f\u043e\u0442\u043e\u0447\u043d\u0438\u0439 \u0441\u0435\u0440\u0432\u0456\u0441 \u043d\u0430 %s. \u0412\u0438 \u0432\u043f\u0435\u0432\u043d\u0435\u043d\u0456, \u0449\u043e \u0431\u0430\u0436\u0430\u0454\u0442\u0435 \u043f\u0440\u043e\u0434\u043e\u0432\u0436\u0438\u0442\u0438?"
  },
  "notifications_invitation_to_service": {
    "sheet_name": "Web",
    "en": "You have been invited to join a new service",
    "ru": "",
    "fi": "Sinut on kutsuttu k\u00e4ytt\u00e4m\u00e4\u00e4n uutta palvelua",
    "sv": "Du har blivit inbjuden till en ny tj\u00e4nst",
    "fa": "",
    "ar": "",
    "uk": "\u0412\u0430\u0441 \u0437\u0430\u043f\u0440\u043e\u0448\u0435\u043d\u043e \u043f\u0440\u0438\u0454\u0434\u043d\u0430\u0442\u0438\u0441\u044f \u0434\u043e \u043d\u043e\u0432\u043e\u0433\u043e \u0441\u0435\u0440\u0432\u0456\u0441\u0443"
  },
  "notifications_task_not_available": {
    "sheet_name": "Web",
    "en": "Opportunity no longer available",
    "ru": "\u0417\u0430\u0434\u0430\u0447\u0430 \u0431\u043e\u043b\u044c\u0448\u0435 \u043d\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u043d\u0430",
    "fi": "Mahdollisuus ei ole en\u00e4\u00e4 avoinna",
    "sv": "Uppdrag tillsatt eller ej tillg\u00e4ngligt",
    "fa": "\u0648\u0638\u06cc\u0641\u0647 \u062f\u06cc\u06af\u0631 \u062f\u0631 \u062f\u0633\u062a\u0631\u0633 \u0646\u06cc\u0633\u062a",
    "ar": "\u0644\u0645 \u062a\u0639\u062f \u0627\u0644\u0645\u0647\u0645\u0629 \u0645\u062a\u0627\u062d\u0629",
    "uk": "\u0437\u0430\u0432\u0434\u0430\u043d\u043d\u044f \u0431\u0456\u043b\u044c\u0448\u0435 \u043d\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u043d\u0435"
  },
  "notifications_release_notes_text": {
    "sheet_name": "Web",
    "en": "Important news",
    "ru": "",
    "fi": "Ajankohtaista",
    "sv": "Viktiga nyheter",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "notifications_title": {
    "sheet_name": "Web",
    "en": "Notifications",
    "ru": "\u0423\u0432\u0435\u0434\u043e\u043c\u043b\u0435\u043d\u0438\u044f",
    "fi": "Ilmoitukset",
    "sv": "Meddelanden",
    "fa": "\u0627\u0637\u0644\u0627\u0639\u06cc\u0647",
    "ar": "\u0625\u0634\u0639\u0627\u0631\u0627\u062a",
    "uk": "\u043f\u043e\u0432\u0456\u0434\u043e\u043c\u043b\u0435\u043d\u043d\u044f"
  },
  "first_time_title": {
    "sheet_name": "Web",
    "en": "Welcome to %s!",
    "ru": "",
    "fi": "Tervetuloa %s -alustalle!",
    "sv": "V\u00e4lkommen till %s!",
    "fa": "",
    "ar": "",
    "uk": "\u041b\u0430\u0441\u043a\u0430\u0432\u043e \u043f\u0440\u043e\u0441\u0438\u043c\u043e \u0434\u043e %s!"
  },
  "first_time_content_1": {
    "sheet_name": "Web",
    "en": "Only a few screens left before you can start using our system.",
    "ru": "\u041e\u0441\u0442\u0430\u043b\u043e\u0441\u044c \u0441\u0434\u0435\u043b\u0430\u0442\u044c \u0435\u0449\u0435 \u043d\u0435\u0441\u043a\u043e\u043b\u044c\u043a\u043e \u0448\u0430\u0433\u043e\u0432, \u043f\u0440\u0435\u0436\u0434\u0435 \u0447\u0435\u043c \u0432\u044b \u0441\u043c\u043e\u0436\u0435\u0442\u0435 \u043d\u0430\u0447\u0430\u0442\u044c \u043f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u044c\u0441\u044f \u043d\u0430\u0448\u0435\u0439 \u0441\u0438\u0441\u0442\u0435\u043c\u043e\u0439.",
    "fi": "En\u00e4\u00e4 muutama askel j\u00e4ljell\u00e4 ennen kuin p\u00e4\u00e4set k\u00e4ytt\u00e4m\u00e4\u00e4n palvelua.",
    "sv": "Det finns n\u00e5gra steg kvar innan du kan anv\u00e4nda tj\u00e4nsten.",
    "fa": "\u0642\u0628\u0644 \u0627\u0632 \u0634\u0631\u0648\u0639 \u0627\u0633\u062a\u0641\u0627\u062f\u0647 \u0627\u0632 \u0633\u06cc\u0633\u062a\u0645 \u060c \u0641\u0642\u0637 \u0686\u0646\u062f \u0635\u0641\u062d\u0647 \u0628\u0627\u0642\u06cc \u0645\u0627\u0646\u062f\u0647 \u0627\u0633\u062a.",
    "ar": "\u0644\u0645 \u064a\u0628\u0642\u0649 \u0633\u0648\u0649 \u0639\u062f\u062f\u0627 \u0642\u0644\u064a\u0644\u0627 \u0645\u0646 \u0627\u0644\u062e\u0637\u0648\u0627\u062a \u0642\u0628\u0644 \u0627\u0646 \u062a\u062a\u0645\u0643\u0646 \u0645\u0646 \u0627\u0644\u0628\u062f\u0621 \u0641\u064a \u0625\u0633\u062a\u062e\u062f\u0627\u0645 \u0646\u0638\u0627\u0645\u0646\u0627",
    "uk": "\u0417\u0430\u043b\u0438\u0448\u0438\u043b\u043e\u0441\u044f \u0434\u0435\u043a\u0456\u043b\u044c\u043a\u0430 \u043a\u0440\u043e\u043a\u0456\u0432, \u043f\u0435\u0440\u0448 \u043d\u0456\u0436 \u0432\u0438 \u0437\u043c\u043e\u0436\u0435\u0442\u0435 \u043f\u043e\u0447\u0430\u0442\u0438 \u043a\u043e\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0442\u0438\u0441\u044f \u043d\u0430\u0448\u043e\u044e \u0441\u0438\u0441\u0442\u0435\u043c\u043e\u044e."
  },
  "first_time_content_2": {
    "sheet_name": "Web",
    "en": "Would you like to register as a Worker %s to find opportunities or an Orderer %s to post opportunities where you need help?",
    "ru": "\u0412\u044b \u0445\u043e\u0442\u0438\u0442\u0435 \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043e\u0432\u0430\u0442\u044c\u0441\u044f \u0432 \u043a\u0430\u0447\u0435\u0441\u0442\u0432\u0435 \u0440\u0430\u0431\u043e\u0442\u043d\u0438\u043a\u0430 (\u043d\u0430\u0439\u0442\u0438 \u0440\u0430\u0431\u043e\u0442\u0443) \u0438\u043b\u0438 \u0417\u0430\u043a\u0430\u0437\u0447\u0438\u043a\u0430 (\u0440\u0435\u043a\u043b\u0430\u043c\u0438\u0440\u043e\u0432\u0430\u0442\u044c \u0437\u0430\u0434\u0430\u0447\u0438, \u043a\u043e\u0442\u043e\u0440\u044b\u0435 \u0432\u044b \u0445\u043e\u0442\u0438\u0442\u0435 \u0447\u0442\u043e\u0431\u044b \u0432\u0430\u043c \u0432\u044b\u043f\u043e\u043b\u043d\u0438\u043b\u0438)?",
    "fi": "Haluatko rekister\u00f6ity\u00e4 Tekij\u00e4ksi %s etsi\u00e4ksesi mahdollisuuksia vai Tilaajaksi %s ilmoittaaksesi avun tarpeesta?",
    "sv": "Vill du registrera dig som arbetare %s f\u00f6r att hitta uppdrag eller som best\u00e4llare %s f\u00f6r att annonsera ut ett uppdrag ni beh\u00f6ver hj\u00e4lp med?",
    "fa": "\u0622\u06cc\u0627 \u0645\u06cc \u062e\u0648\u0627\u0647\u06cc\u062f \u0628\u0647 \u0639\u0646\u0648\u0627\u0646 \u06cc\u06a9 \u06a9\u0627\u0631\u06af\u0631 %s \u06cc\u0627 \u0633\u0641\u0627\u0631\u0634 \u062f\u0647\u0646\u062f\u0647 %s \u062b\u0628\u062a \u0646\u0627\u0645 \u06a9\u0646\u06cc\u062f\u061f",
    "ar": "\u0647\u0644 \u062a\u0631\u063a\u0628 \u0641\u064a \u0627\u0644\u062a\u0633\u062c\u064a\u0644 \u0643\u0639\u0627\u0645\u0644 %s \u0627\u0648 \u0643\u0637\u0644\u0628 %s \u0627\u0644\u0625\u0639\u0644\u0627\u0646 \u0639\u0646 \u0627\u0644\u0645\u0647\u0627\u0645 \u0627\u0644\u062a\u064a \u062a\u0631\u064a\u062f \u0627\u0644\u0642\u064a\u0627\u0645 \u0628\u0647\u0627 \u061f",
    "uk": "\u0412\u0438 \u0431\u0430\u0436\u0430\u0454\u0442\u0435  \u0437\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u0443\u0432\u0430\u0442\u0438\u0441\u044f \u044f\u043a \u043f\u0440\u0430\u0446\u0456\u0432\u043d\u0438\u043a %s, \u0449\u043e\u0431 \u0437\u043d\u0430\u0445\u043e\u0434\u0438\u0442\u0438 \u0440\u043e\u0431\u043e\u0442\u0443, \u0447\u0438 \u044f\u043a \u0437\u0430\u043c\u043e\u0432\u043d\u0438\u043a %s, \u0449\u043e\u0431 \u043f\u0443\u0431\u043b\u0456\u043a\u0443\u0432\u0430\u0442\u0438  \u0437\u0430\u0432\u0434\u0430\u043d\u043d\u044f, \u044f\u043a\u0456 \u0432\u0438 \u0445\u043e\u0447\u0435\u0442\u0435, \u0449\u043e\u0431 \u0432\u0430\u043c \u0432\u0438\u043a\u043e\u043d\u0430\u043b\u0438)?"
  },
  "first_time_orderer_button_label": {
    "sheet_name": "Web",
    "en": "Orderer",
    "ru": "\u0437\u0430\u043a\u0430\u0437\u0447\u0438\u043a",
    "fi": "Tilaaja",
    "sv": "Best\u00e4llare",
    "fa": "\u0633\u0641\u0627\u0631\u0634 \u062f\u0647\u0646\u062f\u0647",
    "ar": "\u0635\u0627\u062d\u0628 \u0627\u0644\u0639\u0645\u0644",
    "uk": "\u0417\u0430\u043c\u043e\u0432\u043d\u0438\u043a"
  },
  "first_time_worker_button_label": {
    "sheet_name": "Web",
    "en": "Worker",
    "ru": "\u0440\u0430\u0431\u043e\u0442\u043d\u0438\u043a",
    "fi": "Tekij\u00e4",
    "sv": "Utf\u00f6rare",
    "fa": "\u06a9\u0627\u0631\u06af\u0631",
    "ar": "\u0627\u0644\u0639\u0627\u0645\u0644",
    "uk": "\u041f\u0440\u0430\u0446\u0456\u0432\u043d\u0438\u043a"
  },
  "service_switcher_registered": {
    "sheet_name": "Web",
    "en": "You are registered with the following services:",
    "ru": "\u0412\u044b \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043e\u0432\u0430\u043b\u0438\u0441\u044c \u043d\u0430 \u0441\u043b\u0435\u0434\u0443\u044e\u0449\u0438\u0435 \u0441\u0435\u0440\u0432\u0435\u0440\u0430",
    "fi": "Olet rekister\u00f6itynyt seuraaviin palveluihin",
    "sv": "Du \u00e4r registrerad med f\u00f6ljande tj\u00e4nster",
    "fa": "\u0634\u0645\u0627 \u0628\u0627 \u0633\u0631\u0648\u06cc\u0633 \u0632\u06cc\u0631 \u062b\u0628\u062a \u0646\u0627\u0645 \u06a9\u0631\u062f\u0647 \u0627\u06cc\u062f:",
    "ar": "\u0623\u0646\u062a \u0645\u0633\u062c\u0644 \u0641\u064a \u0627\u0644\u062e\u062f\u0645\u0627\u062a \u0627\u0644\u062a\u0627\u0644\u064a\u0629",
    "uk": "\u0412\u0438 \u0437\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u0443\u0432\u0430\u043b\u0438\u0441\u044f \u0437\u0430 \u0434\u043e\u043f\u043e\u043c\u043e\u0433\u043e\u044e \u0456\u043d\u0448\u043e\u0433\u043e \u0441\u0435\u0440\u0432\u0456\u0441\u0443"
  },
  "service_switcher_another_btn": {
    "sheet_name": "Web",
    "en": "Register with another service",
    "ru": "\u0417\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u0443\u0439\u0442\u0435\u0441\u044c \u043d\u0430 \u0434\u0440\u0443\u0433\u043e\u043c \u0441\u0435\u0440\u0432\u0435\u0440\u0435",
    "fi": "Rekister\u00f6idy uuteen palveluun",
    "sv": "Registrera dig med en ny tj\u00e4nst",
    "fa": "\u0628\u0627 \u06cc\u06a9 \u0633\u0631\u0648\u06cc\u0633 \u062f\u06cc\u06af\u0631 \u062b\u0628\u062a \u0646\u0627\u0645 \u06a9\u0646\u06cc\u062f",
    "ar": "\u0633\u062c\u0644 \u0645\u0639 \u062e\u062f\u0645\u0629 \u0623\u062e\u0631\u0649",
    "uk": "\u0417\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u0443\u0432\u0430\u0442\u0438\u0441\u044f \u0432 \u0456\u043d\u0448\u043e\u043c\u0443 \u0441\u0435\u0440\u0432\u0456\u0441\u0456"
  },
  "service_switcher_another_desc": {
    "sheet_name": "Web",
    "en": "If you want to register to another service you can do so here. Please be aware that by registering to a new service you are not unregistering from any other services where you are already registered with.",
    "ru": "\u0415\u0441\u043b\u0438 \u0432\u044b \u0445\u043e\u0442\u0438\u0442\u0435 \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043e\u0432\u0430\u0442\u044c\u0441\u044f \u043d\u0430 \u0440\u0430\u0437\u043d\u044b\u0445 \u0441\u0430\u0439\u0442\u0430\u0445, \u0432\u044b \u043c\u043e\u0436\u0435\u0442\u0435 \u044d\u0442\u043e \u0441\u0434\u0435\u043b\u0430\u0442\u044c \u0437\u0434\u0435\u0441\u044c. \u041f\u043e\u0436\u0430\u043b\u0443\u0439\u0441\u0442\u0430, \u043e\u0431\u0440\u0430\u0442\u0438\u0442\u0435 \u0432\u043d\u0438\u043c\u0430\u043d\u0438\u0435, \u0447\u0442\u043e \u043f\u0440\u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u043d\u0430 \u043d\u043e\u0432\u043e\u043c \u0441\u0430\u0439\u0442\u0435, \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u043d\u0430 \u0434\u0440\u0443\u0433\u0438\u0445 \u0441\u0430\u0439 \u0442\u0430\u0445 \u043e\u0441\u0442\u0430\u0435\u0442\u0441\u044f \u043d\u0435\u0438\u0437\u043c\u0435\u043d\u043d\u043e\u0439",
    "fi": "Jos haluat rekister\u00f6ity\u00e4 eri palveluun, voit tehd\u00e4 niin t\u00e4\u00e4ll\u00e4. Ole hyv\u00e4 ja huomio, ett\u00e4 rekister\u00f6itym\u00e4ll\u00e4 uuteen palveluun et poista rekister\u00f6itymist\u00e4 muista palveluista, joihin olet jo rekister\u00f6itynyt.",
    "sv": "Om du vill registrera dig till en annan tj\u00e4nst kan du g\u00f6ra det h\u00e4r. Observera, genom att best\u00e4lla en ny tj\u00e4nst s\u00e5 \u00e4r du inte avregistrerad fr\u00e5n andra tj\u00e4nster d\u00e4r du redan \u00e4r registrerad.",
    "fa": "\u0627\u06af\u0631 \u0645\u06cc \u062e\u0648\u0627\u0647\u06cc\u062f \u062f\u0631 \u06cc\u06a9 \u0633\u0631\u0648\u06cc\u0633 \u062f\u06cc\u06af\u0631 \u062b\u0628\u062a \u0646\u0627\u0645 \u06a9\u0646\u06cc\u062f \u060c \u0645\u06cc \u062a\u0648\u0627\u0646\u06cc\u062f \u062f\u0631 \u0627\u06cc\u0646\u062c\u0627 \u0627\u0646\u062c\u0627\u0645 \u062f\u0647\u06cc\u062f. \u0644\u0637\u0641\u0627\u064b \u062a\u0648\u062c\u0647 \u062f\u0627\u0634\u062a\u0647 \u0628\u0627\u0634\u06cc\u062f \u06a9\u0647 \u0628\u0627 \u062b\u0628\u062a \u0646\u0627\u0645 \u062f\u0631 \u06cc\u06a9 \u0633\u0631\u0648\u06cc\u0633 \u062c\u062f\u06cc\u062f \u060c \u0634\u0645\u0627 \u0627\u0632 \u0647\u06cc\u0686 \u0633\u0631\u0648\u06cc\u0633 \u062f\u06cc\u06af\u0631\u06cc \u06a9\u0647 \u0642\u0628\u0644\u0627\u064b \u062f\u0631 \u0622\u0646 \u062b\u0628\u062a \u0646\u0627\u0645 \u06a9\u0631\u062f\u0647 \u0627\u06cc\u062f \u060c \u062d\u0630\u0641 \u0646\u062e\u0648\u0627\u0647\u06cc\u062f \u0634\u062f!",
    "ar": "\u0625\u0630\u0627 \u0643\u0646\u062a \u062a\u0631\u064a\u062f \u0627\u0644\u062a\u0633\u062c\u064a\u0644 \u0641\u064a \u062e\u062f\u0645\u0629 \u0623\u062e\u0631\u0649 \u064a\u0645\u0643\u0646\u0643 \u0627\u0644\u0642\u064a\u0627\u0645 \u0628\u0630\u0644\u0643 \u0647\u0646\u0627. \u064a\u0631\u062c\u0649 \u0627\u0644\u0639\u0644\u0645 \u0623\u0646\u0647 \u0628\u0627\u0644\u062a\u0633\u062c\u064a\u0644 \u0641\u064a \u062e\u062f\u0645\u0629 \u062c\u062f\u064a\u062f\u0629 \u060c \u0641\u0625\u0646\u0643 \u0644\u0627 \u062a\u0644\u063a\u064a \u0627\u0644\u062a\u0633\u062c\u064a\u0644 \u0645\u0646 \u0623\u064a \u062e\u062f\u0645\u0627\u062a \u0623\u062e\u0631\u0649 \u0633\u0628\u0642 \u0623\u0646 \u0633\u062c\u0644\u062a \u0641\u064a\u0647\u0627",
    "uk": "\u042f\u043a\u0449\u043e \u0412\u0438 \u0431\u0430\u0436\u0430\u0454\u0442\u0435 \u0437\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u0443\u0432\u0430\u0442\u0438\u0441\u044f \u0432 \u0456\u043d\u0448\u043e\u043c\u0443 \u0441\u0435\u0440\u0432\u0456\u0441\u0456, \u0412\u0438 \u043c\u043e\u0436\u0435\u0442\u0435 \u0437\u0440\u043e\u0431\u0438\u0442\u0438 \u0446\u0435 \u0442\u0443\u0442. \u0417\u0432\u0435\u0440\u0442\u0430\u0454\u043c\u043e \u0412\u0430\u0448\u0443 \u0443\u0432\u0430\u0433\u0443, \u0449\u043e \u043f\u0440\u0438 \u0440\u0435\u0454\u0441\u0442\u0440\u0430\u0446\u0456\u0457 \u043d\u0430 \u043d\u043e\u0432\u043e\u043c\u0443 \u0441\u0435\u0440\u0432\u0456\u0441\u0456 \u0412\u0438 \u043d\u0435 \u0432\u0456\u0434\u043c\u0456\u043d\u044f\u0454\u0442\u0435 \u0440\u0435\u0454\u0441\u0442\u0440\u0430\u0446\u0456\u044e \u043d\u0430 \u0456\u043d\u0448\u0438\u0445 \u0441\u0435\u0440\u0432\u0456\u0441\u0430\u0445, \u0434\u0435 \u0432\u0436\u0435 \u0437\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u043e\u0432\u0430\u043d\u0456."
  },
  "service_switcher_tou_by": {
    "sheet_name": "Web",
    "en": "By registering, you agree to the",
    "ru": "\u0417\u0430\u0440\u0435\u0433\u0435\u0441\u0442\u0440\u0438\u0440\u043e\u0432\u0430\u0432\u0448\u0438\u0441\u044c, \u0432\u044b \u043f\u0440\u0438\u043d\u0438\u043c\u0430\u0435\u0442\u0435",
    "fi": "Rekister\u00f6itym\u00e4ll\u00e4, sin\u00e4 hyv\u00e4ksyt",
    "sv": "By registering, you agree to the",
    "fa": "\u0628\u0627 \u062b\u0628\u062a \u0646\u0627\u0645 \u060c \u0634\u0645\u0627 \u0645\u0648\u0627\u0641\u0642\u062a \u0645\u06cc \u06a9\u0646\u06cc\u062f",
    "ar": "\u0628\u0627\u0644\u062a\u0633\u062c\u064a\u0644 \u060c \u0641\u0625\u0646\u0643 \u062a\u0648\u0627\u0641\u0642 \u0639\u0644\u0649",
    "uk": "\u0420\u0435\u0454\u0441\u0442\u0440\u0443\u044e\u0447\u0438\u0441\u044c, \u0432\u0438 \u043f\u043e\u0433\u043e\u0434\u0436\u0443\u0454\u0442\u0435\u0441\u044f \u0437"
  },
  "service_switcher_tou_tou": {
    "sheet_name": "Web",
    "en": "Terms and Conditions",
    "ru": "\u0423\u0441\u043b\u043e\u0432\u0438\u044f \u0438\u0441\u043f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u043d\u0438\u044f",
    "fi": "K\u00e4ytt\u00f6ehdot",
    "sv": "Terms and Conditions",
    "fa": "\u0634\u0631\u0627\u06cc\u0637 \u0648 \u0636\u0648\u0627\u0628\u0637",
    "ar": "\u0627\u0644\u0623\u062d\u0643\u0627\u0645 \u0648\u0627\u0644\u0634\u0631\u0648\u0637",
    "uk": "\u0423\u043c\u043e\u0432\u0438 \u0432\u0438\u043a\u043e\u0440\u0438\u0441\u0442\u0430\u043d\u043d\u044f"
  },
  "service_switcher_tou_os": {
    "sheet_name": "Web",
    "en": "of the service.",
    "ru": "\u0421\u0435\u0440\u0432\u0438\u0441",
    "fi": "palvelulle",
    "sv": "of the service.",
    "fa": "\u0627\u0632 \u062e\u062f\u0645\u0627\u062a",
    "ar": "\u0627\u0644\u062e\u062f\u0645\u0629",
    "uk": "\u0421\u0435\u0440\u0432\u0456\u0441\u0438."
  },
  "switcher_dialog_content_first": {
    "sheet_name": "Web",
    "en": "You will see the information pertaining only to the %s service until you switch back.",
    "ru": "\u0412\u044b \u0432\u0438\u0434\u0438\u0442\u0435 \u0442\u043e\u043b\u044c\u043a\u043e %s \u0438\u043d\u0444\u043e\u0440\u043c\u0430\u0446\u0438\u0438, \u043f\u043e\u043a\u0430 \u043d\u0435 \u043f\u0435\u0440\u0435\u0439\u0434\u0451\u0442\u0435 \u043e\u0431\u0440\u0430\u0442\u043d\u043e",
    "fi": "N\u00e4et vain %s palveluun liittyv\u00e4t tiedot, kunnes vaihdat takaisin.",
    "sv": "Du kommer att se informationen som endast g\u00e4ller %s tj\u00e4nsten tills du byter tillbaka.",
    "fa": "\u0628\u0631\u0627\u06cc \u062f\u0633\u062a\u0631\u0633\u06cc \u0628\u0647 \u0627\u0637\u0644\u0627\u0639\u0627\u062a \u0645\u0631\u0628\u0648\u0637 \u0628\u0647 \u0633\u0631\u0648\u06cc\u0633 s% \u060c \u0628\u0647 \u0639\u0642\u0628 \u0628\u0631\u06af\u0631\u062f\u06cc\u062f",
    "ar": "\u0633\u062a\u0631\u0649 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062a \u0627\u0644\u0645\u062a\u0639\u0644\u0642\u0629 \u0641\u0642\u0637 \u0628\u062e\u062f\u0645\u0629%s \u062d\u062a\u0649 \u062a\u0642\u0648\u0645 \u0628\u0627\u0644\u062a\u0628\u062f\u064a\u0644 \u0645\u0631\u0629 \u0623\u062e\u0631\u0649.",
    "uk": "\u0412\u0438 \u043f\u043e\u0431\u0430\u0447\u0438\u0442\u0435 \u0456\u043d\u0444\u043e\u0440\u043c\u0430\u0446\u0456\u044e, \u044f\u043a\u0430 \u0441\u0442\u043e\u0441\u0443\u0454\u0442\u044c\u0441\u044f \u043b\u0438\u0448\u0435  %s \u0441\u0435\u0440\u0432\u0456\u0441\u0443, \u043f\u043e\u043a\u0438 \u043d\u0435 \u043f\u043e\u0432\u0435\u0440\u043d\u0435\u0442\u0435\u0441\u044f \u043d\u0430\u0437\u0430\u0434."
  },
  "switch_merchant_registered": {
    "sheet_name": "Web",
    "en": "You have already registered for this merchant.",
    "ru": "",
    "fi": "Olet jo kirjautunut t\u00e4h\u00e4n palveluun",
    "sv": "Du har redan registrerat dig f\u00f6r denna uppdragsgivare",
    "fa": "",
    "ar": "",
    "uk": "\u0412\u0438 \u0432\u0436\u0435 \u0437\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u043e\u0432\u0430\u043d\u0456 \u0443 \u0446\u044c\u043e\u0433\u043e \u043f\u0440\u043e\u0434\u0430\u0432\u0446\u044f"
  },
  "feedback_list_title_orderer": {
    "sheet_name": "Web",
    "en": "Feedback received",
    "ru": "\u041f\u043e\u043b\u0443\u0447\u0435\u043d \u043e\u0442\u0437\u044b\u0432",
    "fi": "Saatu palaute",
    "sv": "Feedback mottagen",
    "fa": "\u062f\u0631\u06cc\u0627\u0641\u062a \u0628\u0627\u0632\u062e\u0648\u0631\u062f",
    "ar": "\u062a\u0644\u0642\u064a \u0631\u062f\u0648\u062f \u0627\u0644\u0641\u0639\u0644",
    "uk": "\u041e\u0442\u0440\u0438\u043c\u0430\u043d\u043e \u0432\u0456\u0434\u0433\u0443\u043a"
  },
  "feedback_list_title_worker": {
    "sheet_name": "Web",
    "en": "Feedback received",
    "ru": "\u041f\u043e\u043b\u0443\u0447\u0435\u043d \u043e\u0442\u0437\u044b\u0432",
    "fi": "Saatu palaute",
    "sv": "Feedback mottagen",
    "fa": "\u062f\u0631\u06cc\u0627\u0641\u062a \u0628\u0627\u0632\u062e\u0648\u0631\u062f",
    "ar": "\u062a\u0644\u0642\u064a \u0631\u062f\u0648\u062f \u0627\u0644\u0641\u0639\u0644",
    "uk": "\u041e\u0442\u0440\u0438\u043c\u0430\u043d\u043e \u0432\u0456\u0434\u0433\u0443\u043a"
  },
  "feedback_list_today_label": {
    "sheet_name": "Web",
    "en": "Today",
    "ru": "\u041a\u043e\u043c\u043c\u0435\u043d\u0442\u0430\u0440\u0438\u0438 \u043f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u0435\u043b\u0435\u0439",
    "fi": "T\u00e4n\u00e4\u00e4n",
    "sv": "Idag",
    "fa": "\u0627\u0645\u0631\u0648\u0632",
    "ar": "\u0627\u0644\u064a\u0648\u0645",
    "uk": "\u0421\u044c\u043e\u0433\u043e\u0434\u043d\u0456"
  },
  "feedback_list_no_comment_text": {
    "sheet_name": "Web",
    "en": "There is no feedback yet",
    "ru": "\u041d\u0435\u0442 \u0440\u0435\u0437\u0443\u043b\u044c\u0442\u0430\u0442\u043e\u0432",
    "fi": "Palautetta ei viel\u00e4 l\u00f6ydy",
    "sv": "Det finns ingen feedback \u00e4nnu",
    "fa": "\u0628\u0627\u0632\u062e\u0648\u0631\u062f\u06cc \u0648\u062c\u0648\u062f \u0646\u062f\u0627\u0631\u062f!",
    "ar": "\u0644\u0627 \u062a\u0648\u062c\u062f \u062a\u0639\u0644\u064a\u0642\u0627\u062a \u0628\u0639\u062f",
    "uk": "\u0412\u0456\u0434\u0433\u0443\u043a\u0456\u0432 \u0449\u0435 \u043d\u0435\u043c\u0430\u0454"
  },
  "feedback_list_load_more_label": {
    "sheet_name": "Web",
    "en": "Load more comments",
    "ru": "\u041f\u043e\u043a\u0430\u0437\u0430\u0442\u044c \u0431\u043e\u043b\u044c\u0448\u0435 \u043a\u043e\u043c\u043c\u0435\u043d\u0442\u0430\u0440\u0438\u0435\u0432",
    "fi": "N\u00e4yt\u00e4 lis\u00e4\u00e4 kommentteja",
    "sv": "Ladda fler kommentarer",
    "fa": "\u0628\u0627\u0631\u06af\u0630\u0627\u0631\u06cc \u0646\u0638\u0631\u0627\u062a \u0628\u06cc\u0634\u062a\u0631",
    "ar": "\u062a\u062d\u0645\u064a\u0644 \u0627\u0644\u0645\u0632\u064a\u062f \u0645\u0646 \u0627\u0644\u062a\u0639\u0644\u064a\u0642\u0627\u062a",
    "uk": "\u0417\u0430\u0432\u0430\u043d\u0442\u0430\u0436\u0438\u0442\u0438 \u0431\u0456\u043b\u044c\u0448\u0435 \u043a\u043e\u043c\u0435\u043d\u0442\u0430\u0440\u0456\u0432"
  },
  "feedback_showing_all_comments": {
    "sheet_name": "Web",
    "en": "Showing all comments",
    "ru": "",
    "fi": "N\u00e4ytet\u00e4\u00e4n kaikki kommentit",
    "sv": "Visar alla kommentarer",
    "fa": "",
    "ar": "",
    "uk": "\u041f\u043e\u043a\u0430\u0437\u0430\u0442\u0438 \u0432\u0441\u0456 \u043a\u043e\u043c\u0435\u043d\u0442\u0430\u0440\u0456"
  },
  "shared_order_task_label": {
    "sheet_name": "Web",
    "en": "Description",
    "ru": "\u041e\u043f\u0438\u0441\u0430\u043d\u0438\u0435",
    "fi": "Kuvaus",
    "sv": "Beskrivning",
    "fa": "\u062a\u0648\u0636\u06cc\u062d\u0627\u062a \u0648\u0638\u06cc\u0641\u0647",
    "ar": "\u0648\u0635\u0641 \u0639\u0646 \u0627\u0644\u0639\u0645\u0644",
    "uk": "\u041e\u043f\u0438\u0441 \u0437\u0430\u0432\u0434\u0430\u043d\u043d\u044f"
  },
  "shared_order_type_label": {
    "sheet_name": "Web",
    "en": "Service",
    "ru": "\u0422\u0438\u043f",
    "fi": "Palvelu",
    "sv": "Service",
    "fa": "\u0646\u0648\u0639",
    "ar": "\u0627\u0644\u0646\u0648\u0639",
    "uk": "\u0421\u0435\u0440\u0432\u0456\u0441"
  },
  "shared_order_time_label": {
    "sheet_name": "Web",
    "en": "Time",
    "ru": "\u0412\u0440\u0435\u043c\u044f",
    "fi": "Ajoitus",
    "sv": "Tid",
    "fa": "\u0632\u0645\u0627\u0646",
    "ar": "\u0627\u0644\u0648\u0642\u062a",
    "uk": "\u0427\u0430\u0441"
  },
  "shared_order_location_label": {
    "sheet_name": "Web",
    "en": "Location",
    "ru": "\u041c\u0435\u0441\u0442\u043e \u043d\u0430\u0445\u043e\u0436\u0434\u0435\u043d\u0438\u044f",
    "fi": "Sijainti",
    "sv": "Plats",
    "fa": "\u0645\u0648\u0642\u0639\u06cc\u062a",
    "ar": "\u0645\u0648\u0642\u0639",
    "uk": "\u041c\u0456\u0441\u0446\u0435\u0437\u043d\u0430\u0445\u043e\u0434\u0436\u0435\u043d\u043d\u044f"
  },
  "shared_order_amount_label": {
    "sheet_name": "Web",
    "en": "Amount",
    "ru": "\u041a\u043e\u043b\u0438\u0447\u0435\u0441\u0442\u0432\u043e",
    "fi": "M\u00e4\u00e4r\u00e4",
    "sv": "Summa",
    "fa": "\u0645\u0642\u062f\u0627\u0631",
    "ar": "\u0627\u0644\u0645\u062c\u0645\u0648\u0639",
    "uk": "\u0421\u0443\u043c\u043c\u0438"
  },
  "shared_order_earning_label": {
    "sheet_name": "Web",
    "en": "Earning",
    "ru": "\u041d\u0430\u0447\u0438\u0441\u043b\u0435\u043d\u0438\u0435",
    "fi": "Korvaus",
    "sv": "Ers\u00e4ttning",
    "fa": "\u062f\u0631\u0622\u0645\u062f",
    "ar": "\u0643\u0633\u0628",
    "uk": "\u0417\u0430\u0440\u043e\u0431\u0456\u0442\u043e\u043a"
  },
  "shared_order_add_info_label": {
    "sheet_name": "Web",
    "en": "Additional info",
    "ru": "\u0414\u043e\u043f\u043e\u043b\u043d\u0438\u0442\u0435\u043b\u044c\u043d\u0430\u044f \u0438\u043d\u0444\u043e\u0440\u043c\u0430\u0446\u0438\u044f",
    "fi": "Lis\u00e4tietoa",
    "sv": "Ytterligare information",
    "fa": "\u0627\u0637\u0644\u0627\u0639\u0627\u062a \u0627\u0636\u0627\u0641\u06cc",
    "ar": "\u0645\u0639\u0644\u0648\u0645\u0627\u062a \u0625\u0636\u0627\u0641\u064a\u0629",
    "uk": "\u0414\u043e\u0434\u0430\u0442\u043a\u043e\u0432\u0430 \u0456\u043d\u0444\u043e\u0440\u043c\u0430\u0446\u0456\u044f"
  },
  "shared_order_login_text": {
    "sheet_name": "Web",
    "en": "Login",
    "ru": "\u041b\u043e\u0433\u0438\u043d",
    "fi": "Kirjaudu",
    "sv": "Login",
    "fa": "\u0648\u0631\u0648\u062f \u0628\u0647 \u0633\u06cc\u0633\u062a\u0645",
    "ar": "\u062a\u0633\u062c\u064a\u0644 \u0627\u0644\u062f\u062e\u0648\u0644",
    "uk": "\u041b\u043e\u0433\u0456\u043d"
  },
  "shared_order_more_info_text": {
    "sheet_name": "Web",
    "en": "For more info\/apply, please",
    "ru": "\u0427\u0442\u043e\u0431\u044b \u043f\u0440\u043e\u0434\u043e\u043b\u0436\u0438\u0442\u044c, \u043f\u043e\u0436\u0430\u043b\u0443\u0439\u0441\u0442\u0430, \u0438",
    "fi": "Lis\u00e4tietoja\/tee hakemus",
    "sv": "V\u00e4nligen forts\u00e4tt",
    "fa": "\u0628\u0631\u0627\u06cc \u0627\u062f\u0627\u0645\u0647 \u06a9\u0627\u0631 \u060c \u0644\u0637\u0641\u0627\u064b",
    "ar": "\u0645\u0646 \u0627\u062c\u0644 \u0627\u0644\u0645\u0636\u064a \u0642\u062f\u0645\u0627 , \u0645\u0646 \u0641\u0636\u0644\u0643",
    "uk": "\u0414\u043b\u044f \u043e\u0442\u0440\u0438\u043c\u0430\u043d\u043d\u044f \u0434\u043e\u0434\u0430\u0442\u043a\u043e\u0432\u043e\u0457 \u0456\u043d\u0444\u043e\u0440\u043c\u0430\u0446\u0456\u0457\/\u0437\u0430\u044f\u0432\u043a\u0438, \u0431\u0443\u0434\u044c \u043b\u0430\u0441\u043a\u0430"
  },
  "shared_order_use_app_text": {
    "sheet_name": "Web",
    "en": "or use mobile applications:",
    "ru": "\u0418\u043b\u0438 \u0438\u0441\u043f\u043e\u043b\u044c\u0437\u0443\u0439\u0442\u0435 \u043c\u043e\u0431\u0438\u043b\u044c\u043d\u044b\u0435 \u0441\u0435\u0440\u0432\u0438\u0441\u044b",
    "fi": "tai k\u00e4yt\u00e4 mobiilipalveluja",
    "sv": "eller anv\u00e4nd mobil applikation",
    "fa": "\u06cc\u0627 \u0627\u0632 \u0628\u0631\u0646\u0627\u0645\u0647 \u0647\u0627\u06cc \u062a\u0644\u0641\u0646 \u0647\u0645\u0631\u0627\u0647 \u0627\u0633\u062a\u0641\u0627\u062f\u0647 \u06a9\u0646\u06cc\u062f:",
    "ar": "\u0623\u0648 \u0627\u0633\u062a\u062e\u062f\u0645 \u062a\u0637\u0628\u064a\u0642\u0627\u062a \u0627\u0644\u062c\u0648\u0627\u0644:",
    "uk": "\u0430\u0431\u043e \u0441\u043a\u043e\u0440\u0438\u0441\u0442\u0430\u0439\u0442\u0435\u0441\u044c \u043c\u043e\u0431\u0456\u043b\u044c\u043d\u0438\u043c \u0434\u043e\u0434\u0430\u0442\u043a\u043e\u043c"
  },
  "invite_people_to_service": {
    "sheet_name": "Web",
    "en": "User invitation",
    "ru": "",
    "fi": "Kutsu k\u00e4ytt\u00e4ji\u00e4",
    "sv": "Bjud in anv\u00e4ndare",
    "fa": "",
    "ar": "",
    "uk": "\u0417\u0430\u043f\u0440\u043e\u0448\u0435\u043d\u043d\u044f \u043a\u043e\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430"
  },
  "invite_people_tooltip": {
    "sheet_name": "Web",
    "en": "Here you can send an email and invite someone to use this service.",
    "ru": "",
    "fi": "Kutsu tuttusi mukaan k\u00e4ytt\u00e4m\u00e4\u00e4n palvelua!",
    "sv": "H\u00e4r kan du skicka mejl och bjuda in nya anv\u00e4ndare",
    "fa": "",
    "ar": "",
    "uk": "\u0417\u0430\u043f\u0440\u043e\u0441\u0456\u0442\u044c \u0434\u0440\u0443\u0433\u0430  \u0441\u043a\u043e\u0440\u0438\u0441\u0442\u0430\u0442\u0438\u0441\u044f \u0446\u0456\u0454\u044e \u043f\u043e\u0441\u043b\u0443\u0433\u043e\u044e"
  },
  "invite_first_name_of_invitee": {
    "sheet_name": "Web",
    "en": "First name of invitee",
    "ru": "",
    "fi": "Kutsuttavan nimi",
    "sv": "Inbjudarens f\u00f6rnamn",
    "fa": "",
    "ar": "",
    "uk": "\u0406\u043c'\u044f \u0437\u0430\u043f\u0440\u043e\u0448\u0435\u043d\u043e\u0433\u043e"
  },
  "invite_successfully_sent": {
    "sheet_name": "Web",
    "en": "Invitation was sent successfully!",
    "ru": "",
    "fi": "Kutsu l\u00e4hetettiin onnistuneesti",
    "sv": "Grattis, inbjudan \u00e4r skickad!",
    "fa": "",
    "ar": "",
    "uk": "\u0417\u0430\u043f\u0440\u043e\u0448\u0435\u043d\u043d\u044f \u0443\u0441\u043f\u0456\u0448\u043d\u043e \u043d\u0430\u0434\u0456\u0441\u043b\u0430\u043d\u043e!"
  },
  "invite_you_have_been_invited": {
    "sheet_name": "Web",
    "en": "has invited you to join WorkPilots",
    "ru": "",
    "fi": "on kutsunut sinut k\u00e4ytt\u00e4m\u00e4\u00e4n WorkPilots-sovellusta",
    "sv": "har bjudit in dig till WorkPilots",
    "fa": "",
    "ar": "",
    "uk": "\u0437\u0430\u043f\u0440\u043e\u0448\u0443\u0454 \u0432\u0430\u0441 \u043f\u0440\u0454\u0434\u043d\u0430\u0442\u0438\u0441\u044f \u0434\u043e WorkPilots"
  },
  "invite_with_comment": {
    "sheet_name": "Web",
    "en": "The following personal message was added:",
    "ru": "",
    "fi": "T\u00e4ss\u00e4 h\u00e4nen viestins\u00e4:",
    "sv": "F\u00f6ljande personligt meddelande \u00e4r tillagt:",
    "fa": "",
    "ar": "",
    "uk": "\u0411\u0443\u043b\u043e \u0434\u043e\u0434\u0430\u043d\u043e \u043d\u0430\u0441\u0442\u0443\u043f\u043d\u0435 \u043e\u0441\u043e\u0431\u0438\u0441\u0442\u0435 \u043f\u043e\u0432\u0456\u0434\u043e\u043c\u043b\u0435\u043d\u043d\u044f:"
  },
  "not_the_same_as_invite_email": {
    "sheet_name": "Web",
    "en": "Email and confirm email must be equal!",
    "ru": "\u042d\u043b. \u043f\u043e\u0447\u0442\u0430 \u0438 \u043f\u043e\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043d\u043d\u0430\u044f \u044d\u043b.\u043f\u043e\u0447\u0442\u0430 \u0434\u043e\u043b\u0436\u043d\u044b \u0441\u043e\u0432\u043f\u0430\u0434\u0430\u0442\u044c!",
    "fi": "S\u00e4hk\u00f6postit eiv\u00e4t t\u00e4sm\u00e4\u00e4",
    "sv": "E-postadresser matchar inte",
    "fa": "\u0627\u06cc\u0645\u06cc\u0644 \u0648 \u062a\u0623\u06cc\u06cc\u062f \u0627\u06cc\u0645\u06cc\u0644 \u0628\u0627\u06cc\u062f \u0628\u0631\u0627\u0628\u0631 \u0628\u0627\u0634\u062f!",
    "ar": "\u0631\u0633\u0627\u0626\u0644 \u0627\u0644\u0628\u0631\u064a\u062f \u0627\u0644\u0625\u0644\u0643\u062a\u0631\u0648\u0646\u064a \u0644\u0627\u062a\u062a\u0637\u0627\u0628\u0642",
    "uk": "\u0415mail \u0442\u0430 \u043f\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0443\u044e\u0447\u0438\u0439 email \u043f\u043e\u0432\u0438\u043d\u043d\u0456 \u0431\u0443\u0442\u0438 \u043e\u0434\u043d\u0430\u043a\u043e\u0432\u0438\u043c\u0438!"
  },
  "invite_optional_substring": {
    "sheet_name": "Web",
    "en": "(optional)",
    "ru": "",
    "fi": "(valinnainen)",
    "sv": "(friviligt)",
    "fa": "",
    "ar": "",
    "uk": "(\u043d\u0435\u043e\u0431\u043e\u0432'\u044f\u0437\u043a\u043e\u0432\u043e)"
  },
  "menu_label_invite": {
    "sheet_name": "Web",
    "en": "Invite",
    "ru": "",
    "fi": "Kutsu",
    "sv": "Bjud in",
    "fa": "",
    "ar": "",
    "uk": "\u0417\u0430\u043f\u0440\u043e\u0441\u0438\u0442\u0438"
  },
  "documents_tooltip": {
    "sheet_name": "Web",
    "en": "Please add your official documents here to prove that you have the required skills to perform certain types of tasks.",
    "ru": "",
    "fi": "Lis\u00e4\u00e4th\u00e4n t\u00e4nne asiakirjoja todistaaksesi tiettyihin teht\u00e4viin vaadittavia taitoja.",
    "sv": "L\u00e4gg till de relevanta dokument f\u00f6r att visa att du har de f\u00e4rdigheter som kr\u00e4vs f\u00f6r att utf\u00f6ra de s\u00f6kta uppdragen.",
    "fa": "",
    "ar": "",
    "uk": "\u0411\u0443\u0434\u044c \u043b\u0430\u0441\u043a\u0430, \u0434\u043e\u0434\u0430\u0439\u0442\u0435 \u0432\u0430\u0448\u0456 \u043e\u0444\u0456\u0446\u0456\u0439\u043d\u0456 \u0434\u043e\u043a\u0443\u043c\u0435\u043d\u0442\u0438, \u044f\u043a\u0456 \u043f\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0443\u044e\u0442\u044c, \u0449\u043e \u0432\u0438 \u0432\u043e\u043b\u043e\u0434\u0456\u0454\u0442\u0435 \u043d\u0435\u043e\u0431\u0445\u0456\u0434\u043d\u0438\u043c\u0438 \u043d\u0430\u0432\u0438\u0447\u043a\u0430\u043c\u0438 \u0434\u043b\u044f \u0432\u0438\u043a\u043e\u043d\u0430\u043d\u043d\u044f \u043f\u0435\u0432\u043d\u0438\u0445 \u0432\u0438\u0434\u0456\u0432 \u0440\u043e\u0431\u0456\u0442"
  },
  "documents_name": {
    "sheet_name": "Web",
    "en": "Documents",
    "ru": "",
    "fi": "Asiakirjat",
    "sv": "Dokument",
    "fa": "",
    "ar": "",
    "uk": "\u0414\u043e\u043a\u0443\u043c\u0435\u043d\u0442\u0438"
  },
  "documents_name_header": {
    "sheet_name": "Web",
    "en": "Document",
    "ru": "",
    "fi": "Asiakirja",
    "sv": "Dokument",
    "fa": "",
    "ar": "",
    "uk": "\u0414\u043e\u043a\u0443\u043c\u0435\u043d\u0442"
  },
  "documents_info_header": {
    "sheet_name": "Web",
    "en": "Info",
    "ru": "",
    "fi": "Tiedot",
    "sv": "Information",
    "fa": "",
    "ar": "",
    "uk": "\u0406\u043d\u0444\u043e\u0440\u043c\u0430\u0446\u0456\u044f"
  },
  "documents_delete": {
    "sheet_name": "Web",
    "en": "Delete document",
    "ru": "",
    "fi": "Poista asiakirja",
    "sv": "Ta bort dokument",
    "fa": "",
    "ar": "",
    "uk": "\u0412\u0438\u0434\u0430\u043b\u0438\u0442\u0438 \u0434\u043e\u043a\u0443\u043c\u0435\u043d\u0442"
  },
  "documents_add": {
    "sheet_name": "Web",
    "en": "Add document",
    "ru": "",
    "fi": "Lis\u00e4\u00e4 asiakirja",
    "sv": "L\u00e4gg till ett dokument",
    "fa": "",
    "ar": "",
    "uk": "\u0414\u043e\u0434\u0430\u0442\u0438 \u0434\u043e\u043a\u0443\u043c\u0435\u043d\u0442"
  },
  "documents_edit": {
    "sheet_name": "Web",
    "en": "Edit document",
    "ru": "",
    "fi": "Muokkaa asiakirjaa",
    "sv": "Redigera dokument",
    "fa": "",
    "ar": "",
    "uk": "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438 \u0434\u043e\u043a\u0443\u043c\u0435\u043d\u0442"
  },
  "documents_dialog_tooltip": {
    "sheet_name": "Web",
    "en": "Upload a legible document",
    "ru": "",
    "fi": "Lataa luettavissa oleva asiakirja",
    "sv": "Ladda upp ett l\u00e4stbart dokument",
    "fa": "",
    "ar": "",
    "uk": "\u0417\u0430\u0432\u0430\u043d\u0442\u0430\u0436\u0442\u0435 \u0434\u043e\u043a\u0443\u043c\u0435\u043d\u0442 \u0437 \u0440\u043e\u0437\u0431\u0456\u0440\u043b\u0435\u0432\u0438\u043c \u0442\u0435\u043a\u0441\u0442\u043e\u043c"
  },
  "documents_add_photo": {
    "sheet_name": "Web",
    "en": "Add photo",
    "ru": "",
    "fi": "Lis\u00e4\u00e4 kuva",
    "sv": "L\u00e4gg till ett foto",
    "fa": "",
    "ar": "",
    "uk": "\u0414\u043e\u0434\u0430\u0442\u0438 \u0444\u043e\u0442\u043e"
  },
  "documents_add_message": {
    "sheet_name": "Web",
    "en": "Add message (optional)",
    "ru": "",
    "fi": "Lis\u00e4\u00e4 viesti (valinnainen)",
    "sv": "L\u00e4gg tlll meddelande (friviligt)",
    "fa": "",
    "ar": "",
    "uk": "\u0414\u043e\u0434\u0430\u0442\u0438 \u043f\u043e\u0432\u0456\u0434\u043e\u043c\u043b\u0435\u043d\u043d\u044f (\u043d\u0435\u043e\u0431\u043e\u0432'\u044f\u0437\u043a\u043e\u0432\u043e)"
  },
  "documents_add_type": {
    "sheet_name": "Web",
    "en": "Document type",
    "ru": "",
    "fi": "Asiakirjan tyyppi",
    "sv": "Typ av dokument",
    "fa": "",
    "ar": "",
    "uk": "\u0422\u0438\u043f \u0434\u043e\u043a\u0443\u043c\u0435\u043d\u0442\u0443"
  },
  "cv_show_all_feedback": {
    "sheet_name": "Web",
    "en": "Show feedbacks",
    "ru": "",
    "fi": "N\u00e4yt\u00e4 palautteet",
    "sv": "Visa feedback",
    "fa": "",
    "ar": "",
    "uk": "\u041f\u043e\u043a\u0430\u0437\u0430\u0442\u0438 \u0432\u0456\u0434\u0433\u0443\u043a\u0438"
  },
  "cv_hide_all_feedback": {
    "sheet_name": "Web",
    "en": "Hide feedbacks",
    "ru": "",
    "fi": "Piilota palautteet",
    "sv": "D\u00f6lj feedback",
    "fa": "",
    "ar": "",
    "uk": "\u041f\u0440\u0438\u0445\u043e\u0432\u0430\u0442\u0438 \u0432\u0456\u0434\u0433\u0443\u043a\u0438"
  },
  "save_cv_colors": {
    "sheet_name": "Web",
    "en": "Save colors",
    "ru": "",
    "fi": "Tallenna v\u00e4rit",
    "sv": "Spara f\u00e4rger",
    "fa": "",
    "ar": "",
    "uk": "\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438 \u043a\u043e\u043b\u044c\u043e\u0440\u0438"
  },
  "save_cv_colors_fail": {
    "sheet_name": "Web",
    "en": "CV colors save failed",
    "ru": "",
    "fi": "CV v\u00e4rien tallennus ep\u00e4onnistui",
    "sv": "Sparande av CV f\u00e4rger misslyckades",
    "fa": "",
    "ar": "",
    "uk": "\u041d\u0435 \u0432\u0434\u0430\u043b\u043e\u0441\u044f \u0437\u0431\u0435\u0440\u0435\u0433\u0442\u0438 \u043a\u043e\u043b\u044c\u043e\u0440\u0438 CV"
  },
  "save_cv_colors_success": {
    "sheet_name": "Web",
    "en": "CV colors saved successfully",
    "ru": "",
    "fi": "CV v\u00e4rit tallennettu",
    "sv": "CV f\u00e4rger sparades",
    "fa": "",
    "ar": "",
    "uk": "\u041a\u043e\u043b\u044c\u043e\u0440\u0438 CV \u0443\u0441\u043f\u0456\u0448\u043d\u043e \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043d\u043e"
  },
  "cv_switch_tooltip": {
    "sheet_name": "Web",
    "en": "Toggle which tasks show up on your cv",
    "ru": "",
    "fi": "Valitse suoritukset jotka haluat mukaan CV:lle",
    "sv": "V\u00e4lj vilka uppdrag som skall synas p\u00e5 dit CV",
    "fa": "",
    "ar": "",
    "uk": "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044c \u0437\u0430\u0432\u0434\u0430\u043d\u043d\u044f, \u044f\u043a\u0456 \u0432\u0456\u0434\u043e\u0431\u0440\u0430\u0436\u0430\u0442\u0438\u043c\u0443\u0442\u044c\u0441\u044f\u0443 \u0432\u0430\u0448\u043e\u043c\u0443  \u0440\u0435\u0437\u044e\u043c\u0435"
  },
  "cv_share": {
    "sheet_name": "Web",
    "en": "Share CV",
    "ru": "\u041f\u043e\u0434\u0435\u043b\u0438\u0442\u044c\u0441\u044f \u0440\u0435\u0437\u044e\u043c\u0435",
    "fi": "Jaa CV",
    "sv": "Dela CV",
    "fa": "CV \u0631\u0627 \u0628\u0627\u0632 \u06a9\u0646\u06cc\u062f",
    "ar": "\u0646\u0634\u0631 \u0627\u0644\u0633\u064a\u0631\u0629 \u0627\u0644\u0630\u0627\u062a\u064a\u0629",
    "uk": "\u041f\u043e\u0434\u0456\u043b\u0438\u0442\u0438\u0441\u044f \u0440\u0435\u0437\u044e\u043c\u0435"
  },
  "cv_about_me": {
    "sheet_name": "Web",
    "en": "About me",
    "ru": "\u041e\u0431\u043e \u043c\u043d\u0435",
    "fi": "Esittelyni",
    "sv": "Om mig",
    "fa": "\u062f\u0631\u0628\u0627\u0631\u0647 \u0645\u0646",
    "ar": "\u0639\u0646\u064a",
    "uk": "\u041f\u0440\u043e \u043c\u0435\u043d\u0435"
  },
  "cv_languages": {
    "sheet_name": "Web",
    "en": "Languages",
    "ru": "\u042f\u0437\u044b\u043a\u0438",
    "fi": "Kielet",
    "sv": "Spr\u00e5k",
    "fa": "\u0632\u0628\u0627\u0646 \u0647\u0627",
    "ar": "\u0627\u062e\u062a\u0632 \u0627\u0644\u0644\u063a\u0629",
    "uk": "\u041c\u043e\u0432\u0430"
  },
  "cv_my_experiences": {
    "sheet_name": "Web",
    "en": "My experiences",
    "ru": "\u041c\u043e\u0439 \u043e\u043f\u044b\u0442",
    "fi": "Kokemukseni",
    "sv": "Mina erfarenheter",
    "fa": "\u062a\u062c\u0627\u0631\u0628 \u0645\u0646",
    "ar": "\u062a\u062c\u0627\u0631\u0628\u064a",
    "uk": "\u041c\u0456\u0439 \u0434\u043e\u0441\u0432\u0456\u0434"
  },
  "cv_worked_fields": {
    "sheet_name": "Web",
    "en": "Worked fields",
    "ru": "\u0417\u0430\u0434\u0430\u0447\u0438 \u0438\u0437 \u043a\u0430\u0442\u0435\u0433\u043e\u0440\u0438\u0439",
    "fi": "Valmistuneita teht\u00e4vi\u00e4",
    "sv": "Arbetsomr\u00e5den",
    "fa": "\u062f\u0633\u062a\u0647 \u0647\u0627\u06cc \u0634\u063a\u0644\u06cc",
    "ar": "\u062d\u0642\u0648\u0644 \u0627\u0644\u0627\u0639\u0645\u0627\u0644",
    "uk": "\u0412\u0438\u043a\u043e\u043d\u0430\u043d\u0456 \u0437\u0430\u0432\u0434\u0430\u043d\u043d\u044f"
  },
  "cv_education_and_certificates": {
    "sheet_name": "Web",
    "en": "Education and Certificates",
    "ru": "\u041e\u0431\u0440\u0430\u0437\u043e\u0432\u0430\u043d\u0438\u0435 \u0438 \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043a\u0430\u0442\u044b",
    "fi": "Koulutus ja muu osaaminen",
    "sv": "Utbildning och certifikat",
    "fa": "\u0622\u0645\u0648\u0632\u0634 \u0648 \u06af\u0648\u0627\u0647\u06cc\u0646\u0627\u0645\u0647 \u0647\u0627",
    "ar": "\u0627\u0644\u062a\u0639\u0644\u064a\u0645 \u0648\u063a\u064a\u0631\u0647\u0627 \u0645\u0646 \u0627\u0644\u0645\u0647\u0627\u0631\u0627\u062a",
    "uk": "\u041e\u0441\u0432\u0456\u0442\u0430 \u0442\u0430 \u0441\u0435\u0440\u0442\u0438\u0444\u0456\u043a\u0430\u0442\u0438"
  },
  "cv_worked_times": {
    "sheet_name": "Web",
    "en": "Worked {0} time(s)",
    "ru": "\u041e\u0442\u0440\u0430\u0431\u043e\u0442\u0430\u043d\u043e {0} \u0440\u0430\u0437 (\u0430)",
    "fi": "Ty\u00f6skennellyt {0} kertaa",
    "sv": "Arbetade {0} g\u00e5nger",
    "fa": "\u0634\u0645\u0627 {0} \u0628\u0627\u0631 \u06a9\u0627\u0631 \u0627\u0646\u062c\u0627\u0645 \u062f\u0627\u062f\u0647 \u0627\u06cc\u062f",
    "ar": "\u0627\u0639\u0645\u0627\u0644 {0} \u0627\u0644\u0648\u0642\u062a",
    "uk": "\u0412\u0456\u0434\u043f\u0440\u0430\u0446\u044c\u043e\u0432\u0430\u043d\u043e {0} \u0433\u043e\u0434\u0438\u043d(\u0438)"
  },
  "cv_no_completed_tasks_yet": {
    "sheet_name": "Web",
    "en": "Worker does not have completed tasks yet",
    "ru": "\u0420\u0430\u0431\u043e\u0442\u043d\u0438\u043a \u0435\u0449\u0435 \u043d\u0435 \u0432\u044b\u043f\u043e\u043b\u043d\u0438\u043b \u0440\u0430\u0431\u043e\u0442\u0443",
    "fi": "Tekij\u00e4ll\u00e4 ei viel\u00e4 valmistuneita teht\u00e4vi\u00e4",
    "sv": "Utf\u00f6raren har inte slutf\u00f6rt n\u00e5gra uppdrag \u00e4n",
    "fa": "\u06a9\u0627\u0631\u06af\u0631 \u0647\u0646\u0648\u0632 \u0648\u0638\u0627\u06cc\u0641 \u062e\u0648\u062f \u0631\u0627 \u0627\u0646\u062c\u0627\u0645 \u0646\u062f\u0627\u062f\u0647 \u0627\u0633\u062a",
    "ar": "\u0627\u0644\u0639\u0627\u0645\u0644 \u0644\u064a\u0633 \u0644\u062f\u064a\u0647 \u0645\u0647\u0627\u0645 \u0645\u0643\u062a\u0645\u0644\u0647 \u0628\u0639\u062f",
    "uk": "\u041f\u0440\u0430\u0446\u0456\u0432\u043d\u0438\u043a \u0449\u0435 \u043d\u0435 \u043c\u0430\u0454 \u0432\u0438\u043a\u043e\u043d\u0430\u043d\u0438\u0445 \u0437\u0430\u0432\u0434\u0430\u043d\u044c"
  },
  "cv_print_label": {
    "sheet_name": "Web",
    "en": "Print",
    "ru": "\u0420\u0430\u0441\u043f\u0435\u0447\u0430\u0442\u0430\u0442\u044c",
    "fi": "Printtaa",
    "sv": "Skriv ut",
    "fa": "\u0686\u0627\u067e",
    "ar": "\u0637\u0628\u0627\u0639\u0629",
    "uk": "\u0414\u0440\u0443\u043a\u0443\u0432\u0430\u0442\u0438"
  },
  "cv_change_themes": {
    "sheet_name": "Web",
    "en": "Change themes",
    "ru": "",
    "fi": "Vaihda teemaa",
    "sv": "\u00c4ndra teman",
    "fa": "",
    "ar": "",
    "uk": "\u0417\u043c\u0456\u043d\u0438\u0442\u0438 \u0442\u0435\u043c\u0438"
  },
  "cv_customise_background_color": {
    "sheet_name": "Web",
    "en": "Customise background color",
    "ru": "",
    "fi": "Mukauta taustav\u00e4ri\u00e4",
    "sv": "Anpassa bakgrundsf\u00e4rg",
    "fa": "",
    "ar": "",
    "uk": "\u041d\u0430\u043b\u0430\u0448\u0442\u0443\u0439\u0442\u0435 \u043a\u043e\u043b\u0456\u0440 \u0444\u043e\u043d\u0443"
  },
  "cv_current": {
    "sheet_name": "Web",
    "en": "Current",
    "ru": "\u0443\u043f\u043e\u0442\u0440\u0435\u0431\u0438\u0442\u0435\u043b\u044c\u043d\u044b\u0439",
    "fi": "Nykyinen",
    "sv": "P\u00e5g\u00e5ende",
    "fa": "\u062c\u0627\u0631\u06cc",
    "ar": "\u0627\u0644\u062d\u0627\u0644\u064a",
    "uk": "\u043f\u043e\u0442\u043e\u0447\u043d\u0456"
  },
  "cv_share_merchant_color": {
    "sheet_name": "Web",
    "en": "Share with merchant's color",
    "ru": "",
    "fi": "Jaa CV k\u00e4ytt\u00e4en palvelun v\u00e4rej\u00e4",
    "sv": "Dela med tj\u00e4nst f\u00e4rger",
    "fa": "",
    "ar": "",
    "uk": "\u041f\u043e\u0434\u0456\u043b\u0438\u0442\u0438\u0441\u044f \u0437 \u043a\u043e\u043b\u044c\u043e\u0440\u043e\u043c \u043f\u0440\u043e\u0434\u0430\u0432\u0446\u044f"
  },
  "worker_tutorial_00": {
    "sheet_name": "Web",
    "en": "Hi!",
    "ru": "",
    "fi": "Hei!",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u041f\u0440\u0438\u0432\u0456\u0442!"
  },
  "worker_tutorial_01": {
    "sheet_name": "Web",
    "en": "We'd like to show you the best tips for using our service. To get started, please first choose your role.",
    "ru": "",
    "fi": "Haluaisimme n\u00e4ytt\u00e4\u00e4 sinulle parhaat vinkit palvelumme k\u00e4ytt\u00f6\u00f6n. Valitsethan ensin viel\u00e4 roolin itsellesi.",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u041c\u0438 \u0445\u043e\u0442\u0456\u043b\u0438 \u0431 \u043f\u043e\u043a\u0430\u0437\u0430\u0442\u0438 \u0432\u0430\u043c \u043d\u0430\u0439\u043a\u0440\u0430\u0449\u0456 \u043f\u043e\u0440\u0430\u0434\u0438 \u0449\u043e\u0434\u043e \u0432\u0438\u043a\u043e\u0440\u0438\u0441\u0442\u0430\u043d\u043d\u044f \u043d\u0430\u0448\u043e\u0433\u043e \u0441\u0435\u0440\u0432\u0456\u0441\u0443. \u0429\u043e\u0431 \u0440\u043e\u0437\u043f\u043e\u0447\u0430\u0442\u0438, \u0441\u043f\u043e\u0447\u0430\u0442\u043a\u0443 \u0432\u0438\u0431\u0435\u0440\u0456\u0442\u044c \u0441\u0432\u043e\u044e \u0440\u043e\u043b\u044c"
  },
  "worker_tutorial_01b": {
    "sheet_name": "Web",
    "en": "You can rewatch this intro from the settings anytime",
    "ru": "",
    "fi": "Voit katsoa ohjeistuksen uudelleen asetuksista milloin vain",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0412\u0438 \u043c\u043e\u0436\u0435\u0442\u0435 \u043f\u0435\u0440\u0435\u0433\u043b\u044f\u043d\u0443\u0442\u0438 \u0446\u0456 \u0456\u043d\u0441\u0442\u0440\u0443\u043a\u0446\u0456\u0457 \u0443 \u0431\u0443\u0434\u044c-\u044f\u043a\u0438\u0439 \u0447\u0430\u0441"
  },
  "worker_tutorial_02": {
    "sheet_name": "Web",
    "en": "Make your profile more appealing to Orderers by adding description",
    "ru": "",
    "fi": "Tee profiilistasi houkuttelevampi Tilaajille kirjoittamalla itsest\u00e4si kuvaus",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0417\u0440\u043e\u0431\u0456\u0442\u044c \u0441\u0432\u0456\u0439 \u043f\u0440\u043e\u0444\u0456\u043b\u044c \u0431\u0456\u043b\u044c\u0448 \u043f\u0440\u0438\u0432\u0430\u0431\u043b\u0438\u0432\u0438\u043c \u0434\u043b\u044f \u0437\u0430\u043c\u043e\u0432\u043d\u0438\u043a\u0456\u0432, \u0434\u043e\u0434\u0430\u0432\u0448\u0438 \u043e\u043f\u0438\u0441"
  },
  "worker_tutorial_02b": {
    "sheet_name": "Web",
    "en": "and a profile picture to help you get gigs!",
    "ru": "",
    "fi": "ja lis\u00e4\u00e4m\u00e4ll\u00e4 profiilikuva, joka auttaa my\u00f6s keikkojen saamisessa!",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0410 \u0442\u0430\u043a\u043e\u0436, \u0444\u043e\u0442\u043e\u0433\u0440\u0430\u0444\u0456\u044e \u043f\u0440\u043e\u0444\u0456\u043b\u044e, \u044f\u043a\u0430 \u0434\u043e\u043f\u043e\u043c\u043e\u0436\u0435 \u0432\u0430\u043c \u043e\u0442\u0440\u0438\u043c\u0430\u0442\u0438 \u0440\u043e\u0431\u043e\u0442\u0443!"
  },
  "worker_tutorial_03": {
    "sheet_name": "Web",
    "en": "We will be looking for gigs from this address...",
    "ru": "",
    "fi": "N\u00e4yt\u00e4mme sinulle keikkoja t\u00e4m\u00e4n osoitteen perusteella...",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u041c\u0438 \u043f\u043e\u043a\u0430\u0436\u0435\u043c\u043e \u0432\u0430\u043c \u0432\u0430\u043a\u0430\u043d\u0441\u0456\u0457 \u0437\u0430 \u0446\u0456\u0454\u044e \u0430\u0434\u0440\u0435\u0441\u043e\u044e..."
  },
  "worker_tutorial_04": {
    "sheet_name": "Web",
    "en": "..and within this radius",
    "ru": "",
    "fi": "... ja korkeintaan t\u00e4m\u00e4n et\u00e4isyyden p\u00e4\u00e4st\u00e4.",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "..\u0456 \u0432 \u0446\u044c\u043e\u043c\u0443 \u0440\u0430\u0434\u0456\u0443\u0441\u0456"
  },
  "worker_tutorial_05": {
    "sheet_name": "Web",
    "en": "You can find open opportunities here and start applying for them! If there is nothing available, please go to settings and check you have set location and chosen categories of interests.",
    "ru": "",
    "fi": "T\u00e4\u00e4lt\u00e4 l\u00f6yd\u00e4t avoimet mahdollisuudet ja voit alkaa hakea niihin! Jos avoimia mahdollisuuksia ei ole, tarkistathan asetuksista ett\u00e4 sijainti on asetettu ja kiinnostavat kategoriat on valittu.",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0422\u0443\u0442 \u0432\u0438 \u043c\u043e\u0436\u0435\u0442\u0435 \u0437\u043d\u0430\u0439\u0442\u0438 \u0432\u0456\u0434\u043a\u0440\u0438\u0442\u0456 \u0432\u0430\u043a\u0430\u043d\u0441\u0456\u0457  \u0442\u0430 \u043f\u043e\u0447\u0430\u0442\u0438 \u043f\u043e\u0434\u0430\u0432\u0430\u0442\u0438 \u0437\u0430\u044f\u0432\u043a\u0438 \u043d\u0430 \u0440\u043e\u0431\u043e\u0442\u0443! \u042f\u043a\u0449\u043e \u043d\u0456\u0447\u043e\u0433\u043e \u043d\u0435 \u0437\u043d\u0430\u0439\u0448\u043b\u043e\u0441\u044f, \u043f\u0435\u0440\u0435\u0439\u0434\u0456\u0442\u044c \u0434\u043e \u043d\u0430\u043b\u0430\u0448\u0442\u0443\u0432\u0430\u043d\u044c \u0456 \u043f\u0435\u0440\u0435\u0432\u0456\u0440\u0442\u0435, \u0447\u0438 \u043f\u0440\u0430\u0432\u0438\u043b\u044c\u043d\u043e \u0432\u0438 \u0432\u0441\u0442\u0430\u043d\u043e\u0432\u0438\u043b\u0438 \u043b\u043e\u043a\u0430\u0446\u0456\u044e \u0442\u0430 \u043e\u0431\u0440\u0430\u043b\u0438 \u0456\u043d\u0442\u0435\u0440\u0435\u0441\u0438 \u0437\u0430\u0432\u0434\u0430\u043d\u043d\u044f."
  },
  "worker_tutorial_06": {
    "sheet_name": "Web",
    "en": "When you are selected to a gig, you will see a notification here and get an email. You\u2019ll also get other important notifications here!",
    "ru": "",
    "fi": "Kun sinut valitaan tekij\u00e4ksi keikalle, n\u00e4et t\u00e4\u00e4ll\u00e4 ilmoituksen ja saat my\u00f6s s\u00e4hk\u00f6postin. Saat t\u00e4nne my\u00f6s muita t\u00e4rkeit\u00e4 ilmoituksia!",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u042f\u043a\u0449\u043e \u0432\u0438 \u043f\u043e\u0437\u043d\u0430\u0447\u0438\u043b\u0438 \u043f\u0443\u043d\u043a\u0442 \"\u0412\u0430\u043a\u0430\u043d\u0441\u0456\u0457\", \u0442\u043e \u0432\u0438 \u043f\u043e\u0431\u0430\u0447\u0438\u0442\u0435 \u0442\u0443\u0442 \u0441\u043f\u043e\u0432\u0456\u0449\u0435\u043d\u043d\u044f \u0456 \u043e\u0442\u0440\u0438\u043c\u0430\u0454\u0442\u0435 \u043f\u043e\u0432\u0456\u0434\u043e\u043c\u043b\u0435\u043d\u043d\u044f \u043d\u0430 \u0435\u043b\u0435\u043a\u0442\u0440\u043e\u043d\u0443 \u043f\u043e\u0448\u0442\u0443. \u0412\u0438 \u0442\u0430\u043a\u043e\u0436 \u043e\u0442\u0440\u0438\u043c\u0430\u0454\u0442\u0435 \u0456\u043d\u0448\u0456 \u0432\u0430\u0436\u043b\u0438\u0432\u0456 \u0441\u043f\u043e\u0432\u0456\u0449\u0435\u043d\u043d\u044f!"
  },
  "worker_tutorial_07": {
    "sheet_name": "Web",
    "en": "From the side menu you can find your public profile and CV page. By adding accomplishments and experiences in settings, you can make your profile even better! Side menu can be opened from the three line button on the top.",
    "ru": "",
    "fi": "Sivupalkista l\u00f6yd\u00e4t julkisen profiilisi ja oman CV sivusi. Lis\u00e4\u00e4m\u00e4ll\u00e4 osaamisesi ja kokemuksesi asetukset-sivulla, voit tehd\u00e4 profiilistasi entist\u00e4kin paremman! Sivupalkin saa avattua ylh\u00e4\u00e4ll\u00e4 olevasta napista, jossa on kolme viivaa.",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u041d\u0430 \u0431\u0456\u0447\u043d\u0456\u0439 \u043f\u0430\u043d\u0435\u043b\u0456 \u0432\u0438 \u0437\u043d\u0430\u0439\u0434\u0435\u0442\u0435 \u0441\u0432\u0456\u0439 \u043f\u0443\u0431\u043b\u0456\u0447\u043d\u0438\u0439 \u043f\u0440\u043e\u0444\u0456\u043b\u044c \u0456 \u0432\u043b\u0430\u0441\u043d\u0443 \u0441\u0442\u043e\u0440\u0456\u043d\u043a\u0443 \u0440\u0435\u0437\u044e\u043c\u0435. \u0414\u043e\u0434\u0430\u0432\u0448\u0438 \u0441\u0432\u043e\u0457 \u043d\u0430\u0432\u0438\u0447\u043a\u0438 \u0442\u0430 \u0434\u043e\u0441\u0432\u0456\u0434 \u043d\u0430 \u0441\u0442\u043e\u0440\u0456\u043d\u0446\u0456 \u043d\u0430\u043b\u0430\u0448\u0442\u0443\u0432\u0430\u043d\u044c, \u0432\u0438 \u043c\u043e\u0436\u0435\u0442\u0435 \u0437\u0440\u043e\u0431\u0438\u0442\u0438 \u0441\u0432\u0456\u0439 \u043f\u0440\u043e\u0444\u0456\u043b\u044c \u0449\u0435 \u043a\u0440\u0430\u0449\u0438\u043c! \u0411\u0456\u0447\u043d\u0443 \u043f\u0430\u043d\u0435\u043b\u044c \u043c\u043e\u0436\u043d\u0430 \u0432\u0456\u0434\u043a\u0440\u0438\u0442\u0438 \u0437\u0430 \u0434\u043e\u043f\u043e\u043c\u043e\u0433\u043e\u044e \u043a\u043d\u043e\u043f\u043a\u0438 \u0432\u0433\u043e\u0440\u0456 \u0437 \u0442\u0440\u044c\u043e\u043c\u0430 \u043b\u0456\u043d\u0456\u044f\u043c\u0438"
  },
  "worker_tutorial_08a": {
    "sheet_name": "Web",
    "en": "That\u2019s it, now you are ready to use our service!",
    "ru": "",
    "fi": "Nyt olet valmis k\u00e4ytt\u00e4m\u00e4\u00e4n palveluamme!",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0412\u0441\u0435, \u0442\u0435\u043f\u0435\u0440 \u0432\u0438 \u0433\u043e\u0442\u043e\u0432\u0456 \u0434\u043e \u0432\u0438\u043a\u043e\u0440\u0438\u0441\u0442\u0430\u043d\u043d\u044f \u043d\u0430\u0448\u043e\u0433\u043e \u0441\u0435\u0440\u0432\u0456\u0441\u0443!"
  },
  "worker_tutorial_08b": {
    "sheet_name": "Web",
    "en": "We recommend you go back to settings and fill in the rest of your profile to make it more appealing and increase your chances of getting selected to your first gig. And don\u2019t worry you can rewatch this intro from the settings anytime! PS: some fields also have tool-tips just hover over them!",
    "ru": "",
    "fi": "Suosittelemme, ett\u00e4 seuraavaksi t\u00e4ydenn\u00e4t profiilisi asetuksista tehd\u00e4ksesi siit\u00e4 houkuttelevamman ja kasvattaaksesi mahdollisuuksiasi saada ensimm\u00e4inen keikka. \u00c4l\u00e4 huoli, voit my\u00f6s katsoa n\u00e4m\u00e4 vinkit uudestaan milloin vain asetukset-sivulta! PS: palvelussa on my\u00f6s ty\u00f6kaluvihjeit\u00e4, jotka n\u00e4kyv\u00e4t kun viet hiiren osoittimen kenttien p\u00e4\u00e4lle",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u041c\u0438 \u0440\u0435\u043a\u043e\u043c\u0435\u043d\u0434\u0443\u0454\u043c\u043e \u0432\u0430\u043c \u043f\u043e\u0432\u0435\u0440\u043d\u0443\u0442\u0438\u0441\u044f \u0434\u043e \u043d\u0430\u043b\u0430\u0448\u0442\u0443\u0432\u0430\u043d\u044c \u0456 \u0437\u0430\u043f\u043e\u0432\u043d\u0438\u0442\u0438 \u0440\u0435\u0448\u0442\u0443 \u0432\u0430\u0448\u043e\u0433\u043e \u043f\u0440\u043e\u0444\u0456\u043b\u044e, \u0449\u043e\u0431 \u0437\u0440\u043e\u0431\u0438\u0442\u0438 \u0439\u043e\u0433\u043e \u0431\u0456\u043b\u044c\u0448 \u043f\u0440\u0438\u0432\u0430\u0431\u043b\u0438\u0432\u0438\u043c \u0456 \u043f\u0456\u0434\u0432\u0438\u0449\u0438\u0442\u0438 \u0432\u0430\u0448\u0456 \u0448\u0430\u043d\u0441\u0438 \u0431\u0443\u0442\u0438 \u043e\u0431\u0440\u0430\u043d\u0438\u043c \u043d\u0430 \u0432\u0430\u0448\u0443 \u043f\u0435\u0440\u0448\u0443 \u0440\u043e\u0431\u043e\u0442\u0443. \u0406 \u043d\u0435 \u0445\u0432\u0438\u043b\u044e\u0439\u0442\u0435\u0441\u044f, \u0432\u0438 \u043c\u043e\u0436\u0435\u0442\u0435 \u043f\u0435\u0440\u0435\u0433\u043b\u044f\u043d\u0443\u0442\u0438 \u0446\u0435 \u0432\u0441\u0442\u0443\u043f\u043d\u0435 \u0432\u0456\u0434\u0435\u043e \u0437 \u043d\u0430\u043b\u0430\u0448\u0442\u0443\u0432\u0430\u043d\u044c \u0443 \u0431\u0443\u0434\u044c-\u044f\u043a\u0438\u0439 \u0447\u0430\u0441! PS: \u0434\u0435\u044f\u043a\u0456 \u043f\u043e\u043b\u044f \u0442\u0430\u043a\u043e\u0436 \u043c\u0430\u044e\u0442\u044c \u043f\u0456\u0434\u043a\u0430\u0437\u043a\u0438, \u043f\u0440\u043e\u0441\u0442\u043e \u043d\u0430\u0432\u0435\u0434\u0456\u0442\u044c \u043d\u0430 \u043d\u0438\u0445 \u043a\u0443\u0440\u0441\u043e\u0440!"
  },
  "tutorial_rewatch_tutorial": {
    "sheet_name": "Web",
    "en": "Re-watch intro",
    "ru": "",
    "fi": "Katso ohjeistus",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u041f\u0435\u0440\u0435\u0433\u043b\u044f\u043d\u044c\u0442\u0435 \u0456\u043d\u0441\u0442\u0440\u0443\u043a\u0446\u0456\u0457"
  },
  "orderer_tutorial_01": {
    "sheet_name": "Web",
    "en": "Choose an organization type and add details to tell Workers who you are as an Orderer",
    "ru": "",
    "fi": "Valitse organisaatiotyyppi ja lis\u00e4\u00e4 tietoja n\u00e4ytt\u00e4\u00e4ksesi Tekij\u00f6ille kuka olet Tilaajana",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044c \u0442\u0438\u043f \u043e\u0440\u0433\u0430\u043d\u0456\u0437\u0430\u0446\u0456\u0457 \u0442\u0430 \u0434\u043e\u0434\u0430\u0439\u0442\u0435 \u0434\u0430\u043d\u0456, \u0449\u043e\u0431 \u043f\u043e\u0432\u0456\u0434\u043e\u043c\u0438\u0442\u0438 \u041f\u0440\u0430\u0446\u0456\u0432\u043d\u0438\u043a\u0430\u043c, \u0445\u0442\u043e \u0432\u0438 \u044f\u043a \u0417\u0430\u043c\u043e\u0432\u043d\u0438\u043a"
  },
  "orderer_tutorial_02": {
    "sheet_name": "Web",
    "en": "Make your profile more appealing by adding a picture of yourself or your organization\u2019s logo.",
    "ru": "",
    "fi": "Tee profiilistasi houkuttelevampi lis\u00e4\u00e4m\u00e4ll\u00e4 kuva itsest\u00e4si tai organisaatiosi logosta",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0417\u0440\u043e\u0431\u0456\u0442\u044c \u0441\u0432\u0456\u0439 \u043f\u0440\u043e\u0444\u0456\u043b\u044c \u0431\u0456\u043b\u044c\u0448 \u043f\u0440\u0438\u0432\u0430\u0431\u043b\u0438\u0432\u0438\u043c, \u0434\u043e\u0434\u0430\u0432\u0448\u0438 \u0444\u043e\u0442\u043e\u0433\u0440\u0430\u0444\u0456\u044e \u0441\u0435\u0431\u0435 \u0430\u0431\u043e \u043b\u043e\u0433\u043e\u0442\u0438\u043f \u0432\u0430\u0448\u043e\u0457 \u043e\u0440\u0433\u0430\u043d\u0456\u0437\u0430\u0446\u0456\u0457"
  },
  "orderer_tutorial_02b": {
    "sheet_name": "Web",
    "en": "Add location to your profile. It will be used as the default location when you make orders.",
    "ru": "",
    "fi": "Lis\u00e4\u00e4 sijainti profiilillesi. Sit\u00e4 k\u00e4ytet\u00e4\u00e4n oletussijaintina, kun luot tilauksia.",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0414\u043e\u0434\u0430\u0439\u0442\u0435 \u043c\u0456\u0441\u0446\u0435 \u0440\u043e\u0437\u0442\u0430\u0448\u0443\u0432\u0430\u043d\u043d\u044f \u0434\u043e \u0441\u0432\u043e\u0433\u043e \u043f\u0440\u043e\u0444\u0456\u043b\u044e. \u0412\u043e\u043d\u043e \u0431\u0443\u0434\u0435 \u0432\u0438\u043a\u043e\u0440\u0438\u0441\u0442\u043e\u0432\u0443\u0432\u0430\u0442\u0438\u0441\u044f \u044f\u043a \u043c\u0456\u0441\u0446\u0435 \u0437\u0430 \u0437\u0430\u043c\u043e\u0432\u0447\u0443\u0432\u0430\u043d\u043d\u044f\u043c \u043f\u0440\u0438 \u043e\u0444\u043e\u0440\u043c\u043b\u0435\u043d\u043d\u0456 \u0437\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u044c"
  },
  "orderer_tutorial_03": {
    "sheet_name": "Web",
    "en": "Here you can create a new order and start finding Workers for your needs!",
    "ru": "",
    "fi": "T\u00e4\u00e4lt\u00e4 voit tehd\u00e4 uuden tilauksen ja alkaa etsi\u00e4 Tekij\u00f6it\u00e4 tarpeisiisi!",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0422\u0443\u0442 \u0432\u0438 \u043c\u043e\u0436\u0435\u0442\u0435 \u0441\u0442\u0432\u043e\u0440\u0438\u0442\u0438 \u043d\u043e\u0432\u0435 \u0437\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f \u0456 \u043f\u043e\u0447\u0430\u0442\u0438 \u043f\u043e\u0448\u0443\u043a \u043f\u0440\u0430\u0446\u0456\u0432\u043d\u0438\u043a\u0456\u0432 \u0434\u043b\u044f \u0432\u0430\u0448\u0438\u0445 \u043f\u043e\u0442\u0440\u0435\u0431"
  },
  "orderer_tutorial_04": {
    "sheet_name": "Web",
    "en": "Published orders will be shown here as well as the number of applicants so you can easily choose a suitable Worker.",
    "ru": "",
    "fi": "Julkaisemasi tilaukset ja teht\u00e4viin hakijat n\u00e4kyv\u00e4t t\u00e4\u00e4ll\u00e4, joten voit helposti valita sopivan Tekij\u00e4n",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0422\u0443\u0442 \u0431\u0443\u0434\u0443\u0442\u044c \u043f\u043e\u043a\u0430\u0437\u0430\u043d\u0456 \u043e\u043f\u0443\u0431\u043b\u0456\u043a\u043e\u0432\u0430\u043d\u0456 \u0437\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f, \u0430 \u0442\u0430\u043a\u043e\u0436 \u043a\u0456\u043b\u044c\u043a\u0456\u0441\u0442\u044c \u043f\u0440\u0435\u0442\u0435\u043d\u0434\u0435\u043d\u0442\u0456\u0432, \u0449\u043e\u0431 \u0432\u0438 \u043c\u043e\u0433\u043b\u0438 \u0437 \u043b\u0435\u0433\u043a\u0456\u0441\u0442\u044e \u0432\u0438\u0431\u0440\u0430\u0442\u0438 \u0432\u0456\u0434\u043f\u043e\u0432\u0456\u0434\u043d\u043e\u0433\u043e \u043f\u0440\u0430\u0446\u0456\u0432\u043d\u0438\u043a\u0430."
  },
  "orderer_tutorial_05": {
    "sheet_name": "Web",
    "en": "When you get an applicant, you will also see a notification here. You\u2019ll also get other important notifications here!",
    "ru": "",
    "fi": "Kun saat hakijan teht\u00e4v\u00e4\u00e4n, n\u00e4et my\u00f6s t\u00e4\u00e4ll\u00e4 ilmoituksen. Saat lis\u00e4ksi muita t\u00e4rkeit\u00e4 ilmoituksia t\u00e4nne!",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u041a\u043e\u043b\u0438 \u0432\u0438 \u043e\u0442\u0440\u0438\u043c\u0430\u0454\u0442\u0435 \u0437\u0430\u044f\u0432\u043d\u0438\u043a\u0430, \u0432\u0438 \u0442\u0430\u043a\u043e\u0436 \u043f\u043e\u0431\u0430\u0447\u0438\u0442\u0435 \u043f\u043e\u0432\u0456\u0434\u043e\u043c\u043b\u0435\u043d\u043d\u044f \u0442\u0443\u0442. \u0422\u0430\u043a\u043e\u0436 \u0442\u0443\u0442 \u0432\u0438 \u0431\u0443\u0434\u0435\u0442\u0435 \u043e\u0442\u0440\u0438\u043c\u0443\u0432\u0430\u0442\u0438 \u0456\u043d\u0448\u0456 \u0432\u0430\u0436\u043b\u0438\u0432\u0456 \u043f\u043e\u0432\u0456\u0434\u043e\u043c\u043b\u0435\u043d\u043d\u044f!"
  },
  "orderer_tutorial_06": {
    "sheet_name": "Web",
    "en": "From the side menu you can find your public profile and settings. You can also manage your payment methods from here. Side menu can be opened from the three line button on the top.",
    "ru": "",
    "fi": "Sivupalkista l\u00f6yd\u00e4t julkisen profiilisi ja asetukset. Voit my\u00f6s hallinnoida maksutapoja t\u00e4\u00e4lt\u00e4. Sivupalkin saa avattua ylh\u00e4\u00e4ll\u00e4 olevasta napista, jossa on kolme viivaa.",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0423 \u0431\u0456\u0447\u043d\u043e\u043c\u0443 \u043c\u0435\u043d\u044e \u0432\u0438 \u043c\u043e\u0436\u0435\u0442\u0435 \u0437\u043d\u0430\u0439\u0442\u0438 \u0441\u0432\u0456\u0439 \u043f\u0443\u0431\u043b\u0456\u0447\u043d\u0438\u0439 \u043f\u0440\u043e\u0444\u0456\u043b\u044c \u0442\u0430 \u043d\u0430\u043b\u0430\u0448\u0442\u0443\u0432\u0430\u043d\u043d\u044f. \u0417\u0432\u0456\u0434\u0441\u0438 \u0432\u0438 \u0442\u0430\u043a\u043e\u0436 \u043c\u043e\u0436\u0435\u0442\u0435 \u043a\u0435\u0440\u0443\u0432\u0430\u0442\u0438 \u0441\u0432\u043e\u0457\u043c\u0438 \u043f\u043b\u0430\u0442\u0456\u0436\u043d\u0438\u043c\u0438 \u043c\u0435\u0442\u043e\u0434\u0430\u043c\u0438. \u0411\u0456\u0447\u043d\u0435 \u043c\u0435\u043d\u044e \u043c\u043e\u0436\u043d\u0430 \u0432\u0456\u0434\u043a\u0440\u0438\u0442\u0438 \u0437\u0430 \u0434\u043e\u043f\u043e\u043c\u043e\u0433\u043e\u044e \u043a\u043d\u043e\u043f\u043a\u0438 \u0437 \u0442\u0440\u044c\u043e\u043c\u0430 \u043b\u0456\u043d\u0456\u044f\u043c\u0438 \u0430\u0431\u043e \u043a\u0440\u0430\u043f\u043a\u0430\u043c\u0438 \u0432\u0433\u043e\u0440\u0456"
  },
  "orderer_tutorial_07": {
    "sheet_name": "Web",
    "en": "That\u2019s it, now you are ready to use our service and create your first order! And don\u2019t worry you can rewatch this intro from the settings anytime! PS: some fields also have tool-tips just hover over them!",
    "ru": "",
    "fi": "Se oli siin\u00e4, nyt olet valmis k\u00e4ytt\u00e4m\u00e4\u00e4n palveluamme ja tekem\u00e4\u00e4n ensimm\u00e4isen tilauksesi! \u00c4l\u00e4 huoli, voit my\u00f6s katsoa n\u00e4m\u00e4 vinkit uudestaan milloin vain asetukset-sivulta!  PS: palvelussa on my\u00f6s ty\u00f6kaluvihjeit\u00e4, jotka n\u00e4kyv\u00e4t kun viet hiiren osoittimen kenttien p\u00e4\u00e4lle",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u041e\u0441\u044c \u0456 \u0432\u0441\u0435, \u0442\u0435\u043f\u0435\u0440 \u0432\u0438 \u0433\u043e\u0442\u043e\u0432\u0456 \u0441\u043a\u043e\u0440\u0438\u0441\u0442\u0430\u0442\u0438\u0441\u044f \u043d\u0430\u0448\u0438\u043c \u0441\u0435\u0440\u0432\u0456\u0441\u043e\u043c \u0456 \u0441\u0442\u0432\u043e\u0440\u0438\u0442\u0438 \u0441\u0432\u043e\u0454 \u043f\u0435\u0440\u0448\u0435 \u0437\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f! \u0422\u0430\u043a\u043e\u0436, \u0432 \u0431\u0443\u0434\u044c-\u044f\u043a\u0438\u0439 \u0447\u0430\u0441, \u0432\u0438 \u043c\u043e\u0436\u0435\u0442\u0435 \u043f\u0435\u0440\u0435\u0433\u043b\u044f\u043d\u0443\u0442\u0438 \u0430\u0431\u043e \u0437\u043c\u0456\u043d\u0438\u0442\u0438 \u043d\u0430\u043b\u0430\u0448\u0442\u0443\u0432\u0430\u043d\u043d\u044f  PS: \u0434\u0435\u044f\u043a\u0456 \u043f\u043e\u043b\u044f \u0442\u0430\u043a\u043e\u0436 \u043c\u0430\u044e\u0442\u044c \u043f\u0456\u0434\u043a\u0430\u0437\u043a\u0438, \u043f\u0440\u043e\u0441\u0442\u043e \u043d\u0430\u0432\u0435\u0434\u0456\u0442\u044c \u043d\u0430 \u043d\u0438\u0445 \u043a\u0443\u0440\u0441\u043e\u0440!"
  },
  "tutorial_skip_tutorial": {
    "sheet_name": "Web",
    "en": "Skip",
    "ru": "",
    "fi": "Ohita ohjeistus",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u041f\u0440\u043e\u043f\u0443\u0441\u0442\u0438\u0442\u0438"
  },
  "tutorial_finish": {
    "sheet_name": "Web",
    "en": "Finish",
    "ru": "",
    "fi": "Valmis",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0417\u0430\u043a\u0456\u043d\u0447\u0438\u0442\u0438"
  },
  "new_order_tutorial_00": {
    "sheet_name": "Web",
    "en": "Would you like to see instructions on best practices when creating this order?",
    "ru": "",
    "fi": "Haluatko n\u00e4hd\u00e4 ohjeita parhaista k\u00e4yt\u00e4nn\u00f6ist\u00e4 t\u00e4t\u00e4 tilausta luodessa?",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0427\u0438 \u0445\u043e\u0442\u0456\u043b\u0438 \u0431 \u0412\u0438 \u043f\u043e\u0431\u0430\u0447\u0438\u0442\u0438 \u0456\u043d\u0441\u0442\u0440\u0443\u043a\u0446\u0456\u044e \u0449\u043e\u0434\u043e \u043d\u0430\u0439\u043a\u0440\u0430\u0449\u0438\u0445 \u043f\u0440\u0430\u043a\u0442\u0438\u043a \u043f\u0440\u0438 \u0441\u0442\u0432\u043e\u0440\u0435\u043d\u043d\u0456 \u0446\u044c\u043e\u0433\u043e \u0437\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f?"
  },
  "new_order_tutorial_01": {
    "sheet_name": "Web",
    "en": "Start by adding the required information. Description is like a title of the order so remember to keep it short and simple!",
    "ru": "",
    "fi": "Aloita lis\u00e4\u00e4m\u00e4ll\u00e4 pakolliset tiedot. Teht\u00e4v\u00e4n kuvaus on kuin tilauksen otsikko, joten muista pit\u00e4\u00e4 se lyhyen\u00e4 ja yksinkertaisena.",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u041f\u043e\u0447\u043d\u0456\u0442\u044c \u0437 \u0434\u043e\u0434\u0430\u0432\u0430\u043d\u043d\u044f \u043f\u043e\u0442\u0440\u0456\u0431\u043d\u043e\u0457 \u0456\u043d\u0444\u043e\u0440\u043c\u0430\u0446\u0456\u0457. \u041e\u043f\u0438\u0441 \u0437\u0430\u0432\u0434\u0430\u043d\u043d\u044f - \u0446\u0435 \u044f\u043a \u0437\u0430\u0433\u043e\u043b\u043e\u0432\u043e\u043a \u043d\u0430\u043a\u0430\u0437\u0443, \u0442\u043e\u043c\u0443 \u043f\u0430\u043c'\u044f\u0442\u0430\u0439\u0442\u0435, \u0449\u043e \u0432\u0456\u043d \u043c\u0430\u0454 \u0431\u0443\u0442\u0438 \u043a\u043e\u0440\u043e\u0442\u043a\u0438\u043c \u0456 \u043f\u0440\u043e\u0441\u0442\u0438\u043c!"
  },
  "new_order_tutorial_02": {
    "sheet_name": "Web",
    "en": "Next, choose the most suitable category for the order. If the category has a price, you can see if it\u2019s based on hours, days, months or units.",
    "ru": "",
    "fi": "Valitse seuraavaksi teht\u00e4v\u00e4\u00e4n parhaiten sopiva kategoria. Jos kategorialla on hinta, n\u00e4et my\u00f6s perustuuko se tunteihin, p\u00e4iviin, kuukausiin vai yksikk\u00f6ihin.",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0414\u0430\u043b\u0456 \u0432\u0438\u0431\u0435\u0440\u0456\u0442\u044c \u043a\u0430\u0442\u0435\u0433\u043e\u0440\u0456\u044e, \u044f\u043a\u0430 \u043d\u0430\u0439\u043a\u0440\u0430\u0449\u0435 \u0432\u0456\u0434\u043f\u043e\u0432\u0456\u0434\u0430\u0454 \u0437\u0430\u0432\u0434\u0430\u043d\u043d\u044e. \u042f\u043a\u0449\u043e \u043a\u0430\u0442\u0435\u0433\u043e\u0440\u0456\u044f \u043c\u0430\u0454 \u0446\u0456\u043d\u0443, \u0432\u0438 \u0442\u0430\u043a\u043e\u0436 \u043c\u043e\u0436\u0435\u0442\u0435 \u043f\u043e\u0431\u0430\u0447\u0438\u0442\u0438, \u0447\u0438 \u0431\u0430\u0437\u0443\u0454\u0442\u044c\u0441\u044f \u0432\u043e\u043d\u0430 \u043d\u0430 \u0433\u043e\u0434\u0438\u043d\u0430\u0445, \u0434\u043d\u044f\u0445, \u043c\u0456\u0441\u044f\u0446\u044f\u0445 \u0447\u0438 \u043e\u0434\u0438\u043d\u0438\u0446\u044f\u0445"
  },
  "new_order_tutorial_03": {
    "sheet_name": "Web",
    "en": "We also recommend adding more information about the order in the optional fields. Detailed information helps the applicants to understand what it is really about!",
    "ru": "",
    "fi": "Suosittelemme my\u00f6s kertomaan lis\u00e4tietoja vapaavalintaisissa kentiss\u00e4. Yksityiskohtaiset tiedot auttavat hakijoita ymm\u00e4rt\u00e4m\u00e4\u00e4n, mist\u00e4 todella on kyse!",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u041c\u0438 \u0442\u0430\u043a\u043e\u0436 \u0440\u0435\u043a\u043e\u043c\u0435\u043d\u0434\u0443\u0454\u043c\u043e \u0434\u043e\u0434\u0430\u0432\u0430\u0442\u0438 \u0431\u0456\u043b\u044c\u0448\u0435 \u0456\u043d\u0444\u043e\u0440\u043c\u0430\u0446\u0456\u0457 \u043f\u0440\u043e \u0437\u0430\u0432\u0434\u0430\u043d\u043d\u044f \u0432 \u043d\u0435\u043e\u0431\u043e\u0432'\u044f\u0437\u043a\u043e\u0432\u0438\u0445 \u043f\u043e\u043b\u044f\u0445. \u0414\u0435\u0442\u0430\u043b\u044c\u043d\u0430 \u0456\u043d\u0444\u043e\u0440\u043c\u0430\u0446\u0456\u044f \u0434\u043e\u043f\u043e\u043c\u0430\u0433\u0430\u0454 \u043a\u0430\u043d\u0434\u0438\u0434\u0430\u0442\u0430\u043c  \u0437\u0440\u043e\u0437\u0443\u043c\u0456\u0442\u0438, \u043f\u0440\u043e \u0449\u043e \u043d\u0430\u0441\u043f\u0440\u0430\u0432\u0434\u0456 \u0439\u0434\u0435\u0442\u044c\u0441\u044f \u0432 \u0437\u0430\u0432\u0434\u0430\u043d\u043d\u0456!"
  },
  "new_order_tutorial_04": {
    "sheet_name": "Web",
    "en": "It is also possible to target the order, which means only specific workers will see it available. Order can be targeted to private team by adding a code, to public team by selecting it from the list or to an individual worker by adding worker\u2019s email. If the task can be completed remotely, it\u2019s possible to choose \u201cDistance work\u201d\",",
    "ru": "",
    "fi": "Tilaus on my\u00f6s mahdollistaa kohdentaa, mik\u00e4 tarkoittaa ett\u00e4 vain tietyt tekij\u00e4t n\u00e4kev\u00e4t tilauksen avoimena. Tilauksen voi kohdentaa yksityiselle ryhm\u00e4lle lis\u00e4\u00e4m\u00e4ll\u00e4 koodin, julkiselle ryhm\u00e4lle valitsemalla sen listasta tai ykstt\u00e4iselle tekij\u00e4lle lis\u00e4\u00e4m\u00e4ll\u00e4 h\u00e4nen s\u00e4hk\u00f6postinsa. Jos teht\u00e4v\u00e4n voi suorittaa et\u00e4n\u00e4, on mahdollista valita \"Et\u00e4ty\u00f6\".",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0422\u0430\u043a\u043e\u0436 \u043c\u043e\u0436\u043d\u0430 \u043d\u0430\u0446\u0456\u043b\u0438\u0442\u0438  \u0437\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f, \u0442\u043e\u0431\u0442\u043e \u0442\u0456\u043b\u044c\u043a\u0438 \u043f\u0435\u0432\u043d\u0456 \u043f\u0440\u0430\u0446\u0456\u0432\u043d\u0438\u043a\u0438 \u043f\u043e\u0431\u0430\u0447\u0430\u0442\u044c \u0439\u043e\u0433\u043e \u0434\u043e\u0441\u0442\u0443\u043f\u043d\u0438\u043c. \u0417\u0430\u0432\u0434\u0430\u043d\u043d\u044f \u043c\u043e\u0436\u043d\u0430 \u043d\u0430\u043b\u0430\u0448\u0442\u0443\u0432\u0430\u0442\u0438  \u043d\u0430 \u043f\u0440\u0438\u0432\u0430\u0442\u043d\u0443 \u043a\u043e\u043c\u0430\u043d\u0434\u0443, \u0434\u043e\u0434\u0430\u0432\u0448\u0438 \u043a\u043e\u0434, \u043d\u0430 \u043f\u0443\u0431\u043b\u0456\u0447\u043d\u0443 \u043a\u043e\u043c\u0430\u043d\u0434\u0443, \u0432\u0438\u0431\u0440\u0430\u0432\u0448\u0438 \u0457\u0457 \u0456\u0437 \u0441\u043f\u0438\u0441\u043a\u0443, \u0430\u0431\u043e \u043d\u0430 \u043e\u043a\u0440\u0435\u043c\u043e\u0433\u043e \u043f\u0440\u0430\u0446\u0456\u0432\u043d\u0438\u043a\u0430, \u0434\u043e\u0434\u0430\u0432\u0448\u0438 \u0435\u043b\u0435\u043a\u0442\u0440\u043e\u043d\u043d\u0443 \u043f\u043e\u0448\u0442\u0443 \u043f\u0440\u0430\u0446\u0456\u0432\u043d\u0438\u043a\u0430. \u042f\u043a\u0449\u043e \u0437\u0430\u0432\u0434\u0430\u043d\u043d\u044f \u043c\u043e\u0436\u0435 \u0431\u0443\u0442\u0438 \u0432\u0438\u043a\u043e\u043d\u0430\u043d\u043e \u0434\u0438\u0441\u0442\u0430\u043d\u0446\u0456\u0439\u043d\u043e, \u043c\u043e\u0436\u043d\u0430 \u0432\u0438\u0431\u0440\u0430\u0442\u0438 \"\u0414\u0438\u0441\u0442\u0430\u043d\u0446\u0456\u0439\u043d\u0430 \u0440\u043e\u0431\u043e\u0442\u0430\"\","
  },
  "new_order_tutorial_05": {
    "sheet_name": "Web",
    "en": "Add location for the task by writing address here and choosing it from the list. You can also move the red marker on the map to change location.",
    "ru": "",
    "fi": "Lis\u00e4\u00e4 teht\u00e4v\u00e4n sijainti kirjoittamalla osoite t\u00e4h\u00e4n ja valitse se listasta. Voit my\u00f6s liikuttaa punaista merkki\u00e4 kartalla valitaksesi sijainnin.",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0414\u043e\u0434\u0430\u0439\u0442\u0435 \u043c\u0456\u0441\u0446\u0435 \u0434\u043b\u044f \u0437\u0430\u0432\u0434\u0430\u043d\u043d\u044f, \u043d\u0430\u043f\u0438\u0448\u0456\u0442\u044c \u0442\u0443\u0442 \u0430\u0434\u0440\u0435\u0441\u0443 \u0456 \u0432\u0438\u0431\u0435\u0440\u0456\u0442\u044c \u0457\u0457 \u0456\u0437 \u0441\u043f\u0438\u0441\u043a\u0443. \u0412\u0438 \u0442\u0430\u043a\u043e\u0436 \u043c\u043e\u0436\u0435\u0442\u0435 \u043f\u0435\u0440\u0435\u043c\u0456\u0441\u0442\u0438\u0442\u0438 \u0447\u0435\u0440\u0432\u043e\u043d\u0438\u0439 \u043c\u0430\u0440\u043a\u0435\u0440 \u043d\u0430 \u043a\u0430\u0440\u0442\u0456, \u0449\u043e\u0431 \u0437\u043c\u0456\u043d\u0438\u0442\u0438 \u043c\u0456\u0441\u0446\u0435 \u0440\u043e\u0437\u0442\u0430\u0448\u0443\u0432\u0430\u043d\u043d\u044f"
  },
  "new_order_tutorial_06": {
    "sheet_name": "Web",
    "en": "And if necessary, you can add further information of the address here. For example, special instructions about the entrance or in some rare cases when google maps doesn\u2019t have the exact location, you can specify it here.",
    "ru": "",
    "fi": "Tarvittaessa voit my\u00f6s lis\u00e4t\u00e4 osoitteesta lis\u00e4tietoja t\u00e4nne. Esim. ohjeita sis\u00e4\u00e4nk\u00e4ynnist\u00e4 tai harvinaisissa tapauksissa, kun Google Mapsista ei l\u00f6ydy tarkkaa sijaintia, voit m\u00e4\u00e4ritt\u00e4\u00e4 sen t\u00e4\u00e4ll\u00e4.",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u041f\u0440\u0438 \u043d\u0435\u043e\u0431\u0445\u0456\u0434\u043d\u043e\u0441\u0442\u0456 \u0442\u0443\u0442 \u043c\u043e\u0436\u043d\u0430 \u0434\u043e\u0434\u0430\u0442\u0438 \u0434\u043e\u0434\u0430\u0442\u043a\u043e\u0432\u0443 \u0456\u043d\u0444\u043e\u0440\u043c\u0430\u0446\u0456\u044e \u0430\u0434\u0440\u0435\u0441\u0438. \u041d\u0430\u043f\u0440\u0438\u043a\u043b\u0430\u0434, \u0441\u043f\u0435\u0446\u0456\u0430\u043b\u044c\u043d\u0456 \u0456\u043d\u0441\u0442\u0440\u0443\u043a\u0446\u0456\u0457 \u043f\u0440\u043e \u0432\u0445\u0456\u0434 \u0430\u0431\u043e \u0432 \u0434\u0435\u044f\u043a\u0438\u0445 \u0440\u0456\u0434\u043a\u0456\u0441\u043d\u0438\u0445 \u0432\u0438\u043f\u0430\u0434\u043a\u0430\u0445, \u043a\u043e\u043b\u0438 \u043a\u0430\u0440\u0442\u0438 google \u043d\u0435 \u043c\u0430\u044e\u0442\u044c \u0442\u043e\u0447\u043d\u043e\u0433\u043e \u043c\u0456\u0441\u0446\u044f \u0440\u043e\u0437\u0442\u0430\u0448\u0443\u0432\u0430\u043d\u043d\u044f, \u0432\u0438 \u043c\u043e\u0436\u0435\u0442\u0435 \u0432\u043a\u0430\u0437\u0430\u0442\u0438 \u0439\u043e\u0433\u043e \u0442\u0443\u0442"
  },
  "new_order_tutorial_07": {
    "sheet_name": "Web",
    "en": "To set the timing of the task, you have two options: 1) choose dates from calendar fields 2) write schedule in free form",
    "ru": "",
    "fi": "Teht\u00e4v\u00e4n ajoituksen asettamiselle on kaksi vaihtoehtoa: 1) valitse p\u00e4iv\u00e4t kalenterikentist\u00e4 2) kirjoita aikataulu vapaassa muodossa",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0429\u043e\u0431 \u0437\u0430\u0434\u0430\u0442\u0438 \u0442\u0435\u0440\u043c\u0456\u043d\u0438 \u0432\u0438\u043a\u043e\u043d\u0430\u043d\u043d\u044f \u0437\u0430\u0432\u0434\u0430\u043d\u043d\u044f, \u0443 \u0432\u0430\u0441 \u0454 \u0434\u0432\u0430 \u0432\u0430\u0440\u0456\u0430\u043d\u0442\u0438: 1) \u0432\u0438\u0431\u0440\u0430\u0442\u0438 \u0434\u0430\u0442\u0438 \u0437 \u043f\u043e\u043b\u0456\u0432 \u043a\u0430\u043b\u0435\u043d\u0434\u0430\u0440\u044f 2) \u043d\u0430\u043f\u0438\u0441\u0430\u0442\u0438 \u0433\u0440\u0430\u0444\u0456\u043a \u0443 \u0434\u043e\u0432\u0456\u043b\u044c\u043d\u0456\u0439 \u0444\u043e\u0440\u043c\u0456"
  },
  "new_order_tutorial_08": {
    "sheet_name": "Web",
    "en": "If the task is done during one day, just choose the start date. If the task takes multiple days, add the end date as well. From the time fields, you can set the daily working hours for the task.",
    "ru": "",
    "fi": "Jos teht\u00e4v\u00e4 kest\u00e4\u00e4 yhden p\u00e4iv\u00e4n, valitse vain aloitusp\u00e4iv\u00e4 kalenterista. Jos teht\u00e4v\u00e4 kest\u00e4\u00e4 useamman p\u00e4iv\u00e4n, niin lis\u00e4\u00e4 my\u00f6s lopetusp\u00e4iv\u00e4. P\u00e4ivitt\u00e4isen ty\u00f6ajan voit m\u00e4\u00e4ritt\u00e4\u00e4 lis\u00e4\u00e4m\u00e4ll\u00e4 aloitus- ja lopetusajan.",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u042f\u043a\u0449\u043e \u0437\u0430\u0432\u0434\u0430\u043d\u043d\u044f \u0432\u0438\u043a\u043e\u043d\u0443\u0454\u0442\u044c\u0441\u044f \u043f\u0440\u043e\u0442\u044f\u0433\u043e\u043c \u043e\u0434\u043d\u043e\u0433\u043e \u0434\u043d\u044f, \u043f\u0440\u043e\u0441\u0442\u043e \u0432\u0438\u0431\u0435\u0440\u0456\u0442\u044c  \u0434\u0430\u0442\u0443 \u043f\u043e\u0447\u0430\u0442\u043a\u0443. \u042f\u043a\u0449\u043e \u0437\u0430\u0432\u0434\u0430\u043d\u043d\u044f \u0437\u0430\u0439\u043c\u0430\u0454 \u0434\u0435\u043a\u0456\u043b\u044c\u043a\u0430 \u0434\u043d\u0456\u0432, \u0434\u043e\u0434\u0430\u0439\u0442\u0435  \u0434\u0430\u0442\u0443 \u0437\u0430\u043a\u0456\u043d\u0447\u0435\u043d\u043d\u044f. \u0417 \u043f\u043e\u043b\u0456\u0432 \u0447\u0430\u0441\u0443 \u0434\u043b\u044f \u0432\u0438\u043a\u043e\u043d\u0430\u043d\u043d\u044f \u0437\u0430\u0432\u0434\u0430\u043d\u043d\u044f \u043c\u043e\u0436\u043d\u0430 \u0432\u0441\u0442\u0430\u043d\u043e\u0432\u0438\u0442\u0438 \u0449\u043e\u0434\u0435\u043d\u043d\u0438\u0439 \u0440\u0435\u0436\u0438\u043c \u0440\u043e\u0431\u043e\u0442\u0438"
  },
  "new_order_tutorial_09": {
    "sheet_name": "Web",
    "en": "Or if you rather just write the schedule, you can enter it in free form here, such as \u201cNext week\u201d or \u201cDuring May\u201d.",
    "ru": "",
    "fi": "Tai jos mieluummin vain kirjoitat aikataulun vapaassa muodossa, voit tehd\u00e4 sen t\u00e4h\u00e4n kentt\u00e4\u00e4n esim. \"Ensi viikolla\" tai \"Toukokuun aikana\"",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0412\u0438 \u043c\u043e\u0436\u0435\u0442\u0435 \u043d\u0430\u043f\u0438\u0441\u0430\u0442\u0438 \u0440\u043e\u0437\u043a\u043b\u0430\u0434 \u0441\u0430\u043c\u043e\u0441\u0442\u0456\u0439\u043d\u043e (\u0443 \u0434\u043e\u0432\u0456\u043b\u044c\u043d\u0456\u0439 \u0444\u043e\u0440\u043c\u0456) \u0442\u0443\u0442, \u043d\u0430\u043f\u0440\u0438\u043a\u043b\u0430\u0434 \u00ab\u041d\u0430\u0441\u0442\u0443\u043f\u043d\u043e\u0433\u043e \u0442\u0438\u0436\u043d\u044f\u00bb \u0430\u0431\u043e \u00ab\u041f\u0440\u043e\u0442\u044f\u0433\u043e\u043c \u0442\u0440\u0430\u0432\u043d\u044f\u00bb."
  },
  "new_order_tutorial_10": {
    "sheet_name": "Web",
    "en": "Remember also to set the total duration \/ units here before moving on to the next page. For example, 5 hours or 2 days. Even if you are looking for several workers, always enter one worker's work amount here!",
    "ru": "",
    "fi": "Muistathan my\u00f6s asettaa tilaukselle kokonaiskeston \/ yksikk\u00f6jen m\u00e4\u00e4r\u00e4n ennen kuin siirryt eteenp\u00e4in. Esim. 5 tuntia tai 2 p\u00e4iv\u00e4\u00e4. Vaikka etsisit useita tekij\u00f6it\u00e4, sy\u00f6t\u00e4 t\u00e4h\u00e4n aina yhden tekij\u00e4n ty\u00f6m\u00e4\u00e4r\u00e4!",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u041f\u0430\u043c\u2019\u044f\u0442\u0430\u0439\u0442\u0435 \u0442\u0430\u043a\u043e\u0436, \u0449\u043e \u043f\u0435\u0440\u0435\u0434 \u0442\u0438\u043c, \u044f\u043a \u043f\u0435\u0440\u0435\u0439\u0442\u0438 \u043d\u0430 \u043d\u0430\u0441\u0442\u0443\u043f\u043d\u0443 \u0441\u0442\u043e\u0440\u0456\u043d\u043a\u0443, \u0442\u0443\u0442 \u0431\u0443\u0434\u0435 \u0432\u0441\u0442\u0430\u043d\u043e\u0432\u043b\u0435\u043d\u043e \u0437\u0430\u0433\u0430\u043b\u044c\u043d\u0443 \u0442\u0440\u0438\u0432\u0430\u043b\u0456\u0441\u0442\u044c \/ \u043e\u0434\u0438\u043d\u0438\u0446\u0456. \u041d\u0430\u043f\u0440\u0438\u043a\u043b\u0430\u0434, 5 \u0433\u043e\u0434\u0438\u043d \u0430\u0431\u043e 2 \u0434\u043d\u0456\u0432. \u041d\u0430\u0432\u0456\u0442\u044c \u044f\u043a\u0449\u043e \u0432\u0438 \u0448\u0443\u043a\u0430\u0454\u0442\u0435 \u043a\u0456\u043b\u044c\u043a\u043e\u0445 \u043f\u0440\u0430\u0446\u0456\u0432\u043d\u0438\u043a\u0456\u0432, \u0437\u0430\u0432\u0436\u0434\u0438 \u0432\u0432\u0435\u0434\u0456\u0442\u044c \u0441\u044e\u0434\u0438 \u043a\u0456\u043b\u044c\u043a\u0456\u0441\u0442\u044c \u0440\u043e\u0431\u0456\u0442 \u043e\u0434\u043d\u043e\u0433\u043e \u043f\u0440\u0430\u0446\u0456\u0432\u043d\u0438\u043a\u0430!"
  },
  "new_order_tutorial_11": {
    "sheet_name": "Web",
    "en": "Next you need to choose payment method for the order. If no method is yet available, you can also add payment card from the \u201cAdd card\u201d button.",
    "ru": "",
    "fi": "Seuravaaksi tilaukselle t\u00e4ytyy m\u00e4\u00e4ritt\u00e4\u00e4 maksutapa. Jos mik\u00e4\u00e4n maksutapa ei ole viel\u00e4 valittavissa, voit lis\u00e4t\u00e4 uuden maksukortin \"Lis\u00e4\u00e4 maksukortti\" napista.",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0414\u0430\u043b\u0456 \u043d\u0435\u043e\u0431\u0445\u0456\u0434\u043d\u043e \u0432\u0438\u0431\u0440\u0430\u0442\u0438 \u0441\u043f\u043e\u0441\u0456\u0431 \u043e\u043f\u043b\u0430\u0442\u0438 \u0437\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f. \u042f\u043a\u0449\u043e \u0441\u043f\u043e\u0441\u0456\u0431 \u0449\u0435 \u043d\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u043d\u0438\u0439, \u0432\u0438 \u0442\u0430\u043a\u043e\u0436 \u043c\u043e\u0436\u0435\u0442\u0435 \u0434\u043e\u0434\u0430\u0442\u0438 \u043f\u043b\u0430\u0442\u0456\u0436\u043d\u0443 \u043a\u0430\u0440\u0442\u043a\u0443 \u0437\u0430 \u0434\u043e\u043f\u043e\u043c\u043e\u0433\u043e\u044e \u043a\u043d\u043e\u043f\u043a\u0438 \u00ab\u0414\u043e\u0434\u0430\u0442\u0438 \u043a\u0430\u0440\u0442\u043a\u0443\u00bb"
  },
  "new_order_tutorial_12": {
    "sheet_name": "Web",
    "en": "This is the summary page. We recommend you check once more that all the information is correct and then you can publish the order!",
    "ru": "",
    "fi": "T\u00e4m\u00e4 on tilauksen yhteenvetosivu. Suosittelemme ett\u00e4 tarkistat lis\u00e4\u00e4m\u00e4si tiedot viel\u00e4 kerran ja sitten voit julkaista tilauksen!",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0426\u0435 \u0441\u0442\u043e\u0440\u0456\u043d\u043a\u0430 \u0437\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f. \u0420\u0435\u043a\u043e\u043c\u0435\u043d\u0434\u0443\u0454\u043c\u043e \u0449\u0435 \u0440\u0430\u0437 \u043f\u0435\u0440\u0435\u0432\u0456\u0440\u0438\u0442\u0438, \u0447\u0438 \u0432\u0441\u0456 \u0432\u0456\u0434\u043e\u043c\u043e\u0441\u0442\u0456 \u043f\u0440\u0430\u0432\u0438\u043b\u044c\u043d\u0456, \u0456 \u0442\u043e\u0434\u0456 \u0432\u0438 \u043c\u043e\u0436\u0435\u0442\u0435 \u043e\u043f\u0443\u0431\u043b\u0456\u043a\u0443\u0432\u0430\u0442\u0438 \u0439\u043e\u0433\u043e!"
  },
  "tooltips_target_task_desc": {
    "sheet_name": "Web",
    "en": "Description is like a title of the order. It's best to keep it simple as it will also show in reports and worker certificates.",
    "ru": "",
    "fi": "Kuvaus on kuin tilauksen otsikko. Kannattaa pit\u00e4\u00e4 se yksinkertaisena, sill\u00e4 se tulee n\u00e4kym\u00e4\u00e4n my\u00f6s raporteissa ja tekij\u00e4n todistuksessa.",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u041e\u043f\u0438\u0441 \u0437\u0430\u0432\u0434\u0430\u043d\u043d\u044f - \u0446\u0435 \u044f\u043a \u043d\u0430\u0437\u0432\u0430 \u0437\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f. \u041a\u0440\u0430\u0449\u0435, \u0449\u043e\u0431 \u0432\u0456\u043d \u0431\u0443\u0432 \u043f\u0440\u043e\u0441\u0442\u0438\u043c, \u043e\u0441\u043a\u0456\u043b\u044c\u043a\u0438 \u0432\u0456\u043d \u0442\u0430\u043a\u043e\u0436 \u0432\u0456\u0434\u043e\u0431\u0440\u0430\u0436\u0430\u0442\u0438\u043c\u0435\u0442\u044c\u0441\u044f \u0443 \u0437\u0432\u0456\u0442\u0430\u0445 \u0442\u0430 \u043f\u043e\u0441\u0432\u0456\u0434\u0447\u0435\u043d\u043d\u044f\u0445 \u043f\u0440\u0430\u0446\u0456\u0432\u043d\u0438\u043a\u0456\u0432"
  },
  "tooltips_target_additional_info": {
    "sheet_name": "Web",
    "en": "In additional info we recommend adding more details of the order.",
    "ru": "",
    "fi": "Lis\u00e4tiedoissa suosittelemme kertomaan tarkempia tietoja tilauksesta.",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0423 \u0434\u043e\u0434\u0430\u0442\u043a\u043e\u0432\u0456\u0439 \u0456\u043d\u0444\u043e\u0440\u043c\u0430\u0446\u0456\u0457 \u0440\u0435\u043a\u043e\u043c\u0435\u043d\u0434\u0443\u0454\u043c\u043e \u0434\u043e\u0434\u0430\u0442\u0438 \u0431\u0456\u043b\u044c\u0448 \u0434\u0435\u0442\u0430\u043b\u044c\u043d\u0443 \u0456\u043d\u0444\u043e\u0440\u043c\u0430\u0446\u0456\u044e \u043f\u0440\u043e \u0437\u0430\u0432\u0434\u0430\u043d\u043d\u044f"
  },
  "tooltips_target_order_teams": {
    "sheet_name": "Web",
    "en": "To target this order to a private team, enter a team code.The order will become available only to the workers in the chosen team.",
    "ru": "",
    "fi": "Kohdentaaksesi tilauksen yksityiselle ryhm\u00e4lle, lis\u00e4\u00e4 ryhm\u00e4koodi. Tilaus tulee n\u00e4kyviin vain valitun ryhm\u00e4\u00e4n j\u00e4senille.",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0414\u043b\u044f \u0442\u043e\u0433\u043e, \u0449\u043e\u0431 \u0437\u0440\u043e\u0431\u0438\u0442\u0438 \u0446\u0435 \u0437\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f \u043f\u0440\u0438\u0432\u0430\u0442\u043d\u0456\u0439 \u043a\u043e\u043c\u0430\u043d\u0434\u0456, \u0432\u0432\u0435\u0434\u0456\u0442\u044c \u043a\u043e\u0434 \u043a\u043e\u043c\u0430\u043d\u0434\u0438.\u0437\u0430\u0432\u0434\u0430\u043d\u043d\u044f \u0441\u0442\u0430\u043d\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u043d\u0438\u043c \u043b\u0438\u0448\u0435 \u043f\u0440\u0430\u0446\u0456\u0432\u043d\u0438\u043a\u0430\u043c \u0443 \u043e\u0431\u0440\u0430\u043d\u0456\u0439 \u043a\u043e\u043c\u0430\u043d\u0434\u0456"
  },
  "tooltips_target_public_team": {
    "sheet_name": "Web",
    "en": "To target this order to a public team, choose a team from the list below. The order will become available only to the workers in the chosen team.",
    "ru": "",
    "fi": "Kohdentaaksesi tilauksen julkiselle ryhm\u00e4lle, valitse ryhm\u00e4 alla olevalta listalta. Tilaus tulee n\u00e4kyviin vain valitun ryhm\u00e4\u00e4n j\u00e4senille.",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0414\u043b\u044f \u0442\u043e\u0433\u043e, \u0449\u043e\u0431 \u0437\u0440\u043e\u0431\u0438\u0442\u0438 \u0446\u0435 \u0437\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f \u043f\u0443\u0431\u043b\u0456\u0447\u043d\u0456\u0439 \u043a\u043e\u043c\u0430\u043d\u0434\u0456, \u0432\u0438\u0431\u0435\u0440\u0456\u0442\u044c \u043a\u043e\u043c\u0430\u043d\u0434\u0443 \u0437\u0456 \u0441\u043f\u0438\u0441\u043a\u0443 \u043d\u0438\u0436\u0447\u0435. \u0417\u0430\u0432\u0434\u0430\u043d\u043d\u044f \u0441\u0442\u0430\u043d\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u043d\u0438\u043c \u043b\u0438\u0448\u0435 \u0440\u043e\u0431\u0456\u0442\u043d\u0438\u043a\u0430\u043c \u0443 \u043e\u0431\u0440\u0430\u043d\u0456\u0439 \u043a\u043e\u043c\u0430\u043d\u0434\u0456"
  },
  "tooltips_target_order_worker": {
    "sheet_name": "Web",
    "en": "To target this order to an individual worker, enter the worker's email here. The worker won't have to apply for the order, and it will go straight into ongoing orders when created.",
    "ru": "",
    "fi": "Kohdentaaksesi tilauksen yksitt\u00e4iselle tekij\u00e4lle, lis\u00e4\u00e4 tekij\u00e4n s\u00e4hk\u00f6posti t\u00e4h\u00e4n. Tekij\u00e4n ei tarvitse hakea tilaukseen vaan se siirtyy suoraan meneill\u00e4\u00e4n oleviin tilauksiin julkaistaessa.",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0414\u043b\u044f \u0442\u043e\u0433\u043e, \u0449\u043e\u0431 \u0437\u0440\u043e\u0431\u0438\u0442\u0438 \u0446\u0435 \u0437\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f \u0456\u043d\u0434\u0438\u0432\u0456\u0434\u0443\u0430\u043b\u044c\u043d\u043e\u043c\u0443 \u043f\u0440\u0430\u0446\u0456\u0432\u043d\u0438\u043a\u0443, \u0432\u0432\u0435\u0434\u0456\u0442\u044c \u0441\u044e\u0434\u0438 \u0435\u043b\u0435\u043a\u0442\u0440\u043e\u043d\u043d\u0443 \u043f\u043e\u0448\u0442\u0443 \u043f\u0440\u0430\u0446\u0456\u0432\u043d\u0438\u043a\u0430. \u0420\u043e\u0431\u0456\u0442\u043d\u0438\u043a \u043d\u0435 \u043f\u043e\u0432\u0438\u043d\u0435\u043d \u0431\u0443\u0434\u0435 \u0437\u0432\u0435\u0440\u0442\u0430\u0442\u0438\u0441\u044f \u0437\u0430 \u0437\u0430\u0432\u0434\u0430\u043d\u043d\u044f\u043c, \u0456 \u0437\u0430\u0432\u0434\u0430\u043d\u043d\u044f \u0431\u0443\u0434\u0435 \u0439\u0442\u0438 \u043f\u0440\u044f\u043c\u043e \u0432 \u043f\u043e\u0442\u043e\u0447\u043d\u0456 \u0437\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f \u043f\u0440\u0438 \u0441\u0442\u0432\u043e\u0440\u0435\u043d\u043d\u0456"
  },
  "tooltips_distance_work": {
    "sheet_name": "Web",
    "en": "Distance work means that the order will be available to workers in all locations.",
    "ru": "",
    "fi": "Et\u00e4ty\u00f6 tarkoittaa, ett\u00e4 tilaus tulee n\u00e4kyviin tekij\u00f6ille kaikilla alueilla.",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0414\u0438\u0441\u0442\u0430\u043d\u0446\u0456\u0439\u043d\u0430 \u0440\u043e\u0431\u043e\u0442\u0430 \u043e\u0437\u043d\u0430\u0447\u0430\u0454, \u0449\u043e \u0437\u0430\u0432\u0434\u0430\u043d\u043d\u044f \u0431\u0443\u0434\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u043d\u0435 \u043f\u0440\u0430\u0446\u0456\u0432\u043d\u0438\u043a\u0430\u043c \u0443 \u0432\u0441\u0456\u0445 \u043b\u043e\u043a\u0430\u0446\u0456\u044f\u0445"
  },
  "tooltips_how_to_use_maps": {
    "sheet_name": "Web",
    "en": "Write address here and choose it from the list below or move the red marker on the map to change location.",
    "ru": "",
    "fi": "Kirjoita osoite t\u00e4h\u00e4n ja valitse se listalta tai siirr\u00e4 punaista merkki\u00e4 kartalla muuttaaksesi sijaintia.",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u041d\u0430\u043f\u0438\u0448\u0456\u0442\u044c \u0442\u0443\u0442 \u0430\u0434\u0440\u0435\u0441\u0443 \u0442\u0430 \u043e\u0431\u0435\u0440\u0456\u0442\u044c \u0457\u0457 \u0437\u0456 \u0441\u043f\u0438\u0441\u043a\u0443 \u043d\u0438\u0436\u0447\u0435 \u0430\u0431\u043e \u043f\u0435\u0440\u0435\u043c\u0456\u0441\u0442\u0456\u0442\u044c \u0447\u0435\u0440\u0432\u043e\u043d\u0438\u0439 \u043c\u0430\u0440\u043a\u0435\u0440 \u043d\u0430 \u043a\u0430\u0440\u0442\u0456, \u0449\u043e\u0431 \u0437\u043c\u0456\u043d\u0438\u0442\u0438 \u043c\u0456\u0441\u0446\u0435 \u0440\u043e\u0437\u0442\u0430\u0448\u0443\u0432\u0430\u043d\u043d\u044f"
  },
  "tooltips_team_code": {
    "sheet_name": "Web",
    "en": "Enter a 5-character team code ie. TEAM1. The system will generate additional 3 char.",
    "ru": "",
    "fi": "Kirjoita 5-merkkinen ryhm\u00e4koodi esim. TEAM1. Palvelu luo sitten koodiin viel\u00e4 3 lis\u00e4merkki\u00e4.",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0412\u0432\u0435\u0434\u0456\u0442\u044c 5-\u0437\u043d\u0430\u0447\u043d\u0438\u0439 \u043a\u043e\u0434 \u043a\u043e\u043c\u0430\u043d\u0434\u0438, \u043d\u0430\u043f\u0440\u0438\u043a\u043b\u0430\u0434 TEAM1. \u041f\u043e\u0442\u0456\u043c \u0441\u0438\u0441\u0442\u0435\u043c\u0430 \u0437\u0433\u0435\u043d\u0435\u0440\u0443\u0454 \u0434\u043e\u0434\u0430\u0442\u043a\u043e\u0432\u0456 3 \u0441\u0438\u043c\u0432\u043e\u043b\u0438"
  },
  "tooltips_additional_hours": {
    "sheet_name": "Web",
    "en": "Please enter only the additional hours. For example, if original order was 2h but it took 3h in total, enter 1h here. Adding hours creates new order which needs to be approved normally.",
    "ru": "",
    "fi": "Sy\u00f6t\u00e4 vain lis\u00e4tunnit. Esim. jos alkuper\u00e4inen tilaus oli 2h, mutta keikka kestikin 3h, sy\u00f6t\u00e4 t\u00e4h\u00e4n 1h. Tuntien lis\u00e4\u00e4minen luo toisen tilauksen, joka pit\u00e4\u00e4 hyv\u00e4ksy\u00e4 normaalisti.",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0411\u0443\u0434\u044c \u043b\u0430\u0441\u043a\u0430, \u0432\u0432\u0435\u0434\u0456\u0442\u044c \u0442\u0456\u043b\u044c\u043a\u0438 \u0434\u043e\u0434\u0430\u0442\u043a\u043e\u0432\u0456 \u0433\u043e\u0434\u0438\u043d\u0438. \u041d\u0430\u043f\u0440\u0438\u043a\u043b\u0430\u0434, \u044f\u043a\u0449\u043e \u043f\u043e\u0447\u0430\u0442\u043a\u043e\u0432\u0435 \u0437\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f \u0431\u0443\u043b\u043e \u043d\u0430 2 \u0433\u043e\u0434\u0438\u043d\u0438, \u0430\u043b\u0435 \u0432 \u0446\u0456\u043b\u043e\u043c\u0443 \u0437\u0430\u0439\u043d\u044f\u043b\u043e 3 \u0433\u043e\u0434\u0438\u043d\u0438, \u0432\u0432\u0435\u0434\u0456\u0442\u044c \u0442\u0443\u0442 1 \u0433\u043e\u0434\u0438\u043d\u0443. \u0414\u043e\u0434\u0430\u0432\u0430\u043d\u043d\u044f \u0433\u043e\u0434\u0438\u043d \u0441\u0442\u0432\u043e\u0440\u044e\u0454 \u043d\u043e\u0432\u0435 \u0437\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f, \u044f\u043a\u0435 \u043d\u0435\u043e\u0431\u0445\u0456\u0434\u043d\u043e \u0437\u0430\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438 \u0443 \u0437\u0432\u0438\u0447\u0430\u0439\u043d\u043e\u043c\u0443 \u043f\u043e\u0440\u044f\u0434\u043a\u0443"
  },
  "tooltips_additional_days": {
    "sheet_name": "Web",
    "en": "Please enter only the additional days. For example, if original order was 2 days but it took 3 in total, enter 1 day here. Adding days creates new order which needs to be approved normally.",
    "ru": "",
    "fi": "Sy\u00f6t\u00e4 vain lis\u00e4p\u00e4iv\u00e4t. Esim. jos alkuper\u00e4inen tilaus oli 2 p\u00e4iv\u00e4\u00e4, mutta keikka kestikin yhteens\u00e4 3, sy\u00f6t\u00e4 t\u00e4h\u00e4n 1 p\u00e4iv\u00e4. P\u00e4ivien lis\u00e4\u00e4minen luo toisen tilauksen, joka pit\u00e4\u00e4 hyv\u00e4ksy\u00e4 normaalisti.",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0411\u0443\u0434\u044c \u043b\u0430\u0441\u043a\u0430, \u0432\u043a\u0430\u0436\u0456\u0442\u044c \u0442\u0456\u043b\u044c\u043a\u0438 \u0434\u043e\u0434\u0430\u0442\u043a\u043e\u0432\u0456 \u0434\u043d\u0456. \u041d\u0430\u043f\u0440\u0438\u043a\u043b\u0430\u0434, \u044f\u043a\u0449\u043e \u043f\u043e\u0447\u0430\u0442\u043a\u043e\u0432\u0435 \u0437\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f \u0431\u0443\u043b\u043e \u043d\u0430 2 \u0434\u043d\u0456, \u0430\u043b\u0435 \u0432 \u0446\u0456\u043b\u043e\u043c\u0443 \u0437\u0430\u0439\u043d\u044f\u043b\u043e 3 \u0434\u043d\u0456, \u0432\u0432\u0435\u0434\u0456\u0442\u044c \u0442\u0443\u0442 1 \u0434\u0435\u043d\u044c. \u0414\u043e\u0434\u0430\u0432\u0430\u043d\u043d\u044f \u0434\u043d\u0456\u0432 \u0441\u0442\u0432\u043e\u0440\u044e\u0454 \u043d\u043e\u0432\u0435 \u0437\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f, \u044f\u043a\u0435 \u043c\u0430\u0454 \u0431\u0443\u0442\u0438 \u0437\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043d\u043e \u0443 \u0437\u0432\u0438\u0447\u0430\u0439\u043d\u043e\u043c\u0443 \u043f\u043e\u0440\u044f\u0434\u043a\u0443"
  },
  "tooltips_additional_month": {
    "sheet_name": "Web",
    "en": "Please enter only the additional months. For example, if original order was 2 motnhs but it took 3 in total, enter 1 month here. Adding months creates new order which needs to be approved normally.",
    "ru": "",
    "fi": "Sy\u00f6t\u00e4 vain lis\u00e4kuukaudet. Esim. jos alkuper\u00e4inen tilaus oli 2 kk, mutta keikka kestikin yhteens\u00e4 3 kk, sy\u00f6t\u00e4 t\u00e4h\u00e4n 1 kk. Kuukausien lis\u00e4\u00e4minen luo toisen tilauksen, joka pit\u00e4\u00e4 hyv\u00e4ksy\u00e4 normaalisti.",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0411\u0443\u0434\u044c \u043b\u0430\u0441\u043a\u0430, \u0432\u0432\u0435\u0434\u0456\u0442\u044c \u0442\u0456\u043b\u044c\u043a\u0438 \u0434\u043e\u0434\u0430\u0442\u043a\u043e\u0432\u0456 \u043c\u0456\u0441\u044f\u0446\u0456. \u041d\u0430\u043f\u0440\u0438\u043a\u043b\u0430\u0434, \u044f\u043a\u0449\u043e \u043f\u043e\u0447\u0430\u0442\u043a\u043e\u0432\u0435 \u0437\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f \u0431\u0443\u043b\u043e \u043d\u0430 2 \u043c\u0456\u0441\u044f\u0446\u0456, \u0430\u043b\u0435 \u0432 \u0446\u0456\u043b\u043e\u043c\u0443 \u0437\u0430\u0439\u043d\u044f\u043b\u043e 3 \u043c\u0456\u0441\u044f\u0446\u0456, \u0432\u0432\u0435\u0434\u0456\u0442\u044c \u0442\u0443\u0442 1 \u043c\u0456\u0441\u044f\u0446\u044c. \u0414\u043e\u0434\u0430\u0432\u0430\u043d\u043d\u044f \u043c\u0456\u0441\u044f\u0446\u0456\u0432 \u0441\u0442\u0432\u043e\u0440\u044e\u0454 \u043d\u043e\u0432\u0438\u0439 \u043d\u0430\u043a\u0430\u0437, \u044f\u043a\u0438\u0439 \u043c\u0430\u0454 \u0431\u0443\u0442\u0438 \u0437\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043d\u0438\u0439 \u0443 \u0437\u0432\u0438\u0447\u0430\u0439\u043d\u043e\u043c\u0443 \u043f\u043e\u0440\u044f\u0434\u043a\u0443"
  },
  "tooltips_additional_units": {
    "sheet_name": "Web",
    "en": "Please enter only the additional units. For example, if original order was 2 units but it took 3 in total, enter 1 unit here. Adding units creates new order which needs to be approved normally.",
    "ru": "",
    "fi": "Sy\u00f6t\u00e4 vain lis\u00e4kappaleet. Esim. jos alkuper\u00e4inen tilaus oli 2 kpl, mutta keikka kestikin 3 kpl, sy\u00f6t\u00e4 t\u00e4h\u00e4n 1 kpl. Kappaleiden lis\u00e4\u00e4minen luo toisen tilauksen, joka pit\u00e4\u00e4 hyv\u00e4ksy\u00e4 normaalisti.",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0411\u0443\u0434\u044c \u043b\u0430\u0441\u043a\u0430, \u0432\u0432\u0435\u0434\u0456\u0442\u044c \u0442\u0456\u043b\u044c\u043a\u0438 \u0434\u043e\u0434\u0430\u0442\u043a\u043e\u0432\u0456 \u043e\u0434\u0438\u043d\u0438\u0446\u0456. \u041d\u0430\u043f\u0440\u0438\u043a\u043b\u0430\u0434, \u044f\u043a\u0449\u043e \u043f\u043e\u0447\u0430\u0442\u043a\u043e\u0432\u0435 \u0437\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f \u0431\u0443\u043b\u043e \u043d\u0430 2 \u043e\u0434\u0438\u043d\u0438\u0446\u0456, \u0430 \u0432\u0441\u044c\u043e\u0433\u043e \u0437\u043d\u0430\u0434\u043e\u0431\u0438\u043b\u043e\u0441\u044f 3, \u0432\u0432\u0435\u0434\u0456\u0442\u044c \u0442\u0443\u0442 1 \u043e\u0434\u0438\u043d\u0438\u0446\u044e. \u0414\u043e\u0434\u0430\u0432\u0430\u043d\u043d\u044f \u043e\u0434\u0438\u043d\u0438\u0446\u044c \u0441\u0442\u0432\u043e\u0440\u044e\u0454 \u043d\u043e\u0432\u0435 \u0437\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f, \u044f\u043a\u0435 \u043c\u0430\u0454 \u0431\u0443\u0442\u0438 \u0437\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043d\u043e \u0443 \u0437\u0432\u0438\u0447\u0430\u0439\u043d\u043e\u043c\u0443 \u043f\u043e\u0440\u044f\u0434\u043a\u0443"
  },
  "tooltips_additional_price": {
    "sheet_name": "Web",
    "en": "Please enter only the aditional price. Adding price creates new order which needs to be approved normally.",
    "ru": "",
    "fi": "Sy\u00f6t\u00e4 vain lis\u00e4hinta. Hinnan lis\u00e4\u00e4minen luo toisen tilauksen, joka pit\u00e4\u00e4 hyv\u00e4ksy\u00e4 normaalisti.",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0411\u0443\u0434\u044c \u043b\u0430\u0441\u043a\u0430, \u0432\u0432\u0435\u0434\u0456\u0442\u044c \u0442\u0456\u043b\u044c\u043a\u0438 \u0434\u043e\u0434\u0430\u0442\u043a\u043e\u0432\u0443 \u0446\u0456\u043d\u0443. \u0414\u043e\u0434\u0430\u0432\u0430\u043d\u043d\u044f \u0446\u0456\u043d\u0438 \u0441\u0442\u0432\u043e\u0440\u044e\u0454 \u043d\u043e\u0432\u0435 \u0437\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f, \u044f\u043a\u0435 \u043d\u0435\u043e\u0431\u0445\u0456\u0434\u043d\u043e \u0437\u0430\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438 \u0443 \u0437\u0432\u0438\u0447\u0430\u0439\u043d\u043e\u043c\u0443 \u043f\u043e\u0440\u044f\u0434\u043a\u0443"
  },
  "tooltips_settings_language": {
    "sheet_name": "Web",
    "en": "This is the language in which you use the service.",
    "ru": "",
    "fi": "T\u00e4m\u00e4 on kieli, jolla k\u00e4yt\u00e4t palvelua.",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0426\u0435 \u043c\u043e\u0432\u0430, \u044f\u043a\u043e\u044e \u0432\u0438 \u043a\u043e\u0440\u0438\u0441\u0442\u0443\u0454\u0442\u0435\u0441\u044f"
  },
  "tooltips_settings_org_type": {
    "sheet_name": "Web",
    "en": "Please choose the most suitable organization type. Unless you are a private person, add also organization ID and name.",
    "ru": "",
    "fi": "Valitse sopivin organisaatiotyyppi. Jos et ole yksityishenkil\u00f6 niin lis\u00e4\u00e4th\u00e4n my\u00f6s Y-tunnuksen ja organisaation nimen.",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0411\u0443\u0434\u044c \u043b\u0430\u0441\u043a\u0430, \u0432\u0438\u0431\u0435\u0440\u0456\u0442\u044c \u043d\u0430\u0439\u0431\u0456\u043b\u044c\u0448 \u043f\u0456\u0434\u0445\u043e\u0434\u044f\u0449\u0438\u0439 \u0442\u0438\u043f \u043e\u0440\u0433\u0430\u043d\u0456\u0437\u0430\u0446\u0456\u0457. \u042f\u043a\u0449\u043e \u0432\u0438 \u043d\u0435 \u0454 \u043f\u0440\u0438\u0432\u0430\u0442\u043d\u043e\u044e \u043e\u0441\u043e\u0431\u043e\u044e, \u0434\u043e\u0434\u0430\u0439\u0442\u0435 \u0442\u0430\u043a\u043e\u0436 \u0456\u0434\u0435\u043d\u0442\u0438\u0444\u0456\u043a\u0430\u0442\u043e\u0440 \u043e\u0440\u0433\u0430\u043d\u0456\u0437\u0430\u0446\u0456\u0457 \u0442\u0430 \u0456\u043c'\u044f"
  },
  "tooltips_settings_orderer_desc": {
    "sheet_name": "Web",
    "en": "Description is part of your profile which is visible to workers when you publish orders.",
    "ru": "",
    "fi": "Kuvaus on osa profiiliasi, joka n\u00e4kyy palvelun tekij\u00f6ille silloin kun julkaiset tilauksia.",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u041e\u043f\u0438\u0441 \u0454 \u0447\u0430\u0441\u0442\u0438\u043d\u043e\u044e \u0432\u0430\u0448\u043e\u0433\u043e \u043f\u0440\u043e\u0444\u0456\u043b\u044e, \u044f\u043a\u0443 \u0431\u0430\u0447\u0430\u0442\u044c \u043f\u0440\u0430\u0446\u0456\u0432\u043d\u0438\u043a\u0438, \u043a\u043e\u043b\u0438 \u0432\u0438 \u043f\u0443\u0431\u043b\u0456\u043a\u0443\u0454\u0442\u0435 \u0437\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f"
  },
  "tooltips_settings_worker_type": {
    "sheet_name": "Web",
    "en": "Please choose the most suitable worker type. If it's \"company\" or \"other\", add also organization ID and name.",
    "ru": "",
    "fi": "Valitse toimeksiantosopimus henkil\u00f6kohtaiseen ansiotuloon. Jos sinulla on oma yritys tai toimit jonkin organisaation ty\u00f6ntekij\u00e4n\u00e4 lis\u00e4\u00e4 my\u00f6s Y-tunnus ja organisaation nimi.",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0411\u0443\u0434\u044c \u043b\u0430\u0441\u043a\u0430, \u043e\u0431\u0435\u0440\u0456\u0442\u044c  \u0442\u0438\u043f \u043f\u0440\u0430\u0446\u0456\u0432\u043d\u0438\u043a\u0430, \u044f\u043a\u0438\u0439 \u0432\u0430\u043c \u043f\u043e\u0442\u0440\u0456\u0431\u043d\u043e. \u042f\u043a\u0449\u043e \u0446\u0435 \"\u043a\u043e\u043c\u043f\u0430\u043d\u0456\u044f\" \u0430\u0431\u043e \"\u0456\u043d\u0448\u0435\", \u0434\u043e\u0434\u0430\u0439\u0442\u0435 \u0442\u0430\u043a\u043e\u0436 \u0456\u0434\u0435\u043d\u0442\u0438\u0444\u0456\u043a\u0430\u0442\u043e\u0440 \u0442\u0430 \u043d\u0430\u0437\u0432\u0443 \u043e\u0440\u0433\u0430\u043d\u0456\u0437\u0430\u0446\u0456\u0457"
  },
  "tooltips_settings_worker_desc": {
    "sheet_name": "Web",
    "en": "Description is part of your profile which shows to orderers if you apply to their orders.",
    "ru": "",
    "fi": "Kuvaus on osa profiiliasi, joka n\u00e4kyy tilaajille, jos haet heid\u00e4n tilauksiin.",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u041e\u043f\u0438\u0441 - \u0446\u0435 \u0447\u0430\u0441\u0442\u0438\u043d\u0430 \u0432\u0430\u0448\u043e\u0433\u043e \u043f\u0440\u043e\u0444\u0456\u043b\u044e, \u044f\u043a\u0430 \u043f\u043e\u043a\u0430\u0437\u0443\u0454\u0442\u044c\u0441\u044f \u0437\u0430\u043c\u043e\u0432\u043d\u0438\u043a\u0430\u043c, \u044f\u043a\u0449\u043e \u0432\u0438 \u043f\u0440\u0435\u0442\u0435\u043d\u0434\u0443\u0454\u0442\u0435 \u043d\u0430 \u0457\u0445 \u0437\u0430\u0432\u0434\u0430\u043d\u043d\u044f"
  },
  "tooltips_settings_distance": {
    "sheet_name": "Web",
    "en": "You will see available opportunities within this distance.",
    "ru": "",
    "fi": "N\u00e4et avoimia mahdollisuuksia korkeintaan t\u00e4m\u00e4n et\u00e4isyyden p\u00e4\u00e4st\u00e4.",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0412\u0438 \u043f\u043e\u0431\u0430\u0447\u0438\u0442\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u043d\u0456 \u0437\u0430\u0432\u0434\u0430\u043d\u043d\u044f \u0432 \u043c\u0435\u0436\u0430\u0445 \u0446\u0456\u0454\u0457 \u0432\u0456\u0434\u0441\u0442\u0430\u043d\u0456"
  },
  "tooltips_new_order_total": {
    "sheet_name": "Web",
    "en": "Even if you are looking for several workers, always enter one worker's work amount here",
    "ru": "",
    "fi": "Vaikka etsisit useita tekij\u00f6it\u00e4, sy\u00f6t\u00e4 t\u00e4h\u00e4n aina yhden tekij\u00e4n ty\u00f6m\u00e4\u00e4r\u00e4.",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u041d\u0430\u0432\u0456\u0442\u044c \u044f\u043a\u0449\u043e \u0432\u0438 \u0448\u0443\u043a\u0430\u0454\u0442\u0435 \u043a\u0456\u043b\u044c\u043a\u043e\u0445 \u043f\u0440\u0430\u0446\u0456\u0432\u043d\u0438\u043a\u0456\u0432, \u0437\u0430\u0432\u0436\u0434\u0438 \u0432\u043a\u0430\u0437\u0443\u0439\u0442\u0435 \u0442\u0443\u0442 \u043e\u0431\u0441\u044f\u0433 \u0440\u043e\u0431\u043e\u0442\u0438 \u043e\u0434\u043d\u043e\u0433\u043e \u043f\u0440\u0430\u0446\u0456\u0432\u043d\u0438\u043a\u0430"
  },
  "tooltips_rewatch_new_order_tut": {
    "sheet_name": "Web",
    "en": "Re-watch new order tutorial",
    "ru": "",
    "fi": "Katso ohjeistus tilauksen tekemisest\u00e4",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0414\u0438\u0432\u0456\u0442\u044c\u0441\u044f \u0456\u043d\u0441\u0442\u0440\u0443\u043a\u0446\u0456\u044e \u0449\u043e\u0434\u043e \u043e\u0444\u043e\u0440\u043c\u043b\u0435\u043d\u043d\u044f \u0437\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f"
  },
  "zendesk_messages": {
    "sheet_name": "Web",
    "en": "Messages",
    "ru": "\u0421\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u044f",
    "fi": "Viestit",
    "sv": "Meddelande",
    "fa": "\u067e\u06cc\u0627\u0645 \u0647\u0627",
    "ar": "\u0631\u0633\u0627\u0626\u0644",
    "uk": "\u041f\u043e\u0432\u0456\u0434\u043e\u043c\u043b\u0435\u043d\u043d\u044f"
  },
  "zendesk_tasks": {
    "sheet_name": "Web",
    "en": "Tasks",
    "ru": "\u0420\u0430\u0431\u043e\u0442\u044b",
    "fi": "Teht\u00e4v\u00e4t",
    "sv": "Uppdraget",
    "fa": "\u0634\u063a\u0644 \u0647\u0627",
    "ar": "\u0627\u0644\u0645\u0647\u0627\u0645 \u0627\u0644\u0645\u0643\u062a\u0645\u0644\u0629",
    "uk": "\u0417\u0430\u0432\u0434\u0430\u043d\u043d\u044f"
  },
  "zendesk_please_enter": {
    "sheet_name": "Web",
    "en": "Please, enter message",
    "ru": "\u041f\u043e\u0436\u0430\u043b\u0443\u0439\u0441\u0442\u0430, \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u044f",
    "fi": "Kirjoita viesti",
    "sv": "V\u00e4nligen skriv ett meddelande",
    "fa": "\u0644\u0637\u0641\u0627\u064b \u067e\u06cc\u0627\u0645 \u0631\u0627 \u0648\u0627\u0631\u062f \u06a9\u0646\u06cc\u062f",
    "ar": "\u0627\u0643\u062a\u0628 \u0631\u0633\u0627\u0644\u0629",
    "uk": "\u0411\u0443\u0434\u044c \u043b\u0430\u0441\u043a\u0430, \u0432\u0432\u0435\u0434\u0456\u0442\u044c \u043f\u043e\u0432\u0456\u0434\u043e\u043c\u043b\u0435\u043d\u043d\u044f"
  },
  "zendesk_no_chats": {
    "sheet_name": "Web",
    "en": "No chats",
    "ru": "\u041d\u0438\u043a\u0430\u043a\u0438\u0445 \u0447\u0430\u0442\u043e\u0432",
    "fi": "Ei chatteja",
    "sv": "Ingen chatt",
    "fa": "\u0686\u062a \u0648\u062c\u0648\u062f \u0646\u062f\u0627\u0631\u062f",
    "ar": "\u0644\u0627 \u062f\u0631\u062f\u0634\u0627\u062a",
    "uk": "\u041d\u0435\u043c\u0430\u0454 \u0447\u0430\u0442\u0456\u0432"
  },
  "zendesk_no_messages": {
    "sheet_name": "Web",
    "en": "No messages",
    "ru": "\u041d\u0438\u043a\u0430\u043a\u0438\u0445 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0439",
    "fi": "Ei viestej\u00e4",
    "sv": "Inget meddelande",
    "fa": "\u067e\u06cc\u0627\u0645 \u0648\u062c\u0648\u062f \u0646\u062f\u0627\u0631\u062f",
    "ar": "\u0644\u0627 \u0631\u0633\u0627\u0626\u0644",
    "uk": "\u041d\u0435\u043c\u0430\u0454 \u043f\u043e\u0432\u0456\u0434\u043e\u043c\u043b\u0435\u043d\u044c"
  },
  "worker_map_security": {
    "sheet_name": "Web",
    "en": "For security reasons, the locations of users on this map are only approximate.",
    "ru": "",
    "fi": "Turvallisuussyist\u00e4 k\u00e4ytt\u00e4jien sijainnit kartalla eiv\u00e4t ole tarkkoja.",
    "sv": "Av s\u00e4kerhetssk\u00e4l \u00e4r anv\u00e4ndarnas platser p\u00e5 den h\u00e4r kartan endast ungef\u00e4rliga.",
    "fa": "",
    "ar": "",
    "uk": "\u0417 \u043c\u0456\u0440\u043a\u0443\u0432\u0430\u043d\u044c \u0431\u0435\u0437\u043f\u0435\u043a\u0438, \u043c\u0456\u0441\u0446\u0435\u0437\u043d\u0430\u0445\u043e\u0434\u0436\u0435\u043d\u043d\u044f \u043a\u043e\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0456\u0432 \u043d\u0430 \u0446\u0456\u0439 \u043a\u0430\u0440\u0442\u0456 \u0454 \u043b\u0438\u0448\u0435 \u043f\u0440\u0438\u0431\u043b\u0438\u0437\u043d\u0438\u043c."
  },
  "txt_are_you_sure": {
    "sheet_name": "Web",
    "en": "Are you sure?",
    "ru": "\u0412\u044b \u0443\u0432\u0435\u0440\u0435\u043d\u043d\u044b",
    "fi": "Oletko varma?",
    "sv": "\u00c4r du s\u00e4ker?",
    "fa": "\u0622\u06cc\u0627 \u0634\u0645\u0627 \u0645\u0637\u0645\u0626\u0646 \u0647\u0633\u062a\u06cc\u062f\u061f",
    "ar": "\u0647\u0644 \u0627\u0646\u062a \u0645\u062a\u0623\u0643\u062f",
    "uk": "\u0412\u0438 \u0432\u043f\u0435\u0432\u043d\u0435\u043d\u0456?"
  },
  "sel_cbox_c_all": {
    "sheet_name": "Web",
    "en": "Check all",
    "ru": "\u0412\u044b\u0431\u0440\u0430\u0442\u044c \u0432\u0441\u0435",
    "fi": "Valitse kaikki",
    "sv": "Markera alla",
    "fa": "\u0627\u0646\u062a\u062e\u0627\u0628 \u0647\u0645\u0647",
    "ar": "\u062a\u062d\u0642\u0642 \u0645\u0646 \u0627\u0644\u0643\u0644",
    "uk": "\u0412\u0438\u0431\u0440\u0430\u0442\u0438 \u0432\u0441\u0435"
  },
  "sel_cbox_uc_all": {
    "sheet_name": "Web",
    "en": "Uncheck all",
    "ru": "\u0423\u0434\u0430\u043b\u0438\u0442\u044c \u0432\u0441\u0435",
    "fi": "Poista kaikki",
    "sv": "Avbocka alla",
    "fa": "\u062d\u0630\u0641 \u0647\u0645\u0647",
    "ar": "\u0627\u0644\u063a\u0627\u0621\u0627\u0644\u0643\u0644",
    "uk": "\u0412\u0438\u0434\u0430\u043b\u0438\u0442\u0438 \u0432\u0441\u0435"
  },
  "label_warning": {
    "sheet_name": "Web",
    "en": "Warning",
    "ru": "",
    "fi": "Varoitus",
    "sv": "Varning",
    "fa": "",
    "ar": "",
    "uk": "\u0423\u0432\u0430\u043d\u0430!"
  },
  "label_continue": {
    "sheet_name": "Web",
    "en": "Continue",
    "ru": "",
    "fi": "Jatka",
    "sv": "Forts\u00e4tt",
    "fa": "",
    "ar": "",
    "uk": "\u041f\u0440\u043e\u0434\u043e\u0432\u0436\u0438\u0442\u0438"
  },
  "label_are_you_sure": {
    "sheet_name": "Web",
    "en": "Do you really want to delete your account? This action can not be undone.",
    "ru": "",
    "fi": "Oletko varma ett\u00e4 haluat poistaa koko tilisi? Poistamisen j\u00e4lkeen tili\u00e4 ei voi palauttaa.",
    "sv": "\u00c4r du s\u00e4ker p\u00e5 att du vill radera ditt konto? V\u00e4ljer du att radera g\u00e5r det ej att \u00e5ngra!",
    "fa": "",
    "ar": "",
    "uk": "\u0412\u0438 \u0434\u0456\u0439\u0441\u043d\u043e \u0445\u043e\u0447\u0435\u0442\u0435 \u0432\u0438\u0434\u0430\u043b\u0438\u0442\u0438 \u0441\u0432\u0456\u0439 \u043e\u0431\u043b\u0456\u043a\u043e\u0432\u0438\u0439 \u0437\u0430\u043f\u0438\u0441? \u0426\u044e \u0434\u0456\u044e \u043d\u0435 \u043c\u043e\u0436\u043d\u0430 \u0441\u043a\u0430\u0441\u0443\u0432\u0430\u0442\u0438."
  },
  "button_back_to_chat_list": {
    "sheet_name": "Web",
    "en": "Back to chat list",
    "ru": "",
    "fi": "Takaisin chat listaukseen",
    "sv": "Tillbaka till chat listan",
    "fa": "",
    "ar": "",
    "uk": "\u041f\u043e\u0432\u0435\u0440\u043d\u0443\u0442\u0438\u0441\u044f \u0434\u043e \u0441\u043f\u0438\u0441\u043a\u0443 \u0447\u0430\u0442\u0443"
  },
  "button_go_to_order": {
    "sheet_name": "Web",
    "en": "Go to order",
    "ru": "",
    "fi": "Palaa tilaukseen",
    "sv": "Tillbaka till uppgiften",
    "fa": "",
    "ar": "",
    "uk": "\u041f\u0435\u0440\u0435\u0439\u0442\u0438 \u0434\u043e \u0437\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u044c"
  },
  "button_back_to_chat": {
    "sheet_name": "Web",
    "en": "Back to chat",
    "ru": "",
    "fi": "Takaisin chat",
    "sv": "Tillbaka till chat",
    "fa": "",
    "ar": "",
    "uk": "\u041d\u0430\u0437\u0430\u0434 \u0434\u043e \u0447\u0430\u0442\u0456\u0432"
  },
  "button_back_to_orders": {
    "sheet_name": "Web",
    "en": "Back to orders",
    "ru": "",
    "fi": "Takaisin tilauksiin",
    "sv": "Tillbaka till uppgiften listan",
    "fa": "",
    "ar": "",
    "uk": "\u041f\u043e\u0432\u0435\u0440\u043d\u0443\u0442\u0438\u0441\u044f \u0434\u043e \u0437\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u044c"
  },
  "button_back_to_payment_and_reports": {
    "sheet_name": "Web",
    "en": "Back to Payments and reports",
    "ru": "",
    "fi": "Takaisin Maksut & raportit -sivulle",
    "sv": "Tillbaka till Betalningar & rapporter",
    "fa": "",
    "ar": "",
    "uk": "\u041f\u043e\u0432\u0435\u0440\u043d\u0443\u0442\u0438\u0441\u044f \u043d\u0430 \u0441\u0442\u043e\u0440\u0456\u043d\u043a\u0443 \u043f\u043b\u0430\u0442\u0435\u0436\u0456\u0432 \u0442\u0430 \u0437\u0432\u0456\u0442\u0456\u0432"
  },
  "dialog_title_unknown_error": {
    "sheet_name": "Web",
    "en": "Please note!",
    "ru": "\u041e\u0431\u0440\u0430\u0442\u0438\u0442\u0435 \u0432\u043d\u0438\u043c\u0430\u043d\u0438\u0435",
    "fi": "Huomio!",
    "sv": "OBS!",
    "fa": "\u062a\u0648\u062c\u0647",
    "ar": "\u064a\u0631\u062c\u0649 \u0627\u0644\u0645\u0644\u0627\u062d\u0638\u0629!",
    "uk": "\u0417\u0432\u0435\u0440\u043d\u0456\u0442\u044c \u0443\u0432\u0430\u0433\u0443!"
  },
  "applicant_age_range": {
    "sheet_name": "Web",
    "en": "Age range",
    "ru": "",
    "fi": "Ik\u00e4haarukka",
    "sv": "\u00c5ldersintervall",
    "fa": "",
    "ar": "",
    "uk": "\u0412\u0456\u043a\u043e\u0432\u0438\u0439 \u0434\u0456\u0430\u043f\u0430\u0437\u043e\u043d"
  },
  "product_worker_type": {
    "sheet_name": "Web",
    "en": "Contract model",
    "ru": "",
    "fi": "Sopimusmalli",
    "sv": "Avtalsmodell",
    "fa": "",
    "ar": "",
    "uk": "\u0428\u0430\u0431\u043b\u043e\u043d \u0434\u043e\u0433\u043e\u0432\u043e\u0440\u0443"
  },
  "required_label": {
    "sheet_name": "Web",
    "en": "Required",
    "ru": "",
    "fi": "Pakollinen",
    "sv": "Obligatorisk",
    "fa": "",
    "ar": "",
    "uk": "\u041e\u0431\u043e\u0432'\u044f\u0437\u043a\u043e\u0432\u043e"
  },
  "different_timezone_error": {
    "sheet_name": "Web",
    "en": "You are not in the same timezone as merchant, please check your local time settings!",
    "ru": "",
    "fi": "Et ole samalla aikavy\u00f6hykkeell\u00e4 palvelun kanssa, ole hyv\u00e4 ja tarkista paikallinen aikavy\u00f6hykkseesi",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0412\u0438 \u043f\u0435\u0440\u0435\u0431\u0443\u0432\u0430\u0454\u0442\u0435 \u0432 \u0456\u043d\u0448\u043e\u043c\u0443 \u0447\u0430\u0441\u043e\u0432\u043e\u043c\u0443 \u043f\u043e\u044f\u0441\u0456, \u043d\u0456\u0436 \u043f\u0440\u043e\u0434\u0430\u0432\u0435\u0446\u044c, \u0431\u0443\u0434\u044c \u043b\u0430\u0441\u043a\u0430, \u043f\u0435\u0440\u0435\u0432\u0456\u0440\u0442\u0435 \u0432\u0430\u0448\u0456 \u043c\u0456\u0441\u0446\u0435\u0432\u0456 \u043d\u0430\u043b\u0430\u0448\u0442\u0443\u0432\u0430\u043d\u043d\u044f \u0447\u0430\u0441\u0443!"
  },
  "calendar_days": {
    "sheet_name": "Web",
    "en": "M, T, W, T, F, S, S",
    "ru": "",
    "fi": "M, T, K, T, P, L, S",
    "sv": "M, T, O, T, F, L, S",
    "fa": "",
    "ar": "",
    "uk": "\u041f\u043d, \u0412\u0442, \u0421\u0440, \u0427\u0442, \u041f\u0442, \u0421\u0431, \u041d\u0434"
  },
  "add_hours": {
    "sheet_name": "Web",
    "en": "Add hours",
    "ru": "",
    "fi": "Lis\u00e4\u00e4 tunteja",
    "sv": "L\u00e4gg till timmar",
    "fa": "",
    "ar": "",
    "uk": "\u0414\u043e\u0434\u0430\u0442\u0438 \u0433\u043e\u0434\u0438\u043d\u0438"
  },
  "add_days": {
    "sheet_name": "Web",
    "en": "Add days",
    "ru": "",
    "fi": "Lis\u00e4\u00e4 p\u00e4ivi\u00e4",
    "sv": "L\u00e4gg till dagar",
    "fa": "",
    "ar": "",
    "uk": "\u0414\u043e\u0434\u0430\u0442\u0438 \u0434\u043d\u0456"
  },
  "add_months": {
    "sheet_name": "Web",
    "en": "Add months",
    "ru": "",
    "fi": "Lis\u00e4\u00e4 kuukausia",
    "sv": "L\u00e4gg till m\u00e5nader",
    "fa": "",
    "ar": "",
    "uk": "\u0414\u043e\u0434\u0430\u0442\u0438 \u043c\u0456\u0441\u044f\u0446\u0456"
  },
  "add_units": {
    "sheet_name": "Web",
    "en": "Add units",
    "ru": "",
    "fi": "Lis\u00e4\u00e4 kappaleita",
    "sv": "L\u00e4gg till enheter",
    "fa": "",
    "ar": "",
    "uk": "\u0414\u043e\u0434\u0430\u0442\u0438 \u043e\u0434\u0438\u043d\u0438\u0446\u0456"
  },
  "add_price": {
    "sheet_name": "Web",
    "en": "Add price",
    "ru": "",
    "fi": "Lis\u00e4\u00e4 hintaa",
    "sv": "L\u00e4gg till pris",
    "fa": "",
    "ar": "",
    "uk": "\u0414\u043e\u0434\u0430\u0442\u0443 \u0446\u0456\u043d\u0443"
  },
  "payment_and_reports": {
    "sheet_name": "Web",
    "en": "Payments & reports",
    "ru": "",
    "fi": "Maksut & raportit",
    "sv": "Betalningar & rapporter",
    "fa": "",
    "ar": "",
    "uk": "\u041f\u043b\u0430\u0442\u0435\u0436\u0456 \u0442\u0430 \u0437\u0432\u0456\u0442\u0438"
  },
  "create_order_task_price_fixed": {
    "sheet_name": "Web",
    "en": "%s",
    "ru": "%s",
    "fi": "%s",
    "sv": "%s",
    "fa": "%s",
    "ar": "%s",
    "uk": "%s"
  },
  "create_order_task_price_hour": {
    "sheet_name": "Web",
    "en": "%s \/ hour",
    "ru": "%s \/ \u0447\u0430\u0441",
    "fi": "%s \/ tunti",
    "sv": "%s \/ timme",
    "fa": "\u0633\u0627\u0639\u062a: %s",
    "ar": "%s \/ \u0633\u0627\u0639\u0629",
    "uk": "%s \u0433\u043e\u0434\u0438\u043d\u0438"
  },
  "create_order_task_price_day": {
    "sheet_name": "Web",
    "en": "%s \/ day",
    "ru": "%s \/ \u0434\u0435\u043d\u044c",
    "fi": "%s \/ p\u00e4iv\u00e4",
    "sv": "%s \/ dag",
    "fa": "\u0631\u0648\u0632 : %s",
    "ar": "%s \/ \u064a\u0648\u0645",
    "uk": "%s \u0434\u043d\u044f"
  },
  "create_order_task_price_month": {
    "sheet_name": "Web",
    "en": "%s \/ month",
    "ru": "",
    "fi": "%s \/ kk",
    "sv": "%s \/ m\u00e5n",
    "fa": "",
    "ar": "",
    "uk": "%s \u043c\u0456\u0441\u044f\u0446\u044f"
  },
  "create_order_task_price_unit": {
    "sheet_name": "Web",
    "en": "%s \/ unit",
    "ru": "%s \/ \u0435\u0434\u0438\u043d\u0438\u0446\u044b",
    "fi": "%s \/ kpl",
    "sv": "%s \/ enhet",
    "fa": "\u062a\u0639\u062f\u0627\u062f : %s",
    "ar": "%s \/ \u0627\u0644\u0648\u062d\u062f\u0629",
    "uk": "%s \u043e\u0434\u0438\u043d\u0438\u0446\u0456"
  },
  "label_hours": {
    "sheet_name": "Web",
    "en": "Hours",
    "ru": "\u0427\u0430\u0441\u044b",
    "fi": "Tuntia",
    "sv": "Timmar",
    "fa": "\u0633\u0627\u0639\u062a \u0647\u0627",
    "ar": "\u0633\u0627\u0639\u0627\u062a",
    "uk": "\u0413\u043e\u0434\u0438\u043d\u0438"
  },
  "label_days": {
    "sheet_name": "Web",
    "en": "Days",
    "ru": "",
    "fi": "P\u00e4iv\u00e4\u00e4",
    "sv": "Dagar",
    "fa": "",
    "ar": "",
    "uk": "\u0414\u043d\u0456"
  },
  "label_months": {
    "sheet_name": "Web",
    "en": "Months",
    "ru": "\u043c\u0435\u0441\u044f\u0446",
    "fi": "Kk",
    "sv": "M\u00e5nader",
    "fa": "",
    "ar": "",
    "uk": "\u041c\u0456\u0441\u044f\u0446\u0456"
  },
  "label_units": {
    "sheet_name": "Web",
    "en": "Units",
    "ru": "",
    "fi": "Kpl",
    "sv": "Enheter",
    "fa": "",
    "ar": "",
    "uk": "\u041e\u0434\u0438\u043d\u0438\u0446\u0456"
  },
  "label_price": {
    "sheet_name": "Web",
    "en": "Price",
    "ru": "\u0426\u0435\u043d\u0430",
    "fi": "Hinta",
    "sv": "Pris",
    "fa": "\u0646\u0631\u062e",
    "ar": "\u0627\u0644\u0633\u0639\u0631",
    "uk": "\u0426\u0456\u043d\u0430"
  },
  "websocket_error_can_not_connect": {
    "sheet_name": "Web",
    "en": "Connection to payment provider failed, please try again later",
    "ru": "",
    "fi": "Yhteyden muodostaminen maksupalveluntarjoajaan ep\u00e4onnistui, yrit\u00e4 my\u00f6hemmin uudelleen",
    "sv": "Anslutningen till betalningsleverant\u00f6ren misslyckades, f\u00f6rs\u00f6k igen senare",
    "fa": "",
    "ar": "",
    "uk": "\u041d\u0435 \u0432\u0434\u0430\u043b\u043e\u0441\u044f \u0437'\u0454\u0434\u043d\u0430\u0442\u0438\u0441\u044f \u0437 \u0431\u0430\u043d\u043a\u043e\u043c, \u0441\u043f\u0440\u043e\u0431\u0443\u0439\u0442\u0435, \u0431\u0443\u0434\u044c \u043b\u0430\u0441\u043a\u0430, \u043f\u0456\u0437\u043d\u0456\u0448\u0435"
  },
  "unsupported_browser_message": {
    "sheet_name": "Web",
    "en": "You are using an unsupported browser and things might not work as intended. Please make sure you're using the latest version of Chrome or Firefox.",
    "ru": "",
    "fi": "K\u00e4yt\u00e4t selainta, jota ei tueta, ja siksi kaikki ei v\u00e4ltt\u00e4m\u00e4tt\u00e4 toimi toivotulla tavalla. Varmistathan, ett\u00e4 k\u00e4yt\u00e4t Chromen tai Firefoxin uusinta versiota.",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0412\u0438 \u0432\u0438\u043a\u043e\u0440\u0438\u0441\u0442\u043e\u0432\u0443\u0454\u0442\u0435 \u043d\u0435\u043f\u0456\u0434\u0442\u0440\u0438\u043c\u0443\u0432\u0430\u043d\u0438\u0439 \u0431\u0440\u0430\u0443\u0437\u0435\u0440, \u0456 \u0434\u0435\u044f\u043a\u0456 \u0444\u0443\u043d\u043a\u0446\u0456\u0457 \u043c\u043e\u0436\u0443\u0442\u044c \u043d\u0435 \u043f\u0440\u0430\u0446\u044e\u0432\u0430\u0442\u0438 \u043d\u0430\u043b\u0435\u0436\u043d\u0438\u043c \u0447\u0438\u043d\u043e\u043c. \u0411\u0443\u0434\u044c \u043b\u0430\u0441\u043a\u0430, \u043f\u0435\u0440\u0435\u043a\u043e\u043d\u0430\u0439\u0442\u0435\u0441\u044f, \u0449\u043e \u0432\u0438 \u0432\u0438\u043a\u043e\u0440\u0438\u0441\u0442\u043e\u0432\u0443\u0454\u0442\u0435 \u043e\u0441\u0442\u0430\u043d\u043d\u044e \u0432\u0435\u0440\u0441\u0456\u044e Chrome \u0430\u0431\u043e Firefox"
  },
  "input_field_max_char_error": {
    "sheet_name": "Web",
    "en": "You have reached maximum characters in this field!",
    "ru": "",
    "fi": "T\u00e4h\u00e4n kentt\u00e4\u00e4n ei voi kirjoittaa enemp\u00e4\u00e4 merkkej\u00e4!",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0412\u0438 \u0434\u043e\u0441\u044f\u0433\u043b\u0438 \u043c\u0430\u043a\u0441\u0438\u043c\u0430\u043b\u044c\u043d\u043e\u0457 \u043a\u0456\u043b\u044c\u043a\u043e\u0441\u0442\u0456 \u0441\u0438\u043c\u0432\u043e\u043b\u0456\u0432 \u0443 \u0446\u044c\u043e\u043c\u0443 \u043f\u043e\u043b\u0456!"
  },
  "register_private_service_about_to": {
    "sheet_name": "Web",
    "en": "You are about to register to the following service",
    "ru": "",
    "fi": "Olet rekister\u00f6itym\u00e4ss\u00e4 seuraavaan palveluun:",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0412\u0438 \u0440\u0435\u0454\u0441\u0442\u0440\u0443\u0454\u0442\u0435\u0441\u044f \u043d\u0430 \u043d\u0430\u0441\u0442\u0443\u043f\u043d\u0443 \u043f\u043e\u0441\u043b\u0443\u0433\u0443:"
  },
  "label_over_18": {
    "sheet_name": "Web",
    "en": "Over 18",
    "ru": "",
    "fi": "Yli 18",
    "sv": "\u00d6ver 18",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "order_status_worker_selected": {
    "sheet_name": "Web",
    "en": "You've selected the worker. Please wait worker to claim it as completed.",
    "ru": "\u0412\u044b \u0432\u044b\u0431\u0440\u0430\u043b\u0438 \u044d\u0442\u043e\u0433\u043e \u0440\u0430\u0431\u043e\u0442\u043d\u0438\u043a\u0430 (\u043e\u0436\u0438\u0434\u0430\u043d\u0438\u0435 \u0432\u044b\u043f\u043e\u043b\u043d\u0435\u043d\u0438\u044f)",
    "fi": "Olet valinnut tekij\u00e4n. Odota ett\u00e4 tekij\u00e4 kuittaa suorituksen valmiiksi.",
    "sv": "Du har valt utf\u00f6rare. V\u00e4nta p\u00e5 att utf\u00f6raren markerar uppgiften som slutf\u00f6rd.",
    "fa": "\u0634\u0645\u0627 \u06a9\u0627\u0631\u06af\u0631 \u0631\u0627 \u0627\u0646\u062a\u062e\u0627\u0628 \u06a9\u0631\u062f\u0647 \u0627\u06cc\u062f \u060c (\u0645\u0646\u062a\u0638\u0631 \u062a\u062d\u0648\u06cc\u0644)",
    "ar": "\u0644\u0642\u062f \u0625\u062e\u062a\u0631\u062a \u0627\u0644\u0639\u0627\u0645\u0644 (\u0641\u064a \u0625\u0646\u062a\u0638\u0627\u0631 \u0627\u0644\u062a\u0633\u0644\u064a\u0645)",
    "uk": "\u0412\u0438 \u043e\u0431\u0440\u0430\u043b\u0438 \u0446\u044c\u043e\u0433\u043e \u043f\u0440\u0430\u0446\u0456\u0432\u043d\u0438\u043a\u0430 (\u043e\u0447\u0456\u043a\u0443\u0432\u0430\u043d\u043d\u044f \u0432\u0438\u043a\u043e\u043d\u0430\u043d\u043d\u044f)"
  },
  "order_status_received_task": {
    "sheet_name": "Web",
    "en": "Congratulations! You are selected. Claim as completed after delivery.",
    "ru": "\u042d\u0442\u0430 \u0440\u0430\u0431\u043e\u0442\u0430 \u0432\u0430\u0448\u0430! \u041f\u043e\u0437\u0434\u0440\u0430\u0432\u043b\u044f\u0435\u043c \u0412\u0430\u0441! \u041e\u0436\u0438\u0434\u0430\u043d\u0438\u0435 \u0432\u044b\u043f\u043e\u043b\u043d\u0435\u043d\u0438\u044f \u0440\u0430\u0431\u043e\u0442\u044b.",
    "fi": "Onnea! Sinut on valittu. Kuittaa valmistuneeksi suorituksen j\u00e4lkeen.",
    "sv": "Grattis! Du har f\u00e5tt uppdraget. Markera slutf\u00f6rt efter avslutad.",
    "fa": "\u0645\u0628\u0627\u0631\u06a9 \u062a\u0627\u0646 \u0628\u0627\u062f! \u0627\u06cc\u0646 \u0634\u063a\u0644 \u0628\u0647 \u0634\u0645\u0627 \u0645\u0631\u0628\u0648\u0637 \u06ab\u0631\u0641\u062a\u0647 \u0648 \u0645\u0646\u062a\u0638\u0631 \u062a\u0623\u06cc\u06cc\u062f\u06cc \u0634\u0645\u0627 \u0627\u0633\u062a",
    "ar": "\u0647\u0630\u0647 \u0645\u0647\u0645\u062a\u0643 ! \u062a\u0647\u0627\u0646\u064a\u0646\u0627. \u0641\u064a \u0625\u0646\u062a\u0638\u0627\u0631 \u062a\u0633\u0644\u064a\u0645\u0643\u0645",
    "uk": "\u0426\u044f \u0440\u043e\u0431\u043e\u0442\u0430 \u0432\u0430\u0448\u0430!  \u0412\u0456\u0442\u0430\u0454\u043c\u043e \u0412\u0430\u0441!  \u041e\u0447\u0456\u043a\u0443\u0432\u0430\u043d\u043d\u044f \u0432\u0438\u043a\u043e\u043d\u0430\u043d\u043d\u044f \u0440\u043e\u0431\u043e\u0442\u0438."
  },
  "order_status_applied": {
    "sheet_name": "Web",
    "en": "You have applied for this, you will be notified if you are selected.",
    "ru": "\u0412\u044b \u043f\u043e\u0434\u0430\u043b\u0438 \u0437\u0430\u044f\u0432\u043a\u0443 \u043d\u0430 \u0440\u0430\u0431\u043e\u0442\u0443, \u0432\u044b \u0431\u0443\u0434\u0435\u0442\u0435 \u0443\u0432\u0435\u0434\u043e\u043c\u043b\u0435\u043d\u044b, \u0435\u0441\u043b\u0438 \u0432\u044b \u0432\u044b\u0431\u0440\u0430\u043d\u044b.",
    "fi": "Olet hakenut t\u00e4h\u00e4n. Saat ilmoituksen, jos sinut valitaan.",
    "sv": "Du har s\u00f6kt det h\u00e4r uppdraget och f\u00e5r ett meddelande om du blir vald.",
    "fa": "\u0634\u0645\u0627 \u0628\u0631\u0627\u06cc \u0627\u06cc\u0646 \u06a9\u0627\u0631 \u062f\u0631\u062e\u0648\u0627\u0633\u062a \u06a9\u0631\u062f\u0647 \u0627\u06cc\u062f \u060c \u0627\u06af\u0631 \u0627\u0646\u062a\u062e\u0627\u0628 \u0634\u062f\u0647 \u0628\u0627\u0634\u06cc\u062f \u0628\u0647 \u0634\u0645\u0627 \u0627\u0637\u0644\u0627\u0639 \u062f\u0627\u062f\u0647 \u0645\u06cc \u0634\u0648\u062f",
    "ar": "\u0644\u0642\u062f \u062a\u0642\u062f\u0645\u062a \u0628\u0637\u0644\u0628 \u0644\u0644\u0648\u0638\u064a\u0641\u0629 ,\u0633\u064a\u062a\u0645 \u0625\u0639\u0644\u0627\u0645\u0643 \u0641\u064a \u062d\u0627\u0644 \u062a\u0645 \u0625\u062e\u062a\u064a\u0627\u0631\u0643",
    "uk": "\u0412\u0438 \u043f\u043e\u0434\u0430\u043b\u0438 \u0437\u0430\u044f\u0432\u043a\u0443 \u043d\u0430 \u0440\u043e\u0431\u043e\u0442\u0443, \u0432\u0438 \u0431\u0443\u0434\u0435\u0442\u0435 \u043f\u043e\u0432\u0456\u0434\u043e\u043c\u043b\u0435\u043d\u0456, \u044f\u043a\u0449\u043e \u0432\u0438 \u0432\u0438\u0431\u0440\u0430\u043b\u0438."
  },
  "id": {
    "sheet_name": "Shared (API)",
    "en": "base",
    "ru": "ru",
    "fi": "fi",
    "sv": "sv",
    "fa": "fa",
    "ar": "ar",
    "uk": "uk"
  },
  "error_server": {
    "sheet_name": "Shared (API)",
    "en": "Unknown error.",
    "ru": "\u041d\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043d\u0430\u044f \u043e\u0448\u0438\u0431\u043a\u0430.",
    "fi": "Tuntematon virhe",
    "sv": "Ok\u00e4nt fel",
    "fa": "\u062e\u0637\u0627\u06cc \u0646\u0627\u0634\u0646\u0627\u062e\u062a\u0647.",
    "ar": "\u062e\u0637\u0623 \u063a\u064a\u0631 \u0645\u0639\u0631\u0648\u0641",
    "uk": "\u041d\u0435\u0432\u0456\u0434\u043e\u043c\u0430 \u043f\u043e\u043c\u0438\u043b\u043a\u0430"
  },
  "error_json_decode": {
    "sheet_name": "Shared (API)",
    "en": "JSON decode error",
    "ru": "JSON \u043e\u0448\u0438\u0431\u043a\u0430",
    "fi": "JSON virhe",
    "sv": "JSON fel",
    "fa": "\u062e\u0637\u0627\u06cc \u0631\u0645\u0632\u06af\u0634\u0627\u06cc\u06cc JSON",
    "ar": "\u062e\u0637\u0627\u0621 \u0641\u0643 \u0634\u0641\u0631\u0629 JSON",
    "uk": "JSON \u043f\u043e\u043c\u0438\u043b\u043a\u0430"
  },
  "error_mandatory_email": {
    "sheet_name": "Shared (API)",
    "en": "Please enter your email",
    "ru": "\u041f\u043e\u0436\u0430\u043b\u0443\u0439\u0441\u0442\u0430 \u0432\u044b\u0439\u0434\u0438\u0442\u0435 \u0432\u0430\u0448\u0443 \u044d\u043b\u0435\u043a\u0442\u0440\u043e\u043d\u043d\u0443\u044e \u043f\u043e\u0447\u0442\u0443",
    "fi": "Sy\u00f6t\u00e4th\u00e4n s\u00e4hk\u00f6postiosoiteesi",
    "sv": "V\u00e4nligen skriv in din emailadress",
    "fa": "\u0644\u0637\u0641\u0627 \u0627\u06cc\u0645\u06cc\u0644 \u062e\u0648\u062f \u0631\u0627 \u0648\u0627\u0631\u062f \u06a9\u0646\u06cc\u062f",
    "ar": "\u0627\u062f\u062e\u0644 \u0627\u0644\u0628\u0631\u064a\u062f \u0627\u0644\u0625\u0644\u0643\u062a\u0631\u0648\u0646\u064a",
    "uk": "\u0411\u0443\u0434\u044c \u043b\u0430\u0441\u043a\u0430, \u0432\u0432\u0435\u0434\u0456\u0442\u044c \u0441\u0432\u043e\u044e \u0435\u043b\u0435\u043a\u0442\u0440\u043e\u043d\u043d\u0443 \u043f\u043e\u0448\u0442\u0443"
  },
  "error_mandatory_field": {
    "sheet_name": "Shared (API)",
    "en": "Mandatory field",
    "ru": "\u043e\u0431\u044f\u0437\u0430\u0442\u0435\u043b\u044c\u043d\u043e\u0435 \u043f\u043e\u043b\u0435",
    "fi": "Pakollinen kentt\u00e4",
    "sv": "Obligatoriskt f\u00e4lt",
    "fa": "\u0632\u0645\u06cc\u0646\u0647 \u0627\u062c\u0628\u0627\u0631\u06cc",
    "ar": "\u062d\u0642\u0644 \u0645\u0647\u0645",
    "uk": "\u041e\u0431\u043e\u0432'\u044f\u0437\u043a\u043e\u0432\u0435 \u043f\u043e\u043b\u0435"
  },
  "error_field_may_not_be_null": {
    "sheet_name": "Shared (API)",
    "en": "Field may not be null",
    "ru": "\u041f\u043e\u043b\u0435 \u043d\u0435\u043b\u044c\u0437\u044f \u0431\u044b\u0442\u044c \u043f\u0443\u0441\u0442\u044b\u043c.",
    "fi": "Kentt\u00e4 ei saa olla tyhj\u00e4",
    "sv": "F\u00e4ltet f\u00e5r inte vara tomt",
    "fa": "\u0632\u0645\u06cc\u0646\u0647 \u0646\u0628\u0627\u06cc\u062f \u062e\u0627\u0644\u06cc \u0628\u0627\u0634\u062f",
    "ar": "\u0644\u0627\u064a\u0645\u0643\u0646 \u0627\u0646 \u064a\u0643\u0648\u0646 \u0627\u0644\u062d\u0642\u0644 \u0641\u0627\u0631\u063a\u0627",
    "uk": "\u041f\u043e\u043b\u0435 \u043d\u0435 \u043c\u043e\u0436\u0435 \u0431\u0443\u0442\u0438 \u043d\u0435\u0437\u0430\u043f\u043e\u0432\u043d\u0435\u043d\u0438\u043c"
  },
  "error_invalid_field_value": {
    "sheet_name": "Shared (API)",
    "en": "Invalid value",
    "ru": "\u041d\u0435\u0432\u0435\u0440\u043d\u044b\u0435 \u0434\u0430\u043d\u043d\u044b\u0435",
    "fi": "Virheellist\u00e4 tietoa",
    "sv": "Felaktigt data",
    "fa": "\u0645\u0642\u062f\u0627\u0631 \u0646\u0627\u0645\u0639\u062a\u0628\u0631 \u0627\u0633\u062a",
    "ar": "\u0645\u0639\u0644\u0648\u0645\u0627\u062a \u063a\u064a\u0631 \u0635\u0627\u0644\u062d\u0629",
    "uk": "\u041d\u0435\u0432\u0456\u0440\u043d\u0430 \u0456\u043d\u0444\u043e\u0440\u043c\u0430\u0446\u0456\u044f"
  },
  "error_invalid_input_type": {
    "sheet_name": "Shared (API)",
    "en": "Invalid input type",
    "ru": "\u041d\u0435\u0432\u0435\u0440\u043d\u044b\u0439 \u0442\u0438\u043f \u0432\u0432\u043e\u0434\u0430",
    "fi": "Virheelinen tietotyyppi",
    "sv": "Ogiltig data",
    "fa": "\u0646\u0648\u0639 \u0648\u0631\u0648\u062f\u06cc \u0646\u0627\u0645\u0639\u062a\u0628\u0631 \u0627\u0633\u062a",
    "ar": "\u0646\u0648\u0639 \u0627\u062f\u062e\u0627\u0644 \u063a\u064a\u0631 \u0635\u062d\u064a\u062d",
    "uk": "\u041d\u0435\u043f\u0440\u0430\u0432\u0438\u043b\u044c\u043d\u0438\u0439 \u0442\u0438\u043f \u0432\u0432\u043e\u0434\u0443"
  },
  "error_unknown_field": {
    "sheet_name": "Shared (API)",
    "en": "Unknown field",
    "ru": "\u041d\u0435\u0437\u043d\u0430\u043a\u043e\u043c\u043e\u0435 \u043f\u043e\u043b\u0435",
    "fi": "Tuntematon kentt\u00e4",
    "sv": "Ok\u00e4nt f\u00e4lt",
    "fa": "\u0632\u0645\u06cc\u0646\u0647 \u0646\u0627\u0634\u0646\u0627\u062e\u062a\u0647",
    "ar": "\u062d\u0642\u0644 \u063a\u064a\u0631 \u0645\u0639\u0631\u0648\u0641",
    "uk": "\u041d\u0435\u0432\u0456\u0434\u043e\u043c\u0435 \u043f\u043e\u043b\u0435"
  },
  "error_missing_id": {
    "sheet_name": "Shared (API)",
    "en": "The ID doesn't exists",
    "ru": "ID \u041d\u0435 \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u0435\u0442",
    "fi": "ID:t\u00e4 ei ole olemassa",
    "sv": "ID finns inte",
    "fa": "\u0622\u06cc\u062f\u06cc \u0628\u0647 \u0627\u06cc\u0646 \u0646\u0627\u0645 \u0648\u062c\u0648\u062f \u0646\u062f\u0627\u0631\u062f",
    "ar": "\u0627\u0644\u0645\u0639\u0631\u0641 \u063a\u064a\u0631\u0645\u0648\u062c\u0648\u062f",
    "uk": "ID \u043d\u0435 \u0456\u0441\u043d\u0443\u0454"
  },
  "error_not_found": {
    "sheet_name": "Shared (API)",
    "en": "Not found",
    "ru": "\u041d\u0435 \u043d\u0430\u0439\u0434\u0435\u043d\u043e",
    "fi": "Ei l\u00f6ytynyt",
    "sv": "Hittade inte",
    "fa": "\u067e\u06cc\u062f\u0627 \u0646\u0634\u062f",
    "ar": "\u0644\u0645 \u064a\u062a\u0645 \u0627\u0644\u0639\u062b\u0648\u0631",
    "uk": "\u041d\u0435 \u0437\u043d\u0430\u0439\u0434\u0435\u043d\u043e"
  },
  "error_outdated_version": {
    "sheet_name": "Shared (API)",
    "en": "The version that you are currently using is outdated. Please visit the app store and download the latest version.",
    "ru": "\u0412\u0435\u0440\u0441\u0438\u044f, \u043a\u043e\u0442\u043e\u0440\u0443\u044e \u0432\u044b \u0438\u0441\u043f\u043e\u043b\u044c\u0437\u0443\u0435\u0442\u0435 \u0432 \u0434\u0430\u043d\u043d\u044b\u0439 \u043c\u043e\u043c\u0435\u043d\u0442, \u0443\u0441\u0442\u0430\u0440\u0435\u043b\u0430. \u041f\u043e\u0436\u0430\u043b\u0443\u0439\u0441\u0442\u0430, \u043f\u043e\u0441\u0435\u0442\u0438\u0442\u0435 \u043c\u0430\u0433\u0430\u0437\u0438\u043d \u043f\u0440\u0438\u043b\u043e\u0436\u0435\u043d\u0438\u0439 \u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u0435 \u043f\u043e\u0441\u043b\u0435\u0434\u043d\u044e\u044e \u0432\u0435\u0440\u0441\u0438\u044e.",
    "fi": "K\u00e4ytt\u00e4m\u00e4si versio on vanhentunut. K\u00e4yth\u00e4n p\u00e4ivitt\u00e4m\u00e4ss\u00e4 sovelluksen uusimpaan versioon.",
    "sv": "En ny version av v\u00e5r app \u00e4r tillg\u00e4nglig. Klicka p\u00e5 OK f\u00f6r att uppdatera.",
    "fa": "\u0646\u0633\u062e\u0647 \u0627\u06cc \u06a9\u0647 \u0627\u06a9\u0646\u0648\u0646 \u0627\u0632 \u0622\u0646 \u0627\u0633\u062a\u0641\u0627\u062f\u0647 \u0645\u06cc \u06a9\u0646\u06cc\u062f \u0645\u0646\u0633\u0648\u062e \u0634\u062f\u0647 \u0627\u0633\u062a. \u0644\u0637\u0641\u0627\u064b \u0627\u0632 \u0641\u0631\u0648\u0634\u06af\u0627\u0647 \u0628\u0631\u0646\u0627\u0645\u0647 \u0647\u0627 \u0628\u0627\u0632\u062f\u06cc\u062f \u06a9\u0631\u062f\u0647 \u0648 \u0622\u062e\u0631\u06cc\u0646 \u0646\u0633\u062e\u0647 \u0631\u0627 \u0646\u0635\u0628 \u06a9\u0646\u06cc\u062f.",
    "ar": "\u0627\u0644\u0623\u0635\u062f\u0627\u0631 \u0627\u0644\u0630\u064a \u062a\u0633\u062a\u062e\u062f\u0645\u0647 \u062d\u0627\u0644\u064a\u0627 \u0642\u062f\u064a\u0645. \u064a\u0631\u062c\u0649 \u0632\u064a\u0627\u0631\u0629 \u0645\u062a\u062c\u0631 \u0627\u0644\u062a\u0637\u0628\u064a\u0642\u0627\u062a \u0648\u062a\u062d\u0645\u064a\u0644 \u0627\u062d\u062f\u062b \u0627\u0635\u062f\u0627\u0631",
    "uk": "\u0412\u0435\u0440\u0441\u0456\u044f, \u044f\u043a\u0443 \u0432\u0438 \u0437\u0430\u0440\u0430\u0437 \u0432\u0438\u043a\u043e\u0440\u0438\u0441\u0442\u043e\u0432\u0443\u0454\u0442\u0435, \u0437\u0430\u0441\u0442\u0430\u0440\u0456\u043b\u0430. \u0411\u0443\u0434\u044c \u043b\u0430\u0441\u043a\u0430, \u0432\u0456\u0434\u0432\u0456\u0434\u0430\u0439\u0442\u0435 \u043c\u0430\u0433\u0430\u0437\u0438\u043d \u0434\u043e\u0434\u0430\u0442\u043a\u0456\u0432 \u0442\u0430 \u0437\u0430\u0432\u0430\u043d\u0442\u0430\u0436\u0442\u0435 \u043e\u0441\u0442\u0430\u043d\u043d\u044e \u0432\u0435\u0440\u0441\u0456\u044e"
  },
  "error_not_allowed": {
    "sheet_name": "Shared (API)",
    "en": "Not allowed",
    "ru": "\u041d\u0435 \u0434\u043e\u043f\u0443\u0441\u043a\u0430\u0435\u0442\u0441\u044f",
    "fi": "Ei sallittu",
    "sv": "Inte till\u00e5tet",
    "fa": "\u0645\u062c\u0627\u0632 \u0646\u06cc\u0633\u062a",
    "ar": "",
    "uk": "\u0417\u0430\u0431\u043e\u0440\u043e\u043d\u0435\u043d\u043e"
  },
  "error_outdated_config": {
    "sheet_name": "Shared (API)",
    "en": "The config version is outdated",
    "ru": "",
    "fi": "Konfiguraation versio on vanhentunut",
    "sv": "Konfigurationsversionen har g\u00e5tt ut",
    "fa": "",
    "ar": "",
    "uk": "\u0417\u0430\u0441\u0442\u0430\u0440\u0456\u043b\u0430 \u0432\u0435\u0440\u0441\u0456\u044f \u043a\u043e\u043d\u0444\u0456\u0433\u0443\u0440\u0430\u0446\u0456\u0457"
  },
  "error_unknown_merchant": {
    "sheet_name": "Shared (API)",
    "en": "Unknown merchant",
    "ru": "",
    "fi": "Tuntematon palvelu",
    "sv": "Ok\u00e4nd tj\u00e4nst",
    "fa": "",
    "ar": "",
    "uk": "\u041d\u0435\u0432\u0456\u0434\u043e\u043c\u0438\u0439 \u043f\u0440\u043e\u0434\u0430\u0432\u0435\u0446\u044c"
  },
  "error_invite_email_exists": {
    "sheet_name": "Shared (API)",
    "en": "The user is already registered in this service.",
    "ru": "",
    "fi": "T\u00e4m\u00e4 k\u00e4ytt\u00e4j\u00e4tunnus jo l\u00f6ytyy t\u00e4ss\u00e4 palvelussa.",
    "sv": "Anv\u00e4ndaren \u00e4r redan registrerad i tj\u00e4nsten",
    "fa": "",
    "ar": "",
    "uk": "\u041a\u043e\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447 \u0432\u0436\u0435 \u0437\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u043e\u0432\u0430\u043d\u0438\u0439 \u0443 \u0446\u044c\u043e\u043c\u0443 \u0441\u0435\u0440\u0432\u0456\u0441\u0456"
  },
  "error_login_invalid_credentials": {
    "sheet_name": "Shared (API)",
    "en": "Please check that you have entered a correct email and password.",
    "ru": "\u041d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u043f\u043e\u0434\u043a\u043b\u044e\u0447\u0438\u0442\u044c\u0441\u044f \u043a \u0441\u0435\u0440\u0432\u0438\u0441\u0443. \u041f\u0440\u043e\u0432\u0435\u0440\u044c\u0442\u0435 \u0432\u0432\u0435\u0434\u0435\u043d\u043d\u044b\u0439 \u043b\u043e\u0433\u0438\u043d \u0438 \u043f\u0430\u0440\u043e\u043b\u044c",
    "fi": "Kirjautuminen palveluun ep\u00e4onnistui. Tarkista, ett\u00e4 kirjoitit oikein s\u00e4hk\u00f6postin ja salasanan.",
    "sv": "Inloggningen misslyckades. Se till att du har angett din e-postadress och l\u00f6senord korrekt.",
    "fa": "\u0644\u0637\u0641\u0627\u064b \u0628\u0631\u0631\u0633\u06cc \u06a9\u0646\u06cc\u062f \u06a9\u0647 \u06cc\u06a9 \u0627\u06cc\u0645\u06cc\u0644 \u0648 \u0631\u0645\u0632 \u0639\u0628\u0648\u0631 \u0635\u062d\u06cc\u062d \u0648\u0627\u0631\u062f \u06a9\u0631\u062f\u0647 \u0627\u06cc\u062f.",
    "ar": "\u064a\u0631\u062c\u0649 \u0627\u0644\u062a\u062d\u0642\u0642 \u0645\u0646 \u0625\u062f\u062e\u0627\u0644 \u0627\u0644\u0628\u0631\u064a\u062f \u0627\u0644\u0625\u0644\u0643\u062a\u0631\u0648\u0646\u064a \u0627\u0644\u0635\u062d\u064a\u062d \u0627\u0648 \u0643\u0644\u0645\u0629 \u0627\u0644\u0633\u0631",
    "uk": "\u0411\u0443\u0434\u044c \u043b\u0430\u0441\u043a\u0430, \u043f\u0435\u0440\u0435\u0432\u0456\u0440\u0442\u0435, \u0447\u0438 \u043f\u0440\u0430\u0432\u0438\u043b\u044c\u043d\u043e \u0432\u0438 \u0432\u0432\u0435\u043b\u0438 \u0435\u043b\u0435\u043a\u0442\u0440\u043e\u043d\u043d\u0443 \u043f\u043e\u0448\u0442\u0443 \u0442\u0430 \u043f\u0430\u0440\u043e\u043b\u044c"
  },
  "error_login_blocked": {
    "sheet_name": "Shared (API)",
    "en": "You have entered a wrong email\/password 6 times in a row. You are now blocked for 1 hour",
    "ru": "\u0412\u044b \u0432\u0432\u0435\u043b\u0438 \u043d\u0435\u043f\u0440\u0430\u0432\u0438\u043b\u044c\u043d\u044b\u0439 \u0430\u0434\u0440\u0435\u0441 \u044d\u043b\u0435\u043a\u0442\u0440\u043e\u043d\u043d\u043e\u0439 \u043f\u043e\u0447\u0442\u044b \/ \u043f\u0430\u0440\u043e\u043b\u044c 6 \u0440\u0430\u0437 \u043f\u043e\u0434\u0440\u044f\u0434. \u0422\u0435\u043f\u0435\u0440\u044c \u0432\u044b \u0437\u0430\u0431\u043b\u043e\u043a\u0438\u0440\u043e\u0432\u0430\u043d\u044b \u043d\u0430 1 \u0447\u0430\u0441.",
    "fi": "Olet sy\u00f6tt\u00e4nyt v\u00e4\u00e4r\u00e4n s\u00e4hk\u00f6postiosoitteen\/salasanan 6 kertaa per\u00e4kk\u00e4in. Tilisi on lukittu yhden tunnin ajan.",
    "sv": "Du har skrivit fel l\u00f6senord\/email 6 g\u00e5nger, kontot du f\u00f6rs\u00f6ker logga in p\u00e5 \u00e4r nu l\u00e5st i 1 timme.",
    "fa": "",
    "ar": "",
    "uk": "\u0412\u0438 \u0432\u0432\u0435\u043b\u0438 \u043d\u0435\u0432\u0456\u0440\u043d\u0438\u0439 email\/\u043f\u0430\u0440\u043e\u043b\u044c 6 \u0440\u0430\u0437\u0456\u0432 \u043f\u043e\u0441\u043f\u0456\u043b\u044c. \u0412\u0438 \u0437\u0430\u0431\u043b\u043e\u043a\u043e\u0432\u0430\u043d\u0456 \u043d\u0430 1 \u0433\u043e\u0434\u0438\u043d\u0443"
  },
  "error_login_multiple_merchants": {
    "sheet_name": "Shared (API)",
    "en": "Please select the merchant",
    "ru": "",
    "fi": "Ole hyv\u00e4 ja valitse palvelu",
    "sv": "V\u00e4nligen v\u00e4lj tj\u00e4nst",
    "fa": "",
    "ar": "",
    "uk": "\u0411\u0443\u0434\u044c \u043b\u0430\u0441\u043a\u0430, \u043e\u0431\u0435\u0440\u0456\u0442\u044c \u043f\u0440\u043e\u0434\u0430\u0432\u0446\u044f"
  },
  "error_email_not_confirmed": {
    "sheet_name": "Shared (API)",
    "en": "You haven't confirmed your email address yet. Please click on the 'Confirm email' button in the welcome email we sent you.",
    "ru": "\u0412\u044b \u0435\u0449\u0435 \u043d\u0435 \u043f\u043e\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u043b\u0438 \u0441\u0432\u043e\u0439 \u0430\u0434\u0440\u0435\u0441 \u044d\u043b\u0435\u043a\u0442\u0440\u043e\u043d\u043d\u043e\u0439 \u043f\u043e\u0447\u0442\u044b. \u041f\u043e\u0436\u0430\u043b\u0443\u0439\u0441\u0442\u0430, \u043d\u0430\u0436\u043c\u0438\u0442\u0435 \u043a\u043d\u043e\u043f\u043a\u0443 \u00ab\u041f\u043e\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044c \u0430\u0434\u0440\u0435\u0441 \u044d\u043b\u0435\u043a\u0442\u0440\u043e\u043d\u043d\u043e\u0439 \u043f\u043e\u0447\u0442\u044b\u00bb \u0432 \u043f\u0440\u0438\u0432\u0435\u0442\u0441\u0442\u0432\u0435\u043d\u043d\u043e\u043c \u043f\u0438\u0441\u044c\u043c\u0435, \u043a\u043e\u0442\u043e\u0440\u043e\u0435 \u043c\u044b \u0432\u0430\u043c \u043e\u0442\u043f\u0440\u0430\u0432\u0438\u043b\u0438.",
    "fi": "Et ole vahvistanut s\u00e4hk\u00f6postiosoitettasi viel\u00e4. Ole hyv\u00e4 ja paina 'Vahvista s\u00e4hk\u00f6postiosoite' -painiketta rekister\u00f6itymisen vahvistusviestiss\u00e4, jonka l\u00e4hetimme sinulle.",
    "sv": "Du har inte bekr\u00e4ftat din e-mail adress. V\u00e4nligen f\u00f6lj l\u00e4nken \u201dbekr\u00e4fta e-mail\u201d i mailet som vi skickat till dig.",
    "fa": "\u0634\u0645\u0627 \u0647\u0646\u0648\u0632 \u0622\u062f\u0631\u0633 \u0627\u06cc\u0645\u06cc\u0644 \u062e\u0648\u062f \u0631\u0627 \u062a\u0623\u06cc\u06cc\u062f \u0646\u06a9\u0631\u062f\u0647 \u0627\u06cc\u062f. \u0628\u0631\u0627\u06cc \u0634\u0645\u0627 \u0627\u06cc\u0645\u06cc\u0644 \u062a\u0627\u06cc\u06cc\u062f\u06cc\u0647 \u0627\u0631\u0633\u0627\u0644 \u0634\u062f\u0647 \u0627\u0633\u062a. \u0644\u0637\u0641\u0627 \u0627\u06cc\u0645\u06cc\u0644 \u0631\u0627\u0628\u0627\u0632 \u06a9\u0631\u062f\u0647 \u0648 \u0631\u0648\u06cc \u06af\u0632\u06cc\u0646\u0647 \u06cc * \u062a\u0627\u06cc\u06cc\u062f \u0627\u06cc\u0645\u06cc\u0644* \u06a9\u0644\u06cc\u06a9 \u06a9\u0646\u06cc\u062f.",
    "ar": "\u0644\u0645 \u062a\u0624\u0643\u062f \u0639\u0646\u0648\u0627\u0646 \u0628\u0631\u064a\u062f\u0643 \u0627\u0644\u0625\u0644\u0643\u062a\u0631\u0648\u0646\u064a \u0628\u0639\u062f. \u064a\u064f\u0631\u062c\u0649 \u0627\u0644\u0646\u0642\u0631 \u0641\u0648\u0642 \u0627\u0644\u0632\u0631 \"\u062a\u0623\u0643\u064a\u062f \u0627\u0644\u0628\u0631\u064a\u062f \u0627\u0644\u0625\u0644\u0643\u062a\u0631\u0648\u0646\u064a\" \u0641\u064a \u0631\u0633\u0627\u0644\u0629 \u0627\u0644\u0628\u0631\u064a\u062f \u0627\u0644\u0625\u0644\u0643\u062a\u0631\u0648\u0646\u064a \u0627\u0644\u062a\u0631\u062d\u064a\u0628\u064a\u0629 \u0627\u0644\u062a\u064a \u0623\u0631\u0633\u0644\u0646\u0627\u0647\u0627 \u0625\u0644\u064a\u0643.",
    "uk": "\u0412\u0438 \u0449\u0435 \u043d\u0435 \u043f\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u043b\u0438 \u0441\u0432\u043e\u044e \u0435\u043b\u0435\u043a\u0442\u0440\u043e\u043d\u043d\u0443 \u0430\u0434\u0440\u0435\u0441\u0443. \u0411\u0443\u0434\u044c \u043b\u0430\u0441\u043a\u0430, \u043d\u0430\u0442\u0438\u0441\u043d\u0456\u0442\u044c \u043a\u043d\u043e\u043f\u043a\u0443 \"\u041f\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438 \u0435\u043b\u0435\u043a\u0442\u0440\u043e\u043d\u043d\u0443 \u0430\u0434\u0440\u0435\u0441\u0443\", \u044f\u043a\u0438\u0439 \u043c\u0438 \u043d\u0430\u0434\u0456\u0441\u043b\u0430\u043b\u0438 \u0412\u0430\u043c \u043d\u0430 \u043f\u043e\u0448\u0442\u0443"
  },
  "error_login_needs_approval": {
    "sheet_name": "Shared (API)",
    "en": "This service needs additional approval which is still in progress.  Please wait or contact customer support.",
    "ru": "",
    "fi": "T\u00e4m\u00e4 palvelu vaatii erillisen hyv\u00e4ksynn\u00e4n, joka on viel\u00e4 kesken. Odota hetki tai ota yhteytt\u00e4 asiakaspalveluun.",
    "sv": "Denna tj\u00e4nst beh\u00f6ver ytterligare godk\u00e4nnande. V\u00e4nligen v\u00e4nta eller kontakta v\u00e5r kundsupport.",
    "fa": "",
    "ar": "",
    "uk": "\u0426\u044f \u043f\u043e\u0441\u043b\u0443\u0433\u0430 \u043f\u043e\u0442\u0440\u0435\u0431\u0443\u0454 \u0434\u043e\u0434\u0430\u0442\u043a\u043e\u0432\u043e\u0433\u043e \u0443\u0437\u0433\u043e\u0434\u0436\u0435\u043d\u043d\u044f, \u044f\u043a\u0435 \u043d\u0430\u0440\u0430\u0437\u0456 \u0442\u0440\u0438\u0432\u0430\u0454.  \u0411\u0443\u0434\u044c \u043b\u0430\u0441\u043a\u0430, \u0437\u0430\u0447\u0435\u043a\u0430\u0439\u0442\u0435 \u0430\u0431\u043e \u0437\u0432\u0435\u0440\u043d\u0456\u0442\u044c\u0441\u044f \u0434\u043e \u0441\u043b\u0443\u0436\u0431\u0438 \u043f\u0456\u0434\u0442\u0440\u0438\u043c\u043a\u0438"
  },
  "error_not_approved_worker": {
    "sheet_name": "Shared (API)",
    "en": "You have not been approved to be a worker. Please contact platform owner if you need access to this role.",
    "ru": "",
    "fi": "Sinua ei ole hyv\u00e4ksytty t\u00e4ss\u00e4 palvelussa tekij\u00e4ksi. Ole hyv\u00e4 ja ota yhteytt\u00e4 alustan omistajaan, jos tarvitset oikeuden t\u00e4h\u00e4n rooliin.",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0412\u0438 \u043d\u0435 \u0431\u0443\u043b\u0438 \u0441\u0445\u0432\u0430\u043b\u0435\u043d\u0456 \u044f\u043a \u043f\u0440\u0430\u0446\u0456\u0432\u043d\u0438\u043a. \u0411\u0443\u0434\u044c \u043b\u0430\u0441\u043a\u0430, \u0437\u0432\u0435\u0440\u043d\u0456\u0442\u044c\u0441\u044f \u0434\u043e \u0432\u043b\u0430\u0441\u043d\u0438\u043a\u0430 \u043f\u043b\u0430\u0442\u0444\u043e\u0440\u043c\u0438, \u044f\u043a\u0449\u043e \u0432\u0430\u043c \u043f\u043e\u0442\u0440\u0456\u0431\u0435\u043d \u0434\u043e\u0441\u0442\u0443\u043f \u0434\u043e \u0446\u0456\u0454\u0457 \u0440\u043e\u0431\u043e\u0442\u0438"
  },
  "error_not_approved_orderer": {
    "sheet_name": "Shared (API)",
    "en": "You have not been approved to be an orderer. Please contact platform owner if you need access to this role.",
    "ru": "",
    "fi": "Sinua ei ole hyv\u00e4ksytty t\u00e4ss\u00e4 palvelussa tilaajaksi. Ole hyv\u00e4 ja ota yhteytt\u00e4 alustan omistajaan, jos tarvitset oikeuden t\u00e4h\u00e4n rooliin.",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0412\u0438 \u043d\u0435 \u0431\u0443\u043b\u0438 \u0437\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043d\u0456 \u044f\u043a \u0437\u0430\u043c\u043e\u0432\u043d\u0438\u043a. \u0411\u0443\u0434\u044c \u043b\u0430\u0441\u043a\u0430, \u0437\u0432\u0435\u0440\u043d\u0456\u0442\u044c\u0441\u044f \u0434\u043e \u0432\u043b\u0430\u0441\u043d\u0438\u043a\u0430 \u043f\u043b\u0430\u0442\u0444\u043e\u0440\u043c\u0438, \u044f\u043a\u0449\u043e \u0432\u0430\u043c \u043f\u043e\u0442\u0440\u0456\u0431\u0435\u043d \u0434\u043e\u0441\u0442\u0443\u043f \u0434\u043e \u0446\u0456\u0454\u0457 \u0440\u043e\u0431\u043e\u0442\u0438"
  },
  "error_email_invalid": {
    "sheet_name": "Shared (API)",
    "en": "The email is not valid",
    "ru": "\u041d\u0435\u0432\u0435\u0440\u043d\u044b\u0439 \u0430\u0434\u0440\u0435\u0441 \u044d\u043b\u0435\u043a\u0442\u0440\u043e\u043d\u043d\u043e\u0439 \u043f\u043e\u0447\u0442\u044b.",
    "fi": "Virheellinen s\u00e4hk\u00f6postiosoite.",
    "sv": "Fel e-postadress.",
    "fa": "\u0627\u06cc\u0645\u06cc\u0644 \u062f\u0631\u0633\u062a \u0646\u06cc\u0633\u062a",
    "ar": "\u0627\u0644\u0628\u0631\u064a\u062f \u0627\u0644\u0625\u0644\u0643\u062a\u0631\u0648\u0646\u064a \u063a\u064a\u0631 \u0635\u0627\u0644\u062d",
    "uk": "\u0415\u043b\u0435\u043a\u0442\u0440\u043e\u043d\u043d\u0430 \u043f\u043e\u0448\u0442\u0430 \u043d\u0435 \u0434\u0456\u0439\u0441\u043d\u0430"
  },
  "error_email_already_exists": {
    "sheet_name": "Shared (API)",
    "en": "User name already exists. Would you like to use another email address?",
    "ru": "\u0418\u043c\u044f \u043f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u0435\u043b\u044f \u0443\u0436\u0435 \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u0435\u0442. \u0412\u044b \u0445\u043e\u0442\u0438\u0442\u0435 \u0438\u0441\u043f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u044c \u0434\u0440\u0443\u0433\u043e\u0439 \u0430\u0434\u0440\u0435\u0441 \u044d\u043b\u0435\u043a\u0442\u0440\u043e\u043d\u043d\u043e\u0439 \u043f\u043e\u0447\u0442\u044b?",
    "fi": "K\u00e4ytt\u00e4j\u00e4tunnus on jo olemassa. Haluatko k\u00e4ytt\u00e4\u00e4 toista s\u00e4hk\u00f6postiosoitetta?",
    "sv": "Det valda anv\u00e4ndarnamnet finns redan! V\u00e4nligen v\u00e4lj en ny mejladress.",
    "fa": "\u0634\u0645\u0627 \u0642\u0628\u0644\u0627 \u0627\u06cc\u0646\u062c\u0627 \u062b\u0628\u062a \u0634\u0645\u0627 \u0634\u062f\u0647 \u0627\u06cc\u06cc\u062f. \u0622\u06cc\u0627 \u0645\u06cc \u062e\u0648\u0627\u0647\u06cc\u062f \u0627\u0632 \u0622\u062f\u0631\u0633 \u0627\u06cc\u0645\u06cc\u0644 \u062f\u06cc\u06af\u0631\u06cc \u0627\u0633\u062a\u0641\u0627\u062f\u0647 \u06a9\u0646\u06cc\u062f\u061f",
    "ar": "\u0627\u0633\u0645 \u0627\u0644\u0645\u0633\u062a\u062e\u062f\u0645 \u0645\u0648\u062c\u0648\u062f \u0628\u0627\u0644\u0641\u0639\u0644. \u0647\u0644 \u062a\u0631\u063a\u0628 \u0641\u064a \u0627\u0633\u062a\u062e\u062f\u0627\u0645 \u0639\u0646\u0648\u0627\u0646 \u0628\u0631\u064a\u062f \u0627\u0644\u0643\u062a\u0631\u0648\u0646\u064a \u0627\u062e\u0631\u061f",
    "uk": "\u0406\u043c'\u044f \u043a\u043e\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430 \u0432\u0436\u0435 \u0456\u0441\u043d\u0443\u0454. \u0411\u0430\u0436\u0430\u0454\u0442\u0435 \u0432\u0438\u043a\u043e\u0440\u0438\u0441\u0442\u043e\u0432\u0443\u0432\u0430\u0442\u0438 \u0456\u043d\u0448\u0443 \u0430\u0434\u0440\u0435\u0441\u0443 \u0435\u043b\u0435\u043a\u0442\u0440\u043e\u043d\u043d\u043e\u0457 \u043f\u043e\u0448\u0442\u0438?"
  },
  "error_mandatory_password": {
    "sheet_name": "Shared (API)",
    "en": "Please enter your password",
    "ru": "\u0412\u0438\u0434\u0438\u0442\u0435 \u043f\u0430\u0440\u043e\u043b\u044c",
    "fi": "Sy\u00f6t\u00e4th\u00e4n salasanasi",
    "sv": "Ange ditt l\u00f6senord",
    "fa": "\u0644\u0637\u0641\u0627 \u0631\u0645\u0632 \u062e\u0648\u062f \u0631\u0627 \u0648\u0627\u0631\u062f \u06a9\u0646\u06cc\u062f",
    "ar": "\u0645\u0646 \u0641\u0636\u0644\u0643 \u0627\u062f\u062e\u0644 \u0631\u0642\u0645\u0643 \u0627\u0644\u0633\u0631\u064a",
    "uk": "\u0426\u044f \u0430\u0434\u0440\u0435\u0441\u0430 \u0432\u0436\u0435 \u0437\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u043e\u0432\u0430\u043d\u0430"
  },
  "error_password_short": {
    "sheet_name": "Shared (API)",
    "en": "Password should be at least %d characters",
    "ru": "\u041f\u0430\u0440\u043e\u043b\u044c \u0434\u043e\u043b\u0436\u0435\u043d \u0441\u043e\u0434\u0435\u0440\u0436\u0430\u0442\u044c \u043d\u0435 \u043c\u0435\u043d\u0435\u0435 %d \u0441\u0438\u043c\u0432\u043e\u043b\u043e\u0432.",
    "fi": "Salasanassa on oltava v\u00e4hint\u00e4\u00e4n %d merkki\u00e4.",
    "sv": "L\u00f6senordet ska inneh\u00e5lla minst %d tecken.",
    "fa": "\u0631\u0645\u0632 \u0639\u0628\u0648\u0631 \u0628\u0627\u06cc\u062f \u062d\u062f\u0627\u0642\u0644 %d \u062d\u0631\u0641 \u0628\u0627\u0634\u062f",
    "ar": "\u064a\u062c\u0628 \u0627\u0646 \u062a\u062a\u0643\u0648\u0646 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0645\u0646 \u062d\u0631\u0641 %d \u0639\u0644\u0649 \u0627\u0644\u0627\u0642\u0644",
    "uk": "\u041f\u0430\u0440\u043e\u043b\u044c \u043c\u0430\u0454 \u0431\u0443\u0442\u0438 \u043d\u0435 \u043c\u0435\u043d\u0448\u0435 %d \u0441\u0438\u043c\u0432\u043e\u043b\u0456\u0432"
  },
  "error_password_long": {
    "sheet_name": "Shared (API)",
    "en": "Password should be at most %d characters",
    "ru": "\u041f\u0430\u0440\u043e\u043b\u044c \u0434\u043e\u043b\u0436\u0435\u043d \u0441\u043e\u0434\u0435\u0440\u0436\u0430\u0442\u044c \u043d\u0435 \u0431\u043e\u043b\u0435\u0435 %d \u0441\u0438\u043c\u0432\u043e\u043b\u043e\u0432.",
    "fi": "Salasanassa on oltava enint\u00e4\u00e4n %d merkki\u00e4.",
    "sv": "L\u00f6senordet m\u00e5ste vara h\u00f6gst% d tecken.",
    "fa": "\u0631\u0645\u0632 \u0639\u0628\u0648\u0631 \u0628\u0627\u06cc\u062f \u062d\u062f\u0627\u06a9\u062b\u0631%d \u062d\u0631\u0641 \u0628\u0627\u0634\u062f",
    "ar": "\u064a\u062c\u0628 \u0627\u0646 \u0644\u0627 \u062a\u0632\u064a\u062f \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0639\u0646 \u062d\u0631\u0641 %d",
    "uk": "\u041f\u0430\u0440\u043e\u043b\u044c \u043c\u0430\u0454 \u0431\u0443\u0442\u0438 \u043d\u0435 \u0431\u0456\u043b\u044c\u0448\u0435 %d \u0441\u0438\u043c\u0432\u043e\u043b\u0456\u0432"
  },
  "error_password_confirm_match": {
    "sheet_name": "Shared (API)",
    "en": "Password confirmation doesn't match",
    "ru": "\u041f\u0430\u0440\u043e\u043b\u0438 \u043d\u0435 \u0441\u043e\u0432\u043f\u0430\u0434\u0430\u044e\u0442",
    "fi": "Salasanat eiv\u00e4t t\u00e4sm\u00e4\u00e4",
    "sv": "L\u00f6senord matchar inte",
    "fa": "\u062a\u0623\u06cc\u06cc\u062f \u0631\u0645\u0632 \u0639\u0628\u0648\u0631 \u0645\u0637\u0627\u0628\u0642\u062a \u0646\u062f\u0627\u0631\u062f",
    "ar": "\u062a\u0623\u0643\u064a\u062f \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u063a\u064a\u0631 \u0645\u0637\u0627\u0628\u0642",
    "uk": "\u041f\u0430\u0440\u043e\u043b\u0456 \u043d\u0435 \u0437\u0431\u0456\u0433\u0430\u044e\u0442\u044c\u0441\u044f"
  },
  "error_mandatory_first_name": {
    "sheet_name": "Shared (API)",
    "en": "Please enter your first name",
    "ru": "\u0412\u0438\u0434\u0438\u0442\u0435 \u0438\u043c\u044f",
    "fi": "Sy\u00f6t\u00e4 etunimi",
    "sv": "Fyll i f\u00f6rnamn",
    "fa": "\u0644\u0637\u0641\u0627 \u0646\u0627\u0645 \u062e\u0648\u062f \u0631\u0627 \u0648\u0627\u0631\u062f \u06a9\u0646\u06cc\u062f",
    "ar": "\u0627\u062f\u062e\u0644 \u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0627\u0648\u0644",
    "uk": "\u0411\u0443\u0434\u044c \u043b\u0430\u0441\u043a\u0430, \u0432\u0432\u0435\u0434\u0456\u0442\u044c \u0441\u0432\u043e\u0454 \u0456\u043c'\u044f"
  },
  "error_mandatory_last_name": {
    "sheet_name": "Shared (API)",
    "en": "Please enter your last name",
    "ru": "\u0412\u0438\u0434\u0438\u0442\u0435 \u0444\u0430\u043c\u0438\u043b\u0438\u044e",
    "fi": "Sy\u00f6t\u00e4 sukunimi",
    "sv": "Fyll i efternamn",
    "fa": "\u0644\u0644\u0637\u0641\u0627 \u0646\u0627\u0645 \u062e\u0627\u0646\u0648\u0627\u062f\u06af\u06cc \u062e\u0648\u062f \u0631\u0627 \u0648\u0627\u0631\u062f \u06a9\u0646\u06cc\u062f",
    "ar": "\u0627\u062f\u062e\u0644 \u0627\u0633\u0645 \u0627\u0644\u0639\u0627\u0626\u0644\u0629",
    "uk": "\u0411\u0443\u0434\u044c \u043b\u0430\u0441\u043a\u0430, \u0432\u0432\u0435\u0434\u0456\u0442\u044c \u0441\u0432\u043e\u0454 \u043f\u0440\u0456\u0437\u0432\u0438\u0449\u0435"
  },
  "error_first_name_short": {
    "sheet_name": "Shared (API)",
    "en": "First name should be at least %d letters",
    "ru": "\u0418\u043c\u044f \u0434\u043e\u043b\u0436\u043d\u043e \u0441\u043e\u0434\u0435\u0440\u0436\u0430\u0442\u044c \u043d\u0435 \u043c\u0435\u043d\u0435\u0435 %d \u0441\u0438\u043c\u0432\u043e\u043b\u043e\u0432.",
    "fi": "Etunimess\u00e4 pit\u00e4\u00e4 olla v\u00e4hint\u00e4\u00e4n %d merkki\u00e4.",
    "sv": "F\u00f6rnamnet ska inneh\u00e5lla minst %d tecken.",
    "fa": "\u0646\u0627\u0645 \u0634\u0645\u0627 \u0628\u0627\u06cc\u062f \u062d\u062f\u0627\u0642\u0644%d \u062d\u0631\u0641 \u0628\u0627\u0634\u062f",
    "ar": "\u064a\u062c\u0628 \u0627\u0646 \u064a\u0643\u0648\u0646 \u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0627\u0648\u0644 \u0645\u0646 \u062d\u0631\u0641 %d \u0639\u0644\u0649 \u0627\u0644\u0627\u0642\u0644",
    "uk": "\u0406\u043c\u2019\u044f \u043c\u0430\u0454 \u043c\u0456\u0441\u0442\u0438\u0442\u0438 \u0449\u043e\u043d\u0430\u0439\u043c\u0435\u043d\u0448\u0435 %d \u0431\u0443\u043a\u0432"
  },
  "error_last_name_short": {
    "sheet_name": "Shared (API)",
    "en": "Last name should be at least %d letters",
    "ru": "\u0418\u043c\u044f \u0434\u043e\u043b\u0436\u043d\u043e \u0441\u043e\u0434\u0435\u0440\u0436\u0430\u0442\u044c \u043d\u0435 \u043c\u0435\u043d\u0435\u0435 %d \u0441\u0438\u043c\u0432\u043e\u043b\u043e\u0432.",
    "fi": "Sukunimess\u00e4 pit\u00e4\u00e4 olla v\u00e4hint\u00e4\u00e4n %d merkki\u00e4.",
    "sv": "Efternamnet ska inneh\u00e5lla minst %d tecken.",
    "fa": "\u0646\u0627\u0645 \u062e\u0627\u0646\u0648\u0627\u062f\u06af\u06cc \u0628\u0627\u06cc\u062f \u062d\u062f\u0627\u0642\u0644%d \u062d\u0631\u0641 \u0628\u0627\u0634\u062f",
    "ar": "\u064a\u062c\u0628 \u0627\u0646 \u0644\u0627\u064a\u0642\u0644 \u0627\u0633\u0645 \u0627\u0644\u0639\u0627\u0626\u0644\u0629 \u0645\u0646 \u062d\u0631\u0641 %d",
    "uk": "\u0406\u043c'\u044f \u043c\u0430\u0454 \u043c\u0456\u0441\u0442\u0438\u0442\u0438 \u043d\u0435 \u0431\u0456\u043b\u044c\u0448\u0435 %d \u0431\u0443\u043a\u0432"
  },
  "error_mandatory_language": {
    "sheet_name": "Shared (API)",
    "en": "Select your language",
    "ru": "\u0412\u044b\u0431\u0435\u0440\u0438\u0442\u0435 \u044f\u0437\u044b\u043a",
    "fi": "Valitse kieli",
    "sv": "V\u00e4lj spr\u00e5k",
    "fa": "\u0632\u0628\u0627\u0646 \u062e\u0648\u062f \u0631\u0627 \u0627\u0646\u062a\u062e\u0627\u0628 \u06a9\u0646\u06cc\u062f",
    "ar": "\u0625\u062e\u062a\u0631 \u0627\u0644\u0644\u063a\u0629",
    "uk": "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044c \u043c\u043e\u0432\u0443"
  },
  "error_language_unsupported": {
    "sheet_name": "Shared (API)",
    "en": "Unsupported language",
    "ru": "\u041a \u0441\u043e\u0436\u0430\u043b\u0435\u043d\u0438\u044e, \u044d\u0442\u043e\u0442 \u044f\u0437\u044b\u043a \u043d\u0435 \u043f\u043e\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u0442\u0441\u044f.",
    "fi": "Valitettavasti t\u00e4t\u00e4 kielt\u00e4 ei ole tuettu",
    "sv": "V\u00e4lj ett annat spr\u00e5k",
    "fa": "\u0632\u0628\u0627\u0646 \u0627\u0646\u062a\u062e\u0627\u0628 \u0634\u062f\u0647 \u067e\u06cc\u062f\u0627 \u0646\u0634\u062f",
    "ar": "\u0639\u0630\u0631\u0627, \u0647\u0630\u0647 \u0627\u0644\u0644\u063a\u0629 \u063a\u064a\u0631 \u0645\u062f\u0639\u0648\u0645\u0629",
    "uk": "\u041d\u0430 \u0436\u0430\u043b\u044c, \u0446\u044f \u043c\u043e\u0432\u0430 \u043d\u0435 \u043f\u0456\u0434\u0442\u0440\u0438\u043c\u0443\u0454\u0442\u044c\u0441\u044f"
  },
  "error_mandatory_phone_country": {
    "sheet_name": "Shared (API)",
    "en": "Please select country for your phone number",
    "ru": "\u041f\u043e\u0436\u0430\u043b\u0443\u0439\u0441\u0442\u0430, \u0432\u044b\u0431\u0435\u0440\u0438\u0442\u0435 \u0441\u0442\u0440\u0430\u043d\u0443 \u0432\u0430\u0448\u0435\u0433\u043e \u0442\u0435\u043b\u0435\u0444\u043e\u043d\u0430.",
    "fi": "Maakoodi puhelinnumerollesi",
    "sv": "V\u00e4lj ditt landsnummer",
    "fa": "\u0644\u0637\u0641\u0627 \u062a\u0644\u0641\u0646 \u06a9\u0634\u0648\u0631 \u062e\u0648\u062f \u0631\u0627 \u0627\u0646\u062a\u062e\u0627\u0628 \u06a9\u0646\u06cc\u062f",
    "ar": "\u0645\u0646 \u0641\u0636\u0644\u0643 \u0625\u062e\u062a\u0631 \u0631\u0642\u0645 \u0627\u0644\u0628\u0644\u062f",
    "uk": "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044c \u043a\u0440\u0430\u0457\u043d\u0443 \u0432\u0430\u0448\u043e\u0433\u043e \u043d\u043e\u043c\u0435\u0440\u0430 \u0442\u0435\u043b\u0435\u0444\u043e\u043d\u0443"
  },
  "error_mandatory_phone_code": {
    "sheet_name": "Shared (API)",
    "en": "Please select your phone code",
    "ru": "\u041f\u043e\u0436\u0430\u043b\u0443\u0439\u0441\u0442\u0430, \u0432\u044b\u0431\u0435\u0440\u0438\u0442\u0435 \u0432\u0430\u0448 \u043d\u043e\u043c\u0435\u0440 \u0434\u043b\u044f \u0442\u0435\u043b\u0435\u0444\u043e\u043d\u0430.",
    "fi": "Valitsethan puhelimesi koodin",
    "sv": "V\u00e4lj en kod f\u00f6r din telefon",
    "fa": "\u0644\u0637\u0641\u0627 \u06a9\u0648\u062f \u062a\u0644\u0641\u0646 \u062e\u0648\u062f \u0631\u0627 \u0627\u0646\u062a\u062e\u0627\u0628 \u06a9\u0646\u06cc\u062f",
    "ar": "\u064a\u0631\u062c\u0649 \u0627\u062e\u062a\u064a\u0627\u0631 \u0631\u0645\u0632 \u0644\u0647\u0627\u062a\u0641\u0643",
    "uk": "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044c \u043a\u043e\u0434 \u043a\u0440\u0430\u0457\u043d\u0438 \u0432\u0430\u0448\u043e\u0433\u043e \u043d\u043e\u043c\u0435\u0440\u0430 \u0442\u0435\u043b\u0435\u0444\u043e\u043d\u0443"
  },
  "error_mandatory_phone_number": {
    "sheet_name": "Shared (API)",
    "en": "Please enter your phone number",
    "ru": "\u041f\u043e\u0436\u0430\u043b\u0443\u0439\u0441\u0442\u0430 \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u043d\u043e\u043c\u0435\u0440 \u0432\u0430\u0448\u0435\u0433\u043e \u043c\u043e\u0431\u0438\u043b\u044c\u043d\u043e\u0433\u043e \u0442\u0435\u043b\u0435\u0444\u043e\u043d\u0430",
    "fi": "Sy\u00f6t\u00e4 puhelinnumerosi",
    "sv": "Fyll i telefonnummer",
    "fa": "\u0644\u0637\u0641\u0627 \u0634\u0645\u0627\u0631\u0647 \u062a\u0644\u0641\u0646 \u062e\u0648\u062f \u0631\u0627 \u0648\u0627\u0631\u062f \u06a9\u0646\u06cc\u062f",
    "ar": "\u0623\u062f\u062e\u0644 \u0631\u0642\u0645 \u0647\u0627\u062a\u0641\u0643",
    "uk": "\u0412\u0432\u0435\u0434\u0456\u0442\u044c \u043d\u043e\u043c\u0435\u0440  \u0442\u0435\u043b\u0435\u0444\u043e\u043d\u0443"
  },
  "error_invalid_phone": {
    "sheet_name": "Shared (API)",
    "en": "Phone number is invalid (no blanks or special chars)",
    "ru": "\u041d\u043e\u043c\u0435\u0440 \u0442\u0435\u043b\u0435\u0444\u043e\u043d\u0430 \u043d\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043b\u0435\u043d",
    "fi": "Virheellinen puhelinnumero (\u00e4l\u00e4 j\u00e4t\u00e4 v\u00e4limerkkej\u00e4)",
    "sv": "Fel telefonnummer",
    "fa": "\u0634\u0645\u0627\u0631\u0647 \u062a\u0644\u0641\u0646 \u0646\u0627\u0645\u0639\u062a\u0628\u0631 \u0627\u0633\u062a (\u0628\u062f\u0648\u0646 \u0641\u0627\u0635\u0644\u0647 \u06cc\u0627 \u0639\u0644\u0627\u0645\u062a )",
    "ar": "\u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062a\u0641 \u063a\u064a\u0631 \u0635\u0627\u0644\u062d",
    "uk": "\u041d\u043e\u043c\u0435\u0440 \u0442\u0435\u043b\u0435\u0444\u043e\u043d\u0443 \u043d\u0435\u0434\u0456\u0439\u0441\u043d\u0438\u0439 (\u0431\u0435\u0437 \u043f\u0440\u043e\u0431\u0456\u043b\u0456\u0432 \u0430\u0431\u043e \u0441\u043f\u0435\u0446\u0456\u0430\u043b\u044c\u043d\u0438\u0445 \u0441\u0438\u043c\u0432\u043e\u043b\u0456\u0432)"
  },
  "error_profile_picture_too_big_mb": {
    "sheet_name": "Shared (API)",
    "en": "Profile image should be smaller than %d megabytes.",
    "ru": "",
    "fi": "Profiilikuvan on oltava pienempi kuin %d megatavua",
    "sv": "Profilbilden b\u00f6r vara mindre \u00e4n %d megabyte.",
    "fa": "",
    "ar": "",
    "uk": "\u0417\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u043d\u044f \u043f\u0440\u043e\u0444\u0456\u043b\u044e \u043c\u0430\u0454 \u0431\u0443\u0442\u0438 \u043c\u0435\u043d\u0448\u0438\u043c \u0437\u0430 %d \u043c\u0435\u0433\u0430\u0431\u0430\u0439\u0442"
  },
  "error_register_linked_to_merchant": {
    "sheet_name": "Shared (API)",
    "en": "You have already registered for this service",
    "ru": "",
    "fi": "Olet jo rekister\u00f6itynyt t\u00e4h\u00e4n palveluun",
    "sv": "Du har redan registrerat dig f\u00f6r den h\u00e4r tj\u00e4nsten",
    "fa": "",
    "ar": "",
    "uk": "\u0412\u0438 \u0432\u0436\u0435 \u0437\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u0443\u0432\u0430\u043b\u0438\u0441\u044f \u043d\u0430 \u0446\u044c\u043e\u043c\u0443 \u0441\u0435\u0440\u0432\u0456\u0441\u0456"
  },
  "error_register_different_country": {
    "sheet_name": "Shared (API)",
    "en": "Can't register to a merchant in a different country",
    "ru": "",
    "fi": "Eri maassa olevaan palveluun ei voi rekister\u00f6ity\u00e4",
    "sv": "Du kan inte registrera dig f\u00f6r denna tj\u00e4nst i ett annat land",
    "fa": "",
    "ar": "",
    "uk": "\u041d\u0435\u043c\u043e\u0436\u043b\u0438\u0432\u043e \u0437\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u0443\u0432\u0430\u0442\u0438\u0441\u044f \u043d\u0430 \u0442\u043e\u0440\u0433\u043e\u0432\u0446\u044f \u0432 \u0456\u043d\u0448\u0456\u0439 \u043a\u0440\u0430\u0457\u043d\u0456"
  },
  "error_user_cant_be_deleted": {
    "sheet_name": "Shared (API)",
    "en": "Your account can't be deleted, please contact customer support",
    "ru": "\u041f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u0435\u043b\u044c \u043d\u0435 \u043c\u043e\u0436\u0435\u0442 \u0431\u044b\u0442\u044c \u0443\u0434\u0430\u043b\u0435\u043d",
    "fi": "K\u00e4ytt\u00e4j\u00e4\u00e4 ei voi poistaa. Ota yhteytt\u00e4 asiakastukeen.",
    "sv": "Anv\u00e4ndaren kan inte raderas.",
    "fa": "",
    "ar": "\u0644\u0627\u064a\u0645\u0643\u0646 \u062d\u0630\u0641 \u0627\u0644\u0645\u0633\u062a\u062e\u062f\u0645",
    "uk": "\u0412\u0430\u0448 \u043e\u0431\u043b\u0456\u043a\u043e\u0432\u0438\u0439 \u0437\u0430\u043f\u0438\u0441 \u043d\u0435 \u0432\u0434\u0430\u0454\u0442\u044c\u0441\u044f \u0432\u0438\u0434\u0430\u043b\u0438\u0442\u0438, \u0437\u0432\u0435\u0440\u043d\u0456\u0442\u044c\u0441\u044f \u0434\u043e \u0441\u043b\u0443\u0436\u0431\u0438 \u043f\u0456\u0434\u0442\u0440\u0438\u043c\u043a\u0438"
  },
  "error_forgot_email_doesnt_exist": {
    "sheet_name": "Shared (API)",
    "en": "User with email address has not been registered!",
    "ru": "\u041f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u0435\u043b\u044c \u0441 \u0430\u0434\u0440\u0435\u0441\u043e\u043c \u044d\u043b\u0435\u043a\u0442\u0440\u043e\u043d\u043d\u043e\u0439 \u043f\u043e\u0447\u0442\u044b \u043d\u0435 \u0431\u044b\u043b \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043e\u0432\u0430\u043d!",
    "fi": "S\u00e4hk\u00f6postilla oleva k\u00e4ytt\u00e4j\u00e4 ei ole rekister\u00f6itynyt",
    "sv": "E-postanv\u00e4ndaren \u00e4r inte registrerad",
    "fa": "\u06a9\u0627\u0631\u0628\u0631 \u0628\u0627 \u0627\u06cc\u0646 \u0627\u06cc\u0645\u06cc\u0644 \u0622\u062f\u0631\u0633 \u062b\u0628\u062a \u0646\u0634\u062f\u0647 \u0627\u0633\u062a!",
    "ar": "\u0644\u0645 \u064a\u062a\u0645 \u062a\u0633\u062c\u064a\u0644 \u0627\u0644\u0645\u0633\u062a\u062e\u062f\u0645 \u0628\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0628\u0631\u064a\u062f \u0627\u0644\u0627\u0644\u0643\u062a\u0631\u0648\u0646\u064a",
    "uk": "\u041a\u043e\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430 \u0437 \u0442\u0430\u043a\u043e\u044e \u0430\u0434\u0440\u0435\u0441\u043e\u044e \u0435\u043b\u0435\u043a\u0442\u0440\u043e\u043d\u043d\u043e\u0457 \u043f\u043e\u0448\u0442\u0438 \u043d\u0435 \u0437\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u043e\u0432\u0430\u043d\u043e!"
  },
  "error_reset_password_invalid_token": {
    "sheet_name": "Shared (API)",
    "en": "This \"forgot password\" token is invalid or already used. Please request a new \"forgot password\" email!",
    "ru": "",
    "fi": "Salasanan vaihtoavain on virheellinen tai jo k\u00e4ytetty. L\u00e4het\u00e4 uusi salasanan vaihtopyynt\u00f6.",
    "sv": "Ditt gamla \u00e5terst\u00e4llningsl\u00f6senord \u00e4r ogiltigt eller redan\nanv\u00e4nt. Beg\u00e4r ett nytt e-postmeddelande med \"gl\u00f6mt l\u00f6senord\"!",
    "fa": "",
    "ar": "",
    "uk": "\u0426\u0435\u0439 \u043a\u043b\u044e\u0447 \u00ab forgot password \u00bb \u0454 \u043d\u0435\u043a\u043e\u0440\u0435\u043a\u0442\u043d\u0438\u043c \u0430\u0431\u043e \u0432\u0436\u0435 \u0432\u0438\u043a\u043e\u0440\u0438\u0441\u0442\u0430\u043d\u043e. \u0411\u0443\u0434\u044c \u043b\u0430\u0441\u043a\u0430, \u0437\u0430\u043f\u0438\u0442\u0430\u0439\u0442\u0435 \u043d\u043e\u0432\u0443 \u0435\u043b\u0435\u043a\u0442\u0440\u043e\u043d\u043d\u0443 \u043f\u043e\u0448\u0442\u0443 '\u0437\u0430\u0431\u0443\u043b\u0438 \u043f\u0430\u0440\u043e\u043b\u044c'!"
  },
  "error_reset_password_expired_token": {
    "sheet_name": "Shared (API)",
    "en": "This \"forgot password\" token has expired. Please request a new \"forgot password' email!",
    "ru": "",
    "fi": "Salasanan vaihtoavain on vanhentunut. L\u00e4het\u00e4 uusi salasanan vaihtopyynt\u00f6.",
    "sv": "Ditt gamla \u00e5terst\u00e4llningsl\u00f6senord har g\u00e5tt ut. Skicka en ny beg\u00e4ran om \u00e5terst\u00e4llning av l\u00f6senord.",
    "fa": "",
    "ar": "",
    "uk": "\u0422\u0435\u0440\u043c\u0456\u043d \u0434\u0456\u0457 \u0446\u044c\u043e\u0433\u043e \u043c\u0430\u0440\u043a\u0435\u0440\u0430 \"\u0437\u0430\u0431\u0443\u0432 \u043f\u0430\u0440\u043e\u043b\u044c \u0437\u0430\u043a\u0456\u043d\u0447\u0438\u0432\u0441\u044f. \u0411\u0443\u0434\u044c \u043b\u0430\u0441\u043a\u0430, \u043d\u0430\u0434\u0456\u0448\u043b\u0456\u0442\u044c \u0437\u0430\u043f\u0438\u0442 \u043d\u0430 \u043d\u043e\u0432\u0438\u0439 \u0435\u043b\u0435\u043a\u0442\u0440\u043e\u043d\u043d\u0438\u0439 \u043b\u0438\u0441\u0442 \"\"\u0437\u0430\u0431\u0443\u043b\u0438 \u043f\u0430\u0440\u043e\u043b\u044c\"!\""
  },
  "error_reset_password_not_most_recent": {
    "sheet_name": "Shared (API)",
    "en": "You requested multiple \"forgot password\" emails. Please use the most recent email!",
    "ru": "",
    "fi": "Olet l\u00e4hett\u00e4nyt useampia salasanan vaihtopyynt\u00f6j\u00e4. Valitse linkki uusimmasta s\u00e4hk\u00f6postista.",
    "sv": "Du har tryckt p\u00e5 \"Gl\u00f6mt l\u00f6senord\" flera g\u00e5nger. Anv\u00e4nd det senaste e-postmeddelandet!",
    "fa": "",
    "ar": "",
    "uk": "\u0412\u0438 \u043d\u0430\u0434\u0456\u0441\u043b\u0430\u043b\u0438 \u0437\u0430\u043f\u0438\u0442 \u043d\u0430 \u043a\u0456\u043b\u044c\u043a\u0430 \u0435\u043b\u0435\u043a\u0442\u0440\u043e\u043d\u043d\u0438\u0445 \u043b\u0438\u0441\u0442\u0456\u0432 \"\u0437\u0430\u0431\u0443\u043b\u0438 \u043f\u0430\u0440\u043e\u043b\u044c. \u0411\u0443\u0434\u044c \u043b\u0430\u0441\u043a\u0430, \u0432\u0438\u043a\u043e\u0440\u0438\u0441\u0442\u043e\u0432\u0443\u0439\u0442\u0435 \u043e\u0441\u0442\u0430\u043d\u043d\u0456\u0439 \u0435\u043b\u0435\u043a\u0442\u0440\u043e\u043d\u043d\u0438\u0439 \u043b\u0438\u0441\u0442!\""
  },
  "error_session_invalid_token": {
    "sheet_name": "Shared (API)",
    "en": "Invalid token",
    "ru": "\u043d\u0435\u0432\u0435\u0440\u043d\u044b\u0435 \u0438\u043d\u0434\u0435\u043d\u0442\u0438\u0444\u0438\u043a\u0430\u0442\u043e\u0440",
    "fi": "Virheellinen tunnus",
    "sv": "Ogiltig token",
    "fa": "\u0646\u0634\u0627\u0646 \u0646\u0627\u0645\u0639\u062a\u0628\u0631 \u0627\u0633\u062a",
    "ar": "\u0627\u0644\u0631\u0645\u0632 \u063a\u064a\u0631 \u0635\u0627\u0644\u062d",
    "uk": "\u041d\u0435\u0432\u0456\u0440\u043d\u0438\u0439 \u0456\u0434\u0435\u043d\u0442\u0438\u0444\u0456\u043a\u0430\u0442\u043e\u0440"
  },
  "error_mandatory_primary_address": {
    "sheet_name": "Shared (API)",
    "en": "Please enter your primary address",
    "ru": "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0432\u0430\u0448 \u0430\u0434\u0440\u0435\u0441",
    "fi": "Sy\u00f6t\u00e4th\u00e4n osoitteesi",
    "sv": "V\u00e4nligen ange din adress",
    "fa": "\u0644\u0637\u0641\u0627 \u0622\u062f\u0631\u0633 \u0627\u0635\u0644\u06cc \u062e\u0648\u062f \u0631\u0627 \u0648\u0627\u0631\u062f \u06a9\u0646\u06cc\u062f",
    "ar": "\u064a\u0631\u062c\u0649 \u0625\u062f\u062e\u0627\u0644 \u0639\u0646\u0648\u0627\u0646\u0643",
    "uk": "\u0412\u0432\u0435\u0434\u0456\u0442\u044c \u0432\u0430\u0448\u0443 \u0430\u0434\u0440\u0435\u0441\u0443"
  },
  "error_mandatory_city": {
    "sheet_name": "Shared (API)",
    "en": "Please enter your city",
    "ru": "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0433\u043e\u0440\u043e\u0434!",
    "fi": "Sy\u00f6t\u00e4 kaupunki",
    "sv": "V\u00e4nligen ange din stad",
    "fa": "\u0644\u0637\u0641\u0627 \u0634\u0647\u0631 \u062e\u0648\u062f \u0631\u0627 \u0648\u0627\u0631\u062f \u06a9\u0646\u06cc\u062f",
    "ar": "\u064a\u0631\u062c\u0649 \u0625\u062f\u062e\u0627\u0644 \u0627\u0644\u0645\u062f\u064a\u0646\u0629",
    "uk": "\u0412\u0432\u0435\u0434\u0456\u0442\u044c \u043c\u0456\u0441\u0442\u043e!"
  },
  "error_mandatory_postal_code": {
    "sheet_name": "Shared (API)",
    "en": "Please enter your postal code",
    "ru": "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043f\u043e\u0447\u0442\u043e\u0432\u044b\u0439 \u0438\u043d\u0434\u0435\u043a\u0441!",
    "fi": "Sy\u00f6t\u00e4 postinumero",
    "sv": "V\u00e4nligen ange ditt postnummer",
    "fa": "\u0644\u0637\u0641\u0627 \u0622\u062f\u0631\u0633 \u067e\u0633\u062a\u06cc \u062e\u0648\u062f \u0631\u0627 \u0648\u0627\u0631\u062f \u06a9\u0646\u06cc\u062f",
    "ar": "\u0627\u062f\u062e\u0644 \u0627\u0644\u0631\u0645\u0632 \u0627\u0644\u0628\u0631\u064a\u062f\u064a",
    "uk": "\u0412\u0432\u0435\u0434\u0456\u0442\u044c \u043f\u043e\u0448\u0442\u043e\u0432\u0438\u0439 \u0456\u043d\u0434\u0435\u043a\u0441!"
  },
  "error_profile_unknown_image_format": {
    "sheet_name": "Shared (API)",
    "en": "Unknown image format",
    "ru": "\u041d\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043d\u0430\u044f \u0444\u043e\u0440\u043c\u0430 \u0438\u0437\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u0438\u044f",
    "fi": "Tuntematon kuvamuoto",
    "sv": "Ok\u00e4nt format",
    "fa": "\u062a\u0635\u0648\u06cc\u0631 \u0646\u0627\u0634\u0646\u0627\u062e\u062a\u0647 \u0627\u0633\u062a",
    "ar": "\u062a\u0646\u0633\u064a\u0642 \u0635\u0648\u0631\u0629 \u063a\u064a\u0631 \u0645\u0639\u0631\u0648\u0641",
    "uk": "\u041d\u0435\u0432\u0456\u0434\u043e\u043c\u0430 \u0444\u043e\u0440\u043c\u0430 \u0437\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u043d\u044f"
  },
  "error_profile_mandatory_distance": {
    "sheet_name": "Shared (API)",
    "en": "Please enter the distance",
    "ru": "\u0423\u0441\u0442\u0430\u043d\u043e\u0432\u0438\u0442\u044c \u0440\u0430\u0441\u0441\u0442\u043e\u044f\u043d\u0438\u0435 \u0432 \u043a\u0438\u043b\u043e\u043c\u0435\u0442\u0440\u0430\u0445",
    "fi": "Sy\u00f6t\u00e4 et\u00e4isyys",
    "sv": "St\u00e4ll in avst\u00e5nd",
    "fa": "\u0644\u0637\u0641\u0627 \u0641\u0627\u0635\u0644\u0647 \u0631\u0627 \u0648\u0627\u0631\u062f \u06a9\u0646\u06cc\u062f",
    "ar": "\u064a\u0631\u062c\u0649 \u0625\u062f\u062e\u0627\u0644 \u0627\u0644\u0645\u0633\u0627\u0641\u0629",
    "uk": "\u0412\u0441\u0442\u0430\u043d\u043e\u0432\u0438\u0442\u0438 \u0432\u0456\u0434\u0441\u0442\u0430\u043d\u044c \u0443 \u043a\u0456\u043b\u043e\u043c\u0435\u0442\u0440\u0430\u0445"
  },
  "error_profile_invalid_distance": {
    "sheet_name": "Shared (API)",
    "en": "Invalid distance",
    "ru": "\u041d\u0435\u043f\u0440\u0430\u0432\u0438\u043b\u044c\u043d\u043e\u0435 \u0440\u0430\u0441\u0441\u0442\u043e\u044f\u043d\u0438\u0435",
    "fi": "Virheellinen et\u00e4isyys",
    "sv": "Ogiltigt avst\u00e5nd",
    "fa": "\u0641\u0627\u0635\u0644\u0647 \u0646\u0627\u0645\u0639\u062a\u0628\u0631 \u0627\u0633\u062a",
    "ar": "\u0645\u0633\u0627\u0641\u0629 \u062e\u0627\u0637\u0626\u0647",
    "uk": "\u041d\u0435\u0432\u0456\u0440\u043d\u0430 \u0432\u0456\u0434\u0441\u0442\u0430\u043d\u044c"
  },
  "error_profile_unlimited_distance_not_allowed": {
    "sheet_name": "Shared (API)",
    "en": "Unlimited distance not allowed",
    "ru": "",
    "fi": "Rajoittamaton et\u00e4isyys ei mahdollinen",
    "sv": "Obegr\u00e4nsat avst\u00e5nd till\u00e5ts inte",
    "fa": "",
    "ar": "",
    "uk": "\u043f\u0440\u043e\u0444\u0456\u043b\u044c \u043f\u043e\u043c\u0438\u043b\u043a\u0438 \u043d\u0435\u043e\u0431\u043c\u0435\u0436\u0435\u043d\u0430 \u0432\u0456\u0434\u0441\u0442\u0430\u043d\u044c \u043d\u0435 \u0434\u043e\u043f\u0443\u0441\u043a\u0430\u0454\u0442\u044c\u0441\u044f"
  },
  "error_profile_invalid_bank_account": {
    "sheet_name": "Shared (API)",
    "en": "Invalid bank account",
    "ru": "IBAN \u043d\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043b\u0435\u043d",
    "fi": "Pankkitilinumero on virheellinen",
    "sv": "Fel kontonummer",
    "fa": "\u0634\u0645\u0627\u0631\u0647 \u062d\u0633\u0627\u0628 \u0628\u0627\u0646\u06a9\u06cc IBAN \u0646\u0627\u0645\u0639\u062a\u0628\u0631 \u0627\u0633\u062a",
    "ar": "",
    "uk": "IBAN \u043d\u0435\u0434\u0456\u0439\u0441\u043d\u0438\u0439"
  },
  "error_profile_invalid_tax_amount": {
    "sheet_name": "Shared (API)",
    "en": "Invalid tax percentage",
    "ru": "\u041d\u0435\u043f\u0440\u0430\u0432\u0438\u043b\u044c\u043d\u044b\u0439 \u043d\u0430\u043b\u043e\u0433",
    "fi": "Virheellinen vero%",
    "sv": "Ogiltigt skattesatts",
    "fa": "\u0645\u0628\u0644\u063a \u0646\u0627\u0645\u0639\u062a\u0628\u0631 \u0645\u0627\u0644\u06cc\u0627\u062a",
    "ar": "\u0645\u0628\u0644\u063a \u0627\u0644\u0636\u0631\u064a\u0628\u0629 \u063a\u064a\u0631 \u0635\u0627\u0644\u062d",
    "uk": "\u041d\u0435\u0432\u0456\u0440\u043d\u0438\u0439 \u043f\u043e\u0434\u0430\u0442\u043e\u043a"
  },
  "error_profile_invalid_ssn": {
    "sheet_name": "Shared (API)",
    "en": "Invalid SSN number",
    "ru": "SSN \u043d\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043b\u0435\u043d",
    "fi": "Henkil\u00f6tunnus ei ole oikein",
    "sv": "Ogiltigt personnummer",
    "fa": "\u0634\u0645\u0627\u0631\u0647 SSN \u0646\u0627\u0645\u0639\u062a\u0628\u0631 \u0627\u0633\u062a",
    "ar": "\u0631\u0642\u0645 \u0627\u0644\u062a\u0639\u0631\u064a\u0641 \u0627\u0644\u0634\u062e\u0635\u064a \u063a\u064a\u0631 \u0635\u062d\u064a\u062d",
    "uk": "SSN \u043d\u0435\u0434\u0456\u0439\u0441\u043d\u0438\u0439"
  },
  "error_profile_invalid_ssn_orderer": {
    "sheet_name": "Shared (API)",
    "en": "The worker who you are targeting this order has an invalid SSN. Please ask the worker to fill in the SSN in profile settings.",
    "ru": "",
    "fi": "Tekij\u00e4ll\u00e4, jolle yrit\u00e4t kohdentaa tilausta, on virheellinen henkil\u00f6tunnus. Pyyd\u00e4 tekij\u00e4\u00e4 lis\u00e4\u00e4m\u00e4\u00e4n henkil\u00f6tunnus profiilin asetuksista.",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u041e\u0441\u043e\u0431\u0430, \u044f\u043a\u0456\u0439 \u0432\u0438 \u043d\u0430\u043c\u0430\u0433\u0430\u0454\u0442\u0435\u0441\u044f \u043f\u0440\u0438\u0437\u043d\u0430\u0447\u0438\u0442\u0438 \u0437\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f, \u043c\u0430\u0454 \u043d\u0435\u043f\u0440\u0430\u0432\u0438\u043b\u044c\u043d\u0438\u0439 \u0456\u0434\u0435\u043d\u0442\u0438\u0444\u0456\u043a\u0430\u0442\u043e\u0440.  \u041f\u043e\u043f\u0440\u043e\u0441\u0456\u0442\u044c \u0430\u0432\u0442\u043e\u0440\u0430 \u0434\u043e\u0434\u0430\u0442\u0438 \u043f\u0435\u0440\u0441\u043e\u043d\u0430\u043b\u044c\u043d\u0438\u0439 \u0456\u0434\u0435\u043d\u0442\u0438\u0444\u0456\u043a\u0430\u0442\u043e\u0440 \u0432 \u043d\u0430\u043b\u0430\u0448\u0442\u0443\u0432\u0430\u043d\u043d\u044f\u0445 \u043f\u0440\u043e\u0444\u0456\u043b\u044e."
  },
  "error_profile_invalid_product_tag": {
    "sheet_name": "Shared (API)",
    "en": "Invalid product tag",
    "ru": "",
    "fi": "Virheellinen palvelulaji",
    "sv": "Ogiltig produkt typ",
    "fa": "",
    "ar": "",
    "uk": "\u041d\u0435\u0434\u0456\u0439\u0441\u043d\u0438\u0439 \u0442\u0438\u043f \u043f\u043e\u0441\u043b\u0443\u0433\u0438"
  },
  "error_profile_invalid_organization_type": {
    "sheet_name": "Shared (API)",
    "en": "Invalid organization type",
    "ru": "",
    "fi": "Virheellinen organisaatiotyyppi",
    "sv": "Ogiltig typ av organisation",
    "fa": "",
    "ar": "",
    "uk": "\u041d\u0435\u0434\u0456\u0439\u0441\u043d\u0438\u0439 \u0442\u0438\u043f \u043e\u0440\u0433\u0430\u043d\u0456\u0437\u0430\u0446\u0456\u0457"
  },
  "error_profile_invalid_languages": {
    "sheet_name": "Shared (API)",
    "en": "Invalid languages",
    "ru": "",
    "fi": "Kielitaidoissa on virhe",
    "sv": "Ogiltiga spr\u00e5k",
    "fa": "",
    "ar": "",
    "uk": "\u0404 \u043f\u043e\u043c\u0438\u043b\u043a\u0430 \u0432 \u043d\u0430\u0432\u0438\u0447\u043a\u0430\u0445 \u043c\u043e\u0432\u0438"
  },
  "error_profile_invalid_educations": {
    "sheet_name": "Shared (API)",
    "en": "Invalid educations",
    "ru": "",
    "fi": "Koulutuksissa on virhe",
    "sv": "Ogiltiga utbildningar",
    "fa": "",
    "ar": "",
    "uk": "\u0404 \u043f\u043e\u043c\u0438\u043b\u043a\u0430 \u0432 \u043d\u0430\u0432\u0447\u0430\u043d\u043d\u0456"
  },
  "error_profile_invalid_experiences": {
    "sheet_name": "Shared (API)",
    "en": "Invalid experiences",
    "ru": "\u041d\u0435\u0443\u0434\u0430\u0432\u0448\u0438\u0439\u0441\u044f \u043e\u043f\u044b\u0442",
    "fi": "Kokemuksissa on virhe",
    "sv": "Ogiltiga upplevelser",
    "fa": "\u062a\u062c\u0627\u0631\u0628 \u0646\u0627\u062f\u0631\u0633\u062a",
    "ar": "\u062a\u062c\u0627\u0631\u0628 \u063a\u064a\u0631 \u0635\u0627\u0644\u062d\u0629",
    "uk": "\u0423 \u043f\u0435\u0440\u0435\u0436\u0438\u0432\u0430\u043d\u043d\u044f\u0445 \u0454 \u043d\u0435\u0434\u043e\u043b\u0456\u043a"
  },
  "error_profile_invalid_linked_in_url": {
    "sheet_name": "Shared (API)",
    "en": "Invalid LinkedIn URL (please enter https:\/\/www.linkedin.com\/xx...)",
    "ru": "",
    "fi": "Virheellinen linkki. Linkki on muodossa https:\/\/www.linkedin.com\/xx....",
    "sv": "Felaktig LinkedIn webbadress (https:\/\/www.linkedin.com\/xx...)",
    "fa": "",
    "ar": "",
    "uk": "\u041d\u0435\u0434\u0456\u0439\u0441\u043d\u0435 \u043f\u043e\u0441\u0438\u043b\u0430\u043d\u043d\u044f.  \u041f\u043e\u0441\u0438\u043b\u0430\u043d\u043d\u044f \u0443 \u0444\u043e\u0440\u043c\u0456 https:\/\/www.linkedin.com\/xx...."
  },
  "error_cant_edit_ssn": {
    "sheet_name": "Shared (API)",
    "en": "The SSN can't be edited or deleted, because data of completed orders need to be kept",
    "ru": "",
    "fi": "Henkil\u00f6tunnusta ei voi muokata tai poistaa, sill\u00e4 valmistuneisiin keikkoihin liittyv\u00e4t tiedot pit\u00e4\u00e4 s\u00e4ilytt\u00e4\u00e4",
    "sv": "Det personnummer kan inte redigeras eller raderas, eftersom informationen relaterade till genomf\u00f6rda spelningar m\u00e5ste sparas",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "error_cant_edit_company_reg_number": {
    "sheet_name": "Shared (API)",
    "en": "The company registration number can't be edited or deleted, because data of completed orders need to be kept",
    "ru": "",
    "fi": "Y-tunnusta ei voi muokata tai poistaa, sill\u00e4 valmistuneisiin keikkoihin liittyv\u00e4t tiedot pit\u00e4\u00e4 s\u00e4ilytt\u00e4\u00e4",
    "sv": "F\u00f6retagsregistreringsnumret kan inte redigeras eller raderas, eftersom informationen relaterade till genomf\u00f6rda spelningar m\u00e5ste sparas",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "error_cant_reset_bank_account_number": {
    "sheet_name": "Shared (API)",
    "en": "The bank account number can't be deleted, because data of completed orders need to be kept",
    "ru": "",
    "fi": "Pankkitilinumeroa ei voi poistaa, sill\u00e4 valmistuneisiin keikkoihin liittyv\u00e4t tiedot pit\u00e4\u00e4 s\u00e4ilytt\u00e4\u00e4",
    "sv": "Bankkontonumret kan inte raderas eftersom uppgifter om genomf\u00f6rda best\u00e4llningar m\u00e5ste sparas",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "error_order_mandatory_initial_time": {
    "sheet_name": "Shared (API)",
    "en": "Please enter the initial order time",
    "ru": "\u041f\u043e\u0436\u0430\u043b\u0443\u0439\u0441\u0442\u0430, \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u0432\u0440\u0435\u043c\u044f \u043f\u0435\u0440\u0432\u043e\u043d\u0430\u0447\u0430\u043b\u044c\u043d\u043e\u0433\u043e \u0437\u0430\u043a\u0430\u0437\u0430",
    "fi": "Asetathan tilaukselle aikataulun",
    "sv": "V\u00e4nligen skriv in tid f\u00f6r best\u00e4llning",
    "fa": "\u0644\u0637\u0641\u0627 \u0632\u0645\u0627\u0646 \u0633\u0641\u0627\u0631\u0634 \u0627\u0648\u0644\u06cc\u0647 \u0631\u0627 \u0648\u0627\u0631\u062f \u06a9\u0646\u06cc\u062f",
    "ar": "\u064a\u0631\u062c\u0649 \u0627\u062f\u062e\u0627\u0644 \u0648\u0642\u062a \u0627\u0644\u0637\u0644\u0628 \u0627\u0644\u0627\u0648\u0644\u064a",
    "uk": "\u0411\u0443\u0434\u044c \u043b\u0430\u0441\u043a\u0430, \u0432\u0432\u0435\u0434\u0456\u0442\u044c \u0447\u0430\u0441 \u043f\u043e\u0447\u0430\u0442\u043a\u043e\u0432\u043e\u0433\u043e \u0437\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f"
  },
  "error_order_invalid_duration": {
    "sheet_name": "Shared (API)",
    "en": "Invalid duration",
    "ru": "\u041d\u0435\u0432\u0435\u0440\u043d\u0430\u044f \u043f\u0440\u043e\u0434\u043e\u043b\u0436\u0438\u0442\u0435\u043b\u044c\u043d\u043e\u0441\u0442\u044c",
    "fi": "Virheellinen kesto",
    "sv": "Ogiltig tid",
    "fa": "\u0645\u062f\u062a \u0632\u0645\u0627\u0646 \u0646\u0627\u0645\u0639\u062a\u0628\u0631 \u0627\u0633\u062a",
    "ar": "\u0627\u0644\u0645\u062f\u0629 \u063a\u064a\u0631 \u0635\u0627\u0644\u062d\u0629",
    "uk": "\u041d\u0435\u0432\u0456\u0440\u043d\u0430 \u0442\u0440\u0438\u0432\u0430\u043b\u0456\u0441\u0442\u044c"
  },
  "error_order_edit_has_applicants": {
    "sheet_name": "Shared (API)",
    "en": "Can't edit order because there are applicants already",
    "ru": "\u0417\u0430\u043a\u0430\u0437 \u043d\u0435\u043b\u044c\u0437\u044f \u0438\u0437\u043c\u0435\u043d\u0438\u0442\u044c, \u043f\u043e\u0442\u043e\u043c\u0443 \u0447\u0442\u043e \u0443 \u044d\u0442\u043e\u0433\u043e \u0437\u0430\u043a\u0430\u0437\u0430 \u0443\u0436\u0435 \u0435\u0441\u0442\u044c \u043a\u0430\u043d\u0434\u0438\u0434\u0430\u0442\u044b \u043d\u0430 \u0440\u0430\u0431\u043e\u0442\u0443",
    "fi": "Tilausta ei voi muokata koska sill\u00e4 on jo hakijoita",
    "sv": "Best\u00e4llningen kan inte redigeras eftersom den redan har s\u00f6kande",
    "fa": "\u0627\u0645\u06a9\u0627\u0646 \u062f\u0633\u062a\u06a9\u0627\u0631\u06cc \u0633\u0641\u0627\u0631\u0634 \u0648\u062c\u0648\u062f \u0646\u062f\u0627\u0631\u062f \u0632\u06cc\u0631\u0627 \u0645\u062a\u0642\u0627\u0636\u06cc\u0627\u0646 \u0648\u062c\u0648\u062f \u062f\u0627\u0631\u062f",
    "ar": "\u0644\u0627\u064a\u0645\u0643\u0646 \u062a\u0639\u062f\u064a\u0644 \u0627\u0644\u0627\u0634\u062a\u0631\u0627\u0643 \u0644\u0623\u0646\u0647 \u064a\u062d\u062a\u0648\u064a \u0628\u0627\u0644\u0641\u0639\u0644 \u0639\u0644\u0649 \u0627\u0644\u0645\u062a\u0642\u062f\u0645\u064a\u0646",
    "uk": "\u0417\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f \u043d\u0435 \u043c\u043e\u0436\u043d\u0430 \u0437\u043c\u0456\u043d\u0438\u0442\u0438, \u0442\u043e\u043c\u0443 \u0449\u043e \u0446\u0435 \u0437\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f \u0432\u0436\u0435 \u043c\u0430\u0454 \u043a\u0430\u043d\u0434\u0438\u0434\u0430\u0442\u0456\u0432 \u043d\u0430 \u0440\u043e\u0431\u043e\u0442\u0443"
  },
  "error_order_edit_cancelled": {
    "sheet_name": "Shared (API)",
    "en": "Can't edit order because it's cancelled",
    "ru": "\u0417\u0430\u043a\u0430\u0437 \u043d\u0435\u043b\u044c\u0437\u044f \u0438\u0437\u043c\u0435\u043d\u0438\u0442\u044c, \u043f\u043e\u0442\u043e\u043c\u0443 \u0447\u0442\u043e \u0435\u0433\u043e \u0443\u0436\u0435 \u043e\u0442\u043c\u0435\u043d\u0438\u043b\u0438",
    "fi": "Tilausta ei voi muokata, sill\u00e4 se on peruttu",
    "sv": "Best\u00e4llningen kan inte redigeras eftersom den \u00e4r annulerad",
    "fa": "\u0627\u0645\u06a9\u0627\u0646 \u062f\u0633\u062a\u06a9\u0627\u0631\u06cc \u0633\u0641\u0627\u0631\u0634 \u0648\u062c\u0648\u062f \u0646\u062f\u0627\u0631\u062f \u0632\u06cc\u0631\u0627 \u0644\u063a\u0648 \u0634\u062f\u0647 \u0627\u0633\u062a",
    "ar": "\u0644\u0627\u064a\u0645\u0643\u0646 \u062a\u062d\u0631\u064a\u0631 \u0627\u0644\u0637\u0644\u0628 \u0644\u0627\u0646\u0647 \u062a\u0645 \u0625\u0644\u063a\u0627\u0624\u0647",
    "uk": "\u0417\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f \u043d\u0435 \u043c\u043e\u0436\u043d\u0430 \u0437\u043c\u0456\u043d\u0438\u0442\u0438, \u0431\u043e \u0439\u043e\u0433\u043e \u0432\u0436\u0435 \u0441\u043a\u0430\u0441\u0443\u0432\u0430\u043b\u0438"
  },
  "error_order_cancel": {
    "sheet_name": "Shared (API)",
    "en": "Can't cancel order",
    "ru": "\u0417\u0430\u043a\u0430\u0437 \u0432 \u0442\u0430\u043a\u043e\u043c \u0441\u0442\u0430\u0442\u0443\u0441\u0435 \u043d\u0435\u0432\u043e\u0437\u043c\u043e\u0436\u043d\u043e \u043e\u0442\u043c\u0435\u043d\u0438\u0442\u044c",
    "fi": "Tilausta ei voi perua",
    "sv": "Kan inte annulera order",
    "fa": "\u0633\u0641\u0627\u0631\u0634 \u0644\u063a\u0648 \u0646\u0645\u06cc \u0634\u0648\u062f",
    "ar": "\u0644\u0627 \u064a\u0645\u0643\u0646 \u0625\u0644\u063a\u0627\u0621 \u0627\u0644\u0637\u0644\u0628",
    "uk": "\u0417\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f \u0443 \u0442\u0430\u043a\u043e\u043c\u0443 \u0441\u0442\u0430\u0442\u0443\u0441\u0456 \u043d\u0435\u043c\u043e\u0436\u043b\u0438\u0432\u043e \u0441\u043a\u0430\u0441\u0443\u0432\u0430\u0442\u0438"
  },
  "error_order_selected_worker_not_applicant": {
    "sheet_name": "Shared (API)",
    "en": "Selected worker is not an applicant",
    "ru": "\u0412\u044b\u0431\u0440\u0430\u043d\u043d\u044b\u0439 \u0440\u0430\u0431\u043e\u0442\u043d\u0438\u043a \u043d\u0435 \u043f\u0440\u0435\u0442\u0435\u043d\u0434\u0435\u043d\u0442",
    "fi": "Valittu tekij\u00e4 ei ole hakija",
    "sv": "Den valda utf\u00f6raren \u00e4r inte kandidat",
    "fa": "\u06a9\u0627\u0631\u06af\u0631 \u0645\u0646\u062a\u062e\u0628 \u0645\u062a\u0642\u0627\u0636\u06cc \u0646\u06cc\u0633\u062a",
    "ar": "\u0627\u0644\u0639\u0627\u0645\u0644 \u0627\u0644\u0645\u062e\u062a\u0627\u0631 \u0644\u064a\u0633 \u0627\u0644\u0645\u0633\u062a\u062e\u062f\u0645",
    "uk": "\u0412\u0438\u0431\u0440\u0430\u043d\u0438\u0439 \u043f\u0440\u0430\u0446\u0456\u0432\u043d\u0438\u043a \u043d\u0435 \u043f\u0440\u0435\u0442\u0435\u043d\u0434\u0435\u043d\u0442"
  },
  "error_order_too_young_to_apply": {
    "sheet_name": "Shared (API)",
    "en": "You are not old enough to apply for this task.",
    "ru": "",
    "fi": "Valitettavasti olet viel\u00e4 liian nuori hakeaksesi teht\u00e4viin. Tule takaisin my\u00f6hemmin!",
    "sv": "Tyv\u00e4rr du \u00e4r f\u00f6r ung att anv\u00e4nda service. Kom tillbaks senare!",
    "fa": "",
    "ar": "",
    "uk": "\u0412\u0438\u0431\u0430\u0447\u0442\u0435, \u0432\u0438 \u0437\u0430\u043d\u0430\u0434\u0442\u043e \u043c\u043e\u043b\u043e\u0434\u0456, \u0449\u043e\u0431 \u043a\u043e\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0442\u0438\u0441\u044f \u043f\u043e\u0441\u043b\u0443\u0433\u0430\u043c\u0438.  \u041f\u0440\u0438\u0445\u043e\u0434\u044c\u0442\u0435 \u043f\u0456\u0437\u043d\u0456\u0448\u0435!"
  },
  "error_order_applicant_too_young": {
    "sheet_name": "Shared (API)",
    "en": "The applicant you selected is too young",
    "ru": "",
    "fi": "Valitsemasi hakija on liian nuori",
    "sv": "Den s\u00f6kande du valt \u00e4r f\u00f6r ung",
    "fa": "",
    "ar": "",
    "uk": "\u0412\u0438\u0431\u0440\u0430\u043d\u0438\u0439 \u0432\u0430\u043c\u0438 \u043f\u0440\u0435\u0442\u0435\u043d\u0434\u0435\u043d\u0442 \u0437\u0430\u043d\u0430\u0434\u0442\u043e \u043c\u043e\u043b\u043e\u0434\u0438\u0439"
  },
  "error_order_apply_not_approved": {
    "sheet_name": "Shared (API)",
    "en": "Unfortunately you can't apply because you have not been approved for the service. Please contact customer support.",
    "ru": "",
    "fi": "Voit hakea mahdollisuuksiin vasta kun sinut on hyv\u00e4ksytty palveluun. Odota kunnes hyv\u00e4ksynt\u00e4 valmistuu.",
    "sv": "Tyv\u00e4rr kan du inte s\u00f6ka uppdrag innan du blivit godk\u00e4nd f\u00f6r tj\u00e4nsten. V\u00e4nligen avvakta tills du \u00e4r godk\u00e4nd.",
    "fa": "",
    "ar": "",
    "uk": "\u041d\u0430 \u0436\u0430\u043b\u044c, \u0432\u0438 \u043d\u0435 \u043c\u043e\u0436\u0435\u0442\u0435 \u043f\u043e\u0434\u0430\u0442\u0438 \u0437\u0430\u044f\u0432\u043a\u0443 \u043d\u0430 \u043f\u0440\u0438\u0437\u043d\u0430\u0447\u0435\u043d\u043d\u044f \u0434\u043e \u0442\u043e\u0433\u043e, \u044f\u043a \u0432\u0430\u0441 \u0437\u0430\u0442\u0432\u0435\u0440\u0434\u044f\u0442\u044c \u043d\u0430 \u043f\u043e\u0441\u0430\u0434\u0443.  \u0417\u0430\u0447\u0435\u043a\u0430\u0439\u0442\u0435, \u0434\u043e\u043a\u0438 \u0432\u0430\u0441 \u0441\u0445\u0432\u0430\u043b\u044f\u0442\u044c."
  },
  "error_chat_apply_not_approved": {
    "sheet_name": "Shared (API)",
    "en": "Unfortunately you can't send chat messages because you have not been approved for the service. Please wait for your approval.",
    "ru": "",
    "fi": "Valitettavasti et voi l\u00e4hett\u00e4\u00e4 chat-viestej\u00e4 ennen kuin sinut hyv\u00e4ksyt\u00e4\u00e4n palveluun. Odota kunnes hyv\u00e4ksynt\u00e4 valmistuu.",
    "sv": "Tyv\u00e4r kan du inte skicka chattmeddelanden innan du blivit godk\u00e4nd f\u00f6r tj\u00e4nsten. V\u00e4nligen avvakta tills du \u00e4r godk\u00e4nd.",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "error_order_applicant_not_approved": {
    "sheet_name": "Shared (API)",
    "en": "The worker you selected is waiting for approval to the service. Please wait until approval to this person is completed.",
    "ru": "",
    "fi": "Valitettavasti tekij\u00e4\u00e4, jolle yrit\u00e4t kohdistaa tilauksen ei ole viel\u00e4 hyv\u00e4ksytty palveluun. Odota kunnes henkil\u00f6 on hyv\u00e4ksytty.",
    "sv": "Utf\u00f6raren v\u00e4ntar p\u00e5 ditt godk\u00e4nnande av att anv\u00e4nda tj\u00e4nsten. V\u00e4nligen avvakta tills utf\u00f6raren \u00e4r godk\u00e4nd.",
    "fa": "",
    "ar": "",
    "uk": "\u0412\u0438\u043a\u043e\u043d\u0430\u0432\u0435\u0446\u044c \u0447\u0435\u043a\u0430\u0454 \u0412\u0430\u0448\u043e\u0433\u043e \u0434\u043e\u0437\u0432\u043e\u043b\u0443 \u043d\u0430 \u0432\u0438\u043a\u043e\u0440\u0438\u0441\u0442\u0430\u043d\u043d\u044f \u043f\u043e\u0441\u043b\u0443\u0433\u0438.  \u0411\u0443\u0434\u044c \u043b\u0430\u0441\u043a\u0430, \u0434\u043e\u0447\u0435\u043a\u0430\u0439\u0442\u0435\u0441\u044f \u0437\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043d\u043d\u044f \u0432\u0438\u043a\u043e\u043d\u0430\u0432\u0446\u044f."
  },
  "error_order_already_applied": {
    "sheet_name": "Shared (API)",
    "en": "Already applied for the order",
    "ru": "\u0412\u044b \u0443\u0436\u0435 \u043f\u043e\u0434\u0430\u043b \u0437\u0430\u044f\u0432\u043a\u0443 \u043d\u0430 \u0437\u0430\u043a\u0430\u0437",
    "fi": "Olet jo hakenut teht\u00e4v\u00e4\u00e4n",
    "sv": "Du har redan ans\u00f6kt till uppdraget",
    "fa": "\u0642\u0628\u0644\u0627\u064b \u062f\u0631\u062e\u0648\u0627\u0633\u062a \u0633\u0641\u0627\u0631\u0634 \u062f\u0627\u062f\u0647 \u0627\u06cc\u062f",
    "ar": "\u0644\u0642\u062f \u062a\u0642\u062f\u0645\u062a \u0628\u0627\u0644\u0641\u0639\u0644 \u0628\u0637\u0644\u0628 \u0644\u0644\u062d\u0635\u0648\u0644 \u0639\u0644\u0649 \u0627\u0644\u0648\u0638\u064a\u0641\u0629",
    "uk": "\u0412\u0438 \u0432\u0436\u0435 \u043f\u043e\u0434\u0430\u043b\u0438 \u0437\u0430\u044f\u0432\u043a\u0443 \u043d\u0430 \u0437\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f"
  },
  "error_order_not_applied": {
    "sheet_name": "Shared (API)",
    "en": "Not applied for the order",
    "ru": "\u0412\u044b \u043d\u0435 \u043f\u043e\u0434\u0430\u043b\u0438 \u0437\u0430\u044f\u0432\u043a\u0443 \u043d\u0430 \u0437\u0430\u043a\u0430\u0437",
    "fi": "Et ole hakenut teht\u00e4v\u00e4\u00e4n",
    "sv": "Du har inte ans\u00f6kt till uppdraget",
    "fa": "\u0628\u0631\u0627\u06cc \u0633\u0641\u0627\u0631\u0634 \u0627\u0639\u0645\u0627\u0644 \u0646\u0634\u062f\u0647 \u0627\u0633\u062a",
    "ar": "\u0644\u0645 \u062a\u062a\u0645 \u062a\u062a\u0642\u062f\u0645 \u0628\u0637\u0644\u0628 \u0644\u0647\u0630\u0647 \u0627\u0644\u0648\u0638\u064a\u0641\u0629",
    "uk": "\u0412\u0438 \u043d\u0435 \u043f\u043e\u0434\u0430\u043b\u0438 \u0437\u0430\u044f\u0432\u043a\u0443 \u043d\u0430 \u0437\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f"
  },
  "error_order_already_approved": {
    "sheet_name": "Shared (API)",
    "en": "Order is already approved",
    "ru": "\u0417\u0430\u043a\u0430\u0437 \u0443\u0436\u0435 \u0443\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043d",
    "fi": "Teht\u00e4v\u00e4 on jo hyv\u00e4ksytty",
    "sv": "Uppdraget \u00e4r redan godk\u00e4nnt",
    "fa": "\u0633\u0641\u0627\u0631\u0634 \u0642\u0628\u0644\u0627\u064b \u062a\u0623\u06cc\u06cc\u062f \u0634\u062f\u0647 \u0627\u0633\u062a",
    "ar": "\u062a\u0645 \u0625\u0639\u062a\u0645\u0627\u062f \u0627\u0644\u0637\u0644\u0628 \u0628\u0627\u0644\u0641\u0639\u0644",
    "uk": "\u0417\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f \u0432\u0436\u0435 \u0437\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043d\u043e"
  },
  "error_order_cant_complete": {
    "sheet_name": "Shared (API)",
    "en": "Can't complete order",
    "ru": "\u0417\u0430\u043a\u0430\u0437 \u043d\u0435 \u043c\u043e\u0436\u0435\u0442 \u0431\u044b\u0442\u044c \u0432\u044b\u043f\u043e\u043b\u043d\u0435\u043d \u0434\u043e \u043a\u043e\u043d\u0446\u0430",
    "fi": "Teht\u00e4v\u00e4\u00e4 ei voida suorittaa loppuun",
    "sv": "G\u00e5r inte slutf\u00f6ra uppdraget",
    "fa": "\u0633\u0641\u0627\u0631\u0634 \u06a9\u0627\u0645\u0644 \u0646\u06cc\u0633\u062a",
    "ar": "\u0644\u0627\u064a\u0645\u0643\u0646 \u0625\u0643\u0645\u0627\u0644 \u0627\u0644\u0637\u0644\u0628",
    "uk": "\u0417\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f \u043d\u0435 \u043c\u043e\u0436\u0435 \u0431\u0443\u0442\u0438 \u0432\u0438\u043a\u043e\u043d\u0430\u043d\u0435 \u0434\u043e \u043a\u0456\u043d\u0446\u044f"
  },
  "error_order_invalid_state_change": {
    "sheet_name": "Shared (API)",
    "en": "This status change is not allowed. Please refresh the page to see the actual status of the order.",
    "ru": "",
    "fi": "T\u00e4m\u00e4 statuksen muutos ei ole sallittu. Ole hyv\u00e4 ja p\u00e4ivit\u00e4 sivu n\u00e4hd\u00e4ksesi tilauksen todellisen statuksen.",
    "sv": "Denna status\u00e4ndring \u00e4r inte till\u00e5ten. Uppdatera sidan f\u00f6r att se den faktiska statusen f\u00f6r best\u00e4llningen.",
    "fa": "",
    "ar": "",
    "uk": "\u0426\u044f \u0437\u043c\u0456\u043d\u0430 \u0441\u0442\u0430\u0442\u0443\u0441\u0443 \u043d\u0435 \u0434\u043e\u0437\u0432\u043e\u043b\u0435\u043d\u0430.  \u0411\u0443\u0434\u044c \u043b\u0430\u0441\u043a\u0430, \u043e\u043d\u043e\u0432\u0456\u0442\u044c \u0441\u0442\u043e\u0440\u0456\u043d\u043a\u0443, \u0449\u043e\u0431 \u043f\u043e\u0431\u0430\u0447\u0438\u0442\u0438 \u0444\u0430\u043a\u0442\u0438\u0447\u043d\u0438\u0439 \u0441\u0442\u0430\u0442\u0443\u0441 \u0437\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f."
  },
  "order_status_initialized": {
    "sheet_name": "Shared (API)",
    "en": "Published",
    "ru": "o\u043f\u0443\u0431\u043b\u0438\u043a\u043e\u0432\u0430\u043d",
    "fi": "Julkaistu",
    "sv": "Skapat",
    "fa": "\u0645\u0646\u062a\u0634\u0631 \u0634\u062f\u0647",
    "ar": "\u062a\u0645 \u0627\u0644\u0646\u0634\u0631",
    "uk": "\u043e\u043f\u0443\u0431\u043b\u0456\u043a\u043e\u0432\u0430\u043d\u043e"
  },
  "order_status_in_progress": {
    "sheet_name": "Shared (API)",
    "en": "In progress",
    "ru": "b \u0445\u043e\u0434\u0435 \u0432\u044b\u043f\u043e\u043b\u043d\u0435\u043d\u0438\u044f",
    "fi": "Meneill\u00e4\u00e4n",
    "sv": "P\u00e5g\u00e5ende",
    "fa": "\u062f\u0631 \u062d\u0627\u0644 \u067e\u06cc\u0634 \u0631\u0641\u062a",
    "ar": "\u0641\u064a \u062a\u0642\u062f\u0645",
    "uk": "\u0412 \u0445\u043e\u0434\u0456 \u0432\u0438\u043a\u043e\u043d\u0430\u043d\u043d\u044f"
  },
  "order_status_cancelled_by_worker": {
    "sheet_name": "Shared (API)",
    "en": "Cancelled by worker",
    "ru": "o\u0442\u043c\u0435\u043d\u0435\u043d\u043e \u0440\u0430\u0431\u043e\u0442\u043d\u0438\u043a\u043e\u043c",
    "fi": "Tekij\u00e4 perunut",
    "sv": "Annullerad av utf\u00f6raren",
    "fa": "\u0644\u063a\u0648 \u0634\u062f\u0647 \u062a\u0648\u0633\u0637 \u06a9\u0627\u0631\u06af\u0631",
    "ar": "\u0623\u0644\u063a\u064a \u0645\u0646 \u0642\u0628\u0644 \u0627\u0644\u0639\u0627\u0645\u0644",
    "uk": "\u0441\u043a\u0430\u0441\u043e\u0432\u0430\u043d\u043e \u043f\u0440\u0430\u0446\u0456\u0432\u043d\u0438\u043a\u043e\u043c"
  },
  "order_status_cancelled_by_orderer": {
    "sheet_name": "Shared (API)",
    "en": "Cancelled by orderer",
    "ru": "o\u0442\u043c\u0435\u043d\u0435\u043d\u043e \u0437\u0430\u043a\u0430\u0437\u0447\u0438\u043a\u043e\u043c",
    "fi": "Tilaaja perunut",
    "sv": "Annullerad av best\u00e4llaren",
    "fa": "\u0644\u063a\u0648 \u0634\u062f\u0647 \u062a\u0648\u0633\u0637 \u06a9\u0627\u0631\u06af\u0631",
    "ar": "\u0623\u0644\u063a\u064a\u062a \u0645\u0646 \u0642\u0628\u0644 \u0627\u0644\u0637\u0627\u0644\u0628",
    "uk": "\u0441\u043a\u0430\u0441\u043e\u0432\u0430\u043d\u043e \u0437\u0430\u043c\u043e\u0432\u043d\u0438\u043a\u043e\u043c"
  },
  "order_status_cancelled_by_admin": {
    "sheet_name": "Shared (API)",
    "en": "Cancelled by admin",
    "ru": "O\u0442\u043c\u0435\u043d\u0435\u043d\u043e \u0430\u0434\u043c\u0438\u043d\u0438\u0441\u0442\u0440\u0430\u0442\u043e\u0440\u043e\u043c",
    "fi": "Yll\u00e4pit\u00e4j\u00e4 perunut",
    "sv": "Annullerat av admin",
    "fa": "\u0644\u063a\u0648 \u0634\u062f\u0647 \u062a\u0648\u0633\u0637 \u0645\u062f\u06cc\u0631",
    "ar": "\u0627\u0644\u063a\u0649 \u0627\u0644\u0645\u0634\u0631\u0641",
    "uk": "\u0421\u043a\u0430\u0441\u043e\u0432\u0430\u043d\u043e \u0430\u0434\u043c\u0456\u043d\u0456\u0441\u0442\u0440\u0430\u0442\u043e\u0440\u043e\u043c"
  },
  "order_status_delivered": {
    "sheet_name": "Shared (API)",
    "en": "Delivered",
    "ru": "\u0432\u044b\u043f\u043e\u043b\u043d\u0435\u043d\u0430",
    "fi": "Valmistunut",
    "sv": "Ditt uppdrag \u00e4r avslutat",
    "fa": "\u062a\u062d\u0648\u06cc\u0644 \u062f\u0627\u062f\u0647 \u0634\u062f\u0647",
    "ar": "\u0627\u0643\u0645\u0644\u062a",
    "uk": "\u0432\u0438\u043a\u043e\u043d\u0430\u043d\u043e"
  },
  "order_status_not_approved": {
    "sheet_name": "Shared (API)",
    "en": "Not approved",
    "ru": "h\u0435 \u0443\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043d\u043e",
    "fi": "Hyl\u00e4tty",
    "sv": "Accepteras inte",
    "fa": "\u062a\u0627 \u0647\u0646\u0648\u0632 \u0642\u0628\u0648\u0644 \u0646\u0634\u062f\u0647",
    "ar": "\u0644\u0645 \u062a\u062a\u0645 \u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629",
    "uk": "h\u0435 \u0437\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043d\u043e"
  },
  "order_status_completed": {
    "sheet_name": "Shared (API)",
    "en": "Completed",
    "ru": "\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043d\u043d\u044b\u0439",
    "fi": "Hyv\u00e4ksytty",
    "sv": "Avslutad",
    "fa": "\u062a\u06a9\u0645\u06cc\u0644 \u0634\u062f",
    "ar": "\u0645\u0646\u062c\u0632",
    "uk": "\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043d\u0438\u0439"
  },
  "order_worker_not_in_teams": {
    "sheet_name": "Shared (API)",
    "en": "The worker is not in the selected team(s)",
    "ru": "",
    "fi": "Tekij\u00e4 ei ole mukana valituissa tiimeiss\u00e4",
    "sv": "Utf\u00f6raren \u00e4r inte med i den valda gruppen",
    "fa": "",
    "ar": "",
    "uk": "\u041f\u0440\u0430\u0446\u0456\u0432\u043d\u0438\u043a \u043d\u0435 \u0432\u0445\u043e\u0434\u0438\u0442\u044c \u0434\u043e \u0432\u0438\u0431\u0440\u0430\u043d\u043e\u0457 \u043a\u043e\u043c\u0430\u043d\u0434\u0438"
  },
  "error_order_missing_bank_account": {
    "sheet_name": "Shared (API)",
    "en": "Bank account in profile must be entered to proceed.",
    "ru": "",
    "fi": "Pankkitili profiilissa on sy\u00f6tett\u00e4v\u00e4 ensin.",
    "sv": "Ange bankkonto i din profil f\u00f6rst",
    "fa": "",
    "ar": "",
    "uk": "\u0429\u043e\u0431 \u043f\u0440\u043e\u0434\u043e\u0432\u0436\u0438\u0442\u0438, \u043f\u043e\u0442\u0440\u0456\u0431\u043d\u043e \u0432\u0432\u0435\u0441\u0442\u0438 \u0431\u0430\u043d\u043a\u0456\u0432\u0441\u044c\u043a\u0438\u0439 \u0440\u0430\u0445\u0443\u043d\u043e\u043a \u0443 \u043f\u0440\u043e\u0444\u0456\u043b\u0456."
  },
  "error_order_missing_tax_amount": {
    "sheet_name": "Shared (API)",
    "en": "Tax rate in profile must be entered to proceed.",
    "ru": "",
    "fi": "Veroprosentti profiilissa on sy\u00f6tett\u00e4v\u00e4 ensin.",
    "sv": "Ange skattesatsen i din profilen f\u00f6rst",
    "fa": "",
    "ar": "",
    "uk": "\u0414\u043b\u044f \u043f\u0440\u043e\u0434\u043e\u0432\u0436\u0435\u043d\u043d\u044f \u043f\u043e\u0442\u0440\u0456\u0431\u043d\u043e \u0432\u0432\u0435\u0441\u0442\u0438 \u0441\u0442\u0430\u0432\u043a\u0443 \u043f\u043e\u0434\u0430\u0442\u043a\u0443 \u0432 \u043f\u0440\u043e\u0444\u0456\u043b\u0456."
  },
  "error_order_missing_company_number": {
    "sheet_name": "Shared (API)",
    "en": "Company details must be entered in profile to proceed.",
    "ru": "",
    "fi": "T\u00e4m\u00e4n teht\u00e4v\u00e4n hakemiseen vaaditaan profiilissa yritysmalli. Sy\u00f6t\u00e4 yritystietosi, jotta voit hakea t\u00e4h\u00e4n.",
    "sv": "Ange ditt f\u00f6retag information i din profilen f\u00f6rst",
    "fa": "",
    "ar": "",
    "uk": "\u0429\u043e\u0431 \u043f\u0440\u043e\u0434\u043e\u0432\u0436\u0438\u0442\u0438, \u043d\u0435\u043e\u0431\u0445\u0456\u0434\u043d\u043e \u0432\u0432\u0435\u0441\u0442\u0438 \u0434\u0430\u043d\u0456 \u043a\u043e\u043c\u043f\u0430\u043d\u0456\u0457 \u0432 \u043f\u0440\u043e\u0444\u0456\u043b\u0456."
  },
  "error_order_missing_ssn": {
    "sheet_name": "Shared (API)",
    "en": "SSN in profile must be entered to proceed.",
    "ru": "",
    "fi": "Henkil\u00f6tunnus on sy\u00f6tett\u00e4v\u00e4 ensin.",
    "sv": "Ange ditt personnummer\/SSN i \u200b\u200bdin profil f\u00f6rst",
    "fa": "",
    "ar": "",
    "uk": "\u0429\u043e\u0431 \u043f\u0440\u043e\u0434\u043e\u0432\u0436\u0438\u0442\u0438, \u043f\u043e\u0442\u0440\u0456\u0431\u043d\u043e \u0432\u0432\u0435\u0441\u0442\u0438 SSN \u0443 \u043f\u0440\u043e\u0444\u0456\u043b\u0456."
  },
  "error_order_missing_ssn_orderer": {
    "sheet_name": "Shared (API)",
    "en": "The worker who you are targeting this order has no SSN. Please ask the worker to fill in the SSN in profile settings and check that they also have bank account number and worker type set.",
    "ru": "",
    "fi": "Tekij\u00e4, jolle yrit\u00e4t kohdentaa tilausta, ei ole sy\u00f6tt\u00e4nyt profiiliin henkil\u00f6tunnusta. Pyyd\u00e4 tekij\u00e4\u00e4 lis\u00e4\u00e4m\u00e4\u00e4n henkil\u00f6tunnus profiilin asetuksista sek\u00e4 samalla tarkistamaan onhan h\u00e4nell\u00e4 my\u00f6s pankkitilinumero ja sopimusmalli asetettuna.",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u041f\u0440\u0430\u0446\u0456\u0432\u043d\u0438\u043a, \u043d\u0430 \u044f\u043a\u043e\u0433\u043e \u0432\u0438 \u043d\u0430\u0446\u0456\u043b\u044e\u0454\u0442\u0435 \u0446\u0435 \u0437\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f, \u043d\u0435 \u043c\u0430\u0454 \u0441\u043e\u0446\u0456\u0430\u043b\u044c\u043d\u043e\u0433\u043e \u0441\u0442\u0440\u0430\u0445\u0443\u0432\u0430\u043d\u043d\u044f.  \u0411\u0443\u0434\u044c \u043b\u0430\u0441\u043a\u0430, \u043f\u043e\u043f\u0440\u043e\u0441\u0456\u0442\u044c \u043f\u0440\u0430\u0446\u0456\u0432\u043d\u0438\u043a\u0430 \u0437\u0430\u043f\u043e\u0432\u043d\u0438\u0442\u0438 SSN \u0432 \u043d\u0430\u043b\u0430\u0448\u0442\u0443\u0432\u0430\u043d\u043d\u044f\u0445 \u043f\u0440\u043e\u0444\u0456\u043b\u044e."
  },
  "error_order_missing_worker_type_worker": {
    "sheet_name": "Shared (API)",
    "en": "Please set your worker type in your profile",
    "ru": "",
    "fi": "Aseta sopimusmuoto profiiliisi",
    "sv": "V\u00e4nligen ange din typ av arbetare i profilen",
    "fa": "",
    "ar": "",
    "uk": "\u0411\u0443\u0434\u044c \u043b\u0430\u0441\u043a\u0430, \u0432\u043a\u0430\u0436\u0456\u0442\u044c \u0442\u0438\u043f \u043f\u0440\u0430\u0446\u0456\u0432\u043d\u0438\u043a\u0430 \u0443 \u0441\u0432\u043e\u0454\u043c\u0443 \u043f\u0440\u043e\u0444\u0456\u043b\u0456"
  },
  "error_order_missing_worker_type_orderer": {
    "sheet_name": "Shared (API)",
    "en": "The worker who you are targeting this order has no worker type set in their profile. Please ask the worker to fill in the worker type in profile settings and check that they also have bank account number and SSN set.",
    "ru": "",
    "fi": "Tekij\u00e4, jolle yrit\u00e4t kohdentaa tilausta, ei ole valinnut profiilille sopimusmuotoa. Pyyd\u00e4 tekij\u00e4\u00e4 lis\u00e4\u00e4m\u00e4\u00e4n sopimusmuoto profiilin asetuksista sek\u00e4 samalla tarkistamaan onhan h\u00e4nell\u00e4 my\u00f6s henkil\u00f6tunnus ja pankkitilinumero asetettuna.",
    "sv": "Be arbetaren att st\u00e4lla in sin arbetartyp i profilen",
    "fa": "",
    "ar": "",
    "uk": "\u0411\u0443\u0434\u044c \u043b\u0430\u0441\u043a\u0430, \u043f\u043e\u043f\u0440\u043e\u0441\u0456\u0442\u044c \u043f\u0440\u0430\u0446\u0456\u0432\u043d\u0438\u043a\u0430 \u0432\u0441\u0442\u0430\u043d\u043e\u0432\u0438\u0442\u0438 \u0442\u0438\u043f \u043f\u0440\u0430\u0446\u0456\u0432\u043d\u0438\u043a\u0430 \u0432 \u043f\u0440\u043e\u0444\u0456\u043b\u0456"
  },
  "error_product_is_deleted": {
    "sheet_name": "Shared (API)",
    "en": "The product is marked as deleted",
    "ru": "",
    "fi": "Tuote on merkitty poistetuksi",
    "sv": "Produkten har markerats som borttagen",
    "fa": "",
    "ar": "",
    "uk": "\u0422\u043e\u0432\u0430\u0440 \u043f\u043e\u0437\u043d\u0430\u0447\u0435\u043d\u043e \u044f\u043a \u0432\u0438\u0434\u0430\u043b\u0435\u043d\u0438\u0439"
  },
  "error_chat_self_message": {
    "sheet_name": "Shared (API)",
    "en": "It's not allowed to send chat message to yourself",
    "ru": "",
    "fi": "Eth\u00e4n l\u00e4het\u00e4 chattia itsellesi ;-)",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u041d\u0435 \u0434\u043e\u0437\u0432\u043e\u043b\u0435\u043d\u043e \u043d\u0430\u0434\u0441\u0438\u043b\u0430\u0442\u0438 \u043f\u043e\u0432\u0456\u0434\u043e\u043c\u043b\u0435\u043d\u043d\u044f \u0447\u0430\u0442\u0443 \u0441\u0430\u043c\u043e\u043c\u0443 \u0441\u043e\u0431\u0456"
  },
  "error_duration_cant_be_modified": {
    "sheet_name": "Shared (API)",
    "en": "The duration can't be modified",
    "ru": "",
    "fi": "Kestoa ei voi muokata",
    "sv": "Varaktighet kan inte \u00e4ndras",
    "fa": "",
    "ar": "",
    "uk": "\u0422\u0440\u0438\u0432\u0430\u043b\u0456\u0441\u0442\u044c \u043d\u0435 \u043c\u043e\u0436\u043d\u0430 \u0437\u043c\u0456\u043d\u0438\u0442\u0438"
  },
  "error_cannot_target_yourself": {
    "sheet_name": "Shared (API)",
    "en": "You cannot target the order to yourself! Please remove your email address from the targeting field to publish the order.",
    "ru": "",
    "fi": "Et voi kohdentaa tilausta itsellesi! Ole hyv\u00e4 ja poista s\u00e4hk\u00f6postiosoitteesi kohdennuskent\u00e4st\u00e4, jotta voit julkaista tilauksen.",
    "sv": "Du kan inte rikta best\u00e4llningen till dig sj\u00e4lv! Ta bort din e-postadress fr\u00e5n inriktningsf\u00e4ltet f\u00f6r att publicera best\u00e4llningen.",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "error_teams_invalid_code": {
    "sheet_name": "Shared (API)",
    "en": "Invalid private team code",
    "ru": "\u041d\u0435\u0432\u0435\u0440\u043d\u044b\u0439 \u043a\u043e\u0434 \u0447\u0430\u0441\u0442\u043d\u043e\u0439 \u0433\u0440\u0443\u043f\u043f\u044b",
    "fi": "Virheellinen yksityisen ryhm\u00e4n koodi",
    "sv": "Ogiltig privat gruppkod",
    "fa": "\u06a9\u0648\u062f \u062a\u06cc\u0645 \u062e\u0635\u0648\u0635\u06cc \u0646\u0627\u0645\u0639\u062a\u0628\u0631 \u0627\u0633\u062a",
    "ar": "\u0631\u0645\u0632 \u0627\u0644\u0645\u062c\u0645\u0648\u0639\u0647 \u0627\u0644\u062e\u0627\u0635 \u063a\u064a\u0631 \u0635\u0627\u0644\u062d",
    "uk": "\u041d\u0435\u0432\u0456\u0440\u043d\u0438\u0439 \u043a\u043e\u0434 \u043f\u0440\u0438\u0432\u0430\u0442\u043d\u043e\u0457 \u0433\u0440\u0443\u043f\u0438"
  },
  "error_teams_code_invalid_format": {
    "sheet_name": "Shared (API)",
    "en": "Team code should be 5 characters, without space",
    "ru": "",
    "fi": "Ryhm\u00e4koodi on 5 merkki\u00e4 ilman v\u00e4lily\u00f6ntej\u00e4",
    "sv": "Gruppkoden ska inneh\u00e5lla 5 tecken utan mellanrum",
    "fa": "",
    "ar": "",
    "uk": "\u041a\u043e\u0434 \u0433\u0440\u0443\u043f\u0438 \u043f\u043e\u0432\u0438\u043d\u0435\u043d \u0441\u043a\u043b\u0430\u0434\u0430\u0442\u0438\u0441\u044f \u0437 5 \u0441\u0438\u043c\u0432\u043e\u043b\u0456\u0432, \u0431\u0435\u0437 \u043f\u0440\u043e\u0431\u0456\u043b\u0456\u0432"
  },
  "error_teams_invalid_id": {
    "sheet_name": "Shared (API)",
    "en": "Invalid team resource ID",
    "ru": "\u041d\u0435\u0432\u0435\u0440\u043d\u044b\u0439 \u0438\u0434\u0435\u043d\u0442\u0438\u0444\u0438\u043a\u0430\u0442\u043e\u0440 \u0440\u0435\u0441\u0443\u0440\u0441\u0430 \u0433\u0440\u0443\u043f\u043f\u044b",
    "fi": "Virheellinen ryhm\u00e4n koodi",
    "sv": "Ogiltig gruppkod",
    "fa": "\u0622\u06cc\u062f\u06cc \u0645\u0646\u0628\u0639 \u062a\u06cc\u0645 \u0646\u0627\u0645\u0639\u062a\u0628\u0631 \u0627\u0633\u062a",
    "ar": "\u0631\u0645\u0632 \u0627\u0644\u0645\u062c\u0645\u0648\u0639\u0647 \u063a\u064a\u0631 \u0635\u0627\u0644\u062d",
    "uk": "\u041d\u0435\u0432\u0456\u0440\u043d\u0438\u0439 \u0456\u0434\u0435\u043d\u0442\u0438\u0444\u0456\u043a\u0430\u0442\u043e\u0440 \u043a\u043e\u043c\u0430\u043d\u0434\u043d\u043e\u0433\u043e \u0440\u0435\u0441\u0443\u0440\u0441\u0443"
  },
  "error_teams_reached_teams_limit": {
    "sheet_name": "Shared (API)",
    "en": "Limit of teams reached",
    "ru": "",
    "fi": "Ilmaisten ryhmien maksimim\u00e4\u00e4r\u00e4 saavutettu",
    "sv": "Maximalt antal gratislag uppn\u00e5dd",
    "fa": "",
    "ar": "",
    "uk": "\u041b\u0456\u043c\u0456\u0442 \u0433\u0440\u0443\u043f\u0438 \u0434\u043e\u0441\u044f\u0433\u043d\u0443\u0442\u043e"
  },
  "error_teams_reached_member_limit": {
    "sheet_name": "Shared (API)",
    "en": "Limit of free team members reached",
    "ru": "",
    "fi": "Ilmaisten ryhm\u00e4j\u00e4senten maksimim\u00e4\u00e4r\u00e4 on saavutettu",
    "sv": "Maximalt antal lagmedlemmar uppn\u00e5dd",
    "fa": "",
    "ar": "",
    "uk": "\u0414\u043e\u0441\u044f\u0433\u043d\u0443\u0442\u043e \u043b\u0456\u043c\u0456\u0442 \u0431\u0435\u0437\u043a\u043e\u0448\u0442\u043e\u0432\u043d\u0438\u0445 \u0447\u043b\u0435\u043d\u0456\u0432 \u0433\u0440\u0443\u043f\u0438"
  },
  "error_teams_email_does_not_exist": {
    "sheet_name": "Shared (API)",
    "en": "No user is found with this email address in this service",
    "ru": "",
    "fi": "T\u00e4ll\u00e4 s\u00e4hk\u00f6postiosoitteella ei l\u00f6ydy k\u00e4ytt\u00e4j\u00e4\u00e4 t\u00e4st\u00e4 palvelusta",
    "sv": "Ingen anv\u00e4ndare kan hittas p\u00e5 denna tj\u00e4nst med denna e-postadress",
    "fa": "",
    "ar": "",
    "uk": "\u0415\u043b\u0435\u043a\u0442\u0440\u043e\u043d\u043d\u0430 \u043f\u043e\u0448\u0442\u0430 \u043d\u0435 \u0456\u0441\u043d\u0443\u0454 \u0432 \u0441\u0435\u0440\u0432\u0456\u0441\u0456"
  },
  "error_order_amount_smaller_than_the_minimum": {
    "sheet_name": "Shared (API)",
    "en": "Unfortunately, the order can't be published, because the price is lower than the minimum requirement %s%d. Please change the amount and try again.",
    "ru": "",
    "fi": "Valitettavasti tilausta ei voida julkaista, sill\u00e4 hinta on alhaisempi kuin minimivaatimus %s%d. Muuta tilauksen summaa ja kokeile sitten uudestaan.",
    "sv": "Tyv\u00e4rr kan best\u00e4llningen inte publiceras eftersom priset \u00e4r l\u00e4gre \u00e4n minimikravet %s%d. \u00c4ndra beloppet och f\u00f6rs\u00f6k igen.",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "error_pp_amount_too_small": {
    "sheet_name": "Shared (API)",
    "en": "The minimum amount of PilotPoints is %d",
    "ru": "\u041c\u0438\u043d\u0438\u043c\u0430\u043b\u044c\u043d\u0430\u044f \u0441\u0443\u043c\u043c\u0430 %d",
    "fi": "PilotPointsejen minimim\u00e4\u00e4r\u00e4 on %d",
    "sv": "Minsta summa PilotPoints \u00e4r %d",
    "fa": "\u062d\u062f\u0627\u0642\u0644 \u0645\u0642\u062f\u0627\u0631 PilotPoints \u06a9\u0647 \u0645\u06cc \u062a\u0648\u0627\u0646\u06cc\u062f \u0627\u0647\u062f\u0627 \u06a9\u0646\u06cc\u062f%d \u0627\u0633\u062a",
    "ar": "\u0627\u0644\u062d\u062f \u0627\u0644\u0627\u062f\u0646\u0649 \u0645\u0646 \u0646\u0642\u0627\u0637  PilotPoints \u0627\u0644\u062a\u064a \u064a\u0645\u0643\u0646\u0643 \u0627\u0644\u062a\u0628\u0631\u0639 \u0628\u0647\u0627 %d",
    "uk": "\u041c\u0456\u043d\u0456\u043c\u0430\u043b\u044c\u043d\u0430 \u043a\u0456\u043b\u044c\u043a\u0456\u0441\u0442\u044c PilotPoints \u0441\u0442\u0430\u043d\u043e\u0432\u0438\u0442\u044c %d"
  },
  "error_pp_amount_not_whole": {
    "sheet_name": "Shared (API)",
    "en": "PilotPoint must be a whole number",
    "ru": "\u041a\u043e\u043b\u0438\u0447\u0435\u0441\u0442\u0432\u043e \u0434\u043e\u043b\u0436\u043d\u043e \u0431\u044b\u0442\u044c \u0446\u0435\u043b\u044b\u043c \u0447\u0438\u0441\u043b\u043e\u043c",
    "fi": "PilotPointsien m\u00e4\u00e4r\u00e4n t\u00e4ytyy olla kokonaisluku",
    "sv": "PilotPoints m\u00e5ste vara ett heltal",
    "fa": "\u0627\u06cc\u0646 PilotPoint\u0628\u0627\u06cc\u062f \u06cc\u06a9 \u0639\u062f\u062f \u06a9\u0627\u0645\u0644 \u0628\u0627\u0634\u062f",
    "ar": "\u064a\u062c\u0628 \u0627\u0646 \u064a\u0643\u0648\u0646  PilotPoints \u0639\u062f\u062f\u0627 \u0635\u062d\u064a\u062d\u0627",
    "uk": "PilotPoint \u043c\u0430\u0454 \u0431\u0443\u0442\u0438 \u0446\u0456\u043b\u0438\u043c \u0447\u0438\u0441\u043b\u043e\u043c"
  },
  "error_pp_not_enough": {
    "sheet_name": "Shared (API)",
    "en": "Unfortunately, you do not have enough PilotPoints",
    "ru": "\u041d\u0435\u0434\u043e\u0441\u0442\u0430\u0442\u043e\u0447\u043d\u043e PilotPoints!",
    "fi": "Sinulla ei ole riitt\u00e4v\u00e4sti PilotPointseja",
    "sv": "Du har inte tillr\u00e4ckligt m\u00e5nga PilotPoints",
    "fa": "\u0645\u062a\u0623\u0633\u0641\u0627\u0646\u0647 \u062f\u0631 \u06a9\u0627\u0631\u062a \u0634\u0645\u0627 \u0645\u0634\u06a9\u0644\u06cc \u067e\u06cc\u0634 \u0622\u0645\u062f. \u0644\u0637\u0641\u0627 \u062f\u0631 \u0645\u0648\u0631\u062f \u0627\u06cc\u0646 \u0645\u0634\u06a9\u0644 \u0628\u0627 \u0635\u0627\u062f\u0631\u06a9\u0646\u0646\u062f\u0647 \u06a9\u0627\u0631\u062a \u062e\u0648\u062f \u062a\u0645\u0627\u0633 \u0628\u06af\u06cc\u0631\u06cc\u062f.",
    "ar": "",
    "uk": "\u041d\u0430 \u0436\u0430\u043b\u044c, \u0443 \u0432\u0430\u0441 \u043d\u0435\u0434\u043e\u0441\u0442\u0430\u0442\u043d\u044c\u043e PilotPoints"
  },
  "error_pp_invalid_invitation_code": {
    "sheet_name": "Shared (API)",
    "en": "Invalid invitation code",
    "ru": "\u041d\u0435\u0432\u0435\u0440\u043d\u044b\u0439 \u043a\u043e\u0434 \u043f\u0440\u0438\u0433\u043b\u0430\u0448\u0435\u043d\u0438\u044f",
    "fi": "Virheellinen kutsukoodi",
    "sv": "Ogiltig inbjudningskod",
    "fa": "\u06a9\u0648\u062f \u062f\u0639\u0648\u062a \u0646\u0627\u0645\u0639\u062a\u0628\u0631 \u0627\u0633\u062a",
    "ar": "\u0631\u0645\u0632 \u0627\u0644\u062f\u0639\u0648\u0647 \u063a\u064a\u0631 \u0635\u0627\u0644\u062d",
    "uk": "\u041d\u0435\u0432\u0456\u0440\u043d\u0438\u0439 \u043a\u043e\u0434 \u0437\u0430\u043f\u0440\u043e\u0448\u0435\u043d\u043d\u044f"
  },
  "error_pp_different_merchant_for_donations": {
    "sheet_name": "Shared (API)",
    "en": "PilotPoints can't be transferred to a different service",
    "ru": "",
    "fi": "PilotPointseja ei voi siirt\u00e4\u00e4 eri palveluun",
    "sv": "PilotPoints kan inte delas ut till en annan tj\u00e4nst",
    "fa": "",
    "ar": "",
    "uk": "PilotPoints \u043d\u0435 \u043c\u043e\u0436\u043d\u0430 \u043f\u0435\u0440\u0435\u0434\u0430\u0432\u0430\u0442\u0438 \u043d\u0430 \u0456\u043d\u0448\u0438\u0439 \u0441\u0435\u0440\u0432\u0456\u0441"
  },
  "error_billing_mandatory_email_or_invoice": {
    "sheet_name": "Shared (API)",
    "en": "The billing email or the business ID and invoice details are mandatory",
    "ru": "",
    "fi": "Laskutuss\u00e4hk\u00f6posti tai Y-tunnus ja laskutustiedot ovat pakollisia tietoja",
    "sv": "Faktureringsmailet eller f\u00f6retags-ID och fakturauppgifter \u00e4r obligatoriska",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "error_payment_not_allowed_billing": {
    "sheet_name": "Shared (API)",
    "en": "Not allowed to user billing payment type",
    "ru": "\u041d\u0435\u0442 \u043f\u0440\u0430\u0432\u0430 \u043d\u0430 \u0432\u044b\u0441\u0442\u0430\u0432\u043b\u0435\u043d\u0438\u0435 \u0441\u0447\u0435\u0442\u0430",
    "fi": "Ei laskutusoikeutta",
    "sv": "Inga faktureringsr\u00e4ttigheter",
    "fa": "\u0646\u0648\u0639 \u067e\u0631\u062f\u0627\u062e\u062a \u0628\u0647 \u0635\u0648\u0631\u062a\u062d\u0633\u0627\u0628 \u06a9\u0627\u0631\u0628\u0631 \u0645\u062c\u0627\u0632 \u0646\u06cc\u0633\u062a",
    "ar": "\u063a\u064a\u0631 \u0645\u0633\u0645\u0648\u062d \u0644\u0644\u0645\u0633\u062a\u062e\u062f\u0645 \u062f\u0641\u0639 \u0627\u0644\u0641\u0648\u0627\u062a\u064a\u0631",
    "uk": "\u041d\u0435 \u0434\u043e\u0437\u0432\u043e\u043b\u0435\u043d\u043e \u0432\u0438\u043a\u043e\u0440\u0438\u0441\u0442\u043e\u0432\u0443\u0432\u0430\u0442\u0438 \u0442\u0438\u043f \u043e\u043f\u043b\u0430\u0442\u0438 \u0440\u0430\u0445\u0443\u043d\u043a\u0456\u0432 \u043a\u043e\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0456\u0432"
  },
  "error_payment_no_credit_cards": {
    "sheet_name": "Shared (API)",
    "en": "No credit cards added yet",
    "ru": "\u041d\u0438 \u043e\u0434\u043d\u043e\u0439 \u043a\u0430\u0440\u0442\u044b \u0435\u0449\u0435 \u043d\u0435 \u0434\u043e\u0431\u0430\u0432\u043b\u0435\u043d\u043e",
    "fi": "Maksukorttia ei viel\u00e4 lis\u00e4tty",
    "sv": "Inget betalkort tillagt",
    "fa": "\u0647\u0646\u0648\u0632 \u06a9\u0627\u0631\u062a \u0627\u0639\u062a\u0628\u0627\u0631\u06cc \u0627\u0636\u0627\u0641\u0647 \u0646\u0634\u062f\u0647 \u0627\u0633\u062a",
    "ar": "\u0644\u0645 \u062a\u062a\u0645 \u0625\u0636\u0627\u0641\u0629 \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0627\u0626\u062a\u0645\u0627\u0646 \u0628\u0639\u062f",
    "uk": "\u0429\u0435 \u043d\u0435 \u0434\u043e\u0434\u0430\u043d\u043e \u043a\u0440\u0435\u0434\u0438\u0442\u043d\u0438\u0445 \u043a\u0430\u0440\u0442\u043e\u043a"
  },
  "error_payment_invalid_card_id": {
    "sheet_name": "Shared (API)",
    "en": "Invalid card ID",
    "ru": "\u041d\u0435\u043f\u0440\u0430\u0432\u0438\u043b\u044c\u043d\u044b\u0439 \u043d\u043e\u043c\u0435\u0440 \u043a\u0440\u0435\u0434\u0438\u0442\u043d\u043e\u0439 \u043a\u0430\u0440\u0442\u044b.",
    "fi": "Virheellinen korttinumero",
    "sv": "Felaktigt kortnummer",
    "fa": "\u0634\u0645\u0627\u0631\u0647 \u06a9\u0627\u0631\u062a \u0646\u0627\u0645\u0639\u062a\u0628\u0631 \u0627\u0633\u062a",
    "ar": "\u0645\u0639\u0631\u0641 \u0627\u0644\u0628\u0637\u0627\u0642\u0647 \u063a\u064a\u0631 \u0635\u0627\u0644\u062d",
    "uk": "\u041d\u0435\u043f\u0440\u0430\u0432\u0438\u043b\u044c\u043d\u0438\u0439 \u0456\u0434\u0435\u043d\u0442\u0438\u0444\u0456\u043a\u0430\u0442\u043e\u0440 \u043a\u0430\u0440\u0442\u043a\u0438"
  },
  "error_payment_reservation_needed": {
    "sheet_name": "Shared (API)",
    "en": "Card reservation is needed",
    "ru": "",
    "fi": "Korttimaksun katevaraus puuttuu",
    "sv": "En kortreservation kommer beh\u00f6vas",
    "fa": "",
    "ar": "",
    "uk": "\u041f\u043e\u0442\u0440\u0456\u0431\u043d\u0435 \u0440\u0435\u0437\u0435\u0440\u0432\u0443\u0432\u0430\u043d\u043d\u044f \u043a\u0430\u0440\u0442\u043a\u0438"
  },
  "error_payment_unknown": {
    "sheet_name": "Shared (API)",
    "en": "Unfortunately there was a problem with your card. Please contact your card issuer about this problem.",
    "ru": "\u041a \u0441\u043e\u0436\u0430\u043b\u0435\u043d\u0438\u044e, \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u0435\u0442 \u043f\u0440\u043e\u0431\u043b\u0435\u043c\u0430 \u0441 \u043e\u043f\u043b\u0430\u0442\u043e\u0439. \u041f\u043e\u0436\u0430\u043b\u0443\u0439\u0441\u0442\u0430, \u0441\u0432\u044f\u0436\u0438\u0442\u0435\u0441\u044c \u0441 \u044d\u043c\u0438\u0442\u0435\u043d\u0442\u043e\u043c \u0432\u0430\u0448\u0435\u0439 \u043a\u0430\u0440\u0442\u044b \u043e \u043f\u0440\u043e\u0431\u043b\u0435\u043c\u0435.",
    "fi": "Kortissasi ilmeni ongelma. Otathan yhteytt\u00e4 kortin my\u00f6nt\u00e4j\u00e4\u00e4n ongelmasta.",
    "sv": "Det var ett problem med ditt kort. Kontakta din kortutgivare om problemet.",
    "fa": "\u0645\u062a\u0623\u0633\u0641\u0627\u0646\u0647 \u062f\u0631 \u06a9\u0627\u0631\u062a \u0634\u0645\u0627 \u0645\u0634\u06a9\u0644\u06cc \u067e\u06cc\u0634 \u0622\u0645\u062f. \u0644\u0637\u0641\u0627 \u062f\u0631 \u0645\u0648\u0631\u062f \u0627\u06cc\u0646 \u0645\u0634\u06a9\u0644 \u0628\u0627 \u0635\u0627\u062f\u0631\u06a9\u0646\u0646\u062f\u0647 \u06a9\u0627\u0631\u062a \u062e\u0648\u062f \u062a\u0645\u0627\u0633 \u0628\u06af\u06cc\u0631\u06cc\u062f.",
    "ar": "\u0644\u0644\u0623\u0633\u0641 \u062d\u062f\u062b\u062a \u0645\u0634\u0643\u0644\u0647 \u0641\u064a \u0628\u0637\u0627\u0642\u062a\u0643. \u064a\u0631\u062c\u0649 \u0627\u0644\u0627\u062a\u0635\u0627\u0644 \u0628\u062c\u0647\u0629 \u0627\u0635\u062f\u0627\u0631 \u0628\u0637\u0627\u0642\u062a\u0643 \u0628\u0634\u0623\u0646 \u0647\u0630\u0647 \u0627\u0644\u0645\u0634\u0643\u0644\u0647",
    "uk": "\u041d\u0430 \u0436\u0430\u043b\u044c, \u0437 \u0432\u0430\u0448\u043e\u044e \u043a\u0430\u0440\u0442\u043a\u043e\u044e \u0432\u0438\u043d\u0438\u043a\u043b\u0430 \u043f\u0440\u043e\u0431\u043b\u0435\u043c\u0430. \u041f\u0440\u043e \u0446\u044e \u043f\u0440\u043e\u0431\u043b\u0435\u043c\u0443 \u0437\u0432\u0435\u0440\u0442\u0430\u0439\u0442\u0435\u0441\u044f \u0434\u043e \u0432\u0430\u0448\u043e\u0433\u043e \u0431\u0430\u043d\u043a\u0443"
  },
  "error_payment_unknown_card": {
    "sheet_name": "Shared (API)",
    "en": "Unfortunately there was a problem with your card. Please contact your card issuer about this problem.",
    "ru": "\u041a \u0441\u043e\u0436\u0430\u043b\u0435\u043d\u0438\u044e, \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u0435\u0442 \u043f\u0440\u043e\u0431\u043b\u0435\u043c\u0430 \u0441 \u043e\u043f\u043b\u0430\u0442\u043e\u0439. \u041f\u043e\u0436\u0430\u043b\u0443\u0439\u0441\u0442\u0430, \u0441\u0432\u044f\u0436\u0438\u0442\u0435\u0441\u044c \u0441 \u044d\u043c\u0438\u0442\u0435\u043d\u0442\u043e\u043c \u0432\u0430\u0448\u0435\u0439 \u043a\u0430\u0440\u0442\u044b \u043e \u043f\u0440\u043e\u0431\u043b\u0435\u043c\u0435.",
    "fi": "Kortissasi ilmeni ongelma. Otathan yhteytt\u00e4 kortin my\u00f6nt\u00e4j\u00e4\u00e4n ongelmasta.",
    "sv": "Det var ett problem med ditt kort. Kontakta din kortutgivare om problemet.",
    "fa": "\u0645\u062a\u0623\u0633\u0641\u0627\u0646\u0647 \u062f\u0631 \u06a9\u0627\u0631\u062a \u0634\u0645\u0627 \u0645\u0634\u06a9\u0644\u06cc \u067e\u06cc\u0634 \u0622\u0645\u062f. \u0644\u0637\u0641\u0627 \u062f\u0631 \u0645\u0648\u0631\u062f \u0627\u06cc\u0646 \u0645\u0634\u06a9\u0644 \u0628\u0627 \u0635\u0627\u062f\u0631\u06a9\u0646\u0646\u062f\u0647 \u06a9\u0627\u0631\u062a \u062e\u0648\u062f \u062a\u0645\u0627\u0633 \u0628\u06af\u06cc\u0631\u06cc\u062f.",
    "ar": "\u0644\u0644\u0623\u0633\u0641 \u062d\u062f\u062b\u062a \u0645\u0634\u0643\u0644\u0647 \u0641\u064a \u0628\u0637\u0627\u0642\u062a\u0643. \u064a\u0631\u062c\u0649 \u0627\u0644\u0627\u062a\u0635\u0627\u0644 \u0628\u062c\u0647\u0629 \u0627\u0635\u062f\u0627\u0631 \u0628\u0637\u0627\u0642\u062a\u0643 \u0628\u0634\u0623\u0646 \u0647\u0630\u0647 \u0627\u0644\u0645\u0634\u0643\u0644\u0647",
    "uk": "\u041d\u0430 \u0436\u0430\u043b\u044c, \u0437 \u0432\u0430\u0448\u043e\u044e \u043a\u0430\u0440\u0442\u043a\u043e\u044e \u0432\u0438\u043d\u0438\u043a\u043b\u0430 \u043f\u0440\u043e\u0431\u043b\u0435\u043c\u0430. \u041f\u0440\u043e \u0446\u044e \u043f\u0440\u043e\u0431\u043b\u0435\u043c\u0443 \u0437\u0432\u0435\u0440\u0442\u0430\u0439\u0442\u0435\u0441\u044f \u0434\u043e \u0432\u0430\u0448\u043e\u0433\u043e \u0431\u0430\u043d\u043a\u0443"
  },
  "error_payment_transaction_failed": {
    "sheet_name": "Shared (API)",
    "en": "There is a problem with this transaction. Please try again later and if repeated, contact our support desk.",
    "ru": "\u041a \u0441\u043e\u0436\u0430\u043b\u0435\u043d\u0438\u044e, \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u0435\u0442 \u043f\u0440\u043e\u0431\u043b\u0435\u043c\u0430 \u0441 \u043e\u043f\u043b\u0430\u0442\u043e\u0439. \u041f\u043e\u0436\u0430\u043b\u0443\u0439\u0441\u0442\u0430, \u043f\u043e\u043f\u0440\u043e\u0431\u0443\u0439\u0442\u0435 \u043f\u043e\u0437\u0436\u0435. \u0415\u0441\u043b\u0438 \u043e\u0448\u0438\u0431\u043a\u0430 \u043d\u0435 \u0443\u0441\u0442\u0440\u0430\u043d\u0435\u043d\u0430, \u043e\u0431\u0440\u0430\u0442\u0438\u0442\u0435\u0441\u044c \u0432 \u0441\u043b\u0443\u0436\u0431\u0443 \u043f\u043e\u0434\u0434\u0435\u0440\u0436\u043a\u0438.",
    "fi": "Transaktion kanssa ilmeni ongelmia, yrit\u00e4th\u00e4n uudestaan my\u00f6hemmin. Saman virheen toistuessa otathan yhteytt\u00e4 palvelumme tukeen.",
    "sv": "Det var ett problem med transaktionen, f\u00f6rs\u00f6k igen senare. Om samma fel kvarst\u00e5r, v\u00e4nligen kontakta v\u00e5r service support.",
    "fa": "\u0645\u0634\u06a9\u0644\u06cc \u062f\u0631 \u0627\u06cc\u0646 \u0645\u0639\u0627\u0645\u0644\u0647 \u0648\u062c\u0648\u062f \u062f\u0627\u0631\u062f. \u0644\u0637\u0641\u0627 \u0628\u0639\u062f\u0627\u064b \u062f\u0648\u0628\u0627\u0631\u0647 \u0627\u0645\u062a\u062d\u0627\u0646 \u06a9\u0646\u06cc\u062f \u0648 \u062f\u0631 \u0635\u0648\u0631\u062a \u062a\u06a9\u0631\u0627\u0631 \u060c \u0628\u0627 \u0628\u062e\u0634 \u067e\u0634\u062a\u06cc\u0628\u0627\u0646\u06cc \u0645\u0627 \u062a\u0645\u0627\u0633 \u0628\u06af\u06cc\u0631\u06cc\u062f.",
    "ar": "\u0647\u0646\u0627\u0643 \u0645\u0634\u0643\u0644\u0647 \u0641\u064a \u0647\u0630\u0647 \u0627\u0644\u0645\u0639\u0627\u0645\u0644\u0647. \u064a\u0631\u062c\u0649 \u0627\u0644\u0645\u062d\u0627\u0648\u0644\u0647 \u0645\u0631\u0647 \u0627\u062e\u0631\u0649",
    "uk": "\u0417 \u0446\u0456\u0454\u044e \u0442\u0440\u0430\u043d\u0437\u0430\u043a\u0446\u0456\u0454\u044e \u0432\u0438\u043d\u0438\u043a\u043b\u0430 \u043f\u0440\u043e\u0431\u043b\u0435\u043c\u0430. \u0411\u0443\u0434\u044c \u043b\u0430\u0441\u043a\u0430, \u043f\u043e\u0432\u0442\u043e\u0440\u0456\u0442\u044c \u0441\u043f\u0440\u043e\u0431\u0443 \u043f\u0456\u0437\u043d\u0456\u0448\u0435, \u0456 \u044f\u043a\u0449\u043e \u0432\u043e\u043d\u0430 \u043f\u043e\u0432\u0442\u043e\u0440\u0438\u0442\u044c\u0441\u044f, \u0437\u0432\u0435\u0440\u043d\u0456\u0442\u044c\u0441\u044f \u0434\u043e \u043d\u0430\u0448\u043e\u0457 \u0441\u043b\u0443\u0436\u0431\u0438 \u043f\u0456\u0434\u0442\u0440\u0438\u043c\u043a\u0438"
  },
  "error_payment_invalid_card": {
    "sheet_name": "Shared (API)",
    "en": "This card is no longer valid, please enter valid card.",
    "ru": "\u041a \u0441\u043e\u0436\u0430\u043b\u0435\u043d\u0438\u044e, \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u0435\u0442 \u043f\u0440\u043e\u0431\u043b\u0435\u043c\u0430 \u0441 \u043e\u043f\u043b\u0430\u0442\u043e\u0439. \u0412\u0430\u0448\u0430 \u043a\u0430\u0440\u0442\u0430 \u0431\u043e\u043b\u044c\u0448\u0435 \u043d\u0435 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043b\u044c\u043d\u0430. \u041f\u043e\u0436\u0430\u043b\u0443\u0439\u0441\u0442\u0430, \u0432\u0441\u0442\u0430\u0432\u044c\u0442\u0435 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043b\u044c\u043d\u0443\u044e \u043a\u0430\u0440\u0442\u0443.",
    "fi": "Korttisi ei ole en\u00e4\u00e4 voimassa. Lis\u00e4\u00e4th\u00e4n voimassa olevan kortin.",
    "sv": "Ditt kort \u00e4r inte l\u00e4ngre giltigt. Anv\u00e4nd ett giltigt kort.",
    "fa": "\u0627\u06cc\u0646 \u06a9\u0627\u0631\u062a \u062f\u06cc\u06af\u0631 \u0645\u0639\u062a\u0628\u0631 \u0646\u06cc\u0633\u062a \u060c \u0644\u0637\u0641\u0627\u064b \u06a9\u0627\u0631\u062a \u0645\u0639\u062a\u0628\u0631 \u0631\u0627 \u0648\u0627\u0631\u062f \u06a9\u0646\u06cc\u062f.",
    "ar": "\u0647\u0630\u0647 \u0627\u0644\u0628\u0637\u0627\u0642\u0629 \u0644\u0645 \u062a\u0639\u062f \u0635\u0627\u0644\u062d\u0629. \u064a\u0631\u062c\u0649 \u0625\u062f\u062e\u0627\u0644 \u0628\u0637\u0627\u0642\u0629 \u0635\u0627\u0644\u062d\u0629",
    "uk": "\u0426\u044f \u043a\u0430\u0440\u0442\u043a\u0430 \u0431\u0456\u043b\u044c\u0448\u0435 \u043d\u0435 \u0434\u0456\u0439\u0441\u043d\u0430, \u0431\u0443\u0434\u044c \u043b\u0430\u0441\u043a\u0430, \u0432\u0432\u0435\u0434\u0456\u0442\u044c \u0434\u0456\u0439\u0441\u043d\u0443 \u043a\u0430\u0440\u0442\u043a\u0443."
  },
  "error_payment_invalid_card_number": {
    "sheet_name": "Shared (API)",
    "en": "Card number is invalid, please reenter",
    "ru": "\u041a \u0441\u043e\u0436\u0430\u043b\u0435\u043d\u0438\u044e, \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u0435\u0442 \u043f\u0440\u043e\u0431\u043b\u0435\u043c\u0430 \u0441 \u043e\u043f\u043b\u0430\u0442\u043e\u0439. \u041d\u0435\u0432\u0435\u0440\u043d\u044b\u0439 \u043d\u043e\u043c\u0435\u0440 \u043a\u0430\u0440\u0442\u044b, \u043f\u043e\u0436\u0430\u043b\u0443\u0439\u0441\u0442\u0430, \u0432\u0441\u0442\u0430\u0432\u044c\u0442\u0435 \u0435\u0433\u043e \u0437\u0430\u043d\u043e\u0432\u043e.",
    "fi": "Kortin numero on virheellinen, asetathan sen uudestaan.",
    "sv": "Kortnummret \u00e4r felaktigt, f\u00f6rs\u00f6k igen.",
    "fa": "\u0634\u0645\u0627\u0631\u0647 \u06a9\u0627\u0631\u062a \u0646\u0627\u0645\u0639\u062a\u0628\u0631 \u0627\u0633\u062a \u060c \u0644\u0637\u0641\u0627 \u062f\u0648\u0628\u0627\u0631\u0647 \u0648\u0627\u0631\u062f \u0634\u0648\u06cc\u062f",
    "ar": "\u0631\u0642\u0645 \u0627\u0644\u0628\u0637\u0627\u0642\u0629 \u063a\u064a\u0631 \u0635\u0627\u0644\u062d. \u064a\u0631\u062c\u0649 \u0625\u0639\u0627\u062f\u0629 \u0627\u0644\u0625\u062f\u062e\u0627\u0644",
    "uk": "\u041d\u043e\u043c\u0435\u0440 \u043a\u0430\u0440\u0442\u043a\u0438 \u043d\u0435\u0432\u0456\u0440\u043d\u0438\u0439, \u0431\u0443\u0434\u044c \u043b\u0430\u0441\u043a\u0430, \u0441\u043f\u0440\u043e\u0431\u0443\u0439\u0442\u0435 \u0449\u0435 \u0440\u0430\u0437"
  },
  "error_payment_invalid_card_info": {
    "sheet_name": "Shared (API)",
    "en": "Invalid data, please check card number, expiry date and CCV and that card has been activated.",
    "ru": "\u041a \u0441\u043e\u0436\u0430\u043b\u0435\u043d\u0438\u044e, \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u0435\u0442 \u043f\u0440\u043e\u0431\u043b\u0435\u043c\u0430 \u0441 \u043e\u043f\u043b\u0430\u0442\u043e\u0439. \u041d\u0435\u0432\u0435\u0440\u043d\u0430\u044f \u0438\u043d\u0444\u043e\u0440\u043c\u0430\u0446\u0438\u044f, \u043f\u0440\u043e\u0432\u0435\u0440\u044c\u0442\u0435 \u043d\u043e\u043c\u0435\u0440 \u043a\u0430\u0440\u0442\u044b, \u0441\u0440\u043e\u043a \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044f, \u043d\u043e\u043c\u0435\u0440 CVV \u0438 \u0442\u0430\u043a\u0436\u0435 \u0442\u043e \u0447\u0442\u043e \u043a\u0430\u0440\u0442\u0430 \u0430\u043a\u0442\u0438\u0432\u0438\u0440\u043e\u0432\u0430\u043d\u0430.",
    "fi": "Virheellist\u00e4 tietoa, tarkistathan kortin numeron, voimassaolo p\u00e4iv\u00e4n, CVV-numeron sek\u00e4 sen, ett\u00e4 kortti on aktivoitu.",
    "sv": "Felaktiga data, kontrollera kortnummer, utg\u00e5ngsdatum, CVV-nummer och kort aktiverat.",
    "fa": "\u0627\u0637\u0644\u0627\u0639\u0627\u062a \u0646\u0627\u0645\u0639\u062a\u0628\u0631 \u0627\u0633\u062a \u060c \u0644\u0637\u0641\u0627\u064b \u0634\u0645\u0627\u0631\u0647 \u06a9\u0627\u0631\u062a \u060c \u062a\u0627\u0631\u06cc\u062e \u0627\u0646\u0642\u0636\u0627 \u0648 CCV \u0631\u0627 \u0628\u0631\u0631\u0633\u06cc \u06a9\u0646\u06cc\u062f \u0648 \u0622\u0646 \u06a9\u0627\u0631\u062a \u0641\u0639\u0627\u0644 \u0634\u062f\u0647 \u0628\u0627\u0634\u062f.",
    "ar": "\u0645\u0639\u0644\u0648\u0645\u0627\u062a \u063a\u064a\u0631 \u0635\u062d\u064a\u062d\u0629, \u064a\u0631\u062c\u0649 \u0627\u0644\u062a\u062d\u0642\u0642 \u0645\u0646 \u0631\u0642\u0645 \u0627\u0644\u0628\u0637\u0627\u0642\u0629 \u0648\u062a\u0627\u0631\u064a\u062e \u0627\u0646\u062a\u0647\u0627\u0621 \u0627\u0644\u0635\u0644\u0627\u062d\u064a\u0629 \u0648\u0631\u0642\u0645 CCV \u0648\u062a\u0645 \u062a\u0646\u0634\u064a\u0637 \u062a\u0644\u0643 \u0627\u0644\u0628\u0637\u0627\u0642\u0629",
    "uk": "\u041d\u0435\u0432\u0456\u0440\u043d\u0456 \u0434\u0430\u043d\u0456, \u0431\u0443\u0434\u044c \u043b\u0430\u0441\u043a\u0430, \u043f\u0435\u0440\u0435\u0432\u0456\u0440\u0442\u0435 \u043d\u043e\u043c\u0435\u0440 \u043a\u0430\u0440\u0442\u043a\u0438, \u0442\u0435\u0440\u043c\u0456\u043d \u0434\u0456\u0457 \u0442\u0430 \u041f\u0406\u041d-\u043a\u043e\u0434, \u0430 \u0442\u0430\u043a\u043e\u0436 \u0442\u0435, \u0449\u043e \u043a\u0430\u0440\u0442\u043a\u0430 \u0430\u043a\u0442\u0438\u0432\u043e\u0432\u0430\u043d\u0430"
  },
  "error_admin_already_charged_back": {
    "sheet_name": "Shared (API)",
    "en": "The order is already charged back",
    "ru": "\u0412\u0430\u0448 \u0437\u0430\u043a\u0430\u0437 \u0443\u0436\u0435 \u0431\u044b\u043b \u0432\u043e\u0437\u0432\u0440\u0430\u0449\u0435\u043d",
    "fi": "Tilaus on jo hyvitetty",
    "sv": "Din best\u00e4llning har redan \u00e5terbetalats",
    "fa": "\u0633\u0641\u0627\u0631\u0634 \u0642\u0628\u0644\u0627\u064b \u0628\u0631\u06af\u0634\u062a \u062f\u0627\u062f\u0647 \u0634\u062f\u0647 \u0627\u0633\u062a",
    "ar": "\u062a\u0645 \u062a\u062d\u0635\u064a\u0644 \u0631\u0633\u0648\u0645 \u0627\u0644\u0637\u0644\u0628 \u0628\u0627\u0644\u0641\u0639\u0644",
    "uk": "\u0417\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f \u0432\u0436\u0435 \u0441\u043f\u0438\u0441\u0430\u043d\u043e \u0437 \u0440\u0430\u0445\u0443\u043d\u043a\u0443"
  },
  "error_admin_cant_charge_back_not_payed": {
    "sheet_name": "Shared (API)",
    "en": "Can't charge back as the order is not paid",
    "ru": "\u0417\u0430\u043a\u0430\u0437 \u043d\u0435 \u043c\u043e\u0433\u0443\u0442 \u043e\u0434\u043e\u0431\u0440\u0438\u0442\u044c, \u0442\u0430\u043a \u043a\u0430\u043a \u0437\u0430\u043a\u0430\u0437 \u043d\u0435 \u043e\u043f\u043b\u0430\u0447\u0435\u043d.",
    "fi": "Tilausta ei voida hyvitt\u00e4\u00e4, sill\u00e4 sit\u00e4 ei ole maksettu",
    "sv": "Din best\u00e4llning kan inte \u00e5terbetalas eftersom den inte har betalats",
    "fa": "\u0628\u0627 \u067e\u0631\u062f\u0627\u062e\u062a \u0645\u0628\u0644\u063a\u06cc \u06a9\u0647 \u0633\u0641\u0627\u0631\u0634 \u067e\u0631\u062f\u0627\u062e\u062a \u0646\u0634\u062f\u0647 \u0627\u0633\u062a \u060c \u0646\u0645\u06cc \u062a\u0648\u0627\u0646 \u062f\u0648\u0628\u0627\u0631\u0647 \u067e\u0633 \u0627\u0646\u062f\u0627\u0632 \u06a9\u0631\u062f",
    "ar": "\u0644\u0627\u064a\u0645\u0643\u0646 \u0627\u0633\u062a\u0631\u062f\u0627\u062f \u0627\u0644\u0631\u0633\u0648\u0645 \u0644\u0627\u0646\u0647 \u0644\u0645 \u064a\u062a\u0645 \u062f\u0641\u0639 \u0627\u0644\u0637\u0644\u0628",
    "uk": "\u041d\u0435 \u043c\u043e\u0436\u0435\u043c\u043e \u043f\u043e\u0432\u0435\u0440\u043d\u0443\u0442\u0438 \u043a\u043e\u0448\u0442\u0438, \u0442\u0430\u043a \u044f\u043a \u0437\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f \u043d\u0435 \u043e\u043f\u043b\u0430\u0447\u0435\u043d\u043e"
  },
  "error_admin_cant_delete_has_links": {
    "sheet_name": "Shared (API)",
    "en": "Can't delete because there are other records linking to it",
    "ru": "\u0423\u0434\u0430\u043b\u0435\u043d\u0438\u0435 \u043d\u0435 \u043f\u043e\u043b\u0443\u0447\u0438\u043b\u043e\u0441\u044c, \u043f\u043e\u0442\u043e\u043c\u0443 \u0447\u0442\u043e \u0434\u0440\u0443\u0433\u0438\u0435 \u0434\u0430\u043d\u043d\u044b\u0435 \u0441\u0432\u044f\u0437\u0430\u043d\u044b \u0441 \u043d\u0438\u043c",
    "fi": "Poistaminen ei onnistunut, sill\u00e4 t\u00e4h\u00e4n kytkeytyy my\u00f6s muita tietoja",
    "sv": "Det g\u00e5r inte att ta bort eftersom det finns andra poster som l\u00e4nkar till den",
    "fa": "\u0627\u0645\u06a9\u0627\u0646 \u062d\u0630\u0641 \u0648\u062c\u0648\u062f \u0646\u062f\u0627\u0631\u062f \u0632\u06cc\u0631\u0627 \u0633\u0648\u0627\u0628\u0642 \u062f\u06cc\u06af\u0631\u06cc \u06a9\u0647 \u0628\u0647 \u0622\u0646 \u067e\u06cc\u0648\u0646\u062f \u062f\u0627\u0631\u0646\u062f \u0648\u062c\u0648\u062f \u062f\u0627\u0631\u062f",
    "ar": "\u0644\u0627\u064a\u0645\u0643\u0646 \u0627\u0644\u062d\u0630\u0641 \u0628\u0633\u0628\u0628 \u0648\u062c\u0648\u062f \u0633\u062c\u0644\u0627\u062a \u0627\u062e\u0631\u0649 \u0645\u0631\u062a\u0628\u0637\u0629 \u0628\u0647",
    "uk": "\u041d\u0435 \u043c\u043e\u0436\u043d\u0430 \u0432\u0438\u0434\u0430\u043b\u0438\u0442\u0438, \u0442\u043e\u043c\u0443 \u0449\u043e \u043d\u0430 \u043d\u044c\u043e\u0433\u043e \u043f\u043e\u0441\u0438\u043b\u0430\u044e\u0442\u044c\u0441\u044f \u0456\u043d\u0448\u0456 \u0437\u0430\u043f\u0438\u0441\u0438"
  },
  "error_admin_log_tables_cant_be_edited": {
    "sheet_name": "Shared (API)",
    "en": "Log tables can't be edited",
    "ru": "\u0416\u0443\u0440\u043d\u0430\u043b\u044c\u043d\u044b\u0435 \u0442\u0430\u0431\u043b\u0438\u0446\u044b \u043d\u0435 \u043c\u043e\u0433\u0443\u0442 \u0431\u044b\u0442\u044c \u0438\u0437\u043c\u0435\u043d\u0435\u043d\u044b.",
    "fi": "Lokitaulukoita ei voi muokata.",
    "sv": "Logtabeller kan inte editeras.",
    "fa": "\u062c\u062f\u0648\u0644 \u0647\u0627\u06cc \u0648\u0631\u0648\u062f \u0628\u0647 \u0633\u06cc\u0633\u062a\u0645 \u0642\u0627\u0628\u0644 \u062f\u0633\u062a\u06a9\u0627\u0631\u06cc \u0646\u06cc\u0633\u062a\u0646\u062f.",
    "ar": "\u0644\u0627\u064a\u0645\u0643\u0646 \u062a\u062d\u0631\u064a\u0631 \u062c\u062f\u0648\u0644 \u0627\u0644\u0633\u062c\u0644\u0627\u062a",
    "uk": "\u0422\u0430\u0431\u043b\u0438\u0446\u0456 \u0436\u0443\u0440\u043d\u0430\u043b\u0456\u0432 \u043d\u0435 \u043c\u043e\u0436\u043d\u0430 \u0440\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438"
  },
  "organization_type_private_person": {
    "sheet_name": "Shared (API)",
    "en": "Private person",
    "ru": "\u0427\u0430\u0441\u0442\u043d\u043e\u0435 \u043b\u0438\u0446\u043e",
    "fi": "Yksityishenkil\u00f6",
    "sv": "Privatperson",
    "fa": "\u0634\u062e\u0635 \u062e\u0635\u0648\u0635\u06cc",
    "ar": "\u0634\u062e\u0635 \u062e\u0627\u0635",
    "uk": "\u0424\u0456\u0437\u0438\u0447\u043d\u0430 \u043e\u0441\u043e\u0431\u0430"
  },
  "organization_type_company": {
    "sheet_name": "Shared (API)",
    "en": "Company",
    "ru": "\u043a\u043e\u043c\u043f\u0430\u043d\u0438\u044f",
    "fi": "Yritys",
    "sv": "F\u00f6retag",
    "fa": "\u0634\u0631\u06a9\u062a",
    "ar": "\u0627\u0644\u0634\u0631\u0643\u0629",
    "uk": "\u041a\u043e\u043c\u043f\u0430\u043d\u0456\u044f"
  },
  "organization_type_municipality": {
    "sheet_name": "Shared (API)",
    "en": "Municipality",
    "ru": "\u041c\u0443\u043d\u0438\u0446\u0438\u043f\u0430\u043b\u0438\u0442\u0435\u0442",
    "fi": "Kunta",
    "sv": "Kommun",
    "fa": "\u0634\u0647\u0631\u062f\u0627\u0631\u06cc",
    "ar": "\u0627\u0644\u0628\u0644\u062f\u064a\u0629",
    "uk": "\u041c\u0443\u043d\u0456\u0446\u0438\u043f\u0430\u043b\u0456\u0442\u0435\u0442"
  },
  "organization_type_ngo": {
    "sheet_name": "Shared (API)",
    "en": "NGO\/non-profit",
    "ru": "\u041d\u041f\u041e",
    "fi": "Kansalaisj\u00e4rjest\u00f6",
    "sv": "Ideell f\u00f6rening",
    "fa": "\u0633\u0627\u0632\u0645\u0627\u0646 \u0647\u0627\u06cc \u063a\u06cc\u0631 \u062f\u0648\u0644\u062a\u06cc \/ \u063a\u06cc\u0631\u0627\u0646\u062a\u0641\u0627\u0639\u06cc",
    "ar": "\u0645\u0646\u0638\u0645\u0629 \u062d\u0643\u0648\u0645\u064a\u0629",
    "uk": "\u041d\u0423\u041e\/\u043d\u0435\u043f\u0440\u0438\u0431\u0443\u0442\u043a\u043e\u0432\u0430 \u043e\u0440\u0433\u0430\u043d\u0456\u0437\u0430\u0446\u0456\u044f"
  },
  "organization_type_other": {
    "sheet_name": "Shared (API)",
    "en": "Other",
    "ru": "\u0414\u0440\u0443\u0433\u043e\u0435",
    "fi": "Muu",
    "sv": "Andra",
    "fa": "\u062f\u06cc\u06af\u0631",
    "ar": "\u063a\u064a\u0631 \u0630\u0644\u0643",
    "uk": "\u0406\u043d\u0448\u0435"
  },
  "worker_language_elementary": {
    "sheet_name": "Shared (API)",
    "en": "Elementary",
    "ru": "\u042d\u043b\u0435\u043c\u0435\u043d\u0442\u0430\u0440\u043d\u044b\u0439",
    "fi": "Alkeet",
    "sv": "Element\u00e4r",
    "fa": "\u0627\u0628\u062a\u062f\u0627\u06cc\u06cc",
    "ar": "\u0627\u0628\u062a\u062f\u0627\u0626\u064a",
    "uk": "\u0415\u043b\u0435\u043c\u0435\u043d\u0442\u0430\u0440\u043d\u0438\u0439"
  },
  "worker_language_limited": {
    "sheet_name": "Shared (API)",
    "en": "Limited",
    "ru": "\u041e\u0433\u0440\u0430\u043d\u0438\u0447\u0435\u043d\u043d\u044b\u0439",
    "fi": "Tyydytt\u00e4v\u00e4",
    "sv": "Begr\u00e4nsad",
    "fa": "\u0645\u062d\u062f\u0648\u062f",
    "ar": "\u0645\u0631\u0636\u064a",
    "uk": "\u041e\u0431\u043c\u0435\u0436\u0435\u043d\u0438\u0439"
  },
  "worker_language_intermediate": {
    "sheet_name": "Shared (API)",
    "en": "Intermediate",
    "ru": "\u041f\u0440\u043e\u043c\u0435\u0436\u0443\u0442\u043e\u0447\u043d\u044b\u0439",
    "fi": "Kohtalainen",
    "sv": "Intermedi\u00e4r",
    "fa": "\u062d\u062f \u0648\u0627\u0633\u0637",
    "ar": "\u0645\u062a\u0648\u0633\u0637",
    "uk": "\u0421\u0435\u0440\u0435\u0434\u043d\u0456\u0439"
  },
  "worker_language_advanced": {
    "sheet_name": "Shared (API)",
    "en": "Advanced",
    "ru": "\u041f\u0440\u043e\u0434\u0432\u0438\u043d\u0443\u0442\u044b\u0439",
    "fi": "Sujuva",
    "sv": "Avancerad",
    "fa": "\u067e\u06cc\u0634\u0631\u0641\u062a\u0647",
    "ar": "\u0628\u0633\u0644\u0627\u0633\u0629",
    "uk": "\u0423\u0434\u043e\u0441\u043a\u043e\u043d\u0430\u043b\u0435\u043d\u0438\u0439"
  },
  "worker_language_professional": {
    "sheet_name": "Shared (API)",
    "en": "Professional",
    "ru": "\u041f\u0440\u043e\u0444\u0435\u0441\u0441\u0438\u043e\u043d\u0430\u043b\u044c\u043d\u044b\u0439",
    "fi": "Erinomainen",
    "sv": "Professionell",
    "fa": "\u062d\u0631\u0641\u0647 \u0627\u06cc",
    "ar": "\u0645\u0645\u062a\u0627\u0632",
    "uk": "\u041f\u0440\u043e\u0444\u0435\u0441\u0456\u0439\u043d\u0438\u0439"
  },
  "worker_language_fluent": {
    "sheet_name": "Shared (API)",
    "en": "Fluent or Native",
    "ru": "\u0421\u0432\u043e\u0431\u043e\u0434\u043d\u044b\u0439 \u0438\u043b\u0438 \u0440\u043e\u0434\u043d\u043e\u0439",
    "fi": "\u00c4idinkieli",
    "sv": "Modersm\u00e5l",
    "fa": "\u0645\u0633\u0644\u0637 \u06cc\u0627 \u0628\u0648\u0645\u06cc",
    "ar": "\u0644\u063a\u0629 \u0627\u0644\u0623\u0645",
    "uk": "\u0412\u0456\u043b\u044c\u043d\u0430 \u0430\u0431\u043e \u0440\u0456\u0434\u043d\u0430 \u043c\u043e\u0432\u0430"
  },
  "doc_status_pending": {
    "sheet_name": "Shared (API)",
    "en": "Pending",
    "ru": "",
    "fi": "Odottaa",
    "sv": "V\u00e4ntande",
    "fa": "",
    "ar": "",
    "uk": "\u0420\u043e\u0437\u0433\u043b\u044f\u0434\u0430\u0454\u0442\u044c\u0441\u044f"
  },
  "doc_status_verified": {
    "sheet_name": "Shared (API)",
    "en": "Verified",
    "ru": "",
    "fi": "Vahvistettu",
    "sv": "Verifierats",
    "fa": "",
    "ar": "",
    "uk": "\u041f\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043d\u043e"
  },
  "doc_status_rejected": {
    "sheet_name": "Shared (API)",
    "en": "Rejected",
    "ru": "",
    "fi": "Hyl\u00e4tty",
    "sv": "Avvisats",
    "fa": "",
    "ar": "",
    "uk": "\u0412\u0456\u0434\u0445\u0438\u043b\u0435\u043d\u043e"
  },
  "doc_status_expired": {
    "sheet_name": "Shared (API)",
    "en": "Expired",
    "ru": "",
    "fi": "Vanhentunut",
    "sv": "Utg\u00e5nget",
    "fa": "",
    "ar": "",
    "uk": "\u0417\u0430\u043a\u0456\u043d\u0447\u0438\u0432\u0441\u044f \u0442\u0435\u0440\u043c\u0456\u043d \u0434\u0456\u0457"
  },
  "worker_education_type_education": {
    "sheet_name": "Shared (API)",
    "en": "Education",
    "ru": "\u041e\u0431\u0440\u0430\u0437\u043e\u0432\u0430\u043d\u0438\u0435",
    "fi": "Koulutus",
    "sv": "Utbildning",
    "fa": "\u062a\u062d\u0635\u06cc\u0644\u0627\u062a",
    "ar": "\u0627\u0644\u0645\u0624\u0647\u0644\u0627\u062a",
    "uk": "\u041e\u0441\u0432\u0456\u0442\u0430"
  },
  "worker_education_type_course": {
    "sheet_name": "Shared (API)",
    "en": "Course",
    "ru": "\u041a\u0443\u0440\u0441",
    "fi": "Kurssi",
    "sv": "Kurs",
    "fa": "\u06a9\u0648\u0631\u0633",
    "ar": "\u0643\u0648\u0631\u0633",
    "uk": "\u041a\u0443\u0440\u0441"
  },
  "worker_education_type_certificate": {
    "sheet_name": "Shared (API)",
    "en": "Certificate",
    "ru": "\u0421\u0435\u0440\u0442\u0438\u0444\u0438\u043a\u0430\u0442",
    "fi": "Sertifikaatti",
    "sv": "Certifikat",
    "fa": "\u06af\u0648\u0627\u0647\u06cc \u0646\u0627\u0645\u0647",
    "ar": "\u0634\u0647\u0627\u062f",
    "uk": "\u0421\u0435\u0440\u0442\u0438\u0444\u0456\u043a\u0430\u0442"
  },
  "worker_experience_type_job": {
    "sheet_name": "Shared (API)",
    "en": "Job",
    "ru": "\u0420\u0430\u0431\u043e\u0442\u0430",
    "fi": "Ty\u00f6paikka",
    "sv": "Jobb",
    "fa": "\u06a9\u0627\u0631",
    "ar": "\u0645\u0643\u0627\u0646 \u0627\u0644\u0639\u0645\u0644",
    "uk": "\u0420\u043e\u0431\u043e\u0442\u0430"
  },
  "worker_experience_type_other": {
    "sheet_name": "Shared (API)",
    "en": "Other",
    "ru": "\u0434\u0440\u0443\u0433\u043e\u0439 \u043e\u043f\u044b\u0442",
    "fi": "Muu kokemus",
    "sv": "Annat",
    "fa": "\u0628\u0642\u06cc\u0647 \u062a\u062c\u0631\u0628\u0647",
    "ar": "\u063a\u064a\u0631 \u0630\u0644\u0643",
    "uk": "\u0406\u043d\u0448\u0435"
  },
  "history_type_donate": {
    "sheet_name": "Shared (API)",
    "en": "Transferred",
    "ru": "\u041f\u043e\u0434\u0430\u0440\u0435\u043d",
    "fi": "Siirretty",
    "sv": "Delat ut",
    "fa": "\u0627\u0647\u062f\u0627 \u0634\u062f\u0647",
    "ar": "\u062a\u0628\u0631\u0639",
    "uk": "\u041f\u0435\u0440\u0435\u0440\u0430\u0445\u043e\u0432\u0430\u043d\u043e"
  },
  "history_type_claim": {
    "sheet_name": "Shared (API)",
    "en": "Claimed",
    "ru": "\u0422\u0440\u0435\u0431\u043e\u0432\u0430\u043d\u0438\u0435",
    "fi": "Lunastettu",
    "sv": "L\u00f6st in",
    "fa": "\u0627\u0633\u062a\u062e\u0631\u0627\u062c \u0634\u062f\u0647",
    "ar": "",
    "uk": "\u0417\u0430\u044f\u0432\u043b\u0435\u043d\u043e"
  },
  "history_type_purchase": {
    "sheet_name": "Shared (API)",
    "en": "Purchased",
    "ru": "\u041f\u043e\u043a\u0443\u043f\u043a\u0430",
    "fi": "Ostettu",
    "sv": "K\u00f6pt",
    "fa": "\u062e\u0631\u06cc\u062f\u0627\u0631\u06cc \u0634\u062f\u0647",
    "ar": "",
    "uk": "\u041a\u0443\u043f\u043b\u0435\u043d\u043e"
  },
  "history_type_order": {
    "sheet_name": "Shared (API)",
    "en": "Order",
    "ru": "\u0417\u0430\u043a\u0430\u0437",
    "fi": "Tilaus",
    "sv": "Best\u00e4llning",
    "fa": "\u0633\u0641\u0627\u0631\u0634",
    "ar": "\u0637\u0644\u0628",
    "uk": "\u0417\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f"
  },
  "history_type_order_charge_back": {
    "sheet_name": "Shared (API)",
    "en": "Chargeback",
    "ru": "\u043e\u0431\u0432\u0438\u043d\u0435\u043d\u0438\u0435",
    "fi": "Takaisinveloitus",
    "sv": "\u00c5terbetala",
    "fa": "\u0628\u0627\u0632\u067e\u0631\u062f\u0627\u062e\u062a",
    "ar": "\u0631\u062f \u0627\u0644\u0645\u0628\u0627\u0644\u063a \u0627\u0644\u0645\u062f\u0641\u0648\u0639\u0629",
    "uk": "\u041f\u043e\u0432\u0435\u0440\u043d\u0435\u043d\u043d\u044f \u043a\u043e\u0448\u0442\u0456\u0432"
  },
  "history_type_cancel": {
    "sheet_name": "Shared (API)",
    "en": "Cancel",
    "ru": "O\u0431\u0432\u0438\u043d\u0435\u043d\u0438\u044f \u043e\u0431\u0440\u0430\u0442\u043d\u043e",
    "fi": "Peruuta",
    "sv": "Avbryta",
    "fa": "\u0644\u063a\u0648",
    "ar": "\u062a\u0631\u0627\u062c\u0639",
    "uk": "\u0421\u043a\u0430\u0441\u0443\u0432\u0430\u0442\u0438"
  },
  "history_type_billing_request": {
    "sheet_name": "Shared (API)",
    "en": "Requested",
    "ru": "",
    "fi": "Pyydetty",
    "sv": "Beg\u00e4rde",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "created_at": {
    "sheet_name": "Shared (API)",
    "en": "Creation date",
    "ru": "\u0421\u043e\u0437\u0434\u0430\u043d \u0432",
    "fi": "Tilaus luotu",
    "sv": "Best\u00e4llning skapad",
    "fa": "\u062a\u0627\u0631\u06cc\u062e \u0627\u06cc\u062c\u0627\u062f",
    "ar": "\u062a\u0627\u0631\u064a\u062e \u0627\u0644\u0625\u0646\u0634\u0627\u0621",
    "uk": "\u0414\u0430\u0442\u0430 \u0441\u0442\u0432\u043e\u0440\u0435\u043d\u043d\u044f"
  },
  "completion_date": {
    "sheet_name": "Shared (API)",
    "en": "Completion date",
    "ru": "\u0414\u0430\u0442\u0430 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043d\u0438\u044f",
    "fi": "Valmistumisp\u00e4iv\u00e4",
    "sv": "Uppdragets slutdatum",
    "fa": "\u062a\u0627\u0631\u06cc\u062e \u062a\u06a9\u0645\u06cc\u0644",
    "ar": "\u062a\u0627\u0631\u064a\u062e \u0627\u0644\u0625\u0646\u062a\u0647\u0627\u0621",
    "uk": "\u0414\u0430\u0442\u0430 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043d\u043d\u044f"
  },
  "worker_type_self_employed": {
    "sheet_name": "Shared (API)",
    "en": "Self Employed",
    "ru": "",
    "fi": "Yksityishenkil\u00f6 \/ Toimeksiantosopimus",
    "sv": "Egenanst\u00e4lld",
    "fa": "",
    "ar": "\u0627\u0644\u0639\u0627\u0645\u0644\u0648\u0646 \u0644\u062d\u0633\u0627\u0628\u0647\u0645 \u0627\u0644\u062e\u0627\u0635",
    "uk": "\u0421\u0430\u043c\u043e\u0437\u0430\u0439\u043d\u044f\u0442\u0456\u0441\u0442\u044c"
  },
  "worker_type_company": {
    "sheet_name": "Shared (API)",
    "en": "Company",
    "ru": "\u043a\u043e\u043c\u043f\u0430\u043d\u0438\u044f",
    "fi": "Yritys",
    "sv": "F\u00f6retag",
    "fa": "\u0634\u0631\u06a9\u062a",
    "ar": "\u0627\u0644\u0634\u0631\u0643\u0629",
    "uk": "\u041a\u043e\u043c\u043f\u0430\u043d\u0456\u044f"
  },
  "worker_type_other": {
    "sheet_name": "Shared (API)",
    "en": "Other",
    "ru": "\u0414\u0440\u0443\u0433\u043e\u0435",
    "fi": "Muu",
    "sv": "Andra",
    "fa": "\u062f\u06cc\u06af\u0631",
    "ar": "\u063a\u064a\u0631 \u0630\u0644\u0643",
    "uk": "\u0406\u043d\u0448\u0435"
  },
  "worker_type_employment": {
    "sheet_name": "Shared (API)",
    "en": "Employment",
    "ru": "",
    "fi": "Ty\u00f6sopimus",
    "sv": "Anst\u00e4llningsavtal",
    "fa": "",
    "ar": "",
    "uk": "\u0422\u0440\u0443\u0434\u043e\u0432\u0438\u0439 \u0434\u043e\u0433\u043e\u0432\u0456\u0440"
  },
  "product_based_hours": {
    "sheet_name": "Shared (API)",
    "en": "Hours",
    "ru": "\u0427\u0430\u0441\u044b",
    "fi": "Tunteja",
    "sv": "Timmar",
    "fa": "\u0633\u0627\u0639\u062a \u0647\u0627",
    "ar": "\u0633\u0627\u0639\u0627\u062a",
    "uk": "\u0413\u043e\u0434\u0438\u043d\u0438"
  },
  "product_based_days": {
    "sheet_name": "Shared (API)",
    "en": "Days",
    "ru": "",
    "fi": "P\u00e4ivi\u00e4",
    "sv": "Dagar",
    "fa": "",
    "ar": "",
    "uk": "\u0414\u0435\u043d\u044c"
  },
  "product_based_months": {
    "sheet_name": "Shared (API)",
    "en": "Months",
    "ru": "\u043c\u0435\u0441\u044f\u0446",
    "fi": "Kuukausia",
    "sv": "M\u00e5nader",
    "fa": "",
    "ar": "",
    "uk": "\u041c\u0456\u0441\u044f\u0446\u044c"
  },
  "product_based_units": {
    "sheet_name": "Shared (API)",
    "en": "Units",
    "ru": "",
    "fi": "Kpl",
    "sv": "Enheter",
    "fa": "",
    "ar": "",
    "uk": "\u041e\u0434\u0438\u043d\u0438\u0446\u0456 \u0432\u0438\u043c\u0456\u0440\u0443"
  },
  "product_based_price": {
    "sheet_name": "Shared (API)",
    "en": "Price",
    "ru": "\u0426\u0435\u043d\u0430",
    "fi": "Hinta",
    "sv": "Pris",
    "fa": "\u0646\u0631\u062e",
    "ar": "\u0627\u0644\u0633\u0639\u0631",
    "uk": "\u0426\u0456\u043d\u0430"
  },
  "age_range_under_15": {
    "sheet_name": "Shared (API)",
    "en": "Under 15",
    "ru": "",
    "fi": "Alle 15",
    "sv": "Under 15",
    "fa": "",
    "ar": "",
    "uk": "\u0414\u043e 18 \u0440\u043e\u043a\u0456\u0432"
  },
  "age_range_15_17": {
    "sheet_name": "Shared (API)",
    "en": "15-17",
    "ru": "",
    "fi": "15-17",
    "sv": "15-17",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "age_range_18_24": {
    "sheet_name": "Shared (API)",
    "en": "18-24",
    "ru": "",
    "fi": "18-24",
    "sv": "18-24",
    "fa": "",
    "ar": "",
    "uk": "18-24"
  },
  "age_range_25_29": {
    "sheet_name": "Shared (API)",
    "en": "25-29",
    "ru": "",
    "fi": "25-29",
    "sv": "25-29",
    "fa": "",
    "ar": "",
    "uk": "25-29"
  },
  "age_range_over_29": {
    "sheet_name": "Shared (API)",
    "en": "Over 29",
    "ru": "",
    "fi": "Yli 29",
    "sv": "\u00d6ver 29",
    "fa": "",
    "ar": "",
    "uk": "\u0411\u0456\u043b\u044c\u0448\u0435 29"
  },
  "product_worker_type_employment": {
    "sheet_name": "Shared (API)",
    "en": "Employment",
    "ru": "",
    "fi": "Ty\u00f6suhde",
    "sv": "Anst\u00e4llning",
    "fa": "",
    "ar": "",
    "uk": "\u041f\u0440\u0430\u0446\u0435\u0432\u043b\u0430\u0448\u0442\u0443\u0432\u0430\u043d\u043d\u044f"
  },
  "product_worker_type_assignment": {
    "sheet_name": "Shared (API)",
    "en": "Assignment",
    "ru": "",
    "fi": "Toimeksianto",
    "sv": "Uppdrag",
    "fa": "",
    "ar": "",
    "uk": "\u0417\u0430\u0432\u0434\u0430\u043d\u043d\u044f"
  },
  "push_free_text": {
    "sheet_name": "Shared (API)",
    "en": "New message",
    "ru": "",
    "fi": "Uusi viesti",
    "sv": "Nytt meddelande",
    "fa": "",
    "ar": "",
    "uk": "\u041d\u043e\u0432\u0435 \u043f\u043e\u0432\u0456\u0434\u043e\u043c\u043b\u0435\u043d\u043d\u044f"
  },
  "push_got_task": {
    "sheet_name": "Shared (API)",
    "en": "Congratulations, you've got a task!",
    "ru": "\u041f\u043e\u0437\u0434\u0440\u0430\u0432\u043b\u044f\u0435\u043c, \u0443 \u0432\u0430\u0441 \u0435\u0441\u0442\u044c \u0440\u0430\u0431\u043e\u0442\u0430!",
    "fi": "Sait teht\u00e4v\u00e4n, onnea!",
    "sv": "Grattis! Du har f\u00e5tt uppdraget.",
    "fa": "\u062a\u0628\u0631\u06cc\u06a9 \u0645\u06cc \u06af\u0648\u06cc\u0645 \u060c \u0634\u0645\u0627 \u06a9\u0627\u0631 \u062f\u0631\u06cc\u0627\u0641\u062a \u06a9\u0631\u062f\u0647 \u0627\u06cc\u062f!",
    "ar": "\u062a\u0647\u0627\u0646\u064a\u0627 ,\u0644\u0642\u062f \u062d\u0635\u0644\u062a \u0639\u0644\u0649 \u0627\u0644\u0648\u0638\u064a\u0641\u0629",
    "uk": "\u0412\u0456\u0442\u0430\u0454\u043c\u043e,\u0432\u0438 \u043e\u0442\u0440\u0438\u043c\u0430\u043b\u0438 \u0440\u043e\u0431\u043e\u0442\u0443!"
  },
  "push_new_created": {
    "sheet_name": "Shared (API)",
    "en": "Suitable job available",
    "ru": "\u041d\u043e\u0432\u0430\u044f \u043f\u043e\u0434\u0445\u043e\u0434\u044f\u0449\u0430\u044f \u0440\u0430\u0431\u043e\u0442\u0430 \u0434\u043b\u044f \u0432\u0430\u0441",
    "fi": "Sinulle sopiva teht\u00e4v\u00e4 on avoinna",
    "sv": "Passande uppdrag f\u00f6r dig",
    "fa": "\u0634\u063a\u0644 \u0645\u0646\u0627\u0633\u0628 \u062c\u062f\u06cc\u062f \u0627\u06cc\u062c\u0627\u062f \u0634\u062f\u0647 \u0627\u0633\u062a",
    "ar": "\u062e\u0644\u0642 \u0648\u0638\u064a\u0641\u0629 \u062c\u062f\u064a\u062f\u0629 \u0645\u0646\u0627\u0633\u0628\u0629",
    "uk": "\u0417'\u044f\u0432\u0438\u043b\u0430\u0441\u044f \u0432\u0430\u043a\u0430\u043d\u0441\u0456\u044f \u043d\u0430 \u0440\u043e\u0431\u043e\u0442\u0443"
  },
  "push_cancelled_by_orderer": {
    "sheet_name": "Shared (API)",
    "en": "Order cancelled by orderer",
    "ru": "\u0417\u0430\u043a\u0430\u0437 \u043e\u0442\u043c\u0435\u043d\u0435\u043d \u0437\u0430\u043a\u0430\u0437\u0447\u0438\u043a\u043e\u043c",
    "fi": "Tilaaja perunut teht\u00e4v\u00e4n",
    "sv": "Annulerad av best\u00e4llare",
    "fa": "\u0633\u0641\u0627\u0631\u0634 \u0644\u063a\u0648 \u0634\u062f\u0647 \u062a\u0648\u0633\u0637 \u0633\u0641\u0627\u0631\u0634 \u062f\u0647\u0646\u062f\u0647",
    "ar": "\u062a\u0645 \u0627\u0644\u0625\u0644\u063a\u0627\u0621 \u0628\u0648\u0627\u0633\u0637\u0629 \u0627\u0644\u0645\u0633\u0624\u0648\u0644",
    "uk": "\u0417\u0430\u043c\u043e\u0432\u043d\u0438\u043a \u0441\u043a\u0430\u0441\u0443\u0432\u0430\u0432 \u0437\u0430\u0432\u0434\u0430\u043d\u043d\u044f"
  },
  "push_cancelled_by_worker": {
    "sheet_name": "Shared (API)",
    "en": "Order cancelled by worker",
    "ru": "\u0417\u0430\u043a\u0430\u0437 \u043e\u0442\u043c\u0435\u043d\u0435\u043d \u0440\u0430\u0431\u043e\u0442\u043d\u0438\u043a\u043e\u043c",
    "fi": "Tekij\u00e4 perunut teht\u00e4v\u00e4n",
    "sv": "Utf\u00f6raren avbokade best\u00e4llningen",
    "fa": "\u0633\u0641\u0627\u0631\u0634 \u0644\u063a\u0648 \u0634\u062f\u0647 \u062a\u0648\u0633\u0637 \u06a9\u0627\u0631\u06af\u0631",
    "ar": "\u062a\u0645 \u0627\u0644\u0625\u0644\u063a\u0627\u0621 \u0628\u0648\u0627\u0633\u0637\u0629 \u0627\u0644\u0639\u0627\u0645\u0644",
    "uk": "\u0420\u043e\u0431\u0456\u0442\u043d\u0438\u043a \u0441\u043a\u0430\u0441\u0443\u0432\u0430\u0432 \u0437\u0430\u0432\u0434\u0430\u043d\u043d\u044f"
  },
  "push_marked_completed": {
    "sheet_name": "Shared (API)",
    "en": "Task is marked as ready, please go to approve the task",
    "ru": "\u0420\u0430\u0431\u043e\u0442\u043d\u0438\u043a \u043e\u0442\u043c\u0435\u0442\u0438\u043b \u0412\u0430\u0448\u0443 \u0440\u0430\u0431\u043e\u0442\u0443 \u043a\u0430\u043a \u0432\u044b\u043f\u043e\u043b\u043d\u0435\u043d\u043d\u0443\u044e",
    "fi": "Teht\u00e4v\u00e4 on valmis, k\u00e4yth\u00e4n pikaisesti hyv\u00e4ksym\u00e4ss\u00e4 sen",
    "sv": "Uppdraget \u00e4r markerat som klart, v\u00e4nligen godk\u00e4nn uppdraget",
    "fa": "\u06a9\u0627\u0631\u06af\u0631 \u0648\u0638\u06cc\u0641\u0647 \u0634\u0645\u0627 \u0631\u0627 \u0628\u0647 \u0627\u062a\u0645\u0627\u0645 \u0631\u0633\u06cc\u062f\u0647 \u0627\u0633\u062a",
    "ar": "",
    "uk": "\u0417\u0430\u0432\u0434\u0430\u043d\u043d\u044f \u0433\u043e\u0442\u043e\u0432\u0435, \u0448\u0432\u0438\u0434\u0448\u0435 \u043f\u0440\u0438\u0439\u043c\u0456\u0442\u044c \u0439\u043e\u0433\u043e"
  },
  "push_approved": {
    "sheet_name": "Shared (API)",
    "en": "Your task was approved, great! See the received feedback!",
    "ru": "\u0412\u0430\u0448\u0430 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043d\u043d\u0430\u044f \u0440\u0430\u0431\u043e\u0442\u0430 \u0431\u044b\u043b\u0430 \u0443\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043d\u0430",
    "fi": "Teht\u00e4v\u00e4si on hyv\u00e4ksytty, hienoa! Katso saamasi palaute!",
    "sv": "Ditt avslutade uppdrag \u00e4r godk\u00e4nt.",
    "fa": "\u06a9\u0627\u0631 \u0627\u0646\u062c\u0627\u0645 \u0634\u062f\u0647 \u0634\u0645\u0627 \u062a\u0623\u06cc\u06cc\u062f \u0634\u062f",
    "ar": "\u062a\u0645\u062a \u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629 \u0639\u0644\u0649 \u0645\u0647\u0645\u062a\u0643 \u0627\u0644\u0645\u0643\u062a\u0645\u0644\u0629",
    "uk": "\u0412\u0438\u043a\u043e\u043d\u0430\u043d\u0435 \u0437\u0430\u0432\u0434\u0430\u043d\u043d\u044f \u0441\u0445\u0432\u0430\u043b\u0435\u043d\u043e!"
  },
  "push_not_approved": {
    "sheet_name": "Shared (API)",
    "en": "Your task was not approved",
    "ru": "\u0412\u0430\u0448\u0430 \u0440\u0430\u0431\u043e\u0442\u0430 \u043d\u0435 \u0431\u044b\u043b\u0430 \u043e\u0434\u043e\u0431\u0440\u0435\u043d\u0430",
    "fi": "Teht\u00e4v\u00e4\u00e4si ei hyv\u00e4ksytty",
    "sv": "Ditt uppdrag godk\u00e4ndes inte",
    "fa": "\u0648\u0638\u06cc\u0641\u0647 \u0634\u0645\u0627 \u062a\u0623\u06cc\u06cc\u062f \u0646\u0634\u062f",
    "ar": "\u0644\u0645 \u062a\u062a\u0645 \u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629 \u0639\u0644\u0649 \u0645\u0647\u0645\u062a\u0643",
    "uk": "\u0412\u0430\u0448\u0435 \u0437\u0430\u0432\u0434\u0430\u043d\u043d\u044f \u043d\u0435 \u0437\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043d\u043e"
  },
  "push_new_applicant": {
    "sheet_name": "Shared (API)",
    "en": "You have received a new applicant to your task",
    "ru": "\u0423 \u0412\u0430\u0441 \u043d\u043e\u0432\u044b\u0439 \u043a\u0430\u043d\u0434\u0438\u0434\u0430\u0442 \u043d\u0430 \u0412\u0430\u0448\u0443 \u0440\u0430\u0431\u043e\u0442\u0443",
    "fi": "Olet saanut hakijan teht\u00e4v\u00e4\u00e4si",
    "sv": "Du har f\u00e5tt en ny utf\u00f6rare till ditt uppdrag",
    "fa": "\u0634\u0645\u0627 \u0645\u062a\u0642\u0627\u0636\u06cc \u062c\u062f\u06cc\u062f\u06cc \u0628\u0631\u0627\u06cc \u0648\u0638\u06cc\u0641\u0647 \u062e\u0648\u062f \u062f\u0631\u06cc\u0627\u0641\u062a \u06a9\u0631\u062f\u0647 \u0627\u06cc\u062f",
    "ar": "\u0644\u0642\u062f \u062a\u0644\u0642\u064a\u062a \u0645\u0642\u062f\u0645 \u0637\u0644\u0628 \u062c\u062f\u064a\u062f \u0644\u0645\u0647\u0645\u062a\u0643",
    "uk": "\u0412\u0438 \u043e\u0442\u0440\u0438\u043c\u0430\u043b\u0438 \u043d\u043e\u0432\u043e\u0433\u043e \u043f\u0440\u0435\u0442\u0435\u043d\u0434\u0435\u043d\u0442\u0430 \u043d\u0430 \u0432\u0430\u0448\u0435 \u0437\u0430\u0432\u0434\u0430\u043d\u043d\u044f"
  },
  "push_new_chat_message": {
    "sheet_name": "Shared (API)",
    "en": "You have received new chat message",
    "ru": "\u0412\u044b \u043f\u043e\u043b\u0443\u0447\u0438\u043b\u0438 \u043d\u043e\u0432\u043e\u0435 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u0432 \u0447\u0430\u0442\u0435",
    "fi": "Olet saanut uuden chat-viestin",
    "sv": "Du har ett nytt chattmeddelande",
    "fa": "\u0634\u0645\u0627 \u067e\u06cc\u0627\u0645 \u062c\u062f\u06cc\u062f \u062f\u0631\u06cc\u0627\u0641\u062a \u06a9\u0631\u062f\u0647 \u0627\u06cc\u062f",
    "ar": "\u0644\u0642\u062f \u062a\u0644\u0642\u064a\u062a \u0631\u0633\u0627\u0644\u0629 \u062f\u0631\u062f\u0634\u0647 \u062c\u062f\u064a\u062f\u0647",
    "uk": "\u0412\u0438 \u043e\u0442\u0440\u0438\u043c\u0430\u043b\u0438 \u043d\u043e\u0432\u0435 \u043f\u043e\u0432\u0456\u0434\u043e\u043c\u043b\u0435\u043d\u043d\u044f \u0432 \u0447\u0430\u0442\u0456"
  },
  "push_tou_change": {
    "sheet_name": "Shared (API)",
    "en": "Our Terms of Use have been updated. Please take time to review them.",
    "ru": "\u0423\u0441\u043b\u043e\u0432\u0438\u044f \u0438\u0441\u043f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u043d\u0438\u044f \u0431\u044b\u043b\u0438 \u043e\u0431\u043d\u043e\u0432\u043b\u0435\u043d\u044b. \u041f\u043e\u0436\u0430\u043b\u0443\u0439\u0441\u0442\u0430, \u0441\u043e\u0433\u043b\u0430\u0448\u0430\u0439\u0442\u0435\u0441\u044c \u0441 \u043d\u043e\u0432\u043e\u0439 \u0432\u0435\u0440\u0441\u0438\u0435\u0439 \u043f\u0435\u0440\u0435\u0434 \u0438\u0441\u043f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u043d\u0438\u0435\u043c \u043f\u0440\u0438\u043b\u043e\u0436\u0435\u043d\u0438\u044f.",
    "fi": "K\u00e4ytt\u00f6ehdot on p\u00e4ivitetty. K\u00e4yth\u00e4n ne l\u00e4pi.",
    "sv": "Anv\u00e4ndarvillkorna har uppdaterats. Var god och godk\u00e4nn de nya villkorna.",
    "fa": "\u0634\u0631\u0627\u06cc\u0637 \u0627\u0633\u062a\u0641\u0627\u062f\u0647 \u0628\u0631\u0648\u0632 \u0631\u0633\u0627\u0646\u06cc \u0634\u062f\u0647 \u0627\u0633\u062a. \u0644\u0637\u0641\u0627 \u0622\u0646 \u0631\u0627 \u0645\u0631\u0648\u0631 \u06a9\u0646\u06cc\u062f.",
    "ar": "\u062a\u0645 \u062a\u062d\u062f\u064a\u062b \u0634\u0631\u0648\u0637 \u0627\u0644\u0627\u0633\u062a\u062e\u062f\u0627\u0645 \u0627\u0644\u062e\u0627\u0635 \u0628\u0646\u0627. \u064a\u0631\u062c\u0649 \u0627\u062e\u0630 \u0627\u0644\u0648\u0642\u062a \u0644\u0645\u0631\u0627\u062c\u0639\u062a\u0647\u0627",
    "uk": "\u041d\u0430\u0448\u0456 \u0443\u043c\u043e\u0432\u0438 \u0432\u0438\u043a\u043e\u0440\u0438\u0441\u0442\u0430\u043d\u043d\u044f \u0431\u0443\u043b\u0438 \u043e\u043d\u043e\u0432\u043b\u0435\u043d\u0456. \u0411\u0443\u0434\u044c \u043b\u0430\u0441\u043a\u0430, \u043e\u0437\u043d\u0430\u0439\u043e\u043c\u0442\u0435\u0441\u044f \u0437 \u043d\u0438\u043c\u0438"
  },
  "push_release_notes": {
    "sheet_name": "Shared (API)",
    "en": "Important news",
    "ru": "",
    "fi": "Ajankohtaista",
    "sv": "Viktiga nyheter",
    "fa": "",
    "ar": "",
    "uk": "\u043f\u0440\u0438\u043c\u0456\u0442\u043a\u0438 \u0434\u043e \u0432\u0438\u043f\u0443\u0441\u043a\u0443"
  },
  "push_reminder_from_worker": {
    "sheet_name": "Shared (API)",
    "en": "Reminder: Worker has marked your task as completed",
    "ru": "\u0420\u0430\u0431\u043e\u0442\u043d\u0438\u043a \u043e\u0442\u043c\u0435\u0442\u0438\u043b \u0412\u0430\u0448\u0443 \u0440\u0430\u0431\u043e\u0442\u0443 \u043a\u0430\u043a \u0432\u044b\u043f\u043e\u043b\u043d\u0435\u043d\u043d\u0443\u044e",
    "fi": "Muistutus: Tekij\u00e4 on merkannut teht\u00e4v\u00e4n suoritetuksi",
    "sv": "P\u00e5minnelse: Utf\u00f6raren har avslutat uppgiften",
    "fa": "\u06cc\u0627\u062f\u0622\u0648\u0631\u06cc: \u06a9\u0627\u0631\u06af\u0631 \u0648\u0638\u06cc\u0641\u0647 \u0634\u0645\u0627 \u0631\u0627 \u0628\u0647 \u0627\u062a\u0645\u0627\u0645 \u0631\u0633\u0627\u0646\u062f\u0647 \u0627\u0633\u062a",
    "ar": "\u062a\u0630\u0643\u064a\u0631: \u0648\u0636\u0639 \u0627\u0644\u0639\u0627\u0645\u0644 \u0639\u0644\u0627\u0645\u0629 \u0639\u0644\u0649 \u0645\u0647\u0645\u062a\u0646\u0643 \u0639\u0644\u0649 \u0627\u0646\u0647\u0627 \u0645\u0643\u062a\u0645\u0644\u0647",
    "uk": "\u041d\u0430\u0433\u0430\u0434\u0443\u0432\u0430\u043d\u043d\u044f: \u041f\u0440\u0430\u0446\u0456\u0432\u043d\u0438\u043a \u043f\u043e\u0437\u043d\u0430\u0447\u0438\u0432 \u0432\u0430\u0448\u0435 \u0437\u0430\u0432\u0434\u0430\u043d\u043d\u044f \u044f\u043a \u0432\u0438\u043a\u043e\u043d\u0430\u043d\u0435"
  },
  "push_doc_verified": {
    "sheet_name": "Shared (API)",
    "en": "The document that you submitted has been verified",
    "ru": "",
    "fi": "Antamasi asiakirja on vahvistettu",
    "sv": "Dokumentet som du skickade in har verifierats",
    "fa": "",
    "ar": "",
    "uk": "\u041d\u0430\u0434\u0430\u043d\u0438\u0439 \u0432\u0430\u043c\u0438 \u0434\u043e\u043a\u0443\u043c\u0435\u043d\u0442 \u043f\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043d\u043e"
  },
  "push_doc_rejected": {
    "sheet_name": "Shared (API)",
    "en": "The document that you submitted has been rejected",
    "ru": "",
    "fi": "Antamasi asiakirja on hyl\u00e4tty",
    "sv": "Dokumentet som du skickade in har avvisats",
    "fa": "",
    "ar": "",
    "uk": "\u041f\u043e\u0434\u0430\u043d\u0438\u0439 \u0432\u0430\u043c\u0438 \u0434\u043e\u043a\u0443\u043c\u0435\u043d\u0442 \u0432\u0456\u0434\u0445\u0438\u043b\u0435\u043d\u043e"
  },
  "push_invited_to_merchant": {
    "sheet_name": "Shared (API)",
    "en": "You have been invited to join a new service %s",
    "ru": "",
    "fi": "Sinut on kutsuttu liittym\u00e4\u00e4n palveluun %s",
    "sv": "Du har blivit inbjuden till en ny tj\u00e4nst %s",
    "fa": "",
    "ar": "",
    "uk": "\u0412\u0430\u0441 \u0437\u0430\u043f\u0440\u043e\u0441\u0438\u043b\u0438 \u043f\u0440\u0438\u0454\u0434\u043d\u0430\u0442\u0438\u0441\u044f \u0434\u043e \u043d\u043e\u0432\u043e\u0457 \u043f\u043e\u0441\u043b\u0443\u0433\u0438 %s"
  },
  "push_credit_card_to_be_expired": {
    "sheet_name": "Shared (API)",
    "en": "Your credit card is about to expire",
    "ru": "",
    "fi": "Maksukorttisi er\u00e4\u00e4ntyy pian",
    "sv": "Ditt betalkort \u00e4r p\u00e5 v\u00e4g att l\u00f6pa ut",
    "fa": "",
    "ar": "",
    "uk": "\u0422\u0435\u0440\u043c\u0456\u043d \u0434\u0456\u0457 \u0412\u0430\u0448\u043e\u0457 \u043a\u0440\u0435\u0434\u0438\u0442\u043d\u043e\u0457 \u043a\u0430\u0440\u0442\u043a\u0438 \u0437\u0430\u043a\u0456\u043d\u0447\u0443\u0454\u0442\u044c\u0441\u044f"
  },
  "payment_type_credit_card": {
    "sheet_name": "Shared (API)",
    "en": "Payment card",
    "ru": "\u043a\u0440\u0435\u0434\u0438\u0442\u043d\u0430\u044f \u043a\u0430\u0440\u0442\u0430",
    "fi": "Maksukortti",
    "sv": "Betalskort",
    "fa": "\u06a9\u0627\u0631\u062a \u0627\u0639\u062a\u0628\u0627\u0631\u06cc",
    "ar": "\u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0627\u0626\u062a\u0645\u0627\u0646",
    "uk": "\u041f\u043b\u0430\u0442\u0456\u0436\u043d\u0430 \u043a\u0430\u0440\u0442\u043a\u0430"
  },
  "payment_type_billing": {
    "sheet_name": "Shared (API)",
    "en": "Billing",
    "ru": "\u0431\u0438\u043b\u043b\u0438\u043d\u0433",
    "fi": "Laskutus",
    "sv": "Faktura",
    "fa": "\u0635\u0648\u0631\u062a\u062d\u0633\u0627\u0628",
    "ar": "\u0627\u0644\u0641\u0648\u0627\u062a\u064a\u0631 \/ \u0627\u0644\u0641\u0648\u0627\u062a\u064a\u0631",
    "uk": "\u0412\u0438\u0441\u0442\u0430\u0432\u043b\u0435\u043d\u043d\u044f \u0440\u0430\u0445\u0443\u043d\u043a\u0456\u0432"
  },
  "payment_type_pilot_points": {
    "sheet_name": "Shared (API)",
    "en": "PilotPoints",
    "ru": "PilotPoints",
    "fi": "PilotPoints",
    "sv": "PilotPoints",
    "fa": "PilotPoints",
    "ar": "PilotPoints",
    "uk": "PilotPoints"
  },
  "payment_type_no_payment": {
    "sheet_name": "Shared (API)",
    "en": "No payment",
    "ru": "",
    "fi": "Ei maksua",
    "sv": "Ingen betalning",
    "fa": "",
    "ar": "",
    "uk": "\u0411\u0435\u0437 \u043e\u043f\u043b\u0430\u0442\u0438"
  },
  "html_certificate_title": {
    "sheet_name": "API templates",
    "en": "Certificate",
    "ru": "\u0421\u0435\u0440\u0442\u0438\u0444\u0438\u043a\u0430\u0442",
    "fi": "Sertifikaatti",
    "sv": "Certifikat",
    "fa": "\u06af\u0648\u0627\u0647\u06cc \u0646\u0627\u0645\u0647",
    "ar": "\u0634\u0647\u0627\u062f",
    "uk": "\u0421\u0435\u0440\u0442\u0438\u0444\u0456\u043a\u0430\u0442"
  },
  "html_certificate_wp_certifies": {
    "sheet_name": "API templates",
    "en": "We certify that <b>%s<\/b> completed a task of <b>%s<\/b> for <b>%s<\/b>",
    "ru": "WorkPilots \u0434\u043e\u043a\u0430\u0437\u0438\u0432\u0430\u0435\u0442, \u0447\u0442\u043e <b>%s<\/b> \u0441\u0434\u0435\u043b\u0430\u043b\u0438 \u0437\u0430\u0434\u0430\u0447\u0443 <b>%s<\/b> \u0434\u043b\u044f <b>%s<\/b>",
    "fi": "Todistamme, ett\u00e4 <b>%s<\/b> suoritti teht\u00e4v\u00e4n <b>%s<\/b> tilaajalle <b>%s<\/b>",
    "sv": "Vi intygar att <b>% s <\/b> slutf\u00f6rde en uppgift p\u00e5 <b>% s <\/b> f\u00f6r <b>% s <\/b>",
    "fa": "<b>\u066a s <\/b> \u062a\u06a9\u0645\u06cc\u0644 \u06a9\u0627\u0631 <b>\u066a s <\/b> \u0628\u0631\u0627\u06cc <b>\u066a s <\/b> WorkPilots \u062a\u0623\u06cc\u06cc\u062f \u0645\u06cc \u06a9\u0646\u062f \u06a9\u0647",
    "ar": "\u064a\u0634\u0647\u062f WorkPilots \u0630\u0644\u0643  <b>%s<\/b>  \u0627\u0643\u0645\u0644\u062a \u0627\u0644\u0645\u0647\u0645\u0629 <b>%s<\/b> for <b>%s<\/b>",
    "uk": "WorkPilots \u0434\u043e\u0432\u043e\u0434\u0438\u0442\u044c, \u0449\u043e <b>%s<\/b> \u0432\u0438\u043a\u043e\u043d\u0430\u0432 \u0437\u0430\u0432\u0434\u0430\u043d\u043d\u044f <b>%s<\/b> \u0434\u043b\u044f <b>%s<\/b>"
  },
  "html_certificate_suggested_time": {
    "sheet_name": "API templates",
    "en": "Suggested time",
    "ru": "\u0420\u0435\u043a\u043e\u043c\u0435\u043d\u0434\u0443\u0435\u043c\u043e\u0435 \u0432\u0440\u0435\u043c\u044f",
    "fi": "Ehdotettu aika",
    "sv": "F\u00f6rselagen tid",
    "fa": "\u0632\u0645\u0627\u0646 \u067e\u06cc\u0634\u0646\u0647\u0627\u062f \u0634\u062f\u0647",
    "ar": "\u0627\u0644\u0648\u0642\u062a \u0627\u0644\u0645\u0642\u062a\u0631\u062d",
    "uk": "\u0420\u0435\u043a\u043e\u043c\u0435\u043d\u0434\u043e\u0432\u0430\u043d\u0438\u0439 \u0447\u0430\u0441"
  },
  "html_certificate_agreed_time": {
    "sheet_name": "API templates",
    "en": "Agreed time",
    "ru": "\u0421\u043e\u0433\u043b\u0430\u0441\u043e\u0432\u0430\u043d\u043d\u043e\u0435 \u0432\u0440\u0435\u043c\u044f",
    "fi": "Valmistumisaika",
    "sv": "Avtalad tid",
    "fa": "\u0632\u0645\u0627\u0646 \u062a\u0648\u0627\u0641\u0642 \u0634\u062f\u0647",
    "ar": "\u0627\u0644\u0648\u0642\u062a \u0627\u0644\u0645\u062a\u0641\u0642 \u0639\u0644\u064a\u0647",
    "uk": "\u0423\u0437\u0433\u043e\u0434\u0436\u0435\u043d\u0438\u0439 \u0447\u0430\u0441"
  },
  "html_certificate_duration": {
    "sheet_name": "API templates",
    "en": "Amount",
    "ru": "\u041a\u043e\u043b\u0438\u0447\u0435\u0441\u0442\u0432\u043e",
    "fi": "M\u00e4\u00e4r\u00e4",
    "sv": "Summa",
    "fa": "\u0645\u0642\u062f\u0627\u0631",
    "ar": "\u0627\u0644\u0645\u062c\u0645\u0648\u0639",
    "uk": "\u041a\u0456\u043b\u044c\u043a\u0456\u0441\u0442\u044c"
  },
  "html_certificate_feedback": {
    "sheet_name": "API templates",
    "en": "Feedback",
    "ru": "\u0420\u0435\u0439\u0442\u0438\u043d\u0433",
    "fi": "Palaute",
    "sv": "Feedback",
    "fa": "\u0628\u0627\u0632\u062e\u0648\u0631\u062f",
    "ar": "\u0631\u062f\u0648\u062f \u0627\u0644\u0641\u0639\u0644",
    "uk": "\u0440\u0435\u0439\u0442\u0438\u043d\u0433"
  },
  "html_payment_slip_title": {
    "sheet_name": "API templates",
    "en": "Certification of payment",
    "ru": "\u0421\u0435\u0440\u0442\u0438\u0444\u0438\u043a\u0430\u0446\u0438\u044f \u043e\u043f\u043b\u0430\u0447\u0435\u043d\u043d\u044b\u0445 \u0441\u0431\u043e\u0440\u043e\u0432",
    "fi": "Maksutodistus",
    "sv": "Intyg om utbetalning",
    "fa": "\u06af\u0648\u0627\u0647\u06cc \u0647\u0632\u06cc\u0646\u0647 \u0647\u0627\u06cc \u067e\u0631\u062f\u0627\u062e\u062a \u0634\u062f\u0647",
    "ar": "\u062a\u0635\u062f\u064a\u0642 \u0627\u0644\u0631\u0633\u0648\u0645 \u0627\u0644\u0645\u062f\u0641\u0648\u0639\u0629",
    "uk": "\u0421\u0435\u0440\u0442\u0438\u0444\u0456\u043a\u0430\u0446\u0456\u044f \u0441\u043f\u043b\u0430\u0447\u0435\u043d\u0438\u0445 \u0437\u0431\u043e\u0440\u0456\u0432"
  },
  "html_payment_slip_worker_type": {
    "sheet_name": "API templates",
    "en": "Worker Type",
    "ru": "\u0442\u0438\u043f \u0440\u0430\u0431\u043e\u0442\u043d\u0438\u043a\u0430",
    "fi": "Sopimusmuoto",
    "sv": "Typ av arbetare",
    "fa": "\u0646\u0648\u0639 \u06a9\u0627\u0631\u06af\u0631",
    "ar": "\u0646\u0648\u0639 \u0627\u0644\u0639\u0627\u0645\u0644",
    "uk": "\u0442\u0438\u043f \u0440\u043e\u0431\u0456\u0442\u043d\u0438\u043a\u0430"
  },
  "html_payment_slip_self_billing": {
    "sheet_name": "API templates",
    "en": "Self-billing",
    "ru": "",
    "fi": "Toimeksianto",
    "sv": "Sj\u00e4lvfakturering",
    "fa": "",
    "ar": "",
    "uk": "\u043f\u0440\u0438\u0437\u043d\u0430\u0447\u0435\u043d\u043d\u044f"
  },
  "html_payment_slip_delivery_date": {
    "sheet_name": "API templates",
    "en": "Delivery",
    "ru": "",
    "fi": "Toimitus",
    "sv": "Leverans",
    "fa": "",
    "ar": "",
    "uk": "\u0414\u043e\u0441\u0442\u0430\u0432\u043a\u0430"
  },
  "html_payment_slip_payment_date_short": {
    "sheet_name": "API templates",
    "en": "Payment",
    "ru": "",
    "fi": "Maksu",
    "sv": "Betalning",
    "fa": "",
    "ar": "",
    "uk": "\u041e\u043f\u043b\u0430\u0442\u0430"
  },
  "html_payment_slip_payment_date": {
    "sheet_name": "API templates",
    "en": "Payment date",
    "ru": "\u0414\u0430\u0442\u0430 \u043e\u043f\u043b\u0430\u0442\u044b",
    "fi": "Maksup\u00e4iv\u00e4",
    "sv": "Utbetalningsdag",
    "fa": "\u062a\u0627\u0631\u06cc\u062e \u067e\u0631\u062f\u0627\u062e\u062a",
    "ar": "\u062a\u0627\u0631\u064a\u062e \u0627\u0644\u062f\u0641\u0639",
    "uk": "\u0442\u0435\u0440\u043c\u0456\u043d"
  },
  "html_payment_slip_payer": {
    "sheet_name": "API templates",
    "en": "Payer",
    "ru": "\u041f\u043b\u0430\u0442\u0435\u043b\u044c\u0449\u0438\u043a",
    "fi": "Maksaja",
    "sv": "Betalare",
    "fa": "\u067e\u0631\u062f\u0627\u062e\u062a \u06a9\u0646\u0646\u062f\u0647",
    "ar": "\u062f\u0627\u0641\u0639",
    "uk": "\u041f\u043b\u0430\u0442\u043d\u0438\u043a"
  },
  "html_payment_slip_reg_number": {
    "sheet_name": "API templates",
    "en": "Reg. Number",
    "ru": "\u0411\u0438\u0437\u043d\u0435\u0441-\u0438\u0434\u0435\u043d\u0442\u0438\u0444\u0438\u043a\u0430\u0442\u043e\u0440",
    "fi": "Y-tunnus",
    "sv": "reg.nr.",
    "fa": "\u0634\u0645\u0627\u0631\u0647 \u0631\u0627\u062c\u0633\u062a\u0631",
    "ar": "",
    "uk": "\u0406\u0434\u0435\u043d\u0442\u0438\u0444\u0456\u043a\u0430\u0442\u043e\u0440 \u043f\u0456\u0434\u043f\u0440\u0438\u0454\u043c\u0441\u0442\u0432\u0430"
  },
  "html_payment_slip_worker": {
    "sheet_name": "API templates",
    "en": "Worker",
    "ru": "\u0440\u0430\u0431\u043e\u0442\u043d\u0438\u043a",
    "fi": "Tekij\u00e4",
    "sv": "Utf\u00f6rare",
    "fa": "\u06a9\u0627\u0631\u06af\u0631",
    "ar": "\u0627\u0644\u0639\u0627\u0645\u0644",
    "uk": "\u0440\u043e\u0431\u0456\u0442\u043d\u0438\u043a"
  },
  "html_payment_slip_ssn": {
    "sheet_name": "API templates",
    "en": "SSN",
    "ru": "\u041b\u0438\u0447\u043d\u044b\u0439 \u0438\u0434\u0435\u043d\u0442\u0438\u0444\u0438\u043a\u0430\u0446\u0438\u043e\u043d\u043d\u044b\u0439 \u043d\u043e\u043c\u0435\u0440",
    "fi": "Henkil\u00f6tunnus",
    "sv": "Personnummer",
    "fa": "\u0634\u0645\u0627\u0631\u0647 \u0622\u06cc\u062f\u06cc \u06a9\u0627\u0631\u062a",
    "ar": "\u0631\u0642\u0645 \u0627\u0644\u0647\u0648\u064a\u0629",
    "uk": "\u041e\u0441\u043e\u0431\u0438\u0441\u0442\u0438\u0439 \u0456\u0434\u0435\u043d\u0442\u0438\u0444\u0456\u043a\u0430\u0446\u0456\u0439\u043d\u0438\u0439 \u043d\u043e\u043c\u0435\u0440"
  },
  "html_payment_slip_tax": {
    "sheet_name": "API templates",
    "en": "Tax",
    "ru": "\u041d\u0430\u043b\u043e\u0433",
    "fi": "Vero",
    "sv": "Skatteprocent",
    "fa": "\u0645\u0627\u0644\u06cc\u0647",
    "ar": "\u0627\u0644\u0636\u0631\u064a\u0628\u0629",
    "uk": "\u041f\u043e\u0434\u0430\u0442\u043e\u043a"
  },
  "html_payment_slip_invoice_number": {
    "sheet_name": "API templates",
    "en": "Invoice number",
    "ru": "",
    "fi": "Laskutus numero",
    "sv": "Fakturanummer",
    "fa": "",
    "ar": "",
    "uk": "\u041f\u043b\u0430\u0442\u0456\u0436\u043d\u0438\u0439 \u043d\u043e\u043c\u0435\u0440"
  },
  "html_payment_slip_work_type": {
    "sheet_name": "API templates",
    "en": "Work type",
    "ru": "",
    "fi": "Teht\u00e4v\u00e4",
    "sv": "Typ av arbete",
    "fa": "\u0646\u0648\u0639 \u06a9\u0627\u0631",
    "ar": "\u0646\u0648\u0639 \u0627\u0644\u0639\u0645\u0644",
    "uk": "\u041c\u0456\u0441\u0456\u044f"
  },
  "html_payment_slip_duration": {
    "sheet_name": "API templates",
    "en": "Amount",
    "ru": "\u041a\u043e\u043b\u0438\u0447\u0435\u0441\u0442\u0432\u043e",
    "fi": "M\u00e4\u00e4r\u00e4",
    "sv": "Summa",
    "fa": "\u0645\u0642\u062f\u0627\u0631",
    "ar": "\u0627\u0644\u0645\u062c\u0645\u0648\u0639",
    "uk": "\u20ac \u0441\u0443\u043c\u0430"
  },
  "html_payment_slip_description": {
    "sheet_name": "API templates",
    "en": "Description",
    "ru": "\u041e\u043f\u0438\u0441\u0430\u043d\u0438\u0435",
    "fi": "Kuvaus",
    "sv": "Beskrivning",
    "fa": "\u0634\u0631\u062d",
    "ar": "\u0648\u0635\u0641",
    "uk": "\u041e\u043f\u0438\u0441"
  },
  "html_payment_slip_unit_price": {
    "sheet_name": "API templates",
    "en": "Unit price",
    "ru": "\u0426\u0435\u043d\u0430 \u0437\u0430 \u0435\u0434\u0438\u043d\u0438\u0446\u0443 \u0442\u043e\u0432\u0430\u0440\u0430",
    "fi": "\u20ac\/kpl",
    "sv": "Enhetspris",
    "fa": "\u0642\u06cc\u0645\u062a \u0648\u0627\u062d\u062f",
    "ar": "\u0633\u0639\u0631 \u0627\u0644\u0648\u062d\u062f\u0629",
    "uk": "\u0441\u0443\u043c\u0430"
  },
  "html_payment_slip_unit_price_short": {
    "sheet_name": "API templates",
    "en": "Unit",
    "ru": "",
    "fi": "Kpl",
    "sv": "Enhet",
    "fa": "",
    "ar": "",
    "uk": "\u0446\u0456\u043d\u0430 \u0437\u0430 \u043e\u0434\u0438\u043d\u0438\u0446\u044e \u0442\u043e\u0432\u0430\u0440\u0443"
  },
  "html_payment_slip_total": {
    "sheet_name": "API templates",
    "en": "Total",
    "ru": "\u041a\u043e\u043b\u0438\u0447\u0435\u0441\u0442\u0432\u043e",
    "fi": "Summa",
    "sv": "Totalt",
    "fa": "\u0645\u062c\u0645\u0648\u0639",
    "ar": "\u0627\u0644\u0645\u062c\u0645\u0648\u0639",
    "uk": "\u043e\u0434\u0438\u043d\u0438\u0446\u044f"
  },
  "html_payment_slip_vat": {
    "sheet_name": "API templates",
    "en": "VAT",
    "ru": "\u041d\u0414\u0421",
    "fi": "ALV",
    "sv": "MOMS",
    "fa": "\u0645\u0627\u0644\u06cc\u0627\u062a \u0628\u0631 \u0627\u0631\u0632\u0634 \u0627\u0641\u0632\u0648\u062f\u0647",
    "ar": "\u0636\u0631\u064a\u0628\u0629 \u0627\u0644\u0642\u064a\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629",
    "uk": "\u041f\u0414\u0412"
  },
  "html_payment_slip_paid": {
    "sheet_name": "API templates",
    "en": "Paid",
    "ru": "O\u043f\u043b\u0430\u0447\u0435\u043d\u043e",
    "fi": "Maksettu",
    "sv": "Betald",
    "fa": "\u067e\u0631\u062f\u0627\u062e\u062a \u0634\u062f",
    "ar": "\u062a\u0645 \u0627\u0644\u062f\u0641\u0639",
    "uk": "\u043e\u043f\u043b\u0430\u0447\u0435\u043d\u043e"
  },
  "html_payment_slip_text": {
    "sheet_name": "API templates",
    "en": "Please note compensation for this task is agreed under separate contract or is done without compensation",
    "ru": "",
    "fi": "Korvaus t\u00e4st\u00e4 ty\u00f6st\u00e4 on sovittu erikseen tai ty\u00f6 tehd\u00e4\u00e4n ilman veloitusta",
    "sv": "Observera att betalning f\u00f6r den h\u00e4r uppgiften avtalas under separat kontrakt eller g\u00f6rs utan kompensation enligt \u00f6vk.",
    "fa": "",
    "ar": "",
    "uk": "\u041a\u043e\u043c\u043f\u0435\u043d\u0441\u0430\u0446\u0456\u044f \u0437\u0430 \u0446\u044e \u0440\u043e\u0431\u043e\u0442\u0443 \u043e\u0431\u0433\u043e\u0432\u043e\u0440\u044e\u0454\u0442\u044c\u0441\u044f \u043e\u043a\u0440\u0435\u043c\u043e \u0430\u0431\u043e \u0440\u043e\u0431\u043e\u0442\u0430 \u0431\u0443\u0434\u0435 \u0432\u0438\u043a\u043e\u043d\u0430\u043d\u0430 \u0431\u0435\u0437\u043a\u043e\u0448\u0442\u043e\u0432\u043d\u043e"
  },
  "html_payment_slip_special_payment": {
    "sheet_name": "API templates",
    "en": "Please note that we have made special changes to final payment. Please contact for more information.",
    "ru": "",
    "fi": "Huomioithan ett\u00e4 lopulliseen maksuun on tehty erityisi\u00e4 muutoksia. Ota yhteytt\u00e4 mik\u00e4li haluat lis\u00e4tietoja.",
    "sv": "Observera att s\u00e4rskilda betalnings\u00e4ndringar har gjorts i den slutliga ers\u00e4ttning. Kontakta oss f\u00f6r mera information.",
    "fa": "",
    "ar": "",
    "uk": "\u0417\u0432\u0435\u0440\u043d\u0456\u0442\u044c \u0443\u0432\u0430\u0433\u0443, \u0449\u043e \u0432 \u043e\u0441\u0442\u0430\u0442\u043e\u0447\u043d\u0438\u0439 \u043f\u043b\u0430\u0442\u0456\u0436 \u0432\u043d\u0435\u0441\u0435\u043d\u043e \u043e\u0441\u043e\u0431\u043b\u0438\u0432\u0456 \u0437\u043c\u0456\u043d\u0438.  \u0417\u0432'\u044f\u0436\u0456\u0442\u044c\u0441\u044f \u0437 \u043d\u0430\u043c\u0438, \u044f\u043a\u0449\u043e \u0432\u0430\u043c \u043f\u043e\u0442\u0440\u0456\u0431\u043d\u0430 \u0434\u043e\u0434\u0430\u0442\u043a\u043e\u0432\u0430 \u0456\u043d\u0444\u043e\u0440\u043c\u0430\u0446\u0456\u044f."
  },
  "html_completed_tasks_title": {
    "sheet_name": "API templates",
    "en": "Completed tasks certificate",
    "ru": "",
    "fi": "Todistus valmistuneista teht\u00e4vist\u00e4",
    "sv": "Avslutat uppdrag certifikat",
    "fa": "",
    "ar": "",
    "uk": "\u0417\u0432\u0456\u0442 \u043f\u0440\u043e \u0432\u0438\u043a\u043e\u043d\u0430\u043d\u0456 \u0437\u0430\u0432\u0434\u0430\u043d\u043d\u044f"
  },
  "html_completed_tasks_completed_date": {
    "sheet_name": "API templates",
    "en": "Completed",
    "ru": "",
    "fi": "Valmistunut",
    "sv": "Avslutad",
    "fa": "",
    "ar": "",
    "uk": "\u0412\u0438\u043a\u043e\u043d\u0430\u043d\u043e"
  },
  "html_worker_report_title": {
    "sheet_name": "API templates",
    "en": "Certification of paid fees",
    "ru": "\u0421\u0435\u0440\u0442\u0438\u0444\u0438\u043a\u0430\u0446\u0438\u044f \u043e\u043f\u043b\u0430\u0447\u0435\u043d\u043d\u044b\u0445 \u0441\u0431\u043e\u0440\u043e\u0432",
    "fi": "Todistus ty\u00f6korvausten maksusta",
    "sv": "Intyg om utbetalning av arbetstill\u00e4gg",
    "fa": "\u06af\u0648\u0627\u0647\u06cc \u0647\u0632\u06cc\u0646\u0647 \u0647\u0627\u06cc \u067e\u0631\u062f\u0627\u062e\u062a \u0634\u062f\u0647",
    "ar": "\u062a\u0635\u062f\u064a\u0642 \u0627\u0644\u0631\u0633\u0648\u0645 \u0627\u0644\u0645\u062f\u0641\u0648\u0639\u0629",
    "uk": "\u0421\u0435\u0440\u0442\u0438\u0444\u0456\u043a\u0430\u0446\u0456\u044f \u0441\u043f\u043b\u0430\u0447\u0435\u043d\u0438\u0445 \u0437\u0431\u043e\u0440\u0456\u0432"
  },
  "email_login_text": {
    "sheet_name": "API templates",
    "en": "Login",
    "ru": "",
    "fi": "Kirjaudu",
    "sv": "Logga in",
    "fa": "",
    "ar": "",
    "uk": "\u0442\u0435\u043a\u0441\u0442 \u0435\u043b\u0435\u043a\u0442\u0440\u043e\u043d\u043d\u043e\u0457 \u043f\u043e\u0448\u0442\u0438 \u0434\u043b\u044f \u0432\u0445\u043e\u0434\u0443"
  },
  "email_subject_billing_request": {
    "sheet_name": "API templates",
    "en": "New billing request",
    "ru": "",
    "fi": "Uusi laskutuspyynt\u00f6",
    "sv": "Ny fakturerings f\u00f6rfr\u00e5gan",
    "fa": "",
    "ar": "",
    "uk": ""
  },
  "email_subject_forgot_password": {
    "sheet_name": "API templates",
    "en": "Reset {merchant.name} password",
    "ru": "",
    "fi": "Aseta salasana uudestaan",
    "sv": "\u00c5terst\u00e4ll l\u00f6senord",
    "fa": "\u062f\u0648\u0628\u0627\u0631\u0647 \u0631\u0645\u0632 \u0639\u0628\u0648\u0631 \u0631\u0627 \u062a\u0646\u0638\u06cc\u0645 \u06a9\u0646\u06cc\u062f",
    "ar": "\u0625\u0639\u0627\u062f\u0629 \u062a\u0639\u064a\u0646 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631",
    "uk": "\u0417\u043d\u043e\u0432\u0443 \u0432\u0441\u0442\u0430\u043d\u043e\u0432\u0456\u0442\u044c \u043f\u0430\u0440\u043e\u043b\u044c"
  },
  "email_subject_worker_selection": {
    "sheet_name": "API templates",
    "en": "You've been selected",
    "ru": "\u0412\u0430\u0441 \u0432\u044b\u0431\u0440\u0430\u043b\u0438 \u043d\u0430 \u0440\u0430\u0431\u043e\u0442\u0443",
    "fi": "Sinut on valittu tekij\u00e4ksi teht\u00e4v\u00e4\u00e4n",
    "sv": "Du har blivit utvald",
    "fa": "\u0634\u0645\u0627 \u0627\u0646\u062a\u062e\u0627\u0628 \u0634\u062f\u0647 \u0627\u06cc\u062f",
    "ar": "\u0644\u0642\u062f \u062a\u0645 \u0625\u062e\u062a\u064a\u0627\u0631\u0643",
    "uk": "\u0412\u0430\u0441 \u043e\u0431\u0440\u0430\u043b\u0438 \u043d\u0430 \u0440\u043e\u0431\u043e\u0442\u0443"
  },
  "email_subject_receipt": {
    "sheet_name": "API templates",
    "en": "Receipt from {merchant.name}",
    "ru": "\u041a\u0432\u0438\u0442\u0430\u043d\u0446\u0438\u044f \u043e\u0442 \u0441\u043b\u0443\u0436\u0431\u044b {merchant.name}",
    "fi": "Kuitti {merchant.name}",
    "sv": "Kvitto {merchant.name}",
    "fa": "\u0631\u0633\u06cc\u062f \u0627\u0632 \u0633\u0631\u0648\u06cc\u0633 {merchant.name}",
    "ar": "",
    "uk": "\u041a\u0432\u0438\u0442\u0430\u043d\u0446\u0456\u044f \u0432\u0456\u0434 \u0441\u043b\u0443\u0436\u0431\u0438 {merchant.name}"
  },
  "email_subject_order_confirmation": {
    "sheet_name": "API templates",
    "en": "Order confirmation",
    "ru": "\u041f\u043e\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043d\u0438\u0435 \u0437\u0430\u043a\u0430\u0437\u0430",
    "fi": "Tilausvahvistus",
    "sv": "Best\u00e4llningsbekr\u00e4ftelse",
    "fa": "\u062a\u0627\u06cc\u06cc\u062f \u0633\u0641\u0627\u0631\u0634",
    "ar": "\u062a\u0623\u0643\u064a\u062f \u0627\u0644\u0637\u0644\u0628",
    "uk": "\u041f\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043d\u043d\u044f \u0437\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f"
  },
  "email_subject_thanks_buying_pp": {
    "sheet_name": "API templates",
    "en": "Thank you for buying PilotPoints!",
    "ru": "\u0421\u043f\u0430\u0441\u0438\u0431\u043e \u0437\u0430 \u043f\u043e\u043a\u0443\u043f\u043a\u0443 PilotPoints!",
    "fi": "Kiitos PilotPointsien tilauksestasi!",
    "sv": "Tack f\u00f6r att du k\u00f6pte PilotPoints!",
    "fa": "\u0627\u0632 \u062e\u0631\u06cc\u062f PilotPoints \u0645\u062a\u0634\u06a9\u0631\u06cc\u0645!",
    "ar": "\u0625\u064a\u0635\u0627\u0644 \u062e\u062f\u0645\u0629 PilotPoints!",
    "uk": "\u0434\u044f\u043a\u0443\u0454\u043c\u043e \u0437\u0430 \u043f\u043e\u043a\u0443\u043f\u043a\u0443 PilotPoints"
  },
  "email_subject_orderer_cancelled_task": {
    "sheet_name": "API templates",
    "en": "Orderer has cancelled the task",
    "ru": "\u0417\u0430\u043a\u0430\u0437\u0447\u0438\u043a \u043e\u0442\u043c\u0435\u043d\u0438\u043b \u0440\u0430\u0431\u043e\u0442\u0443",
    "fi": "Tilaaja on perunut teht\u00e4v\u00e4n",
    "sv": "Best\u00e4llaren har avbokat uppdraget",
    "fa": "\u0633\u0641\u0627\u0631\u0634 \u062f\u0647\u0646\u062f\u0647 \u06a9\u0627\u0631 \u0631\u0627 \u0644\u063a\u0648 \u06a9\u0631\u062f\u0647 \u0627\u0633\u062a",
    "ar": "\u062a\u0645 \u0625\u0644\u063a\u0627\u0621 \u0627\u0644\u0637\u0644\u0628 \u0645\u0646 \u0642\u0628\u0644 \u0627\u0644\u0645\u0633\u0624\u0648\u0644",
    "uk": "\u0437\u0430\u043c\u043e\u0432\u043d\u0438\u043a \u0441\u043a\u0430\u0441\u0443\u0432\u0430\u0432 \u0440\u043e\u0431\u043e\u0442\u0443"
  },
  "email_subject_worker_cancelled_task": {
    "sheet_name": "API templates",
    "en": "Worker has cancelled the task",
    "ru": "\u0420\u0430\u0431\u043e\u0442\u043d\u0438\u043a \u043e\u0442\u043c\u0435\u043d\u0438\u043b \u0440\u0430\u0431\u043e\u0442\u0443",
    "fi": "Tekij\u00e4 on perunut teht\u00e4v\u00e4n",
    "sv": "Arbetstagaren har avbokat uppdraget",
    "fa": "\u06a9\u0627\u0631\u06af\u0631 \u06a9\u0627\u0631 \u0631\u0627 \u0644\u063a\u0648 \u06a9\u0631\u062f\u0647 \u0627\u0633\u062a",
    "ar": "\u062a\u0645 \u0625\u0644\u063a\u0627\u0621 \u0627\u0644\u0637\u0644\u0628 \u0645\u0646 \u0642\u0628\u0644 \u0627\u0644\u0639\u0627\u0645\u0644",
    "uk": "\u041f\u0440\u0430\u0446\u0456\u0432\u043d\u0438\u043a \u0441\u043a\u0430\u0441\u0443\u0432\u0430\u0432 \u0440\u043e\u0431\u043e\u0442\u0443"
  },
  "email_subject_welcome_user": {
    "sheet_name": "API templates",
    "en": "Please complete your {merchant.name} registration!",
    "ru": "\u041f\u043e\u0436\u0430\u043b\u0443\u0439\u0441\u0442\u0430 \u043f\u043e\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435 \u0441\u0432\u043e\u0439 \u0430\u0434\u0440\u0435\u0441 \u044d\u043b\u0435\u043a\u0442\u0440\u043e\u043d\u043d\u043e\u0439 \u043f\u043e\u0447\u0442\u044b {merchant.name}!",
    "fi": "Viimeistele {merchant.name} kirjautumisesi!",
    "sv": "V\u00e4nligen slutf\u00f6r din  {merchant.name} registrering!",
    "fa": "\u0644\u0637\u0641\u0627 \u062b\u0628\u062a \u0646\u0627\u0645 {merchant.name} \u062e\u0648\u062f \u0631\u0627 \u062a\u06a9\u0645\u06cc\u0644 \u06a9\u0646\u06cc\u062f!",
    "ar": "",
    "uk": "\u0411\u0443\u0434\u044c \u043b\u0430\u0441\u043a\u0430, \u043f\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0456\u0442\u044c \u0441\u0432\u043e\u044e \u0430\u0434\u0440\u0435\u0441\u0443 \u0435\u043b\u0435\u043a\u0442\u0440\u043e\u043d\u043d\u043e\u0457 \u043f\u043e\u0448\u0442\u0438 {merchant.name}!"
  },
  "email_subject_pilot_points_bonus_new_user": {
    "sheet_name": "API templates",
    "en": "You have received PilotPoints",
    "ru": "\u0412\u044b \u043f\u043e\u043b\u0443\u0447\u0438\u043b\u0438 \u0431\u043e\u043d\u0443\u0441\u043d\u044b\u0435 \u0431\u0430\u043b\u043b\u044b \u0432 \u043f\u043e\u0434\u0430\u0440\u043e\u043a \u043d\u0430 \u0438\u0441\u043f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u043d\u0438\u0435 \u0432  {merchant.name}",
    "fi": "Olet saanut bonuspisteit\u00e4 k\u00e4ytett\u00e4v\u00e4ksi {merchant.name} palvelussa!",
    "sv": "Du har f\u00e5tt bonuspo\u00e4ng som du kan anv\u00e4nda i {merchant.name}!",
    "fa": "\u0634\u0645\u0627 \u0627\u0645\u062a\u06cc\u0627\u0632 \u0627\u0633\u062a\u0641\u0627\u062f\u0647 \u0628\u0631\u0627\u06cc {merchant.name} \u0631\u0627 \u062f\u0631\u06cc\u0627\u0641\u062a \u06a9\u0631\u062f\u0647 \u0627\u06cc\u062f!",
    "ar": "",
    "uk": "\u0412\u0438 \u043e\u0442\u0440\u0438\u043c\u0430\u043b\u0438 \u0431\u043e\u043d\u0443\u0441\u043d\u0456 \u0431\u0430\u043b\u0438 \u0443 \u043f\u043e\u0434\u0430\u0440\u0443\u043d\u043e\u043a \u043d\u0430 \u0432\u0438\u043a\u043e\u0440\u0438\u0441\u0442\u0430\u043d\u043d\u044f \u0443 {merchant.name}"
  },
  "email_subject_pilot_points_bonus_existing_user": {
    "sheet_name": "API templates",
    "en": "You have received PilotPoints",
    "ru": "\u0412\u044b \u043f\u043e\u043b\u0443\u0447\u0438\u043b\u0438 \u0432 \u043f\u043e\u0434\u0430\u0440\u043e\u043a Pilotpoints!",
    "fi": "Olet saanut PilotPointseja (bonuspisteit\u00e4 k\u00e4ytett\u00e4v\u00e4ksi)!",
    "sv": "Du har f\u00e5tt PilotsPoints!",
    "fa": "\u0634\u0645\u0627 PilotPoints \u0631\u0627 \u0628\u0647 \u0639\u0646\u0648\u0627\u0646 \u0647\u062f\u06cc\u0647 \u062f\u0631\u06cc\u0627\u0641\u062a \u06a9\u0631\u062f\u0647 \u0627\u06cc\u062f!",
    "ar": "\u0644\u0642\u062f \u062a\u0644\u0642\u064a\u062a \u0646\u0642\u0627\u0637 PilotPoints \u0643\u0647\u062f\u064a\u0629",
    "uk": "\u0432\u0438 \u043e\u0442\u0440\u0438\u043c\u0430\u043b\u0438 \u0432 \u043f\u043e\u0434\u0430\u0440\u0443\u043d\u043e\u043a PilotPoints"
  },
  "email_subject_invite": {
    "sheet_name": "API templates",
    "en": "You've been invited",
    "ru": "",
    "fi": "Sinut on kutsuttu",
    "sv": "Du har blivit inbjuden",
    "fa": "",
    "ar": "",
    "uk": "\u0442\u0435\u043c\u0430 \u0437\u0430\u043f\u0440\u043e\u0448\u0435\u043d\u043d\u044f \u0435\u043b\u0435\u043a\u0442\u0440\u043e\u043d\u043d\u043e\u0433\u043e \u043b\u0438\u0441\u0442\u0430"
  },
  "email_subject_package_payment": {
    "sheet_name": "API templates",
    "en": "Package payment subject",
    "ru": "",
    "fi": "",
    "sv": "",
    "fa": "",
    "ar": "",
    "uk": "\u0442\u0435\u043c\u0430 \u0435\u043b\u0435\u043a\u0442\u0440\u043e\u043d\u043d\u043e\u0433\u043e \u043b\u0438\u0441\u0442\u0430 \u043e\u043f\u043b\u0430\u0442\u0430 \u043f\u0430\u043a\u0435\u0442\u0430"
  },
  "email_oauth_authorize": {
    "sheet_name": "API templates",
    "en": "Authorize",
    "ru": "\u0440\u0430\u0437\u043f\u0435\u0448\u0438\u0442\u044c \u0434\u043e\u0441\u0442\u044b\u043f",
    "fi": "Valtuuta",
    "sv": "Godk\u00e4nna",
    "fa": "\u0627\u062c\u0627\u0632\u0647 \u062f\u0647\u06cc\u062f",
    "ar": "\u062a\u0641\u0648\u064a\u0636",
    "uk": "\u0434\u043e\u0437\u0432\u043e\u043b\u0438\u0442\u0438 \u0434\u043e\u0441\u0442\u0443\u043f"
  },
  "email_oauth_question": {
    "sheet_name": "API templates",
    "en": "Do you allow VuoLearning accessing your email address?",
    "ru": "\u0414\u0430\u0435\u0442\u0435 \u043b\u0438 \u0432\u044b \u0434\u043e\u0441\u0442\u0443\u043f\u0443 VuoLearning \u043f\u0440\u0430\u0432\u0430 \u043a \u0441\u0432\u043e\u0435\u0439 \u044d\u043b\u0435\u043a\u0442\u0440\u043e\u043d\u043d\u043e\u0439 \u043f\u043e\u0447\u0442\u0435?",
    "fi": "Annatko VuoLearningille oikeudet s\u00e4hk\u00f6postiisi?",
    "sv": "Ger du VuoLearning \u00e5tkomst till din email adress?",
    "fa": "\u0622\u06cc\u0627 \u0628\u0647 VuoLearning \u0627\u062c\u0627\u0632\u0647 \u0645\u06cc \u062f\u0647\u06cc\u062f \u062a\u0627 \u0628\u0647 \u0622\u062f\u0631\u0633 \u0627\u06cc\u0645\u06cc\u0644 \u0634\u0645\u0627 \u062f\u0633\u062a\u0631\u0633\u06cc \u067e\u06cc\u062f\u0627 \u06a9\u0646\u062f\u061f",
    "ar": "\u0647\u0644 \u062a\u0633\u0645\u062d \u0644 VuoLearning \u0628\u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0639\u0646\u0648\u0627\u0646 \u0628\u0631\u064a\u062f\u0643 \u0627\u0644\u0625\u0644\u0643\u062a\u0631\u0648\u0646\u064a\u061f",
    "uk": "\u0427\u0438 \u0434\u0430\u0454\u0442\u0435 \u0432\u0438 \u0434\u043e\u0441\u0442\u0443\u043f\u0443 VuoLearning \u043f\u0440\u0430\u0432\u0430 \u0434\u043e \u0441\u0432\u043e\u0454\u0457 \u0435\u043b\u0435\u043a\u0442\u0440\u043e\u043d\u043d\u043e\u0457 \u043f\u043e\u0448\u0442\u0438?"
  },
  "email_oauth_allow": {
    "sheet_name": "API templates",
    "en": "Allow access",
    "ru": "\u0440\u0430\u0437\u0440\u0435\u0448\u0438\u0442\u044c \u0434\u043e\u0441\u0442\u044b\u043f",
    "fi": "Salli",
    "sv": "Till\u00e5t \u00e5tkomst",
    "fa": "\u0627\u062c\u0627\u0632\u0647 \u062f\u0633\u062a\u0631\u0633\u06cc",
    "ar": "\u0627\u0644\u0633\u0645\u0627\u062d \u0628\u0627\u0644\u0645\u0631\u0648\u0631",
    "uk": "\u0434\u043e\u0437\u0432\u043e\u043b\u0438\u0442\u0438 \u0434\u043e\u0441\u0442\u0443\u043f"
  },
  "email_oauth_deny": {
    "sheet_name": "API templates",
    "en": "Deny access",
    "ru": "\u0417\u0430\u043f\u0440\u0435\u0442\u0438\u0442\u044c \u0434\u043e\u0441\u0442\u044b\u043f",
    "fi": "Est\u00e4",
    "sv": "Neka \u00e5tkomst",
    "fa": "\u062c\u0644\u0648\u06af\u06cc\u0631\u06cc \u0627\u0632 \u062f\u0633\u062a\u0631\u0633\u06cc",
    "ar": "\u064a\u0645\u0646\u0639 \u0627\u0644\u062f\u062e\u0648\u0644",
    "uk": "\u0437\u0430\u0431\u043e\u0440\u043e\u043d\u0438\u0442\u0438 \u0434\u043e\u0441\u0442\u0443\u043f"
  }
}